import React from "react";
import styled from "styled-components";

const Container = styled.div`
  font-family: "Noto Sans KR", Arial, sans-serif;
  line-height: 1.8;
  margin: 0;
  padding: 0 20px 0 0;
  max-width: 1200px;
  margin: 0 auto;
  color: #333;

  h1, h2, h3, h4 {
    color: #1a1a1a;
  }

  h1 {
    font-size: 28px;
    text-align: center;
    margin: 30px 0 20px;
    font-weight: 700;
  }

  h2 {
    font-size: 24px;
    margin-top: 40px;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid #354380;
    font-weight: 700;
  }

  h3 {
    font-size: 20px;
    margin-top: 30px;
    margin-bottom: 15px;
    font-weight: 600;
  }

  h4 {
    font-size: 18px;
    margin-top: 25px;
    margin-bottom: 12px;
    font-weight: 600;
  }

  p {
    margin-bottom: 15px;
    text-align: justify;
  }

  .cover-page {
    min-height: 80vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    page-break-after: always;
  }

  .cover-title {
    font-size: 36px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 20px;
    line-height: 1.4;
  }

  .cover-subtitle {
    font-size: 20px;
    color: #555;
    margin-bottom: 60px;
  }

  .cover-publisher {
    font-size: 18px;
    color: #333;
    margin-top: 80px;
  }

  .cover-date {
    font-size: 16px;
    color: #666;
    margin-top: 10px;
  }

  .preface {
    padding: 40px 0;
    page-break-after: always;
  }

  .preface-title {
    font-size: 28px;
    text-align: center;
    margin-bottom: 40px;
    font-weight: 700;
  }

  .preface-content p {
    text-indent: 1em;
    line-height: 2;
  }

  .preface-content p:first-child {
    text-indent: 0;
  }

  .preface-signature {
    text-align: right;
    margin-top: 50px;
    line-height: 1.8;
  }

  .toc {
    padding: 40px 0;
    page-break-after: always;
  }

  .toc-title {
    font-size: 28px;
    text-align: center;
    margin-bottom: 40px;
    font-weight: 700;
  }

  .toc-list {
    list-style: none;
    padding: 0;
  }

  .toc-item {
    padding: 12px 0;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    transition: background-color 0.2s;
  }

  .toc-item:hover {
    background-color: #f5f5f5;
    padding-left: 10px;
  }

  .toc-subitem {
    padding-left: 30px;
    font-size: 0.95em;
    border-bottom: 1px dashed #e0e0e0;
  }

  .section {
    padding: 40px 0;
    page-break-after: always;
  }

  strong {
    font-weight: 700;
    color: #1a1a1a;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 30px 0;
    font-size: 12px;
    table-layout: fixed;
    word-break: keep-all;
  }

  table thead {
    position: sticky;
    top: 0;
    z-index: 10;
  }

  table th {
    background-color: #354380;
    color: white;
    padding: 5px;
    text-align: left;
    font-weight: 600;
    border: 1px solid #2a3565;
  }

  table td {
    padding: 5px;
    border: 1px solid #ddd;
    vertical-align: top;
    line-height: 1.6;
    word-break: break-word;
    overflow-wrap: break-word;
  }


  .table-title {
    font-size: 16px;
    font-weight: 600;
    margin-top: 30px;
    margin-bottom: 10px;
    color: #1a1a1a;
  }

  sup {
    color: #0066cc;
    font-size: 0.8em;
  }

  .HL_1 {
    color: #A38300;
    font-weight: 700;
  }

  .drug-table {
    width: 100%;
    border-collapse: collapse;
    margin: 30px 0;
    page-break-inside: avoid;
    border: 1px solid #000;
  }

  .drug-table thead th {
    border: 1px solid #000;
    padding: 5px;
    text-align: left;
    font-weight: 400;
    font-size: 14px;
    vertical-align: middle;
  }

  .drug-table thead th.drug-number {
    width: 12%;
    text-align: center;
    background-color: #000;
    color: #fff;
    font-weight: 700;
  }

  .drug-table thead th.drug-name {
    width: 40%;
    text-align: left;
    color: #000;
    background-color: #fff;
  }

  .drug-table thead th.drug-category-label {
    width: 21%;
    text-align: center;
    background-color: #000;
    color: #fff;
    font-weight: 700;
  }

  .drug-table thead th.drug-category-value {
    width: 26%;
    text-align: left;
    color: #000;
    background-color: #fff;
    word-break: break-word;
    overflow-wrap: break-word;
  }

  .drug-table tbody td {
    border: 1px solid #000;
    padding: 5px;
    vertical-align: top;
    line-height: 1.8;
  }

  .drug-table tbody td.field-label {
    width: 80px;
    text-align: center;
    font-weight: 600;
    background-color: #DDDDDD;
    vertical-align: top;
    line-height: 1.4;
  }

  .drug-table tbody td.field-content {
    color: #333;
  }

  .drug-table tbody td.field-content ul {
    margin: 8px 0;
    padding-left: 20px;
    list-style-type: none;
  }

  .drug-table tbody td.field-content li {
    margin: 4px 0;
  }
`;

const KIDS_GERI: React.FC = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Container>
      {/* 표지 페이지 */}
      <div className="cover-page" id="KDGERI_COVER">
        <div className="cover-title">
          노인에 대한 의약품 적정사용 정보집
        </div>
        <div className="cover-subtitle">
          Geriatric Drug Safety Information Guide
        </div>
        <div className="cover-publisher">한국의약품안전관리원</div>
        <div className="cover-date">2015년 12월</div>
      </div>

      {/* 발간사 */}
      <div className="preface section" id="KDGERI_PREFACE">
        <div className="preface-title">발간사</div>
        <div className="preface-content">
          <p>
          최근 우리나라는 생활 수준의 향상과 보건의료기술의 발전으로 국민들의 평균 수명이 연장되고 노인 인구가 크게 증가하고 있습니다 . OECD에 따르면, 우리나라는 2000년에 노인 인구 비율이 7% 이상인 고령화 사회에 도달했으며, 2019년에는 노인 인구 비율이 14% 이상인 고령사회에 도달할 것으로예상됩니다. 빠른 속도로 진행되는 고령화 추세에 따라 노인의건강하고 안전한 삶은 중요한 사회 문제이며, 이를 위해 노인에대한 적절한 의약품 사용의 필요성은 더욱 커지고 있습니다.
          </p>
          <p>특히, 노인은 노화에 따른 신체적, 생리적 변화로 의약품의효과나 약물이상사례가 일반 성인과는 다르게 나타날 수 있으며, 만성질환으로 오랜 기간 약을 복용하거나, 두 가지 이상의 복합질환을 가지는 경우가 많아 다약제복용으로 인한 약물이상사례 발생 빈도가 증가할 수 있습니다. 따라서, 노인에게 의약품 처방 및 조제 시에는 일반 성인에서보다 더 세심한 주의와 평가가 필요합니다.</p>
          <p>우리 처에서는 이러한 노인환자의 증가 추세에 따라 노인을 위한 특화된 정보 제공의 중요성과 필요성을 인식하고, 최신의 의약품 정보를 바탕으로 노인에게 보다 적정한 의약품 사용이 이루어질 수 있도록 ‘노인에 대한 의약품 적정사용 정보집 ’ 개정판을 발간하였습니다. 본 개정판에는 최근 국내･외 노인주의 의약품 기준에 수록된 성분과 이와 동일계열의 국내 허가 성분들을 추가하여 노인에서 고려해야 할 성분별 상세정보를 수록하였습니다. 또한, 노인에서 다빈도로 쓰이는 만성통증, 요실금 치료제 등에 대한 주의사항을 추가하여 보다 폭넓은 질환에 대한 정보를 제공하도록 보완하였으며, 손쉽게 정보를 활용할 수 있도록 의약품을 성분별로 분류하고 각 성분별 표에 구체적인 적정사용 정보를 수록하여 실용적으로 참고할 수 있도록 구성하였습니다.</p>
          <p>앞으로도, 이 정보집이 우리나라 노인환자에게 안전하고 효과적인 의약품 사용을 위한 안내서로써 의료현장의 의･약계 종사자들에게 널리 활용되고, 나아가 국민보건에 크게 기여 할 수 있기를 기대합니다.</p>
          <p>마지막으로, ‘노인에 대한 의약품 적정사용 정보집 ’ 개정판 발간에 협조해주신 중앙약사심의위원회 위원, 관련 전문가 여러분께 감사의 말씀을 드리며, 이 정보집과 더불어 노인 의약･학 분야의 무궁한 발전을 기원하는 바 입니다.</p>

          <div className="preface-signature">
            2015. 12.
            <br /><br />
            식품의약품안전처장
            <br />
            김승희
          </div>
        </div>
      </div>

      {/* 목차 */}
      <div className="toc section" id="KDGERI_TOC">
        <div className="toc-title">목차</div>
        <ul className="toc-list">
          {/* Ⅰ. 서론 */}
          <li
            className="toc-item"
            onClick={() => scrollToSection("KDGERI_INTRO")}
          >
            <span>Ⅰ. 서론</span>
            <span>1</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_INTRO_NEED")}
          >
            <span>1. 노인에 대한 의약품 적정사용 정보의 필요성</span>
            <span>1</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_INTRO_HISTORY")}
          >
            <span>2. 정보집 작성 및 개정 경과</span>
            <span>3</span>
          </li>

          {/* Ⅱ. 노인의 특수성 */}
          <li
            className="toc-item"
            onClick={() => scrollToSection("KDGERI_CHARACTERISTICS")}
          >
            <span>Ⅱ. 노인의 특수성</span>
            <span>5</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_CHAR_PK")}
          >
            <span>1. 노인의 약동학적 특성</span>
            <span>5</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_CHAR_PD")}
          >
            <span>2. 노인의 약력학적 특성</span>
            <span>7</span>
          </li>

          {/* Ⅲ. 노인에게 처방·조제시 일반적 주의사항 */}
          <li
            className="toc-item"
            onClick={() => scrollToSection("KDGERI_GENERAL")}
          >
            <span>Ⅲ. 노인에게 처방·조제시 일반적 주의사항</span>
            <span>8</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_GEN_BASIC")}
          >
            <span>1. 기본 고려 사항</span>
            <span>8</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_GEN_PRINCIPLE")}
          >
            <span>2. 일반적 원칙</span>
            <span>10</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_GEN_POLYPHARMACY")}
          >
            <span>3. 다약제복용</span>
            <span>11</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_GEN_INTERACTION")}
          >
            <span>4. 약물상호작용</span>
            <span>13</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_GEN_MINIMIZE")}
          >
            <span>5. 약물 병용 요법시 유해한 상호작용을 최소화하기 위한 원칙</span>
            <span>15</span>
          </li>

          {/* Ⅳ. 노인에게 처방·조제시 의약품 효능군별 주의사항 */}
          <li
            className="toc-item"
            onClick={() => scrollToSection("KDGERI_THERAPEUTIC")}
          >
            <span>Ⅳ. 노인에게 처방·조제시 의약품 효능군별 주의사항</span>
            <span>22</span>
          </li>

          {/* 1. 근골격계 */}
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_TH_MSK")}
          >
            <span>1. 근골격계</span>
            <span>22</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_MSK_OA")}
            style={{ paddingLeft: '60px' }}
          >
            <span>1) 골관절염</span>
            <span>22</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_MSK_OSTEO")}
            style={{ paddingLeft: '60px' }}
          >
            <span>2) 골다공증</span>
            <span>24</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_MSK_PAIN")}
            style={{ paddingLeft: '60px' }}
          >
            <span>3) 만성통증</span>
            <span>24</span>
          </li>

          {/* 2. 소화기계 */}
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_TH_GI")}
          >
            <span>2. 소화기계</span>
            <span>27</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_GI_GERD")}
            style={{ paddingLeft: '60px' }}
          >
            <span>1) 역류성위산과다, 위궤양</span>
            <span>28</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_GI_DYSPEPSIA")}
            style={{ paddingLeft: '60px' }}
          >
            <span>2) 소화장애</span>
            <span>28</span>
          </li>

          {/* 3. 순환기계 */}
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_TH_CVS")}
          >
            <span>3. 순환기계</span>
            <span>28</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_CVS_HTN")}
            style={{ paddingLeft: '60px' }}
          >
            <span>1) 고혈압</span>
            <span>29</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_CVS_CAD")}
            style={{ paddingLeft: '60px' }}
          >
            <span>2) 관상동맥질환</span>
            <span>30</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_CVS_HF")}
            style={{ paddingLeft: '60px' }}
          >
            <span>3) 심부전</span>
            <span>31</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_CVS_AF")}
            style={{ paddingLeft: '60px' }}
          >
            <span>4) 심방세동</span>
            <span>31</span>
          </li>

          {/* 4. 신경정신계 */}
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_TH_CNS")}
          >
            <span>4. 신경정신계</span>
            <span>32</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_CNS_DEPR")}
            style={{ paddingLeft: '60px' }}
          >
            <span>1) 우울증</span>
            <span>33</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_CNS_DEMENTIA")}
            style={{ paddingLeft: '60px' }}
          >
            <span>2) 치매</span>
            <span>34</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_CNS_ANXIETY")}
            style={{ paddingLeft: '60px' }}
          >
            <span>3) 불안증, 수면질환</span>
            <span>35</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_CNS_PARKINSON")}
            style={{ paddingLeft: '60px' }}
          >
            <span>4) 파킨슨병</span>
            <span>36</span>
          </li>

          {/* 5. 호흡기계 */}
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_TH_RESPIRATORY")}
          >
            <span>5. 호흡기계</span>
            <span>38</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_RESP_COPD")}
            style={{ paddingLeft: '60px' }}
          >
            <span>- 만성폐쇄성 폐질환</span>
            <span>38</span>
          </li>

          {/* 6. 피부계 */}
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_TH_DERM")}
          >
            <span>6. 피부계</span>
            <span>39</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_DERM_PRURITUS")}
            style={{ paddingLeft: '60px' }}
          >
            <span>- 소양증</span>
            <span>39</span>
          </li>

          {/* 7. 내분비계 */}
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_TH_ENDO")}
          >
            <span>7. 내분비계 (여성호르몬제)</span>
            <span>40</span>
          </li>

          {/* 8. 비뇨기계 */}
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_TH_URO")}
          >
            <span>8. 비뇨기계</span>
            <span>41</span>
          </li>
          <li
            className="toc-item toc-subitem"
            onClick={() => scrollToSection("KDGERI_URO_INCONTINENCE")}
            style={{ paddingLeft: '60px' }}
          >
            <span>- 요실금</span>
            <span>41</span>
          </li>

          {/* Ⅴ. 약물별 상세정보 */}
          <li
            className="toc-item"
            onClick={() => scrollToSection("KDGERI_DRUGS")}
          >
            <span>Ⅴ. 약물별 상세정보</span>
            <span>43</span>
          </li>
        </ul>
      </div>

      {/* Ⅰ. 서론 */}
      <div className="section" id="KDGERI_INTRO">
        <h2>Ⅰ. 서론</h2>

        <h3 id="KDGERI_INTRO_NEED">1. 노인에 대한 의약품 적정사용 정보의 필요성</h3>

        <p>
        최근 우리 나라는 지속적으로 생활수준이 향상되고 보건의료기술이 발달함으로써 국민들의 평균수명이 연장되고 노인인구가 크게 늘어나고 있다. 노화는 태어나면서부터 시작되어 평생동안 진행되는 과정이므로 단순히 생물학적 나이를 기준으로 노인의 기준을 삼기는 어려우며, 사회적 환경에 따라서는 생물학적 나이보다 사회적 역할 (social function)이 노인을정의하기에 더 중요한 요소일 수도 있다 . WHO(World Health Organization)에서는 노인에 대해 생물학적 연령기준을 정의하지 않았으나, 각종 통계자료 산출 시에 60세 이상을 기준으로 삼아 통계 결과를 제시하고 있다.<sup>1)2)</sup>미국 보건복지부 (HHS, Department of Health and Human Services) 산하 국립보건원 (NIH, National Institutes of Health)은 65세부터 79세까지의 성인을 노인 (adult, aged)으로 정의하고, 80세 이상의 성인은 ‘80세 이상인 노인(aged, 80 and over)’으로 추가 설명을 덧붙여 사용하고 있다.<sup>3)</sup> 국내에서는통상적으로 의･약학 분야에서 노인을 일컬을 때는 65세 이상인 성인을 뜻하며, 이 정보집에서도 65세 이상인 성인을 정보제공 대상으로 고려하였다.<sup>4)</sup>
        </p>

        <p>국내에서는 65세 이상인 노인 인구가 2005년에 전체 인구의 9.1%를 차지하여 고령화 사회 (aging society)로 접어들게 되었고, 2015년 현재 한국인구 중 고령인구는 13.1%이다 . 2060년 고령인구는 40.1%로 전망되어, 고령인구 비중이 27% 증가할 것으로 전망된다.<sup>5)</sup> 노인질환의 특성을 생각해보면, 노인 인구가 많아질수록 만성 퇴행성 질환의 유병률이 높아지고 이에 따라 노인 환자에 대한 의약품 처방 빈도도 증가할 것으로 예상할 수있다. 실제로 우리나라 전체 노인의 89.2%가 각종 만성 질환에 시달리고있으며, 82.0%가 의사처방약을 3개월 이상 복용하고 있다.<sup>6)</sup>일반의약품, 한약 등 통계자료상 사용량을 확인하기 어려운 의약품의 사용까지 고려하면 실제 사용되는 의약품은 더 많을 것으로 예상된다.</p>

        <p><strong id="KDGERI_INTRO_ELDERLY_ADR" className="HL_1">노인은 약물요법에 대한 순응도가 낮은 경향이 있으며, 만성질환 유병율이 높아 여러 가지 의약품을 동시에 투여하는 경우가 빈번하다. 이환된 질환이 없더라도 노화로 인해 간 및 신장 등 생리기능이 저하되어 있는 사람이 많을뿐더러, 노화로 인한 생리기능 저하 정도의 개인차이가 크기 때문에, 개인별 필요량보다 많거나 부족한 용량으로 의약품을 투여받게 될 가능성이 높다. 이러한 약동학적･약력학적 변화로 말미암아 노인에서는 약물이상사례가 발생할 가능성이 높다.</strong></p>

        <p>노인 인구 및 노인 환자가 증가하면서 노인에 대한 의약품 처방･조제와 그에 따른 약물이상사례도 늘어나고 있다. 따라서 노인에 대한 의약품 정 보를 파악하여 노인에 대한 약물요법의 유익성 대비 위험성을 올바르게 이 해하는 것이 점차 중요해지고 있다.</p>

        <h3 id="KDGERI_INTRO_HISTORY">2. 정보집 작성 및 개정 경과</h3>

        <p>이 정보집은 2009.7월에 발간된 ‘노인에 대한 의약품 적정사용 정보집’의 개정판으로, 노인에서의 일반적 주의사항, 의약품 효능군별 주의사항, 의약품별 적정사용정보로 구성되어 있으며, 국내외 노인주의 의약품 기준 에 수록된 성분 및 이와 동일계열의 국내 허가 성분들을 포함하여 상세정보를 수록하였다.
        </p>

         <p>먼저 정보집의 앞부분에는 노인의 약리학적 특성과 노인에게 의약품 투여 시 일반적으로 주의할 사항을 제시하였다. 정보집의 중간 부분에는 해부학적 계통별로 노인에서 중요시되는 질환의 약물요법에 대한 개론적 설명을 수록하였고, 이번 개정을 통해 노인에서 다빈도 질환인 만성통증과요실금 등에 대한 내용이 새롭게 추가되었다. 이어서 의약품별 적정사용정보란에는 노인에서 주의가 필요한 211개 성분에 대해 성분별 상세정보를 제시하였다. 기존 정보집에 수록된 109개의 성분 중 현재 국내에 유통, 생산되지 않거나 단일제품이 없는 8개의 성분은 삭제하였고, Beers’ Criteria(미국), McLeod’s List(캐나다), STOPP/START(아일랜드) 등 국외 노인 신중투여 약물 목록을 참고하여 목록에 기재된 성분 및 동일계열의 국내 허가성분을 포함하여 113개의 성분을 추가하였다. 그 외, 에스트로겐 계열 호르몬제 4개의 성분은 하나로 통합하였다. 전신적 투여가 가능한 의약품을수록 대상으로 고려하였고, 최종 선정된 수록 의약품 목록은 관련 학회 등의약계 전문가의 추가 검토를 받아 확정하였다.</p>
         
        <p>의약품별 적정사용 상세정보의 내용은 효능 ·효과, 금기, 용법 ·용량, 참고 주의사항, 주요 약물상호작용, 주요 이상사례에 대한 권고사항으로 구성되어 있으며, 최신 자료로 개정하였다. 적정사용정보의 내용은 국내 허가사항을 기준으로 하였고, 주요이상사례는 uptodate 등 임상정보원도 함께 참고하여 정리하였다. 또한, 2012 Beers’ Criteria의 질병에 관계없이 주의가 필요한 약물에 해당하는 성분의 경우 관련 내용을 참고 주의사항 란에 기재하였다. 의약품별 적정사용 상세정보의 내용은 정보집 목적에 따라 국내 허가사항 중 노인 환자에게 중요하다고 판단되는 내용을 위주로 요약하였으므로, 이 정보집을 활용할 때 이러한 한계점을 감안하는 것이 바람직하다.</p>
      </div>

      {/* Ⅱ. 노인의 특수성 */}
      <div className="section" id="KDGERI_CHARACTERISTICS">
        <h2>Ⅱ. 노인의 특수성</h2>
        <h3 id="KDGERI_CHAR_PK">1. 노인의 약동학적 특성</h3>
        <p>
        노화는 신체적 그리고 생리적으로 약물의 흡수, 분포, 대사 및 배설 전 과정에 고루 영향을 줄 수 있다. 이러한 영향은 다양한 양상으로 나타나며,예측하기 어렵고, 개인별 생체 기능 저하의 정도에 따라 심각한 약물이상사례가 초래되는 원인이 되기도 한다.<sup>7)</sup>
        </p>

        <div id="KDGERI_ABSORPTION">
        <h4>1) 흡수 (Absorption)</h4>
        <p>
        대부분의 약물은 수동 확산 (passive diffusion)으로 흡수되며, 이 경우 생체이용률은 노화에 따라 변화하지 않는다. <strong className="HL_1">일부 약물은 능동적 수송 (activetransport)으로 흡수되는데, 이 경우 생체이용률은 노화에 따라 감소하게 된다. 일부 약물은 초회통과 대사가 감소하여 생체이용률이 증가하며, 또 일부 전구약물 (prodrug)의 생체이용률이 감소하기도 한다. 위내 pH 상승, 위 장관 운동성 변화로 인한 위장 배출시간 지연, 소화기관 혈류감소 (위장관 투과성이 큰 약물의 흡수속도 감소, 초회 통과 효과 (first pass effect)가 큰 약물의 생체이용률 증가), 흡수면적 감소, 능동수송기전의 변화 등으로 인하여 흡수과정이 변화될 수 있다.</strong> 그리고, 흡수에 있어 더욱 중요한 영향은 여러 가지 약물을 동시에 복용함으로써 발생하기도 한다.<sup>8)</sup>
        </p>
        </div>

        <div id="KDGERI_DISTRIBUTION">
        <h4>2) 분포 (Distribution)</h4>
        <p>
        신체구성비 변화 (제지방체중 (lean body mass)감소, 체지방증가, 체수분감소), 단백 결합 변화 (혈장단백 (plasma albumin)감소), 혈류량 변화 등이 약물의 분포용적에 영향을 미칠 수 있다. 이런 변화에 의해 <strong className="HL_1">수용성 약물 (예.디곡신, 시메티딘, 페니실린 등)의 분포용적은 좁아지고, 지용성 약물 (예.디아제팜과 같은 진정수면제)의 분포용적은 커진다.</strong><sup>9)</sup>
        </p>
        </div>

        <div id="KDGERI_METABOLISM">
        <h4>3) 대사 (Metabolism)</h4>
        <p>
        간혈류량 감소, 간중량과 부피감소, 간효소 활성 변화(대사능력저하) 등으로 인해 대사능력이 저하된다. 대표적으로, <strong className="HL_1">cytochrome P-450의 3A4로 대사되는 약물의 종류가 가장 많은데, 노인은 이 효소의 기능저하로 인해 간대사의 속도가 느려지게 됨에 따라 반감기가 증가하여 약물의 효과시간이 연장된다. 예로는 아세트아미노펜, 디아제팜, 이부프로펜, 리도카인, 페니토인, 프로프라놀롤, 와파린 등이 있다.</strong><sup>9)</sup> 용량율속대사(capacity-limited metabolism)를 거치는 일부 약물에서 청소율 (clearance)이 감소하고, 반감기가 증가하게 되는데 이는 phase II 보다 phase I 대사가 더 영향을 받기 쉽다. 혈류율속대사 (flow-limited metabolism)를 거치는 약물의 경우 청소율이 감소하고, 반감기는 증가하게 된다.
        </p>
        </div>
      
        <div id="KDGERI_EXCRETION">
        <h4>4) 배설 (Excretion)</h4>
        <p>
        신장으로 배설되는 약물이나 활성 대사체 (active metabolite)의 청소율이 감소하고, 반감기는 증가한다. 신혈류량 감소, 신사구체수 감소로 인한 사구체 여과율 (GFR, glomerular filtration rate)과 세뇨관 분비능 감소 등으로 인해 신장 배설 기능이 감소한다. 만 85세가 되면 크레아티닌 청소율(creatinine clearance)이 만 25세 때에 비하여 50% 정도로 감소하게 된다. <strong className="HL_1">그러므로, 디곡신, 리튬, 이뇨제 및 삼환계 항울제 등은 심각한 약물이상사례 유발을 예방하기 위해 노인환자에게 감량하여 처방되어야 한다.</strong><sup>9)</sup>
        </p>
        </div>

        <h3 id="KDGERI_CHAR_PD">2. 노인의 약력학적 특성</h3>
        <p>
        약동학적 측면과 달리, 생화학적 또는 생리적인 약리효과와 작용기전인약력학적 측면에서는 노화의 영향이 제대로 밝혀진 바가 없고, 노인에서의약력학은 약동학보다 연구된 바가 적다. 체내 약물 반응 정도의 일반화가수월하지 않고 약물의 감수성에 대한 연령의 효과는 연구된 약물과 측정된반응에 따라 다양하다. 약물에 대한 감수성은 연령증가에 따라 증가하거나 감소할 수 있는데, 예를 들어 <strong className="HL_1">노인환자들은 벤조다이아제핀계 약물들의 진정효과의 감수성이 증가되어 있으나 베타교감신경수용체 (beta-adrenergic receptor)에 의해 매개되는 약물들의 효과에는 감수성이 감소하는 것으로 알려져 있다.</strong><sup>8)</sup>
        </p>

      </div>
            {/* Ⅲ. 노인에게 처방·조제시 일반적 주의사항 */}
            <div className="section" id="KDGERI_GENERAL">
        <h2>Ⅲ. 노인에게 처방·조제시 일반적 주의사항</h2>

        <h3 id="KDGERI_GEN_BASIC">1. 기본 고려 사항</h3>

        <div id="KDGERI_BENEFIT_RISK">
        <h4>치료의 유익성과 위험성 (therapeutic benefit and risk)</h4>
        <p>
          약물 처방･조제 시 치료의 유익성과 위험성은 가장 중요하게 고려해야 할 사항이다. 노인에서는 유해효과가 나타날 가능성이 높기 때문에 치료 유익성과 위험성 대비 (therapeutic benefit-risk ratio)를 평가하는 것보다는 문헌근거에 입각한 확실한 효과 (documented effectiveness)와 최소한의 독성 (lowest toxicity)을 갖는 약물을 사용하는 것이 중요하다. 특히 만성 질환을 가진 노인은 약물 투여기간이 길기 때문에 약물 사용의 근거가 잘 알려져 있지 않는 경우, <strong className="HL_1">치료유익성-위험성의 비율을 기준으로 약물을 선택하는 것보다 독성을 최소화할 수 있는 약물을 선택하는 것이 더 타당할 수 있다.</strong> 예를 들어 80세 이상 환자에서 합병증이 없는 고혈압의 치료로 인한 유익성의 근거자료가 80세 이하 환자에서보다 부족할 수 있는데, 이러한 경우 항고혈압제 중 치료유익성이 상대적으로 낮더라도 치료위험성이 적은 약물을 선택하는 것이 바람직할 것이다.
        </p>
        </div>

        <div id="KDGERI_DOSE">
        <h4>용량 (dose)</h4>
        <p>
        환자의 상태에 따라 적절한 용량의 조절이 필요한데, 주로 감량하는 경우가 많다. 일반적으로 <strong className="HL_1">치료역이 좁은 약물의 초기 용량은 성인 용량의 1/3～1/2정도이다.</strong> 약물에 의한 임상적 문제가 있는 환자에게는, 특히 노화에 의해 배설능력이 저하되는 약물의 경우, 초기투여량을 줄여야 한다.
        </p>
        </div>

        <div  id="KDGERI_REGIMEN_COMPLEXITY">
        <h4>약물요법의 복잡성 (complexity of drug regimens)</h4>
        <p>
        약물 복용 방법이 복잡할수록 (예. 여러 약제의 사용, 복용 횟수가 증가, 여러 가지 용량의 사용) 약물 복약 순응도가 낮아질 가능성이 크다. <strong className="HL_1">처방약물 수, 복용 빈도 등을 되도록 최소화, 단순화 하는 것이 좋다.</strong>
        </p>
        </div>

        <div id="KDGERI_COST">
        <h4>비용 (cost)</h4>
        <p>
        고정된 수입에 의존하는 노인에게는 의약품 비용으로 인한 경제적 부담이 복약순응도가 낮아지는 이유일 수 있다. 동일한 효능･효력을 지닌 의약품 중에서 <strong className="HL_1">가급적 저렴한 비용으로 구할 수 있는 의약품을 처방 및 조제하여</strong> 환자의 경제적 부담을 덜어주는 것도 복약 순응도를 높일 수 있는 방안중 하나이다.
        </p>
        </div>

        <div id="KDGERI_COMPLIANCE">
        <h4>순응도 (patient compliance)</h4>
        <p>
        <strong className="HL_1">의약전문가가 환자에게 약물 요법의 상세 내역 및 예상효과에 대해 충분히 설명할수록 의약전문가와 환자의 신뢰관계가 돈독해지고, 복약 순응도도 높아진다.</strong> 환자가 자신의 약물요법에 대해 기대하는 바와 자신의 질병상태에 대해 표현하는 바를 충분히 파악하고, 만약 복약 순응도가 낮다면 환자의 입장에 대한 이해심을 가지되 복약순응도가 낮은 이유에 대해 구체적이고 직접적으로 질문하여 원인을 밝히고 환자와 함께 해결책을 수립하는 것이 바람직하다. 노인의 복약 순응도 향상과 안전한 약물사용을 위해 다음과 같은 방법을 사용할 수 있다.
        </p>
        </div>

        <ul id="KDGERI_COMPLIANCE_ENHANCE">
          <li>하루 1회 또는 2회 정도로 약물 복용 횟수를 간편하게 할 것</li>
          <li>약물 복용시간을 일상생활에 맞추어 줄 것 (기상 직후, 식사시간 전후, 취침 전 등)</li>
          <li>환자의 인지기능이 떨어지는 경우, 환자의 보호자 또는 간병인에게 약물의 내용과 약물이상사례에 대해 설명</li>
          <li>약물 복용에 대한 상담을 맡아줄 의료인 또는 약사의 연락처 제공</li>
          <li>일자, 횟수 별로 약을 담는 용기 (pill box), 설명서, 약 복용 달력 등 제공</li>
          <li>환자가 지속적으로 약을 처방받을 수 있고 계속 구입하여 복용할 수 있다는 데 대한 확신을 줄 것</li>
          <li>최신 약물 처방 내용과 약물 정보 제공</li>
          <li>환자에 대한 약물 복용 필요성의 지속 교육</li>
          <li>비처방약물 (일반의약품)의 복용 가능성을 고려한 복약지도 제공</li>
          <li>인지기능의 문제 (예. 치매 및 우울증)에 대한 정기적 평가</li>
        </ul>
        
        <div id="KDGERI_GEN_PRINCIPLE">
        <h3>2. 일반적 원칙</h3>
        <ul>
          <li> 일반의약품, 한약, 건강기능식품 등 환자가 치료목적으로 복용하는 모든 물질을 파악한다. 환자가 복약 중인 모든 의약품을 가져와서 의약전문가와 함께 직접 확인하는 기회를 마련하며, 환자의 생활습관 (흡연, 음주), 약물 알러지, 약물 유해반응 과거력 등을 조사하여 기록으로 남긴다.</li>
          <li><strong className="HL_1">치료적 유익성이 확실한 경우에만 약물을 사용한다.</strong> 증상이 미미하거나 특이성이 없어 정확한 진단을 할 수 없거나, 치료적 유익성이 확실하지 않은 경우에는 약물 처방을 피한다. 질병증상이 없어지면 약물요법이 지속적으로 필요한지를 평가하고, 예상되는 질병경과 및 예후에 따라 약물요법 계획을 새롭게 수립한다.</li>
          <li>처방하는 의약품에 대한 약리학적 특성 및 잠재적 유해반응을 파악하고 있어야 한다. 약물의 치료적 유익성 및 위험성과 관련된 기능적 지표를 주기적으로 평가한다.</li>
          <li><strong className="HL_1">천천히 투여를 시작하고, 천천히 용량조절을 진행한다 (start slow, go slow).</strong> 최소유효용량을 최소유효빈도로 투여하여, 치료적 유익성은 높이고 치료적 위험성은 낮추도록 노력한다.</li>
          <li>충분히 치료한다 (treat adequately). 약물이상사례를 예방하려는 목적에 치중하여 치료효과를 충분히 나타내지 못하는 용량으로 의약품을 투여하는 것은 지양하여야 한다. <strong className="HL_1">약물유해반응에 주의하여 최소유효용량을 투여하되, 치료 목표를 달성하기에 충분한 용량을 사용하여야 한다.</strong> 또한 치료 가능한 질병을 노화과정의 일부로 생각하여 방치하는 일이 없어야 한다..</li>
          <li>복약 순응도를 높일 수 있도록 노력한다. <strong className="HL_1">약물요법을 통해 기대하는 치료 목표와 복약방법에 대해 환자와 충분히 대화한다.</strong> 이해하기 쉬운 설명서를 제공하고, 약물 선택 시에는 복용법을 간편화하고, 잠재적 약물 유해반응을 고려한다.</li>
          <li>신약 사용 시에는 특히 주의한다. 노인에 대해서 신약의 평가가 충분히 이루어지지 않아 치료 유익성 대비 치료위험성 비율(therapeutic benefit-risk ratio)을 알 수 없는 경우가 많다.</li>
          <li>약물치료 이외의 방법을 고려한다 (non-drug alternatives). <strong className="HL_1">치료에 도움이 되는 생활습관, 식이요법에 대한 정보를 제공한다.</strong></li>
        </ul>
        </div>

        <div id="KDGERI_GEN_POLYPHARMACY">
        <h3>3. 다약제복용 (polypharmacy)</h3>
        <p>‘다약제복용 (polypharmacy)’이란 환자 한 명에게 여러 가지 의약품을 과도하게 사용하는 것을 말한다. 임상적 적응증에 해당하지 않는 한 개 이상의 불필요한 의약품이 포함된 약물요법, 또는 5개 이상의 의약품을 투여하는 약물요법으로 다약제복용을 정의하기도 한다.<sup>10)</sup> 노인은 두 가지 이상의 만성질환을 가지는 경우가 많고, 노화로 인한 생리약동학적 변화로 약물의 흡수, 분포, 대사 및 배설 과정이 젊은 성인과 다르다. 그러므로 다약제복용에 의해 약물-약물 상호작용, 약물-음식 또는 약물-건강기능식품 상호작용, 약물이상사례 등의 문제가 발생할 가능성이 높다. 다약제복용을 피하기 위해 다음과 같은 방법을 사용할 수 있다.
        </p>
        <ul id="KDGERI_POLY_PREVEN">
          <li>환자가 의료기관에 내원할 때, 복약 중인 모든 의약품을 주기적으로 가져와서 의료진과 함께 확인하도록 한다. 일반의약품 및 한약을 포함하여 환자가 복용하는 의약품에 대한 설명을 모두 기록하여, 환자가 지참하고 수시로 확인할 수 있도록 한다.</li>
          <li>환 환자에게 투여되는 모든 의약품의 성분명과 약효를 확인하고, 환자에게도 자신이 복약 중인 의약품을 수시로 확인하는 습관을 가지도록 교육한다.</li>
          <li>의약품을 처방하는 경우에는 반드시 임상적 적응증에 해당되는 경우에만 처방 한다.</li>
          <li><strong className="HL_1">처방한 의약품에 의해 생길 수 있는 약물이상사례의 위중도와 발생빈도를 알고 있어야 한다.</strong></li>
          <li>노화로 인한 약동학적 변화에 따라 노인환자에서 약물이상사례의 위험이 높아질 수 있음을 이해하고 있어야 한다.</li>
          <li><strong className="HL_1">치료유익성이 확실하지 않은 의약품은 투여를 중단한다.</strong></li>
          <li>임상적 적응증에 해당되지 않는 의약품은 투여를 중단한다.</li>
          <li><strong className="HL_1">가급적 독성이 적은 의약품으로 대체하기 위해 노력한다.</strong></li>
          <li>약물 처방의 악순환(약물이상사례 증상을 다른 약물로 치료하려는 것)의 위험성에 대해 항상 주의를 기울여야 한다.</li>
          <li>가급적 "한 가지 질환에 한 가지 약물을 하루 한 번 복용"하게 되도록 노력한다.</li>
        </ul>
        </div>

        <h3 id="KDGERI_GEN_INTERACTION">4. 약물상호작용 (drug interaction)</h3>
        <p>
        약물 상호작용 (drug interaction)이란 한 약물의 효과가 이미 투여 중이던 다른 물질 (다른 약물, 음식물, 건강보조식품 등) 또는 동시에 투여하기 시작한 다른 물질에 의해 측정이 가능할 정도로 변형되는 것을 말한다. 상호작용하는 물질에 따라 약물-질병 상호작용, 약물-약물 상호작용, 약물-음식물 및 약물-건강보조식품 상호작용 등으로 분류하기도 하고, 상호작용의 기전에 따라 약동학적 상호작용, 약력학적 상호작용 등으로 분류하기도 한다
        </p>
        <p>국내 허가사항의 상호작용 항목에는 “다른 의약품과의 병용시 당해 의약품이나 병용약의 작용을 증강 또는 감약시키거나 이상반응의 증강이 일어날 경우, 또는 새로운 이상반응이 발생하거나 원질환의 악화 등이 일어날 경우로서 임상적으로 의의가 있는 사항”을 기재하고 있어, 약물상호작용 중에서 주로 약물-약물 상호작용 (drug-drug interaction)을 명시하고 있다.<sup>11)</sup></p> 
        <p>약물 상호작용이 발생하는 모든 경우가 임상적으로 의미 있는 부작용은아니며, 대부분 약물 상호작용이 발생하지만 임상적으로 별다른 문제를 유발하지 않는 잠재적 약물상호작용 (potential drug interaction)이다. <strong className="HL_1">따라서 임상에서 약물 상호 작용이 발생할 가능성이 있는 약물의 병용투여를 무조건 금지하거나 피할 필요는 없다. 오히려 약물 투여용법을 잘 조절하여 사용하면, 약물 치료의 결과가 더 향상될 수도 있다.</strong></p>
        <p>약물 상호작용의 발생가능성이 상존하는 임상현장에서는 약물요법의 치료효과를 증대시키고 약물이상사례 발생을 최소화하기 위해서 약물상호작용의 기전을 잘 이해하고, 각 약물에서 발생 가능한 약물상호작용에 대한지식을 충분히 갖추고 있어야 한다.</p>

        <h4>상호작용의 기전</h4>
        
        <div id="KDGERI_INTERACTION_PK">
        <h5>약동학적 상호작용 (pharmacokinetic interaction)</h5>
        <p>
          한 약물이 다른 약물의 흡수, 분포, 대사, 배설 (administration, distribution, metabolism, elimination) 과정에 영향을 미치는 약물 상호작용을 말한다. 이는 주로 최대 혈중 농도, 혈중농도-시간 곡선하 면적 (area under the concentration-time curve), 반감기, 요중 배설량 등 약동학적 지표(pharmacokinetic parameters)의 변화로 측정하게 된다.<sup>12)</sup>
        </p>
        </div>

        <div id="KDGERI_INTERACTION_PD">
        <h5>약력학적 상호작용 (pharmacodynamic interaction)</h5>
        <p>
        함께 투여하는 약물이 혈중 약물농도 등 약동학적 지표는 변화시키지 않으면서, 약물의 약리작용 또는 약리작용에 수반되는 생리학적 효과를 변화시키는 상호작용을 말한다. 예를 들어 혈중 농도는 변화하지 않으면서 약물 작용이 다르게 나타나는 경우가 있을 수 있다. Potassium을 고갈시키는 이뇨제에 의해 digoxin의 독성이 증가되는 것이 그 예이다. 체액･전해질의 불균형을 유발하여 약리작용의 변화를 가져오거나, 비슷하거나 반대의 약리학적 작용을 하는 약물을 2가지 이상 동시에 투여했을 때 나타나는 약리학적 상호작용(pharmacological interaction)도 약력학적 상호작용 중 하나이다. 작용기전으로는 상가작용, 상승작용 또는 길항작용 등이 있다. 예를 들어 항불안제(antianxiety drug), 진정수면제(hypnotics), 또는 항히스타민제(antihistamines)를 동시에 투여할 경우 이 의약품들은 공통적으로 진정작용을 일으키는 특성이 있어서 상가작용에 의해 과도한 진정 부작용이 일어날 가능성이 높다.
        </p>
        </div>


        <h3>5. 약물 병용 요법시 유해한 상호작용을 최소화하기 위한 원칙</h3>
        <ul id="KDGERI_GEN_MINIMIZE">
          <li>비처방의약품을 포함하여 환자에게 투여되는 모든 약물을 규명하고 이를 기록해두면 환자에게 약물을 새로 추가 또는 변경하여 처방할 때 이 기록을 참조할 수 있다.</li>
          <li>의약전문가는 사용하고 있는 약물의 약력학･약동학적 지식 및 발생 가능한 약물의 상호작용에 관한 지식을 습득하고 있어야 한다.</li>
          <li>병용투여되는 약물의 숫자를 최소화하며, 이 때 가능하면 치료지수가 큰 약물들을 사용하도록 한다.</li>
          <li>환자의 임상적 상태가 유해한 약물상호작용이 발생할 가능성이 큰 경우에 해당하는지 평가한다.</li>
          <li>약물병용요법 중에 환자상태가 악화될 경우에는 유해한 약물 상호작용의 가능성을 주의 깊게 확인한다.</li>
          <li>약물상호작용에 관한 정보가 없는 새로운 약물을 병용 투여할 경우 약물상호작용의 가능성에 대해 주의 깊게 관찰한다.</li>
          <li>약물대사효소 유도 및 억제작용이 큰 약물을 병용할 때는 유해한 약물상호작용의 가능성에 대해 특히 주의해서 관찰하고, 필요한 경우 혈중약물농도를 관찰하면서 약물요법을 시행한다.</li>
        </ul>

        <div className="table-title" id="KDGERI_DINDEP">
          [표 1] 노인에서 질병과 관계없이 주의가 필요한 약물의 예<sup>13)</sup>
        </div>
        <table>
          <thead>
            <tr>
              <th style={{ width: '15%' }}>계열</th>
              <th style={{ width: '20%' }}>분류</th>
              <th style={{ width: '30%' }}>약물</th>
              <th style={{ width: '35%' }}>주의사항</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_DINDEP_ANTICHOLINERGIC">
              <td rowSpan={3}>
                <strong>항콜린제</strong><br />
                (3급 아민 삼환계 항우울제 제외)
              </td>
              <td>
                <strong>1세대 항히스타민제</strong>
              </td>
              <td>
                Hydroxyzine, Brompheniramine, Carbinoxamine, Chlorpheniramine,
                Clemastine, Cyproheptadine, Dexbrompheniramine, Dexchlorpheniramine,
                Diphenhydramine (경구), Doxylamine, Triprolidine
              </td>
              <td>
                항콜린성작용 (혼돈, 입마름, 변비 등) 높음, 노화에 따른 배출시간 지연,
                수면제로 사용 시 내성 증가
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_ANTIPARKINSON">
              <td>
                <strong>항파킨슨제제</strong>
              </td>
              <td>
                Benztropine (경구), Trihexyphenidyl
              </td>
              <td>
                항정신병약으로 인한 추체외로 증후군 예방에 권고되지 않음,
                파킨슨증후군 치료에 더 효과적인 대체 약물 있음
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_ANTISPASMODIC">
              <td>
                <strong>진경제</strong>
              </td>
              <td>
                Belladonna alkaloids, Clidinium-chlordiazepoxide, Dicyclomine, Scopolamine
              </td>
              <td>
                항콜린성작용 높음, 효과 불확실함.<br />
                단기간 완화치료 목적 이외에는 사용하지 말 것
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_ANTITHROMBOTIC">
              <td>
                <strong>항혈전제</strong>
              </td>
              <td>
                <strong>혈소판 응집 억제제</strong>
              </td>
              <td>
                Ticlopidine
              </td>
              <td>
                보다 효과적인 대체 약물 있으므로 사용 권고되지 않음
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_CVS_ALPHA">
              <td rowSpan={6}>
                <strong>심혈관계 약물</strong>
              </td>
              <td>
                <strong>알파차단제</strong>
              </td>
              <td>
                Doxazosin, Prazosin, Terazosin
              </td>
              <td>
                기립성 저혈압 위험 증가, 고혈압 치료 목적으로 사용 권고되지 않음
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_CVS_ANTIARRHYTHMIC">
              <td>
                <strong>항부정맥약물</strong>
              </td>
              <td>
                Amiodarone, Dronedarone, Flecainide, Propafenone, Quinidine, Sotalol
              </td>
              <td>
                노인에서는 심박수조절이 리듬조절보다 우선시됨<br />
                Amiodarone은 갑상선질환, 폐질환, QT간격 연장 등 독성 유발 가능
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_CVS_DRONEDARONE">
              <td rowSpan={4}>
                <strong>기타</strong>
              </td>
              <td>
                Dronedarone
              </td>
              <td>
                드로네다론을 복용한 영구적 심방세동 또는 심부전 환자에서 더 악화된 결과가 보고됨,
                일반적으로 심방세동 치료에는 심박수 조절(rate control)이 리듬 조절(rhythm control)보다 선호됨
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_CVS_DIGOXIN">
              <td>
                Digoxin &gt; 0.125 mg/d
              </td>
              <td>
                심부전 환자에게 고용량 사용은 추가 이익이 없고 독성 증가 가능,
                느린 신장 클리어런스(renal clearance)로 부작용 위험 증가할 수 있음
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_CVS_NIFEDIPINE">
              <td>
                Nifedipine (서방형제제가 아닌 경우)
              </td>
              <td>
                저혈압 위험, 심근허혈 유발 가능
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_CVS_SPIRONOLACTONE">
              <td>
                Spironolactone &gt; 25mg/d
              </td>
              <td>
                심부전 환자에게 고칼륨혈증(hyperkalemia) 위험이 높음,
                특히 1일 25mg 초과 또는 NSAID 병용, 안지오텐신 변환효소 저해제,
                안지오텐신 수용체 길항제, 칼륨보충제 복용 시 위험 증가.<br />
                심부전 환자 또는 CrCl &lt; 30mL/min 환자에게 사용하지 말 것
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_CNS_TCA">
              <td rowSpan={7}>
                <strong>중추신경계 작용 약물</strong>
              </td>
              <td>
                <strong>3급 아민 삼환계 항우울제</strong>
              </td>
              <td>
                Amitriptyline, Clomipramine, Doxepin &gt; 6mg/d, Imipramine
              </td>
              <td>
                항콜린성작용 (구갈, 배뇨곤란, 변비, 안압항진 등) 높음, 기립성 저혈압 유발
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_CNS_ANTIPSYCHOTIC">
              <td>
                <strong>항정신용제</strong>
              </td>
              <td>
                <strong>1세대(typical)</strong>: Chlorpromazine, Haloperidol, Molindone, Perphenazine, Pimozide<br />
                <strong>2세대(atypical)</strong>: Aripiprazole, Clozapine, Olanzapine, Paliperidone, Quetiapine, Risperidone, Ziprasidone
              </td>
              <td>
                치매환자의 뇌졸중과 사망률 위험 증가
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_CNS_BARBITURATE">
              <td>
                <strong>바르비탈염제제</strong>
              </td>
              <td>
                Pentobarbital, Phenobarbital
              </td>
              <td>
                신체적 의존 위험, 내성, 낮은 용량의 과다복용 위험
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_CNS_BENZODIAZEPINE_LONG">
              <td>
                <strong>장기지속형 벤조다이아제핀</strong>
              </td>
              <td>
                Chlordiazepoxide, Clidinium-chlordiazepoxide, Diazepam, Flurazepam, Clonazepam
              </td>
              <td rowSpan={2}>
                운동실조, 안절부절함, 초조, 신경과민, 과진정, 고용량 복용 시 심한 졸림
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_CNS_BENZODIAZEPINE_SHORT">
              <td>
                <strong>단기지속형 벤조다이아제핀</strong>
              </td>
              <td>
                Triazolam, Alprazolam, Lorazepam, Temazepam
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_CNS_NONBENZODIAZEPINE">
              <td>
                <strong>무벤조다이아제핀(Nonbenzodiazepine) 계열 최면진정제</strong>
              </td>
              <td>
                Zolpidem
              </td>
              <td>
                벤조다이아제핀과 유사한 약물이상사례 위험 (섬망, 낙상, 골절 등)
                수면잠복기(sleep latency)와 수면시간(duration)에 효과가 미미함<br />
                장기간 사용을 피할 것 (&gt; 90days)
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_CNS_ERGOLOID">
              <td>
                <strong>기타</strong>
              </td>
              <td>
                Ergoloid mesylates
              </td>
              <td>
                효과 부족
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_ENDO_ESTROGEN">
              <td rowSpan={5}>
                <strong>내분비계 작용 약물</strong>
              </td>
              <td>
                <strong>에스트로겐제제</strong>
              </td>
              <td>
                Estrogens with or without progestins
              </td>
              <td>
                발암가능성(유방암, 자궁내막), 심장보호효과·인지보호효과 부족<br />
                경구제, 외용패취제 사용을 피할 것
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_ENDO_GH">
              <td rowSpan={3}>기타</td>
              <td>
                Growth hormone (somatropin)
              </td>
              <td>
                부종, 관절통, 수근관 증후군, 여성형 유방, 공복혈당장애
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_ENDO_INSULIN">
              <td>
                Insulin, sliding scale
              </td>
              <td>
                저혈당 위험 증가
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_ENDO_MEGESTOL">
              <td>
                Megestol
              </td>
              <td>
                체중에 영향 미미함, 노인환자에서 혈전성 발병(thrombotic event)·사망 위험 증가
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_ENDO_GLYBURIDE">
              <td>
                설포닐요소제제
              </td>
              <td>
                Glyburide (glibenclamide)
              </td>
              <td>
                체중에 영향 미미함, 노인환자에서 혈전성 발병(thrombotic event)·사망 위험 증가
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_GI_METOCLOPRAMIDE">
              <td>
                <strong>소화기관용 약물</strong>
              </td>
              <td>
                <strong>위장관 조절제</strong>
              </td>
              <td>
                Metoclopramide
              </td>
              <td>
                지연성운동장애(tardive dyskinesia)와 같은 추체외로증상(extrapyramidal effects) 유발 가능,
                고령 환자에서 위험 증가
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_PAIN_NSAID">
              <td rowSpan={3}>
                <strong>통증 관련 약물</strong>
              </td>
              <td>
                <strong>비선택적 비스테로이드성 항염제(Non-selective NSAID), 경구</strong>
              </td>
              <td>
                Aspirin &gt; 325 mg/d, Diclofenac, Diflunisal, Etodolac, Fenoprofen, Ibuprofen,
                Ketoprofen, Mefenamic acid, Meloxicam, Nabumetone, Naproxen, Oxaprozin,
                Piroxicam, Sulindac
              </td>
              <td>
                위장관 출혈, 소화성 궤양 질환 위험 증가<br />
                (고위험환자군: &gt; 75세, 경구 또는 비경구 부신피질스테로이드, 항응고제, 항혈소판제제 투여)
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_PAIN_KETOROLAC">
              <td>
                <strong>기타</strong>
              </td>
              <td>
                Ketorolac (비경구 포함), Indomethacin
              </td>
              <td>
                위장관 출혈, 소화성 궤양 질환 위험 증가, NSAID 중 인도메타신이 가장 약물이상사례 많음
              </td>
            </tr>
            <tr id="KDGERI_DINDEP_PAIN_MUSCLE_RELAXANT">
              <td>
                <strong>골격근이완제</strong>
              </td>
              <td>
                Chlorzoxazone, Cyclobenzaprine, Methocarbamol, Orphenadrine
              </td>
              <td>
                대부분의 근이완제는 노인환자에서 항콜린작용으로 인한 부작용으로 많이 사용되지 않음(poorly tolerated)
              </td>
            </tr>
          </tbody>
        </table>

        <div className="table-title" id="KDGERI_DDEP">
          [표 2] 노인에서 질병에 따라 주의가 필요한 약물의 예<sup>13)</sup>
        </div>
        <table>
          <thead>
            <tr>
              <th style={{ width: '25%' }}>질병</th>
              <th style={{ width: '40%' }}>약물</th>
              <th style={{ width: '35%' }}>주의사항</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_DDEP_DEMENTIA">
              <td>
                <strong>치매, 인지장애</strong>
              </td>
              <td>
                Anticholinergics<br />
                Benzodiazepines<br />
                H2-receptor antagonists<br />
                Zolpidem<br />
                Antipsychotics (만성, 필요시 사용)
              </td>
              <td>
                뇌혈관사고(뇌졸중)와 사망률 위험 증가
              </td>
            </tr>
            <tr id="KDGERI_DDEP_FALL">
              <td>
                <strong>과거 낙상 또는 골절 경험</strong>
              </td>
              <td>
                Anticonvulsants<br />
                Antipsychotics<br />
                Benzodiazepines<br />
                Zolpidem<br />
                TCAs<br />
                Selective serotonin reuptake inhibitors
              </td>
              <td>
                운동장애(ataxia) 유발, 정신･운동기능 저하, 실신, 및 낙상 유발
              </td>
            </tr>
            <tr id="KDGERI_DDEP_INCONTINENCE">
              <td>
                <strong>요실금</strong>
              </td>
              <td>
                Estrogen (경구, 경피)
              </td>
              <td>
                요실금 악화<br />
                여성환자에게 사용하지 말 것
              </td>
            </tr>
            <tr id="KDGERI_DDEP_HEART_FAILURE">
              <td>
                <strong>심부전</strong>
              </td>
              <td>
                NSAIDs, COX-2 inhibitors<br />
                Nondihydropyridine CCBs (avoid only for systolic heart failure) (diltiazem, verapamil)<br />
                Pioglitazone, rosiglitazone<br />
                Dronedarone
              </td>
              <td>
                수분저류, 심부전 악화 가능성
              </td>
            </tr>
            <tr id="KDGERI_DDEP_SYNCOPE">
              <td>
                <strong>실신</strong>
              </td>
              <td>
                AChEIs<br />
                Tertiary TCAs
              </td>
              <td>
                기립성 저혈압, 서맥 위험 증가
              </td>
            </tr>
            <tr id="KDGERI_DDEP_SEIZURE">
              <td>
                <strong>만성발작, 뇌전증</strong>
              </td>
              <td>
                Bupropion<br />
                Chlorpromazine<br />
                Clozapine<br />
                Olanzapine<br />
                Tramadol
              </td>
              <td>
                발작 역치 저하
              </td>
            </tr>
            <tr id="KDGERI_DDEP_DELIRIUM">
              <td>
                <strong>섬망</strong>
              </td>
              <td>
                All TCAs<br />
                Anticholinergics<br />
                Benzodiazepines<br />
                Chlorpromazine<br />
                Corticosteroids<br />
                H2-receptor antagonist<br />
                Meperidine (pethidine)<br />
                Sedative hypnotics
              </td>
              <td>
                섬망 유발, 악화<br />
                장기간 사용한 경우 금단증후군을 예방하기 위해 천천히 용량을 줄일 것
              </td>
            </tr>
            <tr id="KDGERI_DDEP_INSOMNIA">
              <td>
                <strong>불면증</strong>
              </td>
              <td>
                Oral decongestants (pseudoephedrine, phenylephrine)<br />
                Stimulants (methylphenidate)<br />
                Theobromines (theophylline, caffeine)
              </td>
              <td>
                중추신경계 자극 작용 우려
              </td>
            </tr>
            <tr id="KDGERI_DDEP_PARKINSON">
              <td>
                <strong>파킨슨증후군</strong>
              </td>
              <td>
                All antipsychotics<br />
                Antiemetics (metoclopramide)
              </td>
              <td>
                운동 장애 악화
              </td>
            </tr>
            <tr id="KDGERI_DDEP_ULCER">
              <td>
                <strong>위궤양 또는 십이지장궤양의 병력</strong>
              </td>
              <td>
                Aspirin (&gt; 325mg)<br />
                Non-COX-2 selective NSAIDs
              </td>
              <td>
                기존의 궤양 악화 궤양 유발 가능
              </td>
            </tr>
            <tr id="KDGERI_DDEP_RENAL_FAILURE">
              <td>
                <strong>만성 신부전 (Stage IV, V)</strong>
              </td>
              <td>
                NSAIDs
              </td>
              <td>
                신기능 장애 유발
              </td>
            </tr>
            <tr id="KDGERI_DDEP_PROSTATE">
              <td>
                <strong>하부 요로 증상, 전립선 비대증</strong>
              </td>
              <td>
                Inhaled anticholinergic agents
              </td>
              <td>
                요 정체 및 요 저류<br />
                남성환자에게 사용하지 말 것
              </td>
            </tr>
            <tr id="KDGERI_DDEP_STRESS_INCONTINENCE">
              <td>
                <strong>스트레스성 요실금</strong>
              </td>
              <td>
                Alpha-blockers (doxazosin, prazosin, terazosin)
              </td>
              <td>
                요실금 악화<br />
                여성환자에게 사용하지 말 것
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Ⅳ. 노인에게 처방·조제시 의약품 효능군별 주의사항 */}
      <div className="section" id="KDGERI_THERAPEUTIC">
        <h2>Ⅳ. 노인에게 처방·조제시 의약품 효능군별 주의사항</h2>

        {/* 1. 근골격계 */}
        <h3 id="KDGERI_TH_MSK">1. 근골격계</h3>

        <h4>1) 골관절염(osteoarthritis, OA)</h4>
        <p>
        관절연골의 소실에 의한 국소적인 퇴행성 변화를 특징으로 하며 관절 주위의 골반응을 동반한다. 류마티스 관절염과 같이 염증성 반응이나 전신적인 질병은 동반하지 않는다. 통증과 관절의 운동장애를 초래하여 노인 환자의 활동성에 제한을 초래하며, 진통제 복용의 원인이 되는 주된 질환으로 효과적인 질병 관리 및 통증 조절을 위한 약물 사용이 중요하다.
        </p>
        <p>
        약물치료는 환자 교육, 체중 감량, 운동 요법 등의 비약물적 치료와 병행되어야 좋은 치료 효과를 기대할 수 있다는 점을 반드시 염두에 두어야 한다. 또한 어느 한 약제가 모든 환자에게 똑같이 유효하지는 않기 때문에 약제의 종류가 다양하며 선택은 각 환자의 임상적 특성에 따라 개별화되어야 한다. 약물요법은 경구용 제제, 관절강내 주사제, 국소요법제로 나눌 수 있다.<sup>14)</sup> 약물치료의 치료목표는 통증의 완화에 있으며, 약제를 선택할 때에는 관절염이 있는 부위, 질환의 심각도, 동반질환 상태, 복용 중인 약물, 약물 알레르기를 고려하여야 한다.15)
        </p>
        <ul>
          <li>경구용 제제 : acetaminophen, COX-2 selective inhibitor, nonselective NSAID with or without misoprostol or a PPI, nonacetylated salicylate, tramadol, opioids</li>
          <li>관절강내 주사제 : glucocorticoids, hyaluronate sodium</li>
          <li>외용제 : capsaicin, topical NSAIDs</li>
        </ul>
        <p id="KDGERI_MSK_OA">
        <strong className="HL_1">노인 환자에서는 우선 상대적으로 부작용이 적은 아세트아미노펜으로 먼저 시작하는 것이 안전하다.</strong> 아세트아미노펜을 처음 시작할 때에는 하루 4 g을 넘지 않는 용량을 하루 중에 3-4번으로 나누어 복용하도록 한다. 비스테로이드성 소염진통제는 아세트아미노펜보다 통증 완화 효과가 더 우수하다.<sup>15)</sup> 그러나 아세트아미노펜보다 위장관, 신장, 심혈관계 부작용이 더 있으므로 아세트아미노펜을 사용하였으나 효과가 충분하지 못한 경우에 사용하도록 한다. 현재는 약물이상사례와 관련이 있는 cyclooxygenase-1(COX-1) 억제작용은 낮고, 항염증효과와 관련이 높은 cyclooxygenase-2(COX-2)를 선택적으로 억제할 수 있는 <strong className="HL_1">COX-2 선택적 억제제 (selective COX-2 inhibitor, 예 . celecoxib, meloxicam)가 널리 사용되고 있으나, 심혈관 질병의 발생을 증가시킨다는 보고가 있어 사용시 주의가 필요하다.</strong><sup>16)17)</sup>
        </p>
        <p id="KDGERI_MSK_OA_ASPIRIN">
        심혈관계 질환 예방목적으로 <strong className="HL_1">저용량 아스피린을 복용하는 환자가 비스테로이드성 소염진통제를 선택할 경우</strong>에는 아스피린의 항혈전작용에 영향이 적은 약을 선택하여야 한다. 최근 캐나다에서 위장관 및 심혈관계 부작용을 고려한 비스테로이드성 소염진통제 사용에 대한 가이드라인이 개발되었다. 가이드라인은 위장관 및 심혈관계 위험이 높은 환자 (예. 아스피린 복용하는 환자)는 가급적 비스테로이드성 소염진통제 사용을 피하고, 복용이 필요한 경우에는 비스테로이드 소염진통제 중에서 <strong className="HL_1">naproxen을 선택하여 프로톤펌프억제제 또는 misoprostol과 같이 복용하도록 권고하고 있다.</strong><sup>15)18)</sup>
        </p>
        <p>
        또한 COX-2 억제제가 위장관 부작용이 비선택적인 비스테로이드성 소염진통제보다 덜 하지만, 장기간 투여 시에도 그 효과가 우수한지에 대하여서는 분명하지 않다. 또한 이러한 위장관 부작용의 우수성은 아스피린을 복용하는 환자에서는 현저히 떨어진다.<sup>15)</sup> <strong className="HL_1">NSAID는 위장관 부작용, 신장기능 악화, 혈압 상승, 체액저류에 의한 심부전 악화 등의 약물이상사례가 발생할 수 있어 가능하면 단기간 사용하는 것이 추천되며, 장기적으로 사용할 경우에는 약물이상사례 발생 예방에 주의를 기울여야 한다.</strong>
        </p>

        <h4>2) 골다공증</h4>
        <p id="KDGERI_MSK_OSTEO">
        골다공증과 골절은 노인의 거동장애를 초래하여 독립적인 기능의 저해하고 삶의 질을 저하시키는 주된 질병이다. <strong className="HL_1">골다공증 치료약제로는 골흡수를 억제하는 여성호르몬제, 선택적 에스트로젠 수용체조절제 (selective estrogen receptor modulator, SERM), vitamin D, calcitonin, calcium, bisphosphonate 등과 골형성 촉진제인 fluoride 등이 있다.</strong><sup>19)</sup>
        </p>

        <h4>3) 만성통증</h4>
        <p id="KDGERI_MSK_PAIN">
        노인의 만성 통증은 복합적이고 다양한 요소를 가지고 있다. 일반적으로 경구용이 편리하고 상대적으로 혈액 농도가 일정하게 유지되어 선호되지만 빠르게 변동하는 급성 통증의 경우에는 적합하지 않을 수 있다. <strong className="HL_1">경피용, 설하, 직장 투여의 경우 삼킴 장애가 있을 때 유용하다.</strong> 투여 시간도 중요한데 <strong className="HL_1">심한 돌발성 통증에는 속효성, 단시간 작용 약물</strong>을 사용해야 한다.  <strong className="HL_1">간헐적 통증은 “필요시 복용”으로 처방할 수 있으나, 인지기능 장애가 있는 경우는 좋지 않은 방법이다.</strong> 지속되는 통증인 경우 시간표에 맞춰서 처방해야 한다. 지속되는 통증으로 장시간 작용 또는 서방형 약물을 복용하는 경우에도 돌발성 통증의 경감을 위해 속효성 단시간 작용 약물을 투여할 수 있다. 치료적 목표를 위해 한 개 이상의 약물이 필요할 수 있는데, <strong className="HL_1">서로 보완되는 작용 기전을 가진 약물을 2개 이상 복합하여 처방하면 한 개 약물을 높은 용량으로 처방하는 것보다 통증을 더 완화시키고 약물이상사례를 줄일 수 있다.</strong> 이러한 “rational polypharmacy”라는 전략은 특히 한 약물로 약물이상사례을 일으키는 용량이 아니면 통증 완화를 얻어낼 수 없는 경우 중요하다.<sup>20)</sup>
        </p>

        <div className="table-title" id="KDGERI_NONANL">
          [표 3] 만성통증 치료에 사용되는 비마약성 진통제
        </div>
        <table>
          <thead>
            <tr>
              <th style={{ width: '30%' }}>약물</th>
              <th style={{ width: '70%' }}>주의사항</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_NONANL_ACETAMINOPHEN">
              <td><strong>Acetaminophen</strong></td>
              <td>
                ∙ 1일 최대용량 4g<br />
                ∙ 간 장애가 있거나 알코올 남용력이 있는 경우 최대 용량의 50∼75%로 감량
              </td>
            </tr>
            <tr id="KDGERI_NONANL_CELECOXIB">
              <td><strong>Celecoxib</strong></td>
              <td>
                ∙ 용량 증가할수록 위장관 및 심혈관계 부작용 증가<br />
                ∙ 심혈관계 위험이 있는 경우 aspirin을 투여해야 하므로 노인에서는 위장관 보호제 병용이 필요함
              </td>
            </tr>
            <tr id="KDGERI_NONANL_NAPROXEN">
              <td><strong>Naproxen sodium</strong></td>
              <td>
                ∙ 심혈관 독성이 낮은 약물로 보고됨
              </td>
            </tr>
            <tr id="KDGERI_NONANL_IBUPROFEN">
              <td><strong>Ibuprofen</strong></td>
              <td>
                ∙ FDA에서 aspirin과 병용투여시 aspirin의 항혈소판효과가 저해된다고 지목하였으나 실제 임상적으로 뚜렷하지 않으며 다른 NSAIDs에서도 이러한지는 아직 뚜렷하지 않음
              </td>
            </tr>
            <tr id="KDGERI_NONANL_DICLOFENAC">
              <td><strong>Diclofenac sodium</strong></td>
              <td>
                ∙ 상대적으로 COX-2 inhibitor 선택성을 가지고 있어 기존 NSAIDs에 비해 심혈관계 위험이 높을 수 있음
              </td>
            </tr>
            <tr id="KDGERI_NONANL_NABUMETONE">
              <td><strong>Nabumetone</strong></td>
              <td>
                ∙ 반감기가 길고 항혈소판 작용이 적음
              </td>
            </tr>
            <tr id="KDGERI_NONANL_KETOROLAC">
              <td><strong>Ketorolac</strong></td>
              <td>
                ∙ 추천되지 않음. 위장관 및 신독성 위험이 높으며 장기간 복용에 부적합함
              </td>
            </tr>
          </tbody>
        </table>

        <div className="table-title" id="KDGERI_NARANL">
          [표 4] 만성통증 치료에 사용되는 마약성 진통제
        </div>
        <table>
          <thead>
            <tr>
              <th style={{ width: '30%' }}>약물</th>
              <th style={{ width: '70%' }}>주의사항</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_NARANL_HYDROCODONE">
              <td><strong>Hydrocodone</strong></td>
              <td>
                ∙ 속효성 제제로 급작스러운 통증이나 돌발성 통증에 유효<br />
                ∙ Acetaminophen과 복합제제로 acetaminophen 최대 용량 유의
              </td>
            </tr>
            <tr id="KDGERI_NARANL_OXYCODONE_IR">
              <td><strong>Oxycodone immediate-release</strong></td>
              <td>
                ∙ 급성 재발성, 돌발성 통증에 유효 단독으로도 사용됨<br />
                ∙ Acetaminophen과 복합제제일 경우 acetaminophen 최대 용량 유의
              </td>
            </tr>
            <tr id="KDGERI_NARANL_OXYCODONE_CR">
              <td><strong>Oxycodone controlled-release</strong></td>
              <td>
                ∙ 초기 용량을 속효성 마약성 진통제로 결정 후 시작하거나 다른 long-acting 마약성 진통제 복용 후 opioid rotation 필요시 사용
              </td>
            </tr>
            <tr id="KDGERI_NARANL_MORPHINE_IR">
              <td><strong>Morphine sulfate immediate-release</strong></td>
              <td>
                ∙ 속효성 제제로 급작스러운 통증이나 돌발성 통증에 유효
              </td>
            </tr>
            <tr id="KDGERI_NARANL_MORPHINE_SR">
              <td><strong>Morphine sustained-release</strong></td>
              <td>
                ∙ 초기 용량을 속효성 마약성 진통제로 결정 후 시작하거나 다른 long-acting 마약성 진통제 복용 후 opioid rotation 필요시 사용<br />
                ∙ 대사물질의 독성으로 신기능이 저하된 환자에게 사용이 제한됨<br />
                ∙ 음식이나 알코올 독성과 상호작용이 있음
              </td>
            </tr>
            <tr id="KDGERI_NARANL_HYDROMORPHONE">
              <td><strong>Hydromorphone</strong></td>
              <td>
                ∙ 돌발성 통증: 시간표에 따른 복용
              </td>
            </tr>
            <tr id="KDGERI_NARANL_FENTANYL">
              <td><strong>Transdermal fentanyl</strong></td>
              <td>
                ∙ 초기 용량을 속효성 마약성 진통제로 결정 후 시작하거나 다른 long-acting 마약성 진통제 복용 후 opioid rotation 필요시 사용<br />
                ∙ 24시간 60 mg의 morphine이 필요한 경우 가장 낮은 용량의 패취를 사용<br />
                ∙ 첫 사용시 최대 효과는 18∼24시간 후에 나타남<br />
                ∙ 지속기간은 보통 3일(48∼96시간)<br />
                ∙ 혈중 농도가 항정상태가 될 때까지 2∼3개 패취가 필요
              </td>
            </tr>
            <tr id="KDGERI_NARANL_TRAMADOL">
              <td><strong>Tramadol</strong></td>
              <td>
                ∙ 마약성 진통과 norepinephrine or serotonin reuptake inhibitor의 복합 작용기전을 가짐<br />
                ∙ 마약성 진통제의 약물이상사례를 모니터링해야 함<br />
                ∙ 고용량의 경우 발작 위험이 있음<br />
                ∙ SSRI와 함께 복용시 serotonin syndrome을 유발할 수 있음
              </td>
            </tr>
          </tbody>
        </table>

        <p id="KDGERI_MSK_PAIN_ADJ">그 외, 보조 약물로는 항우울제, 항경련제 등 통증 전달 과정에서 신경세포막 전위, 이온 채널, 세포 표면 수용체 부위, 또는 시냅스의 신경전달물질수준 등을 변화시키는 약물들이 포함된다. 보조 약물은 단독으로 또는 비마약성, 마약성 진통제와 함께 처방할 수 있으며, 특히 신경병성 통증에서 널리 사용되고 있다. 기타 약물로는 <strong className="HL_1">gabapentin, pregabalin</strong> 등 voltage-gated alcium ion channel에 작용하는 항경련제 약물, <strong className="HL_1">부신피질호르몬제, 근이완제 (baclofen), calcitonin, bisphosphonate 등</strong>이 있다. <strong className="HL_1">삼환계 항우울제 (TCA)는</strong> 대상포진 후 신경통과 통증성 당뇨병성 말초신경염에서 통증을 감소시킨다고 처음 밝혀진 약물이나, 약물이상사례 때문에 <strong className="HL_1">노인에게 금기</strong>시되기도 하였다. 항우울제 중 <strong className="HL_1">serotonin- and norepinephrine-uptake inhibitors(SNRIs) (예 . duloxetine, venlafaxine)는 특히 다양한 신경병성 통증과 섬유근통에서 효과적이면서 삼환계 항우울제보다 약물이상사례가 덜한 것으로 보고된 바 있다.</strong> 반면 세로토닌 재흡수 차단제 (selective serotonin reuptake inhibitor, SSRI) (예 . sertraline, fluvoxamine, fluoxetine, citalopram)는 통증 에 대한 효과가 아직 검증되지 않았다.<sup>20)</sup></p>

        {/* 2. 소화기계 */}
        <h3 id="KDGERI_TH_GI">2. 소화기계</h3>
        <p>노인 환자는 소화기계 운동질환, 식욕저하, 변비, 복부 팽만감 등의 증상을 호소하는 경우가 흔하다. 이는 소화기계통 장기의 기질적 이상에 의한 증상일 수도 있으나, 다른 계통의 이상에 의한 비전형적인 증상이나 복용하는 약물의 이상반응에 의한 증상일 가능성이 있으므로 진단시 주의가 필요하다. 예를 들어, 드물게 상복부 불쾌감, 오심, 구토 등의 증상이 하벽 심근경색 (inferior wall myocardial infarction)에 의한 증상일 가능성이 있다는 사실을 염두에 두어야 한다. 또한 비특이적인 소화기계 증상을 호소하는 경우에도 노인은 소화기계 악성 질환 (gastrointestinal tract malignancy)의 가능성이 젊은 연령에 비해 높다는 점을 염두에 두고 진단할 필요가 있다. 노인의 유병율이 높은 소화기계 질환으로는 역류성 식도질환, 소화성 궤양, 게실 질환, 변비, 췌담도 질환, 소화기계 악성 질환 등을 생각할 수 있다. 노인에게 소화기계 약물을 처방할 때, 약품의 효능군에 따라 고려할사항은 아래와 같다.</p>

        <div id="KDGERI_GI_GERD">
        <h4>1) 역류성위산과다, 위궤양</h4>
        <p>주로 수용성 약제이며 신장으로 배설되는 약물이 많다. 그러므로 신기능이 저하되어 있는 노인환자에서는 신기능을 측정 및 평가하여 그에 따라 약제 용량 및 투여 주기를 세심하게 조절해야 한다. 특히 cimetidine의 경우 cytochrome P450에 의해 이루어지는 다른 약물들의 대사에 많은 영향을 끼쳐서 병용투여 약물의 혈중 농도 상승을 초래할 수 있다. <strong className="HL_1">노인에게는 가급적 cimetidine 투여를 피하고</strong> 다른 약제로 대체하여 사용하는 것을 고려해야 한다. 장기적으로 사용하는 경우  <strong className="HL_1">골수억제 작용에 의해 혈소판감소증을 초래할 수도 있다.</strong></p>
        </div>

        <div id="KDGERI_GI_DYSPEPSIA">
        <h4>2) 소화장애</h4>
        <p><strong className="HL_1">도파민 수용체 (D2) 차단제의 경우 추체외로증상 (extrapyramidal symptom), 고프로락틴혈증 (hyperprolactinemia), QT 간격 연장, 구강이상운동증 (oral dyskinesia) 등의 증상을 유발</strong>할 수 있어 사용에 주의를 요한다.<sup>21)</sup></p>
        </div>

        {/* 3. 순환기계 */}
        <h3 id="KDGERI_TH_CVS">3. 순환기계</h3>
        <p>연령이 증가함에 따라 심혈관계의 노화현상이 동반되며, 이는 심혈관 질환의 위험인자의 증가와 더불어 노인에서 심혈관 질환의 유병율이 증가하는 주요 원인이 된다. 심혈관계 노화에 따른 특성으로 인해 노인에서는 단독 수축기 고혈압 (isolated systolic hypertension) 및 이완기 심부전 (diastolic heart failure) 등이 특징적으로 관찰되며, 여러 만성 질환을 동반하고 있고 신체 장기의 기능이 저하되어 있어 진단과 치료에 있어 일반 성인과 차이를 보일 수 있다는 점을 고려해야 한다. 특히 노화로 인한 기능적 예비능(functional reserve) 및 항상성 저하는 심혈관계에 가장 크게 나타나기 때문에, 생리적 스트레스를 받는 상황에서 심혈관계의 보상작용 상실이 가장 많이 일어난다.22)</p>

        <h4 id="KDGERI_CVS_HTN">1) 고혈압</h4>
        <p>이완기 혈압은 정상이고 수축기 혈압만 상승되어 있는 단독 수축기 고혈압 (isolated systolic hypertension)은 노인에서 흔히 관찰되는 고혈압 상태이다.23)24) 연령이 증가할수록 혈관벽의 두께가 증가하며, 콜라겐 등 조직기질의 증가 및 석회화로 인해 대동맥의 경직도가 증가되고 탄력성이 감소되어, 단독 수축기 고혈압의 발생이 증가한다.25) 노인에게 나타나는 고혈압 중약 95%가 본태성 (원발성) 고혈압이지만, 최근 갑자기 발생하였거나 약물 투여 후에도 혈압 강하 반응이 좋지 않은 불응성 고혈압인 경우에는 신동맥 협착에 의한 신혈관성 고혈압의 가능성이 있으므로 감별 진단해야 한다.</p>
        <p>혈압을 측정할 때는 가성 고혈압 (pseudohypertension) 가능성을 염두에 두어야 한다. 노인의 혈관은 딱딱하고 석회화되어 있어 보통의 혈압계로는 동맥혈관이 압박되지 않아 혈압값 수치가 실제값 보다 과장되어 측정될 수 있다. 또한 죽상동맥경화로 인해 상완동맥의 내경이 좁아진 경우에는 혈압이 실제값 보다 낮게 측정될 위험이 있다. 따라서 왼쪽과 오른쪽, 또는 상지와 하지의 혈압에 일정 수치이상 차이가 있는 경우에는 말초혈관 질환을 의심해야 한다. <strong id="KDGERI_HTN_ORTHO" className="HL_1">항고혈압 약물을 사용할 때에는 어지럼증이나 현기증, 기립성 저혈압 등의 약물이상사례에 주의해야 한다. 항고혈압 약물을 복용하는 노인환자는 누웠다가 일어날 때 천천히 일어나도록 하며, 특히 비뇨기계에 비선택적인 알파차단제 (예 . doxazosin, terazosin)는 기립성 저혈압 약물이상사례를 주의해야 한다.</strong> 실신을 주소 (chief complaint)로 내원하거나 어지럼증을 호소하는 환자의 경우에도 좌위와 기립 시 혈압을 측정하여 기립성 저혈압의 가능성을 감별해야 한다.</p>
 

        <h4 id="KDGERI_CAD">2) 관상동맥질환</h4>
        <p>노인환자는 기능적 예비능 (functional reserve)이 저하되어 있으며 호흡기 질환, 빈혈, 판막질환 등을 동반하고 있는 경우가 많아 질병경과 중 급격한 악화를 보일 수 있다. 또한 증상이 비전형적으로 발현하는 경우가 흔하므로, 진단시 감별질환을 폭넓게 고려하지 않고 접근하면 오진하게 될 가능성이 많다. 또한 운동 능력의 저하로 인해 일상생활 중 운동량이 감소하므로, 환자는 관상동맥 질환의 전형적 증상인 운동시 호흡곤란 (dyspnea on exertion)을 호소하지 않는 경우가 많아 진단율이 낮아질 수 있다.</p>

        <p>노인은 심근 경색으로 인한 사망률이 높은 것으로 알려져 있다. 이는 위에 언급한 진단적 어려움으로 인해 적절한 치료를 받을 시기를 놓치는 것과 혈전용해제, 관동맥 성형술, 관동맥 우회수술 등과 같은 심근 경색의 치료법으로 인한 합병증의 발생위험이 젊은 연령층에 비해 높다는 점에 기인한다.<sup>26)27)</sup> 항혈소판제 사용시에도 안전한 약물을 사용하는 것이 중요하다. <strong id="KDGERI_CAD_TICLOPIDINE" className="HL_1">Ticlopidine은 가려움증, 간기능 변화 등의 약물이상사례 뿐만 아니라 백혈구 감소증 같은 심각한 약물이상사례가 나타날 수 있으므로 주의를 요한다.</strong> <strong id="KDGERI_CAD_PPI" className="HL_1">그리고 이러한 항혈소판제와 PPI의 상호작용에 의한 합병증의 보고가 있으므로, 노인환자에게 약물사용시 주의가 요구된다.</strong></p>

        <div id="KDGERI_HF">
        <h4>3) 심부전</h4>
        <p>심부전은 65세 이상의 연령에서 가장 흔한 질환 중 하나다. 허혈성 심질환의 유병율이 증가할 뿐 아니라 치료법의 발전으로 인해 허혈성 심질환을 지닌 환자의 생존율이 증가하므로, 앞으로도 심부전 유병율은 지속적으로 증가할 것으로 예상된다.<sup>28)29)</sup> 심부전의 전형적 증상은 호흡곤란, 부종 등이지만 <strong className="HL_1">노인은 소화불량, 만성기침 등 비특이적 증상을 호소하며 내원하는 경우가 많다.</strong><sup>30)</sup></p>

        <p>심부전 환자의 치료계획을 수립할 때는 증상조절도 중요하지만, <strong className="HL_1">질환의 급격한 악화를 유발한 원인을 교정하는 것이 우선적이다. 예를 들어 철분 부족 등으로 인해 발생한 빈혈, 심방 세동 등 부정맥, 감염, 고혈압, 허혈성 심질환, 의약품의 부적절한 투여, 염분의 과다섭취 등</strong>으로 인해 심부전이 급격히 악화된 경우 이에 대한 적극적인 교정이 필요하다.31)32)</p>
        </div>

        <div id="KDGERI_CVS_SVT">
        <h4>4) 심방세동</h4>
        <p>심방 세동은 노인에서 흔히 관찰되는 부정맥이다. 연령이 증가할 수록 유병율이 증가하는 것으로 알려져 있으며 뇌졸중, 심부전 등을 유발하는 대표적 질환 중 하나이므로 임상적으로 중요한 질환이다. 심장의 기저질환이 없이 갑자기 발생한 심방 세동일 경우, 갑상선기능 항진증으로 인해 발생한 것일 수 있다. <strong id="KDGERI_AF" className="HL_1">심방 세동의 약물 치료로는 항부정맥제를 사용하여 동성리듬 (sinus rhythm)을 유지하고, 베타차단제와 칼슘길항제를 사용하여 심박수를 조절하며, 항응고제를 사용하여 혈전생성을 예방하는 치료가 있다.</strong> </p>
        <p>특히 warfarin 등 항응고제 요법과 aspirin은 특별한 금기 및 약물이상사례가 없다면 75세 이상의 노인 환자와 뇌졸중 위험요인을 지닌 65세 이상의 노인환자에서 적극적으로 시행할 것을 권장한다.<sup>33)</sup> <strong id="KDGERI_AF_WF" className="HL_1">Warfarin의 경우 노인환자에서는 수용체의 반응성이 증가하여 효과가 상승해 약물이상사례가 나타날 수 있어, 저용량부터 시작하며 세심한 용량 조절이 필요하다.</strong> 특히 최근에 새로 개발된 항응혈제로 <strong id="KDGERI_AF_NOAC" className="HL_1">dabigatran, rivaroxaban, apixaban 등이 와파린을 대체하여 사용이 증가하고 있다 . 75세 이상의 노인에게 특히 조심하여 사용하는 것이 권장되고 있으며, 사용시 출혈 등의 모니터링과 복용순응도를 높이는 노력이 필요하다.</strong> 심박수 조절을 위해 사용되는 <strong id="KDGERI_AF_DIGOXIN" className="HL_1">digoxin도 신장으로 배설되는 약물이므로, 신장기능이 저하된 노인환자에서는 혈중 농도가 상승하여 약물이상사례가 나타날 수 있다. 따라서 노인환자에게 저용량을 사용하고, 혈중 농도 확인을 통해 용량을 조절해야 한다.</strong></p>
        </div>

        {/* 4. 신경정신계 */}
        <div id="KDGERI_TH_CNS">
        <h3>4. 신경정신계</h3>
        <p>노인의 신경계는 뇌와 신체의 노화, 심리적 요인, 환경적 요인과 적응력 저하 등 많은 인자의 영향을 받으며, 특히 외부환경 변화에 취약하다. 그리고 노화과정에서 체지방 성분이 증가함에 따라 지질친화약물의 체내 분포용적 (volume of distribution)이 증가하므로, 지용성 약물이 많은 정신건강 의학과 약제의 특성을 고려할 때 약물의 체내 축적 위험이 높아진다. 따라서 안전성을 중요하게 생각해야 하며, <strong className="HL_1">작용시간이 짧고 체내에 축적되는 양이 적은 약물을 선택하는 것이 좋다. 일반적으로 사용되는 용량의 1/2～1/3에서부터 투여를 시작</strong>하고, 반드시 효과를 관찰하면서 천천히 증량하도록 한다. <strong className="HL_1">많은 신경정신계 약물이 항콜린 부작용을 가지고 있는데</strong> , 노인에서 항콜린 작용이 강한 약제는 입 마름, 변비, 인지기능 저하, 섬망 등을 초래할 위험이 높으므로가급적 사용을 최소한도로 줄인다. 또한 <strong id="ANTICHOL_EXPLAIN" className="HL_1">환자에게 미리 항콜린성 부작용에 대해 충분히 설명을 하여, 약물이상사례가 나타났을 경우 즉시 환자가 의약전문가에게 상담을 요청할 수 있도록 노력해야 한다.</strong></p>

        <p>낙상의 위험요인은 여러 가지가 있지만 특정 약물군에 의한 낙상 위험 자체가 증가할 수 있고, 대표적인 약물로는 신경정신계에 작용하는 항경련제, 항정신병제제, 벤조다이아제핀계, 삼환계 항우울제, 선택적 세로토닌 재흡수 차단 항우울제 (selective serotonin reuptake inhibitor, SSRI) 등이 있다. 그 외에도 한 연구에 따르면 노인 환자에 흔하게 처방되는 약물 중 아편류 제제, 항혈소판제제, 변비약, 당뇨약, 갑상선 제제 등에서 이러한 약물을 복용하지 않은 환자군에 비해 약물을 처방받았던 환자들에서 낙상 상해에 대해 양의 상관관계를 나타냄이 보고되었다.<sup>34)</sup> 2012년 Beers Criteria에도 낙상 또는 골절이 있던 노인환자에게 낙상유발 가능성이 있는 약물 사용은 피할 것을 권고하고 있다.</p>
        </div>
        
        <div id="KDGERI_DEPR">
        <h4>1) 우울증</h4>
        <p><strong className="HL_1">일반적으로 삼환계 항우울제 (예 . amitriptyline, nortriptyline, imipramine)는 강력한 항우울 작용을 보이나 기립성 저혈압, 빈맥과 같은 심혈관계 부작용 및 항콜린성 부작용이 심하므로 노인환자에게는 사용을 피하는 것이 좋다.</strong><sup>35)</sup> 반면 선택적 세로토닌 재흡수 차단제 (SSRI)는 항콜린 작용, 심혈관계 부작용 및 진정작용이 적어 노인환자에서도 폭넓게 사용되고 있으며, 치매환자의 공격성, 초조함 및 짜증 (agitation, aggression and irritability) 등 의 증상 조절 및 노인 우울증 환자에서 관찰되는 신체증상 및 불안증에도 효과적인 약제로 알려져 있다. 그 외 세로토닌 길항제-재흡수 차단제(serotonin antagonist and reuptake inhibitor, SARI)인 mirtazapine과 세로토닌-노르에피네프린 재흡수 차단제 (serotonin norepinephrine reuptake inhibitor, SNRI)인 venlafaxine 등의 약제가 삼환계 항우울제에 비해 약물이상사례가 적으면서 효과적인 항우울효과를 보이는 것으로 알려져 있다</p>
        </div>

        <h4 id="KDGERI_DEMENTIA">2) 치매</h4>
        <p>치매환자를 대할 때 주의할 점은 치매의 원인이 가역적인지 비가역적인지 판단하여 각 경우에 적절한 치료방침을 수립하는 것이다. 치매의 가역적인 원인으로는 folate, cobalamin, thiamine 등의 비타민 결핍, 만성 약물중독, 경막하 혈종 (subdural hematoma), 정상압 뇌수종 (normal pressure hydrocephalus) 등이 있으며 비가역적인 원인으로는 뇌경색, 알츠하이머형 치매 등이 있다. 비가역적 원인으로 인한 치매환자에게는 증상을 완화시키는 약물 치료를 주로 시행하게 된다.</p>

        <p>치매 관련 약물에 대한 연구는 주로 알츠하이머형 치매 환자군에서 이루어졌는데, 기억력 장애가 아세틸콜린의 부족에서 유발된다는 가설과 뇌의 콜린계 활성을 높이면 기억력 장애가 호전된다는 이론에 근거하여, cholinergic agent가 치매환자의 인지 기능 향상을 위해 사용되고 있다. 현재 아세틸콜린의 분해를 억제하는 cholinesterase inhibitor가 임상에서 널리 사용되고 있으며 donepezil, rivastigmine, galantamine 등이 대표적인 약제이다.<sup>36)</sup> 한편 N-methyl-D-aspartic acid(NMDA) 수용체 길항제인 memantine은 세포내 칼슘 유입을 차단하여 glutamate에 의한 세포독성을 예방하여 중등도 이상의 알츠하이머병의 임상 증상을 호전시키는 것으로 알려져 있다.</p>
        <p>치매환자에서 흔히 관찰되는 행동정신증상 (behavioral and psychological symptom of dementia, BPSD)의 조절을 위해서는 항정신약제의 사용이 필요한데 risperidone, olanzapine, quetiapine 등의 비전형적인 항정신병 약제가 흔히 사용된다.<sup>37)</sup> 이러한 약제는 추체외로증상의 발생이 적다는 장점이 있으나, <strong id="KDGERI_DEMENTIA_ATYPE" className="HL_1">일부에서 인지기능의 저하를 초래하며 QT 간격 연장 등의 심혈관 부작용으로 인해 치매환자의 사망률을 오히려 증가시킨다는 보고가 있어 사용에 주의를 요한다.</strong><sup>38)39)40)41)</sup></p>

        <div id="KDGERI_ANXIETY">
        <h4>3) 항불안제, 수면제</h4>
        <p>노인에서는 체지방의 증가로 인해 지효성 벤조다이아제핀계 약물
        (long-acting benzodiazepine)을 사용하는 경우 체내 축적에 의해 약물이상사례가 발생할 위험이 증가한다. 따라서 반드시 필요한 경우에 국한하여 단기간 사용하는 것을 추천하고, <strong className="HL_1">가급적 속효성 벤조다이아제핀 약물(short-acting benzodiazepine)을 사용하는 것이 안전하다.</strong> 또한 6주 이상 벤조다이아제핀을 사용하다가 중단하는 경우에는 금단증상을 예방하기 위해 서서히 감량하여 중단하는 것이 필요하다.<sup>42)</sup> 또한 노인들이 많이 호소하는 불면증의 치료 약물로는 alprazolam, lorazepam 등의 속방형 벤조다이아제핀계 약물 (immediate-acting benzodiazepine)이나 zolpidem과 같은 약제를 사용하며, <strong className="HL_1">낮 시간 동안 과도한 진정작용을 초래하여 낙상과 같은 약물이상사례의 위험이 증가하지 않도록 주의 깊게 관찰하여야 한다.</strong><sup>43)44)45)</sup></p>
        </div>

        <div id="KDGERI_PARKINSON">
        <h4>4) 파킨슨병</h4>
        <p>파킨슨병은 안정시 떨림 (resting tremor), 근육의 강직 (spasticity), 서동(bradykinesia), 자세불안정 (postural instability) 등을 특징으로 하는 질환으로 중뇌의 흑색질 (substantia niagra)의 도파민 (dopamine) 분비세포의 소실에 의해 발생하는 대표적인 신경 퇴행성 질환이다. 질병경과가 만성으로 서서히 진행하는 특징을 가지고 있으며 경과가 진행된 경우 보행장애, 섭식장애, 혈역학적 불안정 및 배뇨장애 등의 기능 저하를 초래한다. <strong className="HL_1">대표적인 약물치료제로는 도파민 보충제, 도파민 수용체 효능제 (dopamine receptor agonist), 그리고 특히 떨림증상에 효과적인 항콜린성 약제 등이 있으며 그 외 monoamine oxidase (MAO) inhibitor와 catechol O-methyltransferase (COMT) inhibitor 등이 사용된다.</strong> 흔히 사용되는 항파킨슨병 약제의 기전과 약물이상사례는 아래 표에 정리하였다.<sup>46)</sup></p>
        </div>

        <div className="table-title" id="KDGERI_ANTIPARK">
          [표 5] 항파킨슨병 약제의 기전과 약물이상사례
        </div>
        <table>
          <thead>
            <tr>
              <th style={{ width: '20%' }}>기전별 분류</th>
              <th style={{ width: '25%' }}>기전</th>
              <th style={{ width: '25%' }}>대표성분</th>
              <th style={{ width: '30%' }}>약물이상사례</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ANTIPARK_ANTICHOLINERGICS">
              <td><strong>항콜린제<br />(anticholinergics)</strong></td>
              <td>아세틸콜린 수용체 차단</td>
              <td>Trihexyphenidyl, benztropine</td>
              <td>구강건조, 배뇨장애, 녹내장 악화, 인지기능 저하</td>
            </tr>
            <tr id="KDGERI_ANTIPARK_LEVODOPA">
              <td><strong>Levodopa</strong></td>
              <td>dopa-decarboxylase에 의해 도파민으로 대사되어 작용</td>
              <td>Levodopa-carbidopa<br />Levodopa-benserazide</td>
              <td>구역, 체위성 저혈압, 정신증 (혼동, 불면, 악몽, 환각, 망상 등), 운동 기능 악화 (운동실조, 전진 등)</td>
            </tr>
            <tr id="KDGERI_ANTIPARK_DOPAMINE_AGONIST">
              <td><strong>Dopamine receptor agonist</strong></td>
              <td>도파민 수용체 항진</td>
              <td>Bromocriptine, Pramipexole, Ropinirole, Rotigotine</td>
              <td>구역, 체위성 저혈압, 정신증 (혼동, 불면, 악몽, 환각, 망상 등), 하지 부종</td>
            </tr>
            <tr id="KDGERI_ANTIPARK_MAOI">
              <td><strong>Monoamine oxidase inhibitor (MAOI)</strong></td>
              <td>MAO-B 수용체를 차단하여 도파민 대사 억제</td>
              <td>Selegiline, Rasagiline</td>
              <td>구역, 어지럼증, 수면장애</td>
            </tr>
            <tr id="KDGERI_ANTIPARK_COMT">
              <td><strong>Catechol O-methyltransferase (COMT) inhibitor</strong></td>
              <td>COMT 활성을 억제하여 L-dopa의 대사를 억제</td>
              <td>Entacapone</td>
              <td>L-dopa에 의한 약물이상사례 증가, 운동이상증, 정신증 (혼동, 불면, 악몽, 환각, 망상 등) 위장관계 증상 (오심, 구토, 복통, 변비 및 설사)</td>
            </tr>
            <tr id="KDGERI_ANTIPARK_AMANTADINE">
              <td><strong>Amantadine</strong></td>
              <td>NMDA와 아세틸콜린 수용체를 차단하여 도파민 분비 증가</td>
              <td>Amantadine</td>
              <td>시야장애, 정신병적 증상 (망상, 불안, 악몽, 불면, 어지러움, 우울, 지남력 상실 등), 하지 부종</td>
            </tr>
          </tbody>
        </table>

        {/* 5. 호흡기계 */}
        <h3 id="KDGERI_TH_RESPIRATORY">5. 호흡기계</h3>
        <p>연령이 증가할수록 폐기능이 감소함은 잘 알려져 있으며, 이러한 노화과정에 따라 노인의 호흡기계 질환 유병율이 증가한다. 그러나 노인은 호흡기 질환의 증상을 질병으로 인지하지 못하고 단순히 노화과정의 일부로 여기기 쉽다. 또한 호흡기계의 악성종양은 초기에는 별다른 증상을 나타내지 않는 경우가 많아 자세한 문진 및 진찰 없이는 진단을 내리지 못하는 경우가 많다. 따라서 노인환자에게 호흡기 관련 약물을 처방할 경우에는 숨겨진 기저질환의 가능성을 염두에 두고, 약물투여기간이 길어질 경우 환자의 상태를 재평가하여 정확한 진단 및 적절한 약물투여가 이루어졌는지 재확인하는 것이 필요하다.</p>

        <h4 id="KDGERI_RESP_COPD">- 만성폐쇄성 폐질환</h4>
        <p>노인에게 호흡곤란 증상이 있을 때, 노화로 인한 생리적 변화로 생각하여 질병이 진단되지 않는 경우가 있다. 노인에서 만성호흡곤란을 일으키는 가장 대표적 질환인 만성폐쇄성 폐질환은 진행성 질병경과를 보이는 질환이다. 만성폐쇄성 폐질환의 적절한 관리를 위해서는 호흡기 증상과 폐기능 검사의 기류제한 정도에 대하여 주기적으로 검진하여야 하며, 폐기능 검사의 결과에 따른 병기를 기준으로 의약품의 사용을 결정한다. 의약품을 사용하더라도 환자의 질병 예후에 영향을 주지는 못하지만, 증상을 호전시켜서 삶의 질을 향상시키고, 합병증 발생을 예방할 수 있다.
        </p>
        <p id="KDGERI_COPD_INHAL">만성폐쇄성 폐질환에 대표적으로 사용되는 의약품은 기관지 확장제로서 beta-2 adrenergic agonist, anticholinergic drug, methylxanthine 계열 약물 등이 있으며, 전신적인 합병증의 발생을 줄이기 위해 <strong className="HL_1">경구약제보다 흡입제 사용이 우선적으로 추천된다.<sup>47)</sup> 흡입제는 특수한 제형으로 제공되므로 사용법을 정확히 이해할 수 있도록 복약상담이 필요하며,</strong> 필요시 스페이서를 사용하여 사용상의 편의성을 증가할 수 있다. </p>
        <p id="KDGERI_COPD_ANTITU">만성폐쇄성 폐질환에서 가장 흔한 증상 중 하나는 지속적인 기침인데, 노인은 호흡기계의 기능적 예비능이 감소되어 있으므로, <strong className="HL_1">진해제를 권장용량 내에서 투여하여도 진정작용으로 인해 호흡억제를 일으킬 수 있다.</strong> 또한 기침에는 기도 내의 점액 및 이물질을 배출하는기능도 있으므로, <strong className="HL_1">만성폐쇄성 폐질환에서 진해제를 지속적으로 투여하는 것은 피하도록 한다.</strong> 특히 아편계 진해제 등 호흡억제를 일으킬 수 있는 약물을 투여할 때는 항상 과도한 진정작용에 주의해야 한다. 또한 비약물적 요법으로 충분한 수분섭취를 권한다.</p>

        {/* 6. 피부계 */}
        <h3 id="KDGERI_TH_DERM">6. 피부계</h3>
        <p>노화과정에서 피부는 교원섬유 및 탄력섬유의 감소로 인한 육안적 변화 뿐 아니라, 면역학적 기능이나 생리적 기능도 함께 감퇴한다. 또한 표피의 재생시간 (epidermal turnover time)이 젊은 성인에 비해 두 배 가량 연장되어 있으므로, 피부에 외상이 생겼을 경우 치유능이 젊은 성인보다 낮고 감염위험이 증가한다.</p>

        <h4>- 소양증</h4>
        <p id="KDGERI_PRURITUS">소양증, 즉 가려움증은 65세 이상의 노인환자가 가장 많이 호소하는 피부 증상으로서<sup>48)</sup> 대부분의 경우 노화된 피부의 수분함유 감소와 점진적 피지선 분비의 감소로 인한  <strong className="HL_1">피부건조로 인해 발생하는 특발성 소양증(idiopathic pruritus)이다.</strong> 특발성 소양증은 별다른 원인 없이 노화과정으로 인해 발생하는 증상이며 <strong className="HL_1">대부분 약물치료 없이도 충분한 보습과 보존적 치료만으로도 증상이 경감된다.</strong> 그러나 여러 가지 피부질환이나 내과적 또는 신경과적 질환과 연관되어 소양증이 발생하는 경우도 있다. <strong className="HL_1">양증을 일으키는 주요 질환으로는 당뇨병, 폐쇄성 담도질환, 만성신부전 등</strong>소이 있다.<sup>49)</sup></p>

        <p id="KDGERI_PRURITUS_THER">소양증으로 인해 지속적으로 피부를 문지르거나 긁으면 이로 인해 상처가 생기고 감염위험이 증가할 수 있다. 따라서 노인환자가 가려운 감각을 호소할 때 피부질환이나 전신질환 등의 소양증의 기저 원인여부를 주의 깊게 파악하여야 하며, 충분한 대증적 치료를 시행하여 더 이상 피부를 긁거나 손상을 가하지 않도록 조절해야 한다. <strong className="HL_1">소양증에 대한 대증적 치료로서 와세린 성분의 크림이나 로션으로 피부건조를 방지하고, 약물치료로 주로 국소 스테로이드제와 경구 항히스타민제 (예 . hydroxyzine)가 사용된다.</strong> 항히스타민제는 입마름, 배뇨장애, 착란, 섬망 등의 약물이상사례를 일으킬수 있다.<sup>49)</sup> 이러한 약물이상사례는 노인에게 임상적 의의가 큰 유해반응들이므로, 노인환자군에게 항히스타민제를 사용할 경우에는 의약품의 치료 유익성과 치료위험성을 신중히 평가하여 투여 여부를 판단하고, 투여 중 약물이상사례 발생 여부에 주의를 기울일 필요가 있다. 최근 새로운 항히스타민제인 <strong className="HL_1">loratadine, fexofenadine 등은 졸음과 건조증 등의 약물이상사례를 줄이는 것으로 보고되어 있다.</strong></p>

        {/* 7. 내분비계 */}
        <h3>7. 내분비계 (여성호르몬제)</h3>
        <p>여성호르몬은 과거 수십년간 폐경 후 여성의 골다공증 치료에 사용되어 왔으며, 폐경기 증후군에 대한 증상완화 효과 뿐만 아니라 치매, 대장암 및 직장암에 대해서도 유익한 효과가 있다고 알려져 많은 여성 노인에게 투여되었다. 그러나 미국 국립보건원(NIH, National Institutes of Health)에서 시행한 대규모 임상 연구 (WHI, 2002) 결과 <strong id="KDGERI_ENDO" className="HL_1">유방암 발생의 위험이 증가하고 색전증 등 심혈관계 질환 위험을 증가시키는 약물이상사례가 보고되어,</strong><sup>50)</sup> 근래에는 골다공증만 치료할 경우 여성호르몬요법보다 비스포스포네이트(bisphosphonate)약물 등 다른 골다공증 약제를 선택하는 경우가 많다. 그 밖에 여성호르몬을 알츠하이머 치매의 치료에 사용하기 위한 연구가 이루어지고 있으나, 현재까지는 뚜렷하게 월등한 효과가 보고된 바 없다.<sup>51)52)53)54)</sup> 현재로서는 여성호르몬은 개인환자의 임상상태에 따라 치료 유익성과 치료위험성을 면밀히 분석한 후에 투여 여부를 결정하는 것이 바람직하며, 가급적 <strong id="KDGERI_ENDO_MENOPAUSE" className="HL_1">폐경 초기에 단기간 투여하고, 전신적 투여보다는 국소적 투여방법을 시도하는 것을 권고</strong>한다.</p>

        {/* 8. 비뇨기계 */}
        <h3 id="KDGERI_TH_URO">8. 비뇨기계</h3>

        <h4 id="KDGERI_INCONTINENCE">- 요실금</h4>
        <p>노인성 요실금이란 방광의 소변 저류 능력의 감소 및 요도괄약근 기능의 약화로 원하지 않은 시간과 장소에서 본의 아니게 소변이 배출되는 것을 말한다.<sup>55)</sup> 요실금은 대개 요도 또는 방광의 기능 이상 (항진 또는 저하)로 인하여 발생하며, 드물게는 선천적인 장애로 발생할 수 있다. 요실금의 종류에는 스트레스성 요실금 (stress urinary incontinence; 주로, 여성에서 발생하는 방광 주위 또는 괄약근의 퇴화가 원인), 절박성 요실금 (urge urinary incontinence; 과민성 방광으로 인하여 방광 평활근의 불수의적인 잦은 수축이 발생), 범람성 요실금 (overflow urinary incontinence; 방광에 소변이 가득 차 있으나, 소변을 제대로 보지 못하는 경우 발생, 요도 기능 항진 또는 방광 기능 저하 혹은 이 두 가지 기전의 복합적 결과로 발생) 등이 있으며, 기전에 따라 원인이 다양하다.<sup>56)</sup></p>

        <p>노인에게서 발생하는 요실금의 원인으로는 섬망 상태, 요로 감염, 변비, 정신질환 (우울증) 및 약물사용 등이 대표적이며, 노인에게서 갑자기 발생한 요실금의 원인으로 이들을 감별하여야 한다.</p>

        <p>노화에 따라 방광의 기능을 조절하는 뇌 기능의 감퇴, 자연적인 방광 및 요도 구조의 노화 등은 기본적으로 노인을 요실금에 취약하게 하는 요인이며, 부가적으로 요실금을 유발하는 질환으로는 남자에서는 방광출구를 막게 되어 여러 배뇨증상을 유발하는 전립선비대증, 여성에서는 요로 감염 및 복압성 요실금이 대표적이다. 또한, 당뇨, 고혈압 등 직접적으로 배뇨기능에 영향을 미치거나, 이들 질환의 치료를 위하여 사용하는 약물에 의하여 요실금이 유발될 수도 있으며, 노인성 관절염 및 근감소증에 의한 활동 제한 또한 요의가 있을 때 화장실까지의 이동을 지체시켜 요실금이 일어나게 되는 원인이 될 수 있다.<sup>55)</sup></p>


        <div className="table-title" id="KDGERI_URINC">
          [표 6] 요실금을 일으킬 수 있는 약물의 예<sup>57)</sup>
        </div>
        <table>
          <thead>
            <tr>
              <th style={{ width: '40%' }}>약물 종류(예)</th>
              <th style={{ width: '60%' }}>요자제에 미치는 효과</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_URINC_SEDATIVE">
              <td>안정제/최면제 (Diazepam, Flurazepam 등 Benzodiazepine)</td>
              <td>안정, 착란, 기동성 저하로 인한 기능성 요실금</td>
            </tr>
            <tr id="KDGERI_URINC_ANTICHOLINERGIC">
              <td>항콜린성 약제 (Dicyclomine, Disopyramide)</td>
              <td>요폐, 일류성 요실금, 착란, 변비</td>
            </tr>
            <tr id="KDGERI_URINC_ANTIPSYCHOTIC">
              <td>항정신병 약제 (Thioridazine, Haloperidol)</td>
              <td>항콜린성 작용, 안정, 경직, 기동성 저하</td>
            </tr>
            <tr id="KDGERI_URINC_ANTIDEPRESSANT">
              <td>항우울제 (Amitriptyline, Desipramine)</td>
              <td>항콜린성 작용, 안정</td>
            </tr>
            <tr id="KDGERI_URINC_ANTIPARKINSON">
              <td>항파킨슨 약제 (Trihexyphenidyl, Benztropine mesylate)</td>
              <td>항콜린성 작용, 안정</td>
            </tr>
            <tr id="KDGERI_URINC_OPIOID">
              <td>마약성 진통제 (Opiate)</td>
              <td>요폐, 변비, 안정, 착란</td>
            </tr>
            <tr id="KDGERI_URINC_ALPHA_BLOCKER">
              <td>알파교감신경길항제 (Prazosin, Terazosin)</td>
              <td>여성에서 요도괄약근의 약화로 인한 복압성 요실금</td>
            </tr>
            <tr id="KDGERI_URINC_ALPHA_AGONIST">
              <td>알파교감신경촉진제 (비충혈완화제)</td>
              <td>남성에서 요폐</td>
            </tr>
            <tr id="KDGERI_URINC_CCB">
              <td>칼슘통로차단제 (Amlodipine 등)</td>
              <td>요폐, 수분정체로 인한 야간 이뇨</td>
            </tr>
            <tr id="KDGERI_URINC_DIURETIC">
              <td>이뇨제 (Furosemide 등)</td>
              <td>다뇨, 빈뇨, 절박뇨</td>
            </tr>
            <tr id="KDGERI_URINC_ACE">
              <td>ACE길항제 (Captopril, Enalapril, Lisinopril)</td>
              <td>여성에서 기침에 의한 복압성 요실금</td>
            </tr>
            <tr id="KDGERI_URINC_VINCRISTINE">
              <td>Vincristine</td>
              <td>다뇨, 배뇨곤란, 방광무력으로 인한 요정체</td>
            </tr>
            <tr id="KDGERI_URINC_ALCOHOL">
              <td>알콜</td>
              <td>다뇨, 빈뇨, 절박뇨, 안정, 착란, 기동성 저하로 인한 이차요실금</td>
            </tr>
          </tbody>
        </table>

        <p>진단과 치료 과정은 환자마다 개별화하여야 하고 하부요로의 비뇨기과적 문제 이외에 영향을 미칠 수 있는 다른 요인들을 파악해야 한다. 남성에서는 요실금을 일으키는 많은 원인이 전립선비대증, 여성에서는 복압성요실금이나 방광염 등이므로 이에 대한 감별과 치료가 중요하다. 한편 고혈압에 많이 사용되는 이뇨제, 칼슘차단제나 정신과 약 등의 요실금을 유발
        하는 약물을 사용하고 있을 때에는 전문가와 상의하여 이들 약물을 조절하는 것이 중요하다.<sup>57)</sup></p>

        <p id="KDGERI_INCONTINENCE_THER">과민성방광에 의한 요실금 치료제로 항콜린작용이 있는 톨터로딘(tolterodine), 옥시부티닌(oxybutynin) 등이 사용되며, 입마름, 변비, 소변정체, 욕지기, 두통 등의 약물이상사례가 있다. 그 외에도 이미프라민(imipramine)은 어린이의 야뇨증 (오줌싸개)에 사용되어 왔던 약제로서 요절박증 및 복압성요실금 치료에 효과가 있고, 알파 수용체 차단제(alpha-receptor blocker) 계열인 독사조신 (doxazosin), 테라조신 (terazosin) 및 탐스로신 (tamsulosin) 등은 전립선비대증 치료제로서 많이 사용되고 있으나 절박 요실금에서도 좋은 효과를 나타낸다. 노인요실금에 사용되는 약제들은 방광의 수축기능을 약화시키는데, 대개 방광 수축기능이 약해져 있는 노인에서는 약제 사용의 부작용으로 소변이 잘 나오지 않을 수 있다.<sup>58)</sup> 요실금은 노인의 사회활동을 저해하고 정신적인 스트레스로 삷의 질의 저하와 연관이 되며, 적절한 생활환경개선과 위생패드나 팬티 등의 사용을 상의하는 것이 중요하다.</p>
      </div>

      {/* Ⅴ. 약물별 상세정보 */}
      <div className="section" id="KDGERI_DRUGS">
        <h2>Ⅴ. 약물별 상세정보</h2>


        <table className="drug-table" id="KDGERI_ACECLOFENAC" data-drug-number="1">
          <thead>
            <tr>
              <th className="drug-number">1</th>
              <th className="drug-name">아세클로페낙(Aceclofenac)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ACECLOFENAC_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>류마티스관절염, 강직척추염, 골관절염(퇴행관절염) 및 견갑상완골의 관절주위염, 치통, 외상 후 생기는 염증, 요통, 좌골통, 비관절성 류머티즘으로 인한 통증</td>
            </tr>
            <tr id="KDGERI_ACECLOFENAC_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>활동성 소화성궤양/출혈 또는 그 병력이 있는 환자, 이 약 및 이 약의 구성성분 또는 같은 계열의 일부 약물(디클로페낙)에 과민반응이 있는 환자, 아스피린이나 다른 비스테로이드성 소염진통제(COX-2 억제제포함)에 대하여 천식, 두드러기 또는 알레르기 반응 병력이 있는 환자, 아스피린 또는 다른 프로스타글란딘 합성효소 저해작용을 갖는 약물에 의해 천식 위험의 증가, 두드러기 또는 급성비염을 일으킬 수 있는 천식 환자, 관상동맥 우회로술(CABG) 전후에 발생하는 통증의 치료, 중증 심부전 환자, 중증 신장애 환자, 중증 간장애 환자, 과거 비스테로이드성 소염진통제 치료로 위장관출혈 또는 천공의 병력이 있는 환자, 임신 말기의 임부, 수유부, 크론병 또는 궤양성 대장염과 같은 염증성 장질환 환자, 출혈이 있거나 혈액응고장애가 있는 환자</td>
            </tr>
            <tr id="KDGERI_ACECLOFENAC_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 100mg씩 1일 2회</td>
            </tr>
            <tr id="KDGERI_ACECLOFENAC_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers Criteria 해당품목 ‘경구용 콕스 비선택성 비스테로이드성 소염진통제(Non-COX- selective NSAIDs’ oral): 위장관 출혈, 소화성 궤양 위험성 증가하므로 장기간 투여는 추천되지 않음. 류마티스성 관절염이나 골관절염에 단독 사용하거나 경증의 골관절염 통증경감을 위해서는 3달 이내 사용, 다른 대체약이 효과 없거나 프로톤펌프억제제, 미소프로스톨(misoprostol)병용한 경우에는 사용 가능<br/>∙장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br/>∙무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 미소프로스톨이나 프로톤펌프억제제를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함</td>
            </tr>
            <tr id="KDGERI_ACECLOFENAC_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙다른 비스테로이드성 소염진통제(이상반응 증가) <br/>∙경구용 항응고제(와르파린)(출혈 경향 증가) <br/>∙이뇨제(나트륨 뇨배설 효과 감소) <br/>∙리튬(혈중 리튬 농도 증가) <br/>∙메토트렉세이트(혈액학적 독성이 증가될 수 있음) <br/>∙항응고제, 스테로이드, 다른 비스테로이드성 소염진통제(NSAID)(위장관 출혈 위험 증가)</td>
            </tr>
            <tr id="KDGERI_ACECLOFENAC_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>위장관계 이상반응, 어지러움, 간효소 수치 이상, 가려움, 발진을 포함한 피부 이상반응 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ACEMETACIN" data-drug-number="2">
          <thead>
            <tr>
              <th className="drug-number">2</th>
              <th className="drug-name">아세메타신(Acemetacin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ACEMETACIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>류마티양 관절염, 골관절염(퇴행성 관절질환), 강직성 척추염, 통풍, 건염, 요통, 혈전성 정맥염 및 혈관염</td>
            </tr>
            <tr id="KDGERI_ACEMETACIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성 궤양 환자, 심한 혈액 이상 환자, 심한 간장애 환자, 심한 신장애 환자, 심한 심기능 부전 환자, 심한 고혈압 환자, 심한 췌장염 환자, 이 약, 인도메타신 또는 살리실산계 화합물(아스피린 등)에 과민증이 있는 환자, 아스피린이나 다른 비스테로이드성 소염진통제(COX-2 저해제 포함)에 대하여 천식, 두드러기 또는 알레르기 반응 병력이 있는 환자, 관상동맥 우회로술(CABG) 전후에 발생하는 통증의 치료, 디플루니살, 트리암테렌을 투여받고 있는 환자, 임신부 또는 임신하고 있을 가능성이 있는 부인</td>
            </tr>
            <tr id="KDGERI_ACEMETACIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 30-60mg씩 1-3회</td>
            </tr>
            <tr id="KDGERI_ACEMETACIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 활성대사물이 인도메타신임<br />∙ 2012 Beers Criteria 해당품목: 고위험군에서 위장관출혈, 소화성궤양 위험성 증가하므로 노인환자에게 사용을 피해야 함<br />∙ 항응혈제, 스테로이드, 다른 비스테로이드성 소염진통제 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 기존의 신기능 저하 환자에게 투여시 신기능 악화 가능(특히 CrCl 30mL/min 이하인 경우) <br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능</td>
            </tr>
            <tr id="KDGERI_ACEMETACIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음)</td>
            </tr>
            <tr id="KDGERI_ACEMETACIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>소화성 궤양, 빈혈, 과립구 감소, 발진, 가려움, 황달, 두통, 어지러움, 부종 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ACETAMINOPHEN" data-drug-number="3">
          <thead>
            <tr>
              <th className="drug-number">3</th>
              <th className="drug-name">아세트아미노펜(Acetaminophen)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ACETAMINOPHEN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제]감기로 인한 발열 및 동통(통증), 두통, 신경통, 근육통, 월경통, 염좌통(삔 통증),치통, 관절통, 류마티양 동통(통증) [주사제]통증이나 고열로 인하여 신속하게 투여할 필요가 있거나 다른 경로로 투여할 수 없는 경우의 외과 수술 후 통증 또는 발열의 단기간 치료</td>
            </tr>
            <tr id="KDGERI_ACETAMINOPHEN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 심한 혈액이상, 심한 간장애, 심한 신장애, 심한 심기능부전, 아스피린 천식(비스테로이드성 소염진통제에 의한 천식발작 유발) 또는 그 병력</td>
            </tr>
            <tr id="KDGERI_ACETAMINOPHEN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙1회 300-1000mg씩 1일 3-4회<br />∙1일 최대투여량: 4g <br />[주사제]<br /> - Propacetamol <br />∙1회 1-2g씩 4시간 간격으로 1일 2-4회<br />∙1일 최대투여량: 8g <br />∙CrCl≤10ml/min인 중증 신장애 환자는 최소 8시간 간격으로 투여함</td>
            </tr>
            <tr id="KDGERI_ACETAMINOPHEN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 매일 세잔 이상 정기적으로 술을 마시는 사람이 이 약이나 다른 해열 진통제를 복용해야 할 경우 반드시 의사 또는 약사와 상의해야 함. 이러한 사람이 복용하면 간손상이 유발될 수 있음<br />∙ 간부전 또는 알콜중독환자에게는 50~70% 용량을 감량하여 사용하고 장기간 사용시 주기적인 간기능 검사<br />∙ 아세트아미노펜은 프로스타글란딘 억제 등의 항염증 작용이 없어서 염증을 통반한 통증에는 추천되지 않음<br />∙ 노인 골관절염의 관절통에 우선 추천되는 약물이며 NSAIDs과 비슷한 진통효과를 가지면서 위점막의 손상을 가지고 오지 않아 위장관계 안전성이 크고 부작용은 현저히 작음</td>
            </tr>
            <tr id="KDGERI_ACETAMINOPHEN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 이소니아짓(이소니코틴산히드라짓), 리팜핀(간독성 증가) <br />∙ 13가 폐렴백신(백신에 대한 면역반응 감소) <br />∙ 이매티닙(아세트아미노펜 혈중농도 상승)</td>
            </tr>
            <tr id="KDGERI_ACETAMINOPHEN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>오심, 구토, 고혈압, 저혈압, 말초 부종, 빈맥, 두통, 불면증, 불안증, 발진, 변비, 복통, 설사, 빈혈, 간효소 수치 상승, 발열 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ASPIRIN" data-drug-number="4">
          <thead>
            <tr>
              <th className="drug-number">4</th>
              <th className="drug-name">아스피린(Aspirin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ASPIRIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제]감기로 인한 발열 및 동통, 두통, 치통, 월경통, 신경통, 요통, 관절통, 근육통, 류마티스 관절염 또는 류마티양 관절염, 골 관절염(퇴행성 관절질환), 강직성 척추염, 류마티열,수술후 동통, 인후통, 염좌통, 좌골신경통, 섬유조직 증식증[주사제]수술 후 동통, 산통, 류마티양 동통, 발열, 신경통, 신경염, 혈전색전증, 혈전성 정맥염</td>
            </tr>
            <tr id="KDGERI_ASPIRIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 또는 다른 살리실산제제에 과민증의 병력이 있는 환자, 소화성궤양 환자, 아스피린천식(비스테로이드성 소염진통제 등에 의한 천식발작의 유발) 또는 그 병력이 있는 환자, 혈우병 환자, 심한 간장애 환자, 심한 신장애 환자, 심한 심기능부전 환자</td>
            </tr>
            <tr id="KDGERI_ASPIRIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 0.5-1.5g씩 1일 2-3회<br />∙ 연령, 질환, 증상에 따라 적절히 증감<br />[주사제] <br />∙ 1일 0.5-2.0g을 분할 투여<br />∙ 심한 동통에는 1회 1.8g을 투여할 수 있음</td>
            </tr>
            <tr id="KDGERI_ASPIRIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자에는 이상반응이 나타나기 쉬우므로 소량부터 투여를 시작하는 등 환자의 상태를 관찰하면서 신중히 투여<br />∙ 신장애 및 간장애 환자, 기관지 천식 환자, 출혈 경향, 소화성궤양의 병력이 있는 환자는 신중히 투여해야 함<br />∙ 이미 있는 궤양을 악화시키거나 새로운 궤양을 유발할 수 있으므로 다른 대체약품이 없을 때 사용하고, 위장보호제와 함께 처방<br />∙ &gt;325mg 만성 복용 고령자 복용은 PIM에 해당됨<br />∙ 순환기 질환 1차 예방약제로 사용시 80세이상에서 주의가 요구됨</td>
            </tr>
            <tr id="KDGERI_ASPIRIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 경구용 항응고제(와르파린)(출혈 위험 증가하므로 주의) <br />∙ 인슐린 제제 등 당뇨병용제(혈당 강하 작용 증가시킬 수 있으므로 감량 필요) <br />∙ 프로베네시드(요산배설 작용 억제) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있으므로 1주당 15mg 이상의 메토트렉세이트는 아스피린과 병용투여하지 않아야 함) <br />∙ 리튬제제(리튬 혈중농도 상승) <br />∙ 다른 비스테로이드성 소염진통제 및 살리실산염제(출혈을 증가시키거나 신기능을 감소시킬 수 있으므로 병용투여에 신중해야함)</td>
            </tr>
            <tr id="KDGERI_ASPIRIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>쇼크, 과민증(발진, 부종, 두드러기 등), 혈소판 감소, 혈소판 기능 저하, 식욕부진, 가슴쓰림, 이명, 난청, 현기, 두통 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_BUPRENORPHINE" data-drug-number="5">
          <thead>
            <tr>
              <th className="drug-number">5</th>
              <th className="drug-name">부프레노르핀(Buprenorphine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_BUPRENORPHINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>비마약성진통제에 반응하지 않는 중등도 및 중증의 만성 통증완화</td>
            </tr>
            <tr id="KDGERI_BUPRENORPHINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>부프레노르핀이나 다른 부형제에 알려진 과민반응이 있는 환자, 중증 호흡기능 장애 환자 또는 호흡억제상태, MAO 저해제를 복용하고 있거나 지난 2주 이내에 복용한 적이 있는 환자, 임부 및 임신 가능성이 있는 부인</td>
            </tr>
            <tr id="KDGERI_BUPRENORPHINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[패취제] <br />∙ 7일마다 부착<br />∙ 초기용량: 5mg <br />∙ 용량조절 : 주어진 용량은 항정상태에 도달할 때까지 3일 동안 증량하지 않아야 함. 이후 추가적인 통증완화에 대한 필요성 및 이 약에 대한 환자의 진통반응에 따라 용량을 조절할 수 있음<br />∙ 만성 통증환자를 대상으로 한 임상시험에서 20mg을 초과하는 용량으로 투여시 안전성 및 유효성에 대한 평가는 체계적으로 수행되지 않았음</td>
            </tr>
            <tr id="KDGERI_BUPRENORPHINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 한 번 패취를 부착했던 부위에는 3-4주간 새로운 패취를 부착하지 말 것<br />∙ 마약류 중독 치료에 사용되지 않아야 함<br />∙ 반감기가 24-48시간으로 만성 통증의 치료에 적합하며 수술 직후 또는 진통제 필요량이 빠르게 변하는 것이 특징적인 상황에서 진통제로 사용해서는 안 됨<br />∙ MAO 저해제를 복용하고 있거나 지난 2주 이내에 복용한 적이 있는 환자는 투여하지 말 것<br />∙ 노인에서는 치명적인 호흡저하를 유발 가능</td>
            </tr>
            <tr id="KDGERI_BUPRENORPHINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 중추신경 억제제나 근육이완제(호흡저하, 저혈압, 심각한 진정을 야기) <br />∙ 할로탄 등의 일부 전신마취제(간에서 이 약의 제거속도를 감소) <br />∙ 항콜린제(오피오이드제제의 약물 독성 증가) <br />∙ 항정제(오피오이드의 저혈압반응 증가) <br />∙ 이뇨제(오피오이드가 이뇨제의 부작용 증가) <br />∙ 졸피뎀(오피오이드가 졸피뎀의 중추신경억제를 더 악화시킴)</td>
            </tr>
            <tr id="KDGERI_BUPRENORPHINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>식욕 부진, 혼란, 우울, 불면증, 신경과민, 불안, 어지러움, 두통, 기면, 떨림, 호흡곤란, 변비, 구역, 구토, 복통, 설사, 소화불량, 목마름증, 가려움, 홍반, 발진, 땀이 남, 피진, 적용부위 반응(적용부위 홍반, 부종, 가려움 및 발진), 요로감염, 관절통, 말초 부종, 상기도감염, 열</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_BUTORPHANOL" data-drug-number="6">
          <thead>
            <tr>
              <th className="drug-number">6</th>
              <th className="drug-name">브토르파놀(Butorphanol)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_BUTORPHANOL_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>아편계 진통제(Opioid analgesics)가 요구되는 통증의 치료, 수술전 또는 마취전 처치, 조절마취의 보조제, 분만진통 중의 통증 경감</td>
            </tr>
            <tr id="KDGERI_BUTORPHANOL_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>본 약제 또는 benzethonium chloride 과민성</td>
            </tr>
            <tr id="KDGERI_BUTORPHANOL_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[주사제] <br />∙ 통증: 1mg IV 또는 2mg IM을 3-4시간 간격으로 투여<br />∙ 수술 전 또는 마취전 처치: 2mg을 수술 전 60-90분에 근육주사<br />∙ 조절 마취: 마취유도 전에 2mg을 신속히 정맥주사, 마취 중 0.5-1.0mg을 정맥주사<br />∙ 노인환자: 권장용량의 1/2을 초기용량으로 시작. 다음 사용 용량은 초기용량 사용 후 환자 반응에 따라서 결정하나 최소 6시간 이상의 간격을 두고 투여할 것. <br />∙ 신부전, 간부전 환자: 권장용량의 1/2을 초기용량으로 시작. 투여간격을 신부전의 경우 6-8시간, 간부전의 경우 6-12시간으로 늘릴 것.</td>
            </tr>
            <tr id="KDGERI_BUTORPHANOL_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 65세 이상의 환자에서 평균 반감기가 25%증가하므로, 노인환자는 이 약의 부작용에 더욱 민감할 것임<br />∙ 전립선비대, 요로폐쇄환자에게는 주의해서 사용<br />∙ 호흡기질환이 있는 경우 호흡저하 가능성이 있어 주의해서 사용</td>
            </tr>
            <tr id="KDGERI_BUTORPHANOL_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 알코올, 바르비탈류, 진정제, 항히스타민제 등 중추신경계에 작용하는 약물(졸음,어지러움,정신기능장애 등 중추신경 억제효과) <br />∙ 항콜린제(오피오이드제제의 이상반응 증가) <br />∙ 항정제(오피오이드의 저혈압반응 증가) <br />∙ 이뇨제(오피오이드의 이상반응 증가) <br />∙ 졸피뎀(졸피뎀의 중추신경억제효과 증가할 수 있으므로 졸피뎀 용량 감량 필요)</td>
            </tr>
            <tr id="KDGERI_BUTORPHANOL_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>졸음, 어지러움, 오심, 구토, 무력감, 불안, 착란, 발한, 냉감, 시력 불선명, 불면, 심계항진, 혈관이완, 작열감, 가려움, 전진, 쇄약감, 시야흐림, 이명, 상기도감염</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_CELECOXIB" data-drug-number="7">
          <thead>
            <tr>
              <th className="drug-number">7</th>
              <th className="drug-name">세레콕시브(Celecoxib)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_CELECOXIB_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>골관절염(퇴행관절염)의 증상이나 징후의 완화, 류마티스성 관절염의 증상이나 징후의 완화, 강직척추염의 증상 및 징후의 완화, 성인의 급성 통증 완화 (수술후, 발치후 진통), 원발월경통</td>
            </tr>
            <tr id="KDGERI_CELECOXIB_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약의 성분 과민반응, 설폰아미드 알레르기, 아스피린이나 다른 비스테로이드성 소염제에 대하여 천식･두드러기･알러지 반응의 병력, 심한 간 기능 또는 신기능 부전, 활동성 소화성 궤양, 위장관 출혈, 염증성 장 질환, 울혈성 심부전자(NYHAII-IV), 허혈성 심장질환, 말초성 동맥질환, 뇌혈관 질환자, 관상동맥 우회로술(CABG) 전후에 발생하는 통증의 치료</td>
            </tr>
            <tr id="KDGERI_CELECOXIB_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 골관절염: 1회 200mg씩 1일 1회 또는 1회 100mg씩 1일 2회<br />∙ 류마티스 관절염: 1회 100-200mg 1일 2회<br />∙ 강직척추염: 1회 200mg씩 1일 1회 또는 1회 100mg씩 1일 2회,1일 최대투여량: 400mg <br />∙ 급성 통증 및 원발 월경통: 초기 권장 투여량 400mg이며 필요시 투여 첫날에 200mg을 추가 투여, 투여 둘째 날부터는 필요시 권장량으로서 1회 200mg씩 1일 2회 투여<br />∙ 간장애 저하: Child-Pugh Class II 환자에 50%로 감소</td>
            </tr>
            <tr id="KDGERI_CELECOXIB_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ COX-2선택억제제로 위궤양, 위출혈 등의 소화기 부작용의 위험성이 타 비스테로이드소염제보다 감소<br />∙ 고령자는 신기능, 간기능 및 특히 심기능이 저하되어 있을 가능성이 높으므로 고령자에게 이 약을 투여하는 경우 적절한 관찰이 요구됨<br />∙ 일반적으로 고령자에 대한 용량 조절은 요구되지 않으나, 체중이 50kg 이하인 경우에는 최소량에서 투여를 시작함<br />∙ 장기간 투여, 복용 중 음주시에도 위장관 출혈 위험 증가함<br />∙ 기존의 심혈관질환으로 아스피린이나 항응고제를 복용 중인 환자에서의 celecoxib 복용은 심혈관 위험을 더 높힐 수 있음</td>
            </tr>
            <tr id="KDGERI_CELECOXIB_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ CYP 2C9 억제제(이 약의 혈장농도가 상승) <br />∙ CYP 2C9 유도제(이 약의 혈장농도가 감소) <br />∙ Dexketoprofen, 전신작용 ketorolac등의 NSAIDS:NSAIDS의 독성증가(병용삼가) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음) <br />∙ 경구 항응고제(출혈 위험 증가) <br />∙ ACEi/ARB/스테로이드/할로페리돌/케토롤락(약물의 부작용/독성 증가) <br />∙ 삼환계항우울제(NSIADs의 항혈소판효과 증가) <br />∙ 베타차단제(Levobunolol, Metipranolol제외), 코데인(NSAIDs사용이 약물 효과 감소) <br />∙ 디곡신(병용약물의의 농도 증가)</td>
            </tr>
            <tr id="KDGERI_CELECOXIB_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>말초부종, 어지럼증, 두통, 불면증, 피부 발진, 복통, 설사, 소화불량, 오심, 구토, 관절통, 요통, 흉통, 기침, 인후염, 비염, 부비동염, 상기도 감염, 발열, 고혈압악화, 빈맥, 서맥, 불안, 탈모, 방관염, 빈혈, 과민반응, 난청, 폐렴</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_CINNOXICAM" data-drug-number="8">
          <thead>
            <tr>
              <th className="drug-number">8</th>
              <th className="drug-name">시녹시캄(Cinnoxicam)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_CINNOXICAM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>염증성 및 퇴행성 류마티스 질환</td>
            </tr>
            <tr id="KDGERI_CINNOXICAM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약의 성분에 과민증이 있는 환자, 아스피린이나 다른 비스테로이드성 소염진통제(COX-2 저해제 포함)에 대하여 천식, 두드러기 또는 알레르기 반응 병력이 있는 환자, 관상동맥 우회로술(CABG) 전후에 발생하는 통증의 치료</td>
            </tr>
            <tr id="KDGERI_CINNOXICAM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 15mg씩 1일 1회<br />∙ 중증인 경우에는 초기에 1회 15mg씩 1일 2회 <br />∙ 1일 최대투여량: 30mg</td>
            </tr>
            <tr id="KDGERI_CINNOXICAM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능</td>
            </tr>
            <tr id="KDGERI_CINNOXICAM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음) <br />∙ 다른 NSIADS제제: 독성증가(병용삼가)</td>
            </tr>
            <tr id="KDGERI_CINNOXICAM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>위장관 장애(가슴앓이, 구토, 소화불량, 설사), 졸음, 현기증, 소양감, 피부 발진 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_DEXIBUPROFEN" data-drug-number="9">
          <thead>
            <tr>
              <th className="drug-number">9</th>
              <th className="drug-name">덱시부프로펜(Dexibuprofen)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_DEXIBUPROFEN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>급성 및 만성 관절염(만성 다발성 관절염, 류마티스성 관절염 등), 관절증, 염증성 류마티스 질환(강직성척추염, 근육류마티즘), 외상(상처) 및 수술후 통증성 부종(부기) 또는 염증, 염증, 통증 및 발열을 수반하는 감염증의 치료보조</td>
            </tr>
            <tr id="KDGERI_DEXIBUPROFEN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성궤양 환자, 심한 혈액이상 환자, 심한 간장애 환자, 심한 신장애(신장장애) 환자, 심한 심기능부전 환자, 심한 고혈압 환자, 이 약의 성분에 과민증이 있는 환자, 기관지 천식 또는 그 병력이 있는 환자, 아스피린이나 다른 비스테로이드성 소염(항염)진통제(COX-2 저해제(억제제) 포함)에 대하, 천식, 두드러기 또는 알레르기 반응 병력이 있는 환자, 관상동맥(심장동맥) 우회로술(CABG) 전후에 발생하는 통증의 치료</td>
            </tr>
            <tr id="KDGERI_DEXIBUPROFEN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 300mg씩 1일 3-4회 식사시 경구투여<br />∙ 1일 최대투여량: 1,200mg</td>
            </tr>
            <tr id="KDGERI_DEXIBUPROFEN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 기존의 신기능 저하 환자에게 투여시 신기능 악화 가능(특히 CrCl 30mL/min 이하인 경우) <br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능</td>
            </tr>
            <tr id="KDGERI_DEXIBUPROFEN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음)</td>
            </tr>
            <tr id="KDGERI_DEXIBUPROFEN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>쇼크증상, 소화불량, 복부팽만, 설사나 변비, 발진, 두드러기, 황달, 피로, 졸음, 말초부종 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_DICLOFENAC" data-drug-number="10">
          <thead>
            <tr>
              <th className="drug-number">10</th>
              <th className="drug-name">디클로페낙(Diclofenac)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_DICLOFENAC_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제]류마티스 관절염, 골관절염(퇴행성 관절질환), 강직성 척추염, 수술후･외상후 염증 및 동통, 급성통풍, 비관절성 류마티즘, 견관절 주위염, 요통, 치통, 월경곤란증,이비인후 영역의 염증 및 동통[주사제]류마티스 관절염, 골관절염(퇴행성 관절질환), 강직성척추염, 수술후･외상후 염증 및 동통, 급성통풍, 신 및 간산통</td>
            </tr>
            <tr id="KDGERI_DICLOFENAC_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성궤양 환자, 심한 혈액이상, 심한 간 장애 또는 신 장애, 심한 고혈압 환자, 심한 심기능부전, 이 약에 과민증, 이 약 또는 아스피린 등 다른 비스테로이드성소염진통제에 의한 천식･두드러기, 다른 알러지 병력자</td>
            </tr>
            <tr id="KDGERI_DICLOFENAC_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 초회용량: 1일 100-150mg <br />∙ 유지용량: 1일 75-100mg을 2-3회 분할 투여<br />[경구 서방제] <br />∙ 1회 100mg씩 1일 1회<br />[주사제] <br />∙ 1회 75mg씩 1일 1회<br />∙ 중증의 경우 1회 75mg씩 1일 2회</td>
            </tr>
            <tr id="KDGERI_DICLOFENAC_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당 품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 고령자에서 이상반응 위험이 높으므로 고령자에게 필요한 최소량으로 신중히 투여하고 이상반응 발현에 특히 유의해야 함<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 기존의 신기능 저하 환자에게 투여시 신기능 악화 가능(특히 CrCl 30mL/min 이하인 경우) <br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능</td>
            </tr>
            <tr id="KDGERI_DICLOFENAC_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음)</td>
            </tr>
            <tr id="KDGERI_DICLOFENAC_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>부종, 고혈압, 두통, 어지럼증, 두드러기, 피부발진, 수분저류, 변비, 복통, 설사, 구토, 오심, 빈혈, 이명, 신기능 장애 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_EMORFAZONE" data-drug-number="11">
          <thead>
            <tr>
              <th className="drug-number">11</th>
              <th className="drug-name">에몰파존(Emorfazone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_EMORFAZONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>골관절염(퇴행성 관절질환), 경견완증후군, 견관절주위염, 요통, 회음열상, 수술후/외상후 염증 및 동통</td>
            </tr>
            <tr id="KDGERI_EMORFAZONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성궤양 환자, 심한 혈액이상 환자, 심한 간장애 환자, 심한 신장애 환자, 본제에 과민증 환자</td>
            </tr>
            <tr id="KDGERI_EMORFAZONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 200mg씩 1일 3회</td>
            </tr>
            <tr id="KDGERI_EMORFAZONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 기존의 신기능 저하 환자에게 투여시 신기능 악화 가능(특히 CrCl 30mL/min 이하인 경우) <br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능</td>
            </tr>
            <tr id="KDGERI_EMORFAZONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음)</td>
            </tr>
            <tr id="KDGERI_EMORFAZONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>발진, 광과민증, 구내염, 식욕부진, 구역, 구토, 위통, 설사, 구갈, 두통, 현기, 권태, 졸음 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ETODOLAC" data-drug-number="12">
          <thead>
            <tr>
              <th className="drug-number">12</th>
              <th className="drug-name">에토돌락(Etodolac)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ETODOLAC_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>류마티양 관절염, 골관절염(퇴행성 관절질환), 강직성 척추염, 수술후･외상후 발치후 동통</td>
            </tr>
            <tr id="KDGERI_ETODOLAC_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성 궤양 또는 소화성 궤양의 병력 및 다른 비스테로이드성 소염진통제 투여로 출혈의 병력이 있는 환자, 이 약의 성분 또는 다른 비스테로이드성 소염진통제에 과민증이 있는 환자, 아스피린이나 다른 비스테로이드성 소염진통제(COX-2 저해제 포함)에 대하여 천식, 비염, 두드러기 또는 알레르기 반응 병력이 있는 환자, 관상동맥 우회로술(CABG) 전후에 발생하는 통증의 치료</td>
            </tr>
            <tr id="KDGERI_ETODOLAC_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 초회량: 1일 800-1200mg을 2-4회 분할 경구투여<br />∙ 유지량: 1일 600-1200mg을 2-4회 분할 경구투여<br />∙ 1일 최대투여량: 1,200mg</td>
            </tr>
            <tr id="KDGERI_ETODOLAC_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당 품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 기존의 신기능 저하 환자에게 투여시 신기능 악화 가능(특히 CrCl 30mL/min 이하인 경우) <br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능<br />∙ 기존 고혈압 악화 및 새로운 고혈압 유발가능</td>
            </tr>
            <tr id="KDGERI_ETODOLAC_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음)</td>
            </tr>
            <tr id="KDGERI_ETODOLAC_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>어지럼증, 우울증, 피부 발진, 두드러기, 설사, 오심, 구토, 변비, 위염, 이명, 소화불량, 복통, 쇠약감, 시야혼탁, 열 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ETORICOXIB" data-drug-number="13">
          <thead>
            <tr>
              <th className="drug-number">13</th>
              <th className="drug-name">에토리콕시브(Etoricoxib)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ETORICOXIB_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>골관절염(퇴행관절염)의 증상이나 징후의 완화</td>
            </tr>
            <tr id="KDGERI_ETORICOXIB_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>아스피린이나 NSAIDs에 알레르기 있거나 고혈압, 부종, 중증 간장애, 신장애 환자, 위장관 출혈 및 염증성 장질환 환자</td>
            </tr>
            <tr id="KDGERI_ETORICOXIB_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 30 mg씩 1일 1회 (max: 30 mg/day) <br />∙ 간장애 환자: 중증의 간장애(Child-pugh score&gt;9)환자에서의 투여경험이 없으므로 투여금기<br />∙ 신장애 환자: 중증의 신장애(CrCl&lt;30 ml/min)에게 투여금기<br />∙ 복용량과 노출기간이 증가할수록 심혈관계 위험도가 커지므로 가능한 최단 기간 동안 투여하고, 고혈압, 울혈성심부전, 부종 등의 이상반응이 나타날 수 있어 최소한 매달 투여지속여부 및 반응에 대한 재평가 필요</td>
            </tr>
            <tr id="KDGERI_ETORICOXIB_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙고령자는 신기능, 간기능 및 특히 심기능이 저하되어 있을 가능성이 높으므로 고령자에게 이 약을 투여하는 경우 적절한 관찰이 요구됨<br />∙다음의 환자에게 신중투여: 간･신장애, 혈액응고장애 또는 항응고제 투여받는 환자, 천식환자, 심부전, 고혈압, 부종 병력 환자, 이뇨제나 ACEI 투여중인 환자, 고령자, 심혈관계 질환자, 당뇨</td>
            </tr>
            <tr id="KDGERI_ETORICOXIB_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙이뇨제(나트륨 뇨배설 효과 감소) <br />∙시클로스포린, 타크로리무스(신독성 증가) <br />∙리튬(혈중 리튬 농도 증가) <br />∙메토트렉세이트(혈액학적 독성이 증가될 수 있음) <br />∙다른 NSIADS제제: 독성증가(병용삼가)</td>
            </tr>
            <tr id="KDGERI_ETORICOXIB_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>두근거림, 부정맥, 고혈압, 치조골염, 어지러움, 두통, 기관지연축, 설사, 소화불량, 상복부 불편감, 구역, 구토, 변비, 고창, 위염, 가슴쓰림, 식도염, 간효소상승, 피부 반상출혈, 무력증, 피로, 부종, 체액저류</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_FENOPROFEN" data-drug-number="14">
          <thead>
            <tr>
              <th className="drug-number">14</th>
              <th className="drug-name">페노프로펜(Fenoprofen)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_FENOPROFEN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>류마티양 관절염, 골관절염(퇴행성 관절질환), 경증 및 중등도의 동통</td>
            </tr>
            <tr id="KDGERI_FENOPROFEN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성 궤양 환자, 심한 혈액이상 환자, 심한 간장애 환자, 심한 신장애 환자, 심한 심기능부전 환자, 이 약의 성분에 과민증이 있는 환자, 아스피린이나 다른 비스테로이드성 소염진통제(COX-2 저해제 포함)에 의한 천식(천식발작 포함), 두드러기, 알레르기 반응 또는 그 병력이 있는 환자, 관상동맥 우회로술(CABG) 전후에 발생하는 통증의 치료</td>
            </tr>
            <tr id="KDGERI_FENOPROFEN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 류마티양 관절염, 골관절염:초회량은 1회 600mg씩 1일 3회. 심한 경우 취침전 1회 추가투여할 수 있음유지량은 1회 300-600mg씩 1일 3-4회 투여<br />∙ 1일 최대투여량: fenoprofen으로 3g <br />∙ 경증 및 중등도의 동통: 1회 200mg씩 4-6시간마다 투여</td>
            </tr>
            <tr id="KDGERI_FENOPROFEN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당 품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 기존의 신기능 저하 환자에게 투여시 신기능 악화 가능(특히 CrCl 30mL/min 이하인 경우) <br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능</td>
            </tr>
            <tr id="KDGERI_FENOPROFEN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음)</td>
            </tr>
            <tr id="KDGERI_FENOPROFEN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>말초부종, 빈맥, 두통, 졸음, 어지럼증, 피로, 혼돈, 가려움증, 발진, 오심, 변비, 구토, 복통, 진전 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_IBUPROFEN" data-drug-number="15">
          <thead>
            <tr>
              <th className="drug-number">15</th>
              <th className="drug-name">이부프로펜(Ibuprofen)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_IBUPROFEN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제]류마티양 관절염, 연소성(어리거나 젊은 나이에 나타나는) 류마티양 관절염, 골관절염(퇴행성 관절질환), 감기로 인한 발열 및 동통(통증), 요(허리)통, 월경곤란증, 수술 후 동통(통증), 강직성 척추염, 두통, 치통, 근육통, 신경통, 급성통풍, 건선(마른비늘증)성 관절염, 연조직 손상(염좌(삠), 좌상(타박상/멍)), 비관절 류마티스질환(건염(힘줄염), 건초염(힘줄윤활막염),활액(윤활)낭염) [주사제]중등도 및 중증 통증 조절을 위한 마약성 진통제의 보조요법</td>
            </tr>
            <tr id="KDGERI_IBUPROFEN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성궤양, 심한 혈액이상, 심한 간 장애 또는 신 장애, 심한 심기능부전, 심한 고혈압, 이 약에 과민증, 기관지천식, 아스피린천식 또는 그 병력자, CABG 수술을 시행한 환자에서 수술 전 후</td>
            </tr>
            <tr id="KDGERI_IBUPROFEN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 류마티스 관절염, 골관절염, 강직성 척추염, 연조직손상, 비관절 류마티스질환, 급성통풍, 건선성(마른비늘증) 관절염: 1회 200-600mg씩 1일 3-4회, 1일 최대투여량: 3,200mg <br />∙ 연소성(어리거나 젊은 나이에 나타나는) 류마티양 관절염: 1일 체중 kg당 30-40mg을 3-4회 분할 복용<br />∙ 경증 및 중등도의 동통(통증), 감기: 1회 200-400mg씩 1일 3-4회<br />[주사제] <br />∙ 중등도 및 중증 통증 조절을 위한 마약성 진통제의 보조요법: 1회 400-800mg을 6시간 간격으로 투여, 투여시간은 30분 이상<br />∙ 해열: 1회 400mg씩 4-6시간 간격으로 투여</td>
            </tr>
            <tr id="KDGERI_IBUPROFEN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당 품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 노인환자에 투여시 긴 반감기를 가짐<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 기존의 신기능 저하 환자에게 투여시 신기능 악화 가능(특히 CrCl 30mL/min 이하인 경우) <br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능<br />∙ 특히 고령, 당뇨, 신질환 환자, ACE억제제 동반 사용의 경우에 고칼륨혈증 유발가능<br />∙ 기존 고혈압 악화 및 새로운 고혈압 유발가능</td>
            </tr>
            <tr id="KDGERI_IBUPROFEN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음)</td>
            </tr>
            <tr id="KDGERI_IBUPROFEN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>부종, 어지럼증, 두통, 피부 발진, 두드러기, 수분 저류, 오심, 복통, 변비, 설사, 이명, 소화불량, 식욕저하, 속쓰림 등$</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_INDOMETHACIN" data-drug-number="16">
          <thead>
            <tr>
              <th className="drug-number">16</th>
              <th className="drug-name">인도메타신(Indomethacin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_INDOMETHACIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>류마티스 관절염, 골관절염(퇴행성 관절질환), 급성통풍성 관절염, 강직성 척추염, 수술후･외상후 동통</td>
            </tr>
            <tr id="KDGERI_INDOMETHACIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성궤양, 심한 혈액이상, 심한 간 장애 또는 신 장애, 심한 심기능부전, 심한 고혈압, 심한 췌장염, 이 약 또는 살리실산 제제(아스피린 등) 과민증, 아스피린 천식(비스테로이드성 소염진통제 등에 의한 천식발작의 유발)또는 병력자, 디플루니살 또는 트리암테렌 투여중인 환자, CABG 수술을 시행한 환자에서 수술 전 후</td>
            </tr>
            <tr id="KDGERI_INDOMETHACIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 류마티스 관절염, 골관절염, 강직성 척추염, 수술후･외상후 동통: 1회 25mg씩 1일 2-3회, 1일 최대투여량: 200mg <br />∙ 급성통풍성 관절염: 1회 50mg씩 1일 3회</td>
            </tr>
            <tr id="KDGERI_INDOMETHACIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당 품목: 고위험군에서 GI bleeding, peptic ulcer disease 위험성 증가하므로 노인환자에게 사용을 피해야 함<br />∙ 무증상 소화성궤양과 출혈 발생 가능. 예방을 위해서 misoprostol이나 PPI를 투여함. 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가함<br />∙ 장기간 투여 및 복용중 음주시 위장관 출혈 위험 증가함<br />∙ 기존의 신기능 저하 환자에서 신기능 악화 가능(특히 CrCl 30mL/min 이하인 경우) <br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능<br />∙ 최근 심장마비 이력이 있는 환자에서 재발의 위험이 있으므로 indomethacin사용을 피하고 부득이 사용할 때는 심근경맥의 위험을 주의 깊게 관찰</td>
            </tr>
            <tr id="KDGERI_INDOMETHACIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음)</td>
            </tr>
            <tr id="KDGERI_INDOMETHACIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>두통, 구토, 수술 후 출혈, 어지럼증, 우울증, 졸음, 피로, 두드러기, 피부발진, 오심, 변비, 설사, 복통, 이명 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_KETOPROFEN" data-drug-number="17">
          <thead>
            <tr>
              <th className="drug-number">17</th>
              <th className="drug-name">케토프로펜(Ketoprofen)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_KETOPROFEN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제]류마티양 관절염, 골관절염(퇴행성 관절질환), 경견완 증후군, 증후성 신경통, 요통, 급성상기도염, 외상후･수술후 염증 및 동통[주사제]류마티양 관절염, 골관절염(퇴행성 관절질환), 강직성 척추염, 급성통풍, 견관절주위염, 외상후･ 수술후 염증 및 동통 건염, 활액낭염</td>
            </tr>
            <tr id="KDGERI_KETOPROFEN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성궤양/출혈 또는 그 병력이 있는 환자, 심한 혈액이상 환자, 심한 간장애 환자, 심한 신장애 환자, 심한 심장애 환자, 이 약의 성분에 과민증 및 그 병력이 있는 환자, 아스피린이나 다른 비스테로이드성 소염진통제(COX-2 저해제포함)에 의하여 천식(천식 발작 포함), 두드러기, 알레르기 반응 또는 그 병력이 있는 환자, 관상동맥 우회로술(CABG) 전후에 발생하는통증의 치료, 염산시프로플록사신 또는 고용량(15mg/주 이상)의 메토트렉세이트를 투여 받고 있는 환자, 임신후기의 부인, 비스테로이드성 소염진통제 요법에 대하여 위장관출혈 또는 천공의 병력이 있는 환자</td>
            </tr>
            <tr id="KDGERI_KETOPROFEN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 50-100mg씩 1일 2-3회<br />[주사제] <br />∙ 1일 100mg을 1-2회 분할 근육주사<br />∙ 중증에는 1회 100mg씩 1일 2회</td>
            </tr>
            <tr id="KDGERI_KETOPROFEN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당 품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 기존의 신기능 저하 환자에게 투여시 신기능 악화 가능(특히 CrCl 30mL/min 이하인 경우) <br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능</td>
            </tr>
            <tr id="KDGERI_KETOPROFEN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가)메토트렉세이트(혈액학적 독성이 증가될 수 있음)</td>
            </tr>
            <tr id="KDGERI_KETOPROFEN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>말초부종, 두통, 우울증, 어지럼증, 불면증, 발진, 복통, 변비, 설사, 오심, 이명, 간기능이상 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_KETOROLAC" data-drug-number="18">
          <thead>
            <tr>
              <th className="drug-number">18</th>
              <th className="drug-name">케토롤락(Ketorolac)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_KETOROLAC_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제]중등도 및 중증의 급성통증(수술 후 통증 포함)에 대한 단기요법[주사제]중등도 및 중증의 급성통증(수술 후 통증 포함)에 대한 단기요법마약성 진통제가 금기인 중증의 수술후 통증</td>
            </tr>
            <tr id="KDGERI_KETOROLAC_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성 궤양 과거력, 위장관 출혈 또는 천공 과거력, 뇌혈관계 출혈 과거력, 중등도 이상의 신부전, 기관지천식 과거력, 아스피린 또는 비스테로이드성 소염진통제 과민증, 중증 심부전, 다른 비스테로이드성 소염진통제 또는 항응혈제, 펜톡시필린, 프로베네시드, 리튬을 투여받고 있는 환자, CABG 수술을 시행한 환자에서 수술 전 후</td>
            </tr>
            <tr id="KDGERI_KETOROLAC_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 10mg을 4-6시간마다 투여<br />∙ 1일 최대투여량: 40mg <br />∙ 최대투여기간: 7일<br />[주사제] <br />∙ 초회용량: 10mg, 유지용량 1회 10-30mg씩 4-6시간마다 투여<br />∙ 1일 최대투여량: 90mg <br />∙ 고령자, 신기능 장애, 체중 50kg 이하일 경우 1일 최대투여량: 60mg <br />∙ 최대투여기간: 2일65세 이상에서는 용량조절이 필요함</td>
            </tr>
            <tr id="KDGERI_KETOROLAC_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당 품목: 고위험군에서 GI bleeding, peptic ulcer disease 위험성 증가하므로 노인환자에게 사용을 피해야 함<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가함<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가함<br />∙ 이 약을 투여하는 동안 위장관계 궤양 또는 출혈의 증상 및 징후에 대하여 신중히 관찰하며, 위장관계 불편감 호소시 즉시 원인 평가를 수행하여야 함 <br />∙ 간기능 장애, 신기능 장애, 고혈압, 비보상성 심부전 환자의 상태를 악화시킬 수 있으므로 신중투여 필요<br />∙ 특히 고령, 당뇨, 신질환 환자, ACE억제제 동반 사용의 경우에 고칼륨혈증 유발가능, 기존 고혈압 악화 및 새로운 고혈압 유발가능</td>
            </tr>
            <tr id="KDGERI_KETOROLAC_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음)</td>
            </tr>
            <tr id="KDGERI_KETOROLAC_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>두통, 위장통증, 소화불량, 오심, 부종, 고혈압, 어지럼증, 졸음, 두드러기, 피부 발진, 설사, 변비, 빈혈, 간효소 상승, 이명, 신기능 장애, 가슴쓰림, 주사부위통증 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_LORNOXICAM" data-drug-number="19">
          <thead>
            <tr>
              <th className="drug-number">19</th>
              <th className="drug-name">로녹시캄(Lornoxicam)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_LORNOXICAM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제]류마티스성 관절염, 골관절염, 요통, 발치후 동통[주사제]급성의 중등도 수술 후 통증</td>
            </tr>
            <tr id="KDGERI_LORNOXICAM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>위장,소장 출혈, 뇌출혈 또는 기타의 출혈이상환자, 위궤양 또는 소장의 궤양이 있거나 소화성궤양 재발병력을 가진 환자, 출혈의 가능성이 높은 환자, 중증의 혈소판 결핍 환자, 중증의 간기능 장애 환자, 중증의 신기능 장애 환자(혈청 크레아티닌 ＞ 700μ㏖/L), 중증의 심부전 환자, 이 약의 성분에 과민증이 있는 환자, 아스피린이나 다른 비스테로이드성 소염진통제(COX-2 저해제포함)에 대하여 천식, 두드러기, 과민반응 또는 알레르기 반응 병력이 있는 환자, 관상동맥 우회로술(CABG) 전후에 발생하는통증의 치료, 임부 및 수유부, 18세 이하의 환자, 65세 이상이면서 체중 50kg 미만인 급성 수술환자</td>
            </tr>
            <tr id="KDGERI_LORNOXICAM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 류마티스성 관절염, 골관절염: 1일 12mg을 2-3회 분할 경구투여, 1일 최대투여량: 16mg <br />∙ 요통, 발치후 동통: 1일 8-16mg을 2-3회 분할 경구투여, 1일 최대투여량: 16mg <br />∙ 신부전 환자 또는 간기능 부전 환자: 1회 4mg씩 1일 3회, 1일 최대투여량: 12mg <br />[주사제] <br />∙ 초회량 8mg, 증상의 개선이 없을 경우 8mg 추가 투여<br />∙ 1일 최대투여량: 16mg <br />∙ 단 수술 후 첫날에는 필요시 24mg까지 투여 가능</td>
            </tr>
            <tr id="KDGERI_LORNOXICAM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 기존의 신기능 저하 환자에게 투여시 신기능 악화 가능(특히 CrCl 30mL/min 이하인 경우) <br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능</td>
            </tr>
            <tr id="KDGERI_LORNOXICAM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음)</td>
            </tr>
            <tr id="KDGERI_LORNOXICAM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>소화성 궤양, 위통증, 소화불량, 설사, 구역, 구토, 어지러움, 두통, 혈중 요소질 및 크레아티닌 증가 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_LOXOPROFEN" data-drug-number="20">
          <thead>
            <tr>
              <th className="drug-number">20</th>
              <th className="drug-name">록소프로펜(Loxoprofen)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_LOXOPROFEN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>만성 류마티스관절염, 골관절염(퇴행관절염), 요통, 견관절주위염, 경견완증후군, 수술후･외상후 및 발치후의 소염･진통, 급성 상기도염</td>
            </tr>
            <tr id="KDGERI_LOXOPROFEN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성 궤양 환자, 중증 혈액이상 환자, 중증 간장애 환자, 중증 신장애 환자, 중증 심부전 환자, 이 약 및 이 약의 구성성분에 과민반응이 있는 환자, 아스피린이나 다른 비스테로이드성 소염진통제(COX-2 억제제 포함)에 대하여 천식, 두드러기, 알레르기 반응 또는 그 병력이 있는 환자, 관상동맥 우회로술(CABG) 전후에 발생하는 통증의 치료, 임신 말기의 임부, 수유부, 크론병 또는 궤양성 대장염과 같은 염증성 장질환 환자</td>
            </tr>
            <tr id="KDGERI_LOXOPROFEN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 만성 류마티스관절염, 골관절염(퇴행관절염), 요통, 견관절주위염, 경견완증후군, 수술후･외상후 및 발치후의 소염･진통: 1회 60mg씩 1일 3회 <br />∙ 급성 상기도염: 1회 60mg씩 1일 2회, 1일 최대투여량: 180mg</td>
            </tr>
            <tr id="KDGERI_LOXOPROFEN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 기존의 신기능 저하 환자에게 투여시 신기능 악화 가능(특히 CrCl 30mL/min 이하인 경우) <br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능</td>
            </tr>
            <tr id="KDGERI_LOXOPROFEN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음)</td>
            </tr>
            <tr id="KDGERI_LOXOPROFEN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>발진, 가려움, 발열, 소화성 궤양, 천공, 졸음, 무감각, 어지러움, 빈혈, 부종 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_MEFENAMICACID" data-drug-number="21">
          <thead>
            <tr>
              <th className="drug-number">21</th>
              <th className="drug-name">메페남산(Mefenamic acid)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_MEFENAMICACID_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>두통, 치통, 요통, 골관절염(퇴행성 관절질환), 외상후･수술후･분만후 염증 및 동통, 부비동염에 수반하는 동통, 월경통</td>
            </tr>
            <tr id="KDGERI_MEFENAMICACID_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성궤양, 심한 혈액이상, 심한 간 장애 또는 신 장애, 심한 심기능부전 환자, 심한 고혈압 환자, 이약에 과민증자, 아스피린 또는 다른 비스테로이드성소염진통제에 의해 두드러기, 알러지성 비염, 기관지경련, 천식 병력자, 이 약에 의하여 설사를 일으킨 병력</td>
            </tr>
            <tr id="KDGERI_MEFENAMICACID_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 500mg 투여 후, 6시간마다 250mg씩 투여<br />∙ 연령, 질환, 증상에 따라 적절히 증감</td>
            </tr>
            <tr id="KDGERI_MEFENAMICACID_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당 품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 기존의 신기능 저하 환자에게 투여시 신기능 악화 가능(특히 CrCl 30mL/min 이하인 경우) <br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능</td>
            </tr>
            <tr id="KDGERI_MEFENAMICACID_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음)</td>
            </tr>
            <tr id="KDGERI_MEFENAMICACID_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>두통, 신경과민, 어지럼증, 가려움, 발진, 수분저류, 오심, 구토, 설사, 변비, 소화불량, 출혈, 간효소수치 증가, 이명 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_MELOXICAM" data-drug-number="22">
          <thead>
            <tr>
              <th className="drug-number">22</th>
              <th className="drug-name">멜록시캄(Meloxicam)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_MELOXICAM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>통증과 운동실조를 수반하는 골관절염(퇴행관절염)의 급성악화시 단기간의 증상치료, 류마티스관절염의 증상치료, 강직척추염의 증상치료</td>
            </tr>
            <tr id="KDGERI_MELOXICAM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 및 이 약의 구성성분에 과민증, 아스피린 및 다른 비스테로이드성 소염진통제에 교차 과민증, 아스피린 및 다른 비스테로이드성 소염진통제에 의해 천식･비염･맥관신경 부종 또는 두드러기 증상, 소화성 궤양, 중증 간 장애, 중증의 신부전 환자로서 혈액 투석을 하지 않는 환자.</td>
            </tr>
            <tr id="KDGERI_MELOXICAM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 골관절염(퇴행관절염)의 급성악화: 1회 7.5mg씩 1일 1회<br />∙ 류마티스 관절염, 강직성 척추염: 1회 15mg씩 1일 1회<br />∙ 1일 최대투여량: 15mg, 단, 혈액투석중인 중증 신부전증 환자는 7.5mg <br />∙ 고령자는 1일 7.5mg의 용량으로 치료를 시작</td>
            </tr>
            <tr id="KDGERI_MELOXICAM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당 품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 고령자는 신기능, 간기능, 심장기능이 약하기 때문에 필요한 최소량으로 신중히 투여하고, 이상반응의 발현에 특히 유의해야 함<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능<br />∙ 특히 고령, 당뇨, 신질환 환자, ACE억제제 동반 사용의 경우에 고칼륨혈증 유발가능</td>
            </tr>
            <tr id="KDGERI_MELOXICAM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음) <br />∙ ACE억제제(항염증 효과 증가로 인한 심각한 신기능 악화 가능) <br />∙ ARB(약물 독성 증가, 신기능 악화 가능) <br />∙ 베타차단제(항고혈압 효과 감소) <br />∙ 디곡신(혈중 디곡신 농도 증가 가능) <br />∙ 할로페리돌(약물 독성증가 및 졸음, 착란 유발 가능) <br />∙ 반코마이신(농도 증가)</td>
            </tr>
            <tr id="KDGERI_MELOXICAM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>부종, 두통, 어지럼증, 불면증, 두드러기, 피부발진, 설사, 오심, 복통, 변비, 구토, 요로감염, 빈혈, 관절통, 요통, 상기도 감염, 낙상, 감기증상 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_MORNIFLUMATE" data-drug-number="23">
          <thead>
            <tr>
              <th className="drug-number">23</th>
              <th className="drug-name">모니플루메이트(Morniflumate)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_MORNIFLUMATE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>호흡기질환(후두염, 기관염, 기관지염), 이비인후과질환(부비동염, 이염, 편도염, 인두염), 골관절질환</td>
            </tr>
            <tr id="KDGERI_MORNIFLUMATE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성궤양 또는 그 병력이 있는 환자, 위장관 출혈이 있는 환자 및 그 병력이 있는 환자, 심한 혈액 이상 환자, 심한 간장애 환자, 심한 신장애 환자, 심한 심기능부전 환자, 심한 고혈압 환자, 이 약의 구성성분에 과민증이 있는 환자, 아스피린이나 다른 비스테로이드성 소염진통제(COX-2 저해제 포함)에 대하여 천식, 두드러기 또는 알레르기 반응 병력이 있는 환자, 관상동맥 우회로술(CABG) 전후에 발생하는 통증의 치료, 임부 및 수유부, 어린이 및 유소아</td>
            </tr>
            <tr id="KDGERI_MORNIFLUMATE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 350mg씩 1일 2회<br />∙ 1일 최대 투여량: 1,400mg</td>
            </tr>
            <tr id="KDGERI_MORNIFLUMATE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당 성분: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 기존의 신기능 저하 환자에게 투여시 신기능 악화 가능(특히 CrCl 30mL/min 이하인 경우) <br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능</td>
            </tr>
            <tr id="KDGERI_MORNIFLUMATE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음)</td>
            </tr>
            <tr id="KDGERI_MORNIFLUMATE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>구역, 구토, 위통, 가슴앓이, 설사, 소변감소증, 체액저류, 부종, 간수치증가 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_NABUMETONE" data-drug-number="24">
          <thead>
            <tr>
              <th className="drug-number">24</th>
              <th className="drug-name">나부메톤(Nabumetone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_NABUMETONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>골관절염(퇴행관절염), 류마티스 관절염</td>
            </tr>
            <tr id="KDGERI_NABUMETONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성궤양 환자 및 그 병력이 있는 환자, 중증 혈액이상 환자, 중증 간장애 환자, 중증 신장애 환자, 중증 심장애 환자, 이 약에 과민반응이 있는 환자, 아스피린천식(비스테로이드성 소염진통제 등에 의한 천식발작의 유발) 또는 그 병력이 있는 환자, 아스피린이나 다른 비스테로이드성 소염진통제(COX-2 억제제 포함)에 대하여 기관지염, 두드러기, 비염, 맥관부종, 알레르기 반응 병력이 있는 환자, 관상동맥 우회로술(CABG) 전후에 발생하는 통증의 치료, 임부 또는 임신하고 있을 가능성이 있는 여성, 수유부, 이전의 비스테로이드성 소염진통제 치료로 인해, 위장관 출혈, 재발성 소화궤양 또는 천공이 발생한 병력이 있는 환자, 15세 미만의 소아 및 청소년, 크론병 또는 궤양성대장염과 같은 염증성 장질환 환자</td>
            </tr>
            <tr id="KDGERI_NABUMETONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 1g씩 1일 1회 취침 전 투여<br />∙ 증상이 심하거나 지속적일 경우 또는 급속히 악화되는 경우에는 500mg-1g을 추가로 아침에 경구투여<br />∙ 고령자의 1일 최대투여량: 1g</td>
            </tr>
            <tr id="KDGERI_NABUMETONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당 품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 기존의 신기능 저하 환자에게 투여시 신기능 악화 가능(특히 CrCl 30mL/min 이하인 경우) <br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능<br />∙ 특히 고령, 당뇨, 신질환 환자, ACE억제제 동반 사용의 경우에 고칼륨혈증 유발가능, 기존 고혈압 악화 및 새로운 고혈압 유발가능</td>
            </tr>
            <tr id="KDGERI_NABUMETONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음)</td>
            </tr>
            <tr id="KDGERI_NABUMETONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>설사, 소화불량, 복통, 부종, 어지럼증, 두통, 피로, 불면증, 두드러기, 피부발진, 변비, 오심, 구토, 이명, 졸음, 짜증, 더부룩함, 혈변 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_NALBUPHINE" data-drug-number="25">
          <thead>
            <tr>
              <th className="drug-number">25</th>
              <th className="drug-name">날부핀(Nalbuphine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_NALBUPHINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>중등도 및 심한 동통, 마취보조제로서 수술전후 및 분만시 동통</td>
            </tr>
            <tr id="KDGERI_NALBUPHINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증</td>
            </tr>
            <tr id="KDGERI_NALBUPHINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[주사제] <br />∙ 통증조절: 10mg/70kg(체중 70kg당 10mg임) SQ, IM, IV이후 필요시 3~6시간마다 반복투여. 1회 최대투여량: 20mg 1일 최대투여량: 160mg <br />∙ 마취보조:유도용량: 0.3-3.0mg/kg, 10~15분 동안 slow IV유지용량: 필요시 1회 추가 투여, 0.25~0.5mg/kg IV <br />∙ 마약의존성 환자 및 마약 만성투여 환자:기존에 투여했던 약물이 몰핀, 메페리딘, 코데인 등 날부핀과 유사한 작용지속시간을 가진 마약이라면, 환자에게 염산날부핀 예상용량의 1/4을 투여하여 금단증상(복부경련, 구역, 구토, 유루, 비루, 불안, 운동불안, 체온상승, 기모현상)이 일어나는지를 관찰함. 심한 금단 증상이 나타나지 않으면, 신중하게 날부핀용량을 증량하여 투여할 수 있음</td>
            </tr>
            <tr id="KDGERI_NALBUPHINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 노인은 중추신경계 효과에 특히 민감할 수 있으므로 주의 깊게 관찰<br />∙ 마약 의존성이 있는 환자 및 만성적으로 마약을 복용한 환자는 염산날부핀투여로 인하여 마약 금단증상이 나타날 수 있음<br />∙ 날부핀 투여로 인해 마약금단증상이 심하게 발생한 경우, 몰핀을 소량씩 정맥투여하여 금단증상을 조절함<br />∙ 간부전, 신부전환자에서 용량을 줄이는 것이 좋으며 주의하여 사용<br />∙ 전립선비대, 요로폐쇄환자에게는 주의해서 사용<br />∙ 호흡기질환이 있을 경우 호흡저하가능성이 있어 주의해서 사용<br />∙ 호흡억제, 변비, 오심 및 구토는 다른 아편양제제에 비해 약하나 kappa 수용체를 통한 진통효과는 약한 편임</td>
            </tr>
            <tr id="KDGERI_NALBUPHINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 바르비트루 마취제(치아밀란,치오펜탈)(일시적 호흡정지 부작용 빈번해짐) <br />∙ 다른 중추신경계 억제제, 수면제, 진정제, 페노티아진류나 다른 정온제, 전신 마취제나 마약성 진통제(부작용) <br />∙ 항콜린제(오피오이드의 이상반응 증가) <br />∙ 항정제(오피오이드의 저혈압반응 증가) <br />∙ 이뇨제(오피오이드의 이상반응 증가) <br />∙ 졸피뎀(졸피뎀의 중추신경억제효과가 증가할 수 있어 졸피뎀의 용량 감량하여 사용)</td>
            </tr>
            <tr id="KDGERI_NALBUPHINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>진정, 현기, 두통, 냉습피부, 오심, 구토, 구강건조증</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_NAPROXEN" data-drug-number="26">
          <thead>
            <tr>
              <th className="drug-number">26</th>
              <th className="drug-name">나프록센(Naproxen)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_NAPROXEN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>류마티스 관절염, 골관절염(퇴행성 관절질환), 강직성 척추염, 건염, 급성통풍, 월경곤란증, 활액낭염, 골격근장애(염좌, 좌상, 외상, 요천통), 수술후 동통, 편두통, 발치후 동통</td>
            </tr>
            <tr id="KDGERI_NAPROXEN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성 궤양, 심한 혈액 이상, 심한 간장애 또는 신장애, 심한 심기능부전, 심한 고혈압, 이 약 또는 아스피린 등 비스테로이드성 소염진통제에 과민증, 아스피린이나 다른 비스테로이드성 소염진통제에 의해 천식･비염･코의 용종에 대한 병력, 관상동맥 우회로술(CABG) 전후에 발생하는 통증의 치료</td>
            </tr>
            <tr id="KDGERI_NAPROXEN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 류마티스 관절염, 골관절염, 강직성 척추염: 1회 250-500mg씩 1일 2회<br />∙ 급성통풍: 초회량 750mg, 이후 통증발작이 사라질 때까지 8시간 간격으로 250mg <br />∙ 골격근장애, 수술후 동통, 발치후 동통, 월경곤란증, 건염, 활액낭염: 초회량 500mg, 이후 6-8시간 간격으로 250mg, 1일 최대투여량: 1,250mg <br />∙ 편두통: 초회량 750mg, 필요시 30분 후 250-500mg 추가투여 가능, 1일 최대투여량: 1,250mg <br />∙ 고령환자에서 용량 조절 필요</td>
            </tr>
            <tr id="KDGERI_NAPROXEN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당 품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 기존의 신기능 저하 환자에게 투여시 신기능 악화 가능(특히 CrCl 30mL/min 이하인 경우) <br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능<br />∙ 특히 고령, 당뇨, 신질환 환자, ACE억제제 동반 사용의 경우에 고칼륨혈증 유발가능, 기존 고혈압 악화 및 새로운 고혈압 유발가능</td>
            </tr>
            <tr id="KDGERI_NAPROXEN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음) <br />∙ ACE억제제(항염증 효과 증가로 인한 심각한 신기능 악화 가능) <br />∙ ARB(약물 독성 증가, 신기능 악화 가능) <br />∙ 베타차단제(항고혈압 효과 감소) <br />∙ 항우울제(항혈소판효과 증가)스테로이드(이상반응 증가)디곡신(혈중 디곡신 농도 증가 가능)할로페리돌(약물 독성증가 및 졸음, 착란 유발가능)반코마이신(농도 증가)</td>
            </tr>
            <tr id="KDGERI_NAPROXEN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>부종, 어지럼증, 졸음, 두통, 두드러기, 피부 발진, 수분 저류, 복통, 변비, 오심, 설사, 호흡곤란, 반상출혈, 이명, 다형홍반 등 피부 부작용 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_NIMESULIDE" data-drug-number="27">
          <thead>
            <tr>
              <th className="drug-number">27</th>
              <th className="drug-name">니메술리드(Nimesulide)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_NIMESULIDE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>급성통증(수술후 통증, 치통, 두통, 요통), 원발성 월경통</td>
            </tr>
            <tr id="KDGERI_NIMESULIDE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성 궤양환자, 위장관 출혈, 뇌혈관 출혈 또는 다른 활동성 출혈이 있거나 출혈 장애의 병력이 있는 환자, 중증의 혈액응고장애 환자, 중증의 신장애 환자(크레아티닌청소율이 30 mL/min 미만), 중증의 심부전 환자, 간장애 환자, 이 약의 성분 또는 아스피린 등 비스테로이드성 소염진통제에 간독성 반응 병력이 있는 환자, 알코올 또는 다른 간독성이 있는 약물을 투여중인 환자, 알코올 중독자 또는 약물 중독자, 이 약 또는 이 약의 성분에 과민증이 있는 환자, 아스피린이나 다른 비스테로이드성 소염진통제(COX-2 저해제 포함)에 대하여 천식, 두드러기 등의 과민반응 병력이 있는 환자, 관상동맥 우회로술(CABG) 전후에 발생하는 통증의 치료, 발열 또는 인플루엔자 유사 증상이 있는 환자, 임부, 수유부, 소아</td>
            </tr>
            <tr id="KDGERI_NIMESULIDE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 50-100 mg씩 1일 2회<br />∙ 최대투여기간: 15일</td>
            </tr>
            <tr id="KDGERI_NIMESULIDE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 기존의 신기능 저하 환자에게 투여시 신기능 악화 가능(특히 CrCl 30mL/min 이하인 경우) <br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능<br />∙ 간독성으로 15일 이하로 투여해야 하며, 간질환이 있는 환자에서는 ibuprofen, ketoprofen, naproxen, indomethacin등 다른 약제 고려</td>
            </tr>
            <tr id="KDGERI_NIMESULIDE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음)</td>
            </tr>
            <tr id="KDGERI_NIMESULIDE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>설사, 구역, 구토, 탈락성 피부염, 간효소 증가 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_OXAPROZIN" data-drug-number="28">
          <thead>
            <tr>
              <th className="drug-number">28</th>
              <th className="drug-name">옥사프로진(Oxaprozin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_OXAPROZIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>∙ 다음 질환 및 증상의 소염･진통 : 만성 류마티스관절염, 골관절염(퇴행관절염), 요통, 변형성척추증, 경견완증후군, 견관절주위염, 통풍발작<br />∙ 외상후 및 수술후 소염･진통</td>
            </tr>
            <tr id="KDGERI_OXAPROZIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성궤양, 중증 간장애, 중증 신장애, 이 약 과민증, 아스피린이나 다른 비스테로이드성 소염진통제(COX-2 저해제 포함)에 대하여 천식･두드러기･ 알레르기 반응 및 그 병력이 있는 환자, 관상동맥 우회로술(CABG) 전후, 크론병 또는 궤양성대장염과 같은 염증성 장질환 환자</td>
            </tr>
            <tr id="KDGERI_OXAPROZIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1일 400mg을 1-2회 분할투여<br />∙ 1일 최대투여량: 600mg</td>
            </tr>
            <tr id="KDGERI_OXAPROZIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당 품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 주로 신장에서 배설되므로, 고령자는 최소용량을 사용하는 등 신중히 투여<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 특히 고령, 당뇨, 신질환 환자, ACE억제제 동반 사용의 경우에 고칼륨혈증 유발가능, 기존 고혈압 악화 및 새로운 고혈압 유발가능</td>
            </tr>
            <tr id="KDGERI_OXAPROZIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음) <br />∙ ACE억제제(항염증 효과 증가로 인한 심각한 신기능 악화 가능) <br />∙ ARB(약물 독성 증가, 신기능 악화 가능) <br />∙ 베타차단제(항고혈압 효과 감소) <br />∙ 항우울제(항혈소판효과 증가) <br />∙ 스테로이드(이상반응 증가) <br />∙ 디곡신(혈중 디곡신 농도 증가 가능) <br />∙ 할로페리돌(약물 독성증가 및 졸음, 착란 유발가능) <br />∙ 반코마이신(농도 증가)</td>
            </tr>
            <tr id="KDGERI_OXAPROZIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>위부불쾌감, 위통, 발진, 부종, 진정, 이명, 빈뇨, 혼돈, 우울증, 어지럼증, 두통, 수면장애, 빈혈, 간효소 수치 상승 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PELUBIPROFEN" data-drug-number="29">
          <thead>
            <tr>
              <th className="drug-number">29</th>
              <th className="drug-name">펠루비프로펜(Pelubiprofen)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PELUBIPROFEN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>골관절염의 증상이나 징후의 완화, 류마티스관절염의 증상이나 징후의 완화, 요통(허리통증) 완화</td>
            </tr>
            <tr id="KDGERI_PELUBIPROFEN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성궤양 환자, 중증의 혈액이상 환자, 중증의 간장애 환자, 중증의 신장애 환자, 중증의 심기능부전 환자, 중증의 고혈압 환자, 이 약의 성분에 과민증이 있는 환자, 아스피린이나 다른 비스테로이드성 소염진통제(COX-2 저해제 포함)에 대하여 천식, 두드러기, 알레르기 반응 및 그 병력이 있는 환자, 관상동맥우회로술(CABG) 전후에 발생하는 통증의 치료, 수유부</td>
            </tr>
            <tr id="KDGERI_PELUBIPROFEN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 30mg씩 1일 3회<br />∙ 노인에서는 소량부터 투여개시하여 환자의 상태를 관찰하면서 필요한 최소량을 투여</td>
            </tr>
            <tr id="KDGERI_PELUBIPROFEN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함</td>
            </tr>
            <tr id="KDGERI_PELUBIPROFEN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음)</td>
            </tr>
            <tr id="KDGERI_PELUBIPROFEN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>두통, 어지러움, 복통, 속쓰림, 구역, 구토, 소화불량, 위부불쾌감, 설사, 부종, 얼굴부종, 상기도 감염 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PENTAZOCINE" data-drug-number="30">
          <thead>
            <tr>
              <th className="drug-number">30</th>
              <th className="drug-name">펜타조신(Pentazocine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PENTAZOCINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제]중등도에서 중증 통증의 완화[주사제]중등도에서 중증 통증의 완화, 마취전 투약 및 마취보조제</td>
            </tr>
            <tr id="KDGERI_PENTAZOCINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 또는 이 약의 성분에 대한 과민반응 환자두개내압상승, 두개손상 환자(두개내압이 상승할 수 있음)호흡억제 환자, 기관지천식 환자, 폐쇄성호흡장애 환자, 청색증 환자</td>
            </tr>
            <tr id="KDGERI_PENTAZOCINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 25-50mg씩 3-4시간마다 경구 투여<br />∙ 1일 최대투여량: 360mg <br />[주사제] <br />∙ 중등도에서 중증 통증의 완화: 1회 15mg을 근육주사 또는 피하주사, 필요시 3-4시간마다 반복투여<br />∙ 마취전 투약 및 마취보조제: 1회 30-60mg을 근육, 피하 또는 정맥주사<br />∙ 1회 최대투여량: 1mg/kg(피하주사, 근육주사), 0.5mg/kg(정맥주사) <br />∙ 1일 최대투여량: 360mg</td>
            </tr>
            <tr id="KDGERI_PENTAZOCINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당 품목: 노인에게 투여시 중추신경계(CNS) 부작용(섬망,혼돈 등)이 나타날 수 있고, 더 안전한 대체약제가 있으므로 사용을 피해야 함<br />∙ 일반적으로 고령의 환자에게 투여 시 저용량부터 시작하며, 투여간격을 연장하는 등 주의깊게 관찰하여야 함<br />∙ 신장기능이 손상된 환자에게 독성발생의 위험성이 더 높을 수 있음. 고령의 환자는 신장기능이 저하되어 있을 수 있으므로 용량 선택시 주의해야 하며, 신장기능에 대한 관찰이 도움이 될 수 있음<br />∙ CrCl 10-50mL/min 정상용량의 75%로 감량, CrCl&lt;10mL/min 정상용량의 50%로 감량<br />∙ 저혈압환자: 이 약제의 사용이 체액량이 저하된 환자에서 저혈압을 유발할 수 있음<br />∙ 심혈관 질환 환자: 폐동맥 및 전신혈관저항을 증가시킬 수 있음<br />∙ 전립선비대, 요로폐색환자에게 주의하여 사용해야 함<br />∙ 특히 고령에서 다른 오피오이드 제제에 비하여 착란, 환각의 위험이 높으므로 중추신경작용 위험이 높은 고령환자에게는 주의해서 사용</td>
            </tr>
            <tr id="KDGERI_PENTAZOCINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 모르핀제제(이 약의 작용 증가, 고용량에서는 모르핀과 길항작용) <br />∙ 중추성 진통제, 벤조디아제핀 유도체 등 기타 진정제, 수면제 등 중추성약물, 알코올(이 약의 작용이 증강) <br />∙ 세로토닌 신경계 부활 작용이 있는 항우울제(항우울제 작용이 증강) <br />∙ Mirtazapine(중추신경억제효과 증대) <br />∙ 항콜린제(오피오이드의 이상반응 증가) <br />∙ 항정제(오피오이드의 저혈압반응 증가) <br />∙ 이뇨제(오피오이드의 이상반응 증가) <br />∙ 졸피뎀(졸피뎀의 중추신경억제효과가 증가할 수 있어 졸피뎀의 용량 감량하여 사용)</td>
            </tr>
            <tr id="KDGERI_PENTAZOCINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>구역, 구토, 호흡억제, 허약, 실신, 환각, 흥분, 혈압강하, 빈맥, 발진, 발한, 홍조, 의존성, 쇼크, 얼굴부종, 약물의존성, 요저류, 전진 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PIROXICAM" data-drug-number="31">
          <thead>
            <tr>
              <th className="drug-number">31</th>
              <th className="drug-name">피록시캄(Piroxicam)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PIROXICAM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제, 주사제]이 약은 다른 비스테로이드 소염제에 불응성이거나 효과가 불충분한 다음의 경우에만 투여: 류마티스 관절염, 골관절염, 강직성척추염, 허리통증, 어깨관절주위염, 경견완증후군</td>
            </tr>
            <tr id="KDGERI_PIROXICAM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성궤양 환자, 심한 혈액이상, 심한 간 장애 또는 신 장애, 심한 심기능부전, 심한 고혈압, 이 약에 과민증 및 그 병력자, 아스피린 및 다른 비스테로이드성 소염진통제에 의한 천식･비염･혈관부종 병력, 항응혈제투여, 80세 이상의 고령자</td>
            </tr>
            <tr id="KDGERI_PIROXICAM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 20mg씩 1일 1회<br />∙ 1일 최대투여량: 20mg <br />[주사제] <br />∙ 1회 20mg씩 1일 1회 근육주사<br />∙ 1일 최대투여량: 20mg</td>
            </tr>
            <tr id="KDGERI_PIROXICAM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당 품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 중증의 위장관계 이상반응을 일으킬 위험이 연령에 따라 증가. 70세 이상의 고령자에서 이상반응 위험이 높으므로 고령자에게 필요한 최소량으로 신중히 투여하고 이상반응 발현에 특히 유의해야 함<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 기존의 신기능 저하 환자에게 투여시 신기능 악화 가능(특히 CrCl 30mL/min 이하인 경우) <br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능<br />∙ 특히 고령, 당뇨, 신질환 환자, ACE억제제 동반 사용의 경우에 고칼륨혈증 유발가능, 기존 고혈압 악화 및 새로운 고혈압 유발가능</td>
            </tr>
            <tr id="KDGERI_PIROXICAM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음) <br />∙ ACE억제제(항염증 효과 증가로 인한 심각한 신기능 악화 가능) <br />∙ ARB(약물 독성 증가, 신기능 악화 가능) <br />∙ 베타차단제(항고혈압 효과 감소) <br />∙ 항우울제(항혈소판 효과 증가) <br />∙ 스테로이드(이상 반응 증가) <br />∙ 디곡신(혈중 디곡신 농도 증가 가능) <br />∙ 할로페리돌(약물 독성 증가 및 졸음, 착란 유발 가능) <br />∙ 반코마이신(농도 증가)</td>
            </tr>
            <tr id="KDGERI_PIROXICAM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>부종, 어지럼증, 두통, 두드러기, 피부발진, 복통, 식욕부진, 변비, 설사, 빈혈, 간효소 수치 상승, 이명, 속쓰림, PT증가, 신기능저하 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PROGLUMETACINMALEATE" data-drug-number="32">
          <thead>
            <tr>
              <th className="drug-number">32</th>
              <th className="drug-name">말레인산프로글루메타신(Proglumetacin maleate)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PROGLUMETACINMALEATE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>류마티양 관절염,골관절염(퇴행성관절질환),견관절주위염,외상에 의한 염증</td>
            </tr>
            <tr id="KDGERI_PROGLUMETACINMALEATE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성궤양 환자, 심한 혈액이상 환자, 심한 간장애 환자, 심한 신장애 환자, 심한 심기능부전 환자, 심한 고혈압 환자, 심한 췌장염 환자, 이 약의 성분 또는 인도메타신, 살리실산 제제(아스피린 등)에 과민증이 있는 환자, 아스피린이나 다른 비스테로이드성 소염진통제(COX-2 저해제 포함)에 대하여 천식, 두드러기, 알레르기 반응 또는 그 병력이 있는 환자, 관상동맥 우회로술(CABG) 전후에 발생하는 통증의 치료, 임부 또는 임신하고 있을 가능성이 있는 부인</td>
            </tr>
            <tr id="KDGERI_PROGLUMETACINMALEATE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1일 300-600mg을 2-3회 분할 경구투여</td>
            </tr>
            <tr id="KDGERI_PROGLUMETACINMALEATE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함</td>
            </tr>
            <tr id="KDGERI_PROGLUMETACINMALEATE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음)</td>
            </tr>
            <tr id="KDGERI_PROGLUMETACINMALEATE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>소화성 궤양, 위장출혈, 위통, 구역, 구토, 가려움증, 발진, 습진, 두드러기, 이명, 두통, 현기, 졸음, 심계항진, 부종, 발열, 구갈, 빈혈 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_SALSALATE" data-drug-number="33">
          <thead>
            <tr>
              <th className="drug-number">33</th>
              <th className="drug-name">살살레이트(Salsalate)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_SALSALATE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>류마티스 관절염, 골관절염(퇴행성 관절질환)</td>
            </tr>
            <tr id="KDGERI_SALSALATE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약의 성분 또는 살리실산 제제(아스피린 등)에 과민반응 및 그 병력이 있는 환자, 아스피린이나 다른 비스테로이드소염진통제(COX-2억제제 포함)에 대하여 천식, 두드러기 또는 알레르기 반응 병력이 있는 환자, 관상동맥우회술(CABG) 전후에 발생하는 통증의 치료</td>
            </tr>
            <tr id="KDGERI_SALSALATE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>∙ 1회 1,500mg씩 1일 2회<br />∙ 1회 1,000mg씩 1일 3회<br />∙ 일반성인용량에 준하며, 효과가 있는 최소 용량을 선택하도록 함</td>
            </tr>
            <tr id="KDGERI_SALSALATE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자에 있어서 필요한 최소량으로 신중히 투여하고, 이상반응의 발현에 특히 유의해야 함<br />∙ 소화성궤양 환자, 만성신부전 환자, 신장애 환자에게 신중 투여<br />∙ 매일 세잔 이상 정기적으로 술을 마시는 사람이 이 약이나 다른 해열진통제를 복용해야 할 경우에는 반드시 의사 또는 약사와 상의해야 함. 이러한 사람이 이 약을 복용하면 위장출혈이 유발될 수 있음<br />∙ 이 약을 포함한 비스테로이드소염진통제(NSAID)는 중대한 심혈관계 혈전 반응, 심근경색증 및 뇌졸중의 위험을 증가시킬 수 있으며, 이는 치명적일 수 있음<br />∙ 이 약을 포함한 비스테로이드소염진통제는 위 또는 장관의 출혈, 궤양 및 천공을 포함한 중대한 위장관계 이상반응의 위험을 증가시킬 수 있으며, 이는 치명적일 수 있음</td>
            </tr>
            <tr id="KDGERI_SALSALATE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 덱스케토프로펜: 사용금기 (독성증가 및 약효감소) <br />∙ 인플루엔자백신: 사용금기 (Reye’s syndrome) <br />∙ 다른 비스테로이드소염진통제(이상반응 위험 증가) <br />∙ ginkgo bibloba: 살살레이트의 항응고효과 증가, 출혈위험 증가<br />∙ 통풍치료제(요산배설작용 길항) <br />∙ 설포닐우레아계 경구용 당뇨병용제(저혈당 효과 증강) <br />∙ 티오펜탈, 나프록센, 와르파린, 메토트렉세이트, 코르티코스테로이드(단백결합 부위에서 경쟁) <br />∙ 메토트렉세이트(혈액학적 독성이 증가) <br />∙ 항응고제(항응고제 작용 증강) <br />∙ 인플루엔자 백신, 바리셀라 포함 백신(살살레이트의 독성증가)</td>
            </tr>
            <tr id="KDGERI_SALSALATE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>과호흡, 발진, 빈혈, 신장애, 간장애, 과민반응(발진, 부종 등), 아나필락시스, 이명, 난청, 어지러움, 속쓰림, 소화성 궤양 악화, 혈관부종, 저혈압, 기관지연축 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_SULINDAC" data-drug-number="34">
          <thead>
            <tr>
              <th className="drug-number">34</th>
              <th className="drug-name">설린닥(Sulindac)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_SULINDAC_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>골관절염(퇴행성 관절질환),류마티스양 관절염, 강직성 척수염,급성통풍성 관절염,관절주위염(건염,점액낭염,건초염)</td>
            </tr>
            <tr id="KDGERI_SULINDAC_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성궤양 환자 또는 위장출혈 환자, 심한 혈액이상 환자, 심한 간장애 환자, 심한 신장애 환자, 이 약의 성분에 과민증 및 그 병력이 있는 환자, 아스피린이나 다른 비스테로이드성 소염진통제(COX-2 저해제포함)에 대하여 천식(천식발작 포함), 두드러기, 비염, 알레르기반응 또는 그 병력이 있는 환자, 관상동맥 우회로술(CABG) 전후에 발생하는통증의 치료, 임부 또는 임신하고 있을 가능성이 있는 부인, 수유부, 어린이</td>
            </tr>
            <tr id="KDGERI_SULINDAC_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 100-200㎎씩 1일 2회 식사와 함께 경구투여</td>
            </tr>
            <tr id="KDGERI_SULINDAC_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당 품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 기존의 신기능 저하 환자에게 투여시 신기능 악화 가능(특히 CrCl 30mL/min 이하인 경우) <br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능<br />∙ 고령, 당뇨, 신질환 환자, ACE억제제 동반 사용의 경우에 고칼륨혈증 유발 가능<br />∙ 다형홍반 등 피부 부작용이 흔함</td>
            </tr>
            <tr id="KDGERI_SULINDAC_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음) <br />∙ ACE억제제(항염증 효과 증가로 인한 심각한 신기능 악화 가능) <br />∙ ARB(약물 독성 증가, 신기능 악화 가능) <br />∙ 베타차단제(항고혈압 효과 감소) <br />∙ 항우울제(항혈소판 효과 증가) <br />∙ 스테로이드(이상 반응 증가) <br />∙ 디곡신(혈중 디곡신 농도 증가 가능) <br />∙ 할로페리돌(약물 독성 증가 및 졸음, 착란 유발 가능) <br />∙ 반코마이신(농도 증가)</td>
            </tr>
            <tr id="KDGERI_SULINDAC_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>부종, 어지럼증, 두통, 복통, 신경과민, 소양증, 발진, 두드러기, 변비, 설사, 오심, 식욕부진, 구토, 이명 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_TALNIFLUMATE" data-drug-number="35">
          <thead>
            <tr>
              <th className="drug-number">35</th>
              <th className="drug-name">탈니플루메이트(Talniflumate)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_TALNIFLUMATE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>류마티양 관절염, 골관절염(퇴행성 관절질환), 외상후 동통, 수술후 염증 및 동통, 인두염, 편도염, 이염, 부비동염</td>
            </tr>
            <tr id="KDGERI_TALNIFLUMATE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성궤양 또는 그 병력이 있는 환자, 이 약, 니플루미산, 모니플루메이트 또는 이 약의 구성성분에 과민반응 환자, 아스피린이나 다른 비스테로이드소염진통제(COX-2억제제 포함)에 대하여 천식, 두드러기 또는 알레르기 반응 병력이 있는 환자, 관상동맥 우회로술(CABG) 전후에 발생하는 통증의 치료, 중증 간장애 환자, 중증 신장애 환자, 중증 심장애 환자, 임부 또는 임신하고 있을 가능성이 있는 여성, 수유부</td>
            </tr>
            <tr id="KDGERI_TALNIFLUMATE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 370mg씩 1일 3회<br />∙ 중증일 경우에는 1회 740mg</td>
            </tr>
            <tr id="KDGERI_TALNIFLUMATE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 기존의 신기능 저하 환자에게 투여시 신기능 악화 가능(특히 CrCl 30mL/min 이하인 경우) <br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능</td>
            </tr>
            <tr id="KDGERI_TALNIFLUMATE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음)</td>
            </tr>
            <tr id="KDGERI_TALNIFLUMATE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>구역, 구토, 설사, 변비, 복부팽만, 과민성 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_TENOXICAM" data-drug-number="36">
          <thead>
            <tr>
              <th className="drug-number">36</th>
              <th className="drug-name">테녹시캄(Tenoxicam)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_TENOXICAM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>류마티양 관절염, 골관절염(퇴행성 관절질환), 강직성 척추염, 견관절주위염, 고관절주위염, 경견완증후군, 요통, 급성통풍, 수술후･외상후 염증 및 동통, 건염, 활액낭염</td>
            </tr>
            <tr id="KDGERI_TENOXICAM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성궤양 환자, 심한 혈액이상 환자, 심한 간장애 환자, 심한 신장애 환자, 심한 심기능부전 환자, 이 약의 성분에 과민증이 있는 환자, 아스피린 등 살리실산 제제 또는 다른 비스테로이드성 소염진통제(COX-2 저해제 포함)의 투여로 천식, 비염, 두드러기 또는 알레르기 반응 병력이 있는 환자, 마취 또는 수술중인 환자(급성 신부전 발생 위험 증가, 혈액응고장애 유발), 관상동맥 우회로술(CABG) 전후에 발생하는 통증의 치료</td>
            </tr>
            <tr id="KDGERI_TENOXICAM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 20mg씩 1일 1회, 1회 최대투여량: 20mg <br />∙ 급성통풍: 처음 2일간 1회 40mg 투여, 다음 5일간 1회 20mg 투여</td>
            </tr>
            <tr id="KDGERI_TENOXICAM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 기존의 신기능 저하 환자에게 투여시 신기능 악화 가능(특히 CrCl 30mL/min 이하인 경우) <br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능</td>
            </tr>
            <tr id="KDGERI_TENOXICAM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음)</td>
            </tr>
            <tr id="KDGERI_TENOXICAM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>소화성궤양, 위통, 구내염, 구역, 설사, 복통, 발진, 가려움, 습진, 홍반, 어지러움, 두통, 이명, 심계항진, 부종 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_TIAPROFENICACID" data-drug-number="37">
          <thead>
            <tr>
              <th className="drug-number">37</th>
              <th className="drug-name">티아프로펜산(Tiaprofenic acid)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_TIAPROFENICACID_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>류마티양 관절염,골관절염(퇴행성 관절질환), 강직성 척추염, 요통, 견관절주위염, 섬유조직염, 낭염, 상과염과같은 근골격질환, 연조직손상, 건염, 수술후･외상후 염증 및 동통,급성상기도염, 항문질환(항문음와염, 항문유두염, 치루, 치열, 항문농양), 월경곤란증</td>
            </tr>
            <tr id="KDGERI_TIAPROFENICACID_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성궤양/출혈이 있거나 그 병력이 있는 환자, 심한 혈액이상 환자, 심한 간장애 환자, 심한 신장애 환자, 심한 심기능부전 환자, 비뇨기계 질환 병력 환자, 이 약의 성분에 과민증이 있는 환자, 천식(아스피린이나 비스테로이드성 소염진통제에 의한 천식 또는 이에 의하지 않은 천식 발작의 유발) 또는 그 병력이 있는 환자, 아스피린이나 다른 비스테로이드성소염진통제, 관상동맥 우회로술(CABG) 전후에 발생하는 통증의 치료, 이전의 비스테로이드성 소염제요법과 관련된 위장관출혈 또는 천공의 병력이 있는 환자, 3세 이하의 소아, 임부</td>
            </tr>
            <tr id="KDGERI_TIAPROFENICACID_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1일 600mg을 2~3회 분할 경구투여<br />∙ 경우에 따라서 투여후 4일째부터 1일 400mg으로 감량할 수 있음</td>
            </tr>
            <tr id="KDGERI_TIAPROFENICACID_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 기존의 신기능 저하 환자에게 투여시 신기능 악화 가능(특히 CrCl 30mL/min 이하인 경우) <br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능</td>
            </tr>
            <tr id="KDGERI_TIAPROFENICACID_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 코르티코스테로이드(위장관 궤양 또는 출혈 위험 증가) <br />∙ 혈전용해제(출혈 위험 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음) <br />∙ ACE억제제(항염증 효과 증가로 인한 심각한 신기능 악화 가능) <br />∙ ARB(약물 독성 증가, 신기능 악화 가능) <br />∙ 베타차단제(항고혈압 효과 감소) <br />∙ 항우울제(항혈소판 효과 증가) <br />∙ 스테로이드(이상 반응 증가) <br />∙ 디곡신(혈중 디곡신 농도 증가 가능) <br />∙ 할로페리돌(약물 독성 증가 및 졸음, 착란 유발 가능) <br />∙ 반코마이신(농도 증가)</td>
            </tr>
            <tr id="KDGERI_TIAPROFENICACID_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>소화불량, 부종, 홍조, 어지럼증, 두통, 졸음, 우울증, 두드러기, 발진, 고칼륨혈증, 오심, 구토, 변비, 복통, 설사, 가려움, 속쓰림, BUN상승(특히 고령환자)</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_TRAMADOL" data-drug-number="38">
          <thead>
            <tr>
              <th className="drug-number">38</th>
              <th className="drug-name">트라마돌(Tramadol)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_TRAMADOL_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>중증 및 중등도의 급만성 동통(각종 암 등), 진단 및 수술후 동통</td>
            </tr>
            <tr id="KDGERI_TRAMADOL_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>급성 알코올중독, 수면제, 중추신경계 작용약물 중독, 심한 호흡억제상태, 두부손상, 뇌의 병변이 있는 경우로 의식혼탁의 위험, MAO 저해제, 이 약 및 아편 과민증 및 그 병력자</td>
            </tr>
            <tr id="KDGERI_TRAMADOL_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 50mg, 필요시 30-60분 경과후 50mg 추가투여 가능<br />∙ 1일 최대투여량: 400mg <br />[서방형 경구제] <br />∙ 1회 150mg씩 1일 1회<br />∙ 중증의 신장애 환자(CrCl&lt;10ml/min)에게는 사용하지 않음<br />[주사제] <br />∙ 1회 50-100mg IV 또는 IM <br />∙ 필요시 4-5시간마다 추가투여 가능함<br />∙ 1일 최대투여량: 400mg 75세를 초과하는 환자는 이 약의 배설이 지연될 수 있으므로, 필요시 투여간격을 조절하고, 용량 조절시 충분히 모니터링해야 함</td>
            </tr>
            <tr id="KDGERI_TRAMADOL_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 혈중농도가 약간 상승할 수 있으므로 75세 이상 고령자에는 1일 300mg 이상 투여하지 않음<br />∙ 의존성이 낮으나, 장기투여에 의한 내약성으로 인해 정신적･육체적 의존성이 발생할 수 있음<br />∙ 간질이나 발작위험이 있는 환자는 반드시 필요할 때만 투여해야 함<br />∙ 구역, 드물게 구토, 졸음, 어지러움, 휘청거림 등의 증상이 나타날 수 있으므로 외래환자에 투여하는 경우에는 충분히 안정시킨 후 안전을 확인하고 귀가시켜야 함<br />∙ 미세한 동통에는 사용하지 않아야 함<br />∙ 발작의 역치를 낮추므로 발작이 잘 조절되고 다른 약제에 효과가 없는 경우에 고려<br />∙ 우울증 환자 등 항우울제나 진정제를 복용하는 환자에서는 자살위험 증가</td>
            </tr>
            <tr id="KDGERI_TRAMADOL_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 선택적 세로토닌 재흡수 억제제(SSRI) 또는 MAO억제제(세로토닌 증후군) <br />∙ 수면제, 진정제, 알코올 등 중추신경 억제약물(진정효과 강화) <br />∙ 카르바마제핀(트라마돌의 진통효과를 감소시키고 작용시간을 줄일 수 있음) <br />∙ 항콜린제(오피오이드의 이상반응 증가) <br />∙ 항구토제(트라마돌의 효과 감소) <br />∙ 삼환계 항우울제(트라마돌의 발작유발가능성을 높힘) <br />∙ 와르파린(항응고 효과 증가) <br />∙ 이뇨제(오피오이드의 이상반응 증가) <br />∙ 졸피뎀(졸피뎀의 중추신경억제효과가 증가할 수 있어 졸피뎀의 용량 감량하여 사용)</td>
            </tr>
            <tr id="KDGERI_TRAMADOL_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>홍조, 어지럼증, 두통, 중추신경 흥분, 불면증, 두드러기, 변비, 설사, 오심, 구토, 무려증, 기립성 저혈압, 고혈당, 관절통, 소양증, 복통, 근육통, 상기도 감염 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ZALTOPROFEN" data-drug-number="39">
          <thead>
            <tr>
              <th className="drug-number">39</th>
              <th className="drug-name">잘토프로펜(Zaltoprofen)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">해열진통소염제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ZALTOPROFEN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>만성 류마티스관절염, 골관절염(퇴행관절염), 요통, 견관절주위염, 경견완증후군. 수술후･ 외상후 및 발치 후의 소염･진통</td>
            </tr>
            <tr id="KDGERI_ZALTOPROFEN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>소화성 궤양 환자, 중증의 혈액이상 환자, 중증의 간장애 환자, 중증의 신장애 환자, 중증의 심기능부전 환자, 이 약 및 이 약의 성분에 대한 과민반응 환자, 아스피린이나 다른 비스테로이드성 소염진통제(COX-2 저해제포함)에 대하여 천식, 두드러기, 알레르기 반응 및 그 병력이 있는 환자, 관상동맥 우회로술(CABG) 전후에 발생하는통증의 치료, 수유부</td>
            </tr>
            <tr id="KDGERI_ZALTOPROFEN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 80mg씩 1일 3회<br />∙ 계속 사용하는 경우 1회 80-160mg 투여</td>
            </tr>
            <tr id="KDGERI_ZALTOPROFEN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당품목: GI bleeding, peptic ulcer disease 위험성 증가하므로 장기간 투여는 추천되지 않음(Rheumatoid arthritis나 osteoarthritis에 단독 사용하거나 mild osteoarthritis 통증경감을 위해서는 3달 이내 사용), 다른 대체약이 효과 없거나 프로톤펌프저해제, misoprostol 병용한 경우에는 사용 가능<br />∙ 항응혈제, 스테로이드, 다른 NSAID 동시 복용시 위장관 출혈 위험 증가<br />∙ 장기간 투여, 복용중 음주시에도 위장관 출혈 위험 증가<br />∙ 무증상 소화성궤양과 출혈 발생 가능함. 소화성 궤양 예방을 위해서 misoprostol이나 PPI를 병용 투여하고, 가급적 최소효과용량을 최단기간 동안 사용할 것을 권고함. 공복시에는 투여를 피함<br />∙ 기존의 신기능 저하 환자에게 투여시 신기능 악화 가능(특히 CrCl 30mL/min 이하인 경우) <br />∙ 중추신경계 부작용은 과용량에서 주로 나타나지만 노인에서는 권고용량에서도 혼돈 증상 발생 가능</td>
            </tr>
            <tr id="KDGERI_ZALTOPROFEN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 비스테로이드성 소염진통제(이상반응 증가) <br />∙ 경구용 항응고제(와르파린)(출혈 경향 증가) <br />∙ 이뇨제(나트륨 뇨배설 효과 감소) <br />∙ 리튬(혈중 리튬 농도 증가) <br />∙ 메토트렉세이트(혈액학적 독성이 증가될 수 있음)</td>
            </tr>
            <tr id="KDGERI_ZALTOPROFEN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>위불쾌감, 위통, 구역, 설사, 두통, 발진, 적혈구 감소, 부종 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_BACLOFEN" data-drug-number="40">
          <thead>
            <tr>
              <th className="drug-number">40</th>
              <th className="drug-name">바클로펜(Baclofen)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">골격근이완제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_BACLOFEN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>다발성 경화증, 척추소뇌변성증으로 인한 골격근의 경직, 척수질환(염증성, 퇴행성, 외상성, 신생성, 원인불명 등)으로 인한 경직, 대뇌 원인으로 인한 경직(특히 뇌성마비, 뇌혈관사고, 신생성 뇌질환, 퇴행성 뇌질환 등이 있는 경우)</td>
            </tr>
            <tr id="KDGERI_BACLOFEN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 및 이 약의 다른 구성성분에 과민증 환자</td>
            </tr>
            <tr id="KDGERI_BACLOFEN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 초기 용량: 1회 5mg씩 1일 3회<br />∙ 최적 용량: 1일 30-80mg <br />∙ 입원 환자는 철저한 감독하에 1일 100-120mg 투여 가능</td>
            </tr>
            <tr id="KDGERI_BACLOFEN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자에서 생리기능이 저하되어 있는 경우가 많고 비교적 저용량으로 근력저하, 권태감 등의 증상이 나타날 수 있으므로 저용량부터 투여 시작하는 등 환자의 상태를 관찰하며 신중히 투여<br />∙ 장기간 사용했던 환자에게 투여를 갑작스럽게 중단한 경우 불안, 흥분, 착란상태, 환각 등이 발생할 수 있으므로 천천히 감량해야 함<br />∙ 신장, 간질환 환자에 사용 시 주의<br />∙ 중독시 구토, 근육의 긴장 저하, 타액 분비, 졸음, 혼수, 발작 등이 나타나며 이때 atropine을 사용할 수 있음</td>
            </tr>
            <tr id="KDGERI_BACLOFEN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 중추신경계에 작용하는 약물, 합성 아편류, 알코올(진정작용 증강) <br />∙ 삼환계 항우울약(근긴장저하) <br />∙ 혈압강하제(혈압강하작용 증강) <br />∙ 레보도파(정신혼돈, 환각, 두통, 구역, 격앙 보고)</td>
            </tr>
            <tr id="KDGERI_BACLOFEN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>진정, 졸음, 흔하게 호흡기능억제, 두경감, 권태, 피로, 탈진, 정신혼돈, 어지러움, 두통, 불면증, 다행증, 우울증, 근약화, 운동실조, 구역, 불수의성 구토, 식욕부진, 위부불쾌감, 복부팽만감, 가슴쓰림, 구갈, 변비, 설사, 저혈압, 빈뇨 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_CHLORPHENESIN" data-drug-number="41">
          <thead>
            <tr>
              <th className="drug-number">41</th>
              <th className="drug-name">클로르페네신(Chlorphenesin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">골격근이완제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_CHLORPHENESIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>근골격계 질환에 수반하는 동통성 연축 : 요배통증,변형성척추증, 추간판헤르니아, 척추분리･전위증, 척추골다공증, 경견완증후군</td>
            </tr>
            <tr id="KDGERI_CHLORPHENESIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 및 유사화합물(메토카르바몰 등)에 대하여 과민증의 병력자, 간장애</td>
            </tr>
            <tr id="KDGERI_CHLORPHENESIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 250mg씩 1일 3회</td>
            </tr>
            <tr id="KDGERI_CHLORPHENESIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자에서는 생리기능이 저하되어 있으므로 감량하는 등 주의 필요</td>
            </tr>
            <tr id="KDGERI_CHLORPHENESIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 페노티아진계 약물(클로르프로마진 등), 바르비탈계 약물 등의 중추신경억제제, MAO 저해제(병용하는 경우 감량 필요)</td>
            </tr>
            <tr id="KDGERI_CHLORPHENESIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>발진, 부종, 졸음, 어지럼증, 구역, 구토, 위통, 식욕부진, 구갈 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_CHLORZOXAZONE" data-drug-number="42">
          <thead>
            <tr>
              <th className="drug-number">42</th>
              <th className="drug-name">클로르족사존(Chlorzoxazone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">골격근이완제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_CHLORZOXAZONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>근골격계 질환에 수반하는 동통성 연축 : 요배통증, 경견완증후군, 견관절주위염, 변형성 척추증</td>
            </tr>
            <tr id="KDGERI_CHLORZOXAZONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약에 과민증의 병력이 있는 환자, 이 약에 내성이 없는 환자</td>
            </tr>
            <tr id="KDGERI_CHLORZOXAZONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 200-400㎎씩 1일 3-4회 경구투여</td>
            </tr>
            <tr id="KDGERI_CHLORZOXAZONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당 품목: 노인에서는 항콜린성 부작용, 진정, 골절 위험성 증가 등으로 인해 내약성이 적으므로 사용을 피해야 함</td>
            </tr>
            <tr id="KDGERI_CHLORZOXAZONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 페노티아진계 약물(클로르프로마진 등), 바르비탈계 약물 등의 중추신경억제제, MAO 저해제(병용하는 경우 감량 필요)</td>
            </tr>
            <tr id="KDGERI_CHLORZOXAZONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>발진, 가려움, 두드러기, 졸음, 어지러움, 구역, 구토, 변비 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_CYCLOBENZAPRINE" data-drug-number="43">
          <thead>
            <tr>
              <th className="drug-number">43</th>
              <th className="drug-name">시클로벤자프린(Cyclobenzaprine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">골격근이완제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_CYCLOBENZAPRINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>급성, 동통성 근골격계 질환에 수반하는 증상완화</td>
            </tr>
            <tr id="KDGERI_CYCLOBENZAPRINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, MAO저해제를 투여중이거나 투여중지한 후 14일 이내, 심근경색 직후 회복기, 부정맥, 울혈성 심부전, 갑상선 기능 항진증</td>
            </tr>
            <tr id="KDGERI_CYCLOBENZAPRINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제-정제] <br />∙ 1회 10mg씩 1일 3회<br />∙ 1일 최대투여량: 60mg <br />[경구제-서방캡슐] <br />∙ 1회 15mg씩 1일 1회<br />∙ 1일 최대투여량: 30mg</td>
            </tr>
            <tr id="KDGERI_CYCLOBENZAPRINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당 품목: 노인에서는 항콜린성 부작용, 진정, 골절 위험성 증가 등으로 인해 내약성이 적으므로 사용을 피해야 함<br />∙ 고령자에서는 성인에 비해 혈장 약물 농도 및 반감기가 상승하므로, 고령자에게 사용해서는 안 됨<br />∙ 노인 환자에 캡슐, 서방정 사용이 권고 되지않음</td>
            </tr>
            <tr id="KDGERI_CYCLOBENZAPRINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ MAO 저해제(생명을 위협) <br />∙ 알코올, 바르비탈계 약물, 다른 중추신경억제제(작용 증가) <br />∙ 트라마돌(발작 위험 증가)</td>
            </tr>
            <tr id="KDGERI_CYCLOBENZAPRINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>졸음, 어지럼증, 피로, 두통, 혼돈, 신경과민, 복통, 설사, 오심, 인후염, 상기도 감염 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_EPERISONE" data-drug-number="44">
          <thead>
            <tr>
              <th className="drug-number">44</th>
              <th className="drug-name">에페리손(Eperisone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">골격근이완제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_EPERISONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>근골격계질환에 수반하는 동통성 근육연축(경견완증후군, 견관절주위염, 요통), 신경계 질환에 의한 경직성 마비 : 뇌혈관장애, 경직성 척수마비, 경부척추증, 수술후 후유증(뇌･척수종양 포함), 외상후유증(척수손상, 두부외상), 근위축성 축색경화증, 뇌성마비, 척수소뇌변성증, 척수혈관장애, 아급성 척수시신경병변, 기타의 뇌척수질환</td>
            </tr>
            <tr id="KDGERI_EPERISONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약에 과민증 환자, 중증의 근무력증 환자, 3) 이 약은 유당을 함유하고 있으므로, 갈락토오스 불내성(galactose intolerance), Lapp 유당분해효소 결핍증(Lapp lactase deficiency) 또는 포도당-갈락토오스 흡수장애(glucose-galactose malabsorption) 등의 유전적인 문제가 있는 환자</td>
            </tr>
            <tr id="KDGERI_EPERISONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 50mg씩 1일 3회</td>
            </tr>
            <tr id="KDGERI_EPERISONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자에서는 생리기능이 저하되어 있으므로 감량하는 등 주의<br />∙ 무력감, 비틀거림, 졸음 등이 나타날 수 있으므로, 이러한 경우에는 감량 또는 투여 중지<br />∙ 졸음, 주의력･집중력･반사운동능력 등의 저하가 나타날 수 있으므로 이 약을 투여중인 환자는 자동차운전 등 위험을 수반하는 기계조작을 하지 않도록 주의</td>
            </tr>
            <tr id="KDGERI_EPERISONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 염산톨페리손, 메토카르바몰(시조절장애)</td>
            </tr>
            <tr id="KDGERI_EPERISONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>쇼크, 단백뇨, BUN 상승, 빈혈, 발진, 가려움, 불면, 졸음, 두통, 구역, 구토 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_METHOCARBAMOL" data-drug-number="45">
          <thead>
            <tr>
              <th className="drug-number">45</th>
              <th className="drug-name">메토카르바몰(Methocarbamol)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">골격근이완제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_METHOCARBAMOL_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>요배통증,경견완증후군, 견관절주위염, 변형성척추증</td>
            </tr>
            <tr id="KDGERI_METHOCARBAMOL_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 또는 유사화합물(메프로바메이트 등) 과민증, 신장애(또는 신장애 의심), 중증의 근무력증, 혼수 또는 전혼수상태, 뇌손상, 간질 또는 경련의 병력자</td>
            </tr>
            <tr id="KDGERI_METHOCARBAMOL_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 500-750mg씩 1일 3회<br />[주사제] <br />∙ 1회 500mg 근육 또는 정맥주사<br />∙ 1회 최대투여량: 1g <br />∙ 1일 최대투여량: 3g <br />∙ 최대 투여기간: 3일</td>
            </tr>
            <tr id="KDGERI_METHOCARBAMOL_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당 품목: 노인에서는 항콜린성 부작용, 진정, 골절 위험성 증가 등으로 인해 내약성이 적으므로 사용을 피해야 함<br />∙ 고령자에서는 생리기능이 저하되어 있으므로 감량하는 등 주의 필요</td>
            </tr>
            <tr id="KDGERI_METHOCARBAMOL_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 페노티아진계 약물(클로르프로마진 등), 바르비탈계 약물 등의 중추신경억제제, MAO 저해제(병용하는 경우 감량 필요) <br />∙ 염산톨페리손(시조절장애)</td>
            </tr>
            <tr id="KDGERI_METHOCARBAMOL_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>발진, 두드러기, 가려움, 쇼크유사증상, 서맥, 혈압저하, 졸음, 어지러움, 휘청거림, 구역, 구토 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ORPHENADRINE" data-drug-number="46">
          <thead>
            <tr>
              <th className="drug-number">46</th>
              <th className="drug-name">올페나드린(Orphenadrine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">골격근이완제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ORPHENADRINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>특발성 파킨슨증, 기타의 파킨슨증(뇌염후, 동맥경화성), 골격근 연축의 진통</td>
            </tr>
            <tr id="KDGERI_ORPHENADRINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>녹내장 환자, 유문 및 십이지장폐색, 협착성 소화성궤양, 전립선 비대, 방광경부 폐쇄, 분문연축(거대식도), 중증의 근무력증, 이 약 과민증, 자발성 운동장애</td>
            </tr>
            <tr id="KDGERI_ORPHENADRINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 50mg씩 1일 3회<br />[주사제] <br />∙ 1일 80-120mg씩 근육주사</td>
            </tr>
            <tr id="KDGERI_ORPHENADRINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당 품목: 노인에서는 항콜린성 부작용, 진정, 골절 위험성 증가 등으로 인해 내약성이 적으므로 사용을 피해야 함</td>
            </tr>
            <tr id="KDGERI_ORPHENADRINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 옥시코돈(마비성 장폐색 위험성 증가) <br />∙ 마약성 진통제(호흡억제 부작용 증가)</td>
            </tr>
            <tr id="KDGERI_ORPHENADRINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>구갈, 심계항진, 변비, 배뇨장애, 시야몽롱, 산통, 졸음, 안긴장, 구역, 구토 등의 위장관장애, 허약, 두통, 빈맥, 어지러움, 두드러기, 피부질환, 매우 드물게 다행증, 불면, 신경질 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PRIDINOL" data-drug-number="47">
          <thead>
            <tr>
              <th className="drug-number">47</th>
              <th className="drug-name">프리디놀(Pridinol)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">골격근이완제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PRIDINOL_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>운동기 질환의 동통성 경축(요배통증, 경견완증후군, 견관절주위염, 변형성 척추증)</td>
            </tr>
            <tr id="KDGERI_PRIDINOL_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약에 과민증이 있는 환자, 녹내장, 전립선비대에 따른 배뇨장애, 심한 심질환 또는 마비성 장폐쇄증이 있는 환자</td>
            </tr>
            <tr id="KDGERI_PRIDINOL_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 4mg씩 1일 3회<br />[주사제] <br />∙ 1회 2mg을 근육 또는 정맥주사</td>
            </tr>
            <tr id="KDGERI_PRIDINOL_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자에서 생리기능이 저하되어 있으므로 감량하는 등 주의<br />∙ 졸음, 주의력, 집중력, 반사운동능력 등의 저하가 나타날 수 있으므로 이 약을 투여중인 환자는 자동차 운전 등 위험을 수반하는 기계조작을 하지 않도록 주의</td>
            </tr>
            <tr id="KDGERI_PRIDINOL_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 페노티아진계 약물(클로르프로마진 등), 바르비탈계 약물 등의 중추신경억제제, MAO 저해제(병용하는 경우 감량 필요) <br />∙ 아만타딘, 퀴니딘(항콜린작용 증강) <br />∙ 메토클로프라미드(위장관 작용 상쇄)</td>
            </tr>
            <tr id="KDGERI_PRIDINOL_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>발진, 두드러기, 현훈, 실신, 졸음, 환각, 구갈, 구역, 구토 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_THIOCOLCHICOSIDE" data-drug-number="48">
          <thead>
            <tr>
              <th className="drug-number">48</th>
              <th className="drug-name">치오콜치코시드(Thiocolchicoside)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">골격근이완제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_THIOCOLCHICOSIDE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>급성 척추질환으로 인한 동통성 근육수축의 보조치료</td>
            </tr>
            <tr id="KDGERI_THIOCOLCHICOSIDE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약의 주성분에 과민반응이 있는 환자, 이완성 마비 및 근이완 환자, 임신부 및 임신하고 있을 가능성이 있는 여성, 수유부</td>
            </tr>
            <tr id="KDGERI_THIOCOLCHICOSIDE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 8mg씩 1일 2회<br />∙ 1일 최대투여량: 16mg <br />∙ 최대투여기간: 7일</td>
            </tr>
            <tr id="KDGERI_THIOCOLCHICOSIDE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>신장애, 근육 긴장 감퇴 등의 환자에게 사용시 주의</td>
            </tr>
            <tr id="KDGERI_THIOCOLCHICOSIDE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>보고된 자료 없음</td>
            </tr>
            <tr id="KDGERI_THIOCOLCHICOSIDE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>흥분, 불면증, 정신혼란, 설사, 위통, 소화불량, 과민반응 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_TIZANIDINE" data-drug-number="49">
          <thead>
            <tr>
              <th className="drug-number">49</th>
              <th className="drug-name">티자니딘(Tizanidine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">골격근이완제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_TIZANIDINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>근골격계 질환에 수반하는 근육연축(경견완증후군, 요통, 추간판헤르니아), 신경계 질환에 의한 경직성 마비: 뇌혈관장애, 경직성 척수마비, 경부척추증, 뇌성마비, 외상후유증(척수손상, 두부외상), 척수소뇌변성증, 다발성 경화증, 근위축성 축색 경화증</td>
            </tr>
            <tr id="KDGERI_TIZANIDINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>티자니딘 또는 이 약의 다른 성분에 과민증이 있는 환자, 간 기능이 현저하게 손상된 환자, 유ㆍ소아, 플루복사민 또는 시프로플록사신과 같이 CYP1A2의 강한 저해제를 투여받고 있는 환자, 갈락토오스 불내성(galactose intolerance), Lapp 유당분해효소 결핍증(Lapp lactase deficiency) 또는 포도당-갈락토오스 흡수장애(glucose-galactose malabsorption) 등의 유전적인 문제가 있는 환자</td>
            </tr>
            <tr id="KDGERI_TIZANIDINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 1-2mg씩 1일 3회<br />∙ 효과가 나타나면 1일 6-9mg까지 증량</td>
            </tr>
            <tr id="KDGERI_TIZANIDINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 주로 신장에서 배설되어 신기능이 저하된 경우가 많은 고령자에서는 이 약의 높은 혈중농도가 지속될 수 있으므로 감량하는 등 주의(CrCl&lt;25mL/min 인 경우 저용량으로 사용) <br />∙ 간기능 저하자에서 저용량으로 사용<br />∙ 혈압저하가 나타날 수 있으므로 고령자에서는 특히 주의<br />∙ 고령자에서의 사용 경험 제한적임<br />∙ 항콜린성 작용 때문에 치매, 섬망이 있는 고령자에서 적절하지 않음</td>
            </tr>
            <tr id="KDGERI_TIZANIDINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ CYP1A2 저해제(이 약의 혈장 농도 상승) <br />∙ 혈압강하제(저혈압 또는 서맥) <br />∙ 진정제 및 알코올(진정작용 증강) <br />∙ 경구용 피임약(이 약의 혈중농도 증가) <br />∙ 레보도파, MAO저하제(기립성 저혈압 악화) <br />∙ 멀타자핀, 세로토닌 노르에피네프린 재흡수 억제제, 삼환계 항우울제(이 약의 혈압 저하 효과 저하)</td>
            </tr>
            <tr id="KDGERI_TIZANIDINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>졸음, 어지러움, 서맥, 저혈압, 구강건조증, 피로, 혈압저하, 위약, 신경과민, 언어장애, 환시, 망상, 변비, 구토, 빈뇨, 간수치 상승, 운동이상증, 시야 흐림, 후두염, 비염, 감염, 독감 유사 증후군, 과민반응</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_TOLPERISONE" data-drug-number="50">
          <thead>
            <tr>
              <th className="drug-number">50</th>
              <th className="drug-name">톨페리손(Tolperisone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">골격근이완제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_TOLPERISONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>성인의 뇌졸중 후 강직 증상 치료</td>
            </tr>
            <tr id="KDGERI_TOLPERISONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약의 활성성분 또는 에페리손과 화학적 구조가 유사항 성분 및 이 약에 사용된 첨가제 등에 과민증이 있는 환자, 이 약에 과민증 환자, 중증의 근무력증 환자, 3개월 미만의 영아</td>
            </tr>
            <tr id="KDGERI_TOLPERISONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 100-150mg씩 1일 3회</td>
            </tr>
            <tr id="KDGERI_TOLPERISONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 약물과민증의 병력이 있는 환자, 간장애 환자에게 신중 투여</td>
            </tr>
            <tr id="KDGERI_TOLPERISONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 메토카르바몰(시조절장애) <br />∙ 단트롤렌나트륨(근이완작용 증강) <br />∙ 아미노글리코시드계 항생물질(호흡억제 증강)</td>
            </tr>
            <tr id="KDGERI_TOLPERISONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>흉내압박감, 호흡장애, 간장애, 간기능 이상, 발진, 휘청거림, 무력감, 권태감, 어지러움, 식욕부진, 복통, 혈압강하 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ALFENTANIL" data-drug-number="51">
          <thead>
            <tr>
              <th className="drug-number">51</th>
              <th className="drug-name">알펜타닐(Alfentanil)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">합성마약</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ALFENTANIL_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>아산화질소/산소와 함께 마취 유지 시 점적 정맥주사로 투여하는 진통보조제, 감시마취관리(Monitored Anesthesia Care) 시의 진통보조제, 기관내삽관이나 조절호흡이 필요한 전신수술에서 마취유도를 위한 1차 마취제, 바르비튜레이트/아산화질소/산소와 함께 마취유지 시 증량투여하는 진통보조제</td>
            </tr>
            <tr id="KDGERI_ALFENTANIL_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 및 이 약의 구성성분, 다른 아편계 약물에 대한 과민반응 및 그 병력이 있는 환자, 중증 호흡억제 환자, MAO억제제를 투여 중이거나 투여중단 후 2주 이내의 환자, 출산 중이나 제왕절개 수술 시 탯줄을 묶기 전인 임부, 이 약또는 다른 마약성 진통제에 대한 내성이 있는 환자, 아편양수용체의 부분효현제를 투여 받고 있는 환자, 두개내압 상승과 관련된 두부의 기질적 장애나 손상이 있는 환자</td>
            </tr>
            <tr id="KDGERI_ALFENTANIL_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[주사제] <br />∙ 전신마취(자가호흡 또는 보조호흡시): 진통유도 5-20mcg/kg, 진통유지 5-20분마다 3-5mcg/kg, 총 용량: 5-40 mcg/kg <br />∙ 점적정주: 전신 수술환자에게 아산화질소/산소와 함께 0.5-3mcg/kg/min</td>
            </tr>
            <tr id="KDGERI_ALFENTANIL_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자 및 쇠약자는 이 약의 반감기가 연장될 수 있고, 혈장 청소율이 감소될 수 있으며, 수술 후 회복이 지연될 수 있으므로, 초회량을 적절히 감량해야 하며 추가용량은 초회량에 따른 효과를 참고하여 결정해야 함<br />∙ 서맥이 악화될 수 있음<br />∙ 알펜타닐은 펜타닐의 1/10정도의 강도이며 작용발현과 반감기가 펜타닐보다 더 짧음</td>
            </tr>
            <tr id="KDGERI_ALFENTANIL_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 전신마취제 및 중추신경억제제(중추신경계 및 순환기계에 대한 효과, 지속시간 증가, 수술 후 호흡억제 증가) <br />∙ 시토크롬 P450 3A4효소 억제제(이 약의 대사 억제) <br />∙ 간의 혈류나 효소기능에 영향을 미치는 약물(이 약의 혈중 청소율 감소) <br />∙ 베타차단제, 마취제(서맥이나 저혈압의 발현율 증가) <br />∙ 아편양 수용체의 부분효현제(이 약의 진통 효과 감소, 금단증상 촉진) <br />∙ 디아제팜(혈관확장, 저혈압) <br />∙ 항콜린제(오피오이드의 이상반응 증가) <br />∙ 칼슘통로차단제(서맥 악화) <br />∙ 딜티아젬(알펜다닐의 혈중농도를 증가) <br />∙ 이뇨제(이뇨제의 이상반응 증가) <br />∙ Mirtazapine(중추신경억제효과 증대) <br />∙ 졸피뎀(졸피뎀의 중추신경억제효과가 증가할 수 있어 졸피뎀의 용량 감량하여 사용)</td>
            </tr>
            <tr id="KDGERI_ALFENTANIL_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>서맥, 말초혈관확장, 졸음, 진정, 뇌압상승, 오심, 구토, 변비, 안구축동, 부정맥, 기립성 저혈압, 혼돈 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_FENTANYL" data-drug-number="52">
          <thead>
            <tr>
              <th className="drug-number">52</th>
              <th className="drug-name">펜타닐(Fentanyl)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">합성마약</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_FENTANYL_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[주사제]마취 시, 마취전 투약, 마취유도, 마취유지 및 수술직후(회복실) 경우의 단시간 진통제, 전신 또는 국소마취시 마약성 진통보조제, 드로페리돌과 같은 신경이완제와 병용할 경우 마취유도, 마취유지를 위한 마취전 투약제, 다음과 같은 고위험환자군에 산소와 병행하여 마취 : 개심술, 복잡한 신경계 및 정형외과 수술[패취제]장시간 지속적인 마약성 진통제 투여를 필요로 하는 만성 통증의 완화 [구강정, 설하정, 박칼정, 나잘스프레이]현재 지속성 통증에 대한 아편양제제 약물 치료를 받고 있으며, 이에 대한 내약성을 가진 암 환자에 대한 돌발성 통증</td>
            </tr>
            <tr id="KDGERI_FENTANYL_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>펜타닐 또는 이 약의 구성성분에 대한 내약성이 없거나 과민증이 있는 환자, 아편양 제제에 내약성이 없거나 아편계 약물의 투여를 받은 적이 없는 환자, 중증의 호흡 억제 또는 중증 폐쇄성 폐질환 환자, 기존에 안면 방사선 치료를 받은 환자, 재발성 비출혈 증상 환자,2세 미만의 영아</td>
            </tr>
            <tr id="KDGERI_FENTANYL_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[주사제] <br />∙ 마취전투여: 50-100mcg (1-2mL)을 수술 30-60분 전에 근육주사<br />∙ 국소마취시 진통보조제: 부수적으로 진통효과가 필요한 경우 50-100mcg (1-2mL)을 서서히 1-2분에 걸쳐 정맥주사 또는 근육주사<br />∙ 수술 후(회복실): 통증 조절이 필요하거나 빈호흡, 섬망발현 시 50-100mcg (1-2 mL)을 근육주사. 필요 시 1-2시간 후 반복 투여<br />[패취제] <br />∙ 초기 용량: 25mcg/h를 초과하지 않아야 함<br />∙ 3일마다 12 또는 25mcg/h 씩 증가시켜 조절 (max: 300mcg/h) <br />[구강정] <br />∙ 200mcg 투여 시작(처음에는 6정을 초과하여 조제 금지) <br />∙ 필요하면 15분에 걸쳐 두번째 1정을 복용<br />[설하정, 박칼정] <br />∙ 초기 용량: 100mcg <br />∙ 30분 안에 적절한 진통효과를 얻지 못했을 경우 두 번째 용량을 투여받을 수 있음<br />[나잘스프레이] <br />∙ 초기 용량: 한 쪽 비공에 1회 50mcg 투여<br />∙ 충분한 효과를 얻지 못할 경우 10분 후 재투여, 1회의 돌발성 통증에 대해 2회 투여를 초과해서는 안 됨, 또 다른 돌발성 통증에 대해 최소 4시간 이후에 투여</td>
            </tr>
            <tr id="KDGERI_FENTANYL_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 패취제: 비마약성 진통제로 조절이 가능한 경미한 통증이나, 수시 처방이 필요한 간헐적인 통증의 조절에 투여해서는 안 됨<br />∙ 고령에서는 펜타닐에 효과가 두 배 높게 나타나므로 연령, 몸무게 등을 고려하여 용량조절 필요<br />∙ 신부전, 간부전: 패치에서 중증의 경우 50%감량하여 사용하고 심각한 경우에는 사용을 금함<br />∙ 췌장염을 포함한 담관계장애에 주의하여 사용<br />∙ 경련 악화 가능</td>
            </tr>
            <tr id="KDGERI_FENTANYL_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 마약성 진통제, 전신마취제, 중추신경 억제성 항불안제(중추신경억제작용 유발) <br />∙ CYP450 3A4 억제제(이 약의 혈중농도 증가) <br />∙ MAO 억제제(중추신경 흥분 또는 억제되므로 2주 이내 병용 금기) <br />∙ SSRI 또는 SNRI(세로토닌 증후군의 위험성 증가) <br />∙ 항콜린제(오피오이드의 이상반응 증가) <br />∙ 베타차단제, 칼슘통로차단제(서맥 유발 가능) <br />∙ 이뇨제(이뇨제 이상반응 증가) <br />∙ 졸피뎀(졸피뎀의 중추신경억제효과가 증가할 수 있어 졸피뎀의 용량 감량하여 사용)</td>
            </tr>
            <tr id="KDGERI_FENTANYL_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>의존성, 호흡장애, 의식장애, 구역, 구토, 변비, 구갈, 무력증, 발한, 서맥, 흉곽강직, 부종, 중추신경계억제, 탈수</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_HYDROMORPHONE" data-drug-number="53">
          <thead>
            <tr>
              <th className="drug-number">53</th>
              <th className="drug-name">히드로모르폰(Hydromorphone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">합성마약</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_HYDROMORPHONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제-서방정]마약성 진통제 사용이 필요한 심한 통증의 완화[경구제-정제, 주사제]수술, 암, 외상(연조직 및 뼈), 담석산통, 심근경색, 화상, 신산통으로 인한 통증의 완화</td>
            </tr>
            <tr id="KDGERI_HYDROMORPHONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 및 이 약의 구성성분에 대한 과민반응 및 그 병력이 있는 환자, 두개내압 상승과 관련된 두부의 기질적 장애나 손상이 있는 환자, 중증 호흡억제 환자, 만성폐질환에 속발한 심부전 환자, 천식발작 지속상태 환자, 심한 중추신경억제 환자, 급성 복부질환 환자, MAO억제제를 투여중이거나 투여중단 후 2주 이내의 환자, 경련상태(경련중첩증, 파상풍, 스트리크닌 중독)에 있는 환자, 급성 알코올중독 환자, 임부 및 임신하고 있을 가능성이 있는 여성, 간장애 환자, 마비성장폐색 환자</td>
            </tr>
            <tr id="KDGERI_HYDROMORPHONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제-정제] <br />∙ 1회 2-4mg씩 4-6시간마다 투여<br />[경구제-서방정] <br />∙ 현재 마약성 진통제를 정기적으로 투여 받고 있는 성인 환자: 1회 4-32mg씩 1일 1회 아침<br />∙ 용량 조절: 2일 단위로 1일 용량의 25-100% 용량 증가<br />∙ 투여 중단: 2일 단위로 50%씩 감량<br />[주사제] <br />∙ 초기 용량: 1회 1-2mg을 4-6시간마다 피하 또는 근육주사</td>
            </tr>
            <tr id="KDGERI_HYDROMORPHONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자는 생리기능이 저하되어 있고, 특히 호흡억제가 일어나기 쉬우므로 투여 시 환자의 상태를 관찰하면서 저용량부터 시작하는 등 신중히 투여해야 함<br />∙ 기침반사를 억제하므로, 폐질환이 있는 환자에게 사용할 때는 주의<br />∙ 졸음, 어지러움 등이 나타날 수 있으므로, 이 약을 투여 중인 환자는 운전 등 위험한 기계조작을 하지 않도록 주의해야 함<br />∙ 췌장염을 포함한 담관계장애, 진전섬망, 전립선비대, 요도협착 환자에 주의하여 사용</td>
            </tr>
            <tr id="KDGERI_HYDROMORPHONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 마약성 진통제, 전신마취제, 페노티아진계 약물, 베타차단제, 중추신경 억제성 항불안제, 수면제, 삼환계 항우울제 또는 다른 중추신경억제제(추가적인 중추신경억제작용 유발) <br />∙ 아편양 수용체의 부분효현제(이 약의 진통 효과 감소, 금단증상 촉진) <br />∙ MAO억제제(고혈압 또는 저혈압 위기가 동반) <br />∙ 마약성 진통제(신경근육차단제의 효과를 증강시켜 과도한 호흡억제 유발 가능)</td>
            </tr>
            <tr id="KDGERI_HYDROMORPHONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>서맥, 고혈압, 정동변화, 다행감, 이상감각, 졸음, 진정, 갈망, 두려움, 중추 억제로 인한 호흡저하, 오심, 구토, 심계항진, 말초부종, 보행이상, 호전전행동, 간효소수치증가, 감기증상</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_MEPERIDINE" data-drug-number="54">
          <thead>
            <tr>
              <th className="drug-number">54</th>
              <th className="drug-name">메페리딘(Meperidine) =페치딘(Pethidine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">합성마약</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_MEPERIDINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>격렬한 통증의 완화, 진정, 진경, 마취전 투약, 마취시의 보조, 무통 분만</td>
            </tr>
            <tr id="KDGERI_MEPERIDINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>중증 호흡억제 환자, 중증 간ㆍ신장애 환자, 두개내압 상승과 관련된 두부의 기질적 장애나 손상이 있는 환자, 담낭의 쏘는 통증 및 담낭수술 후의 통증, 이 약 및 이 약의 구성성분, 다른 아편계 약물에 대한 과민반응이 있는 환자, MAO억제제를 투여 중이거나 투여중단 후 2주 이내의 환자, 만성폐질환에 속발한 심부전 환자, 경련상태(경련중첩증, 파상풍, 스트리크닌 중독)에 있는 환자, 급성 알코올중독 환자, 갈색세포종 환자, 혼수 상태의 환자, 마비성장폐색으로 진단되었거나 의심되는 환자, 항생제 사용과 관련된 위막성 대장염 환자 또는 독성물질에 의해 설사가 발생한 환자, 리토나비어, 셀레길린을 투여 중인 환자</td>
            </tr>
            <tr id="KDGERI_MEPERIDINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[주사제] <br />∙ 격렬한 동통시 진통/진정/진경: 1회 35-50mg 피하 또는 근육주사 후 필요시3-4시간마다 반복<br />∙ 마취전 투약: 마취30분-1시간 30분전에 50-100mg 피하 또는 근육주사<br />∙ 전신마취보조시: 10mg/ml로 희석해 10-15mg씩 간헐적 정주, 최대 투여량: 50mg <br />∙ 무통분만시: 자궁입구가 손가락 두 마디 정도 열린 시기부터 완전히 열린 시기에 50-100 mg, 필요시 3-4시간마다 35-70mg씩 1-2회 추가 주사</td>
            </tr>
            <tr id="KDGERI_MEPERIDINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers Criteria 해당 품목: 신경 독성 유발가능성 있고, 더 안전한 대체약이 있으므로 사용을 피해야 함<br />∙ 일반적으로 고령자는 생리기능이 저하되어 있고, 특히 호흡억제가 일어나기 쉬우므로 투여 시 환자의 상태를 관찰하면서 저용량부터 시작하는 등 신중히 투여해야 함<br />∙ 간ㆍ신장애 환자, 호흡억제 환자, 천식발작 지속상태 환자, 갑상샘저하증, 부신피질기능저하증(에디슨씨병 등), 심방조동, 상실성빈맥, 심근경색이 있는 환자, 쇠약자, 신생아, 영아, 전립선비대에 의한 배뇨장애, 요도협착, 요관수술 후의 환자에게 신중투여해야 함<br />∙ 장기 투여시 간 대사산물인 노르메페리딘의 축적으로 불안, 정서변화, 진전, 근경련증, 경련 등이 나타날 수 있음<br />∙ 저혈압을 유발할 수 있어 저혈량이 의심되는 환자에게는 주의하여 사용<br />∙ 췌장염을 포함한 담관계장애에 주의하여 사용<br />∙ 진전섬망에 주의하여 사용<br />∙ 고용량에서 발작 유발 가능</td>
            </tr>
            <tr id="KDGERI_MEPERIDINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 병용금기: Moclobemide, Selegiline, Toloxatone <br />∙ MAO억제제(고혈압 또는 저혈압 위기) <br />∙ 셀레길린(고열, 중추신경계 독성) <br />∙ 다른 마약성 진통제, 전신마취제, 베타차단제, 페노티아진계 약물, 중추신경 억제성 항불안제, 수면제, 삼환계 항우울제 또는 다른 중추신경억제제(중추신경억제작용 유발, 호흡억제, 저혈압, 깊은 진정효과 또는 혼수) <br />∙ 항콜린제(마비성장폐색까지 갈 수 있는 심한 변비 또는 소변축적) <br />∙ 시메티딘(이 약의 대사 방해) <br />∙ 시프로플록사신(혈중농도 감소)</td>
            </tr>
            <tr id="KDGERI_MEPERIDINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>의존성, 호흡억제, 착란, 건망, 도취감, 불쾌감, 불안, 구갈, 오심, 구토, 서맥, 심정지, 섬망, 발진, 요정체, 전진</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_MORPHINE" data-drug-number="55">
          <thead>
            <tr>
              <th className="drug-number">55</th>
              <th className="drug-name">모르핀(Morphine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">합성마약</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_MORPHINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제]심한 통증의 완화[주사제]정맥내, 경막외 또는 수막강내로 투여하는 마약성 진통제로서 비마약성 진통제에 반응하지 않는 통증의 완화</td>
            </tr>
            <tr id="KDGERI_MORPHINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 및 이 약의 구성성분에 대한 과민반응 및 그 병력이 있는 환자, 중증 호흡억제 환자, 천식발작 지속상태 환자, 심한 중추신경억제 환자, 만성폐질환에 속발한 심부전 환자, 부정맥 환자, 두개내압 상승과 관련된 뇌의 기질적장애가 있는 환자, 급성 알코올중독 환자, 진전섬망 환자, 경련상태 있는 환자, 복부외과수술, 담도수술 후의 환자, MAO억제제를 투여 중이거나 투여중단 후 2주 이내의 환자, 마비성장폐색 또는 그 위험이 있는 환자, 출혈성대장염 환자, 중증 간ㆍ신장애 환자, 수술 전 또는 수술 후 24시간 이내의 환자</td>
            </tr>
            <tr id="KDGERI_MORPHINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제-정제] <br />∙ 1회 15-30mg씩 4시간마다 투여<br />[경구제-서방정] <br />∙ 1회 10-20mg씩 1일 2회, 씹지 않고 그대로 복용<br />[주사제] <br />∙ 피하주사 또는 근육주사: 1회 10mg씩 4시간마다 투여, 1회 투여량은 환자의 반응 및 요구에 따라 5-20mg의 범위에서 투여<br />∙ 정맥주사: 1회 4-10mg을 4-5분에 걸쳐 천천히 투여, 필요에 따라 4시간마다 투여</td>
            </tr>
            <tr id="KDGERI_MORPHINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자는 생리기능이 저하되어 있고, 특히 호흡억제가 일어나기 쉬우므로 투여 시 환자의 상태를 관찰하면서 저용량부터 시작하는 등 신중히 투여해야 함<br />∙ 장기 투여하면 내성 및 의존성이 나타날 수 있음<br />∙ 졸음, 어지러움 등이 나타날 수 있으므로, 이 약을 투여 중인 환자는 운전 등 위험한 기계조작을 하지 않도록 주의해야 함<br />∙ 몰핀은 히스타민을 분비하여 말초혈관확장, 저혈장, 반응성 빈맥을 보일 수 있으나 서서히 투여하거나 용량을 나누어 투여하여 이러한 부작용을 감소시킬 수 있음. <br />∙ 심근경색이 있는 환자에서 변비가 동반시 문제가 될 수 있으므로 완화제를 함께 사용<br />∙ 저혈압을 유발할 수 있어 저혈량이 의심되는 환자에게는 주의하여 사용<br />∙ 췌장염을 포함한 담관계장애: 주의하여 사용<br />∙ ICP: 호흡저하로 인한 이산화탄소 저류로 ICP악화가능<br />∙ 전립선비대, 요저류: 주의<br />∙ 고용량에서 발작 유발 가능</td>
            </tr>
            <tr id="KDGERI_MORPHINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 마약성 진통제, 전신마취제, 페노티아진계 약물, 베타차단제, 중추신경 억제성 항불안제, 수면제, 삼환계 항우울제 또는 다른 중추신경억제제(추가적인 중추신경억제작용 유발) <br />∙ 경구용 항응고제(와르파린)(쿠마린계 작용 증강)항콜린제(마비성장폐색으로 진전될 수 있는 심한 변비 또는 소변축적)아편양 수용체의 부분효현제(이 약의 진통 효과 감소, 금단증상 촉진) MAO억제제(고혈압 또는 저혈압 위기가 동반)시메티딘(이 약의 대사 억제)근골격계</td>
            </tr>
            <tr id="KDGERI_MORPHINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>서맥, 저혈압, 졸음, 어지럼증, 열, 혼돈, 두통, 두드러기, 변비, 오심, 구토, 뇨저류, 빈혈, 산소포화도 감소, 가려움증, 심방세동, 흉동, 부종, 빈맥, 기억상실, 피부건조, 관절통, 백혈구감소증, 저칼륨혈증</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_OXYCODONE" data-drug-number="56">
          <thead>
            <tr>
              <th className="drug-number">56</th>
              <th className="drug-name">옥시코돈(Oxycodone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">합성마약</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_OXYCODONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>마약성 진통제의 사용을 필요로 하는 중등도 및 중증 통증의 조절</td>
            </tr>
            <tr id="KDGERI_OXYCODONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>옥시코돈에 과민증의 병력이 있는 환자, 호흡저하 환자나 생명을 위협하는 호흡저하 위험이 증가된 환자, 급성 또는 중증의 천식, 탄산과잉증인 환자, 마비성 장폐쇄증 및 위장관계 폐색으로 확진되었거나 의심되는 환자, 중증의 만성폐쇄성폐질환, 폐성심</td>
            </tr>
            <tr id="KDGERI_OXYCODONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 초회 투여량: 이전에 마약성 진통제를 복용한 적이 없는 환자 – 1회 10mg씩 1일 2회<br />∙ 개인별 용량 조절: 혈장 중 약물농도는 약 24-36시간 이내에 steady state에 도달하므로 1-2일마다 용량 조절<br />[주사제] <br />∙ 통증자가조절법(patient-controlled analgesia: PCA)을 이용한 정맥 투여0.9% 생리식염수에 1mg/ml 농도가 되도록 희석 → 2mg 정맥주사하여 통증 안정화 → 최소 5분의 휴지기를 가지고, 필요에 따라 1mg을 PCA를 이용하여 투여</td>
            </tr>
            <tr id="KDGERI_OXYCODONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자에서 옥시코돈의 청소율이 약간 감소하므로, 신중하게 용량을 조절해야 함<br />∙ 호흡저하, 두부손상, 저혈압, 급성 알코올중독, 부신피질 부전증, 갑상선기능 부전증, 전립선 비대, 요도관 협착, 췌장 및 담관 질환시, 중증의 간/폐/신기능 장애 환자는 신중투여<br />∙ 심근경색이 있는 환자에서 변비가 동반시 문제가 될 수 있으므로 완화제를 함께 사용<br />∙ 췌장염을 포함한 담관계장애: 주의하여 사용<br />∙ 전립선비대, 요저류: 악화<br />∙ 고용량에서 발작 유발 가능</td>
            </tr>
            <tr id="KDGERI_OXYCODONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 항불안제, 마취제, 수면제, 항우울제, 진정제, 페노티아진, 신경이완제, 알코올, 그 밖의 아편유사제, 근육이완제 및 항고혈압제(중추신경계 억제효과 강화) <br />∙ 모노아민 산화효소(MAO) 억제제(중추신경 흥분 또는 억제) <br />∙ CYP3A4 억제제(옥시코돈의 혈장농도 증가) <br />∙ CYP3A4 유도제(옥시코돈의 혈장농도 감소)</td>
            </tr>
            <tr id="KDGERI_OXYCODONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>식욕부진, 신경질, 불면, 기면, 발열, 혼란, 설사, 복통, 소화불량, 구역, 구토, 발적, 불안, 다행증, 호흡곤란, 기립성 저혈압, 오한, 단일수축, 위염, 이상한 꿈, 비정상적 사고, 기관지경련, 기침증가 및 딸꾹질, 쇠약감</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_REMIFENTANIL" data-drug-number="57">
          <thead>
            <tr>
              <th className="drug-number">57</th>
              <th className="drug-name">레미펜타닐(Remifentanil)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">합성마약</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_REMIFENTANIL_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>마취유도 및/또는 마취유지의 진통, 기계적 환기를 실시중인 중환자의 진통 및 진정(18세 이상)</td>
            </tr>
            <tr id="KDGERI_REMIFENTANIL_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>경막외 및 경막내 투여 금기, 이 약의 성분 및 다른 펜타닐 유사제제에 과민증의 기왕력 환자, 마취유도의 목적으로 단독 투여해서는 안 됨</td>
            </tr>
            <tr id="KDGERI_REMIFENTANIL_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[주사제] &lt;일반마취&gt; <br />∙ 마취유도: 1mcg/kg bolus → 0.5-1mcg/kg/min continuous infusion <br />∙ 환기된 환자의 마취유지- NO2 (66%): 0.5-1mcg/kg bolus → 초기유지 0.4mcg/kg/min, 이후 0.1-2mcg/kg/min- isoflurane (초회용량 0.5 MAC): 0.5-1mcg/kg bolus → 초기 투여속도 0.25mcg/kg/min, 유지속도 0.05-2mcg/kg/min- Profopol (초회용량 100mcg/kg/min): 0.5-1mcg/kg bolus → 초기 투여속도 0.25mcg/kg/min, 유지속도 0.05-2mcg/kg/min- 정맥내 단회주입시 30초 이상 투여<br />∙ 투여중단 기준: 투여중단 후 5-10분 이내에 잔류 아편양 효과는 나타나지 않음&lt;중환자실&gt; <br />∙ 기계적 환기 중인 중환자실 환자의 진통 및 진정을 위해서 이 약을 초기에 단독투여할 수 있음초기투여속도: 0.1-0.15mcg/kg/분(6-9mcg/kg/h), 이후 0.025mcg/kg/분(1.5mcg/kg/시간)의 증가속도로 주입속도 조절<br />∙ 65세 이상: 권장량의 1/2</td>
            </tr>
            <tr id="KDGERI_REMIFENTANIL_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 호흡기능과 심혈관 기능을 관찰하고 보조할 수 있는 장치가 충분히 갖추어진 곳에서만 투여해야 함<br />∙ 강력한 아편양제제의 예상되는 이상반응을 인지할 수 있고 인공호흡 및 심폐소생술 등으로 그 이상반응을 처치할 수 있는 마취제 사용에 숙련된 의사에 의해서만 투여되어야 함<br />∙ 심근경색이 있는 환자에서 변비가 동반시 문제가 될 수 있으므로 완화제를 함께 사용<br />∙ 췌장염을 포함한 담관계장애: 주의하여 사용<br />∙ 전립선비대, 요저류: 악화<br />∙ 고용량에서 발작 유발 가능</td>
            </tr>
            <tr id="KDGERI_REMIFENTANIL_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ CNS 억제제(CNS 억제제와 관련된 이상반응 발생 증가) <br />∙ β-차단제, 칼슘 채널 차단제(저혈압 및 서맥 부작용 악화)</td>
            </tr>
            <tr id="KDGERI_REMIFENTANIL_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>골격근 강직, 서맥, 저혈압, 급성 호흡억제, 무호흡, 구역, 구토, 가려움증, 수술 후 떨림 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_SUFENTANIL" data-drug-number="58">
          <thead>
            <tr>
              <th className="drug-number">58</th>
              <th className="drug-name">수펜타닐(Sufentanil)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">합성마약</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_SUFENTANIL_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>전신 마취시 진통제, 100% 산소와 병행해서 다음과 같은 환자의 마취유도 및 유지를 위한 마취제 심혈관이나 신경외과 분야 등의 대수술을 받고 있는 환자</td>
            </tr>
            <tr id="KDGERI_SUFENTANIL_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>본 제에 과민증이 있는 환자</td>
            </tr>
            <tr id="KDGERI_SUFENTANIL_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[주사제] <br />∙ 전신마취 진통제로 사용시 8mcg/kg까지 천천히 투여<br />∙ 마취의 유도 및 유지를 위한 마취제로 사용시 8mcg/kg 이상을 천천히 투여 <br />∙ 벤조디아제핀, 바르비튜레이트, 흡입마취제, 다른 마약이나 중추신경 억제제를 병용시는 본제 또는 이들 약물의 용량을 감소해야 함</td>
            </tr>
            <tr id="KDGERI_SUFENTANIL_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 폐질환자, 호흡여량이 감소되었거나 잠재적으로 호흡이 위태로운 환자, 간이나 신기능 장애환자, 뇌손상 환자에게 신중 투여<br />∙ 서맥, 뇌압상승 악화 가능</td>
            </tr>
            <tr id="KDGERI_SUFENTANIL_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 전신마취제 및 중추신경 억제약물(중추신경계 및 심혈관계에 대한 효과의 강도 및 지속시간 또는 호흡억제가 증가) <br />∙ 칼슘길항제 및 베타차단제(서맥과 저혈압 정도 및 발현율 증가)</td>
            </tr>
            <tr id="KDGERI_SUFENTANIL_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>호흡억제, 골격근 강직, 저혈압, 고혈압, 흉벽강직, 서맥, 가려움중, 졸림</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ALENDRONATE" data-drug-number="59">
          <thead>
            <tr>
              <th className="drug-number">59</th>
              <th className="drug-name">알렌드론산(Alendronate)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">골대사제제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ALENDRONATE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>폐경후 여성의 골다공증 치료, 남성의 골다공증 치료, 남성과 여성의 글루코코르티코이드에 의한 골다공증 치료</td>
            </tr>
            <tr id="KDGERI_ALENDRONATE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>본 약제 과민성, 식도 배출 장애로 인한 식도 질환, 저칼슘혈증, 30분간 앉아 있거나 서있을 수 없을 경우, 흡인위험이 있는 경우</td>
            </tr>
            <tr id="KDGERI_ALENDRONATE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 아침기상 후 공복에 충분한 음료수와 함께 복용<br />∙ 폐경후 여성의 골다공증 및 남성의 골다공증 치료: 1회 70mg씩 주 1회 또는 1회 10mg씩 1일 1회<br />∙ 남성과 여성의 글루코코르티코이드에 의한 골다공증 치료<br /> - 남성 및 폐경전 여성: 1회 5mg씩 1일 1회<br /> - 호르몬 요법을 받지 않는 폐경후 여성: 1회 10mg씩 1일 1회</td>
            </tr>
            <tr id="KDGERI_ALENDRONATE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 노인에서 용량 조절은 필요 없으나, 많은 노인들이 이뇨제를 복용 중일 가능성이 있으므로 전해질(칼슘, 인, 마그네슘, 칼륨) 상태에 대한 주기적평가가 필요할 수 있음<br />∙ 식도자극 부작용을 피하기 위해 복용시 충분한 음료수와 함께 투여하고, 취침 전 투여를 피하고 아침 기상 후 투여하며, 투여 후 최소 1시간 동안 상체를 일으킨 자세를 유지해야 함<br />∙ 광천수를 포함한 다른 음료나 음식, 약물을 동시복용하면 이 약물의 체내흡수가 저하되어 효과가 감소할 수 있음<br />∙ 골절 위험이 낮은 골다공증 환자의 경우 3~5년 투약 후 중단 CrCl&lt;35mL/min인 신부전 환자는 투여를 피하도록 권고</td>
            </tr>
            <tr id="KDGERI_ALENDRONATE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 칼슘보충제/제산제(이 약의 흡수 방해하므로 이 약 복용후 적어도 30분의 간격을 두고 다른 약물을 복용해야 함) <br />∙ 아스피린(상부위장관 이상반응 발생 증가)</td>
            </tr>
            <tr id="KDGERI_ALENDRONATE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>복통, 구역, 소화불량, 변비, 설사, 방귀, 식도 궤양, 구토, 근골격 통증, 근경련, 두통, 어지러움, 미각이상, 저칼슘혈증, 저인산혈증, 악골괴사</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_RALOXIFENE" data-drug-number="60">
          <thead>
            <tr>
              <th className="drug-number">60</th>
              <th className="drug-name">라록시펜(Raloxifene)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">골대사제제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_RALOXIFENE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>폐경 후 여성의 골다공증 치료 및 예방</td>
            </tr>
            <tr id="KDGERI_RALOXIFENE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 과거력상 또는 현재 정맥 혈전 색전증이 있는 환자, 간장애, 중증 신장애, 원인을 알 수 없는 자궁출혈, 자궁내막암의 징후 또는 증상이 있는 환자, 장기부동상태에 있는 환자, 항인지질항체증후군 환자</td>
            </tr>
            <tr id="KDGERI_RALOXIFENE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 60mg씩 1일 1회</td>
            </tr>
            <tr id="KDGERI_RALOXIFENE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 정맥혈전색전증, 표재성 정맥혈전염 발현의 위험성이 호르몬대체요법과 유사<br />∙ 주로 간에서 대사되므로 간기능 부전 환자에 대한 안정성과 유효성을 평가하기 전에는 투여 권장되지 않음<br />∙ 폐경 전 여성에 대한 적응증 없음<br />∙ 관상동맥 질환이 있거나 위험이 높은 사람에게 뇌졸중으로 인한 사망이 증가하므로 신중 투여 <br />∙ 전신 에스트로겐과의 병용 사용 권장되지 않음</td>
            </tr>
            <tr id="KDGERI_RALOXIFENE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 디아제팜, 디아족시드, 리도카인 같은 단백결합력 높은 약물(단백결합에 영향을 미침) <br />∙ 콜레스티라민(이 약의 흡수와 장간순환을 유의하게 감소) <br />∙ 암피실린(이 약의 최고농도 감소) <br />∙ 레보싸이록신(레보싸이록신의 흡수 감소)</td>
            </tr>
            <tr id="KDGERI_RALOXIFENE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>말초부종, 홍조, 관절염, 인플루엔자유사증후군, 감염, 흉통, 정맥혈전색전증, 불면증, 발진, 체중 증가, 구토, 부비동염, 폐렴, 하지 근육 연축, 유방통, 복통, 복부팽만, 담성, 위장염, 질출혈, 대하증, 요로 질환, 자궁 질환, 근육통, 기관지염, 후두염, 발한</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_RISEDRONATE" data-drug-number="61">
          <thead>
            <tr>
              <th className="drug-number">61</th>
              <th className="drug-name">리세드론산(Risedronate)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">골대사제제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_RISEDRONATE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>폐경 후 여성의 골다공증 치료와 예방, 남성의 골다공증 치료, 장기적으로 전신적인 코르티코스테로이드 치료를 받는 남녀 환자의 골밀도 유지 또는 증가</td>
            </tr>
            <tr id="KDGERI_RISEDRONATE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>식도협착 또는 무이완증 같이 식도 배출을 지연시키는 식도이상 환자, 이 약 과민증, 비스포스포네이트(bisphosphanates) 과민증, 저칼슘혈증,이 약 투여 후 최소 30분간 앉거나 서있지 못하는 자, 중증 신장애 환자(크레아티닌청소율 30mL/min 미만)</td>
            </tr>
            <tr id="KDGERI_RISEDRONATE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1회 35mg씩 주 1회 또는 1회 5mg씩 1일 1회</td>
            </tr>
            <tr id="KDGERI_RISEDRONATE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자와 젊은 환자 사이에 안전성과 유효성은 차이가 없음<br />∙ 비스포스포네이트(bisphosphanates)는 연하곤란(dysphagia), 식도궤양, 위궤양 초래가능<br />∙ 저칼슘혈증이 있을 경우 이 약물 투여전 반드시 교정되어야 함. 적정량의 칼슘 및 비타민 D 섭취가 요구됨<br />∙ CrCl&gt;30mL/min인 신부전 환자는 용량조절이 필요없으나, CrCl&lt;30mL/min인 신부전 환자는 투여를 피하도록 권고<br />∙ 골절 위험이 낮은 골다공증 환자의 경우 3~5년 투약 후 중단.</td>
            </tr>
            <tr id="KDGERI_RISEDRONATE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 칼슘보충제, 제산제, 다가 양이온(칼슘, 마그네슘, 철, 알루미늄) (이 약의 흡수 방해하므로 이 약 복용후 적어도 30분의 간격을 두고 다른 약물을 복용해야 함) <br />∙ H2길항제(이 약의 농도 증가)</td>
            </tr>
            <tr id="KDGERI_RISEDRONATE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>고혈압, 두통, 피부 발진, 설사, 오심, 복통, 감염, 관절염, 요통, 말초 부종, 우울증, 어지럼증, 변비, 구토, 위장 천공, 궤양, 출혈, 부갑상선 호르몬 증가, 저칼슘혈증, 저인산혈증, 소화불량, 양성전립선비대증, 요로결석, 급성기반응양증후군, 백내장, 독감유사 증후군, 후두염, 비염, 기관지염, 상기도염, 골절, 골성 통증, 악골괴사</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PREDNISOLONE" data-drug-number="62">
          <thead>
            <tr>
              <th className="drug-number">62</th>
              <th className="drug-name">프레드니솔론(Prednisolone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">부신호르몬제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PREDNISOLONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>∙ 내분비 장애 : 원발성 및 속발성 부신피질기능부전증, 선천성 부신이상증식, 암에 수반된 고칼슘혈증, 비화농성 갑상선염<br />∙ 류마티스성 장애: 급성진행 또는 악화를 방지하기 위한 단기투여용 보조요법으로서 다음의 질환(류마티스 관절염, 강직성 척추염) <br />∙ 교원성 질환: 악화 중에 있거나 유지요법이 필요한 다음의 질환: 전신성 홍반성 루푸스, 전신성 피부근염(다발성근염), 급성 류마티스성 심염<br />∙ 피부 질환 : 천포창, 수포성 포진양 피부염, 중증 다형성 홍반(피부점막안 증후군(Stevens-Johnson Syndrome)), 중증 건선, 중증 지루성 피부염, 균상식육종<br />∙ 중증 알레르기성 질환으로서 일반적인 처치로는 반응이 없는 다음의 질환 : 기관지 천식, 접촉성 피부염, 아토피성 피부염, 계절성 알레르기성 비염, 혈청병, 약물 과민반응<br />∙ 중증 급만성 알레르기성 또는 염증성인 눈 및 그 부속기관에 관련되는 다음의 질환 : 홍채모양체염,맥락망막염, 후부의 산재성 포도막염, 시신경염,알레르기성 결막염, 각막염<br />∙ 위장관계 질환: 궤양성 대장염, 국한성 장염<br />∙ 호흡기계 질환: 증후성 사르코이드증, 전격성 또는 파종성 폐결핵(적절한 항결핵 화학요법제와 병용투여) <br />∙ 혈액 질환: 후천성(자가면역성) 용혈성 빈혈, 성인의 특발성 중증 면역질환의 혈소판감소성 자반증, 적아구감소증<br />∙ 종양성 질환: 성인의 백혈병 및 림프종<br />∙ 부종성 질환: 홍반성 루푸스로 인한 신증후에 있어서 배뇨증가와 유도 및 단백뇨의 완화<br />∙ 신경계 질환: 다발성 경화증의 급성악화<br />∙ 기타: 결핵성 수막염</td>
            </tr>
            <tr id="KDGERI_PREDNISOLONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>유효한 항균제가 없는 감염증, 유효한 항균제가 없는 전신 진균 감염증, 프레드니손 과민증 및 그 병력자, 단순포진, 대상포진, 수두 환자, 생백신 투여 환자</td>
            </tr>
            <tr id="KDGERI_PREDNISOLONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 1일 5-60mg을 1-4회 분할 투여<br />∙ 최소효과 용량 사용, 일부 질환 및 장기간 투여시 격일 투여 고려<br />∙ 장기간 투여 후 중단시 점진적으로 감량하여 중단<br />∙ 수술 또는 감염 등 생리적 부담이 증가하는 스트레스 상황을 겪을 때는 증량해서 투여</td>
            </tr>
            <tr id="KDGERI_PREDNISOLONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 전신적 투여시 특히 주의필요. 최소 유효 용량을 최단 기간 사용하도록 권고<br />∙ 장기 사용 시 골밀도 측정하여 골다공증 및 골절 예방</td>
            </tr>
            <tr id="KDGERI_PREDNISOLONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다형성 심실빈맥(Torsades de Pointes)을 일으킬 수 있는 약물(에리트로마이신 IV, 할로판트린, 펜타미딘, 스파르플록사신, 빈카민, 설토프리드)과 병용금기<br />∙ 다형성 심실 빈맥을 일으킬 수 있는 항부정맥제(아미오다론, 디소피라미드, 퀴니딘, 소탈올) (서맥, QT 간격연장, 저칼륨혈증) <br />∙ 바르비탈계 약물(페노바르비탈), 페니토인, 리팜피신, 카르바마제핀, 프리미돈, 아미노글루테치미드, 리파부틴(이 약의 작용 감소) <br />∙ 비스테로이드성 소염제(위장관 궤양 위험 증가) <br />∙ 항응고제, 혈당강하제(효과 감소) <br />∙ 이뇨제(칼륨보존성 이뇨제는 제외), 암포테리신 B, 카르베노졸론, 완화제(저칼륨혈증) <br />∙ 디곡신(부정맥, 저칼륨혈증과 관련된 독성 증가) <br />∙ 이소니아지드(혈중농도 감소) <br />∙ 제산제(코르티코이드의 위장관 흡수 방해하므로 투여간격 2시간 이상) <br />∙ 혈압강하제(혈압강하효과 감소) <br />∙ 알파인터페론(인터페론 활성 억제) <br />∙ 사이클로스포린(사이클로스포린의 혈중농도 상승) <br />∙ 비탈분극성 근이완제(근이완 작용 감소 또는 증가) <br />∙ 클로로퀸, 히드록시클로로퀸(근병증, 심근증 발생위험 증가)</td>
            </tr>
            <tr id="KDGERI_PREDNISOLONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>∙ 감염증: 감염증 유발 및 악화<br />∙ 내분비계: 부신피질자극호르몬 분비억제, 속발성 부신피질기능부전, 당뇨병, 월경이상, 쿠싱증후군(월상안), 소아의 성장억제, 내당력 감소, buffalo hump 등<br />∙ 소화기계: 소화성 궤양, 췌장염, 설사, 구역, 구토, 위통, 가슴쓰림, 복부팽만감, 구갈, 식욕부진, 식욕항진 등<br />∙ 정신신경계: 정신장애, 우울증, 다행감, 불면, 두통, 어지러움, 경련, 보통 치료 후에 나타나는 유두부종을 수반한 뇌압상승(가뇌종양) 등<br />∙ 근골격계: 골다공증, 대퇴골 및 상완골 말단의 무균성 괴사, 근병증, 척추압박골절, 근육실질의 손실, 장골의 병리적 골절, 근육통, 관절통, 관절의 불안정화, 종양, 압통의 악화 등<br />∙ 지질단백질 대사: 음성질소평형, 지방간 등<br />∙ 체액전해질: 부종, 체액저류, 나트륨저류, 칼륨손실, 감수성환자에 있어서 울혈성 심 부전, 혈압상승, 저칼륨성 알칼리혈증 등<br />∙ 눈: 연용에 의해 안압상승, 녹내장, 후낭하 백내장(증상 : 눈이 희미해짐), 중심성 장액성 망맥락막증다발성 후극부 망막색소상피증(증상 : 시력저하, 사물이 비뚤어지게 보이거나, 작게 보이거나, 시야중심이 비뚤어져 보이지 않게 됨, 중심성 장액성 망맥락막증은 국한적인 망막박리가 보이고 진행하면 광범한 망막박리가 생기는 다발성 후극부 망막색소상피증이 됨), 중심성 장액성 맥락망막증 등에 의해 망막장애, 안구돌출 등<br />∙ 혈액: 백혈구 증가, 혈전증 등<br />∙ 심장: 심근경색, 뇌경색, 동맥류<br />∙ 피부: 여드름, 다모, 탈모, 색소침착, 점상 출혈 및 반상 출혈, 피하 일혈, 자반, 선조, 가려움, 발한 이상, 안면 홍반, 창상 치유 지연, 얇고 연약한 피부 등<br />∙ 과민증: 과민 증상<br />∙ 심혈관계 : 심근병증, 울혈성심부전, 고혈압<br />∙ 호흡기계 : 코피</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_CALCITRIOL" data-drug-number="63">
          <thead>
            <tr>
              <th className="drug-number">63</th>
              <th className="drug-name">칼시트리올(Calcitriol)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">비타민A및D제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_CALCITRIOL_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제]만성신부전증 환자 중 투석치료단계 이전 환자: 만성신부전증이 중등도 내지 중증(크레아티닌청소율 15～55 mL/min)이며 투석치료단계 이전인 환자의 2차성 부갑상선기능항진증과 결과적으로 나타나는 대사성 골질환의 치료, 혈액투석 환자의 신성 뼈형성장애, 부갑상선기능저하증(수술후, 특발성 또는 가성 부갑상선기능저하증), 구루병･골연화증(비타민 D 의존성 구루병, 저인산혈증성 비타민 D 저항성 구루병), 골다공증[주사제]만성신장투석환자의 저칼슘혈증의 관리, 상승된 부갑상선호르몬치의 감소, 신성 골이영양증의 개선</td>
            </tr>
            <tr id="KDGERI_CALCITRIOL_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>고칼슘혈증과 관련된 모든 질환자, 고칼슘뇨증에 의한 칼슘결석 환자, 이 약(또는 같은 계열의 약물)이나 이 약에 포함된 성분에의 과민반응 환자, 비타민 D 독성발현의 증후가 있는 환자, 1차성 부갑상선기능항진증 환자</td>
            </tr>
            <tr id="KDGERI_CALCITRIOL_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 투석치료단계 이전 환자: 1일 0.25㎍, 필요시 1일 0.5㎍으로 증량 가능<br />∙ 신성 뼈형성장애(투석환자): 1일 0.25㎍, 혈청 칼슘수치가 정상범위 또는 약간 저하된 환자는 0.25㎍ 격일 투여<br />∙ 골다공증: 1회 0.25㎍씩 1일 2회, 치료반응이 없는 경우 1개월 간격으로 증량하며, 최대 1회 0.5㎍씩 1일 2회까지 증량 가능<br />∙ 부갑상선 기능저하증, 구루병, 골연화증: 1회 0.25㎍씩 1일 1회, 치료반응이 없는 경우 2-4주 간격으로 증량<br />[주사제] <br />∙ 초기 용량: 1회 0.01㎍/kg씩 주 3회 격일 투여<br />∙ 치료반응이 없는 경우 2-4주 간격으로 0.25-0.5㎍ 증량<br />∙ 혈액투석환자: 1회 0.01-0.05㎍/kg씩 주 3회 <br />∙ 용량 조절기간 동안에는 주 2회 이상 혈청칼슘수치를 측정해야 하며, 고칼슘혈증 또는 혈청 creatinine이 증가할 경우 혈청 칼슘수치가 정상범위내로 회복될 때까지 투여를 중단하고 매일 혈청 칼슘 및 인 수치를 측정함. 정상수치로 회복되면 기존 용량보다 0.25㎍ 적은 용량으로 치료를 재시작할 수 있음</td>
            </tr>
            <tr id="KDGERI_CALCITRIOL_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ serum calcium-phosphate product가 70을 초과하지 않도록 칼슘섭취를 적정량 유지해야 함. 과량투여시 고칼슘혈증 (Hypercalcemia)과 고칼슘뇨증 (hypercalciuria) 유발가능. <br />∙ 저알부민혈증(혈청 알부민 수치&lt;4.0g/dL) 동반된 경우 혈청칼슘수치는 보정칼슘수치를 기준으로 판단함. 보정칼슘수치 계산식은 아래와 같음. <br />∙ 보정칼슘수치(mg/dL)=혈청 칼슘수치(mg/dL)-혈청알부민수치(g/dL)+4.0 <br />∙ 간기능 저하시 투여 권고하지 않음</td>
            </tr>
            <tr id="KDGERI_CALCITRIOL_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 비타민 D 및 유도체(상가작용 및 고칼슘혈증) <br />∙ 티아지드계 이뇨제(칼슘의 요중 배설을 감소시켜 고칼슘혈증 위험 증가) <br />∙ 디곡신(고칼슘혈증으로 인한 심부정맥 야기 가능) <br />∙ 코르티코스테로이드(기능적 길항관계) <br />∙ 마그네슘 함유제제(장기 신장투석 환자의 경우 고마그네슘혈증)근골격계<br />∙ 바르비탈계 약물 또는 항전간제(이 약의 대사가 증가하여 혈청 농도 감소) <br />∙ 콜레스티라민 및 세벨라머를 포함하는 담즙산 결합수지나 사하제인 미네랄 오일(이 약의 장관 흡수 저하) <br />∙ 알루미늄 하이드록시드, 수크랄페이트(혈중 알루미늄 농도 상승)</td>
            </tr>
            <tr id="KDGERI_CALCITRIOL_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>심부정맥, 고혈압, 어지럼증, 두통, 두드러기, 발진, 탈수, 고칼슘혈증, 복통, 식욕부진, 변비, 오심, 결막염 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ALPRAZOLAM" data-drug-number="64">
          <thead>
            <tr>
              <th className="drug-number">64</th>
              <th className="drug-name">알프라졸람(Alprazolam)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ALPRAZOLAM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>불안장애의 치료 및 불안증상의 단기완화, 우울증에 수반하는 불안, 정신신체장애(위･십이지장궤양, 과민성대장증후군, 자율신경실조증)에서의 불안･긴장･우울･수면장애, 공황장애, 갈락토오스 불내성, Lapp 유당분해효소 결핍증 또는 포도당-갈락토오스 흡수장애 등의 유전적인 문제가 있는 환자</td>
            </tr>
            <tr id="KDGERI_ALPRAZOLAM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약이나 이 약에 포함된 다른 성분 또는 다른 벤조디아제핀계 약물에 과민증 환자, 급성 폐쇄각녹내장 환자, 케토코나졸, 이트라코나졸을 투여받고 있는 환자, 중증의 근무력증 환자, 중증의 호흡부전 환자(드물게 중증의 폐질환 환자에게서 치료 초기에 이 약에 의한 사망이 보고되었다.), 중증의 간부전 환자, 정신병적 특징이 있는 우울증, 양극성 장애 또는 내인성 우울(예: 심한 우울증으로 입원 환자)이 있는 우울증 환자, 수면 무호흡증 환자, 알코올 또는 약물의존성 환자, 임신 후기 부인, 갈락토오스 불내성, Lapp 유당분해효소 결핍증 또는 포도당-갈락토오스 흡수장애 등의 유전적인 문제가 있는 환자</td>
            </tr>
            <tr id="KDGERI_ALPRAZOLAM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 불안장애: 1회 0.25mg씩 1일 2-3회로 시작, 부작용이 나타나면 감량함(고령자용량)정신신체장애: 1회 0.4mg씩 1일 1-2회, 1일 최대투여량: 1.2mg(고령자용량)공황장애: 초회 0.5mg씩 1일 1회, 치료반응에 따라 3-4일 간격으로 1mg 이하로 증량, 1일 평균 5-6mg 3-4회 분복(일반용량) <br />[서방정제]초회 1회 0.5mg씩 1일 1회 서서히 증량 가능(고령자용량)용량유지: 1일 1-10mg(일반용량)</td>
            </tr>
            <tr id="KDGERI_ALPRAZOLAM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당약품<br />∙ 고령자는 저용량으로 투여 시작(과다진정, 어지러움, 운동실조 등의 이상반응 위험) <br />∙ 심･간･신장애, 뇌 기질적 장애, 고령자, 쇠약 환자, 중등도의 호흡부전 환자 등 신중투여<br />∙ 위험을 수반하는 기계조작하지 말 것(졸음, 주의력･집중력･반사운동능력 등의 저하) <br />∙ 장기간 치료시 혈액검사, 간기능 검사, 요검사 실시<br />∙ 복용중인 환자의 투여 중지 시에는 천천히 용량을 감소하여야 하며, 보통 3일 간격으로 0.5m이하로 감량<br />∙ 심한 우울증 또는 자살 의도가 있는 환자, 공황장애 환자에게 투여할 경우에는 적절한 처방용량으로 신중하게 투여할 것<br />∙ 우울증 환자에게 투여시 경조증 또는 조증이 보고됨<br />∙ 치료기간: 불안장애는 4개월, 공황장애는 4-10주(최대 8개월) <br />∙ 인지 장애, 섬망, 낙상, 골절, 자동차 사고의 위험 증가로 노인의 불면, 초조, 섬망 치료에는 금기(2012 Beers criteria)</td>
            </tr>
            <tr id="KDGERI_ALPRAZOLAM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 페노티아진계 약물, 바르비탈계 약물, MAO 저해제 및 기타 항우울약, 진정최면제, 마약성 진통제, 마취제, 항경련제, 항히스타민제, 알코올(알프라졸람의 중추억제작용이 증강) <br />∙ 이미프라민, 데시프라민(혈장농도 증가) <br />∙ 사이토크롬 P450 3A4 등 간대사 효소를 저해하는 약물(알프라졸람의 농도와 활성 증가) <br />∙ 카르바마제핀(알프라졸람의 작용 감소) <br />∙ 시사프리드(진정효과 증강) <br />∙ 다른 벤조디아제핀계(약물의존성의 위험성 증가)</td>
            </tr>
            <tr id="KDGERI_ALPRAZOLAM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>운동실조, 인지기능 장애, 우울, 현기, 졸음, 구음장애, 피곤, 과민성, 기억이상, 진정, 성욕감소, 체중증가, 체중감소, 식욕변화, 변비, 구강건조증, 배뇨장애, 비충혈, 흉통, 저혈압, 두근거림, 동빈맥, 실신, 초조, 정좌불능, 혼란, 현실감 상실, 방향감각상실, 집중력 장애, 긴장이상, 공포, 환각, 두통, 수면과잉, 감각저하, 불면, 무기력, 신경과민, 악몽, 이상감각, 발작, 피부염, 발한, 발진, 성욕증가, 월경이상, 복통, 식욕저하, 설사, 소화불량, 오심, 구토, 요실금, 간효소 증가, 관절통, 근육통, 진전, 호흡곤란, 과호흡, 상기도감염 등신경정신계</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_BROMAZEPAM" data-drug-number="65">
          <thead>
            <tr>
              <th className="drug-number">65</th>
              <th className="drug-name">브로마제팜(Bromazepam)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_BROMAZEPAM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>신경증에서의 불안･긴장･우울, 정신신체장애에서의 불안･긴장･우울</td>
            </tr>
            <tr id="KDGERI_BROMAZEPAM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>급성 협우각형 녹내장 환자(안압을 상승시킬 수 있다.), 중증의 근무력증 환자(증상을 악화시킬 수 있다.), 이 약 또는 벤조디아제핀계 약물에 과민증 환자, 급성 폐부전 환자, 중증의 호흡부전 환자, 공포 또는 강박장애 환자, 알코올 또는 약물의존성 환자, 수면무호흡증후군 환자, 유･소아, 갈락토오스 불내성, Lapp 유당분해효소 결핍증 또는 포도당갈락토오스 흡수장애 등의 유전적인 문제가 있는 환자</td>
            </tr>
            <tr id="KDGERI_BROMAZEPAM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>고령자(외래환자): 1회 0.75-1.5mg씩 1일 3회고령자(중증환자, 입원환자): 1회 3-6mg씩 1일 2-3회</td>
            </tr>
            <tr id="KDGERI_BROMAZEPAM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자는 저용량으로 투여 시작(운동실조, 과진정 등의 이상반응 위험)등 신중투여<br />∙ 심･간･신장애, 뇌 기질적 장애, 고령자, 쇠약 환자, 중등도의 호흡부전 환자 등 신중투여<br />∙ 위험을 수반하는 기계조작하지 말 것(졸음, 주의력･집중력･반사운동능력 등의 저하) <br />∙ 우울증이나 우울성 불안에 단독으로 사용 시 자살경향 증가<br />∙ 항불안효과를 목적으로 사용 시 총 치료기간은 4-12주를 넘지 않도록 함<br />∙ 장기간 치료시 혈액검사, 간기능 검사, 요검사 실시</td>
            </tr>
            <tr id="KDGERI_BROMAZEPAM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 페노티아진계 약물, 리튬, 바르비탈계 약물, 최면진정제, 마약성 진통제, 마취제, 항우울약, 항히스타민제, 알코올(브로마제팜의 작용 증강) <br />∙ 디설피람(브로마제팜의 혈중농도 증가) <br />∙ 디곡신(디곡신의 신배설 저하) <br />∙ 히단토인계, 바르비탈계 등 항간질약(브로마제팜의 부작용 및 독성) <br />∙ 시메티딘 등 약물대사효소저해제(진정작용 증강) <br />∙ 리팜피신 등 간효소유도제(브로마제팜의 청소율 증가) <br />∙ 다른 벤조디아제핀계 약물(약물의존성의 위험성 증가)</td>
            </tr>
            <tr id="KDGERI_BROMAZEPAM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>의존성 및 금단증상, 졸음, 휘청거림, 어지러움, 흥분, 기분고양, 보행실조, 불면, 두통, 진전, 구음장애, 초조, 안구진탕, 시력불선명, 백혈구감소, 혈액이혼화증, 혈압저하, 구갈, 식욕부진, 구역, 구토, 변비, 위부불쾌감, 드물게 타액분비과다, 발진, 배뇨곤란, 요실금, 빈뇨, 피로감, 무력감, 근긴장저하 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_CHLORDIAZEPOXIDE" data-drug-number="66">
          <thead>
            <tr>
              <th className="drug-number">66</th>
              <th className="drug-name">클로르디아제폭시드(Chlordiazepoxide)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_CHLORDIAZEPOXIDE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>불안･긴장, 수술전 불안･긴장, 정신신체장애(고혈압, 위･십이지장궤양)에서의 불안･긴장, 알코올 금단증상</td>
            </tr>
            <tr id="KDGERI_CHLORDIAZEPOXIDE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>알코올 또는 약물의존성 환자, 수면무호흡증후군 환자, 급성 협우각형 녹내장 환자, 중증의 근무력증 환자, 이 약 또는 벤조디아제핀계 약물에 과민증 환자, 공포 또는 강박상태 환자, 중증의 호흡부전 또는 호흡저하 환자, 갈락토오스 불내성, Lapp 유당분해효소 결핍증 또는 포도당-갈락토오스 흡수장애 등의 유전적인 문제가 있는 환자</td>
            </tr>
            <tr id="KDGERI_CHLORDIAZEPOXIDE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 5mg씩 1일 2-4회(고령자용량)</td>
            </tr>
            <tr id="KDGERI_CHLORDIAZEPOXIDE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당약품<br />∙ 고령자는 저용량으로 투여 시작(운동실조 등 이상반응 위험)등 신중투여<br />∙ 심･간･신장애, 뇌 기질적 장애, 고령자, 쇠약 환자 등 신중투여<br />∙ 우울증이나 우울성 불안에 단독으로 사용 시 자살경향 증가<br />∙ 항불안효과를 목적으로 사용 시 총 치료기간은 4-12주를 넘지 않도록 함<br />∙ 위험을 수반하는 기계조작하지 말 것(졸음, 주의력･집중력･반사운동능력 등의 저하) <br />∙ 장기 투여시에는 정기적으로 혈구수 및 간기능검사를 실시<br />∙ 전향성 기억장애 유발<br />∙ 인지 장애, 섬망, 낙상, 골절, 자동차 사고의 위험 증가로 노인의 불면, 초조, 섬망 치료에는 금기(2012 Beers criteria)</td>
            </tr>
            <tr id="KDGERI_CHLORDIAZEPOXIDE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 페노티아진계 약물, 바르비탈계 약물 등의 중추신경억제제, MAO저해제, 시메티딘, 염산마프로틸린, 음주(중추신경억제작용 증강) <br />∙ 경구용 항응고제(혈액응고효과 변화) <br />∙ 디설피람(클로르디아제폭시드의 혈중농도가 증가) <br />∙ 제산제(클로르디아제폭시드의 위장관흡수 저해) <br />∙ 디곡신(디곡신의 신배설 저하) <br />∙ 단트롤렌나트륨(근이완작용 증강)</td>
            </tr>
            <tr id="KDGERI_CHLORDIAZEPOXIDE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>의존성 및 금단증상(진전, 불안정, 불면, 불안, 두통 및 집중력 결여) 자극흥분, 착란, 졸음, 비틀거림, 어지러움, 보행실조, 다행증, 황달, 호흡억제, 혈압저하, 구역, 변비, 구갈, 발진, 근긴장저하, 부종 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_CLOBAZAM" data-drug-number="67">
          <thead>
            <tr>
              <th className="drug-number">67</th>
              <th className="drug-name">클로바잠(Clobazam)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_CLOBAZAM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>불안, 긴장, 다음 경우에서의 불안, 긴장: 정신신체장애, 자율신경장애, 수면장애, 기질성 장애, 항경련제 단독요법으로 충분히 안정화되지 않는 간질환자에 있어서의 보조치료.</td>
            </tr>
            <tr id="KDGERI_CLOBAZAM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>알코올 또는 약물의존성 환자, 수면무호흡증후군 환자, 이 약 및 이 약의 성분 또는 벤조디아제핀계 약물에 과민증인 환자, 약물의존성의 병력이 있는 환자, 중증근무력증 환자, 심각한 호흡 기능부전 환자, 심각한 간기능 부전 환자, 초기3개월 임부, 수유부, 갈락토오스 불내성, Lapp 유당분해효소 결핍증 또는 포도당-갈락토오스 흡수장애 등의 유전적인 문제가 있는 환자</td>
            </tr>
            <tr id="KDGERI_CLOBAZAM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제]성인: 1회 10mg씩 1일 2회 투여고령자: 성인용량의 1/2을 투여</td>
            </tr>
            <tr id="KDGERI_CLOBAZAM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자는 용량감소 추전(졸음, 어지러움, 근육 쇠약 등 이상반응 위험 및 추락 위험) <br />∙ 전향성 기억장애 유발<br />∙ 차량 및 기계조작에서 위험 발생가능(진정, 근육 쇠약으로 집중 및 반응 능력 손상) <br />∙ 치료를 갑자기 중단하는 경우 금단증상 및 반동증상의 위험이 증가되므로 용량을 서서히 감량할 것<br />∙ 근육쇠약, 신장애 및 간장애 환자 등 신중투여</td>
            </tr>
            <tr id="KDGERI_CLOBAZAM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 알코올(클로바잠의 효과를 증가) <br />∙ 발프로산(발프로산의 혈중농도 상승) <br />∙ 페니토인(페니토인의 혈중농도 상승) <br />∙ 카르바마제핀, 페니토인(클로바잠이 N-데스메칠클로바잠으로 대사되는 반응을 증가) <br />∙ 근이완제, 진통제, 아산화질소(효과 증강) <br />∙ 시메티딘 등 약물대사효소저해제, 시사프리드(클로바잠의 작용이 증강) <br />∙ 마약성 진통제(정신적 의존성 증가) <br />∙ 플루코나졸, 플루복사민, 티클로피딘, 오메프라졸 등 CYP2C19 저해제(클로바잠의 활성대사체인 N-데스메칠클로바잠의 노출을 증가) <br />∙ 덱스트로메토르판, 피모자이드, 파록세틴, 네비보롤 등 CYP2D6에 의해 대사되는 의약품(대사 저하)</td>
            </tr>
            <tr id="KDGERI_CLOBAZAM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>졸음, 공격적 행동, 과민, 타액분비, 상기도 감염, 발열, 운동실조, 진정, 불면, 정신운동격정, 피로, 말더듬증, 변비, 구토, 식욕저하, 식욕증가, 연하곤란, 요로감염증, 기침, 폐렴, 기관지염 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_CLONAZEPAM" data-drug-number="68">
          <thead>
            <tr>
              <th className="drug-number">68</th>
              <th className="drug-name">클로나제팜(Clonazepam)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_CLONAZEPAM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>간질 및 부분발작(초점발작), 원발성 및 2차적으로 전신화된 강직간대발작(대발작), 유･소아 간질(특히 정형성 및 비정형성 결신발작), 공황장애</td>
            </tr>
            <tr id="KDGERI_CLONAZEPAM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>급성 협우각형 녹내장 환자, 중증의 근무력증 환자, 약물의존성 환자, 알코올 또는 약물남용 환자, 이 약 및 이 약의 성분에 과민증 환자, 벤조디아제핀계 약물에 과민증 환자, 중증의 간장애 환자, 중증의 호흡부전 환자, 갈락토오스 불내성, Lapp 유당분해효소 결핍증 또는 포도당-갈락토오스 흡수장애 등의 유전적인 문제가 있는 환자</td>
            </tr>
            <tr id="KDGERI_CLONAZEPAM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량)간질 및 부분발작(초점발작), 원발성 및 2차적으로 전신화된 강직간대발작(대발작), 유･소아 간질(특히 정형성 및 비정형성 결신발작):초기용량 1회 0.5mg씩 1일 3회3일 간격 0.5mg씩 증량, 권장유지용량 3-6mg씩 1일 1회(일반용량)공황장애:초회용량 1회 0.25mg씩 1일 2회3일 후 목표 용량인 1회 0.5mg씩 1일 2회(혹은 취침 전 1회)(일반용량)</td>
            </tr>
            <tr id="KDGERI_CLONAZEPAM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당약품<br />∙ 65세 이상의 공황장애 환자: 안전성 및 유효성 미확립<br />∙ 고령자는 저용량으로 투여 시작<br />∙ 우울증의 징후 및 증상 발현, 자살충동 또는 자살행동 위험성 증가<br />∙ 심･신장애, 뇌 기질적 장애, 고령자, 쇠약 환자 등 신중투여<br />∙ 저용량부터 시작하여 유지량까지 천천히 증가하며, 투여 중지 시에도 천천히 감량<br />∙ 정기적으로 간･신기능, 혈액검사<br />∙ 위험을 수반하는 기계조작하지 말 것(졸음, 주의력･집중력･반사운동능력 등의 저하) <br />∙ 인지 장애, 섬망, 낙상, 골절, 자동차 사고의 위험 증가로 노인의 불면, 초조, 섬망 치료에는 금기(2012 Beers criteria)</td>
            </tr>
            <tr id="KDGERI_CLONAZEPAM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 항간질약(진정, 무감각) <br />∙ 바르비탈계 약물, 히단토인유도체 또는 카르바마제핀과 같은 간효소유발약물(클로나제팜의 생체내 변환을 가속) <br />∙ MAO저해제, 다른 항간질약, 마취제, 최면진정제, 항정신병약, 진통제, 근이완제(클로나제팜의 작용이 증강) <br />∙ 디설피람(클로나제팜의 혈중농도 증가) <br />∙ 디곡신(디곡신의 신배설 감소) <br />∙ 페니토인, 프리미돈(페니토인, 프리미돈의 혈중농도 상승) <br />∙ 페니토인, 페노바르비탈, 카르바마제핀, 발프로산(클로나제팜의 혈중농도 감소) <br />∙ 알코올 등 중추작용억제제(진정,호흡,혈액학에 대한 영향 증강) <br />∙ 시메티딘(클로나제팜의 작용 증가) <br />∙ 리팜피신(클로나제팜의 신배설 증가)</td>
            </tr>
            <tr id="KDGERI_CLONAZEPAM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>의존성 및 금단증상(진전, 불안정, 수면장애, 불안, 두통 및 집중력 결여, 격앙, 근육통, 자극과민, 초조함, 긴장, 안절부절함, 착란, 간질발작), 내성, 지침, 졸음, 휘청거림, 어지러움, 두경감, 운동실조, 숨가쁨, 가슴울혈, 천명, 시실금, 타액증가(유연 등), 식욕부진, 구역, 구토, 야간 빈뇨, 간비대, AST, ALT, 상승, 과민증, 무력감, 권태감, 우울증, 현기증, 신경과민, 운동실조, 지적능력 감퇴 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_CLOTIAZEPAM" data-drug-number="69">
          <thead>
            <tr>
              <th className="drug-number">69</th>
              <th className="drug-name">클로티아제팜(Clotiazepam)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_CLOTIAZEPAM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>정신신체장애(소화기 질환, 순환기 질환)에서의 불안･긴장･우울･수면장애, 마취전 투약</td>
            </tr>
            <tr id="KDGERI_CLOTIAZEPAM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>급성 협우각형 녹내장 환자(항콜린작용에 의해 녹내장이 악화될 수 있다), 중증의 근무력증 환자(근이완작용에 의해 증상이 악화될 수 있다.), 이 약 또는 벤조디아제핀계 약물에 과민증 환자, 알코올 또는 약물의존성 환자, 수면무호흡증후군 환자, 중증의 호흡부전 환자, 갈락토오스 불내성, Lapp 유당분해효소 결핍증 또는 포도당-갈락토오스 흡수장애 등의 유전적인 문제가 있는 환자</td>
            </tr>
            <tr id="KDGERI_CLOTIAZEPAM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) 1회 5-10mg씩 1일 3회마취전 투약: 1회 10-15mg씩 취침전 또는 수술전에 투약연령, 증상에 따라 적절히 증감</td>
            </tr>
            <tr id="KDGERI_CLOTIAZEPAM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자는 저용량으로 투여 시작(운동실조, 과진정 등의 이상반응 위험)등 신중투여<br />∙ 심･간･신장애, 뇌 기질적 장애, 고령자, 쇠약 환자, 중등도의 호흡부전 환자 등 신중투여<br />∙ 위험을 수반하는 기계조작하지 말 것(졸음, 주의력･집중력･반사운동능력 등의 저하) <br />∙ 우울증이나 우울성 불안에 단독으로 사용 시 자살경향 증가<br />∙ 항불안효과를 목적으로 사용 시 총 치료기간은 4-12주를 넘지 않도록 함<br />∙ 장기간 치료시 혈액검사, 간기능 검사, 요검사 실시</td>
            </tr>
            <tr id="KDGERI_CLOTIAZEPAM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 페노티아진계 약물, 바르비탈계 약물, 항우울약, 진정최면약, 마약성 진통제, 마취제, 항히스타민제, 근이완제, 알코올(클로티아제팜의 작용 증강) <br />∙ 시메티딘 등 약물대사효소저해제(클로티아제팜의 작용 증강) <br />∙ 시사프리드(진정효과 증강) <br />∙ 다른 벤조디아제핀계 약물(약물의존성의 위험성 증가)</td>
            </tr>
            <tr id="KDGERI_CLOTIAZEPAM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>의존성 및 금단증상, 불안, 흥분, 우울, 자극과민, 착란, 환각, 정신병, 기타 행동장애, 졸음, 휘청거림, 어지러움, 보행실조, 두통, 언어장애, 진전, 다행증, 실신, 건망증, 안구진탕, 시력불선명, 이명, 혈압저하, 기립성 조절장애, 빈맥, 구역, 구토, 식욕부진, 위통, 변비, 구갈, 발진, 가려움, 쉬피로감, 권태감, 무력감 등의 근긴장저하 증상, 근육통, 관절통, 부종, 성욕의 변화, 요실금, 과민증상 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_DIAZEPAM" data-drug-number="70">
          <thead>
            <tr>
              <th className="drug-number">70</th>
              <th className="drug-name">디아제팜(Diazepam)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_DIAZEPAM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제]신경증에서의 불안･긴장, 정신신체장애(소화기 질환, 순환기 질환, 자율신경실조증, 갱년기장애)에서의 불안･ 긴장･우울, 마취 전 투약, 알코올 금단증상, 골격근경련 또는 결신발작(소발작) 간질의 치료보조제, [주사제]신경증에서의 불안･긴장, 마취 전 투약, 알코올 금단증상, 경련발작 또는 간질 중첩상태, 검사 전 투약(불안･긴장 경감) : 내시경검사, 심율동전환</td>
            </tr>
            <tr id="KDGERI_DIAZEPAM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>급성 협우각형 녹내장 환자(항콜린작용에 의해 안압이 상승하여 증상이 악화될 수 있다.), 중증의 근무력증 환자(근이완작용에 의해 증상이 악화될 수 있다.), 이 약 또는 벤조디아제핀계 약물에 과민증 환자, 중증의 호흡부전 환자, 수면무호흡증후군 환자, 알코올 또는 약물의존성 환자, 중증의 간부전 환자, 쇼크, 혼수, 바이탈 사인이 나쁜 급성 알코올중독 환자(때때로 빈맥, 서맥, 혈압저하, 순환성 쇼크이 나타날 수 있다.), 4주 미만 신생아, 미숙아(벤질알코올 함유 제품에 한함)</td>
            </tr>
            <tr id="KDGERI_DIAZEPAM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 2-2.5mg씩 1일 1-2회, 필요시 점차 증량(고령자용량) <br />[주사제] 1회 2~5mg씩 투여, 필요시 점차 증량(일반용량)</td>
            </tr>
            <tr id="KDGERI_DIAZEPAM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당약품<br />∙ 고령자는 저용량으로 투여 시작(운동실조, 과진정 등 이상반응 위험)등 신중투여<br />∙ 심･간･신장애, 뇌 기질적 장애, 고령자, 쇠약 환자 등 신중투여<br />∙ 위험을 수반하는 기계조작하지 말 것(졸음, 주의력･집중력･반사운동능력 등의 저하) <br />∙ 우울증이나 우울성 불안에 단독으로 사용 시 자살경향 증가<br />∙ 항불안효과를 목적으로 사용 시 총 치료기간은 4-12주를 넘지 않도록 함<br />∙ 전향성 기억장애 유발<br />∙ 인지 장애, 섬망, 낙상, 골절, 자동차 사고의 위험 증가로 노인의 불면, 초조, 섬망 치료에는 금기(2012 Beers criteria)</td>
            </tr>
            <tr id="KDGERI_DIAZEPAM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 항정신병약, 항불안제/진정제, 항우울제, 수면제, 항간질약, 마약성 진통제, 마취제, 항히스타민제, 알코올과 같은 중추작용억제제(진정, 호흡, 혈역학에 대한 영향 증강) <br />∙ 페노티아진계 약물, 바르비탈계 약물, 항우울약, 진정최면약, 마약성 진통제, 마취제, 항히스타민제, 알코올(디아제팜의 작용이 증강, 특히 바르비탈계 약물, 알코올 등은 무호흡 위험의 증가 및 심장 또는 폐기능 억제) <br />∙ CYP3A 또는 CYP2C19 저해제(디아제팜의 진정작용이 증강 및 연장) <br />∙ 디설피람(디아제팜의 혈중농도가 증가) <br />∙ 디곡신(디곡신의 신배설 저하) <br />∙ 제산제(디아제팜의 위장관흡수 저해) <br />∙ 염산마프로틸린(중추신경억제작용이 증강) <br />∙ 단트롤렌나트륨(근이완작용 증강) <br />∙ 시사프리드(진정효과가 증강) <br />∙ 페니토인(페니토인의 항경련작용을 증강) <br />∙ 다른 벤조디아제핀계 약물(약물의존성의 위험성 증가)</td>
            </tr>
            <tr id="KDGERI_DIAZEPAM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>의존성 및 금단증상(진전, 불안정, 불면, 불안, 두통 및 집중력 결여), 반동적 불안, 졸음, 휘청거림, 어지러움, 보행실조, 두통, 요실금, 언어장애, 드물게 진전, 다행증, 실신, 시력장애, 백혈구감소, 과립구감소, 혈액이혼화증, 황달, 빈맥, 혈압저하, 구역, 구토, 식욕부진, 위장장애, 변비, 구갈, 타액분비의 변화, 발진, 호흡억제, 권태감, 무력감, 부종, 황달, 성욕의 변화, 요폐, 요실금, 뇌파의 변화 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_DIPHENHYDRAMINE" data-drug-number="71">
          <thead>
            <tr>
              <th className="drug-number">71</th>
              <th className="drug-name">디펜히드라민(Diphenhydramine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_DIPHENHYDRAMINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>일시적 불면증의 완화</td>
            </tr>
            <tr id="KDGERI_DIPHENHYDRAMINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약에 과민증이 있는 사람, 천식발작, 폐기종, 만성기관지염에 의한 호흡곤란 환자, 녹내장 환자, 전립선비대 등 하부 요로 폐색성 질환 환자, 협착성 소화성 궤양 또는 유문십이지장 폐색 환자, 15세 미만의 소아, 간질 등의 경련성 질환 환자, 크롬친화성세포종 환자, 수유부, 일상적으로 불면인 환자, 불면증의 진단을 받은 환자</td>
            </tr>
            <tr id="KDGERI_DIPHENHYDRAMINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) (정제, 캡슐제) 1회 50mg씩 1일 1회 취침전과도한 진정작용이 나타날 경우 25mg 복용</td>
            </tr>
            <tr id="KDGERI_DIPHENHYDRAMINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당약품<br />∙ 중증 근무력증 환자, 고령자는 이 약을 복용하기 전 의사, 약사와 상의할 것<br />∙ 연용하거나 장기복용하지 않음<br />∙ 위험을 수반하는 기계조작하지 말 것(졸음이 나타날 수 있음) <br />∙ 투여 후 2주 이상 불면증이 지속될 때는 의사와 상의할 것(불면증은 심한 질병의 한 증상일 수 있음) <br />∙ 강한 항콜린 작용으로 노인환자에게 금기(2012 Beers criteria)</td>
            </tr>
            <tr id="KDGERI_DIPHENHYDRAMINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 다른 최면진정제, MAO 저해제, 감기약, 해열진통제, 진해‧거담약, 항히스타민제를 함유하고 있는 내복약(병용금기)</td>
            </tr>
            <tr id="KDGERI_DIPHENHYDRAMINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>발진, 발적, 가려움, 구갈, 위통, 오심, 구토, 식욕부진, 설사, 어지러움, 두통, 기상시의 두중감, 활동중의 졸음, 불쾌감, 신경과민, 일시적인 의식장해, 심계항진, 권태감, 배뇨곤란, 시야혼란, 폐쇄각 녹내장</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_DOXEPIN" data-drug-number="72">
          <thead>
            <tr>
              <th className="drug-number">72</th>
              <th className="drug-name">독세핀(Doxepin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_DOXEPIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>수면유지가 어려운 불면증의 단기 치료</td>
            </tr>
            <tr id="KDGERI_DOXEPIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약이나 이 약의 성분, 또는 다른 디벤옥세핀계 약물(dibenoxepines)에 과민증의 병력이 있는 환자, MAO 억제제를 투여 중이거나 2주 이내 투여받은 환자, 치료되지 않은 협전방각 녹내장 또는 중증의 뇨저류 환자</td>
            </tr>
            <tr id="KDGERI_DOXEPIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 3mg씩 1일 1회, 1일 최대투여량: 6mg</td>
            </tr>
            <tr id="KDGERI_DOXEPIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당약품<br />∙ 고령자에 있어 안전성 유효성은 젊은 성인과 차이가 없음<br />∙ 고령자에서 혼돈 및 진정과다를 유발할 수 있음<br />∙ 고령자 권장 시작용량은 3mg, 용량 증가를 고려하기 전 평가가 권장됨<br />∙ 동반질환의 평가 필요(수면장애는 신체적 및/또는 정신과 질환을 나타내는 증상일 수 있음) <br />∙ 수면 운전과 기타 복합 행동이 나타날 위험 증가<br />∙ 우울증 환자에서 자살 위험 및 우울증의 악화<br />∙ 중추신경계 억제 효과 주의<br />∙ 강한 항콜린 작용, 진정 작용, 기립성 저혈압 발생 가능성으로 노인환자에게 금기(2012 Beers criteria)</td>
            </tr>
            <tr id="KDGERI_DOXEPIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 사이토크롬 P450 효소 억제제(독세핀의 노출을 증가) <br />∙ 시메티딘(독세핀의 혈중농도 2배 증가) <br />∙ 알코올(진정효과 상승) <br />∙ 중추신경 억제제 및 항히스타민제(진정효과 상승) <br />∙ 톨라자미드(중증의 저혈당증)</td>
            </tr>
            <tr id="KDGERI_DOXEPIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>졸림, 진정, 어지러움 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_DOXYLAMINE" data-drug-number="73">
          <thead>
            <tr>
              <th className="drug-number">73</th>
              <th className="drug-name">독시라민(Doxylamine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_DOXYLAMINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>불면증의 보조치료 및 진정</td>
            </tr>
            <tr id="KDGERI_DOXYLAMINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>폐기종, 만성 기관지염 천식 등의 호흡장애 환자, 녹내장 환자, 전립선 비대 환자, 수유부, 15세 이하의 소아</td>
            </tr>
            <tr id="KDGERI_DOXYLAMINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) 1회 25mg씩 1일 1회 수면 30분전연령, 증상에 따라 적절히 증감</td>
            </tr>
            <tr id="KDGERI_DOXYLAMINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당약품<br />∙ 의사 또는 약사와 상의 없이 다른 약물과 병용하거나 2주 이상 투여하지 않음<br />∙ 위험을 수반하는 기계조작하지 말 것(과도한 진정이 나타날 수 있음) <br />∙ 음주 후 또는 음주 시에 투여하지 말 것<br />∙ 강한 항콜린 작용으로 노인환자에게 금기(2012 Beers criteria)</td>
            </tr>
            <tr id="KDGERI_DOXYLAMINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 이미프라민계 항우울약, 항파킨슨제, 디소피라미드(소변축적, 변비 등의 이상반응 증가)</td>
            </tr>
            <tr id="KDGERI_DOXYLAMINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>항콜린작용, 졸음, 심계항진, 현기, 두통, 식욕부진, 설사, 변비, 상복부 통증, 구강건조증, 배뇨곤란, 뇨저류, 복시 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ETHYLLOFLAZEPATE" data-drug-number="74">
          <thead>
            <tr>
              <th className="drug-number">74</th>
              <th className="drug-name">에칠로플라제페이트(Ethyl loflazepate)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ETHYLLOFLAZEPATE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>신경증에서의 불안･긴장･우울･수면장애, 정신신체장애(위･십이지장궤양, 만성위염, 과민성대장증후군, 자율신경실조증)에서의 불안･긴장･우울･수면장애</td>
            </tr>
            <tr id="KDGERI_ETHYLLOFLAZEPATE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>급성 협우각형 녹내장 환자(안압을 상승시킬 수 있다.), 중증의 근무력증 환자(근이완작용에 의해 증상이 악화될 수 있다.), 중증의 간부전 환자, 수면무호흡증후군 환자, 알코올 또는 약물의존성 환자, 이 약 또는 벤조디아제핀계 약물에 과민증 환자, 중증의 호흡부전 환자</td>
            </tr>
            <tr id="KDGERI_ETHYLLOFLAZEPATE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 0.5-1.5mg씩 1일 2회 투여(일반용량)연령, 증상에 따라 적절히 증감</td>
            </tr>
            <tr id="KDGERI_ETHYLLOFLAZEPATE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자는 저용량으로 투여 시작(운동실조, 과진정 등 이상반응 위험) <br />∙ 심･간･신장애, 뇌 기질적 장애, 고령자, 쇠약 환자 등 신중투여<br />∙ 위험을 수반하는 기계조작하지 말 것(졸음, 주의력･집중력･반사운동능력 등의 저하) <br />∙ 우울증이나 우울성 불안에 단독으로 사용 시 자살경향 증가<br />∙ 항불안효과를 목적으로 사용 시 총 치료기간은 4-12주를 넘지 않도록 함</td>
            </tr>
            <tr id="KDGERI_ETHYLLOFLAZEPATE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 페노티아진계 약물, 바르비탈계 약물, 항우울약, 최면진정제, 마약성 진통제, 마취제, 항히스타민제, 알코올(중추신경억제작용이 증강) <br />∙ 시메티딘 등 약물대사효소저해제, 시사프리드(진정작용이 증강) <br />∙ 클로자핀(호흡허탈 및 심정지의 위험성 증가) <br />∙ 큐라레유사약물, 근이완제 등 신경근차단제(상승작용) <br />∙ 다른 벤조디아제핀계(약물의존성의 위험성 증가)</td>
            </tr>
            <tr id="KDGERI_ETHYLLOFLAZEPATE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>의존성 및 금단증상(경련발작, 헛소리, 진전, 불면, 불안, 환각, 망상 등), 불안, 흥분, 자극과민, 착란, 환각, 정신병, 기타 행동장애, 안구진탕, 시력불선명, 잔뇨감, 빈뇨, 발진, 가려움 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ETIZOLAM" data-drug-number="75">
          <thead>
            <tr>
              <th className="drug-number">75</th>
              <th className="drug-name">에티졸람(Etizolam)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ETIZOLAM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>신경증에서의 불안･긴장･우울･신경쇠약증,우울증에 수반하는 불안･긴장,정신신체장애(고혈압, 위･십이지장궤양)에서의 불안･긴장･우울,경추증, 요통, 근수축성 두통에서의 불안･긴장･우울 및 근긴장,신경증, 우울증, 정신분열증, 정신신체장애(고혈압, 위･십이지장궤양)에 의한 수면장애</td>
            </tr>
            <tr id="KDGERI_ETIZOLAM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>급성 폐쇄각녹내장 환자(항콜린작용에 의해 녹내장이 악화될 수 있다), 중증의 근무력증 환자(근이완작용에 의해 증상이 악화될 수 있다), 이 약 또는 벤조디아제핀계 약물에 과민증 환자, 중증의 호흡부전 환자, 중증의 간장애 환자, 수면무호흡증후군 환자, 알코올 또는 약물 의존성 환자, 갈락토오스 불내성, Lapp 유당분해효소 결핍증 또는 포도당갈락토오스 흡수장애 등의 유전적인 문제가 있는 환자</td>
            </tr>
            <tr id="KDGERI_ETIZOLAM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제]신경증, 우울증: 1회 1mg씩 1일 3회(일반용량)정신신체장애, 경추증, 요통, 근수축성 두통: 1회 0.5mg씩 1일 3회(일반용량)수면장애: 1회 1-3mg 1일 1회 취침전(일반용량)고령자 1일 최대용량 : 1.5mg</td>
            </tr>
            <tr id="KDGERI_ETIZOLAM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자는 저용량으로 투여 시작(운동실조, 과다진정 등의 이상반응 위험)등 신중투여<br />∙ 심･간･신장애, 뇌 기질적 장애, 고령자, 쇠약 환자, 중등도의 호흡부전 환자 등 신중투여<br />∙ 위험을 수반하는 기계조작하지 말 것(졸음, 주의력･집중력･반사운동능력 등의 저하) <br />∙ 우울증이나 우울성 불안에 단독으로 사용 시 자살경향 증가<br />∙ 항불안효과를 목적으로 사용 시 총 치료기간은 4-12주를 넘지 않도록 함<br />∙ 장기간 치료시 혈액검사, 간기능 검사, 요검사 실시</td>
            </tr>
            <tr id="KDGERI_ETIZOLAM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 페노티아진계 약물, 바르비탈계 약물, 항우울약, 최면진정제, 마약성 진통제, 마취제, 항히스타민제, 알코올(중추신경억제작용의 증강) <br />∙ 시메티딘, MAO 저해제, 말레인산플루복사민 등 약물대사효소저해제(진정작용 증강) <br />∙ 시사프리드(진정효과 증강) <br />∙ 다른 벤조디아제핀계 약물(약물의존성의 위험성 증가)</td>
            </tr>
            <tr id="KDGERI_ETIZOLAM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>의존성, 호흡억제, 탄산가스혼수, 악성증후군, 횡문근융해증, 간질성 폐렴, 간기능 장애, 황달, 자극과민, 흥분, 초조, 혼돈, 환각, 정신병, 기타 행동장애, 건망, 자극흥분, 혼돈, 졸음, 휘청거림, 어지러움, 보행실조, 두통, 두중, 언어장애, 안구진탕, 시력불선명, 구갈, 구역, 발진, 권태감, 무력감, 유루증, 여성형유방, 고프로락틴혈증, 발한, 배뇨장애, 부종, 코막힘 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_FLUNITRAZEPAM" data-drug-number="76">
          <thead>
            <tr>
              <th className="drug-number">76</th>
              <th className="drug-name">플루니트라제팜(Flunitrazepam)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_FLUNITRAZEPAM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>불면증</td>
            </tr>
            <tr id="KDGERI_FLUNITRAZEPAM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>급성 협우각형 녹내장 환자, 중증의 근무력증 환자, 이 약 또는 다른 벤조디아제핀계 약물 과민증 환자, 수면무호흡증후군 환자, 알코올 또는 약물의존성 환자, 중증의 간부전 환자, 급성 호흡부전 환자, 소아, 갈락토오스 불내성, Lapp 유당분해효소 결핍증 또는 포도당-갈락토오스 흡수장애 등의 유전적인 문제가 있는 환자</td>
            </tr>
            <tr id="KDGERI_FLUNITRAZEPAM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 0.5mg씩 1일 1회(고령자용량)</td>
            </tr>
            <tr id="KDGERI_FLUNITRAZEPAM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자는 저용량으로 투여 시작(운동실조, 과진정 등 이상반응 위험) <br />∙ 수면 운전과 기타 복합 행동이 나타날 위험 증가<br />∙ 위험을 수반하는 기계조작하지 말 것(졸음, 주의력･집중력･반사운동능력 등의 저하) <br />∙ 중증의 아나필락시스 반응 발생 가능<br />∙ 심･간･신장애, 뇌 기질적 장애, 고령자, 쇠약 환자 등 신중투여<br />∙ 우울증이나 우울성 불안에 단독으로 사용 시 자살경향 증가<br />∙ 불면증에 투여시 단기간 동안만 투여</td>
            </tr>
            <tr id="KDGERI_FLUNITRAZEPAM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 페노티아진계 약물, 바르비탈계 약물, 진통약, 마취약 등의 중추신경억제제, MAO저해제, 시메티딘, 진정성 항히스타민제, 음주(클로나제팜의 작용이 증가) <br />∙ 디설피람(클로나제팜의 혈중농도가 증가) <br />∙ 디곡신(디곡신의 신배설 저하) <br />∙ 페니토인, 프리미돈 등의 항경련제(이상반응 및 독성 증가) <br />∙ 리팜피신 등의 간효소유도제(클로나제팜의 청소율 증가)</td>
            </tr>
            <tr id="KDGERI_FLUNITRAZEPAM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>의존성 및 금단증상(진전, 불안정, 불면, 불안, 두통 및 집중력 결여, 우울, 기분변화, 자극과민, 설사), 자극흥분, 착란, 졸음, 어지러움, 비틀거림, 운동실조, 두통, 두중, 두부열오름, 드물게 실조성 보행, 불쾌감, 초조, 불안, 구음장애, 마비감, 이명, 동작완만, 기억력저하, 명정감, 진전, 백혈구감소, 빈혈, 혈소판감소, 심계항진, 혈압저하, 구갈, 드물게 구토, 위부불쾌감, 식욕부진, 설사, 묽은변, 변비, 복통, 혀의거침, 가슴앓이, 타액분비과다, 쓴맛, 발진, 권태감, 무력감 등의 근긴장저하증상 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_FLURAZEPAM" data-drug-number="77">
          <thead>
            <tr>
              <th className="drug-number">77</th>
              <th className="drug-name">플루라제팜(Flurazepam)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_FLURAZEPAM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>잠들기 어렵거나, 밤에 자주 깨거나 새벽에 잠이 깨는 불면증, 수면휴식을 필요로 하는 급만성 병적상태</td>
            </tr>
            <tr id="KDGERI_FLURAZEPAM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>급성 협우각 녹내장, 중증 근무력증, 이 약 및 벤조디아제핀계 약물 과민증자, 급성 호흡부전 환자, 수면무호흡증후군 환자, 15세 이하의 소아, 알코올 또는 약물 의존성 환자</td>
            </tr>
            <tr id="KDGERI_FLURAZEPAM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 15mg씩 1일 1회 취침전, 중증의 경우 30mg 투여(일반용량)연령, 증상에 따라 적절히 증감</td>
            </tr>
            <tr id="KDGERI_FLURAZEPAM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당약품<br />∙ 고령자는 저용량으로 투여 시작(운동실조 등 이상반응 위험)등 신중투여<br />∙ 수면 운전과 기타 복합 행동이 나타날 위험 증가<br />∙ 중증의 아나필락시스 반응 발생 가능<br />∙ 호흡기능 저하, 심･간･신장애, 뇌 기질적 장애, 고령자, 쇠약 환자 등 신중투여<br />∙ 위험을 수반하는 기계조작하지 말 것(졸음, 주의력･집중력･반사운동능력 등의 저하) <br />∙ 장기간 투여시에는 혈구수 및 간기능검사 실시 권장<br />∙ 우울증이나 우울성 불안에 단독으로 사용 시 자살경향 증가<br />∙ 불면증에 투여 시 단기간 동안만 투여할 것<br />∙ 전향성 기억장애 유발<br />∙ 인지 장애, 섬망, 낙상, 골절, 자동차 사고의 위험 증가로 노인의 불면, 초조, 섬망 치료에는 금기(2012 Beers criteria)</td>
            </tr>
            <tr id="KDGERI_FLURAZEPAM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 페노티아진계 약물, 바르비탈계 약물 등의 중추신경억제제, MAO 저해제, 음주(플루라제팜의 작용 증가) <br />∙ 디설피람(플루라제팜의 혈중농도 증가) <br />∙ 디곡신(디곡신의 신배설 저하) <br />∙ 시메티딘, 리팜피신 등 간효소유도제(플루라제팜의 청소율 증가)</td>
            </tr>
            <tr id="KDGERI_FLURAZEPAM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>의존성 및 금단증상(진전, 불안정, 불면, 불안, 두통 및 집중력 결여), 졸음, 비틀거림, 두중감, 두통, 약한 혈압저하, 구갈, 식욕부진, 구역, 변비, 위부불쾌감, 쓴맛, 복부팽만감, 발진, 피로감, 근긴장저하, 관절통 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_LORAZEPAM" data-drug-number="78">
          <thead>
            <tr>
              <th className="drug-number">78</th>
              <th className="drug-name">로라제팜(Lorazepam)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_LORAZEPAM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제]신경증에서의 불안･긴장･우울, 정신신체장애(자율신경실조증, 심장신경증)에서의 불안･긴장･우울, 마취 전 투약[주사제]경구투여가 불가능한 경우 및 경구투여보다 신속한 효과를 필요로 하는 경우:마취 전 투약, 다음 검사시의 불안･긴장 : 내시경검사, 기관지경검사, 동맥촬영, 급성 불안, 급성 흥분 또는 급성 조증</td>
            </tr>
            <tr id="KDGERI_LORAZEPAM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>중중의 근무력증 환자(근이완 작용에 의해 증상이 악화될 수 있다.), 급성 좁은앞방각 녹내장 환자(항콜린작용에 의해 안압이 상승하여 증상이 악화될 수 있다.), 이 약 또는 벤조디아제핀계 약물에 과민반응 환자, 중증의 호흡부전 환자, 수면무호흡증후군 환자, 알코올 또는 약물의존성 환자, 강박증 환자(안전성 및 유효성이 확립되지 않았다.), 중증의 간부전 환자(뇌병증을 유발할 수 있다.), 중증의 신부전 환자, 쇼크, 혼수, 탈진상태 환자, 12세 이하의 소아, 임부 또는 임신하고 있을 가능성이 있는 여성, 임신을 계획하고 있는 여성</td>
            </tr>
            <tr id="KDGERI_LORAZEPAM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) 1~2mg/일을 2~3회로 분할 투여하고 점차 증량, 1일 최대 투여량: 10mg <br />[주사제]마취 전 투여 : 0.05㎎/kg IV or IM, IV: 투여 5-10분후에 진정이 나타나고 30-45분 후에 기억력이 최대로 감소하므로 수술하기 30-45분전에 투여IM: 투여 30-45분 후에 진정이 나타나고 60-90분 후에 기억력이 최대로 감소하므로 수술하기 60-90분전에 투여급성 불안 : 0.025-0.03㎎/kg IV or IM q6hr</td>
            </tr>
            <tr id="KDGERI_LORAZEPAM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당약품<br />∙ 고령자는 저용량으로 투여 시작(과다진정, 어지러움, 운동실조 등의 이상반응 위험)등 신중투여<br />∙ 심･간･신장애, 뇌 기질적 장애, 고령자, 쇠약 환자, 중등도의 호흡부전 환자 등 신중투여<br />∙ 위험을 수반하는 기계조작하지 말 것(졸음, 주의력･집중력･반사운동능력 등의 저하) <br />∙ 우울증이나 우울성 불안에 단독으로 사용 시 자살경향 증가<br />∙ 항불안효과를 목적으로 사용 시 총 치료기간은 4-12주를 넘지 않도록 함<br />∙ 장기간 치료시 혈액검사, 간기능 검사, 요검사 실시<br />∙ 인지 장애, 섬망, 낙상, 골절, 자동차 사고의 위험 증가로 노인의 불면, 초조, 섬망 치료에는 금기(2012 Beers criteria)</td>
            </tr>
            <tr id="KDGERI_LORAZEPAM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 페노티아진계 약물, 바르비탈계 약물, 항우울약, 최면진정제, 마약성 진통제, 마취제, 항히스타민제, 알코올(중추신경억제작용이 증강) <br />∙ 마프로틸린염산염(중추신경억제작용이 증강) <br />∙ 단트롤렌나트륨(근이완작용 증강) <br />∙ 디곡신(디곡신의 신배설 저하) <br />∙ 록사핀(과도한 혼미, 호흡률감소, 저혈압) <br />∙ 로자핀(과진정, 타액분비과다, 운동실조) <br />∙ 시메티딘 등 약물대사효소억제제(로라제팜의 청소율이 감소되어 작용이 증강) <br />∙ 다른 벤조디아제핀계 약물(약물의존성의 위험성 증가) <br />∙ 프레가발린(인지기능장애 및 운동기능장애)신경정신계</td>
            </tr>
            <tr id="KDGERI_LORAZEPAM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>의존성 및 금단증상, 불안, 흥분, 우울, 자극과민, 착란, 환각, 정신병, 기타 행동장애 등의 역설적 반응, 졸음, 어지러움, 휘청거림, 기립성 조절장애, 두중･두통, 두부압박감, 이명, 불면, 심계항진, 보행실조, 안구진탕, 시력불선명, 간기능이상, 구역, 구토, 설사, 변비, 식욕부진, 구갈, 위부불쾌감, 위부팽만감, 상복부통, 가슴쓰림, 혈압저하, 과민반응(부종･혈관부종, 호흡곤란, 때때로 발진, 가려움), 근긴장저하, 드물게 혀의 꼬임, 성욕의 변화, 요실금 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_MEXAZOLAM" data-drug-number="79">
          <thead>
            <tr>
              <th className="drug-number">79</th>
              <th className="drug-name">멕사졸람(Mexazolam)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_MEXAZOLAM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>신경증에서의 불안･긴장･우울, 쉬피로감, 강박･공포 및 수면장애, 정신신체장애(위･십이지장궤양, 만성위염, 과민성대장증후군, 고혈압, 심장신경증, 자율신경실조증)에서의 불안･긴장･우울･쉬피로감･수면장애</td>
            </tr>
            <tr id="KDGERI_MEXAZOLAM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>급성 협우각형 녹내장 환자(안압을 상승시킬 수 있다.), 중증의 근무력증 환자(근이완작용에 의해 증상이 악화될 수 있다.), 이 약 또는 벤조디아제핀계 약물에 과민증 환자, 중증의 호흡부전 환자, 알코올 또는 약물의존성 환자, 수면무호흡증후군 환자</td>
            </tr>
            <tr id="KDGERI_MEXAZOLAM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 0.5mg씩 1일 3회 투여(고령자용량)</td>
            </tr>
            <tr id="KDGERI_MEXAZOLAM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자는 저용량으로 투여 시작(운동실조, 과진정 등 이상반응 위험) <br />∙ 심･간･신장애, 뇌 기질적 장애, 고령자, 쇠약 환자 등 신중투여<br />∙ 위험을 수반하는 기계조작하지 말 것(졸음, 주의력･집중력･반사운동능력 등의 저하) <br />∙ 우울증이나 우울성 불안에 단독으로 사용 시 자살경향 증가<br />∙ 항불안효과를 목적으로 사용 시 총 치료기간은 4-12주를 넘지 않도록 함</td>
            </tr>
            <tr id="KDGERI_MEXAZOLAM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 페노티아진계 약물, 바르비탈계 약물, 항우울약, 최면진정제, 마약성 진통제, 마취제, 항히스타민제, 알코올(중주신경억제작용이 증강) <br />∙ 시메티딘 등 약물대사효소저해제, 시사프리드(진정작용이 증강) <br />∙ 다른 벤조디아제핀계 약물(약물의존성의 위험성 증가)</td>
            </tr>
            <tr id="KDGERI_MEXAZOLAM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>의존성 및 금단증상(경련발작, 헛소리, 진전, 불면, 불안, 환각, 망상), 불안, 흥분, 자극과민, 착란, 환각, 정신병, 기타 행동장애, 졸음, 휘청거림, 어지러움, 보행실조, 두통, 언어장애, 진전, 실신, 다행증, 혼미, 다몽, 건망, 혀의 꼬임, 운동실조, 안구진탕, 시력불선명, ALT, AST, γ-GTP, ALP의 상승, 빈혈, 백혈구･적혈구･혈색소량의 감소, 구갈, 드물게 구역, 구토, 식욕부진, 위부불쾌감, 위트림, 위통, 복통, 설사, 발진, 무력감, 권태감 등의 근긴장저하증상, 요실금, 성욕의 변화 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_MIDAZOLAM" data-drug-number="80">
          <thead>
            <tr>
              <th className="drug-number">80</th>
              <th className="drug-name">미다졸람(Midazolam)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_MIDAZOLAM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>수술 전 진정(수면 또는 가면상태 유도 및 불안경감) 및 수술 전후의 기억력장애 목적으로 근육주사, 기관지경 검사, 위경검사, 방광경 검사, 혈관 조영술 및 심장 카테터법과 같은 단시간 진단 또는 내시경 검사전 의식하의 진정목적으로 단독 또는 마약성 진통제와 병용하여 정맥주사, 다른 마취제 투여전 전신마취 유도목적으로 정맥주사 및 단시간 외과처치시 N2O/O2(균형마취)의 정맥용 보조제, 중환자실 환자의 장기간 진정 목적으로 bolus 정맥주사 또는 지속적 정맥주입</td>
            </tr>
            <tr id="KDGERI_MIDAZOLAM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 및 다른 벤조디아제핀계 약물에 과민증 환자, 급성 협우각형 녹내장 환자, 쇼크 또는 혼수상태의 환자, Vital sign이 억제된 급성 알코올 중독환자, 수면무호흡증후군 환자, 알코올 또는 약물 의존성 환자, 급성 호흡부전 환자</td>
            </tr>
            <tr id="KDGERI_MIDAZOLAM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[주사제] (일반용량) 1. 수술 전 진정(수면 또는 가면상태 유도 및 불안경감) 및 수술 전후의 기억력장애: 0.07-0.08㎎/kg IM, 수술 약 1시간전 투여2. 내시경 또는 심혈관계 처치 전 진정목적: 초회용량 1-1.5mg slow IV.투여 후 2분 이상 진정효과를 관찰하며, 추가 용량필요시 2분내에 1mg 이상 투여하지 않음. 1일 최대 투여량: 3.5mg 3. 마취유도(다른 마취제 투여 전 전신마취 유도목적): 초회용량 0.2-0.3mg/kg 4. 중환자실 환자의 장기간 진정 : 부하용량 0.03-0.3㎎/kg IV, 유지용량 0.03-0.2㎎/kg IV. 14일 이상 투여할 경우 안전성은 확립되어 있지 않으며, 환자 상태에 따라 부하용량을 생략해야 할 수 있음.</td>
            </tr>
            <tr id="KDGERI_MIDAZOLAM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자는 저용량으로 투여 시작(과다진정, 어지러움, 운동실조 등의 이상반응 위험) <br />∙ 심장애, 뇌 기질적 장애, 고령자, 쇠약 환자, 만성 신부전 환자 등 신중투여<br />∙ 반드시 개인별로 용법, 용량을 설정하여 투여할 것, 투여 전 기도 개방 유지 및 호흡보조를 위한 산소와 인공호흡기가 즉시 이용 가능해야 하며, 전신마취제에 대해 훈련받은 의사에 의해서만 마취유도제로 투여되어야 함<br />∙ 위험성이 높은 외과수술환자 또는 쇠약환자, 55세 이상의 환자는 마취유도시 보다 저용량을 투여<br />∙ 위험을 수반하는 기계조작하지 말 것(졸음, 주의력･집중력･반사운동능력 등의 저하)</td>
            </tr>
            <tr id="KDGERI_MIDAZOLAM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 시메티딘, 라니티딘, 에리스로마이신, 베라파밀, 딜티아젬, 케토코나졸, 이트라코나졸 또는 Cytochrome P450 ⅢA를 저해하는 다른 약물(미다졸람의 진정의 증가 및 연장 유발, 미다졸람 투여량을 50-75%로 감량) <br />∙ 바르비탈계 약물 또는 다른 중추신경억제제(호흡저하, 무호흡증 위험성 증가, 약효의 증강 또는 지속화) <br />∙ 알코올(상승작용) <br />∙ 마약성진통제(예 : 모르핀, 메페리딘, 펜타닐), 세코바르비탈, 드로페리돌(미다졸람의 수면작용 증가) <br />∙ 치오펜탈(마취유도에 필요한 치오펜탈 투여량이 감소(15%)) <br />∙ 할로탄(최소폐포농도(MAC)를 감소) <br />∙ 시메티딘, 에리스로마이신(미다졸람의 배설 지연) <br />∙ 사이클로스포린, 아미오다론, 향정신병약 등(미다졸람의 대사산물의 생성 억제) <br />∙ 에리스로마이신(미다졸람의 진정효과 증강) <br />∙ 사퀴나비르(미다졸람의 초기용량 줄일 것이 권장) <br />∙ 발프론산나트륨(미다졸람의 반응 증가)</td>
            </tr>
            <tr id="KDGERI_MIDAZOLAM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>1회 환기량 또는 호흡율 감소, 무호흡, 저혈압, 졸음, 과진정, 두통, 발작성 활동, 오심, 구토, 주사부위 통증, 간대성 근경련, 안구진탕증, 기침, 의존성, 딸국질, 역설적 반응 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PENTOBARBITAL" data-drug-number="81">
          <thead>
            <tr>
              <th className="drug-number">81</th>
              <th className="drug-name">펜토바르비탈(Pentobarbital)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PENTOBARBITAL_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>마취전투약, 전신마취의 도입, 불안, 긴장 상태의 진정, 불면증, 경련상태의 억제</td>
            </tr>
            <tr id="KDGERI_PENTOBARBITAL_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>바르비탈계 약물에 과민반응이 있는 환자, 포르피린증, 잠재포르피린증, 급성 간헐성 포르피린증 환자 또는 그 병력이 있는 환자, 중증의 호흡기능저하 또는 폐기능부전 환자</td>
            </tr>
            <tr id="KDGERI_PENTOBARBITAL_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[주사제]성인: IM: 1회 150-200mg. IV: 초회 100mg 천천히 정주. 필요시 50mg 추가투여. 1일 최대투여량: 500mg. 소아 및 쇠약자: IM: 2-6mg/kg, 1일 최대투여량: 100mg. IV: 성인 대비 비례적으로 감량.</td>
            </tr>
            <tr id="KDGERI_PENTOBARBITAL_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당약품<br />∙ 심･간･신장애, 고령자, 쇠약 환자, 중등도의 호흡부전 환자 등 신중투여<br />∙ 위험을 수반하는 기계조작하지 말 것(졸음, 주의력･집중력･반사운동능력 등의 저하) <br />∙ 급속한 투여에 의해 혈압저하와 함께 호흡저하, 수면무호흡증, 후두연축, 혈관확장 등이 나타날 수 있음<br />∙ 정기적으로 간･신기능 검사<br />∙ 급･만성통증이 있는 환자에게 투여시 역설적인 흥분이 나타나거나 중요한 증상이 은폐될 수 있으므로 주의<br />∙ 투여방법에 있어 특히 주의하며 주사속도는 매우 천천히 함(호흡억제, 혈압강하 나타날 수 있음) <br />∙ 피부노출, 혈관외 유출이나 동맥내 주입을 하지 않도록 주의(혈관외 주입은 조직괴사 등 국소조직의 손상을 일으킬 수 있음) <br />∙ 신체적 의존성이 높고, 수면 내성, 과다 복용의 위험으로 노인환자에게 금기(2012 Beers criteria)</td>
            </tr>
            <tr id="KDGERI_PENTOBARBITAL_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 항불안약, 항정신병약, 최면진정약, 항우울약, 항히스타민제, 티아지드계 이뇨제, 디설피람, 해열진통제, 음주(상호작용이 증강) <br />∙ 와르파린(항응고제의 약물대사를 증가시킴, 프로트롬빈치를 자주 측정할 것) <br />∙ 독시사이클린(독시사이클린의 반감기 단축) <br />∙ 부신피질호르몬(부신피질호르몬의 대사 증가) <br />∙ MAO억제제(펜토바르비탈의 작용이 지연) <br />∙ 페니토인, 발프로산, 발프로산나트륨(상호 혈중농도 예측불가, 혈중농도를 자주 측정할 것)</td>
            </tr>
            <tr id="KDGERI_PENTOBARBITAL_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>의존성 및 금단증상(불안, 불면, 경련, 구역, 환각, 망상, 착란, 흥분 또는 우울상태), 과민반응, 각이상, 구음장애, 정신기능저하, 헛소리, 혼미, 운동실조, 악몽, 이상운동증, 헤마토포르피린뇨, 단백뇨, 저칼슘혈증, 거대적아구성 빈혈, 호흡저하, 수면무호흡증, 서맥, 저혈압, 실신, 흥분, 오한, 복시, 구역, 구토, 권태감, 각성후의 잔류감･숙취감, 주사부위의 혈관부종, 피부발진, 박탈피부염</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PHENOBARBITAL" data-drug-number="82">
          <thead>
            <tr>
              <th className="drug-number">82</th>
              <th className="drug-name">페노바르비탈(Phenobarbital)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PHENOBARBITAL_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>(경구제)불면, 진정, 간질(주사제)진정(긴급을 요하는 경우), 간질, 간질중첩상태</td>
            </tr>
            <tr id="KDGERI_PHENOBARBITAL_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>중증의 간･신장애 환자, 호흡장애 환자, 급성 간헐성 포르피린증 환자, 바르비탈계 약물 과민증 환자, 임부 및 임신하고 있을 가능성이 있는 부인, 아나필락시스양 쇼크 환자, 중추신경억제제 및 알코올 중독증 환자, 갈락토오스 불내성, Lapp 유당분해효소 결핍증 또는 포도당-갈락토오스 흡수장애 등의 유전적인 문제가 있는 환자</td>
            </tr>
            <tr id="KDGERI_PHENOBARBITAL_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량)불면: 1회 30-200㎎씩 1일 1회 취침전진정, 간질: 30-200㎎/일, 1-4회로 분할투여<br />[주사제] (일반용량)진정, 간질: 50-200㎎/일, 1-2회로 분할하여 SQ or IM간질중첩상태: 200-600㎎ IV</td>
            </tr>
            <tr id="KDGERI_PHENOBARBITAL_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당약품<br />∙ 고령자는 저용량으로 투여 시작(호흡억제, 흥분, 우울, 착란 등의 이상반응 위험)등 신중투여<br />∙ 심장애, 뇌 기질적 장애, 고령자, 쇠약 환자, 중등도의 신경증 환자, 갑상선 기능저하증 환자 등 신중투여<br />∙ 위험을 수반하는 기계조작하지 말 것<br />∙ 급･만성통증이 있는 환자에게 투여시 역설적인 흥분이 나타나거나 중요한 증상이 은폐될 수 있으므로 주의<br />∙ 신체적 의존성이 높고, 수면 내성, 과다 복용의 위험으로 노인환자에게 금기(2012 Beers criteria)</td>
            </tr>
            <tr id="KDGERI_PHENOBARBITAL_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 정온제, 수면제, MAO저해제, 삼환계 항우울약, 항히스타민제, 디설피람, 음주(상호작용이 증강) <br />∙ 와르파린(항응고제의 작용 감소, 혈액 응고시간을 자주 측정할 것) <br />∙ 치아짓계 이뇨제(기립성 저혈압 증강) <br />∙ 부신피질호르몬(부신피질호르몬의 대사 증가) <br />∙ 글리세오풀빈(글리세오풀빈의 흡수 저해 및 혈중 농도 감소) <br />∙ 테오필린(테오필린의 혈중 농도 저하) <br />∙ 독시사이클린(독시사이클린의 혈중농도 반감기 단축) <br />∙ 페니토인(약물의 혈중농도를 자주 모니터 할 것) <br />∙ 발프로산(페노바비탈의 혈중농도 증가)</td>
            </tr>
            <tr id="KDGERI_PHENOBARBITAL_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>의존성 및 금단증상(불안, 불면, 경련, 구역, 환각, 망상, 흥분, 착란과 항우울 상태), 발진, 피부점막안증후군(스티븐스-존슨증후군), 중독성표피괴사증(리엘증후군), 박리성 피부염, 호흡억제, 혈소판감소, 황달, ALT, AST, γ-GTP의 상승, 기면, 고정자세 불능증, 어지러움, 두통, 헛소리, 혼미, 둔중, 구음 장애, 지각이상, 운동실조, 정신기능저하, 헤마토포르피린뇨, 단백뇨, 식욕부진, 홍반열양･홍역양･중독진양 발진, 구루병, 골연화증, 치아형성부전, 갑상선기능저하치(혈청 T4치 등)의 이상, 서맥, 저혈압, 쇼크, 부정맥, 복시, 안구진탕, 과립구 감소, 발열, 관절통 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PINAZEPAM" data-drug-number="83">
          <thead>
            <tr>
              <th className="drug-number">83</th>
              <th className="drug-name">피나제팜(Pinazepam)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PINAZEPAM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>신경증, 우울증, 정신신체장애에서의 불안･긴장</td>
            </tr>
            <tr id="KDGERI_PINAZEPAM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>중증의 근무력증 환자(근이완작용에 의해 증상이 악화될 수 있다.), 급성 협우각형 녹내장 환자(항콜린작용에 의해 녹내장이 악화될 수 있다.), 이 약 또는 벤조디아제핀계 약물에 과민증 환자, 중증의 호흡부전 환자, 알코올 또는 약물의존성 환자, 수면무호흡증후군 환자, 영･유･소아, 갈락토오스 불내성, Lapp 유당분해효소 결핍증 또는 포도당-갈락토오스 흡수장애 등의 유전적인 문제가 있는 환자</td>
            </tr>
            <tr id="KDGERI_PINAZEPAM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 2.5-10mg씩 1일 2회 투여(일반용량)</td>
            </tr>
            <tr id="KDGERI_PINAZEPAM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자는 저용량으로 투여 시작(운동실조, 과진정 등 이상반응 위험) <br />∙ 심･간･신장애, 뇌 기질적 장애, 고령자, 쇠약 환자 등 신중투여<br />∙ 위험을 수반하는 기계조작하지 말 것(졸음, 주의력･집중력･반사운동능력 등의 저하) <br />∙ 우울증이나 우울성 불안에 단독으로 사용 시 자살경향 증가<br />∙ 항불안효과를 목적으로 사용 시 총 치료기간은 4-12주를 넘지 않도록 함</td>
            </tr>
            <tr id="KDGERI_PINAZEPAM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 페노티아진계 약물, 바르비탈계 약물, 항우울약, 최면진정제, 마약성 진통제, 마취제, 항히스타민제, 알코올(중추신경억제작용이 증강) <br />∙ 시메티딘 등 약물대사효소저해제, 시사프리드(진정작용이 증강) <br />∙ 단트롤렌(근이완작용 증강) <br />∙ 디설피람(피나제팜의 혈중농도 증가) <br />∙ 디곡신(디곡신의 신배설 감소) <br />∙ 히단토인계, 바르비탈계 등 항간질약(피나제팜의 부작용 및 독성 증가) <br />∙ 리팜피신 등 간효소유도제(피나제팜의 청소율 증가) <br />∙ 다른 벤조디아제핀계(약물의존성의 위험성 증가)</td>
            </tr>
            <tr id="KDGERI_PINAZEPAM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>의존성 및 금단증상(진전, 불안정, 불면, 불안, 두통 및 집중력 결여), 불안, 흥분, 우울, 자극과민, 착란, 환각, 정신병, 기타 행동장애, 안구진탕, 시력불선명, 백혈구감소, 과립구감소, 혈액이혼화증, 황달, 빈맥, 혈압 저하, 구역, 구토, 식욕부진, 변비, 구갈, 타액분비, 발진, 호흡억제, 피부발진, 권태감, 무력감, 부종, 황달, 성욕의 변화, 요폐, 요실금, 뇌파의 변화</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_THIOPENTAL" data-drug-number="84">
          <thead>
            <tr>
              <th className="drug-number">84</th>
              <th className="drug-name">치오펜탈(Thiopental)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_THIOPENTAL_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>전신마취, 국소마취제 및 흡입마취제와의 병용, 정신신경과에서의 전격요법(電擊療法)시의 마취, 국소마취제 중독･파상풍･자간(子癎) 등에 수반되는 경련, 정신신경과에서의 진단(마취 Interview)</td>
            </tr>
            <tr id="KDGERI_THIOPENTAL_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>중증의 간장애 및 신장애 환자, 쇼크 또는 대출혈로 인한 순환부전 환자, 중증의 심부전 환자, 잠복성 또는 급성 간헐성 포르피린증, 애디슨병(부신기능부전) 환자, 중증의 천식 및 천식양 상태의 환자, 바르비탈계 약물에 과민증 환자, 알코올･수면진정제･진통제･항정신병약 중독 환자, 악성고열 환자</td>
            </tr>
            <tr id="KDGERI_THIOPENTAL_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[주사제] (일반용량) 1. 정맥주사용액의 농도: 2.5% 수용액(5% 용액은 정맥염을 일으킬 수 있음) 1) 전신마취의 유도: 최초 50-100mg(2.5% 용액으로 2-4mL) 주입 후 응답이 없을 때까지 추가주입(응답이 없어졌을 때의 주입량이 취면량). 다시 취면량의 반량 내지 동량을 추가주입 후 다른 마취법으로 이행 2) 단시간 마취: 최초 50-75mg(2.5% 용액으로 2-3mL)을 10-15초에 주입. 필요시 다시 50-75mg(2.5% 용액으로 2-3mL)을 같은 속도로 주입, 환자의 응답이 없어졌을 때의 주입량이 취면량.수술에 앞서 다시 50-75mg(2.5% 용액으로 2-3mL)을 같은 속도로 분할주입. 필요시 25-100mg(2.5% 용액으로 1-4mL)을 분할주입(1회 최대 1g) 3) 병용사용(국소마취제 또는 흡입마취제와 병용). 보통 50-100mg(2.5% 용액으로 2-4mL)을 간헐적으로 정맥내 주입 4) 정신신경과에서의 전격요법시의 마취: 300mg(2.5% 용액으로 12mL)을 약 25-35초에 주입 5) 경련시: 50-200mg(2.5% 용액으로 2-8mL)을 경련이 멈출 때까지 천천히 주입 6) 정신신경과에서의 진단(마취 Interview): 투여속도 1mL/min로 75-100mg(2.5% 용액으로 3-4mL) 투여, 잠들게 한 후 2-10분 동안 불러서 각성시켜 Interview 실시 후 1분간 약 1mL의 속도로 추가주입2. 직장내 주입 용액농도는 10%의 수용액 투여량: 20-40mg/kg(10% 용액으로 0.2-0.4mL/kg) 주입법: 용액을 주사기에 넣고 주사기 끝에 요도용 도관(catheter)을 통하여 직장내에 삽입하고 주입. 주입후 약 15분 이내에 마취에 들어가 약 1시간 지속</td>
            </tr>
            <tr id="KDGERI_THIOPENTAL_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자는 신중투여(호흡억제, 혈압강하 등의 이상반응 위험) <br />∙ 중증의 당뇨병, 중증의 고혈압 및 저혈압, 중증의 빈혈, 저단백혈증, 심근 장애, 동맥경화증, 뇌내압항진, 중증의 근무력증, 근위축증, 호흡곤란 및 기도폐색, 대사장애 환자 등 신중 투여<br />∙ 심한 호흡억제, 혈압강하, 맥박의 이상, 안면창백 등의 증상이 나타나는 경우에는 즉시 투여를 중지하고 산소흡입, 인공호흡, 혈압상승제 등의 투여, 적절한 체위 등 적절한 처치를 함<br />∙ 장기간의 수술에 사용할 때에는 단독 투여를 피하고 다른 마취제를 병용하는 것이 바람직함. <br />∙ 마취시 후두근 및 부교감신경이 과민 상태로 될수 있으므로 전처치로서 아트로핀, 스코폴라민 등을 투여하는 것이 바람직함. <br />∙ 진통작용이 없으므로 필요시에는 진통제를 병용투여함.</td>
            </tr>
            <tr id="KDGERI_THIOPENTAL_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 중추신경억제제, 혈압강하제, MAO저해제, 삼환계 항우울약, 메페네신, 설포닐요소, 항파킨슨제, 디설피람(상호작용 증강, 감량하는 등 신중히 투여할 것)</td>
            </tr>
            <tr id="KDGERI_THIOPENTAL_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>호흡정지, 호흡억제, 설근침하, 인두경련, 기관지경련, 기침, 딸꾹질, 재채기, 혈압강하, 부정맥, 정맥염, 혈전증, 정맥류성 신경통, 알레르기성 피부반응, 각성시에 구역, 구토, 두통, 어지러움, 눈물, 떨림, 경련, 흥분, 안면홍조, 복시, 마비감, 요폐, 권태감, 유연, 발한, 근의 불수의운동 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_TRIAZOLAM" data-drug-number="85">
          <thead>
            <tr>
              <th className="drug-number">85</th>
              <th className="drug-name">트리아졸람(Triazolam)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_TRIAZOLAM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>불면증의 단기간 치료</td>
            </tr>
            <tr id="KDGERI_TRIAZOLAM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약의 구성성분 또는 다른 벤조디아제핀계 약물에 과민증 환자, 임부 및 임신하고 있을 가능성이 있는 부인, 급성 폐쇄각녹내장 환자, 케토코나졸, 이트라코나졸, 플루코나졸, 미코나졸, 토루코나졸, 에리트로마이신, 조사마이신, 네파조돈 및 HIV 프로테아제 저해제 투여 환자, 약물 또는 알코올 의존성 환자, 급성 호흡부전 환자, 수면무호흡증후군 환자, 소아, 중증의 근무력증 환자, 비대상성 호흡부전 환자, 갈락토오스 불내성, Lapp 유당분해효소 결핍증 또는 포도당-갈락토오스 흡수장애 등의 유전적인 문제가 있는 환자</td>
            </tr>
            <tr id="KDGERI_TRIAZOLAM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 0.125mg씩 1일 1회 취침전 투여, 최소 유효용량으로 유지함(고령자용량) 1일 최대투여량: 0.25mg최대 치료기간: 2~3주</td>
            </tr>
            <tr id="KDGERI_TRIAZOLAM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당약품<br />∙ 고령자는 저용량으로 투여 시작(과다진정, 어지러움, 운동실조 등의 이상반응 위험) <br />∙ 수면 운전과 기타 복합 행동이 나타날 위험 증가<br />∙ 중증의 아나필락시스 반응, 중추신경계 증상 발생 가능<br />∙ 심･간･신장애, 뇌 기질적 장애, 고령자, 쇠약 환자 등 신중투여<br />∙ 최소유효량으로 사용할 것(투여량과 관련된 이상반응 방지) <br />∙ 불면증에 투여시 단기간 동안만 투여할 것<br />∙ 인지 장애, 섬망, 낙상, 골절, 자동차 사고의 위험 증가로 노인의 불면, 초조, 섬망 치료에는 금기(2012 Beers criteria)</td>
            </tr>
            <tr id="KDGERI_TRIAZOLAM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 향정신성 의약품, 진경제, 항히스타민제, 음주(트리아졸람의 작용이 증가) <br />∙ 시메티딘, 클라리스로마이신, 트리아세틸올레안도마이신, 인산올레안도 마이신, 딜티아젬, 에리스로마이신과 같은 마크로라이드계 항생제(트리아졸람의 반감기 및 혈중 농도 증가) <br />∙ 아졸계 항진균제(트리아졸람의 대사 저해, 혈중농도 상승, 작용의 증강 및 작용시간의 연장) <br />∙ 리팜피신(트리아졸람의 혈중 농도 저하) <br />∙ 이소니아지드, 플루복사민, 세트랄린, 파록세틴, 딜티아젬과 베라파밀, 경구피임제, 자몽쥬스<br />∙ HIV 프로테아제 저해제(트리아졸람의 청소율 저하, 소실 반감기 연장, 임상효과 증가)</td>
            </tr>
            <tr id="KDGERI_TRIAZOLAM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>졸음, 두통, 어지러움, 운동실조, 신경과민, 오심, 구토 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ZOLPIDEM" data-drug-number="86">
          <thead>
            <tr>
              <th className="drug-number">86</th>
              <th className="drug-name">졸피뎀(Zolpidem)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">최면진정제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ZOLPIDEM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>불면증</td>
            </tr>
            <tr id="KDGERI_ZOLPIDEM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 또는 이 약에 함유된 성분에 대해 과민증이 있는 환자, 18세 미만의 소아 3) 폐색성 수면무호흡증후군 환자, 중증근무력증 환자(myasthenia gravis), 중증의 간부전 환자, 급성 또는 중증의 호흡부전 환자, 정신병 환자, 갈락토오스 불내성, Lapp 유당분해효소 결핍증 또는 포도당-갈락토오스 흡수장애 등의 유전적인 문제가 있는 환자</td>
            </tr>
            <tr id="KDGERI_ZOLPIDEM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (속효제, 속붕제) 1회 5mg씩 1일 1회 취침직전 투여(고령자용량) 1일 최대용량: 10mg 최대 투여기간: 4주(서방제) 1회 6.25mg씩 1일 1회 취침직전 투여(고령자용량)</td>
            </tr>
            <tr id="KDGERI_ZOLPIDEM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당약품<br />∙ 고령자, 쇠약 환자, 호흡기능 저하자, 간･신장애, 우울증 환자, 정신병 병력이 있는 환자 등 신중투여<br />∙ 고령자에서 최소한의 유효용량만 사용<br />∙ 수면 운전과 기타 복합 행동이 나타날 위험 증가<br />∙ 기억상실증 및 기타 신경-정신 증상들이 예측할 수 없게 발생, 우울증 환자에서, 자살 충동 및 우울증 악화 보고<br />∙ 위험을 수반하는 기계조작하지 말 것(중추신경계 억제 효과) <br />∙ 알코올, 다른 중추신경계 억제 약물(상가작용) <br />∙ 중증의 아나필락시스 반응 발생 가능<br />∙ 노인 환자에게 90일 이상 사용하는 것은 금기(2012 Beers criteria)</td>
            </tr>
            <tr id="KDGERI_ZOLPIDEM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 이미프라민(각성 감소) <br />∙ 클로르프로마진(각성 및 정신운동실행의 감소) <br />∙ 알코올(상가작용) <br />∙ 플루옥세틴(여성에서 졸피뎀의 반감기 증가) <br />∙ 설트랄린(졸피뎀의 Cmax증가, Tmax 감소) <br />∙ 항정신병약, 수면제, 항불안/진정제, 마약성 진통제, 항우울약, 항간질약, 마취제 및 진정작용이 있는 항히스타민제(졸음, 정신운동 부전 등 중추신경계 억제 효과의 상승) <br />∙ 마약성 진통제(정신적 의존성 증가) <br />∙ 시토크롬 P450를 억제하는 약물(졸피뎀의 수면제 작용 증가) <br />∙ 리팜피신(졸피뎀의 효과 감소) <br />∙ 케토코나졸(진정효과 증가) <br />∙ 플루복사민, 시프로플록사신(졸피뎀의 혈중 농도 증가)</td>
            </tr>
            <tr id="KDGERI_ZOLPIDEM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>두통, 졸음, 어지러움, 흉부 불편감, 혈압 증가, 두근거림, 기억상실, 불안, 무감동, 작열감, 혼미, 우울, 섭식장애, 정서불안, 다행감, 피로, 망상, 체온증가, 불면, 기억력장애, 수면장애, 스트레스, 현기, 발진, 두드러기, 월경과다, 복부불편감, 식욕변화, 변비, 설사, 소화불량, 위장염, 위식도역류병, 딸국질, 오심, 구토, 구강건조증, 배뇨곤란, 요로감염, 질건조증, 과민반응, 관절통, 근육경련, 근육통, 목통증, 진전, 조절장애, 시야혼탁, 복시, 충혈, 시각장애, 내이염, 이명, 독감유사증후, 하기도감염, 인두염, 부비강염, 상기도감염, 발열 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_AMISULPRIDE" data-drug-number="87">
          <thead>
            <tr>
              <th className="drug-number">87</th>
              <th className="drug-name">아미설피리드(Amisulpride)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항정신용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_AMISULPRIDE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제] 정신분열병(조현병)</td>
            </tr>
            <tr id="KDGERI_AMISULPRIDE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 크롬친화세포종이 있거나 있을 것으로 의심되는 환자(중증의 고혈압 반응 가능성), 프로락틴-의존성 종양이거나 의심되는 환자(예 : 프로락틴분비 뇌하수체선종, 유방암), 중증의 신장애(크레아티닌청소율〈10 mL/min)환자, 레보도파를 투여중인 환자, 병용금기약제를 투여중인 환자 (주요 약물상호작용 참고)</td>
            </tr>
            <tr id="KDGERI_AMISULPRIDE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) <br />∙ 음성증상이 우세한 경우1회 50-300mg씩 1일 1회, 최적용량은 1회 100mg씩 1일 1회<br />∙ 양성증상과 음성증상이 혼합된 경우초기용량은 1회 400mg씩 1일 1-2회. 최소유효용량 투여1일 최대용량: 1200mg <br />∙ 65세 이상 고령자에서 저혈압이나 진정의 위험을 야기하여 치료 권장되지 않음<br />∙ 신장애 환자 용량조절<br />∙ CrCl 30-60ml/min; 절반으로 감량<br />∙ CrCl 10-30ml/min; 1/3으로 감량<br />∙ CrCl&lt;10ml/min; 투여하지 않음</td>
            </tr>
            <tr id="KDGERI_AMISULPRIDE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당품목 (항정신병약)<br /> - 치매환자에서 뇌졸증 등 심혈관계 질환의 위험 증가하여 비약물학적 치료가 실패한 경우에만 제한적 사용<br /> - 낙상 및 골절 이력 있는 환자에서 운동실조, 실신 및 추가적인 낙상 유발하여 투여 추천되지 않음<br />∙ 항이뇨호르몬부적절분비증후군 또는 저나트륨혈증을 악화시킬 수 있으므로 혈중 나트륨농도 모니터링하며 제한적 사용<br />∙ 도파민성 약물 투여중인 파킨슨 환자에게 신경이완제 투여 시 도파민성 약물을 서서히 감량하여 중단(감자기 중단 시 신경이완제악성증후군 위험성 증가) <br />∙ 신경이완제는 간질발작 발현 역치를 낮추는 것으로 알려져 있음<br />∙ Benzamide 유도체(sulpiride, metoclopramide, tiapride, sultopride)에 과민증이 있는 환자, 노인환자(부작용 증가<br /> - 용량 조절 필요), 중추신경계 저하제나 혈압 강하제와 병용 투여시 주의</td>
            </tr>
            <tr id="KDGERI_AMISULPRIDE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ Torsades de pointes를 유발약제 (병용금기)<br /> - Class Ⅰ의 항부정맥약물 : 퀴니딘, 하이드로퀴니딘, 디소피라미드, 프로카인아마이드, 멕실레틴, 플레카이니드, 프로파페논<br /> - Class Ⅲ 항부정맥약물 : 아미오다론, 소타롤, 도페틸리드, 이부틸리드<br /> - 기타 : 베프리딜, 시사프라이드, 디페마닐, 메타돈, 정맥용에리스로마이신, 미졸라스틴, 정맥용 빈카민, 할로판트린, 스파플록사신, 가티플록사신, 목시플록사신, 펜타미딘, 정맥용스피라마이신, 설토프리드, 티오리다진<br />∙ 레보도파 (길항적 약리효과로 병용금기: 정신이상 악화) <br />∙ 아만타딘, 아포모르핀, 브로모크립틴, 카베르골린, 엔타카폰, 라이수라이드, 페르골라이드, 피리베딜, 프라미펙솔, 퀴나골라이드, 로피니롤, 셀레길린 등 도파민성 약물 (길항적 약리효과로 병용금기) <br />∙ 알코올 (신경이완제 진정효과 강화로 병용금기) <br />∙ 베타차단제(소타롤제외-병용금기), 칼슘채널차단제(딜티아젬, 베라파밀), 클로니딘, 구안파신(guanfacine), 디기탈리스, 메플로킨 (Torsades de pointes, QT간격 연장 위험증가) <br />∙ 저칼륨성 이뇨제, 자극성 완하제, 정맥용 암포테리신 B, 글루코코르티코이드, 테트라코삭타이드(tetracosactides), 도네피질, 리바스티그민, 타크린, 암베노늄, 갈란타민, 피리도스티그민, 네오스티그민 등 항콜린에스테라제, 티오리다진, 클로르프로마진, 레보메프로마진, 트리플루오페라진, 시아메마진, 설피리드, 설토프리드, 티아프라이드, 피모지드, 할로페리돌, 드로페리돌 등 일부 신경이완제 (저칼륨혈증 유발하여 심실성부정맥 위험 증가) <br />∙ 이미프라민 등 삼환계 항우울제, 리튬<br />∙ 항고혈압 약물 (항고혈압 효과, 기립성 저혈압 위험 증가) <br />∙ 진정성 항불안약, 모르핀 유도체(진통제와 진해제), 마취제, H1 항히스타민제, 바르비트류제, 항불안제, 벤조디아제핀, 수면제, 진정성 항우울제(아미트리프틸린, 독세핀, 미안세린, 미르타자핀, 트리미프라민), 탈리도마이드, 바클로펜, 피조티펜 등 다른 중추신경 억제제 (중추 억제 효과 강화)</td>
            </tr>
            <tr id="KDGERI_AMISULPRIDE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>추체외로 증상(진전, 경직, 운동감소증, 타액분비항진, 정좌 불능, 운동이상증, 졸음, 급성 근육긴장이상(경련성 사경, 안구 운동발작, 입벌림장애 등), 불면, 불안, 초조, 극치감 기능이상, 변비, 구역, 구토, 구강건조, 유즙과다분비, 무월경, 여성형 유방, 유방통, 발기부전, 불감증, 저혈압, 체중 증가<br />∙ 신경이완제악성증후군(Neuroleptic Malignant Syndrome) : 항정신병약, 항우울약 및 도파민작동성 항파킨슨약과의 병용시, 이 약 및 병용약의 감량 또는 중지에 의해 발열, 무동함묵, 의식장애, 중증의 근강직, 불수의운동, 연하곤란, 빈맥, 혈압변동, 발한 등이 나타날 수 있다. 이러한 증상이 나타나는 경우에는 체냉각, 수분보급 등의 전신관리 등 적절한 처치를 한다.</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ARIPIPRAZOLE" data-drug-number="88">
          <thead>
            <tr>
              <th className="drug-number">88</th>
              <th className="drug-name">아리피프라졸(Aripiprazole)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항정신용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ARIPIPRAZOLE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제]정신분열병(조현병), 양극성 장애와 관련된 급성 조증 및 혼재 삽화의 치료, 주요우울장애 치료의 부가요법제</td>
            </tr>
            <tr id="KDGERI_ARIPIPRAZOLE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증</td>
            </tr>
            <tr id="KDGERI_ARIPIPRAZOLE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) <br />∙ 정신분열병<br /> - 초기용량: 1회 10-15mg씩 1일 1회. 2주 이상의 간격으로 증량하여 1회 10-30mg씩 1일 1회 범위내에서 조정<br /> - 유지용량: 3개월 이상 타 항정신병약 투여로 안정화된 환자에서 1회 15mg씩 1일 1회 투여한 임상시험에서 유효성 입증됨<br /> - 타 항정신병약에서 전환: 기존제제의 용량을 서서히 줄이면서 이약 투여 시작. 중복투여기간을 최소화할 것<br />∙ 양극성 장애와 관련된 조증 및 혼재삽화의 치료 (단독 또는 리튬이나 발프로산과 보조)<br /> - 초기용량: 1회 15mg씩 1일 1회, 식사와 관계없이 투여. 1일 최대 30mg까지 증량<br /> - 유지요법: 단독요법으로 1회 15-30mg씩 1일 1회로 최소 6주 이상 투여한 임상시험에서 유효성 입증됨<br />∙ 주요우울장애 치료의 부가요법제<br /> - 초기용량: 1회 2-5mg씩 1일 1회로 시작하여 1회 2-15mg씩 1일 1회까지 1주일 이상 간격으로 점진적 증량<br /> - 유지요법: 평가되지 않음<br />∙ 고령자에서 약물동태의 변화가 없으므로 용량 조절은 권장되지 않음</td>
            </tr>
            <tr id="KDGERI_ARIPIPRAZOLE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당품목<br /> - 투여 추천되지 않음치매환자에서 뇌졸증 등 심혈관계 질환의 위험 증가낙상 및 골절 이력 있는 환자에서 운동실조, 실신 및 추가적인 낙상 유발 파킨슨 환자에서 파킨슨증상 악화<br /> - 제한된 경우에 사용가능치매의 비약물학적 치료가 실패한 경우항이뇨호르몬부적절분비증후군 또는 저나트륨혈증을 악화시킬 수 있으므로 혈중 나트륨농도 모니터링이 필요함<br />∙ 기립성 저혈압: 심혈관계 질환(심근 경색 또는 허혈성 심질환 기왕력, 심부전이나 심전도 이상), 뇌혈관 질환 또는 저혈압을 일으키기 쉬운 상태의 환자에게는 주의 깊게 사용<br />∙ 체온 조절: 격렬한 운동 후 심부체온이 증가할 수 있음<br />∙ 연하곤란: 흡인성 폐렴의 위험이 있는 환자에게 주의해서 사용<br />∙ 당뇨환자, 또는 당뇨 고위험군에서 고혈당 위험이 있음</td>
            </tr>
            <tr id="KDGERI_ARIPIPRAZOLE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 카바마제핀 등 CYP3A4 유도제 (이 약 혈중농도 감소) <br />∙ 케토코나졸, 이트라코나졸 등 CYP3A4의 저해제, 퀴니딘, 플루옥세틴, 파록세틴 등 CYP2D6의 저해제 (이 약 혈중농도 증가) <br />∙ 특정 항고혈압약제 (해당 약 효과 증강)</td>
            </tr>
            <tr id="KDGERI_ARIPIPRAZOLE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>∙ 정좌불능, 진정, 떨림, 안절부절, 추체외로장애, 불면증, 변비, 피로, 시력불선명, 구역, 구토, 소화불량, 구강건조, 복부불쾌감, 위장불쾌감, 치통, 통증, 상하지통증, 근골격계 경직, 근육통, 근연축, 두통, 어지러움, 졸림, 초조, 불안, 인후통, 기침, 구강건조, 침 과다분비, 체중증가, <br />∙ 신경이완제악성증후군(Neuroleptic Malignant Syndrome) : 항정신병약, 항우울약 및 도파민작동성 항파킨슨약과의 병용시, 이 약 및 병용약의 감량 또는 중지에 의해 발열, 무동함묵, 의식장애, 중증의 근강직, 불수의운동, 연하곤란, 빈맥, 혈압변동, 발한 등이 나타날 수 있다. 이러한 증상이 나타나는 경우에는 체냉각, 수분보급 등의 전신관리 등 적절한 처치를 한다.신경정신계</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_BLONANSERIN" data-drug-number="89">
          <thead>
            <tr>
              <th className="drug-number">89</th>
              <th className="drug-name">블로난세린(Blonanserin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항정신용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_BLONANSERIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>정신분열증(조현병)</td>
            </tr>
            <tr id="KDGERI_BLONANSERIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 혼수상태 (혼수상태 악화), 강한 중추신경계 억제상태 (중추신경억제 작용 증강) 아드레날린, 아졸계 항진균제 또는 HIV protease 억제제를 투여받는 환자</td>
            </tr>
            <tr id="KDGERI_BLONANSERIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량)초기용량: 1회 4mg씩 1일 2회 반드시 식후투여유지용량: 서서히 증량하여 1회 4-8mg씩 1일 2회 반드시 식후 투여1일 최대용량: 24mg</td>
            </tr>
            <tr id="KDGERI_BLONANSERIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당품목 (항정신병약)치매환자에서 뇌졸증 등 심혈관계 질환의 위험 증가하여 비약물학적 치료가 실패한 경우에만 제한적 사용낙상 및 골절 이력 있는 환자에서 운동실조, 실신 및 추가적인 낙상 유발하여 투여 추천되지 않음항이뇨호르몬부적절분비증후군 또는 저나트륨혈증을 악화시킬 수 있으므로 혈중 나트륨농도 모니터링하며 제한적 사용<br />∙ 고령자에서 추체외로 증상과 같은 이상반응이 나타나기 쉽고 대체로 신체 기능이 저하되어 있으므로 신중히 투여하고 주의깊게 모니터링</td>
            </tr>
            <tr id="KDGERI_BLONANSERIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 아드레날린 (심각한 혈압강하) <br />∙ 아졸계 항진균제, 경구 케토코나졸, 이트라코나졸 등 CYP3A4의 강력한 억제제와 리토나비어, 사퀴나비어 등 HIV 프로테아제 억제제 (이 약 혈중농도 증가) <br />∙ 레보도파 제제, 브로모크립틴 등 도파민성 제제 (도파민성 길항 효과) <br />∙ 혈압강하제 (혈압강하작용 증대) <br />∙에리스로마이신, 클래리스로마이신, 싸이크로스포린, 딜티아젬, 자몽 쥬스 등 CYP3A4억제제 (이 약의 혈중 농도 상승) <br />∙페니토인, 카르바마제핀, 바비트레이트, 리팜피신 등 CYP3A4유도제 (이 약 혈중 농도 저하로 작용 감소)</td>
            </tr>
            <tr id="KDGERI_BLONANSERIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>파킨슨 증후군, 정좌불능증, 불면증, 프로락틴 상승, 운동장애, 졸음, 불안/초조감/화, 신경이완 악성증후군, 지연성 운동장애, 마비성 장폐색, 횡문근융해증, 무과립구증, 백혈구 감소, 항이뇨호르몬부적절분비증후군(SIADH), 과혈당, 당뇨성 케토산증, 당뇨성 혼수, 추체외로 증상, 변비, 식욕저하, 구역, 불면증, 어지러움/현기증, 둔한 두통/두통, 흥분, 손발저림, 자살 시도, 전신권태, 목마름, 허약한 느낌 <br />∙신경이완제악성증후군(Neuroleptic Malignant Syndrome) : 항정신병약, 항우울약 및 도파민작동성 항파킨슨약과의 병용시, 이 약 및 병용약의 감량 또는 중지에 의해 발열, 무동함묵, 의식장애, 중증의 근강직, 불수의운동, 연하곤란, 빈맥, 혈압변동, 발한 등이 나타날 수 있다. 이러한 증상이 나타나는 경우에는 체냉각, 수분보급 등의 전신관리 등 적절한 처치를 한다.</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_BROMPERIDOL" data-drug-number="90">
          <thead>
            <tr>
              <th className="drug-number">90</th>
              <th className="drug-name">브롬페리돌(Bromperidol)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항정신용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_BROMPERIDOL_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제] 정신분열증(조현병)</td>
            </tr>
            <tr id="KDGERI_BROMPERIDOL_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 또는 부티로페논계 약물 및 유사화합물에 과민증, 혼수상태, 급성 알코올중독 환자, 바르비탈계 약물 또는 마취제 등 중추신경억제제의 강한 영향하에 있는 환자, 중증의 심부전 환자(심근에 대한 장애작용, 혈압저하가 보고되어 있다.), 우울증 환자, 기관지폐렴 환자, 뇌저신경절손상 환자, 파킨슨병 환자(추체외로증상이 악화될 수 있다.), 에피네프린을 투여중인 환자</td>
            </tr>
            <tr id="KDGERI_BROMPERIDOL_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) 1회 5mg씩 1일 1회 저녁식사 후 투여중증: 1회 10-20㎎씩 1일 1회경증 및 장기요법: 1회 5-10mg씩 1일 1회1일 최대용량: 50mg고령자 및 쇠약환자는 감량하여 투여. 연령, 증상에 따라 적절히 증감</td>
            </tr>
            <tr id="KDGERI_BROMPERIDOL_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당품목 (항정신병약)<br /> - 치매환자에서 뇌졸증 등 심혈관계 질환의 위험 증가하여 비약물학적 치료가 실패한 경우에만 제한적 사용<br /> - 낙상 및 골절 이력 있는 환자에서 운동실조, 실신 및 추가적인 낙상 유발하여 투여 추천되지 않음<br /> - 항이뇨호르몬부적절분비증후군 또는 저나트륨혈증을 악화시킬 수 있으므로 혈중 나트륨농도 모니터링하며 제한적 사용<br />∙ 치매환자에서 항정신병제 투여는 뇌졸증 등 심혈관계 질환의 위험 증가되므로 비약물학적 치료가 실패한 경우를 제외하고는 행동장애 조절 목적으로 투여 추천되지 않음<br />∙ 낙상 및 골절 이력 있는 환자에서 항정신병제 투여는 운동실조, 실신 및 추가적인 낙상 유발 가능하므로 안전한 대체약제가 사용 가능하다면 투여 추천되지 않음<br />∙ 항이뇨호르몬부적절분비증후군 또는 저나트륨혈증을 악화시킬 수 있으므로 혈중 나트륨농도 모니터링이 필요함<br />∙ 신중투여간장애, 신장애, 심혈관질환 및 저혈압 또는 이러한 증상이 의심되는 경우(일시적인 혈압저하 가능), 경련성 질환 또는 그 병력의 경우(경련역치를 저하), 갑상선기능 항진증･저하증, 항혈액응고제 병용중, 탈수･영양불량상태 등을 수반하는 신체적 피폐의 경우, 크롬친화세포종, 프롤락틴의존성 종양, 협우각형 녹내장, 중증의 근무력증, 전립선비대<br />∙ 고령자에서 추체외로증상 등 부작용 발생이 쉬우므로 소량부터 시작 등 신중투여<br />∙ 장기 연용시 환자를 주의하여 관찰하고 간기능검사, 혈액검사 등을 실시<br />∙ 갑자기 투여중지하면 구역, 구토, 불면 등의 급성 금단증상이 나타날 수 있으므로 점차적으로 감량<br />∙ 진토작용이 있어 다른 약물에 기인한 중독, 장폐색, 뇌종양 등에 의한 구토증상을 은폐할 수 있으므로 주의<br />∙ 치료초기에서 기립성 저혈압이 나타날 수 있으므로 감량 등 주의</td>
            </tr>
            <tr id="KDGERI_BROMPERIDOL_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 바르비탈계 약물, 마취제 등의 중추신경억제제, 수면제, 진정제, 마약성 진통제, 혈압강하제 또는 항콜린작용을 갖는 약물과의 병용, 유기인살충제와의 접촉, 알코올 섭취 (상호작용 증강) <br />∙ 에피네프린, 기타 교감신경흥분제의 작용(혈압강하효과) <br />∙ 구아네티딘, 클로니딘 등의 교감신경차단제 (혈압강하효과 역전) <br />∙ 레보도파 (항파킨슨효과 저해) <br />∙ 삼환계 항우울약 (대사 저해) <br />∙ 카르바마제핀, 페노바르비탈과 같은 효소유도약물 (이 약 혈중농도 감소) <br />∙ 항파킨슨제 (이 약 항콜린작용 증가로 자발성 운동장애 촉진) <br />∙ 테르페나딘, 아스테미졸 (QT연장, 심실성 부정맥) <br />∙ 신경근차단제 (작용 연장) <br />∙ 리튬 (신경독성, 추체외로증상 등 부작용 증가) <br />∙ 메토클로프라미드, 피페라진 (추체외로증상 발현 증가) <br />∙ 제산제, 카페인 (이 약 흡수 저하)</td>
            </tr>
            <tr id="KDGERI_BROMPERIDOL_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>정맥혈전증, 심전도이상(QT간격의 연장, T파의 변화 등), 혈압저하, 고혈압, 빈맥, 심실성 빈맥(torsades de pointes를 포함), 황달, 간염, 담즙울체, 간장애, 빈혈, 백혈구증가증/감소증, 무과립구증, 추체외로증상, 지발성 운동장애, 신경이완제악성증후군(Neuroleptic Malignant Syndrome), 시력불선명 등 시각장애, 조절장애발진, 광선과민증, 식욕부진, 구역, 구토, 가슴쓰림, 위부불쾌감, 복부팽만감, 소화불량, 변비, 설사, 고프롤락틴혈증, 여성유방화, 유즙분비, 월경이상, 체중증가 또는 감소, 수면장애, 초조감, 졸음, 어지러움･비틀거림, 두통･두중, 역설적 반응, 구갈, 무력감, 권태감, 마비감, 코막힘, 발열, 발한, 홍조, 부종, 배뇨장애, 운동실조, 기립성 조절장애, 전신성홍반성루푸스(SLE)양 증상<br />∙ 신경이완제악성증후군(Neuroleptic Malignant Syndrome) : 항정신병약, 항우울약 및 도파민작동성 항파킨슨약과의 병용시, 이 약 및 병용약의 감량 또는 중지에 의해 발열, 무동함묵, 의식장애, 중증의 근강직, 불수의운동, 연하곤란, 빈맥, 혈압변동, 발한 등이 나타날 수 있다. 이러한 증상이 나타나는 경우에는 체냉각, 수분보급 등의 전신관리 등 적절한 처치를 한다. <br />∙ 지발성 운동장애는 고령자(특히 여자)와 뇌손상 환자, 기분장애가 있을때 발생위험도가 높지만 모든 연령층에서 나타나고, 만일 발생한다면 투여 중지</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_CHLORPROMAZINE" data-drug-number="91">
          <thead>
            <tr>
              <th className="drug-number">91</th>
              <th className="drug-name">클로르프로마진(Chlorpromazine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항정신용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_CHLORPROMAZINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>정신분열증(조현병), 기타의 정신병, 조증, 구역･구토, 딸꾹질, 인공동면, 정신병적 장애에서의 증상으로 나타나는 불안･긴장･흥분</td>
            </tr>
            <tr id="KDGERI_CHLORPROMAZINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 심한 중추신경 억제상태, 혼수 또는 순환허탈 상태, 급성 알코올중독 환자, 에피네프린을 투여중인 환자</td>
            </tr>
            <tr id="KDGERI_CHLORPROMAZINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1일 30㎎-450㎎을 분할 투여 (일반용량) 1일 최대투여량: 1g</td>
            </tr>
            <tr id="KDGERI_CHLORPROMAZINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당품목<br /> - 투여 추천되지 않음실신(syncope)한 적이 있는 경우 기립성 저혈압 또는 서맥의 위험성이 증가간질환자에서 경련의 역치(threshold)를 낮춤치매환자에서 뇌졸증 등 심혈관계 질환의 위험 증가섬망(delirium) 환자에서 증상 악화낙상 및 골절 이력 있는 환자에서 운동실조, 실신 및 추가적인 낙상 유발 파킨슨 환자에서 파킨슨증상 악화만성변비 환자에서 변비 악화전립선비대증 또는 하부요로증상 있는 남성환자에서 뇨 저류를 유발<br /> - 제한된 경우에 사용가능대체약제 사용이 불가능하고 조절되는 경련의 경우치매의 비약물학적 치료가 실패한 경우항이뇨호르몬부적절분비증후군 또는 저나트륨혈증을 악화시킬 수 있으므로 혈중 나트륨농도 모니터링이 필요함<br />∙ 고령자는 기립성 저혈압, 추체외로증상, 무력감, 운동실조, 배설장애 등이 나타나기 쉬우므로 감량하는 등 신중히 투여</td>
            </tr>
            <tr id="KDGERI_CHLORPROMAZINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 바르비탈계 약물, 마취제 등의 중추신경억제제, 혈압강하제 또는 항콜린작용을 갖는 약물, 유기인살충제와의 접촉, 알코올 섭취 (상호작용 증강) <br />∙ 에피네프린과 기타 교감신경흥분제 (혈압강하효과) <br />∙ 구아네티딘, 클로니딘 등의 교감신경차단제 (혈압강하효과 역전) <br />∙ 레보도파, 브로모크립틴, 아만타딘 등 도파민효능약 (해당 약 효과 저해) <br />∙ 메토클로프라미드 등 도파민길항약 (추체외로부작용 증가) <br />∙ 페노티아진계 약물 (경련역치 저하) <br />∙ 페니토인 (해당 약 대사 저해로 독성 증가) <br />∙ 혈당강하제 (해당 약 반응 감소) <br />∙ 테르페나딘, 아스테미졸 (QT연장, 심실성 부정맥) <br />∙ 항응고제 (해당 약 효과 감소) <br />∙ 항파킨슨제 (항콜린작용 증가로 지발성 운동장애 촉진, 흡수 저하) <br />∙ 신경근차단제 (해당 약 작용을 연장) <br />∙ 치아짓계 이뇨제 (페노치아진에 의한 기립성 저혈압 촉진) <br />∙ 프로프라놀롤 (상호 혈중농도 증가) <br />∙ 삼환계 항우울약 (대사 및 당뇨병 조절 저해) <br />∙ 리튬 (상호 혈중농도 상승으로 신경독성, 추체외로증상 등 부작용 증가) <br />∙ 제산제, 카페인 (이 약 흡수가 저하로 치료효과가 감소)</td>
            </tr>
            <tr id="KDGERI_CHLORPROMAZINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>기립성 저혈압, 혈압저하, 빈맥, 심계항진, 부정맥, 심질환악화, 백혈구증가증/감소증, 호산구증가증, 재생불량성 빈혈, 용혈성 빈혈, 범혈구감소증, 무과립구증, 혈소판감소성 자반병, 구역, 구토, 설사, 설태, 변비, 추체외로증상, 지발성 운동장애, 축동, 산동, 안내압항진, 시력불선명, 프롤락틴혈증, 여성유방화, 유즙분비, 발기부전, 사정불능, 성욕의 변화, 고혈당, 저혈당, 당뇨, 체중증가 및 감소, 수면장애(불면, 졸음 등), 초조, 불안, 발작, 착란, 흥분, 역설적 증상, 긴장상태, 환각･환청, 뇌부종, 뇌척수액이상, 불온, 어지러움, 두통･두중, 충동증상, 광선과민증, 가려움, 두드러기, 발진, 천식, 아나필락시양 반응, 혈관신경성 부종, 후두부종, 박탈성 피부염, 접촉성 피부염, 구갈, 무력감, 권태감, 쉬피로감, 다한, 타액분비과다, 코막힘, 요폐, 요실금, 무뇨, 빈뇨, 부종, 피부의 색소침착, 전신성홍반성루푸스(SLE)양 증상<br />∙ 신경이완제악성증후군(Neuroleptic Malignant Syndrome) : 항정신병약, 항우울약 및 도파민작동성 항파킨슨약과의 병용시, 이 약 및 병용약의 감량 또는 중지에 의해 발열, 무동함묵, 의식장애, 중증의 근강직, 불수의운동, 연하곤란, 빈맥, 혈압변동, 발한 등이 나타날 수 있다. 이러한 증상이 나타나는 경우에는 체냉각, 수분보급 등의 전신관리 등 적절한 처치를 한다. <br />∙ 지발성 운동장애는 고령자(특히 여자)와 뇌손상 환자, 기분장애가 있을때 발생위험도가 높지만 모든 연령층에서 나타나고, 만일 발생한다면 투여 중지</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_CLOZAPINE" data-drug-number="92">
          <thead>
            <tr>
              <th className="drug-number">92</th>
              <th className="drug-name">클로자핀(Clozapine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항정신용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_CLOZAPINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>약제내성 정신분열증(조현병) 환자 혹은 심한 추체외로계 부작용(특히, 지연성 운동장애)을 일으키는 환자. 병력과 최근 임상 상태로 미루어 보아, 자살 행동 위험이 있는 정신분열증 또는 분열정동장애 환자의 자살 행동 위험 감소</td>
            </tr>
            <tr id="KDGERI_CLOZAPINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증상, 중독성 또는 특이체질에 의한 과립구감소증/무과립구증의 병력이 있는 환자(이전의 화학요법에 의한 병력은 제외), 골수 기능이 손상된 환자, 알코올 및 다른 중독성 정신질환 환자, 약물중독, 혼수상태, 모든 형태의 순환성 부전 및 중추신경억제 환자, 심한 신장 질환, 심한 심장 질환, 불안정성 간질, 진행성 간질환, 간기능 부전, 정기적인 혈액 검사가 불가능한 환자, 마비성 장폐쇄, 골수기능저하를 일으킬 수 있는 다른 약제 투여중일 경우</td>
            </tr>
            <tr id="KDGERI_CLOZAPINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량)최저 유효용량을 사용할 것. <br />∙ 초기용량: 제 1일에 1회 12.5mg씩 1일 1회 또는 2회, 제 2일에 1회 25mg씩 1일 1회 또는 2회 투여 후 내약성이 좋은 경우 매일 25-50mg씩 증량하여 2-3주째에 1일 300mg까지 투여. 필요 시 주 1회로 1일 용량을 50-100mg씩 더 증량<br />∙ 고령자 초기용량: 제 1일에 1회 12.5mg씩 1일 1회, 그 후 1일 25mg를 초과하여 증량하지 말 것<br />∙ 유효용량: 일 200-450mg 1일 2-4회 분할투여. 1일 총투여량이 균등하게 나누어지지 않을 경우 취침시에 최대량 복용<br />∙ 1일 최대용량: 900mg <br />∙ 유지용량: 치료효과를 달성한 후 1일 150-300mg까지 감량하여 최소 6개월간 치료. 1일 용량이 200mg 이하라면 저녁시간에 1회 투여 가능<br />∙ 치료종료: 1-2주에 걸쳐서 점진적으로 감량. 백혈구감소증 등 갑작스러운 치료 중단이 필요한 경우, 환자 정신상태와 금단증상을 세심히 관찰<br />∙ 치료 재개: 중단기간이 2일 이상 경과한 경우 제 1일에 1회 12.5mg씩 1일 1회 또는 2회로 시작하여 재개하고, 내약성이 좋은 경우 초기 용량보다 빠르게 증량이 가능하나, 처음 사용 시 호흡정지, 심박동 정지가 일어났던 경우 매우 주의할 것<br />∙ 기존의 항정신병약제에서 클로자릴로의 전환: 일반적으로 기존의 항정신병약제와 병용투여 되어서는 안되므로 다른 항정신병약제를 감량하거나 서서히 감량하여 중단해야 함<br />∙ 간장애 환자: 낮은 초기용량, 느린 용량조정을 할 것</td>
            </tr>
            <tr id="KDGERI_CLOZAPINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당품목<br /> - 투여 추천되지 않음간질환자에서 경련의 역치(threshold)를 낮춤치매환자에서 뇌졸증 등 심혈관계 질환의 위험 증가섬망(delirium) 환자에서 증상 악화낙상 및 골절 이력 있는 환자에서 운동실조, 실신 및 추가적인 낙상 유발 만성변비 환자에서 변비 악화전립선비대증 또는 하부요로증상 있는 남성환자에서 뇨 저류를 유발<br /> - 제한된 경우에 사용가능대체약제 사용이 불가능하고 조절되는 경련의 경우치매의 비약물학적 치료가 실패한 경우항이뇨호르몬부적절분비증후군 또는 저나트륨혈증을 악화시킬 수 있으므로 혈중 나트륨농도 모니터링이 필요함<br />∙ 호산구 수치 3,000/mm3 이상이면 투약 중단, 1,000/mm3 이하이면 재투약<br />∙ 혈소판이 50,000/mm3 이하이면 투약 중단<br />∙ 기립성 저혈압 발생 위험이 높으므로 파킨슨병 환자에게 투여 첫주에는 서있는 상태 및 바로 누운 상태에서의 혈압 관찰이 필요<br />∙ 고령자에서 특히 뇨저류, 변비 등 항콜린 작용이 쉽게 나타남</td>
            </tr>
            <tr id="KDGERI_CLOZAPINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 골수 기능을 저하시킬 수 있는 약물 (병용금기) <br />∙ 알코올, MAO 억제제, 마취제, 항히스타민제, 벤조디아제핀류 등 CNS 억제제 (중추억제효과 증가) <br />∙ 벤조디아제핀, 다른 정신병 치료제 병용 (이 약 개시할 때 순환계부전 위험 증가, 드물게 심박동 정지, 호흡정지 유발도 가능) <br />∙ 항콜린성 약물, 혈압강하제, 호흡억제성 약물 (상가 작용) <br />∙ 리튬, 다른 중추신경계에 작용하는 약 (신경이완제 악성증후군(NMS) 위험 증가) <br />∙ 노르에피네프린, 다른 α-adrenergic 약물 (혈압증가 작용 감소) <br />∙ 발프론산 (드물게 헛소리 증상) <br />∙ QTc 간격 증가, 전해질 불균형 유발약제 (부작용 악화) <br />∙ 카르바마제핀, 페니토인, 리팜피신 등 CYP450 3A4 효소 유도체, 오메프라졸, 흡연 등 CYP450 1A2 유도체 (이 약 농도 감소) <br />∙ 시메티딘, 에리스로마이신(3A4), 플루복사민(1A2), 페라진(1A2), 시프로플록사신(1A2), 경구피임제 (1A2, 3A4, 2C19), 아졸계의 항진균제, 프로테아제 억제제(3 A), 카페인(1A2) 등 CYP450 동위효소 억제제 (이 약 농도 상승) <br />∙ 파록세틴(1A2), 설트랄린, 플루옥세틴, 시탈로프람 같은 선택적인 세로토닌 재흡수 억제제를 병용 투여한 환자에게서와 이 약의 혈장 중에서의 농도 상승이 보고된 바 있음<br />∙ 와르파린, 디곡신 등 높은 단백질 결합을 갖고 있는 약물 (해당 약물 농도 증가)</td>
            </tr>
            <tr id="KDGERI_CLOZAPINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>백혈구감소증/백혈구수감소/호중구감소증, 호산구증가증, 백혈구증가증, 체중 증가, 구음장애(dysarthria), 졸음/진정, 어지러움, 발작/경련/간대성 근경련, 추체외로 증상, 정좌불능, 진전, 강직, 두통, 수면장애/악몽, 불면, 운동과다증, 불분명발음, 시야 흐림, 빈맥, 심전도 변화, 흉통/협심증, ECG변화, 실신, 기립성 저혈압, 고혈압, 변비, 과다침분비, 구역, 구토, 구강건조, 식욕부진, 설사, 간효소 수치 증가, 발진, 뇨 저류, 요실금, 양성 고열, 발한/체온 조절의 이상, 피로, 열 <br />∙ 신경이완제악성증후군(Neuroleptic Malignant Syndrome) : 항정신병약, 항우울약 및 도파민작동성 항파킨슨약과의 병용시, 이 약 및 병용약의 감량 또는 중지에 의해 발열, 무동함묵, 의식장애, 중증의 근강직, 불수의운동, 연하곤란, 빈맥, 혈압변동, 발한 등이 나타날 수 있다. 이러한 증상이 나타나는 경우에는 체냉각, 수분보급 등의 전신관리 등 적절한 처치를 한다.신경정신계</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_HALOPERIDOL" data-drug-number="93">
          <thead>
            <tr>
              <th className="drug-number">93</th>
              <th className="drug-name">할로페리돌(Haloperidol)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항정신용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_HALOPERIDOL_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제, 주사제]정신분열증(조현병), 조증, 정신병적 장애의 증상, 투렛증후군(Gilles de la Tourette's syndrome), 구토, 딸꾹질</td>
            </tr>
            <tr id="KDGERI_HALOPERIDOL_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 심한 중추신경억제 상태, 혼수상태 환자, 알코올중독 환자, 중증의 심부전 환자(심근에 대한 장애 작용, 혈압저하), 파킨슨병 환자(추체외로증상 악화), 기관지페렴 환자, 뇌저신경절손상 환자, 에피네프린 투여중인 환자</td>
            </tr>
            <tr id="KDGERI_HALOPERIDOL_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량)초회용량: 1일 1-15㎎를 2-3회 분할투여 (중증에서 최대 100mg까지 투여가능)유지용량: 1일 2-8㎎<br />[주사제] (일반용량) 1일 6-15mg 분할 근육주사, 가능한 빨리 경구 투여로 대치연령 증상에 따라 적절히 증감</td>
            </tr>
            <tr id="KDGERI_HALOPERIDOL_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당품목<br /> - 투여 추천되지 않음치매환자에서 뇌졸증 등 심혈관계 질환의 위험 증가낙상 및 골절 이력 있는 환자에서 운동실조, 실신 및 추가적인 낙상 유발 파킨슨 환자에서 파킨슨증상 악화<br /> - 제한된 경우에 사용가능항이뇨호르몬부적절분비증후군 또는 저나트륨혈증을 악화시킬 수 있으므로 혈중 나트륨농도 모니터링이 필요함<br />∙ 고령자에서 기립성 저혈압, 추체외로증상, 운동실조, 배설장애 등이 나타나기 쉬우므로 감량 투여하는 등 신중히 투여<br />∙ 리튬과 병용 시 리튬의 농도를 1 mmol/ℓ 이하로 유지하고 EEG를 모니터하는 것이 권장. 추체외로증상에 의한 발열이 나타나는 경우 두 약물을 즉시 투여중지</td>
            </tr>
            <tr id="KDGERI_HALOPERIDOL_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 바르비탈계 약물, 마취제 등의 중추신경억제제, 수면제, 강한 진통제, 항히스타민제, 진정제, 혈압강하제 또는 항콜린작용을 갖는 약물과의 병용, 유기인살충제와의 접촉, 알코을 섭취 (상호작용 증강) <br />∙ 에피네프린, 기타 교감신경흥분제 (혈압강하효과) <br />∙ 구아네히딘, 클로니딘 등의 교감신경차단제 (혈압강하효과 역전) <br />∙ 레보도파 (항파킨슨효과 저해) <br />∙ 메칠도파 (중추신경계 효과 증강) <br />∙ 리튬 (심전도 변화, 중증의 추체외로증상, 지발성 운동장애, 신경이완제악성증후군(NMS), 비가역적인 뇌장애 보고) <br />∙ 카르바마제핀, 페노바르비탈 등 효소유도약물 (이 약의 혈중농도 현저히 감소) <br />∙ 삼환계 항우울약 (해당 약 대사 및 당뇨병 조절 저해) <br />∙ 테르페나딘, 아스테미졸 (QT연장, 심실성 부정맥 유발 가능) <br />∙ 퀴니딘, 부스피론, 플루옥세틴 (이 약의 혈중농도 상승) <br />∙ 항파킨슨제 (항콜린작용 증가되어 지발성 운동장애 촉진) <br />∙ 제산제, 카페인 (이 약 흡수 저하로 치료효과 감소)</td>
            </tr>
            <tr id="KDGERI_HALOPERIDOL_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>심전도이상(QT간격의 연장, T파의 변화 등), 혈압저하, 고혈압, 빈맥, 심실성 빈맥(torsades de point를 포함), 추체외로증상, 지발성 운동장애, 간염, 황달, 간장애, 망막염, 백내장, 눈의 조절장애, 시력불선명, 부종, 발적, 두드러기, 박탈성 피부염, 광선과민증, 아나필락시 반응, 빈혈, 백혈구 증가증/감소증, 적혈구감소, 무과립구증, 식욕부진, 구역, 구토, 변비, 설사, 고프롤락틴혈증, 여성유방화, 유즙분비, 성욕의 변화, 고혈당, 저혈당, 체중증가 및 감소, 기관지 경련, 후두연축, 호흡곤란, 불면, 초조, 졸음, 어지러움, 두통⋅두증, 불안, 우울, 환각, 흥분, 구갈, 코막힘, 권태감, 요폐, 발열, 발한, 홍조 <br />∙ 신경이완제악성증후군(Neuroleptic Malignant Syndrome) : 항정신병약, 항우울약 및 도파민작동성 항파킨슨약과의 병용시, 이 약 및 병용약의 감량 또는 중지에 의해 발열, 무동함묵, 의식장애, 중증의 근강직, 불수의운동, 연하곤란, 빈맥, 혈압변동, 발한 등이 나타날 수 있다. 이러한 증상이 나타나는 경우에는 체냉각, 수분보급 등의 전신관리 등 적절한 처치를 한다. <br />∙ 지발성 운동장애는 고령자(특히 여자)와 뇌손상 환자, 기분장애가 있을때 발생위험도가 높지만 모든 연령층에서 나타나고, 만일 발생한다면 투여 중지</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_LEVOMEPROMAZINE" data-drug-number="94">
          <thead>
            <tr>
              <th className="drug-number">94</th>
              <th className="drug-name">레보메프로마진(Levomepromazine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항정신용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_LEVOMEPROMAZINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>정신운동성 흥분 상태, 정신분열병(조현병), 정신박약의 공격성과 초조성 우울증의 보조치료, 신경성 불안증, 수면장애, 진통제의 효력 증가</td>
            </tr>
            <tr id="KDGERI_LEVOMEPROMAZINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 또는 페노티아진계 약물 및 그 유사화합물 과민증, 간장애 환자, 조혈계이상 환자, 신장질환자, 순환 부전 환자, 갑자기 중증의 저혈압이 일어날 수 있는 병적 상태의 환자, 혼수상태 또는 중추신경억제제(바르비탈산 유도체, 마취제, 알코올 등)의 강한 영향 하에 있는 환자, 혈압강하제 또는 MAO억제제를 투여중인 환자, 에피네프린을 투여중인 환자, 파킨슨증 환자, 다발경화증, 근육무력증, 편마비 환자, 피질하부 뇌장애가 의심되거나 확진된 환자, 중증 우울증 상태의 환자, 크롬친화세포종 환자, 요폐 환자, 좁은앞방각녹내장 환자</td>
            </tr>
            <tr id="KDGERI_LEVOMEPROMAZINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) <br />∙정신병<br /> - 1일 25-50mg을 2-4회 분할 경구 투여, 1일 최대용량: 150-250mg <br />∙신경성 불안, 공격성, 초조의 완화 및 통증<br /> - 1일 6-25 mg을 2-4회 분할, 1일 최대용량: 75-100mg <br />∙수면장애: 1회 10-25mg씩 1일 1회 취침전 투여<br />∙증상에 따라 적절히 증감</td>
            </tr>
            <tr id="KDGERI_LEVOMEPROMAZINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당품목 (항정신병약)치매환자에서 뇌졸증 등 심혈관계 질환의 위험 증가하여 비약물학적 치료가 실패한 경우에만 제한적 사용낙상 및 골절 이력 있는 환자에서 운동실조, 실신 및 추가적인 낙상 유발하여 투여 추천되지 않음항이뇨호르몬부적절분비증후군 또는 저나트륨혈증을 악화시킬 수 있으므로 혈중 나트륨농도 모니터링하며 제한적 사용<br />∙ 치매환자에서 항정신병제 투여는 뇌졸증 등 심혈관계 질환의 위험 증가되므로 비약물학적 치료가 실패한 경우를 제외하고는 행동장애 조절 목적으로 투여 추천되지 않음<br />∙ 낙상 및 골절 이력 있는 환자에서 항정신병제 투여는 운동실조, 실신 및 추가적인 낙상 유발 가능하므로 안전한 대체약제가 사용 가능하다면 투여 추천되지 않음<br />∙ 항이뇨호르몬부적절분비증후군 또는 저나트륨혈증을 악화시킬 수 있으므로 혈중 나트륨농도 모니터링이 필요함<br /><br />∙ 신중투여동맥경화증 혹은 심질환이 의심되는 환자, 중증천식, 폐기종, 호흡기감염증 등의 환자(호흡억제), 고온환경에 있는 사람, 간질 등의 경련성 질환 또는 이들의 병력이 있는 환자(경련 역치를 저하) <br />∙ 고령자는 기립성저혈압, 추체외로증상, 탈력감, 운동실조, 배설장애 등이 일어나기 쉽고 항콜린성 및 진정작용 작용에 민감하기 쉽기 때문에 낮은 용량으로 시작하여 서서히 증량하는 등 신중투여. 이 약 투여할 때 정기적으로 혈압을 측정할 것<br />∙ MAO 억제제 투여한 경우 3-6주의 간격을 두고 이 약 투여<br />∙ 기립성 허탈상태 방지 위해 최초 고용량 투여 및 반복투여 후 30분간 눕는 것을 권장<br />∙ 이 약 복용 중 알코올을 섭취하지 말 것<br />∙ QT 간격 연장의 위험을 있으므로 알려진 심혈관계 질환이나 QT 연장의 가족력을 가진 경우 주의<br />∙ 진토작용이 있으므로 다른 약제에 근거하는 중독, 장폐색, 뇌종양 등의 구토증을 불현성화할 수 있으니 주의</td>
            </tr>
            <tr id="KDGERI_LEVOMEPROMAZINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ MAO 억제제 (중추 흥분상태 증가)<br /> - 병용금기<br />∙ 에피네프린 (중증의 혈압강하)<br /> - 병용금기<br />∙ 구아네티딘 및 ACE 억제제 등 혈압강하제 (기립성 저혈압)<br /> - 병용금기<br />∙ 벤조디아제핀류, 수면제, 진통제, 마취제, 부교감신경차단제, 삼환계 항우울약 (항콜린성 및 진정효과 증가) <br />∙ 레보도파제제, 브로모크립틴 등 도파민 효능제 (도파민 효능효과 감소) <br />∙ 알코올 (졸음, 정신운동기능저하) <br />∙ 리튬 (전도 변화, 중증의 추체외로증상, 지연이상운동증, 신경이완제악성증후군, 비가역성의 뇌장애) <br />∙ QT간격을 연장시키는 약물 (효과 증강) <br />∙ 리스페리돈, 할로페리돌, 아미트리프틸린, 캅토프릴, 온단세트론, 코데인, 플레카이니드, 암페타민유도체 등 CYP2D6에 의해 주로 대사되는 약물 (해당 약물 효과 증가) <br />∙ 유기인살충제와 접촉 주의 (동공수축, 서맥)</td>
            </tr>
            <tr id="KDGERI_LEVOMEPROMAZINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>졸림, 어지러움, 착란, 불면, 두통, 불안, 흥분, 쉽게 자극받음, 경련, 구갈, 빈맥, 변비, 요저류, 발기부전, 냉감증, 파킨슨 증후군, 이상운동증, 근긴장이상증, 정좌불능, 백혈구감소증, 과립구감소증, 혈소판감소성자반증, 혈전색전증, 저혈압, 부정맥, 심질환 악화, 식욕항진, 식욕부진, 설태, 구역, 구토, 설사, 동공수축, 안내성항진, 시각장애, 피부의 색소침착, 코막힘, 권태감, 발열, 부종, 무뇨, 요폐, 드물게 알레르기, 광선피부병, 광민감반응<br />∙ 신경이완제악성증후군(Neuroleptic Malignant Syndrome) : 항정신병약, 항우울약 및 도파민작동성 항파킨슨약과의 병용시, 이 약 및 병용약의 감량 또는 중지에 의해 발열, 무동함묵, 의식장애, 중증의 근강직, 불수의운동, 연하곤란, 빈맥, 혈압변동, 발한 등이 나타날 수 있다. 이러한 증상이 나타나는 경우에는 체냉각, 수분보급 등의 전신관리 등 적절한 처치를 한다.</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_LITHIUM" data-drug-number="95">
          <thead>
            <tr>
              <th className="drug-number">95</th>
              <th className="drug-name">리튬(Lithium)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항정신용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_LITHIUM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제] 조증･조울증의 예방과 치료</td>
            </tr>
            <tr id="KDGERI_LITHIUM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>기질성 뇌장애 또는 뇌파이상, 심질환, 리튬체내저류를 일으키기 쉬운 상태(신장애, 쇠약 또는 탈수상태, 발열, 발한 또는 설사, 식염제한), 리튬이나 기타 함유성분에 과민한 자</td>
            </tr>
            <tr id="KDGERI_LITHIUM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) 1회 0.2~0.6g씩 1일 3회연령, 증상에 따라 적절히 증감</td>
            </tr>
            <tr id="KDGERI_LITHIUM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당품목 (항정신병약)낙상 및 골절 이력 있는 환자에서 항전간제 투여는 운동실조, 실신 및 추가적인 낙상 유발 가능하므로 안전한 대체약제가 사용 가능하다면 투여 추천되지 않음<br />∙ 혈중농도에 비례하여 독성 발생<br />∙ 갑상선 질환, 신기능 저하 및 심혈관질환자에게 주의해야 함. <br />∙ 이뇨제, ACEI, NSAID 사용시 또는 설사, 열 등으로 수분 소실이 많은 경우 감량 고려해야 함.</td>
            </tr>
            <tr id="KDGERI_LITHIUM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 치아짓계 이뇨제 (이 약 독성 증강) <br />∙ 카르바마제핀, 딜티아젬 (착란, 조대진전, 방향감각상실 등 정신신경계 증상 유발) <br />∙ MAO 억제제 (치명적 악성고열증이 보고됨) <br />∙ 할로페리돌 및 다른 향정신성 약물 (심전도변화, 심한 추체외로증상, 지발성 운동장애, 신경이완제악성증후군(Neuroleptic Malignant Syndrome), 비가역성 뇌장애, 뇌손상에 의한 뇌병증(허약, 졸음, 착란, 백혈구감소, 혈청효소, BUN 및 FBS의 증가), 치아이상 유발) <br />∙ 요오드화칼륨 (lithium의 갑상선기능 저하효과를 증가시킴) <br />∙ ACE저해제, 비스테로이드성 소염진통제 (이 약 혈중농도 상승으로 독성 유발) <br />∙ 플루옥세틴 (이 약 농도의 증가 또는 감소) <br />∙ Chlorpromazine (두 약물의 혈청 농도가 감소) <br />∙ 선택적인 세로토닌 재흡수 저해제(SSRI), 세로토닌-노르에피네프린 재흡수 저해제(SNRI), 트립탄류 등 세로토닌 효현제 (세로토닌 증후군)</td>
            </tr>
            <tr id="KDGERI_LITHIUM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>뇌파이상, 어지러움, 발열, 두통, 감각이상, 경면, 불면, 언어장애, 건망, 기억장애, 초조감, 요실금, 진전, 긴장항진 또는 저하, 건반사항진, 운동실조, ECG이상, 혈압저하, 다뇨, 간기능이상, 구역, 구토, 구갈, 식욕부진, 복통, 위장장애, 설사, 변비, 타액분비과다, 백혈구증가, 피진, T3, T4 및 PBI(단백결합요오드)의 저하, 갑상선131I 섭취율의 증가 및 TRH 부하 후의 TSH분비반응의 증대, 부갑상선기능항진증, 시야몽롱, 기본파의 혼란, 서파의증가, 가역적인 둔마 및 T파의 역전, 무력, 권태감, 체중증가 또는 감소, 부종, 암점</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_MOLINDONE" data-drug-number="96">
          <thead>
            <tr>
              <th className="drug-number">96</th>
              <th className="drug-name">몰린돈(Molindone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항정신용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_MOLINDONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>정신분열병(조현병)</td>
            </tr>
            <tr id="KDGERI_MOLINDONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 알코올류, 바르비탈계 약물, 마약류 등에 의한 심각한 중추신경저하 또는 혼수상태 환자</td>
            </tr>
            <tr id="KDGERI_MOLINDONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) <br />∙ 초기용량: 1일 50-75mg, 3-4일간에 걸쳐 1일 최대 100mg까지 증량<br />∙ 유지용량<br /> - 경증: 1회 5-15mg씩 1일 3-4회<br /> - 중등도: 1회 10-25mg씩 1일 3-4회<br /> - 중증: 1일 225mg <br />∙ 고령자에서 저용량으로 투여 시작</td>
            </tr>
            <tr id="KDGERI_MOLINDONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당품목<br /> - 투여 추천되지 않음치매환자에서 뇌졸증 등 심혈관계 질환의 위험 증가낙상 및 골절 이력 있는 환자에서 운동실조, 실신 및 추가적인 낙상 유발 파킨슨 환자에서 파킨슨증상 악화<br /> - 제한된 경우에 사용가능치매의 비약물학적 치료가 실패한 경우항이뇨호르몬부적절분비증후군 또는 저나트륨혈증을 악화시킬 수 있으므로 혈중 나트륨농도 모니터링이 필요함<br />∙ 치매환자에서 항정신병제 투여는 뇌졸증 등 심혈관계 질환의 위험 증가되므로 비약물학적 치료가 실패한 경우를 제외하고는 행동장애 조절 목적으로 투여 추천되지 않음<br />∙ 낙상 및 골절 이력 있는 환자에서 항정신병제 투여는 운동실조, 실신 및 추가적인 낙상 유발 가능하므로 안전한 대체약제가 사용 가능하다면 투여 추천되지 않음<br />∙ 파킨슨 환자에서 도파민 수용체 길항제는 파킨슨증상을 악화시킬 수 있어 투여 추천되지 않음<br />∙ 항이뇨호르몬부적절분비증후군 또는 저나트륨혈증을 악화시킬 수 있으므로 혈중 나트륨농도 모니터링이 필요함<br />∙ 지연이상운동, 신경이완제악성증후군, 유방암의 병력이 있는 환자에게 신중투여<br />∙ 진토작용이 있으므로 장폐색증이나 뇌종양의 증상 은폐 가능<br />∙ 백혈구감소증, 호중구감소증 및 무과립구증이 발생할 수 있으므로 유의하게 감소 시 이 약 투여 중지 고려<br />∙ Sulfites에 알레르기, 유방암 병력, 뇌종양 또는 장폐색, BPH, 뇨저류, 녹내장, 간손상에 신중투여172</td>
            </tr>
            <tr id="KDGERI_MOLINDONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>신경정신계</td>
            </tr>
            <tr id="KDGERI_MOLINDONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>∙ 페니토인나트륨 함유제제나 테트라사이클린류 (해당 약물 흡수저해)졸음, 장시간의 정좌불능증, 파킨슨증후군, 지연이상운동(고용량 고령자, 특히 여성 고령자에서 빈번히 발생), 흔들림, 빈맥, 구역, 구토, 구강건조증, 타액분비과다, 수정체 혼탁, 알레르기성 비특이적 피부발진신경이완제악성증후군(Neuroleptic Malignant Syndrome) : 항정신병약, 항우울약 및 도파민작동성 항파킨슨약과의 병용시, 이 약 및 병용약의 감량 또는 중지에 의해 발열, 무동함묵, 의식장애, 중증의 근강직, 불수의운동, 연하곤란, 빈맥, 혈압변동, 발한 등이 나타날 수 있다. 이러한 증상이 나타나는 경우에는 체냉각, 수분보급 등의 전신관리 등 적절한 처치를 한다.</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_OLANZAPINE" data-drug-number="97">
          <thead>
            <tr>
              <th className="drug-number">97</th>
              <th className="drug-name">올란자핀(Olanzapine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항정신용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_OLANZAPINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제, 주사제]정신분열병(조현병)양극성장애: 양극성장애 1형과 관련된 조증 및 혼재삽화의 치료, 올란자핀 투여로 조증삽화에 반응을 보인 환자들에 있어서 양극성 장애의 재발방지, 양극성장애 I형과 관련된 우울삽화의 급성 치료 [주사제]경구 치료제의 투여가 적합지 않은 정신 분열병 또는 양극성 장애의 조증삽화가 있는 환자에서의 흥분 및 행동장애의 급성 치료. (임상적으로 올란자핀의 경구 투여가 적절하다고 판단되는 즉시, 이 약의 사용을 중단하고 경구 투여를 시작할 것.)</td>
            </tr>
            <tr id="KDGERI_OLANZAPINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 폐쇄각녹내장 환자, 에피네프린을 투여중인 환자</td>
            </tr>
            <tr id="KDGERI_OLANZAPINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) <br />∙ 정신분열병<br /> - 초기권장용량: 1회 5-10mg씩 1일 1회<br /> - 유지용량: 투약지속기간 명확하지 않음<br /> - 임상시험에서 1일 10-20mg 8주간 투약한 환자에서 유효성 입증되었음<br />∙ 양극성장애<br /> - 양극성장애 1형과 관련된 조증 및 혼재삽화의 치료초기 단독요법: 1회 15mg씩 1일 1회리튬, 발프로산 보조요법:1회 10mg씩 1일 1회<br /> - 양극성 장애의 재발 방지초기권장용량: 1회 10mg씩 1일 1회조증 치료 위해 투여한 환자는 재발방지 위해 동일용량 유지새로운 조증, 혼재성 또는 우울삽화가 발생하면 보조요법과 함께 이 약 투여 지속<br /> - 정신분열병과 양극성장애 1형과 관련된 조증 및 혼재삽화의 치료, 양극성장애1일 5-20mg씩 1일 1회 범위 내에서 계속하여 조정초기권장용량을 초과한 용량의 증가는 적절한 임상적 평가 후 24시간 이상의 간격을 두고 증량<br /> - 양극성장애 I형과 관련된 우울삽화의 급성 치료1회 5mg씩 1일 1회로 시작, 1회 10mg씩 1일 1회로 증량. 취침 전 투여1일 최대투여량: 20mg <br />∙ 고령자는 시작용량을 1회 5mg 이하로 투약 고려<br />[주사제] (고령자 용량-60세 이상)근육주사용이며 정맥주사, 피하주사하지 말 것단기 사용만을 목적으로 하며 최대 3일까지 연속투여 가능초회 권장사용량: 2.5-5mg 단회 근육주사초회주사 2시간 후 2.5-5mg를 두 번째 주사 가능쇠약환자, 저혈압 위험환자, 약력학적으로 이 약에 민감한 경우 2.5mg 투여 고려1일 최대사용량: 20mg. 24시간 내 3회를 초과하여서는 안됨</td>
            </tr>
            <tr id="KDGERI_OLANZAPINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당품목<br /> - 투여 추천되지 않음실신(syncope)한 적이 있는 경우 기립성 저혈압 또는 서맥의 위험성이 증가간질환자에서 경련의 역치(threshold)를 낮춤치매환자에서 뇌졸증 등 심혈관계 질환의 위험 증가섬망(delirium) 환자에서 증상 악화낙상 및 골절 이력 있는 환자에서 운동실조, 실신 및 추가적인 낙상 유발 파킨슨 환자에서 파킨슨증상 악화만성변비 환자에서 변비 악화전립선비대증 또는 하부요로증상 있는 남성환자에서 뇨 저류를 유발<br /> - 제한된 경우에 사용가능대체약제 사용이 불가능하고 조절되는 경련의 경우치매의 비약물학적 치료가 실패한 경우항이뇨호르몬부적절분비증후군 또는 저나트륨혈증을 악화시킬 수 있으므로 혈중 나트륨농도 모니터링이 필요함<br />∙ 항콜린성 부작용이 강하므로 요폐쇄, 전립선비대증, 협우각 녹내장, 구갈증, 시력저하, 근무력증 환자에게 사용시 주의<br />∙ 특히 주사 후 첫 4시간 동안 체위성 저혈압, 서맥 및/또는 호흡 저하 여부에 대하여 주의 깊게 관찰해야 함</td>
            </tr>
            <tr id="KDGERI_OLANZAPINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 흡연, 카르바마제핀 (이 약 대사 유도되어 농도 감소) <br />∙ 오메프라졸, 리팜핀 등 CYP1A2 또는 glucuronyl transferase 효소 유도제 (이 약 청소율 증가) <br />∙ 플루복사민, 시프로플록사신, 케토코나졸 등 CYP1A2 억제제 (이 약 대사 억제) <br />∙ 활성탄 (이 약 생체이용률 감소, 이 약 투여 2시간 전 또는 2시간 후에 투여) <br />∙ 에피네프린 (중증의 혈압강하) <br />∙ 저혈압, 서맥, 호흡 또는 중추신경계 억제 유발약물, 알코올<br />∙ 파킨슨병 및 치매 환자에게 항-파킨슨 약물과의 병용투여 금기<br />∙ QT간격을 증가시키는 약물<br />∙ 레보도파, 도파민 효능제 (해당 약 효과 길항)</td>
            </tr>
            <tr id="KDGERI_OLANZAPINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>졸음, 체중증가, 호산구증가증, 프로락틴, 콜레스테롤, 혈당 및 중성지방 수치 상승, 당뇨, 식욕 증가, 정좌불능증, 파킨슨증, 백혈구감소증, 중성구감소증, 운동 이상증, 기립성 저혈압, 항콜린 작용, 간 트랜스아미나제의 일시적인 증상이 없는 상승, 발진, 무력증, 피로, 발열, 관절통, 알칼리 인산분해효소 증가, 감마 글루타밀 전이효소(GGT) 상승, 요산 상승, 크레아틴인산활성효소 상승, 부종<br />∙ 신경이완제악성증후군(Neuroleptic Malignant Syndrome) : 항정신병약, 항우울약 및 도파민작동성 항파킨슨약과의 병용시, 이 약 및 병용약의 감량 또는 중지에 의해 발열, 무동함묵, 의식장애, 중증의 근강직, 불수의운동, 연하곤란, 빈맥, 혈압변동, 발한 등이 나타날 수 있다. 이러한 증상이 나타나는 경우에는 체냉각, 수분보급 등의 전신관리 등 적절한 처치를 한다. <br />∙ 지연운동이상증(Tardive dyskinesia) 발생 시 감량 또는 중단. 여성고령자에서 발생율 높고 투여기간, 총 누적용량 증가할수록 증가</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PALIPERIDONE" data-drug-number="98">
          <thead>
            <tr>
              <th className="drug-number">98</th>
              <th className="drug-name">팔리페리돈(Paliperidone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항정신용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PALIPERIDONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제] 정신분열증(조현병)의 치료, 정신분열정동장애의 급성 치료 [주사제] 정신분열증의 급성치료 및 유지요법</td>
            </tr>
            <tr id="KDGERI_PALIPERIDONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 및 리스페리돈 과민증, 정제 삼키기 어려운 환자</td>
            </tr>
            <tr id="KDGERI_PALIPERIDONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량, 고령자 용량도 동일) <br />∙ 정신분열증<br /> - 1회 6mg씩 1일 1회 아침에 투여<br /> - 음식과 함께 또는 공복 중 한가지 방법으로 일관되게 투여<br /> - 증량 필요 시 최소 5일 간격으로 1일 3mg씩 증량<br />∙ 정신분열정동장애의 급성 치료<br /> - 1회 6mg씩 1일 1회 아침에 투여<br /> - 음식과 함께 또는 공복 중 한가지 방법으로 일관되게 투여<br /> - 증량 필요 시 최소 4일 간격으로 1일 3mg씩 증량<br />∙ 신장애 환자<br /> - 경증 신장애 환자 (CrCl 50-80ml/min): 1회 3mg씩 1일 1회, 1일 최대 6mg까지 증량 가능<br /> - 중등증 또는 중증 신장애 환자 (CrCl 10-50ml/min): 1회 1.5mg씩 1일 1회, 1일 최대 3mg까지 증량 가능<br /> - CrCl&lt;10ml/min: 투여 권장되지 않음<br />[주사제] (일반용량, 고령자 용량도 동일) <br />∙ 경구 팔리페리돈 또는 경구 또는 주사 리스페리돈을 투여 받은 적이 없는 경우 이 약 투여 전 경구 팔리페리돈이나 경구 리스페리돈으로 내약성 확립해야 함<br /> - 첫번째날 234mg (팔리페리돈으로서 150mg) 1회<br /> - 1주일 후 156mg (팔리페리돈으로서 100mg) 1회 삼각근에 주사<br /> - 이후 매달 117mg (팔리페리돈으로서 75mg) 1회 삼각근 또는 둔부근에 주사<br /> - 내약성 및 유효성에 따라 39-234mg (팔리페리돈으로서 25-150mg) 범위 내 조절<br /> - 유지용량은 매달 조절 가능<br /> - 매달 투여해야 할 시점 전후로 일주일 내에 투여도 가능<br />∙ 투여 스케줄을 놓친 경우의 용량,용법은 허가사항 참고 &lt;신장애 환자&gt;<br /> - 경증 신장애 환자(CrCl 50-80ml/min):첫 번째날 156mg (팔리페리돈으로서 100mg) 1회1주일 후 117mg (팔리페리돈으로서 75mg) 1회 삼각근에 투여이후 매달 78mg (팔리페리돈으로서 50mg) 1회 삼각근 또는 둔부군에 투여내약성 및 유효성에 따라 39-156mg (팔리페리돈으로서 25-100mg) 범위 내 조절<br /> - 중등도 또는 중증의 신장애 환자(CrCl&lt;50ml/min): 권장되지 않음</td>
            </tr>
            <tr id="KDGERI_PALIPERIDONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당품목<br /> - 투여 추천되지 않음:치매환자에서 뇌졸증 등 심혈관계 질환의 위험 증가낙상 및 골절 이력 있는 환자에서 운동실조, 실신 및 추가적인 낙상 유발 파킨슨 환자에서 파킨슨증상 악화<br /> - 제한된 경우에 사용가능:치매의 비약물학적 치료가 실패한 경우항이뇨호르몬부적절분비증후군 또는 저나트륨혈증을 악화시킬 수 있으므로 혈중 나트륨농도 모니터링이 필요함<br />∙ 용량전환팔리페리돈 주사팔리페리돈 서방정리스페달콘스타 주사용량234mg 4주 1회12mg 1일 1회25mg 2주 1회117mg 4주 1회6mg 1일 1회37.5mg 2주 1회78mg 4주 1회3mg 1일 1회50mg 2주 1회소화기관 내에서 그 모양이 거의 변하지 않기 때문에, 일반적으로 중증의 소화기관 협착 환자들(병리학적 또는 의인성)이나 연하곤란이 있는 환자 또는 정제를 삼키는데 유의한 어려움이 있는 환자에게는 투여하지 않는다</td>
            </tr>
            <tr id="KDGERI_PALIPERIDONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ Class 1A (퀴니딘, 프로카인아미드 등) 또는 Class III(아미오다론, 소타롤 등) 항부정맥약, 항정신병약(클로로프로마진, 치오리다진 등), 항생제(가티플록사신, 목시플록사신 등) 또는 기타의 QT 간격을 연장시키는 약물 (부작용 증가) <br />∙ 다른 중추신경계에 작용하는 약물 및 알코올 (중추신경계 영향 증가) <br />∙ 레보도파 (도파민 수용체 효과 길항) <br />∙ 기립성 저혈압을 유발시킬 수 있는 약물 (부작용 증가) <br />∙ 카바마제핀 (이 약 효과 감소) <br />∙ 발프로산 (이 약 농도 증가) <br />∙ 리스페리돈 (상가적 효과 증가) <br />∙ 메토클로프라미드 (이 약의 부작용 증가)</td>
            </tr>
            <tr id="KDGERI_PALIPERIDONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>빈맥, 1도 방실차단, 서맥, Bundle branch 차단, 두근거림, 동 부정맥, 동 빈맥, 눈의 건조, 안구운동, 시야 흐림, 복통, 상복부 통증, 설사, 입마름, 소화불량, 구역, 타액 분비과다, 위 불쾌감, 치통, 구토, 무력, 피로, 발열, 기관지염, 비인두염, 비염, 상부 호흡기 감염, 바이러스 감염, 낙상, 식욕저하, 식욕증가, 관절통, 요통, 근 강직, 목의 통증, 극심한 통증, 어깨 통증, 정좌불능, 어지러움, 운동이상, 근긴장이상, 추체외로 장애, 두통, 긴장 과도, 파킨슨증, 진정, 졸음, 실신, 떨림, 공격, 불안, 우울, 악몽, 자살 관념, 기침, 코막힘, 가려움증, 저혈압, 기립성 저혈압, 혈압 증가, 혈액 트리글리세라이드 증가, 심전도 QT 보정 간격 연장, 심전도 T 파 이상, 심전도 T 파 반전, 심전도 이상, 심박수 증가, 인슐린 체중감소, 체중증가<br />∙ 신경이완제악성증후군(Neuroleptic Malignant Syndrome) : 항정신병약, 항우울약 및 도파민작동성 항파킨슨약과의 병용시, 이 약 및 병용약의 감량 또는 중지에 의해 발열, 무동함묵, 의식장애, 중증의 근강직, 불수의운동, 연하곤란, 빈맥, 혈압변동, 발한 등이 나타날 수 있다. 이러한 증상이 나타나는 경우에는 체냉각, 수분보급 등의 전신관리 등 적절한 처치를 한다.</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PERPHENAZINE" data-drug-number="99">
          <thead>
            <tr>
              <th className="drug-number">99</th>
              <th className="drug-name">페르페나진(Perphenazine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항정신용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PERPHENAZINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>정신분열증(조현병), 기타의 정신병, 수술전후의 구토, 메니에르증후군에 의한 어지러움･이명</td>
            </tr>
            <tr id="KDGERI_PERPHENAZINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 심한 중추신경억제 상태, 혼수 또는 순환허탈 상태 환자, 급성 알코올중독 환자, 에피네프린을 투여중인 환자, 백혈병, 혈액이혼화증 환자, 골수억제 환자, 간장애 환자, 피질하부의 뇌장애(뇌염, 뇌종양, 두부외상후유증 등)가 의심되는 환자(고열반응)</td>
            </tr>
            <tr id="KDGERI_PERPHENAZINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 2-8mg씩 1일 3회 (일반용량)연령, 증상에 따라 적절히 증감</td>
            </tr>
            <tr id="KDGERI_PERPHENAZINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당품목<br /> - 투여 추천되지 않음실신(syncope)한 적이 있는 경우 기립성 저혈압 또는 서맥의 위험성이 증가간질환자에서 경련의 역치(threshold)를 낮춤치매환자에서 뇌졸증 등 심혈관계 질환의 위험 증가섬망(delirium) 환자에서 증상 악화낙상 및 골절 이력 있는 환자에서 운동실조, 실신 및 추가적인 낙상 유발 파킨슨 환자에서 파킨슨증상 악화만성변비 환자에서 변비 악화전립선비대증 또는 하부요로증상 있는 남성환자에서 뇨 저류를 유발<br /> - 제한된 경우에 사용가능대체약제 사용이 불가능하고 조절되는 경련의 경우치매의 비약물학적 치료가 실패한 경우항이뇨호르몬부적절분비증후군 또는 저나트륨혈증을 악화시킬 수 있으므로 혈중 나트륨농도 모니터링이 필요함<br />∙ 고령자에서는 기립저혈압, 추체외로증상, 무력감, 운동실조, 배설장애 등이 나타나기 쉬우므로 환자의 상태를 관찰하면서 신중히 투여. 치매가 있는 경우 사망률 증가</td>
            </tr>
            <tr id="KDGERI_PERPHENAZINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 바르비탈계 약물, 마취제 등의 중추신경억제제, 혈압강하제또는 항콜린작용을 갖는 약물과의 병용, 유기인살충제와의 접촉, 알코올섭취 (상호작용 증가) <br />∙ 에피네프린, 기타 교감신경흥분제 (혈압강하효과) <br />∙ 구아네티딘, 클로니딘등의 교감신경차단제 (혈압강하효과 역전) <br />∙ 레보도파, 브로모크립틴, 아만타딘 등 도파민효능약 (해당 약 효과 저해) <br />∙ 메토클로프라미드 등 도파민길항약 (추체외로 부작용) <br />∙ 항경련약 (경련역치를 저하) <br />∙ 페니토인 (해당 약 대사 저해로 독성 증가) <br />∙ 삼환계 항우울약 (해당 약 대사 및 당뇨병 조절 저해) <br />∙ 신경근차단제 (해당 약 작용 연장) <br />∙ 항파킨슨제 (항콜린작용 증가로 지발성 운동장애 촉진) <br />∙ 테르페나딘, 아스테미졸 (QT연장, 심실성 부정맥) <br />∙ 퀴니딘 (심억제효과 증가) <br />∙ 코르티코스테로이드제제, 디곡신 (해당 약 흡수 증가) <br />∙ 리튬 (상호 혈중농도 상승으로 신경독성, 추체외로증상 등 부작용 증가) <br />∙ 제산제, 카페인 (이 약 흡수 저하로 치료효과 감소)</td>
            </tr>
            <tr id="KDGERI_PERPHENAZINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>기립성 저혈압, 혈압저하, 빈맥, 부정맥 또는 심질환 악화, 백혈구증가증/감소증, 호산구증가증, 용혈성 빈혈, 범혈구감소증, 무과립구증, 과립구감소증, 혈소판감소성자반병, 식욕항진, 식욕부진, 구갈, 구역, 구토, 변비, 추체외로증상, 지발성 운동장애, 축동, 산동, 안내압 항진, 시력불선명, 고프롤락틴혈증, 여성유방화, 유즙분비, 월경이상, 위양성임신반응, 발기부전, 사정불능, 성욕의 변화, 고혈당, 저혈당, 당뇨, 체중증가 및 감소, 항이뇨호르몬분비이상증후군(Syndromeof Inappropriate ADH), 수면장애(불면, 졸음 등), 어지러움, 두통, 초조, 불안, 흥분, 발작, 역설적 반응, 뇌부종, 뇌척수액이상, 광선과민증, 홍반, 피부염, 가려움, 두드러기, 습진, 아나필락시 반응, 후두부종, 혈관신경부종, 박탈성 피부염, 접촉성피부염, 발한, 요폐, 요실금, 무뇨, 빈뇨, 다뇨, 피부의 색소침착, 전신성홍반성루푸스(SLE)양 증상, 코막힘, 단백결합요오드(PBI)증가, 이하선종창, 초고열, 다식, 식욕부진, 체중증가또는 감소, 권태감, 부종 <br />∙ 신경이완제악성증후군(Neuroleptic Malignant Syndrome) : 항정신병약, 항우울약 및 도파민작동성 항파킨슨약과의 병용시, 이 약 및 병용약의 감량 또는 중지에 의해 발열, 무동함묵, 의식장애, 중증의 근강직, 불수의운동, 연하곤란, 빈맥, 혈압변동, 발한 등이 나타날 수 있다. 이러한 증상이 나타나는 경우에는 체냉각, 수분보급 등의 전신관리 등 적절한 처치를 한다. <br />∙ 지발성 운동장애는 고령자(특히 여자)와 뇌손상 환자, 기분장애가 있을때 발생위험도가 높지만 모든 연령층에서 나타나고, 만일 발생한다면 투여 중지</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PIMOZIDE" data-drug-number="100">
          <thead>
            <tr>
              <th className="drug-number">100</th>
              <th className="drug-name">피모짓(Pimozide)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항정신용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PIMOZIDE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>정신분열증(조현병)</td>
            </tr>
            <tr id="KDGERI_PIMOZIDE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 선천성 QT간격연장 환자 (부정맥, 심전도이상), 부정맥 환자, 내인성 우울증 환자(증상 악화), 파킨슨증후군 또는 간질 환자(증상 악화), 중증의 중추신경억제 또는 혼수상태 환자, 마크롤라이드계 항생물질을 투여받고 있는 환자(이 약 대사 저해), 파록세틴 및 다른 강력한 CYP2D6 저해제 병용투여 환자</td>
            </tr>
            <tr id="KDGERI_PIMOZIDE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) 1-3mg씩 1일 1회, 아침투여증상에 따라 1일 4-6mg까지 점차 증량, 필요시 1일 2-3회 분할투여1일 최대투여량: 9mg연령, 증상에 따라 적절히 증감고령자에서는 추체외로증상 등 이상반응에 주의하여 성인용량의 1/2로 투여 시작</td>
            </tr>
            <tr id="KDGERI_PIMOZIDE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당품목<br /> - 투여 추천되지 않음치매환자에서 뇌졸증 등 심혈관계 질환의 위험 증가섬망(delirium) 환자에서 증상 악화낙상 및 골절 이력 있는 환자에서 운동실조, 실신 및 추가적인 낙상 유발 파킨슨 환자에서 파킨슨증상 악화만성변비 환자에서 변비 악화전립선비대증 또는 하부요로증상 있는 남성환자에서 뇨 저류를 유발<br /> - 제한된 경우에 사용가능치매의 비약물학적 치료가 실패한 경우항이뇨호르몬부적절분비증후군 또는 저나트륨혈증을 악화시킬 수 있으므로 혈중 나트륨농도 모니터링이 필요함<br />∙ 다른 약물에서 이 약으로 변경할 경우 점차 감량투여하면서 중단 후 이 약 투여<br />∙ 효과가 24시간 지속되므로 반드시 1일 1회 투여 (소실반감기 약 53시간) <br />∙ 투약 중단 시 금단증상(구역, 구토, 불면) 유발 가능하므로 점차적으로 중단<br />∙ 발작 환자, 자몽쥬스 음용 환자, 신경이완제 악성 증후군, 지발성 안면 마비 기왕력자, 간, 신부전 환자에 신중투여</td>
            </tr>
            <tr id="KDGERI_PIMOZIDE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 알코올, 수면제, 진정제, 강력한 진통제 등 중추신경억제제 (해당 약 작용 증강) <br />∙ 레보도파 (항파킨슨작용 저하) <br />∙ 항경련제 (경련 역치 저하) <br />∙ 삼환계 항우울약, 테르페나딘, 아스테미졸, 부정맥용제, 페노티아진계 약물, 퀴닌, 메플로퀸 등 QT연장을 일으킨다고 알려진 약물 (QT간격 연장) <br />∙ 이뇨제 등 전해질 불균형을 유발하는 약물 (저칼륨혈증) <br />∙ 파록세틴 등 CYP2D6 저해제 (이 약 농도 증가) <br />∙ Ritonavir, saquinavir, telithromycin, voriconazole, atazanavir (QT 연장, 심실성 빈맥, 심실세동 및 torsades de pointes 등 심독성위험 증가)</td>
            </tr>
            <tr id="KDGERI_PIMOZIDE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>심전도이상, 혈전색전증(폐색전증과 심부정맥혈전증 포함, 빈도불명), 추체외로증상, 졸음, 불면, 불안, 때때로 불온, 흥분, 이(易)자극, 구역, 구토, 식욕부진, 위부불쾌감, 변비, 복통, 배뇨장애, 구갈, 발한, 두통, 권태감, 성욕항진, 빈맥, 어지러움, 비틀거림<br />∙ 신경이완제악성증후군(Neuroleptic Malignant Syndrome) : 항정신병약, 항우울약 및 도파민작동성 항파킨슨약과의 병용시, 이 약 및 병용약의 감량 또는 중지에 의해 발열, 무동함묵, 의식장애, 중증의 근강직, 불수의운동, 연하곤란, 빈맥, 혈압변동, 발한 등이 나타날 수 있다. 이러한 증상이 나타나는 경우에는 체냉각, 수분보급 등의 전신관리 등 적절한 처치를 한다.</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_QUETIAPINE" data-drug-number="101">
          <thead>
            <tr>
              <th className="drug-number">101</th>
              <th className="drug-name">쿠에티아핀(Quetiapine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항정신용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_QUETIAPINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제]정신분열병(조현병)양극성 장애: 양극성 장애 1형과 관련된 조증 삽화의 급성 치료, 양극성 장애와 관련된 우울증의 치료, 양극성 장애의 재발 예방주요우울장애 치료의 보조요법 (서방정제에 한함)</td>
            </tr>
            <tr id="KDGERI_QUETIAPINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 혼수상태</td>
            </tr>
            <tr id="KDGERI_QUETIAPINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) <br />∙ 정신분열병<br /> - 일반정제 초기용량1일째2일째 3일째 4일째5일째부터1회 25mg씩1일 2회1회 50mg씩1일 2회1회 100mg씩1일 2회1회 150mg씩1일 2회1회 150-200mg씩 1일 2회<br /> - 일반정제 유효용량범위: 1회 75-375mg씩 1일 2회<br /> - 서방정제: 1회 300mg씩 1일 1회 저녁에 투여, 1일 간격으로 최대 300mg씩 증량하여 1일 400-800mg에서 조절<br />∙ 양극성장애<br /> - 양극성 장애 1형과 관련된 조증 삽화의 급성 치료일반정제 초기용량1일째2일째 3일째 4일째5-6일째1회 50mg씩1일 2회1회 100mg씩1일 2회1회 150mg씩1일 2회1회 200mg씩1일 2회1회 100mg이하로 증량 일반정제 유효용량범위: 1회 200-400씩 1일 2회 서방정제 초기용량1일째2일째 3일째 1회 300mg씩 1일 1회1회 600mg씩 1일 1회1회 400-800씩 1일 1회<br /> - 양극성 장애와 관련된 우울증의 치료: 취침전 복용일반정제 및 서방정제 초기용량1일째2일째 3일째 4일째1회 50mg씩1일 1회1회 100mg씩1일 1회1회 200mg씩1일 1회1회 300mg씩1일 1회일반정제 1일 권장용량: 300mg<br />- 양극성 장애의 재발 예방양극성장애의 급성 치료에 쿠에티아핀에 반응하였던 환자들은 동일용량으로 유지1회 150-400mg씩 1일 2회. 최소한의 유효용량 사용<br /> - 주요우울장애 치료의 보조요법 (서방정에 한함) 1일째 50mg씩 1일 1회로 투여 시작하여 3일째 150mg씩 1일 1회로 증량유효용량: 150-300mg씩 1일 1회<br />∙ 고령자용량<br /> - 속방정: 25mg/일로 투여를 시작하여 1일 25-50mg씩 점차적으로 증량<br /> - 서방정: 50mg씩 1일 1회로 시작하여 1일 50mg씩 증량</td>
            </tr>
            <tr id="KDGERI_QUETIAPINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당품목치매환자에서 뇌졸증 등 심혈관계 질환의 위험 증가하여 비약물학적 치료가 실패한 경우에만 제한적 사용낙상 및 골절 이력 있는 환자에서 운동실조, 실신 및 추가적인 낙상 유발하여 투여 추천되지 않음항이뇨호르몬부적절분비증후군 또는 저나트륨혈증을 악화시킬 수 있으므로 혈중 나트륨농도 모니터링하며 제한적 사용</td>
            </tr>
            <tr id="KDGERI_QUETIAPINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 에피네프린 (중증 혈압강하) <br />∙ 카바마제핀 (이 약 소실 증가) <br />∙ 페니토인, 바비트레이트, 리팜피신 등 기타 간효소유도제 (이 약 소실 증가) <br />∙ 치오리다진 (이 약 소실 증가) <br />∙ azole계 항진균제 혹은 마크로라이드계 항생제 등 강력한 CYP3A4억제제 (이 약 대사 억제) <br />∙ 로라제팜 (해당 약 소실 감소) <br />∙ 전해질불균형 및 QT 간격을 연장시키는 약제 (부작용 증강)</td>
            </tr>
            <tr id="KDGERI_QUETIAPINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>어지러움, 졸림, 두통, 구강건조, 백혈구감소증, 빈맥, 말초 부종, 변비, 소화불량, 복통, 설사, 경미한 무력증, 말초 부종, 열, 흉통, 체중증가, 혈청 간 효소(ALT, AST) 증가, 호중구 수 감소, 고혈당 수준으로의 혈당 증가, 등의 통증, 근육통, 실신, 불안, 비염, 기립성저혈압, 고혈압, 불면, 신경과민, 정좌불능, 전진, 구음장애<br />∙ 신경이완제악성증후군(Neuroleptic Malignant Syndrome) : 항정신병약, 항우울약 및 도파민작동성 항파킨슨약과의 병용시, 이 약 및 병용약의 감량 또는 중지에 의해 발열, 무동함묵, 의식장애, 중증의 근강직, 불수의운동, 연하곤란, 빈맥, 혈압변동, 발한 등이 나타날 수 있다. 이러한 증상이 나타나는 경우에는 체냉각, 수분보급 등의 전신관리 등 적절한 처치를 한다.</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_RISPERIDONE" data-drug-number="102">
          <thead>
            <tr>
              <th className="drug-number">102</th>
              <th className="drug-name">리스페리돈(Risperidone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항정신용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_RISPERIDONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제]정신분열병(조현병)알츠하이머 형태의 치매 환자의 초조, 공격성 또는 정신병 증상양극성장애의 조증 부가요법[주사제]급성, 만성 정신분열증및 기타 정신질환 상태의 치료 및 유지요법정신분열증과 연관된 정동 장애의 완화의 치료 및 유지요법</td>
            </tr>
            <tr id="KDGERI_RISPERIDONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 중추신경 억제환자, 혼수상태환자, 에피네프린 투여중인 환자</td>
            </tr>
            <tr id="KDGERI_RISPERIDONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 정신분열병 (고령자 용량)<br /> - 초기용량: 1회 0.5mg씩 1일 2회, 유지용량까지 1회 0.5mg씩 1일 2회 증량<br /> - 유지용량: 1회 1-2mg씩 1일 2회1회 1.5mg 이상 1일 2회 용량으로의 증량은 최소 1주 간격으로 할 것<br /> - 일일최대용량:１6mg <br />∙ 알츠하이머 형태의 치매 환자의 초조, 공격성 또는 정신병 증상 (일반용량)<br /> - 초기용량: 1회 0.25mg씩 1일 2회, 최소 2일 이상 간격으로 1회 0.25mg을 1일 2회씩 증량<br /> - 최적용량: 1회 0.5mg씩 1일 2회 (일부에서 1회 1mg씩 1일 2회까지 증량도 가능)<br /> - 최적용량에 도달하면 1일 1회 투여 요법도 고려 가능<br />∙ 양극성장애의 조증 부가요법 (일반용량)<br /> - 초기용량: 1회 2mg씩 1일 1회, 최적용량까지 일 1mg씩 증량가능<br /> - 최적용량: 2-6mg씩 1일 1회<br />[주사제] (고령자용량) 1회 25mg씩 2주 간격으로 둔부에 근육주사, 정맥투여하지 말 것첫 3주간은 추가로 적절한 항정신약물 치료가 필요함</td>
            </tr>
            <tr id="KDGERI_RISPERIDONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당품목<br /> - 투여 추천되지 않음간질환자에서 경련의 역치(threshold)를 낮춤치매환자에서 뇌졸증 등 심혈관계 질환의 위험 증가낙상 및 골절 이력 있는 환자에서 운동실조, 실신 및 추가적인 낙상 유발 파킨슨 환자에서 파킨슨증상 악화<br />- 제한된 경우에 사용가능대체약제 사용이 불가능하고 조절되는 경련의 경우치매의 비약물학적 치료가 실패한 경우항이뇨호르몬부적절분비증후군 또는 저나트륨혈증을 악화시킬 수 있으므로 혈중 나트륨농도 모니터링이 필요함<br />∙ 경고: 고령 치매화자에서 사망률 증가</td>
            </tr>
            <tr id="KDGERI_RISPERIDONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 아편, 진정형 항히스타민제, 벤조디아제핀계, 삼환계 항우울제 등 중추신경계 작용 약물, 알코올 (중추신경계 억제 현상 심화) <br />∙ 레보도파, 도파민 효능약 (해당 약 효과 감소) <br />∙ 항고혈압제 (저혈압) <br />∙ QT 간격 연장 약물 (부작용 증가) <br />∙ 플루옥세틴, 파록세틴, 고용량의 설트랄린 또는 플루복사민(1일 100mg 초과) 등 강한 CYP2D6 억제제 (이 약 농도 증가) <br />∙ 이트라코나졸, 케토코나졸, 베라파밀 등 강한 CYP3A4 그리고/또는 P-gp 억제제 (이 약 농도 증가) <br />∙ 카르바마제핀, 리팜피신 등 CYP3A4 그리고/또는 P-gp 유도제 (이 약 농도 감소) <br />∙ 리토나비어, 리토나비어 보조 단백분해효소억제제 (이 약 농도 증가) <br />∙ 푸로세미드 (고령 치매 환자에서 사망률 증가) <br />∙ 에피네프린 (중증 혈압강하)</td>
            </tr>
            <tr id="KDGERI_RISPERIDONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>코인두염, 상기도 감염, 부비동염, 요로감염, 빈혈, 과민반응, 불면증, 불안, 신경과민,파킨슨증, 정좌불능증, 졸림, 어지러움, 진정, 진전, 근육긴장이상, 졸음증, 체위성 어지러움, 운동이상증, 실신, 흐려보임, 귀통증, 기립성 저혈압, 빈맥, 저혈압, 코막힘, 호흡곤란, 코피, 부비동 충혈, 구역, 변비, 소화불량, 구토, 설사, 타액 과다분비, 입안 건조, 복부 불쾌감, 복부 통증, 위장 불쾌감, 상복부 통증, 발진, 피부 건조, 비듬, 지루성 피부염, 각화과다증, 등통증, 관절통, 팔다리 통증, 요실금, 사정 부전, 피로, 무력증, 발열, 가슴통증,혈액 크레아티닌 포스포키나아제 상승, 심박수 증가, 정맥혈전증<br />∙ 신경이완제악성증후군(Neuroleptic Malignant Syndrome) : 항정신병약, 항우울약 및 도파민작동성 항파킨슨약과의 병용시, 이 약 및 병용약의 감량 또는 중지에 의해 발열, 무동함묵, 의식장애, 중증의 근강직, 불수의운동, 연하곤란, 빈맥, 혈압변동, 발한 등이 나타날 수 있다. 이러한 증상이 나타나는 경우에는 체냉각, 수분보급 등의 전신관리 등 적절한 처치를 한다.</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_SULPIRIDE" data-drug-number="103">
          <thead>
            <tr>
              <th className="drug-number">103</th>
              <th className="drug-name">설피리드(Sulpiride)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항정신용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_SULPIRIDE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제]정신분열증, 우울증, 정신신경증</td>
            </tr>
            <tr id="KDGERI_SULPIRIDE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>크롬친화세포종 환자(급격한 승압발작 유발), 크롬락틴의존성 종양 환자 또는 상피성 유방종양 환장, 조증환자, 간질환자</td>
            </tr>
            <tr id="KDGERI_SULPIRIDE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) <br />∙ 정신분열증: 1일 300-600㎎을 2-3회 분할투여, 1일 1200mg까지 증량 가능<br />∙ 우울증: 1일 150-300㎎을 2-3회 분할투여, 1일 600㎎까지 증량 가능<br />∙ 정신신경증: 1회 50-100㎎씩 1일 3회</td>
            </tr>
            <tr id="KDGERI_SULPIRIDE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당품목<br /> - 치매환자에서 뇌졸증 등 심혈관계 질환의 위험 증가하여 비약물학적 치료가 실패한 경우에만 제한적 사용<br /> - 낙상 및 골절 이력 있는 환자에서 운동실조, 실신 및 추가적인 낙상 유발하여 투여 추천되지 않음<br /> - 항이뇨호르몬부적절분비증후군 또는 저나트륨혈증을 악화시킬 수 있으므로 혈중 나트륨농도 모니터링하며 제한적 사용</td>
            </tr>
            <tr id="KDGERI_SULPIRIDE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 메토클로프라미드, 티아프리드 등) 다른 벤자미드계 약물 (내분비기능 이상 또는 추제외로증상 부작용 증가) <br />∙ 아트로핀, 메칠스코플라민 등 항콜린약 (길항효과) <br />∙ 디기탈리스제제 (구역, 구토, 식욕부진 증상 은폐)</td>
            </tr>
            <tr id="KDGERI_SULPIRIDE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>경련, 지발성 운동장애, 심전도 변화(급격히 증량할 경우), 파킨슨증후군(진전, 근강직, 타액분비항진 등), 이상운동증(dyskinesia : 혀의 굳어짐, 언어장애, 안구회전, 주시경련, 연하곤란 등), 유즙분비, 여성형 유방이 월경이상, 사정불능, 수면장애, 불안, 초조, 졸음, 흥분, 건망증, 몽롱한 상태, 배회, 다동, 억제결여, 무욕상태, 경련, 조전 및 조증상태, 구갈, 구역, 구토, 변비, 식욕부진, 위･복부불쾌감, ALT, AST, ALP 등의 상승, 발진, 부종, 체중증가, 성욕감퇴, 빈뇨, 요통<br />∙ 신경이완제악성증후군(Neuroleptic Malignant Syndrome) : 항정신병약, 항우울약 및 도파민작동성 항파킨슨약과의 병용시, 이 약 및 병용약의 감량 또는 중지에 의해 발열, 무동함묵, 의식장애, 중증의 근강직, 불수의운동, 연하곤란, 빈맥, 혈압변동, 발한 등이 나타날 수 있다. 이러한 증상이 나타나는 경우에는 체냉각, 수분보급 등의 전신관리 등 적절한 처치를 한다.</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ZIPRASIDONE" data-drug-number="104">
          <thead>
            <tr>
              <th className="drug-number">104</th>
              <th className="drug-name">지프라시돈(Ziprasidone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항정신용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ZIPRASIDONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제]정신분열병(조현병), 양극성 장애 1형- 양극성 장애 1형과 관련된 조증 혹은 혼재 삽화 (episode)의 급성치료- 양극성 장애 1형 치료 유지를 위한 보조요법</td>
            </tr>
            <tr id="KDGERI_ZIPRASIDONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 최근에 급성 심근 경색증의 병력이 있는 환자, 비보상성 심부전 환자, QT 간격 연장의 가능성이 있는 상태의 환자, Class I과 Class III에 속하는 항부정맥 약물로 치료받는 부정맥 환자</td>
            </tr>
            <tr id="KDGERI_ZIPRASIDONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량, 고령자에서 용량조절 불필요) <br />∙ 정신분열병<br /> - 급성치료: 1회 40mg씩 1일 2회 음식물과 복용. 최소 2일 간격으로 증량. 최대용량은 1회 80mg씩 1일 2회<br /> - 유지요법: 최소유효용량 복용. 1회 20mg씩 1일 2회 복용으로 충분한 경우가 많음<br />∙ 양극성 장애 1형과 관련된 조증 혹은 혼재 삽화의 급성치료<br /> - 초기요법: 1회 40mg씩 1일 2회, 2일째에 1회 60-80mg씩 1일 2회, 이후 내약성 및 효능에 따라 1회 40-80mg씩 1일 2회. 임상시험에서 평균 1회 60mg씩 1일 2회 투여함<br /> - 유지요법: 통제된 임상시험을 통해 입증된 단독치료 자료 없음<br />∙ 양극성 장애 1형 치료 유지를 위한 기분안정제(리튬 또는 발프로산)의 보조요법<br /> - 1회 40-80mg씩 1일 2회. 초기 치료시 안정되었던 용량과 동일하게 유지</td>
            </tr>
            <tr id="KDGERI_ZIPRASIDONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당품목<br /> - 투여 추천되지 않음치매환자에서 뇌졸증 등 심혈관계 질환의 위험 증가낙상 및 골절 이력 있는 환자에서 운동실조, 실신 및 추가적인 낙상 유발 파킨슨 환자에서 파킨슨증상 악화<br /> - 제한된 경우에 사용가능치매의 비약물학적 치료가 실패한 경우항이뇨호르몬부적절분비증후군 또는 저나트륨혈증을 악화시킬 수 있으므로 혈중 나트륨농도 모니터링이 필요함</td>
            </tr>
            <tr id="KDGERI_ZIPRASIDONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ Type IA, IIIA 항부정맥 약물 (QTc 연장) <br />∙ 케토코나졸 (강력한 CYP3A4 저해로 이 약 혈청농도 증가) <br />∙ 카바마제핀 (CYP3A4 유도로 이 약 AUC, Cmax 감소) <br />∙ 다른 중추신경계 작용 약물<br />∙ 도파민 수용체 효현제 (해당약물 작용 길항)</td>
            </tr>
            <tr id="KDGERI_ZIPRASIDONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>∙ 무력, 두통, 변비, 구갈, 타액분비증가, 구역, 구토, 체중감소, 초조, 정좌불능, 불안, 어지러움, 운동장애, 근긴장이상, 추체외로 증후군, 과다근육긴장증, 불면, 졸림, 떨림, 발진, 두드러기<br />∙ 신경이완제악성증후군(Neuroleptic Malignant Syndrome) : 항정신병약, 항우울약 및 도파민작동성 항파킨슨약과의 병용시, 이 약 및 병용약의 감량 또는 중지에 의해 발열, 무동함묵, 의식장애, 중증의 근강직, 불수의운동, 연하곤란, 빈맥, 혈압변동, 발한 등이 나타날 수 있다. 이러한 증상이 나타나는 경우에는 체냉각, 수분보급 등의 전신관리 등 적절한 처치를 한다.</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ZOTEPINE" data-drug-number="105">
          <thead>
            <tr>
              <th className="drug-number">105</th>
              <th className="drug-name">죠테핀(Zotepine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항정신용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ZOTEPINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>정신분열병(조현병)</td>
            </tr>
            <tr id="KDGERI_ZOTEPINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 및 페노티아진계 약물, 티오잔틴계 약물 및 그 유사체에 과민증, 혼수상태, 순환허탈상태의 환자 (혼수상태 악화), 중추신경억제제을 투여받고 있는 환자, 에피네프린을 투여받고 있는 환자, 급성 알코올 중독환자, 조혈기능장애 환자, 테르페나딘, 아스테미졸을 투여중인 환자, 조혈능 장애</td>
            </tr>
            <tr id="KDGERI_ZOTEPINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) 1일 75-150mg 분할 경구투여. 증상에 따라 1일 450mg까지 증량, 최소유효량 투여1일 복용량이 300mg 이상인 경우 4시간 이상의 간격으로 투여</td>
            </tr>
            <tr id="KDGERI_ZOTEPINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당품목 (항정신병약)<br /> - 치매환자에서 뇌졸증 등 심혈관계 질환의 위험 증가하여 비약물학적 치료가 실패한 경우에만 제한적 사용<br /> - 낙상 및 골절 이력 있는 환자에서 운동실조, 실신 및 추가적인 낙상 유발하여 투여 추천되지 않음<br /> - 항이뇨호르몬부적절분비증후군 또는 저나트륨혈증을 악화시킬 수 있으므로 혈중 나트륨농도 모니터링하며 제한적 사용<br />∙ 중증 천식, 폐기종, 호흡기감염증, 만성호흡장애 등의 환자에게 신중투여 (유사화합물인 페노티아진계 약물에서 호흡억제가 보고됨) <br />∙ 고령자는 추체외로증상 등의 부작용이 나타나기 쉬우므로 신중투여<br />∙ 경증-중등증의 간부전 환자에 투여시 감량, 간기능 모니터 요함</td>
            </tr>
            <tr id="KDGERI_ZOTEPINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 테르페나딘, 아스테미졸 (QT 연장, 심실성 부정맥-병용금기) <br />∙ 에피네프린 (중증의 혈압강하-병용금기) <br />∙ 알코올, 중추신경억제제(바르비탈산유도체, 마취제 등), 혈압강하제, 아트로핀형 작용을 가진 약물 (상호작용) <br />∙ 펜테트라졸 (경련) <br />∙ 구아네티딘, 클로니딘, α-메틸도파 (혈압강하효과 감소) <br />∙ 항콜린제 (항콜린작용 증강) <br />∙ 브로모크립틴, 아만타딘, 레보도파 등 도파민효능제 (효능작용 감소) <br />∙ 메트로클로프라미드, 브로모프라이드, 알리자프라이드 등 도파민길항제 (추체외로 이상반응증가) <br />∙ 바르비츄레이트, 카르바마제핀 등 효소유도제(신경이완제 대사 촉진) <br />∙ 프로프라놀롤, 삼환계항우울제 (상호혈중농도 상승) <br />∙ 리튬 (상호혈중농도 상승, 위험한 신경중독 증상, 고혈당증 및 당뇨병 위험 증가)<br /><br />∙ 페니토인 (해당 약 혈중농도 상승) <br />∙ 카페인 (항정신병약, 신경이완제 효과 감소) <br />∙ 다른 신경이완제 (경련역치 저하) <br />∙ 바르비탈계약물 및 마약성진통제 (호흡억제작용) <br />∙ 항응고제 (항응고작용증강) <br />∙ 유기인살충제 (상호작용 증강, 접촉주의)</td>
            </tr>
            <tr id="KDGERI_ZOTEPINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>심전도 이상, 마비성 장폐색, 경련발작, 지연이상운동, 항이뇨호르몬분비이상증후군(SIADH), 자극전도장애, 기립성조절장애, 변비, 구역, 구토, 식욕부진, 복부불쾌감, 담즙울체, 추체외로증상, 졸음, 뇌파이상, 헛소리(특히 항콜린약과 병용시), 우울, 졸리움, 후부두종, 천식, 시야조절 장애, 땀샘 분비 장애, 탄수화물대사장애, 성기능장애, 각막 또는 수정체혼탁(고용량으로 장기치료시), 조절장애, 녹내장(좁은앞방각녹내장), 얼굴홍조, 광민감반응, 부종, 조혈기능장애(무과립구증), 혈청뇨산저하, 전신홍반루프스(SLE)양 증상<br />∙ 신경이완제악성증후군(Neuroleptic Malignant Syndrome) : 항정신병약, 항우울약 및 도파민작동성 항파킨슨약과의 병용시, 이 약 및 병용약의 감량 또는 중지에 의해 발열, 무동함묵, 의식장애, 중증의 근강직, 불수의운동, 연하곤란, 빈맥, 혈압변동, 발한 등이 나타날 수 있다. 이러한 증상이 나타나는 경우에는 체냉각, 수분보급 등의 전신관리 등 적절한 처치를 한다.</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_AMITRIPTYLINE" data-drug-number="106">
          <thead>
            <tr>
              <th className="drug-number">106</th>
              <th className="drug-name">아미트리프틸린(Amitriptyline)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항우울제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_AMITRIPTYLINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>우울증, 우울상태, 야뇨증</td>
            </tr>
            <tr id="KDGERI_AMITRIPTYLINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>삼환계 항우울약에 과민증 환자, 심근경색 회복초기 환자(순환기계에 영향을 미쳐 심근경색이 악화될 수 있다.), 녹내장 환자(항콜린작용이 있어 증상이 악화될 수 있다.), 중추신경억제제 또는 알코올 급성 중독 환자, 급성 섬망 환자, 전립선비대 등 배뇨장애 환자, 부정맥 환자, 대뇌손상, 무과립구증 환자, MAO 저해제를 투여중인 환자</td>
            </tr>
            <tr id="KDGERI_AMITRIPTYLINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 30-75㎎/일, 2-3회 분할 투여(일반용량)필요시 150mg/일까지 증량 가능1일 최대투여량: 300mg야뇨증: 1회 10-30mg씩 1일 1회 취침전연령, 증상에 따라 적절히 증감</td>
            </tr>
            <tr id="KDGERI_AMITRIPTYLINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당약품<br />∙ 고령자는 저용량으로 투여 시작(기립성 저혈압, 비틀거림, 항콜린작용에 의한 구갈, 배뇨곤란, 변비, 안내압항진 등의 이상반응 위험)등 신중투여<br />∙ 심질환, 갑상선기능항진증, 경련성 질환, 조울증, 뇌의 기질적 장애, 조울증, 배뇨곤란, 안압항진, 고령자 등 신중투여<br />∙ 질환의 악화, 자살 성향 또는 적개심, 공격성, 분노 등 다른 비정상적인 행동의 변화가 있는지 주의 깊게 관찰<br />∙ 항우울 효과: 투여 4-10일 후 발현(6주 후 발현하기도 함), 증상 개선 후에도 수개월간 투여를 계속할 필요가 있음(증상 재발 방지) <br />∙ 위험을 수반하는 기계조작하지 말 것(졸음, 주의력･집중력･반사운동능력 등의 저하) <br />∙ 수술할 경우 수일 전 투여 중지 할 것<br />∙ 강한 항콜린 작용, 진정 작용, 기립성 저혈압 발생 가능성으로 노인환자에게 금기(2012 Beers criteria)</td>
            </tr>
            <tr id="KDGERI_AMITRIPTYLINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ MAO저해제(발한, 불온, 전신경련, 이상고열, 혼수) <br />∙ 알코올섭취, 항콜린작용약, 에피네프린 작용약, 중추신경억제제(아미트리프틸린의 작용 증강) <br />∙ 퀴니딘, 아미오다론 등의 부정맥용제(병용금기) <br />∙ 혈압강하제(혈압강하제의 작용 감소) <br />∙ 설파메톡사졸, 트리메토프림 등의 항균제(아미트리프틸린의 작용 저하) <br />∙ 디설피람(섬망) <br />∙ 피모짓 등 심전도 영향 약물(병용금기)</td>
            </tr>
            <tr id="KDGERI_AMITRIPTYLINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>신경이완제악성증후군, 심근경색, 뇌졸중, 실신, 저혈압(특히 기립성 저혈압), 고혈압, 빈맥･서맥, 심계항진, 부정맥, 심블록, 심발작, ECG이상, 알레르기성 혈관염, 혼수, 집중력장애, 방향감각상실, 망상, 환각, 헛소리, 정신착란, 흥분, 불안, 불면, 악몽, 마비, 이명, 사지의 감각이상, 말초신경병증, 운동실조, 경련발작, 진전, 지발성 운동장애 등의 추체외로증상, 두통, 피로, 졸음, 구음장애, EEG상의 변화, 초조, 구갈, 배뇨곤란, 시조절장애, 안내압항진, 변비, 발한, 빈뇨, 산동, 이상 고열, 발진, 두드러기, 안면･설부부종, 광과민증, 무과립구증, 백혈구감소, 자반, 혈소판감소, 호산구증가, 구역, 구토, 식욕부진, 설사, 미각이상, 상복부장애, 구내염, 이하선부종, 혀의 흑변, 고환부종 및 여성형 유방, 여성에서 유방팽대, 유즙분비, 성욕감퇴･증가, 혈당저하･상승, 성기능장애, 골절, 어지러움, 체중증가･감소, 탈모증, 입주위 등의 불수의운동</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_AMOXAPINE" data-drug-number="107">
          <thead>
            <tr>
              <th className="drug-number">107</th>
              <th className="drug-name">아목사핀(Amoxapine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항우울제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_AMOXAPINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>우울증</td>
            </tr>
            <tr id="KDGERI_AMOXAPINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 및 Dibenzoxazepine계 약물에 과민반응의 병력이 있는 환자, MAO억제제를 투여 받고 있는 환자, 최근에 심근경색이나 관상동맥부전을 앓았던 환자, 심장차단이나 다른 심부정맥 환자, 요도전립선 장애로 인한 요저류 환자, 폐쇄각 녹내장의 위험이 있는 환자, 조증환자, 중증의 간질환 환자, 알코올, 클로니딘 및 유도체, 비경구용 아드레날린, 노르아드레날린 및 도파민을 투여 받고 있는 환자</td>
            </tr>
            <tr id="KDGERI_AMOXAPINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>초기용량: 1회 25mg씩 1일 2-3회(고령자용량) 1회 50mg씩 1일 2-3회로 증량 가능(고령자용량)</td>
            </tr>
            <tr id="KDGERI_AMOXAPINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙고령자는 저용량으로 투여 시작(기립성 저혈압, 어지러움, 항콜린작용에 의한 목마름, 배뇨곤란, 변비, 안내압항진, 특히 초조감, 착란 등의 이상반응 위험) <br />∙심혈관계 장애, 기립성 저혈압과 진정작용 등의 과민반응을 보이거나 만성변비, 전립선 비대증 환자, 경련장애 병력 환자, 혈액질환, 간질환, 신질환 환자 등 신중투여<br />∙질환의 악화, 자살 성향 또는 적개심, 공격성, 분노 등 다른 비정상적인 행동의 변화가 있는지 주의 깊게 관찰<br />∙지연이상운동(비가역적이고, 불수의적인, 운동장애를 포함하는 증후군), 신경이완제악성증후군 주의<br />∙투여 중단시 천천히 감량함(금단증상 방지)위험을 수반하는 기계조작하지 말 것(졸음, 주의력･집중력･반사운동능력 등의 저하)</td>
            </tr>
            <tr id="KDGERI_AMOXAPINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>[병용금기] <br />∙비선택성의 MAO억제제(세로토닌성 증후군) <br />∙설토프리드(심실리듬 장애) [권장되지 않는 병용] <br />∙비경구용 아드레날린, 노르아드레날린 및 도파민(리듬장애를 수반한 발작성 고혈압) <br />∙알코올(아목사핀의 진정효과 증가) <br />∙클로니딘 및 유사체(클로니딘의 항고혈압 작용 억제) <br />∙선택성의 MAO-A억제제(세로토닌성 증후군) [사용 시 주의를 요하는 배합] <br />∙아드레날린 및 노르아드레날린(리듬장애를 수반한 발작성 고혈압) <br />∙항경련제(전신경련 위험) <br />∙카르바마제핀(전신 경련성 발작) <br />∙세로토닌계 항우울제(경련발작의 위험성 증가) <br />∙간대사효소(CYP-450 2D6)를 억제시키는 약물(혈중농도 유의하게 증가)</td>
            </tr>
            <tr id="KDGERI_AMOXAPINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>[기타 상호작용] <br />∙ 항고혈압제(항고혈압 효과 및 기립성 저혈압의 위험성 증가) <br />∙ 중추신경계 억제제(중추신경 억제 작용이 증가) <br />∙ 항히스타민제, 바르비탈계 약물, 항파킨슨제, 항콜린제, 아트로핀성 항경련제, disopyramide, 신경이완제, 페노티아진계등의 아트로핀 및 다른 아트로핀류 약물(요폐색, 변비, 구강건조 등의 아트로핀성 이상반응) <br />∙ 바클로펜(근육의 긴장저하) <br />∙ 마취제(부정맥 및 저혈압의 위험성 증가)졸음, 구강건조증, 변비, 부종, 심계항진, 불안, 운동실조, 혼란, 어지러움, ECG변화, 흥분, 피로, 두통, 불면, 신경과민, 악몽, 발한, 발진, 혈중 프로락틴 증가, 식욕 증가, 오심, 진전, 흐린 시력 등신경정신계</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_BUPROPION" data-drug-number="108">
          <thead>
            <tr>
              <th className="drug-number">108</th>
              <th className="drug-name">부프로피온(Bupropion)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항우울제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_BUPROPION_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>(속효제) 주요 우울증(서방제) 우울증, 금연시 니코틴 의존을 치료하기 위한 단기간의 보조요법</td>
            </tr>
            <tr id="KDGERI_BUPROPION_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약의 주성분 또는 다른 성분에 과민증이 있는 환자, 발작 장애 또는 발작 병력이 있는 환자, 중추신경계 종양이 있는 환자, 알코올 또는 복용 중단 시 발작위험과 관련있는 약물을 갑자기 중단한 환자, 대식증 또는 신경성 식욕부진을 현재 또는 과거에 진단 받은 환자, MAO 억제제를 투여중인 환자, 양극성 장애의 병력이 있는 환자, 부프로피온염산염을 함유하고 있는 다른 약을 투여받고 있는 환자</td>
            </tr>
            <tr id="KDGERI_BUPROPION_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙ 우울증(일반용량) (속효제)<br /> - 초기용량 1회 100mg씩 1일 1회 4일간, 이후 1회 100mg씩 1일 3회<br /> - 1일 최대투여량: 450mg (서방제)<br /> - 초기용량 1회 150mg씩 1일 1회 4일간, 이후 1회 150mg씩 1일 2회<br /> - 1일 최대투여량: 400mg<br /> - 간질환 환자: 1일 최대 투여량: 100mg, 또는 150mg/2일 이하<br />∙ 금연시 니코틴 의존 치료(일반용량) (서방제)<br /> - 초기용량 1회 150mg씩 1일 1회 6일간, 이후 1회 150mg씩 1일 2회(최소 8시간 간격)<br /> - 1일 최대투여량: 300mg</td>
            </tr>
            <tr id="KDGERI_BUPROPION_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당약품<br />∙ 일부 고령자에서 부프로피온에 대한 민감성이 더 크게 나타남<br />∙ 고령자에서 단회 및 반복 투여시 부프로피온과 그 대사체가 축적될 위험성이 높음<br />∙ 고령자는 신기능이 감소되어 있을 가능성이 높으므로 투여횟수 및 투여량의 감소가 요구 됨(독성 반응의 위험성은 신기능이 손상된 환자에서 더 클 수 있음) <br />∙ 정신병 및 조증 환자, 자살 기도 환자, 알러지 반응, 심혈관계 질환이 있는 환자, 발작의 위험이 있는 환자, 간･신장애 환자 등 신중투여<br />∙ 질환의 악화, 자살 성향 또는 적개심, 공격성, 분노 등 다른 비정상적인 행동의 변화가 있는지 주의 깊게 관찰<br />∙ 용량증가와 함께 발작률의 불균형한 증가가 나타나므로 투여용량에 주의를 요함<br />∙ 간･신장애 환자는 투여횟수 및/또는 투여량 감소가 필요<br />∙ 심혈관계 질환(고혈압, 관상동맥)에서 본 약물 투여 후 치료가 필요한 고혈압 발생이 보고된 바 있으므로 투여기간 중 정기적 혈압측정을 권고함. <br />∙ 위험을 수반하는 기계조작하지 말 것(판단 또는 운동 및 인식기능을 요구하는 능력에 영향) <br />∙ 식욕 및 체중감소 주의<br />∙ 발작의 역치를 낮추므로 만성 간질 또는 발작 노인에게 부적절, 다른 약물로 효과가 없는 간질 환자에게는 사용이 가능(2012 Beers criteria)</td>
            </tr>
            <tr id="KDGERI_BUPROPION_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 올페나드린, 사이클로포스파미드 이포스파미드, 티클로피딘, 클로피도그렐 등(부프로피온의 활성 대사체의 대사 변경) <br />∙ carbamazepine, phenobarbital, phenytoin(부프로피온의 대사 유도) <br />∙ valproate(부프로피온의 대사 저해) <br />∙ 항우울제, 항정신병약, β-차단제, 그리고 1C 타입 항부정맥제 등 CYP2D6 isoenzyme에 의해 대사되는 약물(저용량으로 투여 시작할 것) <br />∙ MAO저해제(부프로피온의 급성독성 증강) <br />∙ 레보도파, 아만타딘(신경정신학적 이상반응의 발생률 증가) <br />∙ 발작 역치를 낮추는 약물(주의 필요) <br />∙ 알코올(병용을 피해야 함) <br />∙ 리토나비어(부프로피온 및 그 주요 대사체의 노출이 용량 의존적으로 감소, 부프로피온의 용량을 증가시킬 필요 있음)</td>
            </tr>
            <tr id="KDGERI_BUPROPION_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>심계항진, 두통, 초조, 현기, 불면, 발한, 체중감소, 구강건조증, 오심, 시야혼탁, 인두염, 심부정맥, 흉통, 고혈압, 홍조, 저혈압, 착란, 불안, 적개심, 신경과민, 감각이상, 수면장애, 편두통, 기억력장애, 졸음, 과민성, 통증, 정좌불능, 중추신경흥분, 지각이상, 단일수축, 우울, 발적, 가려움, 두드러기, 체중증가, 월경이상, 성욕저하, 일과성 열감, 변비, 복통, 설사, 고창, 식욕저하, 미각장애, 구토, 소화불량, 연하곤란, 절박뇨, 질출혈, 요로감염, 과민반응, 감염, 진전, 근육통, 관절통, 관절염, 목통증, 이명, 청각이상, 다뇨, 상기도 감염, 기침, 부비강염, 발열 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_CITALOPRAM" data-drug-number="109">
          <thead>
            <tr>
              <th className="drug-number">109</th>
              <th className="drug-name">시탈로프람(Citalopram)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항우울제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_CITALOPRAM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>우울증, 공황장애, 강박장애</td>
            </tr>
            <tr id="KDGERI_CITALOPRAM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 또는 이 약의 구성성분에 과민반응이 있는 환자, 14일 이내 MAO 저해제를 투여 중인 환자, 중증 신장애(CrCl 20mL/min이하), 피모지드 투여 중인 환자, 선천성 QT연장 증후군 또는 QT 간격 연장이 있는 환자, QT 간격 연장 유발 약물을 복용 중인 환자</td>
            </tr>
            <tr id="KDGERI_CITALOPRAM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구] (일반용량) <br />∙ 우울증<br /> - 초기용량 1회 20mg씩 1일 1회, 일주일 이내 간격으로 증량<br />∙ 1일 최대투여량: 40mg(40mg이상 투여해도 치료효과는 증가하지 않음) <br />∙ 공황장애<br /> - 첫 일주일 동안 1회 10mg씩 1일 1회, 개별적인 반응에 의존하여 증량<br /> - 1일 최대투여량: 40mg <br />∙ 강박장애<br /> - 초회용량 1회 20mg씩 1일 1회, 필요시 점차 증량<br /> - 1일 최대투여량: 40mg (고령자용량) 60세 이상의 환자의 경우 1일최대추천용량: 20mg</td>
            </tr>
            <tr id="KDGERI_CITALOPRAM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 노인에서 우울증상, 불안, 초조 등의 증상 개선. 인지기능 개선효과는 일관성 없음<br />∙ 노인 및 간질환자, 신기능 저하 환자에서 반감기상승<br />∙MAO 저해제와 병용투여시 진전, 간대성 근경련, 발한, 오심, 구토, 홍조, 현기, 신경이완제 악성증후군과 유사한 특징을 나타내는 고열, 경련 유발가능<br />∙ 경련환자, 뇌손상, 알코올중독자 등에서 경련 유발가능<br />∙ NSAID, aspirin 및 기타 항응고약물 복용환자에서 출혈위험 증가<br />∙항이뇨 호르몬 분비이상 증후군(syndrome of inappropriate ADH)이 발생할 수 있으므로 필요시 전해질(특히 나트륨) 측정을 시행할 것을 권고<br />∙ 양극성 장애 환자에서 조증을 악화시킬 수 있음</td>
            </tr>
            <tr id="KDGERI_CITALOPRAM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 피모지드 (QT간격 증가, 병용하지 말 것) <br />∙ 카르베딜롤 (극심한 베타차단효과로 인한 서맥) <br />∙ 클로자핀 (일부 SSRI와 동시 투여시 클로자핀 혈청농도 상승, 약리학적 효과와 독작용 증가) <br />∙ NSAIDs (위장관 부작용 위험 증가) <br />∙ 항편두통제(selective 5-HT1 receptor agonists), MAO저해제(selegiline) (세로토닌 증후군 유발 가능</td>
            </tr>
            <tr id="KDGERI_CITALOPRAM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>기면, 불면, 발한, 구역, 구갈, QT 간격 연장, 저혈압, 기립저혈압, 빈맥, 서맥, 피로감, 초조, 불안, 하품, 두통, 어지러움, 식욕저하, 떨림, 사정지연, 발기부전, 상기도감염, 비염, 부비동염 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_CLOMIPRAMINE" data-drug-number="110">
          <thead>
            <tr>
              <th className="drug-number">110</th>
              <th className="drug-name">클로미프라민(Clomipramine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항우울제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_CLOMIPRAMINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>진정이 요구되는 우울증, 강박상태, 공포상태, 수면발작과 관련된 급발작</td>
            </tr>
            <tr id="KDGERI_CLOMIPRAMINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약에 과민증 환자, 삼환계 항우울약(디벤자제핀계열)에 교차과민증이 있는 환자, 이 약의 투여전후 14일 이내에 MAO저해제(모클로베미드와 같은 선택적, 가역적인 MAO-A저해제도 포함), 선택적인 세로토닌 재흡수 저해제(SSRI), 세로토닌-노르에피네프린 재흡수 저해제(SNRI), 선택적인 세로토닌 효현제(트립탄류)를 투여하고 있는 환자, 최근의 심근경색 환자, 녹내장 환자(항콜린작용에 의해 증상이 악화될 수 있다.)</td>
            </tr>
            <tr id="KDGERI_CLOMIPRAMINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (고령자용량)초회용량: 1회 10mg씩 1일 1회 취침전필요시 30-50㎎/일까지 증량할 수 있으며, 분할투여 가능함</td>
            </tr>
            <tr id="KDGERI_CLOMIPRAMINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당약품<br />∙ 고령자: 항콜린성 이상반응, 신경정신과적 또는 심혈관계 이상반응에 민감. 심기능 및 EEG를 계속적으로 모니터하면서 신중투여(고령자는 약물의 대사, 배설능력이 감소되어 있어 치료용량의 투여로도 혈장농도가 상승되는 위험 초래 가능) <br />∙ 심질환, 갑상선기능항진증, 경련성 질환, 조울증, 뇌의 기질적 장애, 조울증, 배뇨곤란, 안압항진, 고령자 등 신중투여<br />∙ 질환의 악화, 자살 성향 또는 적개심, 공격성, 분노 등 다른 비정상적인 행동의 변화가 있는지 주의 깊게 관찰 <br />∙ 투여 중단시 수주나 수개월에 거쳐 점진적으로 용량 감량할 것<br />∙ 위험을 수반하는 기계조작하지 말 것(졸음, 주의력･집중력･반사운동능력 등의 저하) <br />∙ 강한 항콜린 작용, 진정 작용, 기립성 저혈압 발생 가능성으로 노인환자에게 금기(2012 Beers criteria)</td>
            </tr>
            <tr id="KDGERI_CLOMIPRAMINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ MAO저해제(고혈압위기, 이상고열증, 근간대경련, 격월성 발작, 정신착란, 혼수) <br />∙ 아드레날린성 신경차단제(항고혈압 효과의 저하 또는 상쇄) <br />∙ 교감신경흥분약(교감신경흥분약의 심혈관 효과 증강) <br />∙ 중추신경억제제, 알코올(중추신경억제제의 효과 증강) <br />∙ 항콜린약(항콜린성 약물의 눈, 중추신경계, 위장관, 방광에 대한 효과 증강) <br />∙ 퀴니딘(병용금기) <br />∙ 선택적인 세로토닌 재흡수 저해제(SSRI), 세로토닌-노르에피네프린 재흡수 저해제(SNRI), 선택적인 세로토닌 효현제(세로토닌 증후군) <br />∙ 간효소유도제(클로미프라민의 효과 감소), 페니토인, 카르바마제핀(이상반응 유발) <br />∙ 항정신병약(간질유발), 치오리다진(심한 심부정맥) <br />∙ 항응고제(항응고효과 증강)시메티딘, 메칠페니데이트, 에스트로겐(클로미프라민의 혈장농도 상승)<br />신경정신계</td>
            </tr>
            <tr id="KDGERI_CLOMIPRAMINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>기립성 저혈압, 심계항진, 현기, 졸음, 두통, 피로, 불면, 신경과민, 간대성 근경련, 발한, 성욕변화, 체중증가, 구강건조증, 변비, 오심, 소화불량, 식욕부진, 설사, 복통, 식욕증가, 사정장애, 발기부전, 배뇨곤란, 진전, 근육통, 시각장애, 인두염, 비염, 홍조, 흉통, 심계항진, ECG이상, 실신, 불안, 이상감각, 기억력 저하, 수면장애, 단일수축, 우울, 집중력 저하, 통증, 긴장항진, 초조, 혼돈, 편두통, 정신신체장애, 언어장애, 하품, 공격성, 오한, 정서불안, 과민성, 불완전마비, 근무력증, 공황, 발적, 가려움, 피부염, 피부건조증, 두드러기, 체중저하, 일과성 열감, 월경이상, 무월경, 미각장애, 구토, 고창, 아프타성 구내염, 연하곤란, 위장병, 구취, 식도염, 뇨저류, 요로감염, 빈뇨, 젖분비, 방광염, 백대하, 질염, 유방통, 자반병, ALT,AST상승, 과민반응, 눈물, 동공 부동증, 안검 경련, 산동, 눈 알러지, 결막염, 이명, 기관지 경련, 부비강염, 호흡곤란, 코피, 후두염, 발열 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_DESVENLAFAXINE" data-drug-number="111">
          <thead>
            <tr>
              <th className="drug-number">111</th>
              <th className="drug-name">데스벤라팍신(Desvenlafaxine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항우울제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_DESVENLAFAXINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>주요 우울증</td>
            </tr>
            <tr id="KDGERI_DESVENLAFAXINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>데스벤라팍신숙신산염, 벤라팍신염산염 또는 이 약의 구성성분에 대하여 과민증이 있는 환자, MAO억제제 투여를 중단한 후 14일이 지나지 않은 환자</td>
            </tr>
            <tr id="KDGERI_DESVENLAFAXINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 50mg씩 1일 1회, 1일 최대투여량: 200mg (일반용량)나누거나, 분쇄하거나, 씹거나, 물에 녹여 복용하지 않음</td>
            </tr>
            <tr id="KDGERI_DESVENLAFAXINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자: 수축기 기립성 저혈압, 저나트륨혈증 주의<br />∙ 고령자 투여용량: 신청소율 감소 가능성을 고려하여 결정<br />∙ 고혈압 또는 심질환자, 조증/경조증 병력이나 가족력이 있는 환자, 발작 환자, 신장애 환자, 간장애 환자, 황색5호 성분에 과민하거나 알레르기 병력이 있는 환자 등 신중투여<br />∙ 질환의 악화, 자살 성향 또는 적개심, 공격성, 분노 등 다른 비정상적인 행동의 변화가 있는지 주의 깊게 관찰<br />∙ 세로토닌 증후군 주의<br />∙ 양극성 장애에 대한 환자선별 필요(양극성 우울증 치료에 대해 승인되지 않았음: 혼합된/조증 에피소드 촉진 가능성) <br />∙ 비정상적인 출혈, 동공확대, 금단증상, 저나트륨혈증, 간질성 폐질환 및 호산구성 폐렴 주의<br />∙ 신기능, 혈압, 혈중지질, 세로토닌 증후군 증상/징후 등 모니터링 필요</td>
            </tr>
            <tr id="KDGERI_DESVENLAFAXINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ MAO 억제제, 세로토닌성 약물(세로토닌 증후군) <br />∙ 항응고 약물(출혈의 위험성을 증가) <br />∙ 데스벤라팍신과 벤라팍신을 함유하는 약물(이상반응 증가) <br />∙ 알코올(병용을 피해야 함)</td>
            </tr>
            <tr id="KDGERI_DESVENLAFAXINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>현기, 불면, 다한증, 오심, 구강건조증, 기립성 저혈압, 실신, 심계항진, 고혈압, 졸음, 피로, 불안, 사정지연, 신경과민, 근긴장이상, 집중력저하, 탈모, 광과민반응, 발진, 성욕저하, 혈중콜레스테롤 증가, 프로락틴 증가, 체중증가, 일과성 열감, LDL 콜레스테롤 증가, 변비, 식욕저하, 구토, 단백뇨, 발기부전, 뇨저류, 간기능 이상, 혈관부종, 진전, 시야혼탁, 산동, 이명 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_DOTHIEPIN" data-drug-number="112">
          <thead>
            <tr>
              <th className="drug-number">112</th>
              <th className="drug-name">도치에핀(Dothiepin)= 도술레핀(Dosulepin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항우울제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_DOTHIEPIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>우울증, 우울상태</td>
            </tr>
            <tr id="KDGERI_DOTHIEPIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>최근의 심근경색, 심차단, 부정맥 환자, 조증 환자, 중증의 간질환 환자, 녹내장 환자(산동, 안압항진 등의 항콜린작용으로 인해 증상이 악화될 수 있다.), 삼환계 항우울약에 과민증 환자, MAO저해제를 투여중인 환자, 전립선비대 환자</td>
            </tr>
            <tr id="KDGERI_DOTHIEPIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>초기용량: 50-75mg/일 분할투여(고령자용량)</td>
            </tr>
            <tr id="KDGERI_DOTHIEPIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 고령자는 혈중농도가 높게 지속되는 경향이 있음<br />∙ 고령자는 저용량으로 투여 시작(흥분, 착란, 기립성 저혈압, 비틀거림, 항콜린작용에 의한 구갈, 배뇨곤란, 변비, 안내압항진)등 신중투여<br />∙ 배뇨곤란, 안내압항진, 심질환, 갑상선기능항진증, 조울증, 뇌의 기질적 장애, 고령자 등 신중투여<br />∙ 우울증의 개선효과는 투여 2-4주 후에 나타남<br />∙ 위험을 수반하는 기계조작하지 말 것(졸음, 주의력･집중력･반사운동능력 등의 저하) <br />∙ 투여 중단시 천천히 감량함(금단증상 방지) <br />∙ 자살경향이 있는 환자는 치료초기에 신중히 모니터함</td>
            </tr>
            <tr id="KDGERI_DOTHIEPIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙MAO저해제(발한, 불온, 전신경련, 이상고열, 혼수) <br />∙알코올섭취, 항콜린작용약, 에피네프린작용약, 중추신경억제제(도치에핀의 작용을 증강) <br />∙ 베타니딘, 데브리퀸, 구아네티딘 등 혈압강하제(혈압강하제의 작용 감소) <br />∙ 메칠페니데이트(도치에핀의 혈중농도 상승) <br />∙ 알코올(중추신경억제작용 증강)</td>
            </tr>
            <tr id="KDGERI_DOTHIEPIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>신경이완제악성증후군(저나트륨혈증, 저침투압혈증, 요중 나트륨배설량 증가, 고장뇨, 경련, 의식장애), 혈압강하, 심계항진, 경련, 졸음, 어지러움･비틀거림･기립성 조절장애, 수면장애, 두통, 두중, 진전, 성욕감퇴, 불온, 흥분, 기억장애, 지각이상, 발한, 구음장애, 운동실조, 헛소리, 조전, 마비감, 초조, 발진, 골수기능억제, 무과립구증, 백혈구감소, ALT, AST, ALP, LDH의 상승, 담즙울체성 황달, 식욕부진, 구역, 구토, 설사, 위부불쾌감, 골절, 구갈, 변비, 시조절장애, 배뇨곤란, 성기능장애 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_DULOXETINE" data-drug-number="113">
          <thead>
            <tr>
              <th className="drug-number">113</th>
              <th className="drug-name">둘록세틴(Duloxetine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항우울제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_DULOXETINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>주요 우울장애의 치료, 범불안장애의 치료, 당뇨병성 말초 신경병증성 통증의 치료, 섬유근육통의 치료, 비스테로이드성 소염진통제(NSAIDs)에 반응이 적절하지 않은 골관절염 통증의 치료</td>
            </tr>
            <tr id="KDGERI_DULOXETINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약의 주성분 또는 첨가제에 대해 과민증을 나타낼 경우, MAO 저해제, 간질환 환자, 투석이 필요한 말기 신질환 환자 또는 중증의 신장애 환자, 조절되지 않는 협우각 녹내장환자, 조절되지 않는 고혈압 환자, 과당 불내성, 포도당-갈락토스 흡수장애, 또는 수크로스 이소말타아제 결핍증 등의 유전적인 질환을 가진 환자</td>
            </tr>
            <tr id="KDGERI_DULOXETINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) 1. 주요 우울장애의 치료: 1회 60mg씩 1일 1회, 1일 최대투여량: 60mg 2. 범불안장애의 치료: 1회 60mg씩 1일 1회, 1일 최대투여량: 120mg 3. 당뇨병성 말초 신경병증성 통증의 치료: 1회 60mg씩 1일 1회, 1일 최대투여량: 120mg 4. 섬유근육통, NSAIDs에 반응이 적절하지 않은 골관절염 통증의 치료: 1회 30mg씩 1일 1회 1주간 투여후 1회 60mg씩 1일 1회로 증량. 1일 최대투여량: 60mg. (고령자용량)연령에 따른 용량조절이 권장되지 않음. 그러나 치료시 주의가 필요하며 특히 이 약 1일 120mg 용량 사용에 대한 임상자료는 제한적임</td>
            </tr>
            <tr id="KDGERI_DULOXETINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 조증 또는 양극성 장애 환자, 간질 병력이 있는 환자, 안압이 증가되었거나 급성 협우각 녹내장 위험이 있는 환자, 경증 또는 중등증 신장애 환자, 고혈압 환자, 심장질환 환자, 출혈 경향이 있는 환자, 항응고제 또는 혈소판 기능에 영향을 주는 약물을 투여하는 환자, 항우울제 복용환자, 고령자, 탈수 환자 또는 이뇨제를 투여 중인 환자 등 신중투여<br />∙ 질환의 악화, 자살 성향 또는 적개심, 공격성, 분노 등 다른 비정상적인 행동의 변화가 있는지 주의 깊게 관찰<br />∙ 세로토닌 증후군 주의<br />∙ 혈압상승 및 심박수 증가, 기립성저혈압 및 실신, 출혈, 중증 피부반응, 저나트륨혈증, 노저류 및 노폐, 좌불안석증/정신운동성 안절부절증, 간염 및 간효소 증가, 치료 중단 시 금단증상 주의<br />∙ 위험한 기계 조작시 주의(진정, 어지러움)</td>
            </tr>
            <tr id="KDGERI_DULOXETINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 알코올, 수면제(병용투의시 주의 요구) <br />∙ MAO억제제, 세로토닌성 약물(세로토닌 증후군 위험성을 증가) <br />∙ 응고제 및 항혈소판제제(INR값이 증가) <br />∙ CYP1A2 저해제(둘록세틴의 혈중농도 증가)</td>
            </tr>
            <tr id="KDGERI_DULOXETINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>두통, 졸음, 피로, 오심, 구강건조증, 체중저하, 홍조, 혈압상승, 심계항진, 불면, 초조, 불안, 사정지연, 오한, 감각저하, 이상감각, 수면장애, 발한, 가려움, 성욕저하, 체중증가, 변비, 설사, 구토, 식욕저하, 복통, 소화불량, 미각장애, 고창, 발기부전, 사정장애, 빈뇨, ALT상승, 진전, 근골격계 통증, 시야혼탁, 구강인두 통증, 기침 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ESCITALOPRAM" data-drug-number="114">
          <thead>
            <tr>
              <th className="drug-number">114</th>
              <th className="drug-name">에스시탈로프람(Escitalopram)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항우울제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ESCITALOPRAM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>주요우울장애, 광장공포증을 수반하거나 수반하지 않는 공황장애, 사회불안장애(사회공포증), 범불안장애, 강박장애의 치료</td>
            </tr>
            <tr id="KDGERI_ESCITALOPRAM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약의 주성분인 에스시탈로프람, 라세미체인 시탈로프람 또는 이 약의 다른 성분에 과민성이 있는 환자, MAO저해제를 투여하고 있는 환자, 피모자이드를 투여하고 있는 환자, 선천성 QT 연장 증후군 또는 QT 간격 연장이 있는 것으로 알려진 환자, QT 간격 연장을 유발하는 약물을 복용중인 환자</td>
            </tr>
            <tr id="KDGERI_ESCITALOPRAM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량)- 주요우울장애, 사회불안장애, 범불안장애, 강박장애 : 1회 10mg씩 1일 1회. 1일 최대투여량: 20mg- 광장공포증을 수반하거나 수반하지 않는 공황장애: 초기용량 1회 5mg씩 1일 1회. 1일 최대투여량: 20mg (고령자용량)- 초기용량은 권장량의 절반으로 감량하는 것이 좋으며 더 낮은 최대 용량을 고려할 것</td>
            </tr>
            <tr id="KDGERI_ESCITALOPRAM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 질환의 악화, 자살 성향 또는 적개심, 공격성, 분노 등 다른 비정상적인 행동의 변화가 있는지 주의 깊게 관찰<br />∙ 역행성 불안, 간질발작, 조증, 자살, 저나트륨혈증, 출혈, 세로토닌 증후군, 금단 증상, QT 간격 연장 주의<br />∙ 당뇨병 환자에게 투여시 인슐린 및 경구용 혈당강하제의 용량 조정 필요</td>
            </tr>
            <tr id="KDGERI_ESCITALOPRAM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>[병용금기] <br />∙ MAO 억제제(병용금기, 세로토닌 증후군 위험성) <br />∙ 피모자이드(QTs 간격 연장) <br />∙ Class IA 및 III의 항부정맥약, 항정신병약, 삼환계 항우울제, 특정 항생제, 특정 항히스타민제(QTs 간격 연장) [병용주의] <br />∙ 세로토닌성 약물<br />∙간질발작 역치(seizure threshold)를 낮추는 약물(에스시탈로프람은 발작 역치를 낮출 수 있음) <br />∙리튬, 트립토판(에스시탈로프람의 효과 증가) <br />∙성요한의 풀(이상반응의 발생 증가) <br />∙항응고제(항응고제 효과 변화), 비스테로이드성 소염진통제(출혈 경향 증가) <br />∙알코올(병용을 하지 않는 것이 좋음)</td>
            </tr>
            <tr id="KDGERI_ESCITALOPRAM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>두통, 불면, 졸음, 오심, 설사, 사정장애, 피로, 현기, 이상감각, 하품, 발한, 성욕감소, 월경이상, 구강건조증, 변비, 소화불량, 식욕저하, 구토, 복통, 고창, 치통, 발기부전, 요로감염, 목통증, 어깨통증, 등통증, 독감유사증후, 비염, 부비강염, 비충혈 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_FLUOXETINE" data-drug-number="115">
          <thead>
            <tr>
              <th className="drug-number">115</th>
              <th className="drug-name">플루옥세틴(Fluoxetine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항우울제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_FLUOXETINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>우울증, 신경성 식욕과항진증, 강박반응성 질환, 월경전 불쾌장애</td>
            </tr>
            <tr id="KDGERI_FLUOXETINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 또는 이 약의 첨가물에 대한 과민증의 병력이 있는 환자, 중증의 신장애 환자(사구체 여과율&lt;0 mL/분), MAO 저해제를 투여 중인 환자</td>
            </tr>
            <tr id="KDGERI_FLUOXETINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량)우울증, 강박반응성 질환: 초회용량 1회 20mg씩 1일 1회 오전 투여(초과시 1일 2회 아침, 정오), 1일 최대 투여량: 80mg신경성 식욕과항진증: 1회 60mg씩 1일 1회, 1일 최대 투여량: 80mg신장 및/또는 간손상 환자, 여러 약물을 투여받고 있는 환자, 고령자 및 병발질환이 있는 환자: 저용량을 투여하거나 투여횟수를 줄임, 연령, 증상에 따라 적절히 증감</td>
            </tr>
            <tr id="KDGERI_FLUOXETINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙발작의 병력, 자살의 소인이 있는 환자, 조증, 심･간･신장애, 당뇨가 있는 환자, 동공확대 환자 등 신중투여<br />∙질환의 악화, 자살 성향 또는 적개심, 공격성, 분노 등 다른 비정상적인 행동의 변화가 있는지 주의 깊게 관찰<br />∙긴 반감기 주의(이 약(2-3일) 및 주 대사물(7-9일)의 긴 반감기 때문에, 용량 변화 시에도 수 주일간은 충분히 반영되지 않음) <br />∙위험을 수반하는 기계조작하지 말 것(판단, 사고 또는 운동기능에 손상 가능) <br />∙신체적 및 정신적 의존성 주의<br />∙양극성 장애환자에서 조증 발생 가능</td>
            </tr>
            <tr id="KDGERI_FLUOXETINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙MAO(monoamine oxidase) 저해제, 다른 세로토닌성 약물(세로토닌 증후군 위험성) <br />∙기타 항우울약(혈장농도 두 배 이상 증가) <br />∙디아제팜(디아제팜의 반감기 연장) <br />∙쿠마딘, 디기톡신 등 혈장단백결합율이 높은 약물(혈장농도의 변화) <br />∙중추신경작용약물<br />∙전기경련요법(ECT)(지속적인 발작 드물게 보고됨) <br />∙시토크롬 P450 2D6 동종효소에 의하여 대사하는 약물(시토크롬 P450 2D6 동종효소에 의하여 대사하는 약물의 치료용량을 저용량부터 시작할 것) <br />∙지혈 저해 약물(출혈위험) <br />∙알코올(병용 권고되지 않음) <br />∙QT 간격을 연장시킬 수 있는 약물</td>
            </tr>
            <tr id="KDGERI_FLUOXETINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>흉통, 고혈압, 심계항진, 혈관확장, 비정상적인 꿈, 비정상적인 생각, 초조, 기억상실, 불안, 오한, 혼미, 현기, 졸음, 정서불안, 두통, 불면, 신경과민, 수면장애, 발한, 가려움, 발적, 성욕감소, 월경과다, 갈증, 체중증가, 체중감소, 식욕저하, 변비, 설사, 미각장애, 소화불량, 식욕증가, 오심, 구토, 구강건조증, 사정장애, 발기부전, 빈뇨, 진전, 시각장애, 이명, 코피, 독감유사증후, 인두염, 부비강염 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_FLUVOXAMINE" data-drug-number="116">
          <thead>
            <tr>
              <th className="drug-number">116</th>
              <th className="drug-name">플루복사민(Fluvoxamine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항우울제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_FLUVOXAMINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>우울증, 강박장애</td>
            </tr>
            <tr id="KDGERI_FLUVOXAMINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>MAO 억제제를 투여 중인 환자, 이 약 또는 이 약의 구성성분에 과민반응 환자, 티오리다진, 메소리다진, 피모지드, 티자니딘염산염, 테르페나딘, 아스테미졸 또는 시사프리드를 투여 중인 환자</td>
            </tr>
            <tr id="KDGERI_FLUVOXAMINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제]우울증(일반용량)초기 용량: 1회 100mg씩 1일 1회 취침전 투여 또는 100-200mg/일을 2~3회로 분할투여. 이후 필요시 점차적으로 증량. 1일 최대 투여량: 300mg강박증(일반용량)초기 용량: 1회 50mg씩 1일 1회, 1주 이상 복용한 후 100-200mg/일로 증량하며, 최소 유효용량으로 유지함. 1일 최대 투여량: 300mg</td>
            </tr>
            <tr id="KDGERI_FLUVOXAMINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙고령자는 약의 높은 혈중농도가 지속되어 출혈경향 증강 등이 일어날 수 있으므로 증량시 용량 등에 주의하여 신중히 투여<br />∙고령자는 항이뇨호르몬부적절분비증후군을 주의, 심장질환이 있는 고령자에서는 방실차단, 심실빈박 등이 보고 됨<br />∙간･신장애, 경련성질환, 자살충동, 조증, 뇌의 기질적장애, 충동성이 높은 병존장애, 심장질환, 출혈성질환 병력, 고령자, 당뇨병 환자 등 신중투여<br />∙질환의 악화, 자살 성향 또는 적개심, 공격성, 분노 등 다른 비정상적인 행동의 변화가 있는지 주의 깊게 관찰<br />∙위험을 수반하는 기계조작 주의(졸음, 의식레벨저하･의식소실 등의 의식장애가 일어날 수 있음) <br />∙양극성 장애 환자에서 조증 발생 가능</td>
            </tr>
            <tr id="KDGERI_FLUVOXAMINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙와르파린, 페니토인, 테오필린, 카르바마제핀, 클로자핀(약물의 분해가 늦춰질 수 있음. 용량 조절 필요) <br />∙MAO 억제제(병용금기, 세로토닌 증후군 위험성) <br />∙티오리다진, 피모지드(병용금기, 심혈관계 이상반응) <br />∙티자니딘염산염(병용금기, 현저한 혈압저하) <br />∙시사프리드(병용금기, QT연장, 심실성부정맥) <br />∙리튬(플루복사민의 이상반응 강화) <br />∙L-트립토판을 함유하는 제제, 세로토닌성 약물<br /><br />∙ 항전간제, 삼환계 항우울약, 벤조디아제핀계 약물, 올란자핀, 멕실레틴염산염(혈중 농도 상승) <br />∙ 프로프라노놀염산염 등 베타-차단약(서맥, 저혈압) <br />∙ 테오필린 등 잔틴계 기관지확장제(어지러움, 졸음, 부정맥) <br />∙ 시클로스포린(혈중농도 상승) <br />∙ 출혈경향이 증강되는 약물(피부의 이상출혈, 출혈증상이 보고) <br />∙ 알코올(병용을 피해야 함)</td>
            </tr>
            <tr id="KDGERI_FLUVOXAMINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>두통, 불면, 졸음, 현기, 신경과민, 오심, 설사, 구강건조증, 식욕저하, 사정장애, 흉통, 심계항진, 혈관확장, 고혈압, 부종, 저혈압, 실신, 통증, 불안, 하품, 지적이상, 무감동, 중추신경흥분, 오한, 우울, 과다근육긴장증, 정신신경증, 단일수축, 기억상실증, 조증반응, 간대성 근경련, 정신증적 반응, 권태, 발한, 여드름, 성욕저하, 월경과다, 체중저하, 체중증가, 소화불량, 변비, 구토, 복통, 고창, 미각장애, 연하곤란, 치은염, 빈뇨, 발기부전, 요로감염, 요저류, 간기능검사 이상, 바이러스 감염, 진전, 근육통, 과활동, 운동저하, 약시, 다뇨증, 상기도 감염, 인두염, 독감유사증후, 후두염, 기관지염, 호흡곤란, 코피, 기침 증가, 부비강염 등신경정신계</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_IMIPRAMINE" data-drug-number="117">
          <thead>
            <tr>
              <th className="drug-number">117</th>
              <th className="drug-name">이미프라민(Imipramine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항우울제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_IMIPRAMINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>우울증, 우울상태, 주･야간의 유뇨증</td>
            </tr>
            <tr id="KDGERI_IMIPRAMINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>녹내장 환자(항콜린작용이 있어 안내압이 상승할 수 있다.), 삼환계 항우울약에 과민증 환자, 심근경색 회복초기 환자(증상이 악화될 수 있다.), 전립선질환 등 요폐 환자(항콜린작용에 의해 증상이 악화될 수 있다.), MAO저해제를 투여중인 환자, 조증 환자, 부정맥 환자, 급성 섬망 환자, 유문협착 환자, 마비성 장폐색 환자</td>
            </tr>
            <tr id="KDGERI_IMIPRAMINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량)우울증, 우울상태: 초회용량 25-75㎎/일을 분할투여, 200㎎까지 점차 증량1일 최대투여량: 300㎎</td>
            </tr>
            <tr id="KDGERI_IMIPRAMINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers criteria 해당약품<br />∙고령자는 저용량으로 투여 시작(기립성 저혈압, 비틀거림, 항콜린작용에 의한 구갈, 배뇨곤란, 변비, 안내압항진 등의 이상반응 위험)등 신중투여<br />∙배뇨곤란, 안내압항진, 심질환, 갑상선기능항진증, 조울증, 뇌의 기질적 장애, 부신수질종양, 간･신장애, 저혈압, 만성 변비 환자, 고령자 등 신중투여<br />∙질환의 악화, 자살 성향 또는 적개심, 공격성, 분노 등 다른 비정상적인 행동의 변화가 있는지 주의 깊게 관찰<br />∙우울증의 개선효과는 투여 2-4주 후에 나타남<br />∙위험을 수반하는 기계조작하지 말 것(졸음, 주의력･집중력･반사운동능력 등의 저하) <br />∙정기적으로 간･신기능 검사<br />∙투여 중지 시에는 천천히 감량<br />∙강한 항콜린 작용, 진정 작용, 기립성 저혈압 발생 가능성으로 노인환자에게 금기(2012 Beers criteria)</td>
            </tr>
            <tr id="KDGERI_IMIPRAMINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙MAO저해제(발한, 불온, 전신경련, 이상고열, 혼수) <br />∙항콜린작용약, 에피네프린작용약, 중추신경억제제, 전신마취제, 퀴니딘, 메칠페니데이트, 시메티딘, 페노티아진계 정신신경용제, 항불안약, 황체･난포호르몬제제, 알코올(이미프라민의 작용 증강) <br />∙혈압강하제(혈압강하제의 작용 감소) <br />∙바르비탈계 약물, 페니토인, 카르바마제핀, 니코틴, 경구용 피임약 등 간효소유도약물(이미프라민의 작용 감소) <br />∙페니토인, 카르바마제핀(페니토인, 카르바마제핀의 혈중농도 상승) <br />∙인슐린제제, 설포닐요소계 혈당강하제(과도한 혈당강하) <br />∙설파메톡사졸･트리메토프림(우울증 재발 또는 악화) <br />∙전기경련요법(ECT)(경련역치 저하) <br />∙와르파린(항응고효과 증강) <br />∙피모짓 등 QT 연장약물(병용금기)</td>
            </tr>
            <tr id="KDGERI_IMIPRAMINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>신경이완제악성증후군, 심부전, 기립성 저혈압, 심전도이상, 심근경색, 뇌졸중, 혈압강하･상승, 빈맥, 부정맥, 심차단, 심계항진, 간질발작, 진전･파킨슨증상･정좌불능 등의 추체외로장애, 운동실조, 구음장애, 지각이상, 환각, 헛소리, 정신착란, 불면, 악몽, 불안, 초조, 졸음, 공격적 반응, 격정, 조증, 간대성 근경련, 방향감각상실, 무감각, EEG상변화, 말초신경병증, 구갈, 배뇨곤란, 안내압항진, 시조절장애(산동 등), 변비, 코막힘, 발한, 무과립구증, 호산구증다증, 백혈구감소, 혈소판증가, 자반, 점상출혈, 간기능장애, 안면･혀의 부종, 흑색 혀, 발진, 가려움, 광과민증, 부종, 탈모, 약열(drug fever), 입주위 등의 불수의운동, 알레르기성 폐렴, 골절 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_MILNACIPRAN" data-drug-number="118">
          <thead>
            <tr>
              <th className="drug-number">118</th>
              <th className="drug-name">밀나시프란(Milnacipran)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항우울제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_MILNACIPRAN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>우울증, 섬유근육통의 치료</td>
            </tr>
            <tr id="KDGERI_MILNACIPRAN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 및 이 약의 구성성분에 과민반응인 환자, 비선택적 MAO억제제, MAO-B억제제, 디기탈리스, 5-HT1D 작용약(수마트립탄)과의 병용 환자, 비경구적인 방법으로 투여되는 아드레날린, 노르아드레날린 및 클로니딘, 클로니딘 유사물질, MAO-A억제제를 투여받는 환자, 전립선 비대와 기타 비뇨생식기계 질환자, 18세 미만 환자, 임부 및 임신하고 있을 가능성이 있는 여성, 수유부, 조절되지 않는 폐쇄각녹내장 환자, 조절되지 않는 고혈압 환자, 중증 또는 불안정 관상동맥질환자</td>
            </tr>
            <tr id="KDGERI_MILNACIPRAN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (고령자용량) 1회 12.5mg씩 1일 2회1일 최대투여량: 60mg</td>
            </tr>
            <tr id="KDGERI_MILNACIPRAN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙신부전 환자, 요 배출이 어려운 환자, 전립선 비대 환자 그리고 기타 생식-비뇨기계 장애 환자, 고혈압 또는 심질환자, 폐쇄각녹내장 환자, 간질환자 또는 간질 병력이 있는 환자, 세로토닌 재흡수 저해제 투여 환자, 황색5호 성분에 과민하거나 알레르기 병력이 있는 환자 등 신중투여</td>
            </tr>
            <tr id="KDGERI_MILNACIPRAN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>[병용금기] <br />∙비선택적 MAO 억제제(세로토닌 증후 발생의 위험) <br />∙MAO-B억제제(발작성인 고혈압 위험) <br />∙5-HT1D 작용약(고혈압, 관상 동맥 혈관 수축 발생) <br />∙디기탈리스(혈액 역학 측면 잠재적 위험성) [병용이 추천되지 않는 약물] <br />∙아드레날린, 노르아드레날린(부정맥, 발작적인 고혈압) <br />∙클로니딘과 클로니딘 유사물질(클로니딘의 항고혈압 효과를 저해) <br />∙MAO-A억제제(세로토닌 증후 유발) [병용주의] <br />∙리튬(세로토닌 증후 발생) <br />∙클로미프라민(이상행복감, 기립저혈압의 증가) <br />∙알코올(병용을 피해야 함)</td>
            </tr>
            <tr id="KDGERI_MILNACIPRAN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>두통, 불면, 일과성 열감, 오심, 변비, 심계항진, 심박수 증가, 고혈압, 홍조, 말초부종, 어지러움, 편두통, 오한, 우울, 졸음, 넘어짐, 피로, 과민성, 다한증, 발진, 야간발한, 성욕감소, 과콜레스테롤혈증, 체중변화, 구토, 구강건조증, 복통, 식욕저하, 복부팽창, 미각장애, 설사, 소화불량, 고창, 위식도역류성 질환, 배뇨곤란, 사정장애, 발기부전, 전립선염, 음낭통증, 고환통증, 고환부기, 요도 통증, 배뇨지연, 뇨저류, 방광염, 요도감염, 진전, 시야혼탁, 호흡곤란, 발열 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_MIRTAZAPINE" data-drug-number="119">
          <thead>
            <tr>
              <th className="drug-number">119</th>
              <th className="drug-name">미르타자핀(Mirtazapine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항우울제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_MIRTAZAPINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>주요 우울증</td>
            </tr>
            <tr id="KDGERI_MIRTAZAPINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 및 이 약의 구성성분 대한 과민반응이 있는 환자, MAO억제제를 투여 받고 있는 환자, 갈락토오스 불내성, Lapp 유당분해효소 결핍증 또는 포도당-갈락토오스 흡수장애 등의 유전적인 문제가 있는 환자</td>
            </tr>
            <tr id="KDGERI_MIRTAZAPINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량, 고령자용량)초기 용량: 1회 15mg씩 1일 1회, 최소 1주 이상 간격으로 증량1일 유효용량: 15-45mg최대 8주 이상 투여해도 치료반응이 없을 경우 투여를 중단하나, 치료반응이 있다면 증상이 완전히 없어질 때까지 4-6개월 이상 투여를 지속할 것.</td>
            </tr>
            <tr id="KDGERI_MIRTAZAPINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers criteria 해당약품<br />∙고령자에서 배설이 감소하였음, 고령자에게 이 약을 투여할 때는 주의.(기타 특이한 연령 연관성 현상은 확인되지 않음) <br />∙간･신장애, 간질 및 기질성뇌증후군 환자, 당뇨병 환자, 자극 전도장애, 협심증 및 심근경색증 등의 심질환 환자, 저혈압 환자 등 신중투여<br />∙질환의 악화, 자살 성향 또는 적개심, 공격성, 분노 등 다른 비정상적인 행동의 변화가 있는지 주의 깊게 관찰<br />∙백혈구감소와 함께 목이 아프거나 열, 위염, 감염증상이 나타나면 이 약의 투여를 중단하고 혈구수를 측정(무과립세포증) <br />∙황달 발생시 투여 중단<br />∙졸음, 어지러움, 식욕증가 및 체중증가, 콜레스테롤 및 트리글레세라이드 증가, 트란스아미나제 상승, 조증 및 경조증, 발작, 저나트륨혈증, 세로토닌 증후군, 자살 등 주의<br />∙부적절한 항이뇨 호르몬 분비 증상 또는 저나트륨혈증 증후군을 일으킬 수 있어 노인환자에게 사용 시 주의를 요함(2012 Beers criteria)</td>
            </tr>
            <tr id="KDGERI_MIRTAZAPINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙CYP3A4의 강력한 억제제,HIV 프로테아제 억제제, azole 항진균제, 에리스로마이신 혹은 네파조돈과 병용시 주의(미르타자핀의 투여 용량 감소 필요) <br />∙카바마제핀 혹은 다른 간 대사 유도제(미르타자핀의 투여 용량 증가 필요) <br />∙시메티딘(미르타자핀의 평균 혈장농도 50% 이상 증가) <br />∙MAO저해제, 세로토닌성 약제(세로토닌 증후군 위험성을 증가) <br />∙벤조디아제핀 및 기타 진정제(진정작용 증가) <br />∙알코올(중추신경계 억제 효과 증가) <br />∙와르파린(INR 증가) <br />∙QT 간격을 연장시키는 약물(QT 연장 및/또는 심실 부정맥의 위험성)</td>
            </tr>
            <tr id="KDGERI_MIRTAZAPINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>졸음, 혈중 콜레스테롤 증가, 체중증가, 구강건조증, 식욕증가, 변비, 말초부종, 부종, 고혈압, 혈관확장, 현기, 착란, 초조, 기억상실, 불안, 무감동, 우울, 지각감퇴, 불안, 근무력증, 이상감각, 단일수축, 가려움, 발적, 혈중 TG 상승, 갈증, 복통, 식욕저하, 구토, 빈뇨, 요로감염, ALT증가, 등 통증, 근육통, 진전, 관절통, 과활동, 운동저하, 독감유사증후, 호흡곤란, 기침, 부비강염 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_NORTRIPTYLINE" data-drug-number="120">
          <thead>
            <tr>
              <th className="drug-number">120</th>
              <th className="drug-name">노르트립티린(Nortriptyline)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항우울제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_NORTRIPTYLINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>우울증 또는 우울상태(내인성 우울증, 반응성 우울증, 퇴행성 우울증, 신경증적 우울증, 뇌기질성 정신장애의 우울상태)</td>
            </tr>
            <tr id="KDGERI_NORTRIPTYLINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>삼환계 항우울약에 과민증 환자, 녹내장 환자, 삼환계 항우울약 또는 MAO저해제를 투여중인 환자, 최근에 심근경색의 병력이 있는 환자, 중증의 전도장애(부정맥, 심블록, 각블록, 방실블록 3도) 환자, 요폐(전립선질환 등) 환자, 중추신경억제제 또는 알코올 급성 중독 환자, 급성 섬망 환자, 유문협착 환자, 마비성 장폐색 환자, 중증의 간질환 환자, 조증 환자, 수유부, 18세 이하의 환자</td>
            </tr>
            <tr id="KDGERI_NORTRIPTYLINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 10-25mg씩 1일 3회, 필요시 점차 증량(일반용량) 1일 최대투여량: 150mg연령, 증상에 따라 적절히 증감</td>
            </tr>
            <tr id="KDGERI_NORTRIPTYLINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙고령자는 저용량으로 투여 시작(기립성 저혈압, 비틀거림, 항콜린작용에 의한 구갈, 배뇨곤란, 변비, 안내압항진 등의 이상반응 위험)등 신중투여<br />∙심질환, 갑상선기능항진증, 경련성 질환, 조울증, 뇌의 기질적 장애, 배뇨곤란, 안압항진, 고령자 등 신중투여<br />∙질환의 악화, 자살 성향 또는 적개심, 공격성, 분노 등 다른 비정상적인 행동의 변화가 있는지 주의 깊게 관찰<br />∙위험을 수반하는 기계조작하지 말 것(졸음, 주의력･집중력･반사운동능력 등의 저하) <br />∙우울증 환자의 자살기도 위험 주의</td>
            </tr>
            <tr id="KDGERI_NORTRIPTYLINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙MAO저해제(발한, 불온, 전신경련, 이상고열, 혼수) <br />∙알코올, 중추신경억제제(중추신경억제작용 증강) <br />∙항콜린효능약(상호 콜린작용 증강) <br />∙에피네프린효능약(에피네프린효능약의 심혈관계 작용 증강) <br />∙혈압강하제(혈압강하제의 효능 감소) <br />∙디벤자제핀(교차감수성) <br />∙퀴니딘(노르트립티린의 반감기, 혈중농도 증가, 제거율 감소) <br />∙시메티딘(노르트립티린의 혈중농도 증가) <br />∙클로르프로파미드(제2형 당뇨병 환자: 심각한 저혈당) <br />∙피모짓 등 심전도 영향 약물(병용금기)</td>
            </tr>
            <tr id="KDGERI_NORTRIPTYLINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>간질 발작, 진전 등의 파킨슨증상, 운동실조, 지각이상, 환각, 헛소리, 정신착란, 불면, 불안, 초조, 이명, 졸음, 혼수, 추체외로 증상, EEG상의 변화, 골수기능저하, 백혈구감소, 호산구증가, 자반, 혈소판 감소, 신경이완제악성증후군, 여성형유방, 유방확장, 유즙누출, 성욕항진 또는 저하, 발기불능, 혈당증가 또는 감소, 혈압강하, 혈압상승, 빈맥, 심계항진, 심근경색, 부정맥, 졸도, 골절, 구갈, 배뇨곤란, 안압항진, 시조절장애, 변비, 코막힘, 요저류, 시야몽롱, 산동, 설하설염, 발진, 가려움, 광선과민증, 두드러기, 입주위 등의 불수의운동, 비틀거림, 어지러움, 기립성 저혈압, 권태감, 두통, 발한, 빈뇨, 야뇨증 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PAROXETINE" data-drug-number="121">
          <thead>
            <tr>
              <th className="drug-number">121</th>
              <th className="drug-name">파록세틴(Paroxetine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항우울제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PAROXETINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>주요우울증, 강박장애, 공황장애, 범불안장애(GAD), 외상후 스트레스장애(PTSD), 사회불안장애/사회공포증</td>
            </tr>
            <tr id="KDGERI_PAROXETINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 또는 이 약의 구성성분에 과민반응 환자, MAO 억제제 복용 환자, 티오리다진 복용 환자, 피모지드 복용 환자, 세로토닌 전구체(L-트립토판, 트립탄 계열) 복용 환자, 갈락토오스 불내성, Lapp 유당분해효소 결핍증 또는 포도당-갈락토오스 흡수장애 등의 유전적인 문제가 있는 환자</td>
            </tr>
            <tr id="KDGERI_PAROXETINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (고령자용량) 1회 10mg씩 1일 1회, 필요시 증량 가능, 1일 최대투여량: 40mg (서방제) 1회 12.5mg씩 1일 1회, 필요시 증량 가능, 1일 최대 투여량: 50mg</td>
            </tr>
            <tr id="KDGERI_PAROXETINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙신경이완제 복용 환자, 경구용 항응고제 복용 환자, 간질, 심질환, 당뇨병, 조증, 출혈 경향 환자, 협각 녹내장 환자, 중증 간장애 및 신장애 환자, 자살충동 또는 자살기도 병력 환자, 뇌의 기질적장애, 고령자 등 신중투여<br />∙질환의 악화, 자살 성향 또는 적개심, 공격성, 분노 등 다른 비정상적인 행동의 변화가 있는지 주의 깊게 관찰<br />∙투여 중단시 수주나 수개월에 거쳐 점진적으로 용량 감량할 것</td>
            </tr>
            <tr id="KDGERI_PAROXETINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙MAO 억제제, 알코올, 세로토닌 유사약물(병용금기) <br />∙리튬(리튬의 농도 모니터링 할 것) <br />∙시메티딘 등 약물대사효소 억제제(파록세틴의 생물학적 이용율 증가) <br />∙항경련제(이상반응 증가) <br />∙항응고제(출혈 증가) <br />∙프로시클리딘(프로시클리딘의 혈장농도 증가) <br />∙CYP2D6에 의해 대사되는 약물(CYP2D6에 의해 대사되는 약물의 혈중농도 증가) <br />∙포삼프레나비어/리토나비어(파록세틴의 혈장 농도 감소) <br />∙타목시펜(유효성 저하, 항우울제를 변경할 것) <br />∙비스테로이드성 항염증약, 아스피린 및 다른 항혈소판제(출혈 위험 증가) <br />∙신경근육차단제(신경근육 차단 작용의 연장)</td>
            </tr>
            <tr id="KDGERI_PAROXETINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>졸음, 불면, 두통, 어지러움, 발한, 성욕감소, 오심, 구강건조증, 변비, 설사, 사정장애, 기력쇠약, 진전, 혈관 확장, 흉통, 심계항진, 고혈압, 신경과민, 불안, 피로, 집중력 저하, 하품, 간대성 근경련, 기억상실, 오한, 정서불안, 혼란, 근무력증, 발진, 두드러기, 체중증가, 식욕저하, 소화불량, 헛배부름, 복부통증, 오심, 구토, 식욕증가, 미각장애, 생식기 이상, 발기부전, 월경곤란, 빈뇨, 요로감염, 감염, 근육통, 근육병증, 관절통, 흐린 시력, 시각 장애, 이명, 호흡 곤란, 인두염, 부비강염, 비염 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_SERTRALINE" data-drug-number="122">
          <thead>
            <tr>
              <th className="drug-number">122</th>
              <th className="drug-name">설트랄린(Sertraline)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항우울제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_SERTRALINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>우울증, 성인 및 소아 강박장애의 치료, 공황장애의 치료, 외상후 스트레스 장애의 치료, 사회불안장애(혹은 사회공포증으로도 알려져 있음)의 치료, 월경 전 불쾌 장애의 치료</td>
            </tr>
            <tr id="KDGERI_SERTRALINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약에 과민증 환자, 중등도에서 중증의 간장애 환자 (이 약은 간에서 광범위하게 대사되고 중등도에서 중증의 간기능장애 환자에 대한 약물역학은 아직 연구되지 않았으므로 투여하지 않는다.), MAO 저해제를 투여중인 환자, 리네졸리드 또는 정맥주사용 메틸렌블루 제제와 같은 MAO 저해제를 투여받는 환자, 피모자이드를 복용 중인 환자</td>
            </tr>
            <tr id="KDGERI_SERTRALINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량)우울증, 강박장애: 초회용량 1회 50mg씩 1일 1회, 유지량 50-100mg/일효과 불충분시 50mg씩 증량, 1일 최대투여량: 200mg (치료효과: 투여 후 7일 이내, 충분한 항우울 작용: 2-4주 요구됨) (일반용량)공황장애, 외상 후 스트레스 장애, 사회불안장애 : 초기용량 1회 25mg씩 1일 1회, 1주일 후 1회 50mg씩 1일 1회, 유지량 50-200mg/일, 1일 최대투여량: 200mg (일반용량)고령자에게 특별한 용량조절은 필요하지 않음, 증상에 따라 적절히 증감함</td>
            </tr>
            <tr id="KDGERI_SERTRALINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙질환의 악화, 자살 성향 또는 적개심, 공격성, 분노 등 다른 비정상적인 행동의 변화가 있는지 주의 깊게 관찰<br />∙세로토닌증후군 또는 신경이완제악성증후군 주의<br />∙간질, 경증의 간장애, 폐쇄각녹내장 또는 녹내장 병력 환자는 신중투여<br />∙위험을 수반하는 기계 조작시 주의(정신적, 육체적 능력에 장애 유발 가능) <br />∙양극성 장애환자에서 조증야기<br />∙혈당변동(glucose fluctuation)과 관련한 증상 및 징후를 모니터링(당뇨병 발병 사례 보고됨)</td>
            </tr>
            <tr id="KDGERI_SERTRALINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙MAO(monoamine oxidase) 저해제, 다른 세로토닌성 약물(세로토닌 증후군 위험성) <br />∙피모자이드(피모자이드 농도의 증가) <br />∙중추신경계 억제제 및 알코올(병용을 피하는 것이 바람직) <br />∙수마트립탄(쇠약, 과다반사, 운동협조실조, 착란, 불안, 초조 등의 이상반응) <br />∙리튬(떨림 증가) <br />∙혈장단백결합 약물<br />∙와르파린(프로트롬빈 시간 증가) <br />∙시메티딘(설트랄린의 청소율 감소) <br />∙삼환계 항우울제(삼환계 항우울제의 대사 억제) <br />∙페니토인(페니토인의 혈중 농도 모니터링 권장, 설트랄린의 혈장 농도 감소) <br />∙QTc 간격을 연장시키는 약물들(QTc 연장 및/또는 심실성 빈맥(예: TdP)의 위험이 증가)</td>
            </tr>
            <tr id="KDGERI_SERTRALINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>불면, 두통, 어지러움, 피곤, 졸음, 발한, 성욕감소, 오심, 설사, 구강 건조증, 소화불량, 식욕저하, 사정장애, 진전, 흉통, 심계항진, 불안, 통증, 신경과민, 이상감각, 공격적 행동, 지각감퇴, 발진, 체중증가, 변비, 복통, 구토, 식욕 증가, 요실금, 발기부전, 자반병, 근육통, 시각장애, 이명, 코피, 부비강염, 비염, 발열 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_TRAZODONE" data-drug-number="123">
          <thead>
            <tr>
              <th className="drug-number">123</th>
              <th className="drug-name">트라조돈(Trazodone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항우울제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_TRAZODONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>우울증</td>
            </tr>
            <tr id="KDGERI_TRAZODONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 또는 이 약의 구성성분에 과민반응 환자, MAO억제제를 투여중인 환자, 18세 이하의 소아 및 청소년, 급성심근경색증 환자, 알코올 또는 수면제 중독 환자, 사퀴나비르를 투여중인 환자</td>
            </tr>
            <tr id="KDGERI_TRAZODONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (고령자용량) 1회 100mg씩 1일 1회 식후 또는 간식 후에 투여(졸음이 오면 수면시간에 투여) 1일 최대투여량: 300mg(1회 투여량 100mg 이하)</td>
            </tr>
            <tr id="KDGERI_TRAZODONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙고령자에서는 생리기능이 저하되어 있으므로 감량하는 등 주의<br />∙심질환의 병력, 녹내장, 배뇨곤란 또는 안압상승, 경련성 질환, 조울증, 뇌의 기질적 장애, 고령자, 간･신장애, 자살 충동, 갑상샘기능항진증 환자 등 신중투여<br />∙질환의 악화, 자살 성향 또는 적개심, 공격성, 분노 등 다른 비정상적인 행동의 변화가 있는지 주의 깊게 관찰<br />∙지속성 발기 증상이 나타날 경우 즉시 투여 중지(발기능력 손상, 발기불능 가능성) <br />∙위험을 수반하는 기계조작하지 말 것(졸음, 주의력･집중력･반사운동능력 등의 저하) <br />∙전기경련요법(ECT)전 사용 중지<br />∙양극성 장애 환자에서 조증 야기<br />∙세로토닌 증후군, 금단증상(구역질, 두통, 피로, 불안, 수면 장애), 비정상적 출혈, 저나트륨혈증 주의</td>
            </tr>
            <tr id="KDGERI_TRAZODONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙디곡신, 페니토인(디곡신, 페니토인의 혈청농도 상승) <br />∙MAO억제제(세로토닌 증후군 위험성을 증가) <br />∙혈압강하제(기립성 저혈압, 실신 등의 저혈압) <br />∙알코올, 중추신경억제제(트라조돈의 작용 증강) <br />∙페노티아진계 약물(혈압저하) <br />∙와르파린(프로트롬빈시간의 감소 또는 연장) <br />∙카르바마제핀 등 CYP3A4유도제(트라조돈의 혈중 농도가 저하) <br />∙리토나비르, 인디나비르, 케토코나졸, 이트라코나졸 등 CYP3A4억제제(트라조돈의 혈중 농도 상승) <br />∙세로토닌성 약물(세로토닌 증후군) <br />∙비스테로이드소염진통제, 아스피린 또는 지혈에 영향을 미치는 다른 약물(위장관 출혈의 위험 증가) <br />∙사퀴나비르(트라조돈의 혈중농도 증가, 심각한 심혈관계 이상반응) <br />∙근육이완제 및 마취제(근육이완제 및 마취제의 효과 강화)</td>
            </tr>
            <tr id="KDGERI_TRAZODONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>진정, 두통, 현기, 피로, 구강건조증, 오심, 부종, 초조, 운동실조, 착란, 방향감각 상실, 기억력장애, 편두통, 야간발한, 성욕저하, 변비, 복통, 미각장애, 구토, 사정장애, 절박뇨, 등 통증, 근육통, 진전, 시야혼탁, 시각장애, 호흡곤란 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_VENLAFAXINE" data-drug-number="124">
          <thead>
            <tr>
              <th className="drug-number">124</th>
              <th className="drug-name">벤라팍신(Venlafaxine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항우울제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_VENLAFAXINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>우울증, 범불안장애, 사회공포증, 공황장애</td>
            </tr>
            <tr id="KDGERI_VENLAFAXINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 또는 이 약의 성분에 대하여 과민반응이 있는 환자, MAO저해제를 투여 받고 있는 환자, 임부 및 임신하고 있을 가능성이 있는 환자, 수유부, 18세 미만의 환자</td>
            </tr>
            <tr id="KDGERI_VENLAFAXINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량)캡슐을 나누거나, 분쇄하거나, 씹거나, 물에 녹여 복용치 않도록 함.우울증 및 범불안장애: 초기용량 1회 37.5-75mg씩 1일 1회, 1일 최대투여량: 225mg (증량 시 최소 4일 이상 간격으로 1일 75mg 이하로 증량)사회공포증: 1회 75mg씩 1일 1회공황장애: 1회 37.5mg씩 1일 1회, 1일 최대투여량: 225mg (1주일 간격으로 75 mg씩 증량)간기능 장애 및 신기능 장애 환자는 상용량의 25~50%로 감량하여 투여한다. (고령자용량)연령만을 기준으로 할 경우에는 용량증감이 필요 없음, 고령자에서 좀 더 흔한 신장애나 간장애와 같은 다른 질환이 있을 경우에는 용량감소가 고려되어야 함</td>
            </tr>
            <tr id="KDGERI_VENLAFAXINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙고령 환자에게서 저나트륨혈증과 항이뇨호르몬부적절분비증후군(SIDAH)가 보고<br />∙자살시도, 발작, 발진 및 두드러기 등 알러지 반응 일어난 환자, 약물 남용 또는 오용의 징후가 있는 환자, 신장애･간경변 환자, 경련, 조증 및 경조증 활성 환자, 심근경색증을 최근에 앓았던 환자나 심질환이 있는 환자, 공격성 병력이 있는 환자 등 신중투여<br />∙질환의 악화, 자살 성향 또는 적개심, 공격성, 분노 등 다른 비정상적인 행동의 변화가 있는지 주의 깊게 관찰<br />∙벤라팍신은 일부 환자들에게 혈압의 지속적 상승을 유발시킬 수 있으므로 주의<br />∙세로토닌 증후군/신경이완제 악성 증후군(NMS) 유사반응 주의<br />∙식욕과 체중변화, 불면과 신경과민, 저나트륨혈증 및 항이뇨호르몬분비이상증후군(SIADH), 인식력과 운동수행 장애, 동공확대, 비정상 출혈, 혈청 콜레스테롤 수준 상승, 간질성 폐질환 및 호산구성 폐렴, 골절, QTs 연장 등 주의<br />∙양극성 장애 환자에서 조증 발생 가능<br />∙투여 중단시 수주나 수개월에 거쳐 점진적으로 용량 감량할 것</td>
            </tr>
            <tr id="KDGERI_VENLAFAXINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙시메티딘(벤라팍신의 초회 통과 대사 저해) <br />∙CYP2D6 억제제(약물 상호작용의 가능성이 존재) <br />∙케토코나졸(벤라팍신과 벤라팍신의 주요 대사물의 혈장 농도 증가) <br />∙CYP2D6 및 3A4 억제제(벤라팍신의 혈장 농도를 증가시키는 것으로 예상) <br />∙MAO저해제, 세로토닌성 약물, 트립탄(세로토닌 증후군 위험성을 증가) <br />∙QTc 간격을 연장시키는 약물들(QTc 연장 및/또는 심실성 빈맥의 위험이 증가) <br />∙알코올(병용을 피해야 함)</td>
            </tr>
            <tr id="KDGERI_VENLAFAXINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>두통, 불면, 졸음, 현기, 발한, 체중감소, 오심, 구강건조증, 식욕부진, 사정장애, 혈관확장, 고혈압, 심계항진, 흉통, 부종, 심계항진, 신경과민, 불안, 하품, 초조, 우울, 긴장항진, 단일수축, 이상감각, 기억상실, 오한, 혼란, 편두통, 두드러기, 반상출혈, 성욕저하, 단백뇨증, 체중증가, 혈중TG상승, 변비, 설사, 소화불량, 복부통증, 구토, 고창, 미각장애, 식욕상승, 발기부전, 진전, 목통증, 시각장애, 조절장애, 산동, 인두염, 호흡곤란, 발열 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_CARBAMAZEPINE" data-drug-number="125">
          <thead>
            <tr>
              <th className="drug-number">125</th>
              <th className="drug-name">카르바마제핀(Carbamazepine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항전간제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_CARBAMAZEPINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제] 간질, 삼차신경통, 조병, 조울병의 조상태, 정신분열증의 흥분상태</td>
            </tr>
            <tr id="KDGERI_CARBAMAZEPINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 또는 삼환계 항우울제 과민증, 중증의 혈액장애, 방실블록, 중증 서맥(50회/분 미만), 골수억제 및 간성 포르피린증의 병력, MAO 억제제 병용</td>
            </tr>
            <tr id="KDGERI_CARBAMAZEPINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 200mg씩 1일 1-2회, 최적효과가 얻어질때까지 천천히 증량1일 최대용량: 1600mg (간질, 조병, 조울증의 조상태, 정신분열증의 흥분상태) 1200mg(삼차신경통)정제→시럽제로 용량 변경할 경우 동일용량을 보다 저용량으로 분할하여 자주 투여</td>
            </tr>
            <tr id="KDGERI_CARBAMAZEPINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers criteria 해당품목<br /> - 낙상 및 골절 이력 있는 환자에서 항전간제 투여는 운동실조, 실신 및 추가적인 낙상 유발 가능하므로 안전한 대체약제가 사용 가능하다면 투여 추천되지 않음<br /> - 항이뇨호르몬부적절분비증후군 또는 저나트륨혈증을 악화시킬 수 있으므로 혈중 나트륨농도 모니터링하며 제한적 사용<br />∙MAO 억제제는 이 약 투여하기 최소 2주 전에 중단</td>
            </tr>
            <tr id="KDGERI_CARBAMAZEPINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙덱스트로프로폭시펜, 이부프로펜, 다나졸, 에리스로마이신, 트롤레안도마이신, 조사마이신, 마크로라이드계 항생제, 데시프라민, 플루옥세틴, 플루복사민, 네파조돈, 트라조돈, 빌록사진, 스티리펜톨, 비가바트린, 아졸계 항진균제, 로라타딘, 테르페나딘, 록사핀, 올란자핀, 퀘티아핀, 이소니아지드, 리토나비어, 아세타졸아미드, 베라파밀, 딜티아젬, 시메티딘, 오메프라졸, 옥시부티닌, 단트롤렌, 티클로피딘, 록사핀, 퀘티아핀, 프리미돈, 프로가비드, 발프론산, 발녹타미드, 발프로미드 (어지러움, 졸림, 운동실조, 복시 등 부작용 증가) <br />∙펠바메이트, 메스석시미드, 옥스카르바제핀, 페노바르비톤, 펜석시미드, 페니토인, 포스페니토인, 프리미돈, 프로가비드, 클로나제팜, 발프론산, 발프로미드, 시스플라틴, 독소루비신, 리팜피신, 테오필린, 아미노필린, 이소트레티노인, St John's wort (Hyericum perforatum) 함유 생약제제 (이 약 농도 감소) <br />∙메타돈, 파라세타몰, 아세트아미노펜, 페나존(안티피린), 트라마돌, 독시사이클린, 와르파린, 펜프로쿠몬, 디쿠마롤, 아세노쿠마롤, 부프로피온, 시탈로프람, 나파조돈, 트라조돈, 삼환계 항우울제(이미프라민, 아미트립틸린, 노르트립틸린, 클로미프라민), 클로바잠, 클로나제팜, 에토석시미드, 펠바메이트, 라모트리진, 옥스카르바제핀, 프리미돈, 티아가빈, 토피라메이트, 발프론산, 조니사미드, 이트라코나졸, 프라지콴델, 이매티닙, 클로자핀, 할로페리돌, 브롬페리돌, 올란자핀, 퀘티아핀, 리스페리돈, 지프라시돈, 인디나비르, 리토나비르, 사퀴나비르, 알프라졸람, 미다졸람, 테오필린, 펠로디핀, 디곡신 등 dihydropyridine계 칼슘채널차단제, 프레드니솔론, 덱사메타손 등 코르티코스테로이드제, 사이클로스포린, 에베로리무스, 레보치록신, 에스트로겐 및/또는 프로게스테론 함유 약물 (해당 약 농도 감소)</td>
            </tr>
            <tr id="KDGERI_CARBAMAZEPINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>∙ 레베티라세탐 (이 약 독성 증가) <br />∙ 이소니아지드 (간독성 증가) <br />∙ 메토클로프라미드, 할로페리돌, 치오리다진 (신경학적 이상반응 증가) <br />∙ 히드로클로로치아지드, 푸로세미드 (저나트륨혈증) <br />∙ 판쿠로니움 (작용 차단) <br />∙ 항전간제 복용한 환자에서 자살충동 또는 자살행동을 보이는 위험성이 증가되므로 비정상적인 기분변화에 대하여 모니터링해야 함백혈구 감소증, 혈소판 감소증, 호산구 증가증, 부종, 수분저류, 체중 증가, 저나트륨혈증, 기면, 혼돈 상태, 어지러움, 운동실조, 졸음, 피로, 두통, 복시, 조절장애(예, 시야혼탁), 구역, 구토, 구갈, γ-GTP 상승, 알칼라인 포스파타제 상승, 알레르기성 피부염, 심각할 수 있는 두드러기, 박리성 피부염, 홍피증신경정신계</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ETHOSUXIMIDE" data-drug-number="126">
          <thead>
            <tr>
              <th className="drug-number">126</th>
              <th className="drug-name">에토석시미드(Ethosuximide)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항전간제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ETHOSUXIMIDE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>결신발작(소발작)</td>
            </tr>
            <tr id="KDGERI_ETHOSUXIMIDE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 중증의 혈액장애 환자, 포르피린증 환자</td>
            </tr>
            <tr id="KDGERI_ETHOSUXIMIDE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) 1일 500mg로 시작필요시 소량씩(4~7일마다 1일 250mg씩) 증량하여 1일 1000mg까지 도달일 2~3회 분복</td>
            </tr>
            <tr id="KDGERI_ETHOSUXIMIDE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers criteria 해당품목 (항전간제)<br /> - 낙상 및 골절 이력 있는 환자에서 항전간제 투여는 운동실조, 실신 및 추가적인 낙상 유발 가능하므로 안전한 대체약제가 사용 가능하다면 투여 추천되지 않음<br />∙간, 신장애 환자, 약물과민증 환자, 정신질환의 병력이 있는 환자에게 신중투여<br />∙연용(계속복용)중에는 간.신기능검사, 혈액검사, 요검사 정기적으로 실시<br />∙혼합발작형에서는 단독투여에 의해 강직간대성발작의 유발 또는 악화 가능</td>
            </tr>
            <tr id="KDGERI_ETHOSUXIMIDE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙페니토인 (페니토인의 작용이 증강) <br />∙카르바마제핀, 네비라핀, 페노바비탈, 페니토인 (이 약의 효과 감소) <br />∙페노바르비탈산나트륨 (이 약 대사 억제) <br />∙발프로산, 리토나비르 (이 약의 효과 및 독성 증가) <br />∙Ginkgo (이 약의 항전간 효과 감소)</td>
            </tr>
            <tr id="KDGERI_ETHOSUXIMIDE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>공격성, 운동실조, 주의력･집중력･반사운동 등의 저하, 어지러움, 졸음, 환각, 피로감, 두통, 과잉행동, 기면(수면발작), 우울, 밤공포증(야경증), 편집증, 수면장애, 피부점막안증후구(Stevens-Johnson syndrome)〔발열, 피부점막의 발진 등 홍반, 괴사성 결막염 등의 증후군, 다모증, 가려움, 발진, 성욕증가, 복통(배아픔), 식욕부진, 체중감소, 위경련, 설사, 구역, 구토, 체중감소, 질출혈, 혈뇨, 백혈구감소, 호산구증가, 과립구감소, 범혈구 감소, 근시, 과민증항전간제 복용한 환자에서 자살충동 또는 자살행동을 보이는 위험성이 증가되므로 비정상적인 기분변화에 대하여 모니터링해야 함</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_FOSPHENYTOIN" data-drug-number="127">
          <thead>
            <tr>
              <th className="drug-number">127</th>
              <th className="drug-name">포스페니토인(Fosphenytoin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항전간제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_FOSPHENYTOIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>강직간대발작(대발작)성 간질중첩증 조절, 신경외과 수술 중 발생하는 발작의 치료와 예방, 경구투여가 가능하지 않거나 또는 금기시될 때의 경구용 페니토인의 대체</td>
            </tr>
            <tr id="KDGERI_FOSPHENYTOIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 동서맥, 동방블록, 2･3도 방실 블록, 그리고 애덤스-스톡스 증후군(Adams-Stokes syndrome) 환자, 심근경색(3개월 이내) 환자, 중증의 혈액 및 골수장애 환자, 급성 간헐성 포르피린증 환자</td>
            </tr>
            <tr id="KDGERI_FOSPHENYTOIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[주사제] (일반용량) <br />∙항상 페니토인나트륨 당량(PE, phenytoin sodium equivalent)으로 처방 및 투약<br /> - 1.5mg 포스페니토인 = 1mg PE<br /> - 투여경로: 정맥주사 (긴급한 발작조절) 또는 근육주사<br /> - 투여법: 1.5-25mg PE/mL 로 5% 포도당 주사액 또는 생리식염 주사액에 희석저혈압의 우려가 있으므로 50-100mg PE/min 속도로 투여응급상황에도 150mg PE/min을 초과해서는 안됨투여용량, 희석, 그리고 주입 시간 산출 예시는 허가사항 참고<br />∙간질중첩증<br /> - 이 약 투여 전 디아제팜 또는 로라제팜 정맥주사<br /> - 초회용량: 15mg PE/kg 단회 정맥주사로만 투여정맥주사 주입속도 100~150mg PE/min<br /> - 유지용량: 4-5mg/PE/kg/day, 정맥 또는 근육주사로 투여. 총 일일 용량을 1-2회로 분할투여, 정맥주사 주입속도 50~100mg PE/min <br />∙ 발작의 예방 또는 치료<br /> - 초회용량: 10~15mg PE/kg 단회 정맥주사 또는 근육주사정맥주사 주입 속도 50~100mg PE/min<br /> - 유지용량: 4~5mg PE/kg/day 정맥주사 또는 근육주사, 총 일일 용량을 1-2회로 분할투여, 정맥주사 주입속도 50~100mg PE/min <br />∙ 경구용 페니토인의 일시적인 대체<br /> - 동일용량 및 투여 빈도로 정맥주사 또는 근육주사<br /> - 정맥주사 주입 속도: 50~100mg PE/min<br /> - 5일을 초과한 기간 동안 평가된 바 없음<br />∙ 고령자용량<br /> - 낮은 초회 용량 그리고/또는 주입속도, 낮거나 빈번하지 않은 유지용량<br /> - 용량 또는 주입속도에서 10-25% 감소 고려, 주의깊은 임상 모니터링 필요<br />∙ 신장애, 간장애, 저알부민혈증을 환자<br /> - 간질중첩증을 제외하고는 낮은 초회 용량 그리고/또는 주입속도, 낮거나 빈번하지 않은 유지용량<br /> - 용량 또는 주입속도에서 10-25% 감소 고려, 주의깊은 임상 모니터링 필요</td>
            </tr>
            <tr id="KDGERI_FOSPHENYTOIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 2012 Beers criteria 해당품목 (항전간제)<br /> - 낙상 및 골절 이력 있는 환자에서 항전간제 투여는 운동실조, 실신 및 추가적인 낙상 유발 가능하므로 안전한 대체약제가 사용 가능하다면 투여 추천되지 않음<br />∙ 페니토인은 소발작(결신발작, absence seizures)에는 효과적이지 않음. 만약 강직간대발작과 소발작이 동시에 존재한다면, 병용 약물 요법이 추천됨<br />∙ 치료약물농도 모니터링(TDM)<br /> - 정맥주사 후 최소 2시간 혹은 근육주사 후 최소 4시간 이후 혈액 샘플 채취<br /> - 최적범위: 혈장 총 페니토인 농도 10~20mg/L(40~80μmol/L) 또는 혈장 미결합 페니토인 농도 1~2mg/L (4~8μmol/L)<br /> - 최적 범위 이상으로 유지되는 혈장 페니토인 농도는 급성독성증상 발생 가능<br /> - 생체이용률이 경구 90%, 근육주사 및 정맥주사 시 100%이므로 경구투여에서 주사제로 대체할 때 혈장 페니토인 농도 상승 가능<br />∙ 포스페인 나트륨 mg 당 0.0038mmol 인산 공급되므로 심각한 신부전 환자 등 인산 제한이 필요한 경우 주의<br />∙ 5 %의 포도당 혹은 생리식염 주사액 외에는 배합금기<br />∙ 희석 후 즉시 사용. 단회로만 사용하며, 개봉 후 사용되지 않은 제품은 폐기</td>
            </tr>
            <tr id="KDGERI_FOSPHENYTOIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 항암제(플루오로우라실), 아졸계 항진균제(케토코나졸, 이트라코나졸, 플루코나졸, 미코나졸), 글리벤클라미드 (CYP2C9 저해로 혈장 페니토인 농도 증가) <br />∙ 펠바메이트 (CYP2C19 저해로 혈장 페니토인 농도 증가) <br />∙ 아자프로파존, 플루복사민, 니페디핀, 설트랄린, 티클로피딘, 톨부타미드 (CYP2C9/ 2C19 저해로 혈장 페니토인 농도 증가) <br />∙ 급성 알콜 섭취, 아미오다론, 암포테리신 B, 클로람페니콜, 딜티아젬(고용량), 디설피람, 플루옥세틴, H2-길항제(예.시메티딘), 할로탄, 이소니아지드, 메틸페니데이트, 에스트로겐, 오메프라졸, 페노티아진, 페닐부타존, 살리실레이트, 석시니미드(예.에토석시미드), 설폰아미드, 트라조돈, 빌록사진 (이 약 혈중농도 증가) <br />∙ 리팜피신 (CYP2C9/2C19 유도로 혈장 페니토인 농도 감소) <br />∙ 만성 알콜 남용, 디아족시드, 엽산, 넬피나비르, 수크랄페이트, 테오필린, 비가바트린, 제절초(St John's wort) (혈장 페니토인 농도 감소) <br />∙ 넬피나비르 (혈장 페니토인 농도 감소) <br />∙ 항암제, 카르바마제핀, 클로르디아제폭시드, 시프로플록사신, 디아제팜, 페노바르비탈 발프론산나트륨, 발프론산, 특정 제산제 (혈장 페니토인 농도 증가 또는 감소) <br />∙ 항암제(예.테니포시드), 사이클로스포린, 에리트로마이신, 메타돈, 신경근육차단제(예.판쿠로늄, 베쿠로늄), 니카르디핀, 니페디핀, 프라지콴텔, 베라파밀 (CYP3A4 유도로 해당 약 혈중농도 감소) <br />∙ 클로르프로파미드 (CYP2C9/2C19 유도로 해당 약 혈중농도 감소) <br />∙ 테오필린 (CYP1A2 유도로 해당 약 혈중농도 감소)<br /><br />∙ 항생제(예.독시사이클린, 리팜피신, 테트라사이클린), 항응고제(와르파린), 항진균제(아졸계), 코르티코스테로이드, 심혈관계약물(예.디곡신, 니모디핀, 퀴니딘), 푸로세미드, 글리벤클라미드, 호르몬(에스트로겐, 경구용 피임제), 라모트리진, 정신작용약(예.파록세틴, 클로자핀), 비타민 D (해당 약 혈중농도 감소) <br />∙ 파록세틴, 설트랄린 (발작 역치 감소) <br />∙ 인슐린, 글리벤클라미드, 톨부타미드 등 경구용 항당뇨병약 (혈당 증가로 혈당강하제 용량조절 필요)</td>
            </tr>
            <tr id="KDGERI_FOSPHENYTOIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>∙ 근육주사보다 정맥주사하는 경우 흔하게 발생한 이상반응이 더 자주 나타남<br />∙ 용량 및 투여속도와 관련 있음<br />∙ 항전간제 복용한 환자에서 자살충동 또는 자살행동을 보이는 위험성이 증가되므로 비정상적인 기분변화에 대하여 모니터링해야 함백혈구감소증, 과립백혈구감소증, 무과립구증, 골수 억제를 동반하거나 동반하지 않는 범혈구감소증, 혈소판감소증, 재생불량성 빈혈, 림프절병증, 아나필락시스/아나필락시스모양 반응, 과민반응, 결절동맥주위염, 면역글로불린 비정상, 고혈당증, 식욕장애, 이상황홀감, 신경질, 혼동상태, 비정상적인 사고, 안구진탕, 어지럼, 감각이상, 실조, 졸림, 두통, 떨림, 불균형, 이상미각, 혼미, 구음장애, 감각저하, 반사 증가, 반사 저하, 추체외로장애, 흐려보임, 시각 장애, 귀울림, 어지럼, 중증의 심장독성 반응, 심실 전도 저하(서맥과 모든 단계의 심장 차단을 포함), 무수축 심실 세동과 심혈관 허탈, 혈관확장, 저혈압, 폐렴, 호흡정지를 포함하는 호흡기능 변화, 구역, 구강 건조, 구토, 독성 간염, 간세포 손상, 가려움증, 자주 반상출혈, 주사부위 이상반응, 주사부위 통증, 무력증, 오한</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_GABAPENTIN" data-drug-number="128">
          <thead>
            <tr>
              <th className="drug-number">128</th>
              <th className="drug-name">가바펜틴(Gabapentin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항전간제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_GABAPENTIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>간질(Epilepsy), 신경병증성 통증 (Neuropathic pain)</td>
            </tr>
            <tr id="KDGERI_GABAPENTIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 급성 췌장염 환자, 전신 소발작(absence seizure) 혹은 이를 포함하는 발작 혼합 환자(유효하지 않음)</td>
            </tr>
            <tr id="KDGERI_GABAPENTIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량)첫째날: 1회 300mg씩 1일 1회 또는 1회 100mg씩 1일 3회둘째날: 1회 300mg씩 1일 2회 또는 1회 200mg씩 1일 3회셋째날부터: 1회 300mg씩 1일 3회1일 최대용량: 2400mg (간질), 3600mg (신경병증성 통증) <br />∙신경병증성 통증에서 5개월 이상 투여에 대한 안전성 및 유효성 평가되지 않음신장애 환자에서 용량조절CrCl (mL/min)용량≥ 80 1회 300-800mg씩 1일 3회50<br /> - 79 1회 200-600mg씩 1일 3회30<br /> - 49 1회 100-300mg씩 1일 3회15<br /> - 29 1회 200mg씩 1일 3회또는 1회 100mg씩 1일 3회 격일투여&lt; 15 1회 100mg씩 1일 3회또는 1회 100mg씩 1일 3회 격일투여CrCl에 비례하여 감량혈액투석환자초기용량: 300-400mg (1회 100mg씩 1일 3회)유지용량: 4시간 혈액투석 후 200-300mg 보충 혈액투석하지 않는 날은 이 약 투여하지 않음<br />∙고령자에서 신중투여</td>
            </tr>
            <tr id="KDGERI_GABAPENTIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers criteria 해당품목 (항전간제)<br /> - 낙상 및 골절 이력 있는 환자에서 항전간제 투여는 운동실조, 실신 및 추가적인 낙상 유발 가능하므로 안전한 대체약제가 사용 가능하다면 투여 추천되지 않음<br />∙졸음, 어지러움, 피로감, 운동실조 등 주된 이상반응 감소시키기 위해 투여 첫날 1차 투약은 취침 시 시행<br />∙정신병의 병력이 있는 환자, 말초 신경병증성 통증에 5개월 이상 투여하는 경우 신중투여</td>
            </tr>
            <tr id="KDGERI_GABAPENTIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 마그네슘 혹은 알루미늄을 함유하는 제산제 (이 약 생체이용률 감소. 최소 2시간 후에 이 약 투여) <br />∙ 아편유사제 (이 약 효과 증가. 졸음, 진정 및 호흡억제와 같은 중추신경계 억제 증상을 주의 깊게 관찰이 필요) <br />∙ 나프록센나트륨 (이 약 흡수 증가)</td>
            </tr>
            <tr id="KDGERI_GABAPENTIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>어지러움, 졸음, 운동실조, 피로, 바이러스 감염, 말초부종, 혈관확장, 적개심, 진전, 운동과다, 두통, 사고이상, 보행이상, 기억상실, 우울증, 감정적 불안정, 지각감퇴, 가려움, 발진, 체중증가, 설사, 구역 및/혹은 구토, 구갈 또는 목마름, 변비, 복통, 소화불량, 치아 비정상, 식욕증가, 발기불능, 백혈구감소증, 요통, 근육통, 골절, 약시, 복시, 안구진탕증, 기침, 인두염, 비염신경정신계<br />∙ 항전간제 복용한 환자에서 자살충동 또는 자살행동을 보이는 위험성이 증가되므로 비정상적인 기분변화에 대하여 모니터링해야 함</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_LACOSAMIDE" data-drug-number="129">
          <thead>
            <tr>
              <th className="drug-number">129</th>
              <th className="drug-name">라코사미드(Lacosamide)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항전간제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_LACOSAMIDE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제(정제, 시럽제), 주사] 16세 이상의 간질 환자에서 2차성 전신발작을 동반하거나 동반하지 않는 부분발작 치료의 부가요법주사제는 경구투여가 일시적으로 불가능한 환자에 투여</td>
            </tr>
            <tr id="KDGERI_LACOSAMIDE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 페닐케톤뇨증 환자(시럽제),</td>
            </tr>
            <tr id="KDGERI_LACOSAMIDE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 식사와 관계없이 복용<br />[주사제] 1회 30~60분간 정맥주입. 희석하지 않고 주입 가능초회투여량: 1회 50mg씩 1일 2회로 시작, 매주 1회 50mg씩 1일 2회로 증량권장투여량: 1회 200mg씩 1일 2회 (일반용량)투여 중단 시 점차적으로 감량 (예: 1일 투여량을 매주 200mg씩 점차 감량) <br />∙신장애 환자<br /> - 경증 또는 중등증의 신장애 환자(CrCl&gt;30ml/min): 용량조절 불필요<br /> - 중증의 신장애 환자(CrCl&lt;30ml/min), 말기 신질한 환자: 1일 최대투여량 300mg<br /> - 혈액투석환자: 혈액투석 직후 1회 투여량의 최대 50%까지 추가용량 투여<br />∙간장애 환자<br /> - 경증 또는 중등증 간장애 환자: 1일 최대투여량 300mg<br /> - 중증의 간장애 환자: 투여 권장되지 않음</td>
            </tr>
            <tr id="KDGERI_LACOSAMIDE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers criteria 해당품목 (항전간제)<br /> - 낙상 및 골절 이력 있는 환자에서 항전간제 투여는 운동실조, 실신 및 추가적인 낙상 유발 가능하므로 안전한 대체약제가 사용 가능하다면 투여 추천되지 않음<br />∙경구제↔주사제 투여경로 변경 시 용량적정 없이 바로 투여 가능<br />∙5일까지 주사제 투여 경험 있음<br />∙신중투여<br />∙어지러움, 심장전도 및 심장박동 이상</td>
            </tr>
            <tr id="KDGERI_LACOSAMIDE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙카르바마제핀, 라모트리진, 프레가발린, class 1 항부정맥약 (PR연장) <br />∙케토로락, 나프록센: 이 약의 항경련 효과 저하</td>
            </tr>
            <tr id="KDGERI_LACOSAMIDE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>어지러움, 피로, 운동실조, 두통, 운동장애, 구역, 구토, 떨림, 겹보임(복시), 시야흐림, 실신, 현기증, 졸음, 기억손상, 평형장애, 협동장애, 보행장애, 우울증, 가려움증, 설사, 타박상, 변비, 위고창, 소화불량, 구강건조<br />∙항전간제 복용한 환자에서 자살충동 또는 자살행동을 보이는 위험성이 증가되므로 비정상적인 기분변화에 대하여 모니터링해야 함</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_LAMOTRIGINE" data-drug-number="130">
          <thead>
            <tr>
              <th className="drug-number">130</th>
              <th className="drug-name">라모트리진(Lamotrigine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항전간제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_LAMOTRIGINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>간질(부분발작 및 전신 강직간대발작의 단독요법 및 부가요법, 레녹스-가스토 증후군에 의한 발작의 부가요법), 양극성 1형 장애 환자에서의 우울삽화의 재발 방지</td>
            </tr>
            <tr id="KDGERI_LAMOTRIGINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 이 약 투여와 관련된 무균 수막염으로 인해 투여를 중단한 환자</td>
            </tr>
            <tr id="KDGERI_LAMOTRIGINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) A: 글루쿠론산 포합 억제제 (예: 발프로에이트) B: 글루쿠론산 포합 유도체 (예: 페니토인, 카르바마제핀, 페노바르비탈, 프리미돈, 리팜피신, 로피나비어, 리토나비어) <br />∙간질A B제1･2주제3･4주유지용량O O/X 1회 25mg씩2일 1회1회 25mg씩1일 1회1회 100-200mg씩 1일 1회 또는1회 50-100mg씩 1일 2회유지용량에 도달할 때까지 1-2주마다최대 25-50mg씩 증량X O 1회 50mg씩1일 1회1회 50mg씩1일 2회1회 100-200mg씩 1일 2회유지용량에 도달할 때까지 1-2주마다최대 100mg씩 증량X X 1회 25mg씩1일 1회1회 50mg씩1일 1회1회 100-200mg씩 1일 1회 또는1회 50-100mg씩 1일 2회유지용량에 도달할 때까지 1-2주마다최대 50-100mg씩 증량라모트리진단독<br />∙양극성장애A B제1･2주제3･4주제5주목표 안정화용량 (6주) O O/X 1회 25mg씩2일 1회1회 25mg씩1일 1회1회 25mg씩1일 2회또는1회 50mg씩1일 1회1회 50mg씩 1일 2회또는1회 100mg씩 1일 1회1일 최대 용량: 200mg X O 1회 50mg씩1일 1회1회 50mg씩1일 2회1회 100mg씩1일 2회1회 150mg씩 1일 2회필요시 7주째에1회 200mg씩 1일 2회까지 증량X X 1회 25mg씩1일 1회1회 25mg씩1일 2회또는1회 50mg씩1일 1회1회 50mg씩1일 2회또는1회 100mg씩1일 1회1회 100mg씩 1일 2회또는1회 200mg씩 1일 1회라모트리진단독<br />병용투여약제 중단 후 양극성 장애환자에서의 1일 유지 안정화 용량A B제1주제2주제3주 이후중단O/X안정화 용량의 2배 투여. 단 용량 증량이 100 mg/주를 초과하지 않아야 함1주째의 용량 유지X중단기존 유지 용량에 따라용량선택투여1회 200mg씩1일 2회1회 150mg씩1일 2회1회 100mg씩1일 2회1회 150mg씩1일 2회1회 125mg씩1일 2회1회 75mg씩1일 2회1회 100mg씩1일 2회1회 75mg씩 1일 2회1회 50mg씩1일 2회X X용량 증량을 통해 도달된 목표 유지용량을 유지, 1회 100mg씩 1일 2회다른 약물의 부가요법에 따른 양극성 장애 환자에서의 라모트리진 용량 조절: 라모트리진의 기존 투여량에 따라 용량 선택투여A B현재의 라모트리진 안정화 용량제1주제2주제3주 이후추가1회 100mg씩1일 2회100mg씩 1일 1회 또는 1회 50mg씩 1일 2회1회 150mg씩1일 2회150mg씩 1일 1회 또는 1회 750mg씩 1일 2회1회 200mg씩1일 2회200mg씩 1일 1회 또는 1회 100mg씩 1일 2회X추가1회 100mg씩1일 2회1회 100mg씩1일 2회1회 150mg씩1일 2회1회 200mg씩1일 2회1회 75mg씩1일 2회1회 75mg씩1일 2회1회 112.5mg씩1일 2회1회 150mg씩1일 2회1회 50mg씩1일 2회1회 50mg씩1일 2회1회 75mg씩1일 2회1회 100mg씩1일 2회X X용량 증량을 통해 도달된 목표 유지용량<br />∙갑작스런 투여중지는 반동성 경련을 초래하므로 안전성의 문제(예를 들어 심각한 피부 발진)로 인해 즉각적인 투여중지가 요구되지 않는다면 이 약의 용량은 최소 2주에 걸쳐 점진적으로 감소<br />∙재시작시 일반적으로 투여중단기간이 이 약 반감기의 5배를 초과한다면 적절한 계획에 따라 유지용량까지 점차적으로 증량. 단, 발진으로 투여 중단한 경우 기대되는 유익성이 위험성을 상회하지 않는다면 이 치료를 재개하지 말 것<br />∙고령자는 낮은 용량부터 시작하여 신중투여<br />∙간장애 환자에서 초기용량, 증가용량, 유지용량은 각각 약 50% 및 75%까지 감소</td>
            </tr>
            <tr id="KDGERI_LAMOTRIGINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers criteria 해당품목 (항전간제)<br /> - 낙상 및 골절 이력 있는 환자에서 항전간제 투여는 운동실조, 실신 및 추가적인 낙상 유발 가능하므로 안전한 대체약제가 사용 가능하다면 투여 추천되지 않음<br />∙발진: 잠재적으로 생명을 위협하는 중증의 피부발진이 보고되었으며, 라모트리진의 초회 투여량이 높거나 권장 용량 증가량을 초과하여 투여할 경우, 발프로에이트와 병용 투여할 경우, 다른 항전간제에 대한 알레르기 또는 발진의 병력이 있는 경우 위험성 증가<br />∙심전도 이상이 있거나 방실 전도 억제 약물을 투여중인 경우 신중투여<br />∙이 약은 멜라닌과 결합할 수 있기 때문에, 시간이 지나면서 눈 등 멜라닌이 풍부한 조직에 축적될 수 있음</td>
            </tr>
            <tr id="KDGERI_LAMOTRIGINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙글루쿠론산 포합 억제제 (발프로에이트: 이 약 대사 감소, 평균 반감기 2배 증가) <br />∙글루쿠론산 포합 유도제 (카르바마제핀, 페니토인, 프리미돈, 페노바르비탈계, 리팜피신, 로피나비어/리토나비어, 아타자나비어/리토나비어, 에티닐에스트라디올/레보노르게스트렐 혼합제제: 이 약 대사 촉진) <br />∙CNS 억제제 (이 약에 의해 부작용/독성작용 증가 가능)</td>
            </tr>
            <tr id="KDGERI_LAMOTRIGINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>피부발진, 구역, 불면증, 졸음, 피로, 어지러움, 운동실조, 불안, 통증, 신경과민, 자살시도, 비정상적 꿈, 비정상적 사고, 초조, 기억상실, 우울, 통합운동장애, 감각저하, 두통, 감각저하, 감각이상, 반사이상항진, 반사저하, 혼돈, 감각이상, 발진, 피부염, 발한증가, 피부건조증, 체중감소, 체중증가, 구토, 소화불량, 복통, 구강건조, 변비, 식욕부진, 성욕감소, 빈뇨, 감염, 요통, 무력증, 관절통, 근육통, 복시, 흐린 시력, 약시, 인두염, 기침, 호흡곤란, 코피, 독감 증후군, 호흡기 장애, 흉통, 기면, 비염항전간제 복용한 환자에서 자살충동 또는 자살행동을 보이는 위험성이 증가되므로 비정상적인 기분변화에 대하여 모니터링해야 함</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_LEVETIRACETAM" data-drug-number="131">
          <thead>
            <tr>
              <th className="drug-number">131</th>
              <th className="drug-name">레비티라세탐(Levetiracetam)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항전간제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_LEVETIRACETAM_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>처음 간질로 진단된 2차성 전신발작을 동반하거나 동반하지 않는 부분발작의 치료의 단독요법기존 1차 간질치료제 투여로 적절하게 조절이 되지 않는 2차성 전신발작을 동반하거나 동반하지 않는 부분발작, 특발성 전신성 간질(Idiopathic Generalized Epilepsy) 환자의 1차성 전신 강직-간대 발작 치료의 부가요법</td>
            </tr>
            <tr id="KDGERI_LEVETIRACETAM_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증</td>
            </tr>
            <tr id="KDGERI_LEVETIRACETAM_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량)신기능 정상환자<br />∙단독요법<br /> - 1회 250mg씩 1일 2회로 시작<br /> - 2주 후 1회 500mg씩 1일 2회로 증량, 2주마다 1회 250mg씩 증량할 수 있음<br /> - 1일 최대투여량: 3000mg (1500mg씩 1일 2회) <br />∙부가요법<br /> - 부분발작: 1회 500mg씩 1일 2회, 임상적 반응과 내약성에 따라 2-4주마다 1회 500mg씩 증량 또는 감량<br /> - 1차성 전신 강직-간대발작: 1회 500m씩 1일 2회, 2주마다 1회 500mg씩 증량하여 1회 1500mg씩 1일 2회까지 증량신장애환자군CrCl (mL/min) 1회 용량용 법정상&gt; 80 500-1500mg 1일 2회(12시간간격)경증50-80 500-1000mg 1일 2회(12시간간격)중등증30-50 250-750mg 1일 2회(12시간간격)중증&lt; 30 250-500mg 1일 2회(12시간간격)말기신질환투석환자-투여첫날 750mg 1회이후 500-1000mg 1일 1회, 투석 후 250-500mg 추가투여<br />∙신기능이 약화된 노인에서 용량조정이 권장됨<br />[주사제]주사제는 경구투여가 일시적으로 불가능한 환자에게 투여경구제와 용량 동일. 경구↔주사 투여경로 변경 시 용량적정 없이 바로 투여 가능주사제는 4일을 초과하여 정맥투여한 경험이 없음<br />주사제는 정맥으로만 투여, 투여 전 반드시 희석할 것투여량투여 용량희석제 용량주입시간투여횟수1일 총 투여량250mg 2.5mL (1/2 바이알) 100mL 15분1일 2회500mg/일500mg 5mL (1 바이알) 100mL 15분1일 2회1000mg/일1000mg 10mL (2 바이알) 100mL 15분1일 2회2000mg/일1500mg 15mL (3 바이알) 100mL 15분1일 2회3000mg/일</td>
            </tr>
            <tr id="KDGERI_LEVETIRACETAM_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙중단 시 발작 빈도가 증가되는 잠재성을 최소화하기 위해 점진적으로 감량<br /> - 성인은 500mg을 1일 2회 매 2-4주마다 단계적으로 감량<br />∙2012 Beers criteria 해당품목 (항전간제)<br /> - 낙상 및 골절 이력 있는 환자에서 항전간제 투여는 운동실조, 실신 및 추가적인 낙상 유발 가능하므로 안전한 대체약제가 사용 가능하다면 투여 추천되지 않음</td>
            </tr>
            <tr id="KDGERI_LEVETIRACETAM_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙케토로락 (이 약의 효과 감소) <br />∙카바마제핀 (해당 약의 독성인 안구진탕증, 운동장애, 현기증, 복시 증상 발생) <br />∙은행엽 (이 약의 효과 감소)</td>
            </tr>
            <tr id="KDGERI_LEVETIRACETAM_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>혈압증가, 행동이상 (적개심/공격성, 초조, 분노, 불안, 감정둔마, 이인증, 과민성, 감정적 불안정성, 신경과민/과민성, 인격장애), 두통, 졸음, 피로, 구토, 감염, 무력증, 비인두염, 어지러움, 우울, 현훈(어지러움), 조화운동불능/운동실조, 균형 장애, 감정적 불안정성/기분의 요동, 불면, 복통, 설사, 소화불량, 구역, 식욕부진, 근육통, 복시, 흐린 시력, 기억상실, 경련, 운동과다증, 떨림, 주의력 장애, 기억 손상<br />∙항전간제 복용한 환자에서 자살충동 또는 자살행동을 보이는 위험성이 증가되므로 비정상적인 기분변화에 대하여 모니터링해야 함</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_OXCARBAZEPINE" data-drug-number="132">
          <thead>
            <tr>
              <th className="drug-number">132</th>
              <th className="drug-name">옥스카르바제핀(Oxcarbazepine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항전간제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_OXCARBAZEPINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제] 부분발작, 전신 강직간대발작</td>
            </tr>
            <tr id="KDGERI_OXCARBAZEPINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약, 카르바마제핀, 다른 삼환계 항우울제 또는 이 약의 구성성분에 과민증, 방실차단, 골수억제, MAO억제 병용</td>
            </tr>
            <tr id="KDGERI_OXCARBAZEPINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제]다른 항전간제에서 전환하는 경우 병용하는 항전간제 투여를 3∼6주에 걸쳐 완전하게 중지하면서, 이 약은 약 2∼4주에 걸쳐 최고 용량에 도달- 초기용량: 1회 300mg씩 1일 2회, 일주일 간격으로 1회 300mg 이하씩 증량- 유지용량: 1회 300-1200mg씩 1일 2회<br />∙신기능 장애 환자<br /> - CrCl&lt;30ml/min: 1회 150mg씩 1일 2회로 시작, 1주일 이상의 간격으로 원하는 임상반응이 나타날 때까지 증량</td>
            </tr>
            <tr id="KDGERI_OXCARBAZEPINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers criteria 해당품목 (항전간제)<br /> - 낙상 및 골절 이력 있는 환자에서 항전간제 투여는 운동실조, 실신 및 추가적인 낙상 유발 가능하므로 안전한 대체약제가 사용 가능하다면 투여 추천되지 않음<br />∙옥스카르바제핀 또는 활성대사체인 MHD의 혈장농도 모니터링은 일반적으로 권장되지 않으나, 신장애 환자, 간효소 유도 약물을 병용중인 경우에는 이 약 복용 2-4시간 후 측정한 혈중농도가 MHD&lt;35mg/L도록 용량 조절해야 함.</td>
            </tr>
            <tr id="KDGERI_OXCARBAZEPINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙MAO억제제 (병용금기): 이 약 투여 최소 2주 전 MAO 억제제 투여 중단할 것<br />∙페니토인 (해당 약 혈중농도 증가) <br />∙시클로스포린, 타크롤리무스 (해당 약 혈중농도 감소) <br />∙카르바마제핀, 페니토인, 페노바르비탈 (이 약 혈중농도 저하) <br />∙라모트리진 (구역, 졸음, 어지러움, 두통 등 이상반응 증가) <br />∙베라파밀 (이 약 혈중농도 감소) <br />∙알코올 (진정작용 유발)</td>
            </tr>
            <tr id="KDGERI_OXCARBAZEPINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>∙항전간제 복용한 환자에서 자살충동 또는 자살행동을 보이는 위험성이 증가되므로 비정상적인 기분변화에 대하여 모니터링해야 함저나트륨혈증, 초조(예, 신경과민), 정서불안정(예, 신경증), 혼돈상태, 우울, 기억상실, 감정 둔화, 졸음, 두통, 어지러움, 흔하게 운동실조, 진전, 안구진탕증, 주의력 장애, 기억력 장애, 복시, 혼탁시야, 시각 장애, 어지러움, 이명, 구토, 구역, 설사, 복통, 변비, 발진, 탈모증, 여드름, 피로, 무력증, T4 감소</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PHENYTOIN" data-drug-number="133">
          <thead>
            <tr>
              <th className="drug-number">133</th>
              <th className="drug-name">페니토인(Phenytoin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항전간제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PHENYTOIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제]간질: 강직간대발작(대발작), 부분발작(초점발작), 정신운동성발작[주사제]간질중첩상태, 경구투여가 불가능한 경우(특히 의식장애, 수술중･수술후), 1차라인 치료가 효과적이 않은 디기탈리스로 유도된 심부정맥</td>
            </tr>
            <tr id="KDGERI_PHENYTOIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>히단토인계 화합물 과민증, 중증의 혈액 및 골수장애, 2, 3도 방실블록, 3개월 이내 심근경색애덤스-스톡스 증후군, 동서맥, 동방블록: 주사제에 한함</td>
            </tr>
            <tr id="KDGERI_PHENYTOIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) <br />∙간질<br /> - 초기용량: 1회 100㎎씩 1일 3회<br /> - 유지용량: 1일 300-400mg 분할투여<br /> - 1일 최대투여량 600mg/일<br /> - 발작의 정도 및 환자의 내약성에 따라 용량을 조절하며, 필요시 혈중농도를 측정<br /> - 1일 1회 용법으로 투여해서는 안되며 반드시 분할투여<br />[주사제] (일반용량) <br />∙간질중첩상태, 경구투여로 발작의 억제가 곤란한 경우<br /> - 125-250㎎를 50mg/min 미만의 속도로 천천히 정맥주사<br /> - 필요시 30분 후 100-150㎎ 추가 투여하거나 다른 치료 고려<br /> - 투여 후 경련이 소실하여 의식 회복되면 경구투여로 전환<br />∙1차라인 치료가 효과적이 않은 디기탈리스로 유도된 심부정맥<br /> - 3.5-5mg/kg를 50mg/min 미만의 속도로 천천히 정맥주사. 필요시 1회 반복<br /> - 연령, 증상에 따라 적절히 증감</td>
            </tr>
            <tr id="KDGERI_PHENYTOIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers criteria 해당품목 (항전간제)<br /> - 낙상 및 골절 이력 있는 환자에서 항전간제 투여는 운동실조, 실신 및 추가적인 낙상 유발 가능하므로 안전한 대체약제가 사용 가능하다면 투여 추천되지 않음<br />∙서맥(50/분 미만) 환자에게 신중투여<br />∙주사제의 경우 중증의 쇠약 환자 및 고령자에서 주의<br />∙말초 정맥주사 후 Purple Glove 증후군(부종, 피부변색 및 주사부위 원위부 통증 등)이 보고됨. 국소 독성 위험을 낮추기 위해 넓은 구경의 카테터를 통하여 말초의 넓은 정맥 또는 중심정맥을 통하여 직접 주입하여야 함. <br />∙강직간대발작을 억제하는 약물은 결신발작에는 효력이 없음<br /> - 혼합 발작형에서는 복합약물치료가 필요함<br />∙일반적으로 고령자는 저용량에서 투여 시작하는 등 신중투여<br /><br />∙급격한 용량 감소나 중지로 간질중첩상태 발생 가능하므로 천천히 감량 및 중단. 고령자는 독성 징후가 일찍 나타나므로 주의<br />∙치료중 간･신기능검사, 혈액검사를 정기적으로 수행<br />∙1주 이상 근육주사 해야 하는 환자의 경우 다른 투여 경로로 대체해야 함<br />∙1주 이하로 근육주사 후 경구로 전환할 경우, 기존의 근육주사 투여기간만큼 본래 경구투여 용량의 50%로 감량하여 복용</td>
            </tr>
            <tr id="KDGERI_PHENYTOIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙와르파린, 디설피람, 페닐부타존, 파라아미노살리실산, 이소니코틴산히드라짓, 설티암, 메칠페니데이트, 에토석시미드, 테가푸르, 플루코나졸, 미코나졸, 조니사마이드, 급성 알코올 섭취, 아미오다론, 클로람페니콜, 디아제팜. 디쿠마롤, 설폰아미드, 할로탄, 이소니아지드, 에스트로겐, 설파메티졸, 설파페나졸, 니페디핀, 오메프라졸, 시프로플록사신, 에녹사신, 노플록사신, 펠바메이트, 플루오세틴, 인플루엔자 백신, 메드로니다졸, 티클로피딘 (이 약의 작용이 증강) <br />∙만성 알코올 남용자, 레세르핀, 카르바마제핀, 슈크랄페이트, 칼슘함유 제산제, 아미오다론, 시스플라틴, 디설피람, 블레오마이신, 엽산, 피리독신, 비가바트린, 테오필린(이 약 농도 감소) <br />∙아세타졸아미드 (구루병, 골연화증 부작용 위험 증가) <br />∙덱사메타손 등 부신피질호르몬, 갑상선호르몬, 독시사이클린, 항응고제, 에스트로겐, 푸로세미드, 경구용 피임제, 퀴니딘, 리팜피신 (해당 약물 작용 감소) <br />∙발프로산나트륨, 페노바르비탈 (이 약 혈중농도가 변화(상승 또는 저하)) <br />∙딜티아젬 (이 약 혈중농도 상승) <br />∙펠로디핀, 베라파밀 (해당 약 혈중농도 저하) <br />∙빈크리스틴 등 빈카알카로이드 (이 약 혈중농도 저하) <br />∙도파민 (서맥, 급격한 저혈압-주사제에 한함) <br />∙리도카인, β-차단제 (심장억제 작용 증가-주사제에 한함) <br />∙알로푸리놀 (이 약 혈중농도 상승-경구제에 한함) <br />∙설파메톡사졸, 트리메토프림, (이 약 작용 증가- 경구제에 한함) <br />∙인슐린, 경구용 혈당강하제 (혈당치 증가) <br />∙경구용 디아족사이드 (고혈당 작용 감소)</td>
            </tr>
            <tr id="KDGERI_PHENYTOIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>불수의운동(이상운동증, 무도병, 고정자세불능증등), 신경병증, 어지러움, 운동실조증, 정신착란, 구음장애, 불면, 신경과민, 주의력･집중력, 반사운동능력의 저하, 성홍열양･홍역양･중독진양 발진, 혈소판감소, 백혈구감소, 과립구감소, 무과립구증, 범혈구감소, 적혈구증가, 거적아구성 빈혈, 드물게 재생불량성 빈혈, 단구성 백혈병, 용혈성 빈혈, 중독성 간염, 황달, 단백뇨, 안구진탕증, 시각장애, 치은증식, 안면거침, 다모증, 입술종창, 페로니 증후군, 구루병, 골연화증, 치아형성부전, 결절성 동맥주위염, 다발성 관절증, 과혈당, 털과다증, 탄수화물 불내성, 엽산결핍증, SLE <br />∙항전간제 복용한 환자에서 자살충동 또는 자살행동을 보이는 위험성이 증가되므로 비정상적인 기분변화에 대하여 모니터링해야 함</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PREGABALIN" data-drug-number="134">
          <thead>
            <tr>
              <th className="drug-number">134</th>
              <th className="drug-name">프레가발린(Pregabalin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항전간제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PREGABALIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>성인에서 말초와 중추 신경병증성 통증의 치료, 성인에서 이차적 전신증상을 동반하거나 동반하지 않은 부분발작의 보조제, 섬유근육통의 치료</td>
            </tr>
            <tr id="KDGERI_PREGABALIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증</td>
            </tr>
            <tr id="KDGERI_PREGABALIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량)음식물과 상관없이 경구투여신기능 정상 환자1회 75mg씩 1일 2회로 시작, 3-7일 후 1회 150mg씩 1일 2회로 증량 가능. 필요시 이후 7일 간격으로 증량<br />∙신경병증 통증, 간질의 1일 최대량: 1회 300mg씩 1일 2회<br />∙섬유근육통의 치료의 1일 최대량: 1회 225mg씩 1일 2회중단할 경우 1주일 이상의 간격을 두고 점진적으로 중단신기능 저하 환자CrCl 30-60ml/min: 1일 37.5mg씩 1일 2회로 시작, 최대 150mg씩 1일 2회CrCl 15-30ml/min: 1일 25mg씩 1일 1회 또는 2회로 시작, 최대 75mg씩 1일 2회CrCl&lt;15ml/min: 1일 25mg씩 1일 1회로 시작, 최대 75mg씩 1일 1회혈액투석 환자: CrCl&lt;15ml/min과 동일, 매 4시간마다 혈액투석 실시한 후에는 25mg 1회 보충투여</td>
            </tr>
            <tr id="KDGERI_PREGABALIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers criteria 해당품목 (항전간제)<br /> - 낙상 및 골절 이력 있는 환자에서 항전간제 투여는 운동실조, 실신 및 추가적인 낙상 유발 가능하므로 안전한 대체약제가 사용 가능하다면 투여 추천되지 않음<br />∙신중투여<br /> - 당뇨환자 (혈당강하제의 용량조정 필요할 수 있음)<br /> - 고령환자 (어지러움 및 졸음으로 우연한 상해의 빈도 증가 가능)<br /> - 중증의 울혈성 심부전 환자<br />∙일부 환자에서 금단증상이 보고되었으며, 시판 후 자료에서 오용 및 남용 사례가 보고되었으므로 징후를 관찰해야 함<br />∙당뇨병성 말초 신경병증 및 대상 포진후 신경통 외의 다른 신경병증성 통증에 대한 유효성은 입증되지 않음</td>
            </tr>
            <tr id="KDGERI_PREGABALIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙에탄올, 로라제팜 (효과 증강) <br />∙옥시코돈 (인지력 및 운동기능 감소) <br />∙다른 중추신경계 억제제 (호흡부전, 혼수) <br />∙아편유사 진통제 (장폐쇄증, 무력 장폐쇄증, 변비 등 하부소화기계 기능 감소)</td>
            </tr>
            <tr id="KDGERI_PREGABALIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>말초부종, 어지러움, 졸음, 실조, 두통, 피로, 체중증가, 구강건조, 떨림, 시야흐림, 복시, 감염, 우연한 상해, 흉통, 고혈압, 저혈압, 감각이상, 혼돈, 환각, 적절한 용어 찾기의 어려움, 주의력 장애, 기억상실, 기억력 장애, 운동협조이상, 불면증, 어지러움, 감각저하, 감각이상, 취한느낌, 불안, 기면, 방향감장애, 이인증, 정신운동성 과민, 안절부절, 초조, 자극과민성, 우울, 다행감, 구진상 발진, 두드러기, 성욕감소, 체액저류, 저혈당, 구역, 구토, 복부팽만, 변비, 고창(방귀), 식욕감소, 복통, 혈소판감소증, 평형장애, 근육경련, 관절통, 등통증, 사지통증, 자궁경부경련, 근육연축, 목의 통증, 근육경직, 관절종창, 시야장애, 코인두염항전간제 복용한 환자에서 자살충동 또는 자살행동을 보이는 위험성이 증가되므로 비정상적인 기분변화에 대하여 모니터링해야 함</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PRIMIDONE" data-drug-number="135">
          <thead>
            <tr>
              <th className="drug-number">135</th>
              <th className="drug-name">프리미돈(Primidone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항전간제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PRIMIDONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>간질 : 강직간대발작(대발작), 정신운동성발작, 부분발작(초점발작)</td>
            </tr>
            <tr id="KDGERI_PRIMIDONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>급성 간헐성 포르피린증, 바르비탈계 약물 과민증, 중추신경억제제 및 알코올중독 환자</td>
            </tr>
            <tr id="KDGERI_PRIMIDONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량)초기 3일간 1회 250㎎씩 1일 1회 취침전 투여이후 발작 정도에 따라 3일 간격으로 250㎎씩 증량함.권장 유지용량: 1일 1.5g 2-3회 분할투여1일 최대투여량: 2g연령, 증상에 따라 적절히 증감</td>
            </tr>
            <tr id="KDGERI_PRIMIDONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers criteria 해당품목 (항전간제)<br /> - 낙상 및 골절 이력 있는 환자에서 항전간제 투여는 운동실조, 실신 및 추가적인 낙상 유발 가능하므로 안전한 대체약제가 사용 가능하다면 투여 추천되지 않음<br />∙대사체가 페노바르비탈임<br />∙고령자는 호흡억제가 나타날 수 있으므로 신중 투여, 중지할 경우 천천히 감량<br />∙갑자기 중단할 경우 간질중첩상태가 나타날 수 있으므로 감량 및 투여중지시에는 서서히 용량을 조절할 것을 권고<br />∙약물의 독성작용을 감시하기 위해 치료기간중 간･신기능검사, 혈액검사를 주기적으로 시행할 것을 권고</td>
            </tr>
            <tr id="KDGERI_PRIMIDONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙알코올 또는 페노티아진계 약물, 바르비탈계 약물 등의 중추신경억제제, 삼환계 항우울약, MAO저해제, 메칠페니데이트, 항히스타민제 (상호작용 증가) <br />∙치아짓계 이뇨제 (기립성 저혈압 증가) <br />∙아세타졸아미드 (구루병, 골연화증) <br />∙독시사이클린 (이 약 혈중반감기 단축) <br />∙페니토인 등의 항경련제, 와르파린 (간효소 유도하여 해당약물 농도 변화) <br />∙코르티코스테로이드 (해당 약 작용 감소)</td>
            </tr>
            <tr id="KDGERI_PRIMIDONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>∙피부점막안증후군(Stevens-Johnson syndrome), 재생불량성 빈혈, 불안, 불면, 경련, 구역, 환각, 망상, 흥분, 착란 또는 우울 등의 금단증상, 졸음, 주의력, 집중력, 반사운동능력 저하, 어지러움, 운동실조, 두통, 권태, 피로, 기분장애, 구음장애, 착란, 신경과민, 기억장애, 성격변화, 명정상태, 구역, 구토, 식욕부진, 과립구감소증, 과립구증가증, 적혈구형성부전, 서맥, 저혈압, 쇼크, 부정맥(고용량), 구루병, 골연화증, 치조골형성부전, 발기부전, 자극과민<br />∙항전간제 복용한 환자에서 자살충동 또는 자살행동을 보이는 위험성이 증가되므로 비정상적인 기분변화에 대하여 모니터링해야 함</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_RUFINAMIDE" data-drug-number="136">
          <thead>
            <tr>
              <th className="drug-number">136</th>
              <th className="drug-name">루피나미드(Rufinamide)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항전간제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_RUFINAMIDE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>레녹스-가스토 증후군과 관련된 간질 치료시 부가 요법</td>
            </tr>
            <tr id="KDGERI_RUFINAMIDE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 선천성 QT 간격 단축 증후군 또는 그러한 가족력이 있는 환자(Familial Short QT Syndrome) 환자</td>
            </tr>
            <tr id="KDGERI_RUFINAMIDE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (고령자 용량)초기용량: 1회 200mg씩 1일 2회 음식과 함께 복용. 1일 단위로 400mg씩 증량체중 범위30.0<br /> - 50.0 kg 50.1<br /> - 70.0 kg 70.1 kg 이상최대권장용량1회 900mg씩 1일 2회1회 1200mg씩 1일 2회1회 1600mg씩 1일 2회중단 시 서서히 감량해야 함 (임상 시험에서는 매 이틀마다 25%씩 감량하였음)</td>
            </tr>
            <tr id="KDGERI_RUFINAMIDE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙간질 치료에 경험이 신경과 전문의에 의해 치료를 시작해야 함<br />∙2012 Beers criteria 해당품목 (항전간제)<br /> - 낙상 및 골절 이력 있는 환자에서 항전간제 투여는 운동실조, 실신 및 추가적인 낙상 유발 가능하므로 안전한 대체약제가 사용 가능하다면 투여 추천되지 않음<br />∙중증 간장애 환자에게 투여 권장되지 않음</td>
            </tr>
            <tr id="KDGERI_RUFINAMIDE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙카바마제핀, 페노바비탈, 페니토인, 비가바트린, 프리미돈 (이 약 농도 감소) <br />∙발프로산 (이 약 농도 증가, 30kg 미만의 환자에서 현저함) <br />∙페니토인 (해당 약 혈장 평균 농도 증가) <br />∙CYP3A 효소계에 의해 대사되는 약제 (해당 약제 농도 변경 가능)</td>
            </tr>
            <tr id="KDGERI_RUFINAMIDE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>폐렴, 인플루엔자, 코인두염, 중이염, 부비동염, 비염, 식욕부진, 섭식 장애 식욕 감소, 불안, 불면, 졸음, 두통, 어지러움, 간질지속상태, 경련, 협동장애, 눈떨림, 정신운동 과다활동, 떨림, 복시, 시각 흐림, 현기증, 코피, 구역, 구토, 상부 복통, 변비, 소화불량, 설사, 발진, 여드름, 등통증, 희발월경, 피로, 걸음 장애, 체중 감소, 머리 손상, 타박상, 약물과민증후군, 지속성 간질<br />∙항전간제 복용한 환자에서 자살충동 또는 자살행동을 보이는 위험성이 증가되므로 비정상적인 기분변화에 대하여 모니터링해야 함</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_SODIUMVALPROATE" data-drug-number="137">
          <thead>
            <tr>
              <th className="drug-number">137</th>
              <th className="drug-name">발프로산나트륨 (Sodium Valproate)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항전간제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_SODIUMVALPROATE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제, 주사제]간질과 간질에 뒤따르는 성격, 행동장애의 예방과 치료수술후 및 외상후의 발작 (주사제에 한함)</td>
            </tr>
            <tr id="KDGERI_SODIUMVALPROATE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>간염(특히 약물에 의한) 병력 또는 가족력, 이 약 과민증, 중증 간장애, 카바페넴계항생물질(베타미프론, 메로페넴, 이미페넴, 실라스타틴, 파니페넴) 투여, 포르피린증, 간질환</td>
            </tr>
            <tr id="KDGERI_SODIUMVALPROATE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제: 정제] (일반용량) 1일 400-1200mg을 2-3회 분할 경구투여<br />[경구제: 서방정, 시럽제, 액제]초회량: 5-10mg/kg 경구투여, 4-7일마다 5mg씩 증량유지용량: 20mg/kg/일. 연령, 증상에 따라 적절히 증감<br />[주사제] (일반용량, 고령자는 성인의 투여방법에 준함) 400-800mg (최대 10mg/kg)를 지속적 또는 반복적으로 3-5분에 걸쳐 정맥주사1일 최대 2500mg 범위 내에서 지속적 또는 반복적으로 정맥주사</td>
            </tr>
            <tr id="KDGERI_SODIUMVALPROATE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers criteria 해당품목 (항전간제)<br /> - 낙상 및 골절 이력 있는 환자에서 항전간제 투여는 운동실조, 실신 및 추가적인 낙상 유발 가능하므로 안전한 대체약제가 사용 가능하다면 투여 추천되지 않음<br />∙고령자에는 혈장 알부민이 감소되어 유리 약물 혈중농도가 높아질 수 있으므로 용량에 유의하면서 신중히 투여<br />∙갑작스럽게 투여를 중단하면 간질중첩상태가 나타나기 쉬우므로 천천히 감량하여 투여를 중단해야 함.</td>
            </tr>
            <tr id="KDGERI_SODIUMVALPROATE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙항우울제(이미프라민계 약물, 선택성 세로토닌 재흡수 억제제), 신경이완제(페노치아진 및 뷰티로페논), 메플로퀸, 부프로피온, 트라마돌 (경련 유발 또는 간질 역치 저하) <br />∙카바페넴계 및 모노박탐계 항생제, 아즈트레오남, 리팜피신 (이 약 농도 저하) <br />∙디발프로산염, 발프로미드 (동일한 대사 과정으로 과량투여) <br />∙이미프라민 (경련 발작 유발) <br />∙페노바르비탈 (간대사 저하로 해당 약 혈중농도 증가, 이 약 혈중농도 감소) <br />∙프리미돈 (해당 약 혈중농도 증가로 진정작용 등 부작용 증가) <br />∙페니토인 (발작 악화) <br />∙페니토인, 페노바르비탈, 카르바마제핀 (이 약 혈중농도 감소, 간독성, 고암모니아혈증 위험 증가) <br />∙지도부딘 (해당 약 농도 증가로 독성 유발)<br /><br />∙메플로퀸 (이 약 대사 증가로 경련효과) <br />∙와르파린, 아스피린 (출혈경향 증가) <br />∙시메티딘, 플루옥세틴, 에리스로마이신 (이 약 간대사 감소로 혈중농도 증가) <br />∙신경이완제, 바르비탈계 약물, 벤조디아제핀계 약물(디아제팜, 로라제팜, 클로나제팜 등), MAO 억제약물 및 항정신병약, 항우울약 (해당 약 혈중농도 상승) <br />∙알코올 (중추신경계 억제작용 증가) <br />∙클로나제팜 (결신 발작병력 환자에서 결신 상태 유발) <br />∙에토석시미드 (해당 약 반감기 증가) <br />∙라모트리진 (해당 약 대사 저하로 반감기 증가) <br />∙토피라메이트 (고암모니아혈증 또는 뇌혈관 발현 위험 증가) <br />∙니모디핀 (혈압강하효과 증가) <br />∙콜레스티라민, 아시클로비르, 카바마제핀, 라모트리진, 페니토인 (이 약의 혈중농도를 감소시킴)</td>
            </tr>
            <tr id="KDGERI_SODIUMVALPROATE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>∙항전간제 복용한 환자에서 자살충동 또는 자살행동을 보이는 위험성이 증가되므로 비정상적인 기분변화에 대하여 모니터링해야 함간기능 검사치 변화, 식욕항진을 동반한 비정상적 체중 증가, 복통, 식욕부진, 위부불쾌감, 변비, 구역, 위통, 구토, 설사, 일시적 및/또는 용량과 관련된 탈모, 모발 퇴색(hair fading), 곱슬머리(hair curling), 알레르기 반응, 혈관부종, DRESS 증후군, 홍반성 낭창, 혈관염, 알러지 반응, 뇌위축, 치매, 혈뇨, 구갈, 고암모니아혈증, 졸음, 현기증, 불면, 신경과민, 혈소판감소증, 상기도감염</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_TOPIRAMATE" data-drug-number="138">
          <thead>
            <tr>
              <th className="drug-number">138</th>
              <th className="drug-name">토피라메이트(Topiramate)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항전간제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_TOPIRAMATE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>간질 (2차성 전신발작을 동반하거나 동반하지 않은 부분발작 치료의 단독요법, 기존 1차 항전간제 투여로 적절하게 조절이 되지 않는 2차성 전신발작을 동반하거나 동반하지 않은 부분발작 도는 레녹스-가스토 증후군과 관련된 발작, 1차성 강직성/간대성 전신발작 치료의 부가요법), 편두통의 예방</td>
            </tr>
            <tr id="KDGERI_TOPIRAMATE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증</td>
            </tr>
            <tr id="KDGERI_TOPIRAMATE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) <br />∙낮은 용량부터 시작하여 유효용량까지 증량<br />∙안전성 문제로 다른 항전간제를 중단할 경우 2주 간격으로 1/3정도씩 단계적으로 감량하여 중단<br />∙정제는 부수지 말고 그대로 복용, 스프링클캡슐은 통째로 삼키거나 내용물 전체를 소량의 부드러운 음식 위에 뿌려 씹지 말고 곧바로 삼켜야 함<br />∙간질의 단독요법<br /> - 첫 1주일간 1회 25mg씩 1일 1회 저녁에 투여<br /> - 1-2주 간격으로 1일 25-50mg씩 증량, 1일 2회 분할투여<br /> - 권장용량: 1회 50-100mg씩 1일 2회<br /> - 1일 최대권장용량: 1회 250mg씩 1일 2회<br />∙간질의 부가요법<br /> - 첫 1주일간 25-50mg씩 1일 1회 저녁에 투여. 더 낮은용량으로 시작도 가능<br /> - 1-2주 간격으로 25-50mg씩 증량, 1일 2회 분할투여하여<br /> - 권장용량: 1회 100-200mg씩 1일 2회 (최소유효량: 1일 200mg)<br /> - 1일 최대권장용량: 800mg <br />∙편두통의 예방<br /> - 첫 1주일간 1회 25mg씩 1일 1회 저녁에 투여<br /> - 이후 1주 간격으로 1일 25mg씩 증량<br /> - 권장용량: 1회 50mg씩 1일 2회<br /> - 1일 최대용량: 200mg <br />∙신장애 환자<br /> - 중등도 및 중등의 신장애(CrCl&lt;70ml/min): 시작용량 및 유지용량을 1/2로 감량<br /> - 혈액투석환자: 투석 당일 이 약 투여용량 1/2 증량. 혈액투석으로 혈장에서 제거</td>
            </tr>
            <tr id="KDGERI_TOPIRAMATE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers criteria 해당품목 (항전간제)<br /> - 낙상 및 골절 이력 있는 환자에서 항전간제 투여는 운동실조, 실신 및 추가적인 낙상 유발 가능하므로 안전한 대체약제가 사용 가능하다면 투여 추천되지 않음<br />∙이 약을 투여 중에는 적절한 수분 공급으로 신결석 형성의 위험을 낮출 수 있음<br />∙이 약을 투여받은 환자에서 이차성 협우각 녹내장과 관련된 급성 근시 증후군이 보고되었으며, 갑작스런 시력저하 및/또는 안통이 발생하여 부작용이 의심되는 경우 가능한 빨리 이 약의 투여를 중단하고 안압을 저하시키는 적절한 조치를 취할 것</td>
            </tr>
            <tr id="KDGERI_TOPIRAMATE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 페니토인 (해당 약 혈중농도 증가, 이 약 혈장농도 감소) <br />∙ 카르바마제핀, 발프로산 (이 약 혈장농도 감소) <br />∙ 디곡신, 에스트라디올 (해당 약 혈중농도 감소) <br />∙ 하이드로클로로치아지드 (이 약 전신노출 증가) <br />∙ Carbonic anhydrase 억제제 (acetazolamide, dichlorphenamide 등: 결석 생성 촉진) <br />∙ 발프로산 (고암모니아혈증, 저체온증)</td>
            </tr>
            <tr id="KDGERI_TOPIRAMATE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>감각저하, 졸림, 피로, 어지러움(dizziness), 기억력 장애, 기분장애, 체중 감소, 식욕부진, 설사, 감염, 발열, 흉통, 조홍, 집중/주의력 장애, 우울증, 불면, 인지 장애, 감정불안, 감각저하, 신경과민, 정신운동 서행, 운동실조, 혼미, 행동문제, 현기(vertigo), 피부 장애, 홍반성 발진, 미각도착, 변비, 위장염(gastroenteritis), 구갈, 리비도 감소, 빈번한 배뇨, 요로감염, 뇨실금, 소변 이상, 빈혈, 인플루엔자양 증상, 무력증, 등통, 하지통, 비출혈, 비염, 인두염, 부비동염, 호흡곤란, 안구진탕증, 시력이상, 상기도 이상신경정신계<br />∙ 항전간제 복용한 환자에서 자살충동 또는 자살행동을 보이는 위험성이 증가되므로 비정상적인 기분변화에 대하여 모니터링해야 함</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_VIGABATRIN" data-drug-number="139">
          <thead>
            <tr>
              <th className="drug-number">139</th>
              <th className="drug-name">비가바트린(Vigabatrin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항전간제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_VIGABATRIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>다른 간질 치료제로 충분히 조절되지 않거나 다른 간질치료제와 병용요법을 실시할 수 없는 저항성 부분 간질(2차성 전신화 발작의 유무에 관계없이) 환자에 대하여 다른 간질치료제와 병용요법</td>
            </tr>
            <tr id="KDGERI_VIGABATRIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증</td>
            </tr>
            <tr id="KDGERI_VIGABATRIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량)- 초기용량: 1회 0.5g씩 1일 2회 또는 1회 1g씩 1일 1회. 1주일 이상의 간격으로 0.5g씩 증량- 유지용량: 1일 용량 2-3g</td>
            </tr>
            <tr id="KDGERI_VIGABATRIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers criteria 해당품목 (항전간제)<br /> - 낙상 및 골절 이력 있는 환자에서 항전간제 투여는 운동실조, 실신 및 추가적인 낙상 유발 가능하므로 안전한 대체약제가 사용 가능하다면 투여 추천되지 않음<br />∙신배설되므로 CrCl&lt;60ml/mn 환자에게 투여 시 저용량으로 시작하는 등 주의<br />∙내분비장애 환자에게 신중투여<br />∙임상적으로 중요한 시야장애의 병력이 있는 환자에게는 투여하지 않는 것이 좋음. 치료기간 동안 시야장애의 발현 빈도, 증상을 철저하게 기록할 것<br />∙반동성 발작 예방 위해 투여 중지 시 2∼4주 이상의 기간에 걸쳐 천천히 감량</td>
            </tr>
            <tr id="KDGERI_VIGABATRIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙페니토인 (농도 감소) <br />∙카바마제핀 (해당 약의 독성 증가) <br />∙포스페니토인 (해당 약의 효과 감소) <br />∙ginkgo (항전간제 효과 감소)</td>
            </tr>
            <tr id="KDGERI_VIGABATRIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>졸림, 언어장애, 두통, 어지러움, 지각이상, 주의력 저하, 기억력저하, 정신장애(사고장애), 진전, 시야장애, 흐린시야, 복시, 안구진탕, 간장애, 복통, 피로, 부종, 과민반응, 초조, 공격, 신경과민, 우울, 편집증적 반응, 체중증가<br />∙항전간제 복용한 환자에서 자살충동 또는 자살행동을 보이는 위험성이 증가되므로 비정상적인 기분변화에 대하여 모니터링해야 함</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ZONISAMIDE" data-drug-number="140">
          <thead>
            <tr>
              <th className="drug-number">140</th>
              <th className="drug-name">조니사미드(Zonisamide)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항전간제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ZONISAMIDE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>부분발작 및 전신발작, 혼합발작</td>
            </tr>
            <tr id="KDGERI_ZONISAMIDE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증</td>
            </tr>
            <tr id="KDGERI_ZONISAMIDE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) 1일 100-200㎎을 1-3회 분할 투여로 시작1-2주마다 증량하여 보통 1일 200-400㎎을 1-3회 분할투여1일 최대량: 600mg</td>
            </tr>
            <tr id="KDGERI_ZONISAMIDE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers criteria 해당품목 (항전간제)<br /> - 낙상 및 골절 이력 있는 환자에서 항전간제 투여는 운동실조, 실신 및 추가적인 낙상 유발 가능하므로 안전한 대체약제가 사용 가능하다면 투여 추천되지 않음<br />∙심각한 간장애 또는 관련 병력이 있는 환자에게 신중투여<br />∙급작스러운 투약 중지로 경련중첩증이 발생할 수 있으므로 점차 감량하는 등 신중히 중단<br />∙용량 조절을 적절히 하기 위해 이 약의 혈중농도 측정이 바람직함<br />∙땀배출이 감소되거나 체온이 상승할 수 있으므로 여름에 체온상승하지 않도록 각별히 주의</td>
            </tr>
            <tr id="KDGERI_ZONISAMIDE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙페니토인, 카바마제핀, 발프로산나트륨 등 항간질약 (이 약의 효능 감소) <br />∙페니토인 (눈떨림, 발아장애, 운동실조 등 페니토인 독성증상 발생 가능) <br />∙토피라메이트 아세타졸아미드 등 탄산탈수효소저해제 (대사성 산증, 신장결석 위험성 증가) <br />∙CYP3A4 (이 약의 혈중농도 증가로 약효 증가)</td>
            </tr>
            <tr id="KDGERI_ZONISAMIDE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>졸음, 어지러움, 식욕부진, 안면부종, 두통, 과민성/초조, 불안, 피로감, 쇠약, 혼돈, 우울, 불면, 집중력 감소, 정신력감퇴, 기억력 판단력 감소, 운동실조, 언어장애, 동기 저하 및 자발성 감소, 의식장애, 운동실조, 구역과 구토, 정신병 증상, 불수의운동/떨림, 발열, 발진, 가려움, 메스꺼움/구토, 위통/복통, 설사, 과다침분비, 갈증, 체중 감소, 백혈구 감소, 빈혈, 권태/쇠약, 복시/시각장애, 눈떨림<br />∙항전간제 복용한 환자에서 자살충동 또는 자살행동을 보이는 위험성이 증가되므로 비정상적인 기분변화에 대하여 모니터링해야 함</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_AMANTADINE" data-drug-number="141">
          <thead>
            <tr>
              <th className="drug-number">141</th>
              <th className="drug-name">아만타딘(Amantadine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항파킨슨제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_AMANTADINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제] 파킨슨증후군, 인플루엔자 A형 바이러스에 의한 호흡기감염증의 예방 및 치료[주사제] 파킨슨 증후군의 급성 악화 시 무운동성 발작의 초기 및 단기 치료</td>
            </tr>
            <tr id="KDGERI_AMANTADINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 경련환자, 위궤양 또는 그 병력이 있는 환자, 중증의 신질환 환자, 중증의 비-대상성 심장 부전증(NYHA Ⅳ 단계), 심근증 및 심근염, Ⅱ또는 Ⅲ단계의 AV 차단, 55회/분 미만의 서맥, 알려진 연장된 QT 간격(Bazett QTc&gt;420ms) 또는 명백한 U-wave 또는 가족기왕력이 있는 울혈성 QT 증후군, torsades de pointes를 포함하여 중등도의 심실성 부정맥의 병력</td>
            </tr>
            <tr id="KDGERI_AMANTADINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 100㎎씩 1일 2회 (일반용량)중증의 내과질환 환자 또는 다른 항파킨슨제를 투여하는 환자: 초기 100㎎씩 1일 1회, 수 주후 1회 100㎎씩 1일 2회로 증량 (일반용량)고령자 최대투여량: 1회 100㎎씩 1일 1회 <br />[주사제] 1회 500mL(황산아만타딘으로서 200mg) 1일 1~2회, 3시간에 걸쳐서 정맥내 점적 주입 (55방울/분을 초과하지 않는다) (일반용량)</td>
            </tr>
            <tr id="KDGERI_AMANTADINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙약물투여 전 및 투여 후 1, 3주, 용량증가 전 및 후 2주에 ECG 기록. 1년에 한번은 ECG 기록<br />∙심계항진, 현기 또는 기절과 같은 증상이 발생한 경우에는 이 약의 투여를 즉시 중단하고 24시간 이내에 QT 연장을 검사<br />∙갑자기 투여를 중지하면 파킨슨 증상이 악화될 수 있으므로 투여를 중지하는 경우에는 천천히 감량</td>
            </tr>
            <tr id="KDGERI_AMANTADINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙일부 class ⅠA, Ⅲ 항부정맥제(퀴니딘, 디소피라미드, 프로카인아미드, 아미오다론, 소타롤), 항정신병제(치오리다진, 클로르프로마진, 할로페리돌, 피모지드), 삼환계 및 사환계 항우울제(아미트립틸린), 항히스타민제(아스테미졸, 테르페나딘), 마크롤라이드 항생제(에리스로마이신, 클래리스로마이신), 아졸계 항진균제 등 QT 간격을 연장시키는 약제<br />∙항콜린작용제 (트리헥시페니딜, 벤즈트로핀, 스코폴아민, 비페리딘, 오펜아드린(ophenadrine): 항콜린작용제의 부작용인 혼동 및 환각 강화) <br />∙메만틴 (아만타딘 부작용 증가) <br />∙하이드로크로로치아자이드류의 이뇨제 (아만타딘 독성 유발)</td>
            </tr>
            <tr id="KDGERI_AMANTADINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>망상피반, 기립성 저혈압, 말초성 부종, 악몽, 불안, 신경과민, 불수의운동(진전 등), 혼동, 섬망, 우울, 어지러움, 졸음, 피로, 시각적 환각, 두통, 불면, 비안정상태, 흥분, 신경과민, 변비, 설사, 식욕부진, 구역, 구내건조</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_BENZTROPINE" data-drug-number="142">
          <thead>
            <tr>
              <th className="drug-number">142</th>
              <th className="drug-name">벤즈트로핀(Benztropine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항파킨슨제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_BENZTROPINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>특발성 파킨슨증, 기타의 파킨슨증(뇌염후, 동맥경화성), 항정신병약 투여로 인한 파킨슨증</td>
            </tr>
            <tr id="KDGERI_BENZTROPINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 녹내장, 중증 근무력증</td>
            </tr>
            <tr id="KDGERI_BENZTROPINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1일 0.5-1㎎로 투여 시작, 5-6일 간격으로 1일 0.5㎎씩 점차 증량 (일반용량) 1일 최대용량: 6mg</td>
            </tr>
            <tr id="KDGERI_BENZTROPINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 beers criteria 해당품목<br /> - 항정신병약으로 인한 추체외로계 증상 예방을 위해서는 추천되지 않음<br /> - 항콜린성 약제는 섬망, 치매 또는 인지기능 저하 환자, 만성 변비환자, 하부요로증상 또는 전립선비대증 환자에서 증상 악화시킬 수 있으므로 투여 추천되지 않음<br />∙신중투여<br /> - 부정맥 또는 빈맥 환자<br /> - 간･신장애 환자<br /> - 고온 환경에 있는 자(발한 억제가 나타나기 쉬운 환자) <br />∙이 약 투여중에는 정기적인 우각검사와 함께 안압검사를 하는 것이 추천됨<br />∙항파킨슨제는 페노티아진계 약물･유도체로 인한 입주위 등의 불수의운동(지발성 운동장애)을 경감시키지 않음</td>
            </tr>
            <tr id="KDGERI_BENZTROPINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙페노티아진계 약물, MAO저해제, 마약성 진통제, quinidine, 항히스타민제, 삼환계 항울약 (중추나 말초 항콜린 증후군 야기) <br />∙레세르핀 유도체 (이 약 작용 증강) <br />∙디곡신 (해당 약의 흡수 증가) <br />∙레보도파 (해당 약의 위장관 분해 증가)</td>
            </tr>
            <tr id="KDGERI_BENZTROPINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>빈맥, 운동실조, 정신착란, 환각, 의식장애, 신경과민, 흥분, 불안, 우울증, 권태감, 수족의 지각이상, 주의력 저하, 열사병, 고체온증, 기억장애, 발진, 구갈, 구역, 구토, 변비, 배뇨곤란, 요폐, 시력 조절장애</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_BIPERIDEN" data-drug-number="143">
          <thead>
            <tr>
              <th className="drug-number">143</th>
              <th className="drug-name">비페리덴(Biperiden)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항파킨슨제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_BIPERIDEN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>특발성 파킨슨증, 기타의 파킨슨증</td>
            </tr>
            <tr id="KDGERI_BIPERIDEN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 녹내장 환자, 중증의 근무력증 환자, 거대결장 환자, 장폐색 환자</td>
            </tr>
            <tr id="KDGERI_BIPERIDEN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) 1회 1㎎씩 1일 2회로 시작, 점차 증량하여 1일 3-6㎎을 분할 경구투여1일 최대용량: 16mg</td>
            </tr>
            <tr id="KDGERI_BIPERIDEN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙신중투여<br /> - 전립선비대 등 요로폐색성 질환 환자 (배뇨장애 발생 또는 악화)<br /> - 부정맥 또는 빈맥의 경향이 있는 환자 (부정맥 등 순환기계 부작용)<br /> - 간･신장애 환자 (대사, 배설기능 저하로 부작용 유발)<br /> - 간질 환자 (발작 유발)<br /> - 고온 환경에 있는 자 (발한 억제)<br /> - 탈수･영양불량상태 등을 수반한 신체적 피폐 환자 (신경이완제악성증후군 발생위험 증가) <br />∙이 약 투여중에는 정기적으로 우각검사 및 안압검사를 하는 것이 권장됨<br />∙페노티아진계 약물, 레세르핀 유도체 등에 의한 입주위 등의 불수의운동(지발성 운동장애)을 경감시키지 않으며 경우에 따라서는 이러한 증상을 악화 또는 현성화시킬 수 있음</td>
            </tr>
            <tr id="KDGERI_BIPERIDEN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙페노티아진계 약물, 삼환계 항우울약, MAO 저해제, 레세르핀계 약물 (이 약 작용 증강) <br />∙항콜린작용 약물(페노티아진계 약물, 삼환계 항우울약 등: 장관마비) <br />∙Betel nut (이 약의 작용 감소) <br />∙Cisapride (해당 약의 약효 소실) <br />∙KCl (위장관 손상 위험 증가)</td>
            </tr>
            <tr id="KDGERI_BIPERIDEN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>구갈, 구역, 구토, 변비, 식욕부진, 구내염, 위부불쾌감, 설사, 배뇨곤란, 요폐, 발진, 혈압저하, 심박수증가, 혈압상승, 심박수감소, 시조절장애, 파킨슨 증상, cortisol, prolactin 증가, 저체온증, 직장 위상성활동 증가, 착란, 다행감, 초조, 행동이상, 두통, 허약감, 어지러움, 이인장애, 비현실감, 환시, 수면 장애, 의존성신경이완제악성증후군(Neuroleptic Malignant Syndrome) : 항정신병약, 항우울약 및 도파민작동성 항파킨슨약과의 병용시, 이 약 및 병용약의 감량 또는 중지에 의해 발열, 무동함묵, 의식장애, 중증의 근강직, 불수의운동, 연하곤란, 빈맥, 혈압변동, 발한 등이 나타날 수 있다. 이러한 증상이 나타나는 경우에는 체냉각, 수분보급 등의 전신관리 등 적절한 처치를 한다.</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_BROMOCRIPTINE" data-drug-number="144">
          <thead>
            <tr>
              <th className="drug-number">144</th>
              <th className="drug-name">브로모크립틴(Bromocriptine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항파킨슨제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_BROMOCRIPTINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>파킨슨병이외 적응증은 노인관련 질병에 가능성 낮아 이하에 기술하지 않음(유즙 분비의 예방 및 억제, 고프로락틴혈증에 기인하는 남성, 여성의 성선기능저하증 및 유루증, 불임증, 월경불순의 여러 증상(특히, 유방에 나타나는 증상), 월경 직전의 두통, 기분변화 및 부종 등과 같은 증상의 완화, 말단 비대증 환자 치료 시 수술 또는 방사선 요법과 병행하여 혈중 성장호르몬 저하 목적)</td>
            </tr>
            <tr id="KDGERI_BROMOCRIPTINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 맥각알칼로이드를 투여중인 환자, 관상동맥 질환 또는 중증의 심혈관계 질환 환자, 동맥 폐색증 환자, 레이노병 환자, 조절되지 않는 고혈압 환자, 중증의 정신병 또는 그 병력이 있는 환자, 중중의 간 기능 부전 환자 및 패혈증 환자, 진토성 신경이완제 또는 항정신병성 신경이완제(클로자핀 제외)를 투여 받고 있는 환자, 시토크롬 P450을 억제하는 약물을 투여 받고 있는 환자, 맥각제제에 대해 과민증의 병력이 있는 환자</td>
            </tr>
            <tr id="KDGERI_BROMOCRIPTINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량)초기용법: 첫 1주동안 1회 1.25mg 1일 1회 취침시 투여유지요법: 1주 간격으로 1.25-2.5mg씩 증량하여 1일 10-15mg를 아침, 저녁 식사직후에 투여. 연령, 증상에 따라 적절히 증감1일 최대용량: 30-40mg</td>
            </tr>
            <tr id="KDGERI_BROMOCRIPTINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙ 레보도파를 투여중인 환자에게 이 약을 추가로 투여할 경우 최적균형이 확보될 때까지 레보도파의 양을 점진적으로 감량하면서 이 약을 점증적으로 투여<br />∙ 신중투여<br /> - 간장애 환자 또는 그 병력이 있는 환자(주로 간에서 대사됨)<br /> - 소화성 궤양 환자 또는 그 병력이 있는 환자(위장 출혈 가능, 증상 모니터링 필요)<br /> - 정신병환자 또는 그 병력이 있는 환자(정신증상의 악화 가능)<br /> - 심근경색증 등 중증의 혈관장애의 병력이 있는 환자<br /> - 신질환 환자 또는 그 병력이 있는 환자(급격한 혈압저하 시 신혈류량 저하 가능) <br />∙ 장기간 이 약을 고용량으로 투여한 파킨슨병 환자에서 흉막 및 심낭의 삼출, 폐의 섬유화, 교착성 심낭염, 후복막의 섬유화가 되었으므로 설명되지 않는 흉막, 폐 이상을 호소하는 환자는 철저히 검사하고 이 약의 치료 중단을 숙고할 것<br />∙ 도파민 효능제를 투여 받는 환자는 충동 조절 장애의 발생에 대해 정기적으로 모니터링되어야 하며, 증상이 발생하면 용량조절 또는 점진적인 증량이 필요</td>
            </tr>
            <tr id="KDGERI_BROMOCRIPTINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙ 혈압강하가 예상되는 약물 (메칠도파, 구아네티딘, 글리세릴 트리니트레이트: 혈압저하 가능, 병용 시 신중투여) <br />∙ 알코올 (이 약 작용 증강)<br /><br />∙ 마크로라이드계 항생물질(에리스로마이신 및 조사마이신 등), 아졸계 항진균제(케토코나졸, 이트라코나졸 등), 시메티딘, 옥트레오티드 등 시토크롬 P450 억제제 (이 혈중농도 상승으로 이상반응 빈도 증가, 병용하지 말 것) <br />∙ 페노티아진계 약물, 부티로페논계 약물, 도파민 길항제(메토클로프라미드, 돔페리돈), 치오잔틴계 약물 (이 약 효과 감소) <br />∙ 맥각알칼로이드 (도파민 항진 작용으로 두통, 구역, 구토 등 이상반응 증가) <br />∙ 항파킨슨약 (레보도파 등: 정신신경게 부작용 증강) <br />∙ 항정신병성 신경이완제(클로자핀 제외), 진토성 신경이완제 (병용 투여하지 말 것) <br />∙ HIV 프로테아제 저해제(리토나버, 사키나버 등: 이 약 작용 증강) <br />∙ 수마트립탄 (혈관경련성 반응 위험 증가) <br />∙ sibutramine, serotonin 효능제 (해당 약의 혈중 농도 증가시킴)</td>
            </tr>
            <tr id="KDGERI_BROMOCRIPTINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>어지러움, 피로, 두통, 변비, 구역, 무력증, 비염, 혈압저하, 기립성 어지러움, 실신, 혈관경련(투여중지), 나른함 (drowsiness), 저혈당, 위부 불쾌감, 식욕부진, 설사, 소화불량, 위⋅장 출혈, 구토, 구갈, 시야 장애, 비충혈</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_LEVODOPACARBIDOPA" data-drug-number="145">
          <thead>
            <tr>
              <th className="drug-number">145</th>
              <th className="drug-name">레보도파/카비도파(Levodopa/Carbidopa)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항파킨슨제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_LEVODOPACARBIDOPA_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[일반정, 서방정] 파킨슨병, 파킨슨증후군</td>
            </tr>
            <tr id="KDGERI_LEVODOPACARBIDOPA_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민성, 비선택성 MAO 저해제를 복용하는 환자(이 약 투여하기 적어도 2주 전에 복용 중단), 협우각형 녹내장 환자, 미진단성 피부질환, 피부병변이 의심되는 환자 또는 흑색종의 병력이 있는 환자</td>
            </tr>
            <tr id="KDGERI_LEVODOPACARBIDOPA_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제: 일반정] (일반용량)초기용량레보도파를 투여하지 않았던 환자: 레보도파로서 1회 100-125㎎씩 1일 100-300㎎로 시작. 매일 또는 격일로 레보도파로서 100-125㎎씩 증량레보도파를 투여중인 환자: 레보도파 단일제제 복용후, 적어도 8시간의 간격을 두고 투여 시작. 레보도파의 1일 유지량의 약1/5을 초회량으로 1일 3회 분할투여표준유지량: 레보도파로서 1회 200-250㎎씩 1일 3회1일 최대용량: 레보도파로서 1500mg <br />[경구제: 서방정-시네메트씨알정 (Carbidopa/Levodopa) 50/200mg] (일반용량)초기용량레보도파를 투여하지 않은 환자: 1회 1정씩 1일 2회, 투여간격 6시간 이상기존에 레보도파 단일제제를 투여한 환자: 이 약을 투여하기 적어도 8시간 전 기존의 레보도파 단일제제를 중단, 레보도파로서 약 25% 증량 투여. 경증 및 중등도 환자의 경우 1회 1정씩 1일 2회기존에 레보도파/탈탄산효소저해제 복합제를 투여한 환자: 수면 시간을 제외하고 4-8시간마다 복용시네메트정 1일용량 (레보도파로서 mg)시네메트 씨알 정 50/200 용량별 투여횟수(레보도파로서 mg) 300<br /> - 400mg 1회 200mg씩 1일 2회500<br /> - 600mg 1회 200mg씩 1일 3회700<br /> - 800mg 1일 총 800mg을 3회 이상 분복900<br /> - 1000mg 1일 총 1000mg을 3회 이상 분복(예, 400-400-200mg 1일 3회)표준 유지량: 1일 400-1600mg을 수면시간을 제외하고 4-8시간마다 분복같은 용량을 적어도 3일 이상 투여한 후 증감 고려</td>
            </tr>
            <tr id="KDGERI_LEVODOPACARBIDOPA_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙투여간격이 4시간 미만이거나 매 투여마다 복용량이 일정하지 않은 경우 하루 중 마지막 투여시 보다 적은 용량을 복용<br />∙Up-down 현상이 나타나는 경우에는 1일 용량의 범위 내에서 투여횟수를 증가 On-off 현상이 나타나는 경우에는 유지량을 점차적으로 감량하거나 휴약, 증상이 악화되면 기타의 항파킨슨제를 병용<br />∙신경이완제를 투여하는 경우 이 약의 중단 또는 감량이 필요한지 관찰<br />∙레보도파 단일제에 비해 뇌내 도파민 증가로 인한 운동이상 등이 보다 적은 용량에서 빨리 나타날 수 있으며 운동이상이 보이면 감량<br />∙신중투여<br /> - 간･신장애 환자<br /> - 위･십이지장궤양 또는 그 병력이 있는 환자<br /> - 정신질환 병력이 있는 환자 (뇌내 도파민 증가로 인한 불수의 운동, 정신장애)<br /> - 심한 심혈관계, 폐, 기관지천식, 신장, 간, 내분비질환 환자<br /> - 잔류성 방실부정맥, 결절성 부정맥 또는 심실부정맥을 동반한 심근경색 환자<br /> - 당뇨병 환자 (혈당치를 상승)<br /> - 만성 광우각형 녹내장 환자 (안압 상승)</td>
            </tr>
            <tr id="KDGERI_LEVODOPACARBIDOPA_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙도파민을 감소시키는 약물 (예, 레세르핀, 테트라베나진) 또는 저장된 모노아민을 감소시키는 약물 (이 약의 효과 감소, 병용 권장되지 않음) <br />∙혈압강하제, 특히 메칠도파, 신경절차단제 (이 약 작용 증강) <br />∙페노티아진계, 부티로페논계 항정신병약, 페니토인, 파파베린 (이 약 효과 감소) <br />∙기타의 항파킨슨제 (항콜린제, 아만타딘, 브로모크립틴: 정신신경계의 부작용 증강) <br />∙삼환계 항우울약 (고혈압 및 운동이상) <br />∙고단백식이 (이 약의 흡수 저해)</td>
            </tr>
            <tr id="KDGERI_LEVODOPACARBIDOPA_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>기립성 저혈압, 말초부종, 고혈압, 허혈, 부정맥, 심계항진, 어지러움, 두통, 우울, 불면, 불안, 초조감, 꿈의 이상, 수면장애, 말초신경병증, 환각, 정신착란, 발진, 구역, 구토, 변비, 구갈, 설사, 소화불량, 복부불쾌감, 무과립구증, 불수의 운동, 시각장애<br />∙신경이완제악성증후군 (Neuroleptic Malignant Syndrome): 항파킨슨제를 갑자기 감량 또는 중지할 경우 운동마비, 심한 근육강직, 연하곤란, 빈맥, 혈압변화, 발한 등이 나타나므로 이러한 증상과 함께 발열이 나타나는 경우에는 투여를 중지하고 체냉각과 수분보급 등의 전신적 치료와 함께 적절한 처치를 한다.</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PRAMIPEXOLE" data-drug-number="146">
          <thead>
            <tr>
              <th className="drug-number">146</th>
              <th className="drug-name">프라미펙솔(Pramipexole)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항파킨슨제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PRAMIPEXOLE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[일반정, 서방정] 특발성 파킨슨증[일반정] 중등증 및 중증의 특발성 하지 불안 증후군</td>
            </tr>
            <tr id="KDGERI_PRAMIPEXOLE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증</td>
            </tr>
            <tr id="KDGERI_PRAMIPEXOLE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>∙특발성 파킨슨증<br />[경구제: 일반정] (일반용량)신기능 정상 환자의 시작용량:주용량 (mg)총 1일 용량 (mg) 1 0.125mg 1일 3회0.375 2 0.25mg 1일 3회0.75 3 0.5mg 1일 3회1.50 4 0.75mg 1일 3회2.25 5 1.0mg 1일 3회3.0 6 1.25mg 1일 3회3.75 7 1.5mg 1일 3회4.50신기능 정상 환자의 유지용량: 1회 0.5-1.5mg씩 1일 3회신기능 장애 환자신기능 상태개시용량(mg)최대용량(mg) CrCl &gt; 50ml/min 1일 투여용량 및 투여빈도 조절 필요 없음. CrCl 20~50ml/min 0.125mg정 1일 2회1일 2.25mg CrCl &lt; 20ml/min 0.125mg정 1일 1회1일 1.5mg투여 중단 시 1회 0.25mg 1일 3회까지는 1회 0.25mg씩 감량, 이후에는 1회 0.125mg씩 감량<br />[경구제: 서방정] (일반용량) 1일 1회 같은 시간에 씹거나 분할 또는 분쇄하지 않고 물과 함께 복용신기능 정상 환자의 시작용량: 1회 0.375mg씩 1일 1회로 시작, 5-7일마다 0.75mg씩 1일 1회 → 1.5mg씩 1일 1회까지 도달. 이후 필요시 1주 간격으로 0.75mg씩 증량하여 1일 최대 4.5mg까지 도달프라미펙솔 일반정을 복용 중인 환자의 경우 하룻밤 간격으로 동일 1일 용량의 이 약으로 대체 가능신기능 정상 환자의 유지용량: 1회 0.375-4.5mg씩 1일 1회<br />신기능 장애 환자신기능 상태개시용량(mg)최대용량(mg) CrCl &gt; 50ml/min 1일 투여용량 및 투여빈도 조절 필요 없음. CrCl 30-50ml/min 2일 1회 0.375mg 1일 1회 2.25mg CrCl &lt; 30ml/min연구된 바 없으므로, 프라미펙솔 일반정 복용투여 중단 시 1일 용량이 0.75mg씩 1일 1회까지는 1일 0.75mg씩 감량, 이후에는 매일 0.375mg씩 감량<br />∙특발성 하지불안증후군<br />[경구제: 일반정] (일반용량) 1회 0.125mg씩 1일 1회 취침 2-3시간 전 복용추가적인 증상 완화가 필요할 경우 4-7일마다 1회 0.25mg씩 1일 1회 → 1회 0.5mg씩 1일 1회까지 증량중증 및 중등증의 신기능 장애(CrCl 20~60ml/min) 환자의 경우 14일마다 증량중단 시 감량 필요하지 않음</td>
            </tr>
            <tr id="KDGERI_PRAMIPEXOLE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙서방정제의 경우 복용을 잊었을 경우 예정된 복용 시간 후 12시간안에 복용<br />∙12시간이 지나면, 잊은 복용은 빼고 다음 예정된 복용계획에 따라 복용<br />∙레보도파와 이 약 서방정제를 병용하는 환자에서는 프라미펙솔의 용량 증가 및 유지요법 중에 과도한 도파민성 자극을 피하기 위해 레보도파의 감량을 고려<br />∙도파민성 약물을 급작스럽게 중단한 경우 신경이완제 악성 증후군(NMS)을 암시하는 징후가 보고된 바 있음<br />∙졸음 발현의 가능성이 크므로 진정제를 병용 투여하거나, 수면장애가 있을 때, 그리고 프라미펙솔의 혈장 농도를 상승시키는 약물(예: 시메티딘)을 병용 투여하는 경우 주의<br />∙도파민 효능제와 레보도파 병용시의 부작용인 환각과 혼돈은 젊은 환자에 비해 노인에서 더 위험이 높으며, 연령에 따라 증가<br />∙증량 시 전신 혈압조절에 장애로 기립성 저혈압이 발생할 위험이 특히 높으며 파킨슨병 환자에서는 기립성 저혈압에 대처능력이 저하되므로 증상을 주의깊게 모니터링해야 함</td>
            </tr>
            <tr id="KDGERI_PRAMIPEXOLE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙양이온 수송 체계에 의해 배설 되는 약물(시메티딘, 라니티딘, 딜티아젬, 트리암테린, 베라파밀, 퀴니딘, 퀴닌: 신장 청소율 감소, 병용 시 운동장애, 흥분, 환각 등 도파민 과잉 자극의 징후를 관찰) <br />∙신경이완제(페노치아진, 부티로페논, 치옥산틴) 또는 메토클로프라미드와 같은 도파민 길항제 (이 약 효능 감소)</td>
            </tr>
            <tr id="KDGERI_PRAMIPEXOLE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>기립성 저혈압, 졸음, 추체외로 증후군, 불면, 현기증, 두통, 혼란, 환각, 수면장애, 구역, 변비, 운동이상증, 쇠약, 우연한 상해, 일반적 부종, 말초 부종, 흉통, 하지불안증후군 악화, 혼란, 피로, 근육긴장이상, 비정상적 걸음걸이, 과잉운동증, 기억상실, 기면증, 낙상, 충동장애, 현기증, 지각감퇴, 정좌불능, 권태감, 수면이상, 평형이상, 우울, 편집증, 식욕부진, 체중감소, 구갈, 삼킴곤란, 빈뇨, 발기부전, 요실금, 시야이상, 호흡곤란, 비염</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PROCYCLIDINE" data-drug-number="147">
          <thead>
            <tr>
              <th className="drug-number">147</th>
              <th className="drug-name">프로싸이클리딘(Procyclidine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항파킨슨제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PROCYCLIDINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>뇌염후･동맥경화성･특발성 파킨슨병, 항정신병약(페노티아진, 레세르핀 등)으로 인한 추체외로증상</td>
            </tr>
            <tr id="KDGERI_PROCYCLIDINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 폐쇄각녹내장 환자, 치료되지 않은 요폐 환자 또는 폐쇄요로병증 환자, 위장관폐쇄 환자, 중증 근육무력증 환자, 중증 궤양대장염 또는 궤양대장염에 합병된 독성거대결장 환자, 지연운동이상 환자, 초기 치매증상 환자 또는 치매 환자, 이완증 환자, 알코올 또는 약물(수면제, 삼환계 항우울제, 항경련제, 항히스타민제, 진정제) 중독 환자</td>
            </tr>
            <tr id="KDGERI_PROCYCLIDINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) <br />∙파킨슨병<br /> - 다른 약물 요법을 받지 않은 경우: 1회 2.5mg씩 1일 3회 식후 복용. 순응도 양호하면 마지막 투여시에만 5mg로 증량하거나, 1회 5mg씩 1일 3회로 점차 증량 가능.<br /> - 다른 약물요법에서 프로시클리딘염산염 요법으로 전환하는 경우<br /> - 다른 약물의 전체 또는 일부를 이 약 1회 2.5mg씩 1일 3회 요법으로 점차적 전환<br />∙항정신병약으로 인한 추체외로증상<br /> - 1회 2.5mg씩 1일 3회로 투여 시작하여 증상 경감될때까지 1일 2.5mg씩 추가로 더 증량</td>
            </tr>
            <tr id="KDGERI_PROCYCLIDINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙취침시 복용에 순응하지 못하는 환자의 경우 취침시에 투여하지 말고 주간에 1일 투여량을 균등하게 나누어서 투여<br />∙이상반응의 발현을 최소화하기 위해서는 식사도중 또는 식후에 복용<br />∙신중투여<br /> - 심혈관질환 환자(부정맥, 울혈심부전, 허혈심장병, 고혈압 또는 저혈압 환자)<br /> - 간부전 또는 신부전 환자<br />∙체외로계 이상반응을 저지하기 위해 항파킨슨 약물의 용량을 증량할 경우 때때로 정신병의 급격한 촉진 가능<br />∙반동 파킨슨 증상이 나타날 수 있으므로 갑자기 중단하지 말 것</td>
            </tr>
            <tr id="KDGERI_PROCYCLIDINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙중추신경 억제제 (알코올, 항경련제, 바르비투르염류, 벤조디아제핀류, MAO 억제제, 아편유사제, 페노티아진류 및 삼환계 항우울제: 중추신경 억제 효과 증강) <br />∙아만타딘 (아만타딘의 중추신경 이상반응 증가) <br />∙항콜린제 (아만타딘, 약간의 항히스타민제, 페노티아진, 삼환계 항우울제: 부가적 항콜린효과) <br />∙콜린에스테라아제 억제제 (도네페질, 갈란타민, 리바스타그민: 서로 작용 간섭) <br />∙레보도파 (레보도파 흡수 감소) <br />∙시사프리드, 돔페리돈 및 메토클로프라미드 (위장효과 상쇄) <br />∙퀴니딘 (미주신경 억제효과 증가) <br />∙파록세틴 (이 약 혈장농도 증가) <br />∙제산제 (이 약 흡수 저하. 제산제 복용 최소 1시간 전에 이 약 복용)</td>
            </tr>
            <tr id="KDGERI_PROCYCLIDINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>빈맥, 요저류, 정신병, 불안, 혼란, 방향감각장애, 어지러움, 환각, 신경질, 기억력장애, 초조, 발진, 변비, 상복부통, 구역, 구토, 이하전암, 입안건조, 요저류, 근무력감, 시야흐림, 동공산대</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_RASAGILINE" data-drug-number="148">
          <thead>
            <tr>
              <th className="drug-number">148</th>
              <th className="drug-name">라사길린(Rasagiline)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항파킨슨제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_RASAGILINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>특발성 파킨슨병의 치료: 초기 파킨슨병 환자에서 단독요법(레보도파 없이) 또는 운동 동요 증상(end of dose motor fluctuations)이 있는 환자에서 레보도파의 보조요법</td>
            </tr>
            <tr id="KDGERI_RASAGILINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증다음의 약을 투여중인 환자: 다른 MAO(모노아민산화효소) 억제제. 페티딘, 트라마돌, 덱스트로메토르판다음의 약을 투여 중단 후 2주 이내의 환자: 다른 MAO 억제제, 페티딘,중등증 및 중증의 간장애</td>
            </tr>
            <tr id="KDGERI_RASAGILINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 1mg씩 1일 1회 (일반용량)</td>
            </tr>
            <tr id="KDGERI_RASAGILINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>레보도파와 병용요법으로 투여하는 경우, 운동이상증을 유발하거나 도파민성 부작용을 증가시키고, 기존의 운동이상증을 악화시킬수 있음충동조절장애의 발달과 관련하여 정기적으로 모니터링받아야 함</td>
            </tr>
            <tr id="KDGERI_RASAGILINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>다른 MAO 억제제 (고혈압 위기 유발)페티딘 (중대한 이상반응 보고)트라마돌 (설사, 빈맥, 발한, 진전, 착란 등 세로토닌 증후군 야기)덱스트로메토르판 (고도의 흥분, 정신착란)교감신경흥분제 (중증의 고혈압) SSRIs(선택적 세로토닌 재흡수 억제제), SNRIs(세로토닌･노르아드레날린 재흡수 억제제), 삼환계 또는 사환계 항우울제 (세로토닌 증후군 발생)</td>
            </tr>
            <tr id="KDGERI_RASAGILINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>기립성 저혈압, 저혈압, 두통, 구역, 운동이상증, 말초부종, 협심증, 흉통, 어지러움, 졸음, 운동실조, 우울, 낙상, 근육긴장이상, 백혈구감소증, 권태감, 감각이상, 불면, 환각, 발진, 반상출혈, 발한, 체중감소, 변비, 소화불량, 설사, 구토, 입마름, 복통, 식욕부진, 요절박, 감염, 관절통, 등과 목의 통증, 결막염, 독감, 백혈구감소증, 알레르기</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ROPINIROLE" data-drug-number="149">
          <thead>
            <tr>
              <th className="drug-number">149</th>
              <th className="drug-name">로피니롤(Ropinirole)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항파킨슨제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ROPINIROLE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[일반정, 서방정] 특발성 파킨슨씨병의 치료[일반정] 중등증에서 중증의 원발성 하지불안증후군(Restless Legs Syndrome)</td>
            </tr>
            <tr id="KDGERI_ROPINIROLE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 유당불내성</td>
            </tr>
            <tr id="KDGERI_ROPINIROLE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>∙특발성 파킨슨씨병 <br />[경구제: 일반정] (일반용량, 고령자에서 동일)<br /> - 1일 3회 위장관의 내성을 향상시키기 위해 음식물과 함께 복용<br /> - 초기요법: 처음 1주간 1회 0.25mg씩 1일 3회 복용, 이후 1주일마다 1회 0.25mg씩 증량(1회 0.5mg씩 1일 3회 → 1회 0.75mg씩 1일 3회 → 1회 1mg씩 1일 3회)<br /> - 유지요법: 초기요법 후 1주일 간격으로 1일 3mg까지 증량<br /> - 1일 최대용량: 24mg <br />[경구제: 서방정] (일반용량, 고령자에서 동일)<br /> - 1일 1회 매일 같은 시각에 복용, 음식물과 관계없이 복용 가능.<br /> - 씹거나 부수거나 쪼개지 말고 통째로 삼켜 복용<br /> - 초기요법: 처음 1주간 1회 2mg씩 1일 1회 복용, 2주째부터 1회 4mg씩 1일 1회까지 증량<br /> - 유지요법: 증상의 조절이 불충분하거나 유지되지 않을 경우, 4mg씩 1일 1회 복용하던 환자는 1주 이상의 기간에 걸쳐 2mg씩 증량하여 8mg씩 1일 1회에 도달. 8mg씩 1일 1회 복용하던 환자는 2주 이상의 기간에 걸쳐 2mg 또는 4mg씩 단계적으로 증량<br /> - 1일 최대용량: 24mg <br />∙원발성 하지불안증후군 <br />[경구제: 일반정] (일반용량, 고령자에서 동일)<br /> - 1일 1회 취침 1-3시간 전에 복용<br /> - 초기요법: 2일동안 0.25mg씩 1일 1회 취침전에 복용. 내약성이 양호하다면 투여 3일째부터 투여 첫주의 마지막날(투여 7일째)까지 0.5mg 1일 1회로 증량<br /> - 유지요법: 최적 치료반응에 도달할 때까지 1주 간격으로 1회 0.5mg씩 증량<br /> - 1일 최대용량:４mg <br />∙고령자에서 로피니롤 청소율이 감소되므로, 임상반응에 따라 용량을 보다 서서히 증량하여 투여</td>
            </tr>
            <tr id="KDGERI_ROPINIROLE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙치료가 1일 또는 1일 이상 중단된 경우, 초기 요법의 용량에 따라 치료 재시작<br />∙투여 중지 시 1주일에 걸쳐 매일 투여횟수를 줄이면서 서서히 중지<br />∙레보도파의 보조요법으로 투여할 때 레보도파의 투여량은 전체량의 약 20%까지 서서히 감량할 수 있음<br />∙로피니롤 일반정 ↔ 서방정 용량전환로피니롤 일반정의 1일 총 용량(mg)로피니롤 서방정의 1일 총 용량(mg) 0.75-2.25 2 3-4.5 4 6 6 7.5-9 8 12 12 15-18 16 21 20 24 24 <br />∙중증의 신손상 (CrCl＜30mL/min), 간손상 환자에게 투여 권장되지 않음<br />∙어떤 용량단계에서도 극도의 졸음이 발생할 경우 감량<br />∙신경이완제에 의한 정좌불능증 또는 이차성 하지불안증후군(예: 신부전, 철결핍성 빈혈 또는 임신에 의한 경우)의 치료에 사용하지 말 것<br />∙기립성 저혈압에 대한 증상과 징후를 주의깊게 모니터링해야 함<br />∙로피니롤을 투여하고 있는 동안 호르몬대체요법을 중단하거나 시작할 경우 로피니롤 용량 조절이 필요</td>
            </tr>
            <tr id="KDGERI_ROPINIROLE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙신경이완약, 도파민 길항제(메토클로프라미드), 설피리드 (이 약 효과 감소로 병용햐지 말 것) <br />∙CYP1A2 저해제 (시프로플록사신, 에녹사신, 플루복사민 및 시메티딘: 이 약 효과 증가) <br />∙에스트로겐 (이약의 소실 감소)</td>
            </tr>
            <tr id="KDGERI_ROPINIROLE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>실신, 피로, 구역, 구토, 바이러스감염, 말초성 부종(다리 부종 포함), 고혈압, 흉통, 홍조, 빈맥, 말초허혈, 심방세동, 기외수축, 통증, 두통, 혼돈, 환각, 감각저하, 하품, 집중력 저하, 어지러움(현훈 포함), 다한증, 소화불량, 복통, 변비, 구강건조, 설사, 식욕부진, 요로감염, 관절통, 근육통, 운동과다증, 시력이상, 안구건조증, 코인두염, 인두염, 비염, 부비동염,</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ROTIGOTINE" data-drug-number="150">
          <thead>
            <tr>
              <th className="drug-number">150</th>
              <th className="drug-name">로티고틴(Rotigotine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항파킨슨제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ROTIGOTINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>특발성 파킨슨병의 치료, 중등증 및 중증의 특발성 하지불안증후군 환자의 증상 치료</td>
            </tr>
            <tr id="KDGERI_ROTIGOTINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 자기공명영상(MRI) 또는 심율동전환술(Cardioversion)을 실시하는 경우</td>
            </tr>
            <tr id="KDGERI_ROTIGOTINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[패취제] 1일 1회 24시간 적용초기 파킨슨병: 1회 2mg/24시간 1일 1회로 시작, 매주 2mg/24시간씩 증량, 최대 8mg/24시간 (일반용량)진행성 파킨슨병: 1회 4mg/24시간 1일 1회로 시작, 매주 2mg/24시간씩 증량, 최대 16mg/24시간 (일반용량)하지불안증후군: 1회 1mg/24시간 1일 1회로 시작, 매주 1mg/24시간씩 증량,최대 3mg/24시간 (일반용량)</td>
            </tr>
            <tr id="KDGERI_ROTIGOTINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙도파민 치료의 갑작스런 중단으로 인하여 신경이완제악성증후군(neuroleptic malignant syndrome)이 유발될 수 있음. 투여 중단할 경우 서서히 중단. 파킨슨병은 격일로 2mg/24시간씩, 하지불안증후군에는 격일로 1mg/24시간씩 감소<br />∙14일 이내 동일한 부위에 다시 부착하지 말 것<br />∙지지층이 알루미늄을 함유하고 있으므로 자기공명영상(MRI) 또는 심율동전환술(Cardioversion)을 실시하는 경우 피부 화상을 피하기 위해 패취 제거</td>
            </tr>
            <tr id="KDGERI_ROTIGOTINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙도파민길항제 (페노치아진, 뷰티로페논, 티오산틴류), 메토클로프라마이드: 이 약 효과 감소) <br />∙진정효과 있는 약물, 중추신경계 억제제 (조디아제핀계, 항정신병제, 항우울제 등), 알코올 (부가적 효과) <br />∙레보도파, 카르비도파 (도파민성 이상반응 강화, 운동이상증 유발 또는 악화)</td>
            </tr>
            <tr id="KDGERI_ROTIGOTINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>저혈압, 말초부종, 졸음, 기립성저혈압, 어지러움, 두통, 피로, 수면장애, 권태감, 환각, 불면, 기면증, 다한증, 혈당감소, 구역, 구토, 헤마토크릿 감소, 헤모글로빈 감소, 부착부위 피부반응, 운동이상증, 쇠약, 관절통, 악몽, 우울, 감각이상, 자세성 현기증, 평형장애, 신경과민, 수면발작/갑작스러운 수면, 가려움, 홍반, 체중증가, 이상성욕, 변비, 식욕부진, 구강내건조, 설사, 소화불량, 백혈구수치변화, 떨림, 근육경련, 시력장애, 코인두염, 기침, 비충혈, 딸국질</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_TRIHEXYPHENIDYL" data-drug-number="151">
          <thead>
            <tr>
              <th className="drug-number">151</th>
              <th className="drug-name">트리헥시페니딜(Trihexyphenidyl)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항파킨슨제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_TRIHEXYPHENIDYL_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>특발성 파킨슨증, 기타의 파킨슨증(뇌염후, 동맥경화성), 항정신병약 투여에 의한 파킨슨증, 운동장애(지발성은 제외), 정좌불능증</td>
            </tr>
            <tr id="KDGERI_TRIHEXYPHENIDYL_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 녹내장, 중증의 근무력증</td>
            </tr>
            <tr id="KDGERI_TRIHEXYPHENIDYL_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량)첫째날에 1㎎, 둘째날에 2㎎을 경구투여한 후 1일 2㎎씩 증량하여 1일 6-10㎎을 3-4회 분할투여항정신병약 투여에 의한 경우 1일 2-10㎎을 3-4회 분할 투여고령자에서 저용량부터 시작하고 주의 깊게 관찰할 것</td>
            </tr>
            <tr id="KDGERI_TRIHEXYPHENIDYL_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 beers criteria 해당품목<br /> - 항정신병약으로 인한 추체외로계 증상 예방을 위해서는 추천되지 않음<br /> - 항콜린성 약제는 섬망, 치매 또는 인지기능 저하 환자, 만성 변비환자, 하부요로증상 또는 전립선비대증 환자에서 증상 악화시킬 수 있으므로 투여 추천되지 않음<br />∙신중투여<br /> - 부정맥 또는 빈맥의 경향이 있는 환자 (증상 악화)<br /> - 간･신장애 환자 (이상반응 가능성 증가)<br /> - 고혈압 환자 (증상 악화)<br /> - 고온 환경에 있는 환자 (발한억제)<br /> - 위장관폐쇄성 질환 환자 (증상 악화)<br /> - 동맥경화파킨슨병 환자 (정신신경계 이상반응) <br />∙치료를 시작하기 전에 전방각경 검사를 하고 안압을 주의깊게 모니터링<br />∙열이 있는 경우, 더운 날씨, 운동 중에 이 약을 투여할 경우, 주의<br />∙아트로핀 유사성질로 장기간 투여 시 고혈압이 악화되거나 빈맥 발생 가능<br />∙파킨슨증 치료 시 갑작스런 투여중지는 파킨슨 증후군의 급성 악화 및 신경이완제악성증후군 발생 가능하므로 급작스럽게 중단하지 말 것</td>
            </tr>
            <tr id="KDGERI_TRIHEXYPHENIDYL_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙레제르핀 유도체 (이 약 효과 증가) <br />∙MAO 저해제 (항콜린 작용 증강) <br />∙삼환계 항우울약 (정신착란, 흥분, 환각, 장관마비 등 이상반응 증강) <br />∙페노티아진계 약물 (장관마비 등 이상반응 증강) <br />∙바르비탈계, 아편, 알코올 (상가작용으로 남용의 우려가 있음) <br />∙레보도파 (약물-유도성 불수의운동이 증가) <br />∙감귤류 및 과일 쥬스와 같은 산성 음식 (이 약 효과 감소)</td>
            </tr>
            <tr id="KDGERI_TRIHEXYPHENIDYL_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>빈맥, 초조, 혼동, 망상, 어지러움, 환각, 두통, 신경과민, 편집증, 정신착란, 발진, 구갈, 구역, 구토, 변비, 식욕부진, 장(腸)비대, 마비성 장폐쇄증, 화농성이하선염, 요폐, 권태감, 녹내장, 내안압 증가, 동공확대, 피부건조, 광과민성증가, 발진, 뇨정체<br />∙신경이완제악성증후군(Neuroleptic Malignant Syndrome) : 항정신병약, 항우울약 및 도파민작동성 항파킨슨약과의 병용시, 이 약 및 병용약의 감량 또는 중지에 의해 발열, 무동함묵, 의식장애, 중증의 근강직, 불수의운동, 연하곤란, 빈맥, 혈압변동, 발한 등이 나타날 수 있다. 이러한 증상이 나타나는 경우에는 체냉각, 수분보급 등의 전신관리 등 적절한 처치를 한다.</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_DIETHYLPROPION" data-drug-number="152">
          <thead>
            <tr>
              <th className="drug-number">152</th>
              <th className="drug-name">디에칠프로피온(Diethylpropion)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">식욕억제제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_DIETHYLPROPION_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>적절한 체중감량요법(식이요법 및/또는 운동)에 반응하지 않는 초기 체질량지수(Body Mass Index : BMI)가 30kg/㎡ 이상 또는 다른 위험인자(예, 고혈압, 당뇨, 고지혈증)가 있는 BMI 27kg/㎡ 이상인 비만환자에서 칼로리 제한을 기본으로 하는 체중감량 요법의 단기간 보조요법</td>
            </tr>
            <tr id="KDGERI_DIETHYLPROPION_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>MAO 억제제 복용중 또는 복용후 14일이 경과하지 않은 자, 폐동맥 고혈압을 포함하는 중증의 고혈압, 녹내장, 갑상샘 항진, 진전된 동맥경화증, 동맥폐색, 기지의 심장잡음 또는 판막심장병, 내인성 우울증, 정신적으로 매우 불안하거나 흥분상태, 교감신경 흥분성 아민류에 과민 또는 특이체질자, 약물, 알코올 남용 기왕력자 또는 가능성이 있는 자, 뇌졸중 이후 상태, 다른 식욕억제제를 복용하고 있는 환자, 부정맥이나 고혈압을 포함하는 중증 심질환, 크롬친화세포종, 16세 이하</td>
            </tr>
            <tr id="KDGERI_DIETHYLPROPION_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) 1회 25mg씩 1일 3회, 식사 1시간 전 복용1일 최대용량: 75mg최대 투여기간: 4주</td>
            </tr>
            <tr id="KDGERI_DIETHYLPROPION_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙고령자는 신기능이 저하되어있으므로 고령자에게는 투여하지 않음(신 배설 약제, 신장 기능이 손상된 환자의 경우 독성 위험성 높음) <br />∙심혈관 질환, 고혈압, 간질, 전립샘 선종, 당뇨병 등 신진대사 질환, 전신마취 하는 경우 등 신중투여<br />∙다른 식욕억제제와 병용금기<br />∙내성이 나타나면 사용 중지<br />∙약물의 남용 및 의존성 방지를 위해 장기복용은 엄격히 금지<br />∙정신적인 의존성이 나타나면 점진적으로 투약을 중지<br />∙식욕억제제는 종종 치명적인 질병으로 간주되는 원발성 폐동맥 고혈압의 위험을 증가시킴(원인을 알 수 없는 협심증, 실신, 또는 하지말단부종이나 운동호흡곤란의 발생시 즉시 투여를 중단하고 원발성 폐동맥 고혈압의 발생 가능성을 평가) <br />∙장기간 투여는 치료중지 후 금단증상과 같은 의존성 유발 가능<br />∙최근 1년 이내에 다른 식욕억제제를 사용한 환자에게는 투여 권장하지 않음<br />∙위험한 활동에 종사하고 있는 사람들에게는 주의하여 투여(중추신경계 작용)</td>
            </tr>
            <tr id="KDGERI_DIETHYLPROPION_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙전신마취제 및 교감신경작용 약물(부정맥) <br />∙중추신경계 작용하는 다른 약물(약효 변화) <br />∙당뇨병약(투여량 조절 필요) <br />∙구아네티딘(구아네티딘의 혈압강하 효과 저하) <br />∙구아네티딘, 아만타딘(구아네티딘, 아만타딘의 초기 교감신경 흥분 작용 강화) <br />∙다른 식욕억제제(외인성 카테콜아민류의 혈압상승 효과 강화) <br />∙페노티아진(디에칠프로피온의 식욕억제효과 차단) <br />∙쿠마린 계열의 항응고제, 항경련제(예, 페노바르비탈, 디페닐하이단토인, 프리미돈), 신경이완제, 심환계항우울제(특히 이미프라민 및 데시프라민), 페닐부타존(주어진 성분들의 신진대사 저해, 디에필프로피온의 용량 줄이는 것 필요) <br />∙알코올(유해 상호작용의 가능성)</td>
            </tr>
            <tr id="KDGERI_DIETHYLPROPION_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>불면, 신경질, 어지럼, 불안, 초조 및 구갈, 원발성 폐동맥 고혈압, 빈맥, 명치동통, 부정맥(심실부정맥 포함), 심계항진, 혈압상승, 심전도 변화, 운동이상증, 흐려보임, 과자극, 신경질, 안절부절, 어지럼, 초조, 불면, 불안, 이상황홀감, 불쾌감, 때로 우울증, 진전, 동공확대, 졸음, 권태감, 두통, 뇌혈관사고, 정신병적 에피소드, 경련성 장애 증가, 설사, 변비, 구역, 구토, 복부불쾌감, 복통, 불쾌한 맛, 구갈, 구강건조증, 구내염, 기타 위장장애, 두드러기, 발진, 반상출혈, 홍반, 발기부전, 월경통, 성욕변화, 월경곤란, 여성형유방, 골수기능억제, 백혈구감소증, 무과립구증, 저혈소판증, 호흡곤란, 모발감소, 근육통, 배뇨장애, 다뇨증, 발한, 혈관부종 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_LORCASERIN" data-drug-number="153">
          <thead>
            <tr>
              <th className="drug-number">153</th>
              <th className="drug-name">로카세린(Lorcaserin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">식욕억제제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_LORCASERIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>체질량지수(BMI) 30kg/㎡ 이상의 비만환자 또는 다른 위험인자(예. 고혈압, 이상지질혈증, 제2형 당뇨)가 있는 체질량지수(BMI) 27kg/㎡ 이상인 과체중 환자의 체중조절을 위한 식이 및 운동요법의 보조요법</td>
            </tr>
            <tr id="KDGERI_LORCASERIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 및 이 약의 구성성분에 과민반응이 있는 환자, 임부 또는 임신하고 있을 가능성이 있는 여성 및 수유부, 다른 체중조절약을 복용하고 있는 환자, 약물 남용의 병력이 있는 환자</td>
            </tr>
            <tr id="KDGERI_LORCASERIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) 1회 10mg씩 1일 2회개시 후 12주 이내 투여시점 대비 5% 미만 감량시 복용 중단고령자: 정상 신기능을 가진 고령자에는 용량조절이 필요하지 않음</td>
            </tr>
            <tr id="KDGERI_LORCASERIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙고령자에 대한 이 약의 사용은 신기능을 바탕으로 결정하여야 함<br />∙울혈성 심부전, 판막성 심질환, 서맥, 심장질환 또는 기왕력자, 당뇨병, 겸상적혈구빈혈, 다발성 골수종, 백혈병, 음경의 해부학적 변형, 페이로니병, 4시간 이상 발기 지속자 또는 기왕력자, PDE5 효소 저해제 복용자, 중등증 이상 신장애, 중증 간장애, 세로토닌-노르에피네프린/선택적 세로토닌 재흡수 억제제(SNRI/SSRI), 삼환계 항우울제(TCA), 부프로피온, MAO 저해제, 항도파민 약물, 항정신병약 투여중, 고프로락틴혈증, 임신,수유 계획여성 신중투여<br />∙다른 식욕억제제와 병용금기<br />∙세로토닌 증후군 또는 신경이완제악성증후군 유사 반응, 판막성 심장질환, 인지 장애, 정신장애, 당뇨병치료제를 복용 중인 제2형 당뇨 환자에서 저혈당의 잠재적 위험성, 지속발기증, 심박수 감소, 혈액학적 변화, 프로락틴 수치 증가, 폐고혈압, 남용, 의존성 주의<br />∙투여 시작시 최소용량으로 시작<br />∙차를 운전하거나 중장비 기계를 작동하지 말 것(사고능력에 영향)</td>
            </tr>
            <tr id="KDGERI_LORCASERIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙세로토닌 경로에 영향을 미치는 약물(병용시 최대한 신중하게 사용) <br />∙CYP 2D6 효소 기질 약물(CYP 2D6 효소 기질 약물의 노출을 증가)</td>
            </tr>
            <tr id="KDGERI_LORCASERIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>두통, 저혈당, 림프구 감소, 등 통증, 상기도 감염, 비인두염, 말초부종, 고혈압, 현기, 피로, 불안, 불면, 우울, 인지장애, 정신질환, 발적, 당뇨병 악화, 프로락틴 증가, 오심, 설사, 변비, 구강 건조증, 구토, 위장염, 치통, 식욕저하, 요로감염, 헤모글로빈 저하, 호중구 저하, 근경련, 근골격계 통증, 눈 장애, 기침, 구강인두 통증, 비강울혈, 계절성 알러지, 스트레스 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_MAZINDOL" data-drug-number="154">
          <thead>
            <tr>
              <th className="drug-number">154</th>
              <th className="drug-name">마진돌(Mazindol)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">식욕억제제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_MAZINDOL_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>적절한 체중감량요법(식이요법 또는 운동요법)에 반응하지 않는 초기 체질량지수(Body Mass Index : BMI)가 30kg/㎡이상이며 다른 위험인자(예, 고혈압, 당뇨, 고지혈증)가 있는 외인성 비만 환자에서 운동, 행동 수정 및 칼로리 제한을 기본으로 하는 체중감량요법의 단기간 보조요법</td>
            </tr>
            <tr id="KDGERI_MAZINDOL_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 또는 이 약 구성성분 과민증, 심혈관계･뇌혈관계 질환, 중등도-중증 고혈압, 폐동맥 고혈압, 갑상샘 항진, 중등도-중증 간･신장애, 중증 심장애, 중증 췌장 장애, 요독증, 녹내장, 교감신경 흥분성 아민류에 특이체질, 정신적으로 매우 불안하거나 흥분상태, 약물･알코올 남용 기왕력자, MAO억제제 복용중이거나 복용후 14일 이내, 임부･가임부･수유부, 16세 이하, 다른 식욕억제제를 복용하고 있는 환자</td>
            </tr>
            <tr id="KDGERI_MAZINDOL_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) 1회 0.5mg씩 1일 1회 점심식사 전 복용1일 최대투여량: 1.5mg (2-3회로 분복)최대 투여기간: 4주</td>
            </tr>
            <tr id="KDGERI_MAZINDOL_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙65세 이상의 고령자에서는 이상반응 발현율이 높음<br />∙당뇨병, 정신장애 병력, 간질, 고령자, 경증의 고혈압 환자 등 신중투여<br />∙다른 식욕억제제와 병용금기<br />∙식욕억제제는 종종 치명적인 질병으로 간주되는 원발성 폐동맥 고혈압의 위험을 증가시킴(격심한 호흡곤란의 시작이나 악화 또는 이유가 밝혀지지 않은 협심증 증상, 실신, 하지부종 발생시 즉시 투여를 중단하고 원발성 폐동맥 고혈압의 발생 가능성을 평가) <br />∙오랫동안 고용량 투약 후 갑작스런 투약 중지시 극도의 피로나 우울증, 심혈관계 질환을 초래할 수 있음</td>
            </tr>
            <tr id="KDGERI_MAZINDOL_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙MAO억제제(MAO억제제의 작용 증가) <br />∙외인성 카테콜아민(혈압상승 작용을 현저히 높임) <br />∙갑상샘 호르몬이나 아만타딘 같은 중추신경 흥분제(중추신경 흥분 야기) <br />∙클로니딘, 구아네티딘, 메틸도파, 맥각 알칼로이드 같은 혈압강하제(혈압 강하작용을 감소) <br />∙할로탄과 같은 흡입마취제(부정맥) <br />∙경구당뇨병제(경구당뇨병제의 투여량 조절필요, 마진돌의 인슐린 분비 억제 작용 및 체중감소효과) <br />∙알코올(어지럼, 졸음 등)</td>
            </tr>
            <tr id="KDGERI_MAZINDOL_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>신경과민, 불면, 구갈, 변비, 빈뇨, 구역, 구토, 복부불쾌감, 의존성, 폐동맥고혈압, 격앙된 말투, 정신장애, 과흥분, 환각, 불안, 불쾌감, 진전, 지각이상, 우울, 수면장애, 두통, 무력감, 어지럼, 권태감, 안절부절못함, 졸음, 휘청거림, 빈맥, 가슴통증, 안면홍조, 혈압변화(고혈압, 저혈압), 뇌졸중, 협심증, 심근경색, 부정맥, 심부전, 심정지, 심계항진, 불쾌한 맛, 구토, 설사, 복통, 배가 거북함, 복부 팽만감, 발기부전, 월경이상, 가려움, 과도한 발한, 창백, 손의 저림, 발진, 탈모, 서늘함, AST･ALT 상승, 동공확대, 시야혼탁, 배뇨곤란 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PHENDIMETRAZINE" data-drug-number="155">
          <thead>
            <tr>
              <th className="drug-number">155</th>
              <th className="drug-name">펜디메트라진(Phendimetrazine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">식욕억제제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PHENDIMETRAZINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>적절한 체중감량요법(식이요법 및/또는 운동요법)에 반응하지 않는 초기 체질량지수(Body Mass Index : BMI)가 30kg/㎡ 이상, 또는 다른 위험인자(예, 고혈압, 당뇨, 고지혈증)가 있는 BMI 27kg/㎡ 이상인 비만 환자에서 칼로리 제한을 기본으로 하는 외인성 비만 치료 시 체중감량 요법의 단기간 보조요법</td>
            </tr>
            <tr id="KDGERI_PHENDIMETRAZINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>교감신경 흥분성 아민류에 과민증 또는 특이체질, 진전된 동맥경화증, 증후성 심혈관계 질환, 폐동맥 고혈압을 포함하는 중등도-중증 고혈압, 갑상샘 항진증, 녹내장, 정신적으로 매우 불안하거나 흥분상태, 약물 남용 기왕력자, 다른 중추신경계 흥분제 복용중 또는 MAO억제제 복용후 14일 이내, 다른 식욕억제제를 복용하고 있는 환자, 심장잡음 또는 판막심장병, 16세 이하</td>
            </tr>
            <tr id="KDGERI_PHENDIMETRAZINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) 1회 35mg씩 1일 2-3회 식사 1시간 전 복용1일 최대투여요량: 210mg최대 투여기간: 4주</td>
            </tr>
            <tr id="KDGERI_PHENDIMETRAZINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙경증의 고혈압 환자, 수유부, 당뇨병 환자 신중투여<br />∙다른 식욕억제제와 병용금기<br />∙식욕억제제는 치명적인 폐동맥 고혈압의 위험성 증가와 드물게 관련이 있음(운동호흡곤란의 발현 또는 악화, 또는 예측되지 않았던 협심증 증상, 실신 또는 하지 말단 부종 발생시 즉시 투여를 중단하고 폐동맥 고혈압의 유무에 대하여 평가) <br />∙내성이 나타나면 사용 중지<br />∙위험한 활동에 종사하고 있는 사람들에게는 주의하여 투여(중추신경계 작용) <br />∙인슐린 의존성 진성 당뇨병 환자에게 인슐린 요구량이 변경될 수 있음<br />∙투여 시작시 최소용량으로 시작<br />∙오랫동안 고용량 투여 후 갑작스럽게 투여를 중지할 경우 극도의 피로나 우울증 초래</td>
            </tr>
            <tr id="KDGERI_PHENDIMETRAZINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙구아네티딘(구아네티딘의 혈압강하 효과 저하) <br />∙요의 산성화(펜디메트라진의 배설 증가)</td>
            </tr>
            <tr id="KDGERI_PHENDIMETRAZINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>심계항진, 빈맥, 혈압상승, 과자극작용, 불안감, 어지럼, 불면증, 진전, 도취감, 두통, 구갈, 불쾌감, 설사, 변비, 기타 소화기 장애(구역, 위통), 성적충동의 변화, 빈뇨, 요결핍, 발기부전, 두드러기 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PHENTERMINE" data-drug-number="156">
          <thead>
            <tr>
              <th className="drug-number">156</th>
              <th className="drug-name">펜터민(Phentermine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">식욕억제제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PHENTERMINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>적절한 체중감량요법(식이요법 및/또는 운동요법)에 반응하지 않는 초기 체질량지수(Body Mass Index : BMI)가 30kg/㎡이상, 또는 다른 위험인자(예: 고혈압, 당뇨, 고지혈증)가 있는 BMI 27kg/㎡이상인 외인성 비만 환자에서 운동, 행동 수정 및 칼로리 제한을 기본으로 하는 체중감량요법의 단기간 보조요법</td>
            </tr>
            <tr id="KDGERI_PHENTERMINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>진전된 동맥경화증, 심혈관계 질환, 중등도-중증 고혈압, 폐동맥 고혈압, 갑상샘 항진, 본제 과민증, 교감신경 흥분성 아민류에 과민하거나 특이체질, 녹내장, 정신적으로 매우 불안하거나 흥분상태, 약물남용 기왕력자, MAO억제제 복용중 또는 복용후 14일 이내, 다른 식욕억제제를 복용하고 있는 환자, 16세 이하, 갈락토오스 불내성, Lapp 유당분해효소 결핍증 또는 포도당-갈락토오스 흡수장애 등의 유전적인 문제가 있는 환자</td>
            </tr>
            <tr id="KDGERI_PHENTERMINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) (정제)<br /> - 1회 37.5mg씩 1일 1회 아침 식전 혹은 식후 1-2시간 후 복용<br /> - 최대 투여기간: 4주<br /> - 최소 유효 용량을 사용하되 적절한 반응을 얻을 수 있도록 개인별로 조정하여야 함(1회 18.75mg 1일 1-2회 가능) (서방캡슐)<br /> - 1회 30mg씩 1일 1회 아침 식전 또는 아침 식후 2시간 후 복용<br /> - 최대 투여기간: 4주</td>
            </tr>
            <tr id="KDGERI_PHENTERMINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙당뇨병, 경증의 고혈압 환자 신중투여<br />∙다른 식욕억제제와 병용금기<br />∙투여 시작시 최소용량으로 시작<br />∙당뇨병 환자에서 인슐린 요구량이 변경될 수 있음<br />∙내성이 나타나면 사용 중지<br />∙오랫동안 고용량으로 투여 후 갑작스런 투여 중지시 극도의 피로나 우울증이 나타날 수 있으며, 수면 중 EEG(뇌전도)의 변화가 관찰됨<br />∙위험한 활동에 종사하고 있는 사람들에게는 주의하여 투여(중추신경계 작용)</td>
            </tr>
            <tr id="KDGERI_PHENTERMINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙구아네티딘(구아네티딘의 혈압강하 효과 저하) <br />∙알코올(유해한 약물 상호작용) <br />∙SSRI(fluoxetine, sertraline 등)(세로토닌증후군 위험 증가)</td>
            </tr>
            <tr id="KDGERI_PHENTERMINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>원발성 폐동맥 고혈압, 역류성 심장판막 질환, 심계항진, 빈맥, 혈압상승, 과자극작용, 불안감, 어지럼, 불면증, 불쾌감, 도취감, 진전, 두통. 구갈, 불쾌한 맛, 설사, 변비, 기타 위장관 장애, 두드러기, 발기부전, 성적충동의 변화 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_DONEPEZIL" data-drug-number="157">
          <thead>
            <tr>
              <th className="drug-number">157</th>
              <th className="drug-name">도네페질(Donepezil)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항치매제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_DONEPEZIL_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>알츠하이머형 치매증상의 치료, 혈관성 치매(뇌혈관질환을 동반한 치매)증상의 개선</td>
            </tr>
            <tr id="KDGERI_DONEPEZIL_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증</td>
            </tr>
            <tr id="KDGERI_DONEPEZIL_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제]초기용량: 1회 5 mg씩 1일 1회 취침전 투여 (일반용량)유지용량: 4-6주 후 1회 10mg씩 1일 1회로 증량, 최소 3개월동안 10mg을 1일 1회 복용한 환자에게 23mg을 1일 1회 투여 가능 (일반용량)저체중인 85세 이상 여성환자에게는 1일 5mg 이하로 투여</td>
            </tr>
            <tr id="KDGERI_DONEPEZIL_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙심장질환 환자에서 미주신경자극작용으로 인해 서맥을 일으키고 부정맥이 발생할 가능성이 있음<br />∙비스테로이드성 소염진통제를 투여중인 환자 또는 소화성궤양의 병력 환자에서 위산분비 촉진 및 소화관운동 촉진으로 소화성궤양이 악화될 가능성이 있음<br />∙천식 및 폐쇄폐질환 병력 환자에서 기관지평활근의 수축 및 기관지점액 분비 항진으로 증상이 악화될 수 있음<br />∙추체외로장애(파킨슨병, 파킨슨증후군 등) 환자에서 선조체의 콜린계신경의 항진으로 증상을 유발 또는 악화시킬 가능성이 있음</td>
            </tr>
            <tr id="KDGERI_DONEPEZIL_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙CYP3A4 및 CYP2D6 억제제 (이트라코나졸, 에리트로마이신, 퀴니딘, 플루옥세틴: 이 약 대사 방해, 약효 증가) <br />∙CYP3A4 및 CYP2D6 유도제 (리팜피신, 페니토인, 카르바마제핀, 덱사메타손, 페노바르비탈, 알코올: 이 약 대사 증가, 약효 감소) <br />∙콜린성약물 또는 아세틸콜린에스테라제 억제제 (카프로늄, 베타네콜, 아클라토늄, 나파디실레이트, 암베노늄, 디스티그민, 피리도스티그민, 네오스티그민: 콜린성 작용 증가) <br />∙항쿨린성약물 (아트로핀, 스코폴라민, 트리헥시페니딜, 피로헵틴, 비페리딘: 이 약 약효 감소) <br />∙베타차단제 (상승작용) <br />∙NSAIDs (위산분비 증가로 소화성 궤양 유발) <br />∙아세틸콜린에스테라제 억제제 (항 정신병과 관련된 추체회로 효과를 증가시킬 위험이 있으며, 신경근 차단제의 효과를 감소시킴)</td>
            </tr>
            <tr id="KDGERI_DONEPEZIL_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>불면, 구역, 설사, 감염, 고혈압, 흉통, 실신, 심방세동, 서맥, 심부전, ECG 이상, 부종, 두통, 통증, 어지러움, 피로, 비정상적인 꿈, 환각, 적개심, 신경질, 혼돈, 졸음, 감정불안정증, 인격장애, 습진, 체중감소, 고지혈증, 탈수, 구토, 식욕부진, 요실금, 빈뇨, 방광염, 반상출혈, 출혈, 근육경련, 등통증, 근육CK 증가, 관절염, 쇠약, 발열</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_GALANTAMINE" data-drug-number="158">
          <thead>
            <tr>
              <th className="drug-number">158</th>
              <th className="drug-name">갈란타민(Galantamine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항치매제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_GALANTAMINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>알쯔하이머 형태의 경등도, 중등도 치매 증상의 치료</td>
            </tr>
            <tr id="KDGERI_GALANTAMINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 중증 신장애(CrCl&lt;9mL/min), 중증 간장애(child-pugh score&gt;9)</td>
            </tr>
            <tr id="KDGERI_GALANTAMINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제]<br /> - 초기용량: 첫 4주 동안 1회 8mg 1일 1회 아침식사 직후 투여 (일반용량)<br /> - 유지용량: 최소 4주 이상 1회 16mg 1일 1회, 내약성에 따라 1회 24mg 1일 1회까지 증량 (일반용량)<br /> - 1일 최대용량: 24mg <br />∙중등도 간장애 환자에서 용량 조절<br /> - 초기용량: 최소 1주 동안 1회 8mg 이틀에 한번 아침식사 직후 투여<br /> - 유지용량: 최소 4주 동안 1회 8mg 1일 1회<br /> - 1일 최대용량: 16mg</td>
            </tr>
            <tr id="KDGERI_GALANTAMINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙콜린성 이상반응을 감소시키기 위해 이 약을 음식과 함께 복용하는 것을 권장<br />∙심박동수에 미주신경긴장 효과를 일으킬 수 있으므로 동기능부전증후군(sick sinus syndrome) 또는 다른 심전도 장애(동방차단, 방실차단) 환자에서 주의<br />∙위산분비를 증가시킬 수 있으므로 소화성궤양의 병력이 있는 경우 주의<br />∙중증 천식 및 폐쇄폐질환 환자에게 주의하여 사용<br />∙뇨배출 장애 환자에게 투여 권장하지 않음</td>
            </tr>
            <tr id="KDGERI_GALANTAMINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙다른 콜린작용성 약물과 병용투여해서는 안됨<br />∙항콜린성 약물 (해당약물 효과 저해) <br />∙CYP2D6 또는 CYP3A4의 강력한 저해제 (파록세틴, 아미트리프틸린, 플루옥세틴, 플루복사민, 퀴니딘, 케토코나졸, 에리스로마이신, 리토나비르: 콜린성 이상반응 빈도 증가)</td>
            </tr>
            <tr id="KDGERI_GALANTAMINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>구역, 구토, 실신, 서맥, 어지러움, 두통, 우울, 피로, 졸음, 권태감, 다한증, 설사, 식욕저하, 체중감소, 식욕부진, 복통, 소화불량, 상복부 통증, 복부불쾌감, 떨림, 요로감염, 빈혈, 진전, 비염</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_MEMANTINE" data-drug-number="159">
          <thead>
            <tr>
              <th className="drug-number">159</th>
              <th className="drug-name">메만틴(Memantine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항치매제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_MEMANTINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>중등도에서 중증의 알츠하이머병 치료</td>
            </tr>
            <tr id="KDGERI_MEMANTINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 중증 간장애, 중증 신장애 (CrCl&lt;5mL/min)</td>
            </tr>
            <tr id="KDGERI_MEMANTINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙이상반응 발생 위험을 최소화하기 위해 처음 3주간에 걸쳐 다음과 같이 주당 5mg씩 증량하여 유지용량에 도달<br /> - 첫째 주(1일~7일): 1회 5mg씩 1일 1회<br /> - 둘째 주(8일~14일): 1회 5mg씩 1일 2회<br /> - 셋째 주(15일~21일): 1아침에 10mg, 저녁에 5mg씩 1일 2회<br /> - 넷째 주부터: 1회 10mg씩 1일 2회 (=1일 최대용량) (고령자용량) <br />∙중증의 신장애 환자(CrCl 5-30ml/min): 1일 용량을 5mg씩 1일 2회로 감량</td>
            </tr>
            <tr id="KDGERI_MEMANTINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙간질 환자, 과거 경련 경험자, 간질에 걸리기 쉬운 소인이 있는 환자에게 신중히 투여<br />∙NMDA(N-methyl-D-aspartate) 길항제를 병용 투여하는 환자는 부작용 발생 비율 및 지속시간이 연장될 수 있으므로 병용 투여하지 않음<br />∙뇨 pH를 증가시킬 수 있으므로 주의하여 모니터링</td>
            </tr>
            <tr id="KDGERI_MEMANTINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙레보도파, 도파민 효능약 및 항콜린성 약물 (해당약물 효능 및 부작용 증강) <br />∙바르비탈계 약물 및 항정신병 약물 (해당약물 효능 감소) <br />∙NMDA(N-methyl-D-aspartate) 길항제 (아만타딘, 케타민 또는 덱스트로메토르판: 중추신경계 부작용 유발하므로 병용투여하지 않는다) <br />∙시메티딘, 라니티딘, 프로카인아미드, 퀴니딘, 퀴닌 및 니코틴 (이 약 혈중농도 상승) <br />∙하이드로클로로티아지드 (해당약물 배설 감소) <br />∙와르파린 (INR 증가) <br />∙carbonic anhydrase inhibitor, sodium bicarbonate (뇨의 pH를 높여 이 약의 소실률을 감소시킴)</td>
            </tr>
            <tr id="KDGERI_MEMANTINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>고혈압, 어지러움, 혼돈, 두통, 불안, 우울, 졸림, 환각, 두통, 공격적인 행동, 피로, 체중증가, 설사, 변비, 구토, 복통, 요실금, 호흡곤란, 요통, 기침</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_RIVASTIGMINE" data-drug-number="160">
          <thead>
            <tr>
              <th className="drug-number">160</th>
              <th className="drug-name">리바스티그민(Rivastigmine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항치매제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_RIVASTIGMINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>경증-중등도 알츠하이머형 치매증상 또는 파킨슨병 관련 치매증상의 치료중증 알츠하이머형 치매의 대증적 치료 [패취제만 해당]</td>
            </tr>
            <tr id="KDGERI_RIVASTIGMINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 중증 간장애패취제 투여 시 알레르기성 접촉성피부염으로 의심되는 투여부위반응 병력이 있는 환자</td>
            </tr>
            <tr id="KDGERI_RIVASTIGMINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) 1회 1.5mg씩 1일 2회로 시작, 내약성에 따라 1회 3mg씩 1일 2회 → 1회 4.5mg씩 1일 2회 → 1회 6mg씩 1일 2회까지 증량 (=1일 최대용량) <br />∙알츠하이머형 치매: 최소 2주 간격으로 증량<br />∙파킨슨병 관련 치매: 최소 4주의 간격으로 증량<br />[패취제] (일반용량)이 약 패취 5를 1일 1회로 투여 시작, 최소 4주 후 내약성에 따라 패취 10 으로 증량. 패취 10 을 6개월 이상 투여하는 동안 의미있는 인지능 및/또는 기능의 저하를 보인 환자는 좋은 내약성을 보인 경우에 한해 패취 15 까지 증량<br />∙유효용량경증-증등도 알츠하이머형 치매 또는 파킨슨병과 관련된 치매: 패취10중증 알츠하이머형 치매: 패취 15 <br />∙구역, 구토, 설사 등의 소화기계 이상반응이 관찰되면 1회 또는 그 이상 중단이상반응이 지속되면 1일 용량을 이전의 양호한 내약성을 보인 용량으로 감소3일 이상 동안 투여가 중단되면 1일 최저용량으로 투여를 다시 시작<br />∙캡슐 ↔ 패취 전환: 마지막 캡슐 투여 다음 날부터 패취를 사용 캡슐 6mg/일 미만: 패취 5 캡슐 6mg-12mg/일: 패취 10</td>
            </tr>
            <tr id="KDGERI_RIVASTIGMINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙다른 콜린성약물 또는 항콜린약물과 병용시 특별히 주의<br />∙위산분비를 증가시킬 수 있으므로 소화성궤양의 병력이 있는 경우 주의<br />∙심박동수에 미주신경긴장 효과를 일으킬 수 있으므로 동기능부전증후군(sick sinus syndrome) 또는 다른 심전도 장애(동방차단, 방실차단) 환자에서 주의<br />∙천식 및 폐쇄폐질환 환자, 요폐 및 발작 환자에서 주의<br />∙추체외로계 증상을 악화시키거나 유발할 수 있으므로 주의<br />∙패취제를 한 번 부착된 부분에는 14일 동안 다시 부착하지 말 것</td>
            </tr>
            <tr id="KDGERI_RIVASTIGMINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙메토클로프라미드 (추체외로계 증상 증대되어 투여 권장하지 않음) <br />∙콜린유사제제 (이 약의 효과 증대), 항 콜린 작용 약물 (옥시부티닌, 톨터로딘: 해당 약물 활성 방해) <br />∙베타 차단제, 칼슘채널차단제 (서맥)</td>
            </tr>
            <tr id="KDGERI_RIVASTIGMINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>어지러움, 두통, 불안, 체중감소, 구역, 구토, 설사, 식욕부진, 북통, 부착부위 홍반, 진전, 고혈압, 실신, 피로, 불면, 혼돈, 우울, 졸음, 권태감, 환각, 보행장애, 공격성, 파킨슨 증상 악화, 톱니바퀴경축, 안절부절, 파킨슨증, 발한증가, 탈수, 소화불량, 식욕저하, 복통, 타액 과분비, 요로감염증, 요실금, 부착부위 가려움, 발진 및 자극, 운동완만증, 운동저하증, 운동이상증, 비염고용량 투여환자, 저체중(50kg 미만) 환자에서 이상반응이 빈번하였음</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ATOMOXETINE" data-drug-number="161">
          <thead>
            <tr>
              <th className="drug-number">161</th>
              <th className="drug-name">아토목세틴(Atomoxetine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">각성제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ATOMOXETINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>6세 이상의 소아 및 성인의 주의력 결핍/과잉행동 장애(ADHD)의 치료제.</td>
            </tr>
            <tr id="KDGERI_ATOMOXETINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약의 주성분 또는 기타 성분에 과민증을 나타내는 환자, MAO 억제제 복용환자, 협우각 녹내장 환자, 크롬친화세포종(갈색세포종)환자, 중증 심혈관 질환 환자</td>
            </tr>
            <tr id="KDGERI_ATOMOXETINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량)초기용량: 1회 0.5 mg/kg 1일 1회 오전 복용유지용량: 1.2mg/kg/day</td>
            </tr>
            <tr id="KDGERI_ATOMOXETINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙고령자에 대한 이 약의 안전성과 효능은 확립되지 않음<br />∙알러지 우려자, 갑작스런 사망과 이전의 구조적인 심장 이상 또는 타 심각한 심장 문제, 고혈압, 빈맥, 심혈관질환 또는 뇌혈관질환과 같이 혈압 또는 심박수 상승에 의해 기존 질병 악화 우려자, 저혈압 소인자 또는 갑작스러운 심박수 또는 혈압변화 관련 상태, 선천적 또는 후천적 긴 QT 또는 QT 연장 가족력자, 황달 또는 간 손상에 대한 검사적 증거가 있는 자, 성장하지 않거나 만족할만한 체중 증가를 나타내지 못하는 자, 정신병적 또는 조증 증상, 발작 또는 그 기왕력자, 6세 미만, 타 효능효과(주요우울증 또는 불안증)에 본제 사용 등 신중투여<br />∙자살과 관련된 행동, 공격적인 행동, 적개심 또는 감정적 불안정성, 중대한 간 손상 등 주의<br />∙간, 신장 손상 환자는 주의해서 투여해야 함. 간손상 환자는 용량 조절이 필요함. 드물지만 심각한 간독성을 유발할 수 있음, 간독성반응의 징후나 증상(예, 황달, 소양증, 독감유사증상)이 나타나면 투여를 중단해야 함</td>
            </tr>
            <tr id="KDGERI_ATOMOXETINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙MAO억제제(자율신경계 불안정, 과도한 흥분을 포함하는 정신상태의 변화 등) <br />∙CYP2D6 저해제(아토목세틴의 용량을 서서히 단계적으로 증가시킬 필요 있음) <br />∙살부타몰(살부타몰의 심혈관계에 대한 작용 강화) <br />∙QT 연장시킬 수 있는 약물, CYP2D6 억제제(QT 간격 연장에 대한 위험을 잠재적으로 증가) <br />∙발작 역치를 낮추는 것으로 알려진 약물(발작에 대한 잠재적 위험 주의) <br />∙고혈압치료제 및 혈압상승제(아토목세틴이 혈압에 영향을 미칠 수 있음) <br />∙노르아드레날린에 영향을 미치는 약물(추가적 또는 상승적 약리 작용)</td>
            </tr>
            <tr id="KDGERI_ATOMOXETINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>두통, 불면, 졸음, 다한증, 구강건조증, 오심, 식욕저하, 복통, 구토, 변비, 발기부전, 확장기 혈압 상승, 수축기 고혈압, 심계항진, 실신, 홍조, 기립성 저혈압, QT 간격 연장, 피로, 현기, 우울, 수면장애, 과민성, 신경과민, 오한, 감각 이상, 불안, 적개심, 정서불안, 초조, 한랭감, 발적, 가려움, 두드러기, 체중저하, 성욕저하, 일과성 열감, 갈증, 월경 이상, 소화불량, 식욕부진, 미각장애, 고창, 사정장애, 뇨저류, 배뇨곤란, 빈뇨, 전립선염, 고환 통증, 진전, 근경련, 시야혼탁, 결막염, 산동, 인후통 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_CAFFEINE" data-drug-number="162">
          <thead>
            <tr>
              <th className="drug-number">162</th>
              <th className="drug-name">카페인(Caffeine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">각성제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_CAFFEINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>척추천자에 의한 두통, 알코올 또는 모르핀 중독에 의한 호흡억제시 호흡흥분 보조제</td>
            </tr>
            <tr id="KDGERI_CAFFEINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>없음</td>
            </tr>
            <tr id="KDGERI_CAFFEINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[주사제] (일반용량) 1회 100-500mg씩 근육 또는 피하주사, 긴급할 경우에는 정맥주사 가능소아: 1회 8mg/kg씩 근육 또는 피하주사, 필요할 경우 4시간마다 반복주사연령, 증상에 따라 적절히 증감</td>
            </tr>
            <tr id="KDGERI_CAFFEINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers criteria 해당약품<br />∙고령자는 생리기능이 저하되어 있으므로 감량하는 등 주의<br />∙위궤양 또는 그 병력이 있는 환자, 심장애 환자, 녹내장 환자, 이 약에 과민증 환자 신중투여<br />∙과랑 투여할 경우 우울증 환자를 더욱 우울하게 만들 수 있으므로 1회 용량이 1g을 넘지 않도록 함<br />∙중추신경을 자극하므로 불면 노인환자에게는 부적절(2012 Beers criteria)</td>
            </tr>
            <tr id="KDGERI_CAFFEINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>없음</td>
            </tr>
            <tr id="KDGERI_CAFFEINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>구역, 설사, 빈맥, 심계항진, 기외수축, 불면, 흥분, 진전, 어지러움, 동공확대, 섬광안검(Scintillation-Scotoma), 이명, 만성 녹내장, 무력감, 만성 요통 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_METHYLPHENIDATE" data-drug-number="163">
          <thead>
            <tr>
              <th className="drug-number">163</th>
              <th className="drug-name">메칠페니데이트(Methylphenidate)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">각성제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_METHYLPHENIDATE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>수면발작(정제) 6세 이상의 소아 및 청소년의 주의력결핍과잉행동장애의 치료(정제, 서방정제, 서방캡슐제)</td>
            </tr>
            <tr id="KDGERI_METHYLPHENIDATE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>중증의 불안, 긴장, 흥분 환자, 이 약 및 이 약의 다른 성분에 과민증이 있는 환자, 녹내장 환자, 뚜렛 증후군으로 진단받았거나 가족력이 있는 환자 및 운동성 틱장애 환자, MAO 저해제 투여 중이거나, MAO 저해제 투여 중단 후 최소 14일 이내의 환자, 중중의 고혈압이나 협심증, 심부정맥, 심부전, 최근의 심근경색증, 갑상선기능항진증이나 갑상샘항진증을 앓고 있는 환자</td>
            </tr>
            <tr id="KDGERI_METHYLPHENIDATE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (정제) (일반용량)수면발작: 20-60mg/일 1-2회 분할투여6세 이상의 소아 및 청소년 주의력결핍과잉행동장애: 1회 5mg씩 1일 2회(아침, 점심 식전), 1주 간격으로 5-10mg씩 증량, 1일 최대투여량: 60mg연령, 증상에 따라 적절히 증감</td>
            </tr>
            <tr id="KDGERI_METHYLPHENIDATE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers criteria 해당약품<br />∙고령자는 생리기능이 저하되어 있으므로 감량하는 등 주의<br />∙정신질환 환자, 고혈압 환자 및 심박수나 혈압이 상승될 수 있는 의학적 상태의 환자, 약물의존성 또는 알코올중독의 병력이 있는 환자, 간질 또는 발작 병력이 있는 환자 등 신중투여<br />∙중대한 심혈관 사례, 정신과적 유해사례, 장기간 투여 시 성장 억제, 발작, 레이노증후군을 포함한 말초혈관장애, 시력장애, 약물의존, 지속적인 통증성 발기 등 주의<br />∙흥분할 요소가 있는 환자는 필요시 치료를 중단<br />∙장기간 투여 시 정기적 혈액 검사 실시<br />∙백혈구감소증, 혈소판감소증, 빈혈, 신질환 또는 간질환 상태 변화의 조짐이 보일 경우, 치료 중지 고려<br />∙운전 시나, 기계조작 시 또는 다른 위험 가능성 있는 활동 시 주의(어지러움) <br />∙중추신경을 자극하므로 불면 노인환자에게는 부적절(2012 Beers criteria)</td>
            </tr>
            <tr id="KDGERI_METHYLPHENIDATE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙MAO억제제를 투여 중이거나, MAO억제제 투여 중단 후 최소 14일 이내의 환자(병용금기) <br />∙혈압상승제(혈압 상승) <br />∙고혈압 치료 약물(효과 감소) <br />∙쿠마린 항응고제, 항전간제 및 일부 항우울제(대사 저해, 약물의 감량 필요) <br />∙클로니딘(갑작스러운 사망 등 중대한 이상반응) <br />∙도파민성 약물<br />∙알코올(중추신경계에 대한 이상반응을 악화) <br />∙할로겐화 마취제(수술 중 갑작스런 혈압 상승) <br />∙항종양약, 마취제, 면역억제제, 인슐린을 제외한 혈당강하제, 아편유사체, 녹내장치료제(병용투여 주의) <br />∙CYP 2D6저해제(이 약의 혈중 농도 및 약효 증강)</td>
            </tr>
            <tr id="KDGERI_METHYLPHENIDATE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>신경과민증, 불면증, 과민반응(피부발진, 두드러기, 발열, 관절통, 박탈피부염, 괴사성 혈관염의 조직병리학적 소견을 가진 다형성 홍반, 혈소판 감소성 자반증 포함), 식욕부진, 구역, 어지러움, 두근거림, 두통, 이상운동증, 졸음, 혈압 및 맥박의 상승 및 감소, 빈맥, 협심증, 심부정맥, 복통, 장기간 투여 중 체중 감소 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_MODAFINIL" data-drug-number="164">
          <thead>
            <tr>
              <th className="drug-number">164</th>
              <th className="drug-name">모다피닐(Modafinil)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">각성제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_MODAFINIL_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>성인에 있어서, 기면증과 관련한 과다졸음</td>
            </tr>
            <tr id="KDGERI_MODAFINIL_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>임부, 수유부, 소아, 중등도 ~ 중증의 고혈압 환자, 부정맥 환자, 이 약의 성분에 과민증이 있는 환자, 갈락토오스 불내성, Lapp 유당분해효소 결핍증 또는 포도당-갈락토오스 흡수장애 등의 유전적인 문제가 있는 환자</td>
            </tr>
            <tr id="KDGERI_MODAFINIL_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) 1회 200mg씩 1일 1회 아침 투여중증의 간장애 환자: 성인용량의 1/2을 투여</td>
            </tr>
            <tr id="KDGERI_MODAFINIL_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙고령자의 신기능 및 간기능 저하에 따른 이 약의 용량 감소 필요<br />∙65세 이상의 환자에 대한 안전성 및 유효성은 확립되지 않으므로 사용하지 않는 것이 바람직<br />∙불안증 환자, 가임기 여성, 고혈압 환자, 우울증, 조증, 정신계 질환, 간질환자, 심각한 간기능 장애, 중대한 신장기능장애, 고령자 등 신중투여<br />∙졸음, 피부발진, 혈관부종 및 아나필락시스양 반응, 다기관 과민반응, 정신과적 증상, 불안, 자살충동, 정신병 또는 조증 증상, 양극성 장애, 공격 또는 적대적 성향, 불면, 심혈관 위험 등 주의<br />∙운전이나 위험한 기계 조작에 주의(판단, 사고 또는 운동기능을 변화) <br />∙9주 이상의 장기 효과가 평가되지 않음, 본 제를 장기간 사용할 경우, 환자 개개인에 대해 장기간 사용에 대한 주기적인 재평가를 실시하여야 함</td>
            </tr>
            <tr id="KDGERI_MODAFINIL_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙스테로이드 피임제(스테로이드 피임제의 유효성이 감소) <br />∙항우울제(모다피닐이 대사효소 저해할 수 있으므로, 항우울제를 저용량으로 투여) <br />∙Carbamazepine 및 Phenobarbital 등 CYP 활성을 유도할 가능성이 있는 약물(모다피닐의 혈중농도 감소) <br />∙Phenytoin(Phenytoin의 청소율 감소) <br />∙Methylpheniate(모다피닐의 흡수 지체) <br />∙Triazolam(트리아졸람의 평균Cmax와 AUC0-∞ 감소, 소실반감기 감소) <br />∙항응고제(청소율 감소) <br />∙Ethinyl Estradiol(Ethinyl Estradiol의 Cmax와 AUC0-∞ 감소) <br />∙Cyclosporine(Cyclosporine의 대사 증가) <br />∙CYP2C19 대사에 의해 주로 소실되는 물질(CYP2C19 대사에 의해 주로 소실되는 물질의 청소율이 감소될 수 있으므로 용량 감소 필요)</td>
            </tr>
            <tr id="KDGERI_MODAFINIL_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>흉통, 고혈압, 심계항진, 혈관확장, 부종, 두통, 신경과민, 불안, 현기, 불면, 우울, 졸음, 감각이상, 초조, 오한, 착란, 정서불안, 긴장항진, 발한, 체중저하, 갈증, 식욕저하, 복통, 오심, 설사, 소화불량, 구강건조증, 식욕저하, 변비, 미각장애, 고창, 구강 점막의 궤양, 호산 백혈구 증가증, 간기능 검사 이상, ALP상승, 등 통증, 운동이상, 과활동, 진전, 비염, 인두염, 천식, 코피 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_BUSPIRONE" data-drug-number="165">
          <thead>
            <tr>
              <th className="drug-number">165</th>
              <th className="drug-name">부스피론(Buspirone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항불안제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_BUSPIRONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>불안장애의 치료 또는 불안증상의 단기완화</td>
            </tr>
            <tr id="KDGERI_BUSPIRONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약에 과민증 환자, 중증의 간･신장애 환자, 간질 환자, 급성 협우각형 녹내장 환자, 중증의 근무력증 환자, MAO저해제를 투여중인 환자</td>
            </tr>
            <tr id="KDGERI_BUSPIRONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량)초기용량 1회 5mg씩 1일 3회, 2-3일마다 1일 5mg씩 증량하여 1일 20-30mg을 분할투여1일 최대투여량: 60mg</td>
            </tr>
            <tr id="KDGERI_BUSPIRONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙항정신병약으로는 사용하지 말 것<br />∙위험을 수반하는 기계조작하지 말 것<br />∙부스피론 투약전에 중추신경억제제(진정･수면･항불안약)를 오랫동안 사용해 온 환자들은 이전에 투여해 온 약물을 천천히 감량할 것(금단증상 억제 위함) <br />∙투여 환자의 일부에서 투여개시 직후에 초조증상이 발현(중추노르아드레날린 작용증가효과 또는 도파민양효과(장시간 정좌불능 등) 등에 기인)</td>
            </tr>
            <tr id="KDGERI_BUSPIRONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙다른 중추신경작용약물(병용투여하는 경우 주의) <br />∙트라조돈(ALT가 3-6배 증가) <br />∙MAO저해제(혈압 상승) <br />∙알코올(병용투여하지 않음) <br />∙CYP3A4 저해제(이 약의 효과, 독성 증가) <br />∙CYP3A4 유도제(이 약의 효과 감소)</td>
            </tr>
            <tr id="KDGERI_BUSPIRONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>현기, 흉통, 졸음, 두통, 신경과민, 착란, 흥분, 무감각, 운동실조, 이상감각, 발한, 발적, 오심, 설사, 인후염, 근골격계 통증, 진전, 시야혼탁, 이명, 비충혈 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ETIFOXINE" data-drug-number="166">
          <thead>
            <tr>
              <th className="drug-number">166</th>
              <th className="drug-name">에티폭신(Etifoxine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항불안제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ETIFOXINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>불안의 정신・신체적 증상 치료</td>
            </tr>
            <tr id="KDGERI_ETIFOXINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약의 주성분 또는 기타 성분에 과민증을 나타내는 환자, 쇼크 상태, 중증의 간장애, 신장애 환자, 근무력증 환자, 갈락토오스 불내성, Lapp 유당분해효소 결핍증 또는 포도당-갈락토오스 흡수장애 등의 유전적인 문제가 있는 환자</td>
            </tr>
            <tr id="KDGERI_ETIFOXINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) 1회 50mg씩 1일 3회1일 최대투여량: 200mg</td>
            </tr>
            <tr id="KDGERI_ETIFOXINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙다른 중추신경억제제와 병용투여할 경우 중추신경억제작용 증강 주의<br />∙위험을 수반하는 기계조작 주의(졸음, 주의력･집중력･반사운동능력 등의 저하)</td>
            </tr>
            <tr id="KDGERI_ETIFOXINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙알코올(진정효과 증가) <br />∙모르핀 유도체, 벤조디아제핀, 최면진정제, 향정신병약, 항히스타민제, 항우울약, 중추성 항고혈압제, 바클로펜, 탈리도마이드(중추신경억제작용 증강)</td>
            </tr>
            <tr id="KDGERI_ETIFOXINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>현훈, 구역, 구토, 두통, 상복부 통증, 피로, 현기증, 졸음 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_TANDOSPIRONE" data-drug-number="167">
          <thead>
            <tr>
              <th className="drug-number">167</th>
              <th className="drug-name">탄도스피론(Tandospirone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항불안제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_TANDOSPIRONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>신경증에서의 우울, 공포,심신증(자율신경실조증, 본태성고혈압증, 소화성궤양)에서의 신체장애 및 우울, 불안, 초조, 수면장해</td>
            </tr>
            <tr id="KDGERI_TANDOSPIRONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약의 성분에 과민한 환자, 갈락토오스 불내성, Lapp 유당분해효소 결핍증 또는 포도당-갈락토오스 흡수장애 등의 유전적인 문제가 있는 환자</td>
            </tr>
            <tr id="KDGERI_TANDOSPIRONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] (일반용량) 1회 10mg씩 1일 3회1일 최대투여량: 60mg</td>
            </tr>
            <tr id="KDGERI_TANDOSPIRONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙고령자에게는 저용량(예로 1일 15㎎)으로 투여를 개시하는 등 주의<br />∙뇌에 기질적 장애, 호흡부전, 심･간･신장애, 고령자, 탈수, 영양실조가 동반된 육체적 피로가 있는 환자 등 신중투여<br />∙1일 60밀리그람을 투여하여도 효과가 나타나지 않는 경우에는 투여를 중지<br />∙고도의 불안증상을 수반하는 환자의 경우 효과를 기대하기 어려움<br />∙위험을 수반하는 기계조작 주의(졸음, 어지러움) <br />∙벤조디아제핀유도체 중지하는 경우는 서서히 감량(벤조디아제핀계 유도체와는 교차의존성이 없음)</td>
            </tr>
            <tr id="KDGERI_TANDOSPIRONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙할로페리돌 등 부티로페논계 유도체(추체외로계 증상 증가) <br />∙니카르디핀, 암로디핀, 니페디핀 등의 칼슘길항제(강압작용 증가) <br />∙플루복사민, 파록세틴, 밀란시프란, 트라조돈 등의 세로토닌 재흡수 저해작용을 가진 약물(세로토닌 증후군)</td>
            </tr>
            <tr id="KDGERI_TANDOSPIRONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>졸음, 휘청거림, 구역, 권태감, 기분불쾌, 식욕부진, AST 및 ALT의 상승, 세로토닌 증후군(빈도불명), 신경이완제악성증후(발열, 의식장애, 심각한 근육 경직, 불수의운동, 발한, 빈맥과 같은 어느 증상) 등</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_THIAMYLAL" data-drug-number="168">
          <thead>
            <tr>
              <th className="drug-number">168</th>
              <th className="drug-name">치아밀랄(Thiamylal)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">전신마취제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_THIAMYLAL_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[주사제] 전신마취, 국소마취제 및 흡입마취제와의 병용, 정신신경과에서의 전격요법(電擊療法)시의 마취, 국소마취제 중독･파상풍･자간(子癎) 등에 수반되는 경련</td>
            </tr>
            <tr id="KDGERI_THIAMYLAL_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>중증 간장애 및 신장애, 중증심부전, 쇼크 또는 대출혈로 인한 순환부전, 잠복성 또는 급성 간헐성 포르피린증, 부신기능부전, 중증 천식, 바르비탈계 약물 과민증</td>
            </tr>
            <tr id="KDGERI_THIAMYLAL_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[주사제] (일반용량) <br />∙정맥주사<br /> - 농도: 2.5%<br /> - 전신마취의 유도: 최초 50-100mg 주입 후 환자 상태에 따라 추가량 결정<br /> - 단시간마취: 최초 50-75mg을 10-15초에 주입 후 30초간 전싱상태 관찰. 필요 시 50-75mg를 같은 속도로 주입. 수술에 앞서 다시 50-75mg를 같은 속도로 분할주입하여 10-15분 정도의 마취 유발 가능. 단시간 내 수술이 종료되지 않으면 20-100mg 분할주입. 1회 최대사용량 1g<br /> - 병용사용: 50-100mg을 간헐적으로 정맥주입<br /> - 정신신경과에서 전격요법시의 마취: 300mg를 약 25-35초에 주입<br /> - 경련시: 50-200mg을 경련이 멈출 때까지 천천히 주입<br />∙직장내 주입<br /> - 농도: 10%<br /> - 투여량: 20-40mg/kg, 요도용 도관을 통해 직장 내 삽입하여 주입<br /> - 주입 후 약 15분 이내에 마취에 들어가 약 1시간 지속함</td>
            </tr>
            <tr id="KDGERI_THIAMYLAL_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙고령자에는 호흡억제, 혈압강하가 심하게 나타날 수 있으므로 신중 투여<br />∙직장에 염증이 있는 환자나 항문 괄약근의 조절 부전 환자에는 직장내 주입을 하지 말 것<br />∙장기간의 수술에 사용할 경우 단독 투여를 피하고 다른 마취제 병용이 바람직함<br />∙마취시 후두근 및 부교감신경이 과민 상태로 될 수 있으므로 전처치로서 아트로핀, 스코폴라민 등을 투여하는 것이 바람직함<br />∙진통작용이 없으므로 필요시에는 진통제를 병용투여해야 함<br />∙정맥외로 주사액이 누출된 경우에는 프로카인 주사액 등의 국소 마취제로 침윤, 온습포 등의 적당한 처치를 할 것</td>
            </tr>
            <tr id="KDGERI_THIAMYLAL_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙중추신경억제제, 혈압강하제. MAO저해제, 삼환계 항우울제, 메페네신, 설파닐유레아, 항파킨슨제, 디설피람 (상호작용 증강) <br />∙독시사이클린 (혈중농도반감기 단축)</td>
            </tr>
            <tr id="KDGERI_THIAMYLAL_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>쇼크, 호흡정지, 흡입억제, 설근침하, 인두경련, 기관지경련, 기침, 딸꾹질, 혈압하강 부정맥, 피부발진각성시: 구역, 구토, 두통, 어지러움, 눈물, 떨림, 경련, 흥분, 안면홍조, 복시, 마비감, 요폐. 권태감, 유연, 발한 근의불수의 운동</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_AMIODARONE" data-drug-number="169">
          <thead>
            <tr>
              <th className="drug-number">169</th>
              <th className="drug-name">아미오다론(Amiodarone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">부정맥용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_AMIODARONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>심방성부정맥, 심실성부정맥, 기타 다른 부정맥용제로 치료되지 않는 재발성중증 부정맥, 협심증 등 기초 심질환을 수반하는 부정맥</td>
            </tr>
            <tr id="KDGERI_AMIODARONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 심실성 서맥, 심이성 심폐쇄, 동서맥 및 동방차단, 중증의 동기능부전증후군 또는 2도 이상의 방실전도장애(심박조율기 착용시 제외), 갑상선기능장애, 임부, 수유부, 토르사드 데 포인트 유발 약제 투여, 갈락토오스 관련 유전적 문제, 신생아･미숙아 또는 저혈압･중증 호흡기부전･심근병증･심부전(주사제에 한함)</td>
            </tr>
            <tr id="KDGERI_AMIODARONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙초기용량: 첫 8~10일간 1일 600mg, 필요시 1일 800-1000mg으로 증량<br />∙유지용량: 1일 200-400mg, 1주에 5일간 투여<br />[주사제] <br />∙포화요법: 5㎎/kg IV infusion, D5W 250mL에 희석 후 20분-2시간 동안 투여24시간 내 동일용량을 2-3회 반복 투여 가능<br />∙유지요법: 10-20㎎/kg IV infusion, D5W 250mL에 희석, 2-3일간 투여<br />∙1일 평균 투여량: 600-800㎎, 1일 최대 투여량: 1200㎎<br />∙IV 투여 1일째, 경구요법(1일 600㎎)으로 치환, 1일 800-1000㎎까지 증량가능</td>
            </tr>
            <tr id="KDGERI_AMIODARONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers‘ Criteria 해당 품목(노인 환자에게 심방세동의 1차 치료약으로 사용하지 않음). <br />∙amiodarone은 독성이 높아 1차 치료요법으로 권고되지 않으며, 새로운 부정맥을 발생시킬 수 있음. <br />∙약물 투여 초기에는 저혈압 및 서맥에 주의하여 심전도 및 혈압 관찰을 위해 입원이 필요함. <br />∙개체에 따라 치료반응이 나타나는 용량이 매우 다를 수 있으므로 용량조절 및 투여 속도에 특히 주의를 기울여야 하며, 최소 용량 사용을 권고함. <br />∙고령자나 저체중인 경우 1일 100mg을 유지용량으로 하기도 함(Zimetbaum, 2007). <br />∙신장애 환자의 용량조절은 불필요. 간장애 환자의 경우 신중 투여<br />∙갑상선질환의 병력 및 가족력이 있는 환자의 경우 갑상선기능 항진증 또는 저하증을 야기할 수 있으므로 투여 전 usTSH 모니터링 권장. <br />∙저칼륨혈증시 효과 없거나 부정맥 유발할 수 있음. 약물에 적절한 반응을 보이지 않거나 심각한 부작용을 보일 경우 혈중 amiodarone 농도 측정 권장. <br />∙주사제의 경우 중증 저혈압, 순환성 쇼크을 유발할 수 있으므로 IV bolus는 권장되지 않으며, 가능한 중심정맥 투여관을 통해 IV infusion 하도록 함. <br />∙amiodarone은 경구, IV, intraosseous injection 만 투여 가능하며, PVC 용기는 본 약물용액에 소량씩 용해되므로, 정맥점적주사 투여할 때는 유리용기 사용.</td>
            </tr>
            <tr id="KDGERI_AMIODARONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙QT연장 유발약물, 플루오로퀴놀론제제 (QT 연장, 심실성 부정맥 유발) <br />∙리토나비어, 사퀴나비어, 넬피나비어, 인디나비어(이 약 혈중농도 상승) <br />∙베타차단제, 베라파밀, 딜티아젬(현저한 서맥, 전도장애 위험) <br />∙자극성 완화제(저칼륨혈증 유발, 토르사드 데 포인트 위험 증가)</td>
            </tr>
            <tr id="KDGERI_AMIODARONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>저혈압, 서맥, 방실블록, 심정지, 심장 부정맥, 심부전, 심실빈맥, 부전수축, 심방세동, 심인성 쇼크, 토르사르데 포인트, 심실세동, 실조증, 현기증, 피로, 권태감, 말초신경병증, 기억 장애, 감각 이상, 두통, 불면증, 수면장애, 색소침착, 광과민성, 갑상선기능 저하증, 성욕감퇴, 갑상선 기능 항진증, 오심, 구토, 식욕부진, 변비, 타액분비 이상, 미각 이상, 복통, 설사, 혈액 응고 장애, 간기능 수치 상승, 간질환, 진전, 시각장애, 시신경염, 폐독성, 폐부종</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_DRONEDARONE" data-drug-number="170">
          <thead>
            <tr>
              <th className="drug-number">170</th>
              <th className="drug-name">드로네다론(Dronedarone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">부정맥용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_DRONEDARONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>발작성 또는 지속성 심방세동 병력을 가진 현재 정상 동율동(sinus rhythm)인 심방세동 환자에서 심방세동으로 인한 입원 위험성 감소</td>
            </tr>
            <tr id="KDGERI_DRONEDARONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 영구적 심방세동, 심부전 기왕력 또는 좌심실 수축기능부전, 불안정한 혈역학적 상태, 2도 또는 3도 방실 차단, 완전각차단, 원위 차단, 동방결절기능장애, 심방전도결함 또는 동기능 부전 증후군(심장 박동 조율기 착용 제외), 분당 50회 미만의 서맥, 강력한 CYP 3A 억제제 투여, 페노티아진계 항정신병 약물, 삼환계 항우울약, 일부 경구용 마크로라이드계 항생제 및 Class I과 III의 항부정맥제와 같이 QT 간격을 연장시키고 다형성 심실빈맥(Torsade de Pointes) 발생 위험을 높일 수 있는 약물이나 생약 제제를 병용 투여, QTc Bazett 간격이 500ms 이상 또는 PR 간격이 280ms 초과, 중증 간장애, 아미오다론 사용 관련 간 및 폐 독성, 임부 또는 수유부, 갈락토오스 관련 유전적 문제</td>
            </tr>
            <tr id="KDGERI_DRONEDARONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>1회 드로네다론으로서 400mg씩 1일 2회 식사와 함께 투여.고령자, 신장애 및 경증-중등증 간장애 환자: 용량 조절 불필요.중증 간장애 환자: 사용 경험이 없으므로 투여하지 않음.</td>
            </tr>
            <tr id="KDGERI_DRONEDARONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers’ Criteria 해당 품목(영구심방세동 및 심부전이 있는 노인 환자에게 사용하지 않음). <br />∙고령자와 젊은 성인에 대한 이 약의 안전성과 유효성은 유사함. <br />∙저칼륨혈증에서 효과적이지 않거나 부정맥을 유발할 수 있으므로 이 약 투여 시작 전과 치료 중 칼륨 또는 마그네슘 결핍 교정. <br />∙호흡곤란 또는 가래 없는 기침 발생은 폐독성과 관련 있을 수 있으므로 주의.</td>
            </tr>
            <tr id="KDGERI_DRONEDARONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙QT 간격 연장 약물(잠재적 위험 수반) <br />∙디곡신(이 약의 전기생리적 효과 증가, 디곡신 혈중농도 증가) <br />∙강력한 CYP3A억제제, 자몽주스(이 약의 노출량 증가) <br />∙리팜피신과 다른 CYP3A 유도제(이 약의 노출량 감소) <br />∙와르파린, 다른 비타민 K 길항제(INR 증가) <br />∙스타틴계 약물(스타틴계 약물 노출량 증가) <br />∙칼슘채널차단제(이 약의 효과 증가) <br />∙베타차단제(서맥 우려 가능성)</td>
            </tr>
            <tr id="KDGERI_DRONEDARONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>QT간격 연장, 혈청 크레아티닌 수치 증가, 서맥, 발진, 가려움증, 습진, 피부염, 알레르기성 피부염, 설사, 구역, 복통, 소화불량의 징후 및 증상, 구토, 무기력상태</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_FLECAINIDE" data-drug-number="171">
          <thead>
            <tr>
              <th className="drug-number">171</th>
              <th className="drug-name">플레카이니드(Flecainide)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">부정맥용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_FLECAINIDE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>심실성부정빈맥, 심실성기외수축, 발작성심실성빈맥, WPW증후군, 다른 수단에 의해 회복된 정상리듬의 유지, 발작성심방세동</td>
            </tr>
            <tr id="KDGERI_FLECAINIDE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>심부전, 동기능부전증후군, 중증의 자극전도장애, 현저한 서맥, 심근경색 후 무증후성 심실성 기외수축, 비지속성 심실빈맥, 임부 또는 가임부</td>
            </tr>
            <tr id="KDGERI_FLECAINIDE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>1회 50-100mg씩 1일 2회1일 최대 투여량: 400mg(체격이 큰 환자나 부정맥의 신속한 처치가 필요한 경우)고령자: 1회 100mg씩 1일 2회, 1주일 후 유지요법으로 감량중증 신장애 (CrCl 35ml/min 이하) : 1일 최대 투여량 100mg</td>
            </tr>
            <tr id="KDGERI_FLECAINIDE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers’ Criteria 해당 품목(노인 환자에게 심방세동의 1차 치료약으로 사용하지 않음) <br />∙고령자나 고위험군 환자는 입원 후 투여를 시작하고 정기적으로 심전도 검사하고 이상반응 관찰. <br />∙이 약은 다른 부정맥용제를 사용할 수 없거나 무효한 경우에만 투여. <br />∙혈장 디곡신 농도를 약 15% 상승시키므로 이 약 투여 전후 디기탈리스 포화 환자는 혈장디곡신 농도를 측정. <br />∙이 약 장기투여로 시신경장애, 운동실조, 각막침착, 폐섬유증, 폐렴과 같은 부작용 보고됨.</td>
            </tr>
            <tr id="KDGERI_FLECAINIDE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙QT연장 유발약물 (예: 아스테미졸): (QT 연장, 심실성 부정맥 유발) <br />∙아미오다론, 시메티딘, 플루옥세틴 (이 약 혈장농도 상승) <br />∙디곡신 (혈장 디곡신 농도 상승) <br />∙리토나비어, 로피나비어, 인디나비어, 삼환계 항우울제, 클로자핀 (부정맥 위험)</td>
            </tr>
            <tr id="KDGERI_FLECAINIDE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>어지러움, 시력불선명 등의 시각장애, 조절장애, 호흡곤란, 심실빈맥, 전부정맥, 흉부불쾌감, 부종, 실신, 두통, 피로, 신경과민, 발열, 권태감, 운동실조, 이명, 불안, 불면증, 우울증, 발진, 오심, 변비, 복통, 식욕부진, 설사, 진전, 무기력, 복시, 수족마비감</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PROPAFENONE" data-drug-number="172">
          <thead>
            <tr>
              <th className="drug-number">172</th>
              <th className="drug-name">프로파페논(Propafenone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">부정맥용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PROPAFENONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구, 일반정]증후성상실성부정빈맥(WPW증후군 또는 발작성심방세동을 수반한 상실성빈맥, 방실접합부빈맥), 생명을 위협하거나 의사의 판단에 의해 치료가 필요한 심한 증후성심실성부정빈맥[경구, 서방캡슐]구조적 심장질환이 없고 증후성 심방 세동 병력이 있는 환자에서의 증후성 심방 부정맥의 재발시간 연장</td>
            </tr>
            <tr id="KDGERI_PROPAFENONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>심각한 구조적 심장 질환(좌심실 박출량 35% 미만인 울혈성 심부전 또는 심인성 쇼크, 브루가다증후군, 중증의 증후성 서맥, 심근경색 후 3달 이내, 심박출손상(심박출&lt;35%)로 생명을 위협하는 심실성 부정맥을 가지지 않는 환자), 동방결절 기능 장애, 심방내･심실내 전도장애, 2도 또는 고도의 방실블록, 각블록 또는 원위블록 환자(인공심박조율기 착용 제외), 동기능부전증후군(서맥-빈맥증후군), 중증 저혈압, 명백한 전해질평형실조(예, 칼륨대사장애), 중증 폐쇄성 폐질환, 중증 근무력증, 이 약 과민증, 리토나비어 투여</td>
            </tr>
            <tr id="KDGERI_PROPAFENONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구, 일반정] 1회 150mg씩 1일 3회 또는 1회 300mg씩 1일 2회1일 최대 투여량: 1일 900mg <br />[경구, 서방캡슐]초기용량: 1회 225mg씩 1일 2회최소 5일간 투여 후 1회 325mg씩 1일 2회까지 증량 가능1일 최대 투여량: 850mg</td>
            </tr>
            <tr id="KDGERI_PROPAFENONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers’ Criteria 해당 품목(노인 환자에게 심방세동의 1차 치료약으로 사용하지 않음) <br />∙고령자, 심근손상 병력, 간기능･신기능 부전 환자는 저용량에서 투여를 시작하여 주의해서 천천히 증량. <br />∙특히 고령자는 간･신기능 저하 또는 저체중 경향이 있으므로 입원시켜서 투여하고 자주 심전도 검사를 하고 환자 상태를 관찰하도록 함. <br />∙쓴 맛과 표면 마취작용이 있으므로 씹거나 부수지 말고 그대로 복용할 것. <br />∙QRS군의 유의한 연장, 2-3도 방실전도 차단이 발생한 경우 용량 감소 고려. <br />∙자동차 등 위험이 수반되는 기계 조작 활동 시 주의</td>
            </tr>
            <tr id="KDGERI_PROPAFENONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙QT연장 유발약물 (예: 아스테미졸): (QT 연장, 심실성 부정맥 유발) <br />∙국소마취제, 베타차단제, 삼환계 항우울제(부작용 상승) <br />∙사이클로스포린, 테오필린, 디곡신(병용약물의 혈중농도 상승) <br />∙와르파린(항응고효과 증가) <br />∙페노바르비탈, 리팜피신(이 약 혈중농도 저하) <br />∙리토나비어(이 약 혈중농도 상승)</td>
            </tr>
            <tr id="KDGERI_PROPAFENONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>협심증, 심실조동･세동, 빈맥, 전도장애, 실신, QRS 연장, 흉통, 서맥, 부종, 심방조동, 저혈압, 어지러움, 피곤함, 두통, 실신, 수면장애, 불안, 졸림, 발진, 오심, 구토, 쓴 맛이나 입의 마비, 변비, 소화불량, 설사, 구강건조, 식욕저하, 복부팽만감, 조화운동불능, 복통, 진전, 관절통, 무기력, 시야흐림, 호흡곤란, 발한</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_SOTALOL" data-drug-number="173">
          <thead>
            <tr>
              <th className="drug-number">173</th>
              <th className="drug-name">소타롤(Sotalol)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">부정맥용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_SOTALOL_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>증후성상실성부정빈맥(방실결절빈맥, WPW증후군 또는 발작성심방세동을 수반하는 상실성빈맥), 중증의 증후성심실성부정빈맥의 치료 및 예방</td>
            </tr>
            <tr id="KDGERI_SOTALOL_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>기관지천식,서맥(50회/분 이하), 방실블록(2, 3도), 동방결절블록, 선천성･후천성 QT연장증후군 환자(심박조율기 장치 제외), 심인성 쇼크, 비조절성 울혈성 심부전, 이 약 또는 설파제 과민증, 동기능부전증후군, 저혈압, 말초순환장애(레이노증후군)의 기왕력자, 대사성 산증 및 당뇨병성 케토산증, 베라파밀･딜티아젬 등의 칼슘길항제 투여, 아미오다론 투여</td>
            </tr>
            <tr id="KDGERI_SOTALOL_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙초기용량: 1회 40-80mg씩 1일 1-2회, 필요시 240-320mg까지 증량. <br />∙유지용량: 1일 160-320mg 2-3회 분할 투여<br />∙치명적인 불응성 심실성 부정맥 환자: 1일 480-640mg까지 투여 가능<br />∙중증신장애환자: 1/2(CrCl:10~30ml/min) 또는 1/4로 감량(CrCl:10ml/min 이하) <br />[주사제] <br />∙초기용량은 20mg을 5분에 걸쳐 IV후 20mg(1mg/분)을 천천히 추가 투여 가능<br />∙총 투여용량은 1.5㎎/kg 이하의 용량을 5-15분간에 걸쳐 투여</td>
            </tr>
            <tr id="KDGERI_SOTALOL_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers’ Criteria 해당 품목(노인 환자에게 심방세동의 1차 치료약으로 사용하지 않음) <br />∙베라파밀, 딜티아젬 등의 칼슘길항제 투여중인 환자에게 소타롤과 같은 β-차단제를 정맥투여하거나, β-차단제를 투여중인 환자에게 이러한 칼슘길항제를 정맥투여하는 것은 응급목적을 제외하고는 금기. <br />∙전해질평형이상을 보정하기 전에 저칼륨혈증, 저마그네슘혈증 환자에게는 투여하지 않음. 중증 또는 지속성 설사환자 및 이뇨제 병용투여시 주의.</td>
            </tr>
            <tr id="KDGERI_SOTALOL_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙아미오다론 (심한 서맥, 심정지, 심실성 빈맥) <br />∙칼슘길항제 (방실 차단, 좌심실부전) <br />∙페니토인 (CNS 또는 호흡 저하) <br />∙부정맥용제 (심장불응기 연장) <br />∙인슐린, 경구용 혈당강하제, 베타차단제 (저혈당, 고혈당 발생, 저혈당 은폐) <br />∙디곡신 (서맥, 디기탈리스 글리코사이드 독성증가) <br />∙바르비탈계, 마약류, 혈압강하제 (과도한 혈압강하) <br />∙돌라세트론, 히드록시클로로퀸, 아르제닉트리옥사이드, 도네페질, 이뇨제 (심장독성 유발 QT연장, 토르사드 드 포인트, 심정지) <br />∙딜티아젬, 베라파밀 (서맥, 저혈압)</td>
            </tr>
            <tr id="KDGERI_SOTALOL_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>방실차단, 심실성 빈맥, 토르사드 드 포인트, 서맥, QT연장, 울혈성심부전, 흉통, 심계항진, 피로, 어지러움, 두통, 무력증, 호흡곤란, 부종, ECG 이상, 저혈압, 심부전, 실신, 전구실신, 전부정맥,, 말초혈관장애, 심혈관장애, 혈관확장, 협심증, 고혈압, 졸음, 두통, 수면장애, 불안, 우울감, 감각이상, 냉감, 의식저하, 피부발진, 발한, 체중변화, 오심, 구토, 설사, 복통, 소화불량, 복부팽만, 장질환, 식욕이상, 비뇨생식기계장애, 성기능장애</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_DOXAZOSIN" data-drug-number="174">
          <thead>
            <tr>
              <th className="drug-number">174</th>
              <th className="drug-name">독사조신(Doxazosin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">혈압강하제기타의 비뇨생식기관 및 항문용약</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_DOXAZOSIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>고혈압, 양성전립선 비대에 의한 뇨폐색 및 배뇨장애</td>
            </tr>
            <tr id="KDGERI_DOXAZOSIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 저혈압, 장폐쇄, 식도폐쇄 병력, 상부요도 울혈, 만성 요도감염 또는 방광결석을 동반한 전립선 비대증, 수유부, 과잉방광, 무뇨, 진행성 신부전</td>
            </tr>
            <tr id="KDGERI_DOXAZOSIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구, 일반정] <br />∙초기용량: 1회 1mg씩 1일 1회<br />∙유지용량: 1-2주 간격으로 이전 투여량의 두 배로 증량<br /> - 고혈압 치료시 1일 최대투여량: 16mg<br /> - 양성전립선비대증 치료시 1일 최대투여량: 8mg <br />[경구, 서방정] <br />∙초기용량: 1회 4mg씩 1일 1회, 4주 후 8mg으로 증량 가능<br />∙1일 최대투여량: 8mg</td>
            </tr>
            <tr id="KDGERI_DOXAZOSIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers’ Criteria 해당 품목(노인의 경우 고혈압 치료 목적으로 사용은 가급적 삼감). <br />∙70세 이상 환자에서 독사조신 전신 노출 증가 등으로 저혈압 발생률 증가. <br />∙과도한 혈압강하로 인해 뇌경색 발생 위험이 증가할 수 있으므로 노인에서는 저용량에서 시작하여 천천히 증량함. <br />∙특히 알파차단제를 병용투여할 경우 기립성 저혈압 위험 증가. <br />∙초기 투여, 휴약 후 재투여, 용량 증가, 신부전, 다른 항고혈압약물 병용투여시 기립성 저혈압으로 인한 기절 및 낙상 위험이 증가하므로 투여 전 누운 자세-앉은 자세-선 자세로 체위별 혈압(3-position BP)을 측정하여 자율신경계 이상 여부를 평가할 것을 권고함. <br />∙구갈 및 비뇨기계 문제 등 유해반응이 노인에서 특히 문제됨. <br />∙서방정의 경우 씹거나 자르거나 분쇄하지 말고 그대로 복용할 것.</td>
            </tr>
            <tr id="KDGERI_DOXAZOSIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙PDE-5저해제(저혈압 유발) <br />∙혈압강하제(혈압강하 작용 촉진)</td>
            </tr>
            <tr id="KDGERI_DOXAZOSIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>현기증, 권태감, 피로, 두통, 부종, 저혈압, 기립성 저혈압, 심장 부정맥, 안면부종, 홍조, 심계항진. 졸음, 통증, 불안, 실조증, 항진, 불면, 성적 장애, 복통, 소화불량, 구강 건조증, 방광염, 근육통, 시야 혼탁. 기관지염</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PRAZOSIN" data-drug-number="175">
          <thead>
            <tr>
              <th className="drug-number">175</th>
              <th className="drug-name">프라조신(Prazosin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">혈압강하제기타의 비뇨생식기관 및 항문용약</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PRAZOSIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>고혈압, 울혈성심부전, 레이노병 및 레이노증후군, 양성전립선비대에 의한 배뇨장애</td>
            </tr>
            <tr id="KDGERI_PRAZOSIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 대동맥ㆍ승모판협착증, 폐색전증, 제한성 심막질환 같은 기계적 폐쇄에 의한 울혈성 심부전, 폐고혈압에 의한 만성 심부전, 12세 이하의 소아, 갈락토오스 불내성 등의 유전적인 문제</td>
            </tr>
            <tr id="KDGERI_PRAZOSIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>∙고혈압 ① 단독투여: 1회 0.5mg (취침시) 초회투여 후 1회 0.5-1mg씩 1일 2-3회 3-7일간 투여, 1일 최대 투여량: 20mg ② 병용투여: 1회 0.5mg (취침시) 초회투여 후 1회 0.5mg씩 1일 2-3회 ③ 신부전환자: 1회 0.5mg (취침시) 초회투여 후 신중히 증량<br />∙울혈성 심부전<br /> - 1회 0.5mg씩 1일 2-4회, 2-3일마다 용량 조절, 1일 최대 투여량: 20mg <br />∙레이노병 및 레이노증후군<br /> - 1회 0.5mg씩 1일 2회 3-7일간 투여, 1회 1-2mg씩 1일 2회까지 투여가능<br />∙양성전립선비대에 의한 배뇨장애<br /> - 1회 0.5mg씩 1일 2회 3-7일간 투여, 최대 1회 2mg씩 1일 2회까지 투여가능</td>
            </tr>
            <tr id="KDGERI_PRAZOSIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers’ Criteria 해당 품목(노인의 경우 고혈압 치료 목적으로 사용은 가급적 삼감). <br />∙고령자에서 과도한 혈압강하는 바람직하지 않음(뇌경색 등이 나타날 수 있음). <br />∙고령자는 저용량(1회 0.25mg 1일 2회)에서 투여를 시작하는 등 신중히 투여. <br />∙어지러움 등이 나타날 수 있으므로 낙상, 운전 및 기계조작 주의<br />∙기립성 저혈압이 나타날 수 있으므로 체위 변화에 의한 혈압변화를 측정하여 앉은 위치에서 혈압 조절. <br />∙음주, 장시간 서있기, 운동, 뜨거운 날씨 등은 어지러움, 실신, 두경감 등의 부작용을 증가시키므로 주의.</td>
            </tr>
            <tr id="KDGERI_PRAZOSIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙이뇨제, 혈압강하제, 마취약, 칼슘길항제, 바클로펜 (혈압강하작용 증가) <br />∙코르티코이드 (이 약의 작용 감소)</td>
            </tr>
            <tr id="KDGERI_PRAZOSIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>빈맥, 현기증, 두통, 어지러움, 쇠약, 오심, 무력감, 부종, 기립성 저혈압, 실신, 우울, 신경과민, 발진, 변비, 설사 구토, 구강 건조증, 빈뇨, 시야 흐림, 호흡곤란, 비충혈</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_DIGOXIN" data-drug-number="176">
          <thead>
            <tr>
              <th className="drug-number">176</th>
              <th className="drug-name">디곡신(Digoxin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">강심제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_DIGOXIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제, 주사제]울혈성심부전(폐부종, 심장천식 등 포함), 심방세동･조동에 의한 빈맥, 발작성심방성빈맥, 기타 심질환(심막염, 심근질환 등), 갑상선기능항진 증 및 저하증, 심부전 또는 각종 빈맥의 예방 및 치료</td>
            </tr>
            <tr id="KDGERI_DIGOXIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>방실블록(특히 애덤스-스토크스증후군), 동방블록, 경동맥동증후군, 디기탈리스 중독, 폐쇄성 심근병증(특발성 비대성 대동맥판하협착증 등), 심실빈맥, WPW증후군, 이 약 과민증</td>
            </tr>
            <tr id="KDGERI_DIGOXIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙급속포화요법(포화량: 1.0-4.0㎎): 1회 0.5-1.0㎎ 투여 후 1회 0.5㎎ q6-8hr <br />∙유지요법: 1회 0.25-0.5mg씩 1일 1회 투여<br />∙연령, 증상에 따라 적절히 증감(예, 고령자의 경우 성인용량의 1/2로 투여) <br />[주사제] <br />∙급속포화요법(포화량: 1.0-2.0㎎): 1회 0.25-0.5㎎씩 IV q2-4hr <br />∙유지요법: 1회 0.25㎎씩 1일 1회 IV <br />∙연령, 증상에 따라 적절히 증감(예, 고령자의 경우 성인용량의 1/2로 투여)</td>
            </tr>
            <tr id="KDGERI_DIGOXIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers’ Criteria 해당 품목. <br />∙고령자에 투여할 경우 부작용이 나타나기 쉬우므로 관찰을 충분히 하고 투여량을 신중히 결정. <br />∙심부전: 70세 이상인 경우 저용량(0.125mg 매일 또는 격일)으로 투여할 것(ACCF/AHA [Yancy, 2013]). <br />∙디지탈리스(Digitalis)류(특히 디곡신(digoxin))는 노인 심장 질환(울혈성심부전, 심방 세동 등) 치료에 흔히 사용되나, 노화로 인한 생리적 변화에 따라 독성 위험 높음. <br />∙체내분포용적 감소, 청소율 감소에 따른 반감기 증가, 이 약 대사에 영향 미치는 다른 약물 복용 등에 의한 영향 고려 필요. <br />∙갑상선기능 이상, 신기능 감소가 디곡신 제거에 영향 미칠 수 있음. <br />∙저산소증, 갑상선기능저하증, 급성심근염 환자에 투여시 신중해야 함. <br />∙중독증상(식욕부진, 구역, 구토, 설사, 부정맥, 시각장애, 어지러움, 두통)이 나타날 경우 감량하거나 휴약하는 등의 적절한 처치 필요.</td>
            </tr>
            <tr id="KDGERI_DIGOXIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙칼륨배설성 이뇨제, 아미오다론, 갑상선 제제 등(디지탈리스 중독 위험 증가) <br />∙콜레스티라민, 제산제, 페니토인, 리팜피신(이 약의 흡수 지연 또는 감소)</td>
            </tr>
            <tr id="KDGERI_DIGOXIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>어지러움, 두통, 식욕부진, 오심, 구토, 설사, 부정맥, 방실블록, 빈맥, 현저한 서맥</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_TICLOPIDINE" data-drug-number="177">
          <thead>
            <tr>
              <th className="drug-number">177</th>
              <th className="drug-name">티클로디핀(Ticlopidine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">기타의 혈액 및 체액용약</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_TICLOPIDINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>혈관수술 및 혈액체외순환에 따른 혈전･색전의 치료 및 혈류장애의 개선, 만성동맥폐색증에 따른 궤양, 동통 및 냉감 등 허혈성 제증상의 개선, 허혈성 뇌혈관 장애에 따른 혈전･색전의 치료, 뇌지망막하출혈 수술 후의 뇌혈관 연축에 따른 혈류장애의 개선, 관상동맥질환(협심증, 심근경색)에 따른 혈전･색전의 예방, 치료 및 허혈성 제증상의 치료, 관상동맥내 스텐트 삽입시술 후 아급성 혈전의 예방</td>
            </tr>
            <tr id="KDGERI_TICLOPIDINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>출혈(혈우병, 모세혈관 취약증, 소화관궤양, 요로출혈, 객혈, 초자체출혈 등), 중증 간장애, 조혈이상(백혈구감소증, 혈소판감소증 및 무과립구증)이나 혈전성혈소판감소성자반병 또는 재생불량성빈혈 병력, 이 약 과민증, 출혈하기 쉬운 병변(활성 십이지장궤양 또는 급성기에 있는 출혈성 뇌혈관 질환자), 출혈시간 연장 증상 포함하는 혈액질환, 출혈경향, 심한 간부전</td>
            </tr>
            <tr id="KDGERI_TICLOPIDINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>∙혈관수술 및 혈액체외순환에 따른 혈전･색전의 치료 및 혈류장애의 개선:<br /> - 1일 200-300mg, 2-3회 분할 투여<br />∙만성동맥폐색증에 따른 궤양, 동통 및 냉감 등 허혈성 제증상의 개선:<br /> - 1일 300-600mg, 2-3회 분할 투여<br />∙뇌지망막하출혈 수술 후의 뇌혈관 연축에 따른 혈류장애의 개선:<br /> - 1회 100mg씩 1일 3회<br />∙허혈성 뇌혈관 장애에 따른 혈전･색전의 치료, 관상동맥질환(협심증, 심근경색)에 따른 혈전･색전의 예방, 치료 및 허혈성 제증상의 치료:<br /> - 1회 250mg씩 1일 2회<br />∙관상동맥내 스텐트 삽입시술 후 아급성 혈전의 예방:<br /> - 1회 250mg씩 1일 2회. 스텐트 삽입전날 또는 삽입일부터 투여 시작.<br /> - 아스피린(1일 100-325mg)과 병용하여 최소 4~6주간 투여.</td>
            </tr>
            <tr id="KDGERI_TICLOPIDINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers’ Criteria 해당 품목(노인환자에게 사용하지 않음). <br />∙고령자는 조혈기능, 대사기능이 저하된 경우가 많고, 저체중 경향이 있으므로 소량으로 개시하고 환자의 상태를 관찰하며 신중 투여. <br />∙이 약 투여중에는 정기적으로(특히 투여 개시 후 3개월간) 혈액 및 간기능 검사를 하는 것이 권장됨. <br />∙심각한 중성구 감소의 위험이 있음. <br />∙중성구 감소 부작용: 환자 중 1~2.4%에서 첫 3주-3개월에 ANC 감소 나타남. 투여 중지하면 중성구의 수는 1-3주내에 정상화됨. <br />∙이 약물을 투여하기 전 항혈액응고제 또는 섬유소 용해제는 중단함. <br />∙심각한 간 질환자에게 사용을 권하지 않음. <br />∙출혈의 위험이 증가하는 환자 및 간질환, 신질환 환자에게 투여시 치명적인 혈액학적 부작용이 일어날 수 있으므로 신중 투여. <br />∙수술 예정이고, 항혈소판 효과가 필요치 않다면 수술(발치 포함) 10-14일전 이 약의 투여 중단.<br /><br />∙ 비스테로이드성 소염제, 항혈소판제, 항응고제, 혈전용해제(출혈 위험성 증가) <br />∙ 테오필린, 아미노필린(혈장 테오필린 농도 상승)</td>
            </tr>
            <tr id="KDGERI_TICLOPIDINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>순환기계</td>
            </tr>
            <tr id="KDGERI_TICLOPIDINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>∙ 바르비탈계 약물, 페니토인(병용 약물의 혈중농도 상승) <br />∙ 클로자핀(클로자핀의 부작용 증가) <br />∙ 밀나시프란, 플루옥세틴, 시탈로프람, 파록세틴, 벤라팍신, 둘록세틴(출혈 위험 증가) <br />∙ 앱시시맵(과다 출혈 유발) <br />∙ 오메가3지방산(항혈소판 효과 증가) <br />∙ 비타민 E(항혈소판 효과 증가)총 콜레스테롤의 상승, TG 상승, 설사, 현기증, 발진, 두드러기, 자반, 오심, 소화불량, 복통, 구토, 식욕부진, ALP 상승, 간기능검사 이상</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_FERROUSSULFATE" data-drug-number="178">
          <thead>
            <tr>
              <th className="drug-number">178</th>
              <th className="drug-name">황산제일철(Ferrous sulfate)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">무기질제제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_FERROUSSULFATE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>철 결핍성 빈혈의 예방 및 치료</td>
            </tr>
            <tr id="KDGERI_FERROUSSULFATE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 혈색소증, 헤모시데린 침착증, 철 이용장애(납 중독으로 인한 빈혈, 철불용성 빈혈, 지중해 빈혈, 만발성 피부 포르피린증), 비철결핍성 빈혈, 골수 부족에 의한 빈혈, 만성 용혈성 빈혈, 철 과잉증, 감염이나 종양에 의한 빈혈, 만성췌장염, 간경변</td>
            </tr>
            <tr id="KDGERI_FERROUSSULFATE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구, 서방정] 철로서 1회 80mg씩 1일 1-2회<br />[경구, 장용캡슐] 철로서 1회 100mg씩 1일 1회</td>
            </tr>
            <tr id="KDGERI_FERROUSSULFATE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙치료를 시작하기 전에 빈혈의 유형과 원인을 파악하고 이 약의 투여 여부 결정(만성질환에 의한 빈혈은 철분 복용이 유용하지 않을 수 있음). <br />∙투여 중 혈액검사를 실시하고 과량투여하지 않도록 주의. <br />∙제산제, 경구용 테트라사이클린, 인산염, 칼슘염제제와 함께 복용하지 말 것. <br />∙녹차, 홍차 등 탄닌 함유 차 및 우유･유제품과 함께 복용하지 말 것. <br />∙만성적 알코올 오남용은 철분 재흡수를 증가시키고, 철분과부하 유발. <br />∙아스코르빈산(비타민C) 200mg 이상과 함께 복용시 철분 흡수 증가.</td>
            </tr>
            <tr id="KDGERI_FERROUSSULFATE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙제산제, 양성자펌프억제제, 경구용 테트라사이클린, 인산염(철분 흡수 감소) <br />∙항알도스테론제, 트리암테렌(고칼륨혈증) <br />∙살리실산, 페닐부타존, 옥시펜부타존(두 약물의 효과 증강) <br />∙퀴놀론계열 항생제, 페니실라민, 콜레스티라민, 세프디니르, 레보도파, 레보티록신(병용약물의 혈중 농도 감소) <br />∙(철분 흡수 감소)</td>
            </tr>
            <tr id="KDGERI_FERROUSSULFATE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>변비, 흑변, 위장장애, 구역, 구토, 복부･위통증, 위경련, 설사, 요 변색, 치아 변색두드러기, 햇빛 노출시 피부 과민반응</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_SPIRONOLACTONE" data-drug-number="179">
          <thead>
            <tr>
              <th className="drug-number">179</th>
              <th className="drug-name">스피로노락톤(Spironolactone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">이뇨제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_SPIRONOLACTONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>고혈압(본태성, 신성등), 원발성알도스테론증, 저칼륨혈증, 심성부종(울혈성 심부전), 신성부종, 간성부종, 특발성부종</td>
            </tr>
            <tr id="KDGERI_SPIRONOLACTONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>무뇨, 급성 신부전, 중증의 신기능장애, 중증 간부전, 고칼륨혈증, 이 약 과민증, 애디슨병 또는 고칼륨혈증과 연관된 다른 상태</td>
            </tr>
            <tr id="KDGERI_SPIRONOLACTONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>1일 50-100mg 분할 투여</td>
            </tr>
            <tr id="KDGERI_SPIRONOLACTONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers’ Criteria 해당 품목(심부전이 있거나 크레아티닌청소율이 30 mL/min 미만인 노인 환자에게 1일 25 mg 용량을 초과하여 사용하지 않음). <br />∙고령자는 저용량(심부전의 경우 1일 25mg 이하)에서 투여를 시작하여 환자의 상태를 관찰하면서 신중히 투여하고, 투여를 중단할 경우 2-3일에 걸쳐 감량하고 중단함. <br />∙특히 심질환 환자 중 부종이 있는 고령자에서의 급격한 이뇨는 급속한 혈장량 감소, 혈액 농축을 초래하여 뇌경색 등의 혈전색전증 나타날 수 있음. <br />∙이 약은 칼륨보급성 약물 등과 병용시 고칼륨혈증을 초래할 수 있으므로 주의. <br />∙기립성 조절장애, 어지러움이 나타날 수 있으므로 낙상, 운전 및 기계조작 주의. <br />∙간장애 환자에서는 미세한 전해질 균형의 변화가 간성혼수를 유발할 수 있으므로 주의<br />∙심한 구토나 TPN 투여시 전해질 불균형 위험 증가</td>
            </tr>
            <tr id="KDGERI_SPIRONOLACTONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙다른 이뇨제, 혈압강하제(혈압강하작용 증가) <br />∙디곡신(디곡신 농도 증가) <br />∙카르베녹솔론(요저류) <br />∙메트포르민(젖산혈증 위험) <br />∙알코올, 바르비탈계 약물, 마약(기립성 저혈압 증가) <br />∙비스테로이드성 소염진통제(혈압강하작용과 이뇨작용 감소) <br />∙스타틴계열(스피로노락톤의 부작용, 독작용 증가 가능) <br />∙시프로플록사신(전신적)(스피로노락톤이 시프로플록사신에 의한 전신적인 부정맥 증가 가능) <br />∙헤파린(칼륨 저류 증가 가능) <br />∙듀록세틴, 레보도파(저혈압 유발 가능)</td>
            </tr>
            <tr id="KDGERI_SPIRONOLACTONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>다리경련, 전해질장애(저나트륨혈증, 고칼륨혈증, 대사성산증), 여성형 유방, 유방통, 폐경후 출혈, 성욕변화, 발기부전, 발열, 피부발진, 약물발진, 탈모, 다모증, 가려움, 두드러기, 식욕부진, 구역, 구토, 구갈, 위출혈, 위염, 설사 어지러움, 두통, 사지마비감, 신경과민, 불안, 운동실조, 졸음, 백혈구감소증, 간기능이상, 신기능 이상, 권태감, 심계항진, 유방암</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_NIFEDIPINE" data-drug-number="180">
          <thead>
            <tr>
              <th className="drug-number">180</th>
              <th className="drug-name">니페디핀(Nifedipine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">혈관확장제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_NIFEDIPINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구, 일반정]관동맥심질환(만성안정형협심증, 이형협심증), 고혈압(고혈압성발증 포함), 레이노병 및 레이노증후군[경구, 서방정]관동맥심질환(만성안정형협심증), 고혈압</td>
            </tr>
            <tr id="KDGERI_NIFEDIPINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 임부, 수유부, 심인성 쇼크, 불안정형 협심증, 저혈압, 중증 대동맥판협착증, 리팜피신 투여, 급성 심근경색(8일 이내), 직장절제수술 후 회장조루술을 받은 콕낭 환자(서방정에 한함)</td>
            </tr>
            <tr id="KDGERI_NIFEDIPINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구, 일반캡슐] <br />∙관상동맥질환: 1일 15-30mg<br /> - 1일 최대 투여량: 60mg, 관동맥성 경련: 1일 80-120mg <br />∙고혈압: 1회 10mg씩 1일 3회<br /> - 1일 최대 투여량: 60mg(1회 20mg씩 1일 3회)<br /> - 응급성 고혈압(고혈압성 발증): 1회 10-20mg, 1회 최대투여량: 30mg <br />[경구, 서방정]- 1회 30mg 또는 60mg씩 1일 1회 통상 7-14일간 투여하면서 용량 조절- 고혈압: 치료 시작시 20mg 또는 30mg 권장- 1일 최대 투여량: 120mg</td>
            </tr>
            <tr id="KDGERI_NIFEDIPINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers’ Criteria 해당 품목(노인환자에게 서방형이 아닌 제형을 사용하지 않음). <br />∙고령자는 투여시 저용량으로 시작하며, 환자 반응에 따라 주의깊게 투여, 유지용량은 젊은 환자보다 저용량일 수 있음. <br />∙초기 투여 후 또는 증량 후 30분 이내에 허혈성 흉통이 나타나는 경우 투여를 중지할 것(일반정에 한함). <br />∙간기능 장애 환자 투여시 주의깊은 모니터링과 감량 필요<br />∙협심증 발작 우려가 있는 경우 신속한 작용발현을 위해 캡슐을 씹어서 복용. <br />∙혈압강하작용으로 어지러울 수 있으므로 낙상, 운전 및 기계조작 주의. <br />∙이 약은 자몽주스와 함께 복용하지 말 것(적어도 투여 3일 이전에 섭취 중지) <br />∙서방정의 경우 씹거나 부수지 말 것. <br />∙고용량의 펜타닐 마취에 의한 수술시 적어도 36시간 이전에 이 약의 복용 중지(환자상태에 따라)</td>
            </tr>
            <tr id="KDGERI_NIFEDIPINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙클로피도그렐(항혈전효과 감소, 혈전성 질환 위험도 증가) <br />∙펜타닐(심한 저혈압 유발) <br />∙C3A4 유도제(이 약의 효과 감소) <br />∙타크로리무스(타크로리무스 농도 증가) <br />∙디곡신, 테오필린, 페니토인(혈중 농도 증가) <br />∙시메티딘, 라니티딘, 딜티아젬, 미카펀진(이 약 작용 증강) <br />∙퀴니딘, 인삼, 은행엽 제제(이 약의 부작용 증가) <br />∙항진균제(이 약의 혈중농도 증가)</td>
            </tr>
            <tr id="KDGERI_NIFEDIPINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>안면홍조, 말초부종, 어지러움, 두통, 오심, 허혈성 동통(특히 치료 초기나 용량 증가시), 심계항진, 기립성 저혈압, 심부전, 신경과민, 기분변화, 피로, 수면장애, 발열, 오한, 피부염, 가려움증, 두드러기, 발기부전, 설사, 변비, 경련, 복부팽만감, 잇몸증식, 근경련, 무기력, 염증, 관절경직, 시야 흐림, 기침, 비충혈, 호흡곤란, 발한</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ESTROGEN" data-drug-number="181">
          <thead>
            <tr>
              <th className="drug-number">181</th>
              <th className="drug-name">에스트로겐(Estrogen) 단일성분(Conjugate Estrogen, Estradiol, Estropipate, Ethinyl estradiol)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">난포호르몬 및 황체호르몬제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ESTROGEN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제] 성선기능저하증, 난소적출, 난소기능부전으로 인한 저에스트로겐증, 위축성 질염, 외음위축증, 갱년기장애, 기능성 자궁출혈, 골다공증, 폐경 후의 유방암 (증상완화용), 수술불능의 진행성 전립선암 (증상완화용) [주사제] 에스트로겐 결핍 증상의 치료(자연적 폐경 및 난소 절제술 후 폐경기 증상, 비뇨생식기관의 기능쇠퇴증상의 예방 및 치료, 골다공증의 예방 및 지연) [외용제] 자연적 또는 외과적 수술로 인한 폐경에 따르는 에스트로겐 결핍증상(안면홍조, 수면장애, 비뇨생식기위축, 정서장해, 골조직 상실)</td>
            </tr>
            <tr id="KDGERI_ESTROGEN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>유방암, 에스트로겐 의존성 종양(예, 자궁내막암, 자궁내막과형성), 임부, 진단되지 않은 비정상적인 자궁출혈, 정맥성･동맥성 혈전색전증, 혈전성정맥염, 뇌혈관 또는 관상동맥질환, 이 약 과민증, 중증 심 또는 신질환, 두빈-존슨증후군 또는 로터증후군, 급･만성 간질환, 자궁내막증식증(에스트로겐요법 단독요법), 눈의 혈관질환에 의한 부분적 또는 완전한 시각상실 및 복시, 전형적인 편두통, 뇌하수체 종양, 이(耳)경화증, 포르피린증, 결합조직염</td>
            </tr>
            <tr id="KDGERI_ESTROGEN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] <br />∙성선기능저하증: 1일 2.5-7.5mg 3주간 투여 후 1주 휴약<br />∙난소적출 및 난소기능부전: 1일 1.25mg 3주간 투여 후 1주 휴약<br />∙위축성 질염, 외음위축증, 갱년기장애: 1일 0.3-1.25mg 월경주기 제5일부터 3주간 투여 후 1주 휴약 또는 비주기적 투여<br />∙기능성 자궁출혈: 1일 0.625-3.75mg, 출혈이 멈출 때까지 투여, 이후 20일간 동일 용량을 투여<br />∙골다공증: 1일 0.625-1.25mg 3주간 투여 후 1주 휴약 또는 비주기적 투여<br />∙폐경 후의 유방암(경감용): 1회 10mg씩 1일 3회, 최소 3개월 동안 투여<br />∙수술불능의 진행성 전립선암(경감용): 1회 1.25-2.5mg씩 1일 3회 투여<br />∙갱년기 장애: 길초산에스트라디올로서 1회 1-2mg씩 1일 1회 투여<br />[주사제] 1회 1amp(=에스트라디올발레레이트 10mg)씩 2주마다 IM <br />[외용제, 패취] 1주일간 부착, 주 1회 교환<br />[외용제, 갤제] 1일 1.5g, 24-28일 동안 사용</td>
            </tr>
            <tr id="KDGERI_ESTROGEN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers’ Criteria 해당 품목(노인환자에게 전신으로 작용하는 경구제 또는 패취제 사용을 하지 않음. 질 건조증, 요로감염 등의 질 증상에 저용량의 국소형 제제를 사용함) <br />∙에스트로겐 대체요법(ERT) 또는 호르몬 대체요법(HRT)은 특정 암(유방암, 자궁내막암) 또는 심혈관계 질환, 정맥성 혈전색전증 질환의 위험성 가능성으로 치료목적 및 위험성에 따라 최소유효농도로 최단기간동안만 투여. <br />∙비정상적 자궁출혈의 경우 적절한 진단방법으로 종양검사를 하고, 출혈에 대한 병적요인이 없을 경우 용량 감소 또는 주기적 요법 실시하고 정기적인 산부인과 검사 실시. <br />∙에스트로겐 대체요법/호르몬 대체요법은 천식, 간질, 편두통, 당뇨병, 포르피린증, 전신홍반성루푸스(SLE), 간혈관종의 악화를 유발할 수 있음. <br />∙이전에 없던 편두통, 두통, 갑작스런 시력장애, 황달, 혈압상승, 간질성 발작이 증가하면 치료를 즉시 중지할 것. <br />∙겔제의 경우 자외선에 분해되므로 의복으로 가려지는 팔, 어깨, 허벅지 안쪽, 배 등에 적용.</td>
            </tr>
            <tr id="KDGERI_ESTROGEN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙CYP3A4 유도제, 억제제(약물 대사 변화) <br />∙혈당강하제(혈당강하작용 감소) <br />∙아스코르빅산 제제(이 약물의 혈중 농도 증가) <br />∙전신적 코르티코스테로이드 제제(병용 약물의 혈중 농도 증가) <br />∙NSAID(COX-2 inhibitor)(혈전 발생 증가) <br />∙테오필린(병용 약물의 혈중 농도 증가) <br />∙우르소디올(우소데옥시콜린산)(병용 약물의 치료 효과 저해)</td>
            </tr>
            <tr id="KDGERI_ESTROGEN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>두통, 편두통, 유방통, 복통, 설사, 질출혈, 요통, 관절통, 인후염, 부비동염, 정신우울증, 어지러움, 신경과민, 가려움증, 복부팽만감, 질염, 질분비물, 무기력, 사지경련, 기침, 고혈압, 두피탈모, 담즙저류, 담석증</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_TIBOLONE" data-drug-number="182">
          <thead>
            <tr>
              <th className="drug-number">182</th>
              <th className="drug-name">티볼론(Tibolone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">난포호르몬 및 황체호르몬제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_TIBOLONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>자연적인 또는 수술에 의한 폐경 이후의 홍조 또는 야간발한, 골절되기 쉬운 폐경 이후의 골다공증</td>
            </tr>
            <tr id="KDGERI_TIBOLONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>임산부, 수유부, 유방암, 에스트로겐 의존성 악성 종양, 진단되지 않은 질 출혈, 치료되지 않은 자궁내막 증식증, 정맥혈전색전증, 혈전발현성질환, 동맥 혈전색전증 질환력, 급성 간질환 또는 간질환 병력, 이 약 과민증, 포르피린증, 갈락토오스 관련 유전적 문제</td>
            </tr>
            <tr id="KDGERI_TIBOLONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>1회 2.5mg씩 1일 1회 (매일 동일한 시간에 복용)노년층에서 용량조절은 불필요</td>
            </tr>
            <tr id="KDGERI_TIBOLONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙이 약의 처방은 환자의 전반적인 위험성(뇌졸중, 유방암, 자궁내막암 등)을 평가하여 결정하며, 이러한 평가는 최소 연 1회 이루어져야 함. <br />∙뇌졸중 위험성의 기저치는 연령-의존도가 매우 높기 때문에 특히 60대 이상 여성은 뇌졸중의 위험성을 고려해야 함. <br />∙폐경 후 증상에 대한 치료시작 및 치료지속은 최소 유효용량으로 최단기간 시행. <br />∙나이에 따른 자연폐경을 경험한 여성들은 마지막 정상생리 이후 최소 12개월이 지난 다음에 이 약의 치료 시작. <br />∙에스트로겐은 체액 저류를 유발할 수 있으므로 심장이나 신장 기능이상이 있는 경우 주의. <br />∙65세 이후 복합 또는 에스트로겐만을 함유한 호르몬대체요법을 시작한 여성에서 치매위험이 증가 관련 증거 보고됨. <br />∙고지질혈증, 당조절 장애, 고혈압 환자에게 투여 주의</td>
            </tr>
            <tr id="KDGERI_TIBOLONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙와르파린(항응고제 효과 향상) <br />∙CYP3A4 유도약물(이 약의 대사 증강)</td>
            </tr>
            <tr id="KDGERI_TIBOLONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>정맥혈전색전증, 뇌혈관질환, 하복부 통증, 골반통, 음부소양증, 체중증가, 비정상적 자궁경부 세포 도말, 유방암, 유방압통, 자궁경부 이형성증, 질분비물, 자궁내막벽 두께 증가, 비정상적 체모증가, 폐경 후 출혈, 질출혈, 진균감염, 질 진균증, 담낭질환, 피부와 피하질환(기미, 다형홍반, 혈관성 자반병), 부종, 간기능 이상</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_GLIBENCLAMIDE" data-drug-number="183">
          <thead>
            <tr>
              <th className="drug-number">183</th>
              <th className="drug-name">글리벤클라미드(Glibenclamide) = 글리브라이드(Glyburide)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">당뇨병용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_GLIBENCLAMIDE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>제2형 당뇨병(식사요법, 운동요법으로 충분한 효과를 얻을 수 없는 경우에 한함)</td>
            </tr>
            <tr id="KDGERI_GLIBENCLAMIDE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>중증 케톤증, 당뇨병성 혼수 또는 전혼수, 제1형 당뇨병, 중증 간･신장･부신기능장애, 중증 감염증, 외상, 수술 전후, 위장장애, 이 약 성분 과민증, 임부, 수유부, 미코나졸이나 보센탄 투여, 췌장절제, 포르피린증</td>
            </tr>
            <tr id="KDGERI_GLIBENCLAMIDE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>초기용량: 1회 2.5mg씩 1일 1회 (신중투여 필요한 경우: 1회 1.25mg씩 1일 1회)유지용량: 1회 2.5-5mg씩 1일 1회1일 최대 투여량: 15mg(1일 용량 10mg 이상: 2회 분할투여)</td>
            </tr>
            <tr id="KDGERI_GLIBENCLAMIDE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers’ Criteria 해당 품목(장시간 작용형 설포닐유리아로 저혈당 위험이 크므로 노인환자에게 사용하지 않음). <br />∙고령자는 생리기능이 저하되어 있으므로 소량부터 투여를 시작하며, 정기적으로 검사를 실시하는 등 신중 투여. <br />∙중증의 지연성 저혈당을 일으킬 수 있으므로 저혈당증에 대한 주의와 예방책을 미리 알아두고, 낙상, 운전 및 기계조작 주의. <br />∙간･신기능장애가 있는 경우 대사나 배설이 저하되어 저혈당을 일으킬 수 있으므로 투여량, 투여간격에 주의. <br />∙베타차단제를 병용할 경우 저혈당의 증상을 은폐할 수 있으므로 주의</td>
            </tr>
            <tr id="KDGERI_GLIBENCLAMIDE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙보센탄(간효소치 상승) <br />∙CYP2C9 유도제, 저해제(약물 대사 변화) <br />∙이 약의 효과 증가 : α-글루코시다제 저해제, 인슐린, 쿠마린계, 살리실산계, 베타차단제, MAO저해제, 설파제, 비스테로이드성 소염진통제, 인슐린저항성개선제, 티아졸리디네디온, 피브레이트계, 아졸계 항진균제, ACE억제제, 시클로포스파미드, 테리플루노마이드, 시메티딘, 라니티딘<br />∙이 약의 효과 감소 : 코르티코이드, 갑상선호르몬제, 난포호르몬제, 티아지드계 이뇨제, 경구용 피임제, 칼슘차단제, 글루카곤, 효소유도제(바르비튜레이트, 리팜피신, 페니토인) 등<br />∙사이클로스포린(사이클로스포린 농도 증가) <br />∙와르파린(출혈위험 증가)</td>
            </tr>
            <tr id="KDGERI_GLIBENCLAMIDE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>저혈당, AST/ALT 상승, 간기능장애, 복통, 포만감, 구역, 가슴쓰림, 식욕부진, 설사, 변비, 홍반, 두드러기, 가려움, 광과민반응, 권태감, 어지러움, 졸음, 무과립구증, 용혈성빈혈, 시력저하, 부종, 저나트륨혈증, 담즙, 저류성 황달</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_INSULIN" data-drug-number="184">
          <thead>
            <tr>
              <th className="drug-number">184</th>
              <th className="drug-name">인슐린(Insulin), Sliding Scale (Aspart, Lispro, Glulisine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">당뇨병용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_INSULIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>인슐린 요법이 요구되는 당뇨병</td>
            </tr>
            <tr id="KDGERI_INSULIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>저혈당, 이 약 성분 과민증</td>
            </tr>
            <tr id="KDGERI_INSULIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>용량은 환자 혈당에 따라 개별적으로 결정식전 15분 이내 또는 식사 직후 SC 또는 CSII필요한 경우 전문 의료인에 의한 IV infusion 가능(바이알에 한함). <br />[Insulin lispro] ① 초기용량: 1회 2-20IU씩 식전 15분 이내 또는 식사 직후 SC 또는 CSII ② 유지용량: 지속형 인슐린 제제의 투여량을 포함하여 1일 4-100IU</td>
            </tr>
            <tr id="KDGERI_INSULIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers’ Criteria 해당 품목(sliding scale 요법으로 사용하지 않음) <br />∙인슐린 sliding scale 요법이란 혈당에 따라 인슐린 용량을 달리하여 short-acting insulin을 2-4시간마다 주사하는 것으로 저혈당 위험성 증가시킬 수 있음. <br />∙인슐린 슬라이딩은 속효성 인슐린을 2-4시간 마다 주사하는 것보다는 하루 3회 식전에 주사하여 식후 혈당을 조절하는 것으로 알려져 있음<br />∙고령자는 저혈당 발생에 취약하고 저혈당으로 인한 이차적인 문제가 발생할 위험이 높으므로 용량에 유의하여 정기적 검사 등 신중 투여 필요. <br />∙베타차단제 등 교감신경 차단제에 의해 저혈당 증후가 은폐될 수 있으므로 주의. <br />∙인슐린 과량투여는 특히 정맥 내 투여시 저혈당증과 저칼륨혈증을 야기할 수 있음. <br />∙신장애, 간장애 환자에서 감량 필요</td>
            </tr>
            <tr id="KDGERI_INSULIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙경구용 혈당강하제, 살리실산 유도체, 인슐린 저항성개선제, 항종양제, 쿠마린계 약제, ACE 저해제, ACEⅡ 저해제, MAO저해제, 삼환계항우울제 등(혈당강하작용 증가) <br />∙경구용 피임제, 티아지드계 이뇨제, 부신피질자극호르몬, 갑상선호르몬, 베타2 효현제 등(혈당강하작용 감소)</td>
            </tr>
            <tr id="KDGERI_INSULIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>저혈당, 주사부위 발적, 부종, 가려움, 호흡곤란, 구역, 복통</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_TESTOSTERONE" data-drug-number="185">
          <thead>
            <tr>
              <th className="drug-number">185</th>
              <th className="drug-name">테스토스테론(Testosterone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">남성호르몬제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_TESTOSTERONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제]남성 성선기능저하(유환관증), 조정기능장애에 의한 남성불임증, 남성 갱년기장애[주사제]남성의 일차성 및 이차성 성선기능저하증에 테스토스테론 대치치료여성의 폐경 후 전이성 유방암(경감용), 남성 성선기능저하증[외용제]내인성 테스토스테론의 부족 또는 결핍과 관련한 성인 남성 호르몬 대체요법.</td>
            </tr>
            <tr id="KDGERI_TESTOSTERONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>안드로겐 의존성 종양, 이 약 과민증, 중증 간기능 장애, 중증 심･신부전, 임부, 수유부, 사춘기 이전의 남성, 악성 종양의 경우에 고칼슘혈증</td>
            </tr>
            <tr id="KDGERI_TESTOSTERONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제]초회용량: 1일 120-160mg, 2-3주, 유지용량: 1일 40-120mg 음식과 함께 복용.고령자: 성인과 같은 반응에 도달하기 위해 더 적은 용량과 횟수로 가능<br />[주사제]테스토스테론운데카노에이트로서 1000mg씩 10-14주마다 IM여성의 폐경 후 전이성 유방암: 에난토산 테스토스테론으로서 250mg, 1-2주 IM남성의 성선기능저하증: 에난토산 테스토스테론으로서 250mg, 2-3주 IM <br />[외용제, 겔제] 1회 테스토스테론으로서 50mg씩 1일 1회 적용. <br />[외용제, 액제] 1회 테스토스테론으로서 60mg씩 1일 1회 적용.</td>
            </tr>
            <tr id="KDGERI_TESTOSTERONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers‘ Criteria 해당 품목. <br />∙남성 고령자는 안드로겐 의존성 종양(전립샘암 및 남성 유방암 등)이 잠재할 가능성이 있음. <br />∙고령자는 생리기능이 저하되어 있으므로 성인용량 보다 더 적은 용량과 횟수로 신중 투여하고 주기적으로 모니터링. <br />∙심･신질환, 암 골전이, 고령자, 전립선비대증, 고혈압, 편두통, 간질, 부종 환자는 신중 투여. <br />∙테스토스테론 제제 시판 후 조사에서 정맥혈전색전증이 보고된 바 있음.</td>
            </tr>
            <tr id="KDGERI_TESTOSTERONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙경구용 항응고제(와르파린)(항응고효과 증가) <br />∙리팜피신, 바르비탈계, 카르바마제핀, 페니토인(이 약 효과 감소)</td>
            </tr>
            <tr id="KDGERI_TESTOSTERONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>장기간 투여시 여성의 남성화(비가역적 음성 변화, 지루, 다모), 정자형성 억제, 뼈성숙의 가속화, 부종, 체액의 저류, 고혈압, 두통, 피로, 불면, 기분변화, 여드름, 다한증, 혈장 에스트라디올 농도 상승, 여성형 유방, 설사, 전립샘특이항원(PSA) 증가, 전립선비대, 전립선암, 사정장애, 적혈구 증가증</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_SOMATROPIN" data-drug-number="186">
          <thead>
            <tr>
              <th className="drug-number">186</th>
              <th className="drug-name">성장호르몬 Growth hormone 소마트로핀(Somatropin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">뇌하수체호르몬제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_SOMATROPIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>Two dynamic test에 의해 확인된 성장호르몬 결핍증을 가진 성인의 성장호르몬 대체 요법</td>
            </tr>
            <tr id="KDGERI_SOMATROPIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>당뇨병(당뇨병성 망막증), 악성종양, 골단폐쇄, 뇌하수체 기능 저하성 성장호르몬 분비감소를 일으키는 뇌종양에 의한 소인증, 이 약 과민증, 임부, 수유부, 심장절개나 복부수술, 다수의 사고성 외상 또는 급성 호흡부전증에 수반하는 합병증에 의한 중대한 급성 질환, 급성 호흡부전증, 크레솔 또는 글리세롤 과민증, 프라더-윌리증후군 환자 중 중증의 비만 또는 중증의 호흡기 장애</td>
            </tr>
            <tr id="KDGERI_SOMATROPIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>이상반응 발생 및 혈청 중 인슐린양성장인자(IGF-1) 농도에 따라 연령과 성별에 맞게 투여용량 적정화<br />∙지노트로핀: 1일 0.018IU(0.006mg) SC, 1일 최대 투여량: 0.036IU(0.012mg) <br />∙싸이젠: 1일 0.15-0.3mg SC, 1일 최대 투여량: 1mg <br />∙유트로핀: 0.125IU/kg(0.04mg) 주 6-7회 SC, 1주 최대 투여량: 0.25IU/kg(0.08mg) <br />∙노디트로핀노디렛: ① 유년기 개시형 결핍증: 0.2-0.5mg/day ② 성인기 개시형 결핍증: 1일 0.45-0.9IU(0.15-0.3mg) SC, 1일 최대 투여량: 3IU(1mg)</td>
            </tr>
            <tr id="KDGERI_SOMATROPIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers’ Criteria 해당 품목(뇌하수체 절제 후 성장호르몬 대체치료 이외의 목적으로 사용하지 않음) <br />∙최소 효과 용량을 사용하며, 지속적 부종 혹은 중증 이상감각의 경우 팔목터널증후군(carpal tunnel syndrome) 피하기 위해 감량 필요. <br />∙고령자에서 약품 활성이 더 민감하게 나타날 수 있으며, 이상반응 발현이 증가할 수 있으므로 투여 시 시작 용량 및 용량 증량 감소 고려. <br />∙심･신질환자, 당뇨병 가족력, 성장호르몬 결핍증을 포함한 내분비 장애환자의 경우 특히 신중 투여. <br />∙소마트로핀 제제 과량 투여 시 사망률 증가 위험에 관한 검토 중. 급성 과량 투여 시 혈당 저하, 연이어 혈당상승, 체액 저류 유발할 수 있음.</td>
            </tr>
            <tr id="KDGERI_SOMATROPIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙인슐린 및/혹은 경구 혈당 강하제(용량조절 필요) <br />∙경구용 에스트로겐(소마토트로핀 증량 필요) <br />∙코르티코이드, 성호르몬, 항전간제, 사이클로스포린(병용투여시 주의)</td>
            </tr>
            <tr id="KDGERI_SOMATROPIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>당불내성(당부하 장애/공복혈당 장애, 명백한 당뇨를 포함), 두개내압 항진, 심각한 당뇨병성 망막병증, 부종으로 나타나는 체액 저류, 관절통, 근육통, 팔목터널증후군, 감각이상으로 나타나는 신경 압박증상, 잠복된 중추성 갑상선기능저하증의 발현, 주사 부위 반응, 발진 및 지방 위축(드물게 전신 과민반응)</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_MEGESTROL" data-drug-number="187">
          <thead>
            <tr>
              <th className="drug-number">187</th>
              <th className="drug-name">메게스트롤(Megestrol)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항악성종양제, 여성호르몬제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_MEGESTROL_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구, 일반정제]암 또는 AIDS환자의 식욕부진, 악액질 또는 원인불명의 현저한 체중감소 치료, 재발성, 전이성, 수술이 불가능한 유방암 및 자궁내막암의 완화[경구, 현탁제]암 또는 AIDS환자의 식욕부진, 악액질 또는 원인불명의 현저한 체중감소 치료</td>
            </tr>
            <tr id="KDGERI_MEGESTROL_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 임부 또는 임신하고 있을 가능성 있는 여성, 수유부, 유산 예방 및 치료 필요, 갈락토오스 관련 유전적 문제(정제에 한함)</td>
            </tr>
            <tr id="KDGERI_MEGESTROL_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구, 일반정]유방암: 1회 40mg씩 1일 4회자궁내막암: 1일 40-320mg 분할투여암 또는 AIDS 환자의 식욕부진, 악액질, 체중감소: 1일 400-800mg, 1일 최대 투여량: 1일 1회 800mg <br />[경구, 현탁제]암 또는 AIDS 환자의 식욕부진, 악액질, 체중감소: 1일 400-800mg 1일 최대 투여량: 1일 1회 800mg</td>
            </tr>
            <tr id="KDGERI_MEGESTROL_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers’ Criteria 해당 품목(노인환자에게 사용하지 않음. 노인환자에서 혈전색전 발생 및 사망 위험 증가함). <br />∙체중감소의 치료는 치료 가능한 체중감소의 원인을 찾은 후 설정. <br />∙시판후 조사에서 혈전성 정맥염을 포함한 혈전색전증상과 폐색전증, 당불내성 보고된 바 있으므로 혈전색전질환의 병력이 있거나 당뇨병 환자는 신중히 투여. <br />∙이 약 장기 투여로 당뇨병 발병, 기존 당뇨병의 악화, 현성 쿠싱증후군, 호흡기 감염 위험성 증가 등이 나타날 수 있음. <br />∙여성 노인의 경우 질출혈이나 질분비물이 나타날 수 있음. <br />∙체중증가 효과가 미미하며, 제지방체중(lean body mass)보다는 주로 지방 증가. <br />∙노인 환자, 신장애 환자의 경우 용량 감소 및 모니터링이 필요함.</td>
            </tr>
            <tr id="KDGERI_MEGESTROL_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙항응고제(메게스트롤은 프로게스틴으로 혈액응고 촉진할 수 있으므로 신중하게 사용할 것, 용량조절 고려) <br />∙울리프리스탈(병용투여 피할 것)</td>
            </tr>
            <tr id="KDGERI_MEGESTROL_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>고혈압, 심근병증, 흉통, 부종, 말초부종, 두통, 불면, 비정상적 사고, 혼란, 경련, 우울, 피부발진, 탈모증, 고혈당, 무기력, 오심, 구토, 소화불량, 설사, 약시, 발열, 발기부전</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_CLEBOPRIDE" data-drug-number="188">
          <thead>
            <tr>
              <th className="drug-number">188</th>
              <th className="drug-name">클레보프리드(Clebopride)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">기타의 소화기관용약</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_CLEBOPRIDE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>구역, 구토, 위궤양, 위장신경증, 위염, 소화불량증, 과민성대장증후군(복통, 복부팽만감, 변비, 설사의 반복)</td>
            </tr>
            <tr id="KDGERI_CLEBOPRIDE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>위장출혈･폐색･천공, 신경이완제를 투여 받고 있는 만발성 운동장애, 갈락토오스 불내성 등의 유전적인 문제</td>
            </tr>
            <tr id="KDGERI_CLEBOPRIDE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>1회 0.68mg(클레보프리드로서 0.5mg)씩 1일 3회 식전 투여</td>
            </tr>
            <tr id="KDGERI_CLEBOPRIDE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙고령자는 부작용(추체외로증상 등)의 발현에 주의하고 환자 상태를 관찰하면서 신중하게 투여할 것. <br />∙진토작용에 의해 장폐색, 뇌부종 등에 의한 구토작용을 은폐할 수 있음. <br />∙졸릴 수 있으므로 낙상, 운전 및 기계조작 주의.</td>
            </tr>
            <tr id="KDGERI_CLEBOPRIDE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙메토클로프라미드(프로락틴 분비이상, 추체외로 증상) <br />∙페노티아진계, 항도파민약물(중추신경계 효과 증가) <br />∙디곡신, 시메티딘(병용약물의 효과 감소) <br />∙중추신경 억제성 항불안제, 수면제, 마취제, 알코올(진정작용) <br />∙항콜린성약물 및 마약류(소화관에 대한 이약의 효과 감소) <br />∙QT간격 연장 유발약물(QT 간격 임상적 변화)</td>
            </tr>
            <tr id="KDGERI_CLEBOPRIDE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>졸음, 초조감, 불면, 동요감, 입술 혀의 마비, 수족마비, 두통, 무기력, 진전, 구강경직, 근경직, 변비, 구역, 구갈감, 식욕부진, 공복감, 설사, 복통, 발진, 가려움증, 두드러기 유즙누출, GOT/GPT 상승, 탈력감, 권태감, 현기</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_DOMPERIDONE" data-drug-number="189">
          <thead>
            <tr>
              <th className="drug-number">189</th>
              <th className="drug-name">돔페리돈(Domperidone)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">기타의 소화기관용약</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_DOMPERIDONE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>오심, 구토 증상의 완화</td>
            </tr>
            <tr id="KDGERI_DOMPERIDONE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 위장관출혈, 기계적 폐쇄증 또는 천공, 프로락틴분비종양 환자(프로락틴선종), 강력한 CYP3A4 저해제 병용투여, QTc 간격 지연 약물 병용투여, 중등도-중증 간장애, 임부, 수유부, QTc와 같은 심장전도 간격 연장, 전해질 불균형(저칼륨혈증, 고칼륨혈증, 저마그네슘혈증), 심부전과 같은 심장 기저질환, 갈락토오스 관련 유전적 문제</td>
            </tr>
            <tr id="KDGERI_DOMPERIDONE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>1회 10mg(레보도파 투여시 5mg)씩 1일 3회 식전 투여1일 최대 복용량: 30mg일반적으로 투여기간은 최대 1주일을 초과하지 않도록 함.</td>
            </tr>
            <tr id="KDGERI_DOMPERIDONE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙고령자는 생리 기능이 저하되어 있으므로 감량하는 등 주의. 60세 이상 환자에게 투여시 복용 전 의사와 상담할 것. <br />∙심각한 심실부정맥이나 심장돌연사의 위험 증가 보고됨. 특히 60세 이상 환자에서 높게 나타남. <br />∙전해질 불균형과 서맥은 부정맥의 위험을 증가시킴. 관련 증상이나 징후가 보일 경우 투약을 중단하고 의사와 상의. <br />∙주로 간에서 대사되므로 간손상 환자 투여시 주의. <br />∙졸음, 어지러움, 휘청거림이 나타날 수 있으므로 낙상, 운전 및 기계조작 주의. <br />∙복부팽만, 속쓰림 등의 증상이나 심장문제가 있는 환자는 사용하지 않도록 함.</td>
            </tr>
            <tr id="KDGERI_DOMPERIDONE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙페노티아진계, 부티로페논계(추체외로 증상) <br />∙디곡신(중독증상 은폐, 디곡신 생체이용률 감소) <br />∙항콜린제 및 마약성 진통제(이 약의 효과 길항) <br />∙강력한 CYP3A4 억제제, QT간격 연장 유발약물(QT 간격 임상적 변화) <br />∙MAO 억제제 (고혈압 위기 가능성)</td>
            </tr>
            <tr id="KDGERI_DOMPERIDONE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>두통, 편두통, 구강 건조, 설사, 여성형 유방</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_LEVOSULPIRIDE" data-drug-number="190">
          <thead>
            <tr>
              <th className="drug-number">190</th>
              <th className="drug-name">레보설피라이드(Levosulpiride)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">기타의 소화기관용약</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_LEVOSULPIRIDE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>기능성소화불량으로 인한 다음 증상의 완화: 복부팽만감, 상복부불쾌감, 속쓰림, 트림, 구역, 구토</td>
            </tr>
            <tr id="KDGERI_LEVOSULPIRIDE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>임부, 수유부, 위장관 출혈, 기계적인 장애 또는 천공, 크롬친화세포종 환자, 이 약 과민증, 간질, 조병 상태 및 조울병의 조병단계, 악성유선병증 환자</td>
            </tr>
            <tr id="KDGERI_LEVOSULPIRIDE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>1회 25mg씩 1일 3회 식전 투여</td>
            </tr>
            <tr id="KDGERI_LEVOSULPIRIDE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙주로 신장으로 배설되나 고령자는 신기능이 저하되어 있는 경우가 많아 높은 혈장농도가 지속될 우려가 있으므로 이상반응(추체외로 증상 등)의 발현에 주의하고 용량 및 투여간격에 유의하는 등 신중히 투여<br />∙진토작용에 의해 장폐색, 뇌부종 등에 의한 구토작용을 은폐할 수 있음. <br />∙고혈압 환자는 신중 투여하고, 전해질 장애 유발 약물과 병용투여하지 않음.</td>
            </tr>
            <tr id="KDGERI_LEVOSULPIRIDE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙항콜린효능약, 마약 및 진통제(이 약의 길항효과) <br />∙디곡신(중독증상 은폐, 디곡신 생체이용률 감소) <br />∙메토클로프라미드(프로락틴 분비이상, 추체외로 증상) <br />∙QT간격 연장 유발약물(QT 간격 임상적 변화)</td>
            </tr>
            <tr id="KDGERI_LEVOSULPIRIDE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>진전, 혀의 꼬임, 초조감, 지연이상운동, 구갈, 속쓰림, 구역, 구토, 설사, 변비, 고혈압, 부정맥, 발진, 부종, 여성형유방증, 유즙분비과다, 성욕 증감, 추체외로증상</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_METOCLOPRAMIDE" data-drug-number="191">
          <thead>
            <tr>
              <th className="drug-number">191</th>
              <th className="drug-name">메토클로프라미드(Metoclopramide)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">기타의 소화기관용약</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_METOCLOPRAMIDE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제]항암화학요법 후 지연된 구역,구토 예방, 방사선요법 유발 구역･구토 예방, 구역･구토의 증상 치료[주사제]수술 후 구역.구토 예방, 방사선요법 유발 구역･구토 예방, 구역･구토의 증상 치료</td>
            </tr>
            <tr id="KDGERI_METOCLOPRAMIDE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>크롬친화세포종, 이 약 과민증, 위장관 출혈, 기계적 장폐색, 천공, 신경이완제 또는 메토플로프라미드 유발 지연성 이상운동증 병력, 간질, 파킨슨병, 레보도파 또는 도파민효능제 병용투여, 메트헤모글로빈혈증 또는 NADH 시토크롬 b5 결핍 병력</td>
            </tr>
            <tr id="KDGERI_METOCLOPRAMIDE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>비록 구토 또는 용량거부가 있었더라도 투여간격은 적어도 6시간 이상 권장<br />[경구, 일반정] 1일 10-30mg, 2~3회 분할투여, 식전 복용1일 최대 투여량: 30mg 또는 0.5mg/kg, 최대 권장치료기간: 5일<br />[경구, 서방정] 1회 15mg씩 1일 2회1일 최대 투여량: 30mg 또는 0.5mg/kg, 최대 권장치료기간: 5일<br />[주사제]수술 후 구역구토 예방: 10mg 단회 투여방사선요법 유발 구역구토 예방, 증상 치료: 10mg 단회 투여, slow IV 또는 IM 1일 최대 투여량: 30mg 또는 0.5mg/kg경구투여 가능하면 빠른 시간 내 경구투여로 변경 권장<br />∙노인: 신장 및 간기능, 전체적인 쇠약도에 근거하여 용량 감소 고려<br />∙말기 신장애 환자(CrCl≤15ml/min): 일일용량 75%까지 감소<br />∙중등도-중증 신장애 환자(CrCl 15-60ml/min): 일일용량 50%까지 감소<br />∙중증 간장애환자: 일일용량 50%까지 감소</td>
            </tr>
            <tr id="KDGERI_METOCLOPRAMIDE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers‘ Criteria 해당 품목(노인환자의 경우 위장관무력증 치료 목적 이외의 사용을 삼감). <br />∙장기 또는 고용량 사용시 지발성운동장애(tardive dyskinesia) 발생 위험 있음. 특히 여성노인과 장기 사용 환자는 위험하므로 3개월 이상 사용하지 않음. <br />∙약물중독, 장폐색, 뇌종양 등으로 인한 구토증상을 억제하여 진단이 지연될 수 있음. <br />∙정맥투여 후 순환허탈, 심각한 서맥, 심정지, QT 연장 등이 보고되었으므로 노인환자에게 정맥투여시 주의<br />∙졸음, 어지러움, 이상운동, 근긴장이상을 일으킬 수 있으므로 낙상, 운전 및 기계조작 주의.</td>
            </tr>
            <tr id="KDGERI_METOCLOPRAMIDE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>메토클로프라미드, 페노티아진계, 부티로페논계(추체외로 증상)디곡신(중독증상 은폐, 디곡신 생체이용률 감소)카르바마제핀(카르바마제핀의 혈중농도 상승)항콜린제 및 마약성 진통제(이 약의 효과 길항)알코올, 중추신경저하제(진정효과 증가)세로토닌성 약물(세로토닌증후군 위험성 증가)사이클로스포린(사이클로스포린의 생체이용률 증가)</td>
            </tr>
            <tr id="KDGERI_METOCLOPRAMIDE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>졸림, 추체외로증상, 권태감, 불안, 피로, 두통, 현기증, 오심, 구토, 설사, 무력증, 우울증, 특히 정맥주사 투여시 저혈압, 가슴통증</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_DICYCLOMINE" data-drug-number="192">
          <thead>
            <tr>
              <th className="drug-number">192</th>
              <th className="drug-name">디싸이클로민(Dicyclomine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">진경제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_DICYCLOMINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>위･십이지장궤양, 위염, 대장염, 담낭염, 게실염, 유문연축, 식도경련, 경련성 변비, 요로결석에서 나타나는 경련</td>
            </tr>
            <tr id="KDGERI_DICYCLOMINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>녹내장, 전립선비대에 의한 배뇨장애, 중증 심질환, 폐쇄성 요로질환, 위장관 폐색, 마비성 장폐색, 장의 무긴장증, 이 약 과민증, 6개월 이하 영아, 수유부, 중증 근무력증, 중증 궤양성 대장염, 거대결장, 역류성 식도염, 갈락토오스 불내성 등의 유전적 문제</td>
            </tr>
            <tr id="KDGERI_DICYCLOMINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>1회 10-20mg씩 1일 3-4회</td>
            </tr>
            <tr id="KDGERI_DICYCLOMINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers‘ Criteria 해당 품목(노인환자에게 단기간 사용 이외 사용을 삼감) <br />∙고령자는 이 약 투여로 항콜린작용에 의한 구갈, 배뇨장애, 변비, 안내압 항진 등의 부작용이 나타나기 쉬우므로 신중히 투여할 것. <br />∙시조절장애, 졸음 등이 나타날 수 있으므로 자동차 운전 등 기계 조작하지 않도록 주의.</td>
            </tr>
            <tr id="KDGERI_DICYCLOMINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙페노티아진계, 삼환계 항우울약, MAO저해제(항콜린작용 증강)</td>
            </tr>
            <tr id="KDGERI_DICYCLOMINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>어지러움, 구갈, 오심, 시각(조절)장애, 졸림, 신경과민, 무력감, 두통, 변비, 배뇨장애</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_SCOPOLAMINE" data-drug-number="193">
          <thead>
            <tr>
              <th className="drug-number">193</th>
              <th className="drug-name">스코폴라민(Scopolamine) = 히요신(Hyoscine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">진경제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_SCOPOLAMINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제], [주사제]위･십이지장궤양, 식도경련, 유문연축, 위염, 장염, 장산통, 경련성 변비, 기능성 설사, 담낭염, 담관염, 담석증, 담도이상운동증, 담낭절제후의 후유증, 요로결석, 방광염, 기능성설사, 기구삽입에 의한 요도방광경련, 월경곤란에서의 경련 및 운동기능 항진(단, 주사제의 경우 분만시 자궁하부 경련, 소화관의 엑스선 및 내시경 검사의 전처치에도 사용됨.) [외용제]멀미에 의한 구역･구토의 예방</td>
            </tr>
            <tr id="KDGERI_SCOPOLAMINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>녹내장, 전립선비대에 의한 배뇨장애, 유문협착 등 위장관의 기능적 협착, 마비성 장폐색, 중증 근무력증, 거대 결장, 빈맥, 중증 심질환, 이 약 과민증, 출혈성 대장염,</td>
            </tr>
            <tr id="KDGERI_SCOPOLAMINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 10-20㎎씩 1일 3-5회<br />[주사제] 1회 10-20㎎ SQ, IM, IV (단, 항응고제 투약 환자는 SC 또는 IV만 가능) <br />[외용, 패취제] 성인 1회 1매(최소 4시간 전 부착, 3일간 약효 지속)</td>
            </tr>
            <tr id="KDGERI_SCOPOLAMINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers‘ Criteria 해당 품목(노인환자에게 단기간 사용 이외 사용을 삼감) <br />∙고령자에서는 전립선비대를 수반하는 경우가 많으므로 신중 투여. <br />∙고령자는 전립선 비대증 초기일 경우 배뇨장애 증상이 나타나지 않을 수도 있으므로 신중 투여 필요. <br />∙항응고제 투여중인 환자는 근육주사 시 근육 내 혈종이 발생할 수 있으므로 피하주사 또는 정맥주사로 투여해야 함. <br />∙시조절장애, 졸음, 어지러움이 나타날 수 있으므로 운전 등 기계조작 피할 것. <br />∙시야장애와 두통이 나타날 경우 녹내장 가능성을 고려하여 진찰해야 함. <br />∙고령자, 대사질환, 간질환, 신질환 환자인 경우 외용제 사용 전 의사, 약사와 상의할 것. <br />∙감염성 설사, 울혈성 심부전, 부정맥, 궤양성 대장염, 갑상선기능항진증, 전립선 비대 환자는 가급적 투여를 피하고 부득이할 경우 신중 투여</td>
            </tr>
            <tr id="KDGERI_SCOPOLAMINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙페노티아진계, 삼환계 항우울제, 항히스타민제, 항정신병약(항콜린작용 증강) <br />∙메토클로프라미드 및 도파민길항제(위장관에 대한 약물 효과 감약) <br />∙베타 1 수용체 효능약(심박 증가 작용 증강)</td>
            </tr>
            <tr id="KDGERI_SCOPOLAMINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>산동, 모양근마비, 조절장애, 구강건조, 구갈, 구역, 구토, 변비, 배뇨장애, 뇨저류, 두통, 두중감, 심계항진, 빈맥, 혈압저하, 어지러움, 안면홍조, 발한장애, 이상고열</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_DIMENHYDRINATE" data-drug-number="194">
          <thead>
            <tr>
              <th className="drug-number">194</th>
              <th className="drug-name">디멘히드리네이트(Dimenhydrinate)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">진토제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_DIMENHYDRINATE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>멀미, 메니에르증후군, 방사선숙취에 의한 구역･구토･어지러움, 수술 후 구역･구토</td>
            </tr>
            <tr id="KDGERI_DIMENHYDRINATE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>MAO 저해제 투여, 디멘히드리네이트･염산메클리진･염산부톨리진 과민증, 전립선비대 등 배뇨장애, 협우각형 녹내장, 간질환자, 갈락토오스 관련 유전적 문제</td>
            </tr>
            <tr id="KDGERI_DIMENHYDRINATE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>1회 50mg씩 1일 3-4회예방목적: 30분-1시간 전 50-100mg 1일 최대 투여량: 200mg</td>
            </tr>
            <tr id="KDGERI_DIMENHYDRINATE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙고령자는 생리기능이 저하되어 있으므로 감량하는 등의 주의. <br />∙졸음, 어지러움, 시각장애 등이 나타날 수 있으므로 낙상, 운전 및 기계조작 주의. <br />∙발진, 광과민증이 나타날 경우 투여 중지.</td>
            </tr>
            <tr id="KDGERI_DIMENHYDRINATE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙중추신경억제제, 알코올(진정작용 증강) <br />∙아미노글리코시드 항생물질(난청 등 이상반응 은폐) <br />∙아트로핀(항콜린 부작용 증가) <br />∙MAO 저해제(항콜린 및 진정 효과 증가)</td>
            </tr>
            <tr id="KDGERI_DIMENHYDRINATE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>졸음, 두통, 두중감, 수족마비, 손가락진전, 어지러움, 시각장애, 불면, 지각이상, 발진, 광과민증, 가슴쓰림, 위통, 배뇨장애, 구갈, 피로감</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_MECLIZINE" data-drug-number="195">
          <thead>
            <tr>
              <th className="drug-number">195</th>
              <th className="drug-name">메클리진(Meclizine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">진토제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_MECLIZINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>멀미에 의한 구역･구토･어지러움, 미로염･메니에르증후군･방사선 숙취에 따르는 구역･구토･어지러움</td>
            </tr>
            <tr id="KDGERI_MECLIZINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>임부, 이 약(계열) 과민증, 협우각형 녹내장, 전립선비대 등 배뇨장애, 갈락토오스 관련 유전적 장애</td>
            </tr>
            <tr id="KDGERI_MECLIZINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>∙멀미에 의한 구역･구토･어지러움:<br /> - 1회 25-50mg씩 단회 투여(승차 1시간 전), 24시간마다 반복투여 가능<br />∙미로염･메니에르증후군･방사선 숙취에 따르는 구역･구토･어지러움:<br /> - 1회 25mg씩 1일 2-3회 투여, 1일 최대투여량: 75mg</td>
            </tr>
            <tr id="KDGERI_MECLIZINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙고령자는 생리기능이 저하되어 있으므로 감량하는 등 주의할 것. <br />∙천식환자는 신중히 투여하도록 함. <br />∙졸음이 나타날 수 있으므로 낙상, 운전 및 기계조작 주의.</td>
            </tr>
            <tr id="KDGERI_MECLIZINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙바르비탈계 약물, 알코올, 정신병 치료약, 진정제(중추신경억제작용 증강) <br />∙MAO저해제(항콜린 작용 연장)</td>
            </tr>
            <tr id="KDGERI_MECLIZINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>졸음, 위부불쾌감, 시각장애, 발진, 배뇨장애, 구갈, 피로</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_CIMETIDINE" data-drug-number="196">
          <thead>
            <tr>
              <th className="drug-number">196</th>
              <th className="drug-name">시메티딘(Cimetidine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">소화성 궤양용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_CIMETIDINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구, 일반정]위･십이지장궤양, 역류성식도염, 재발성궤양, 문합부궤양, 졸링거-엘리슨증후군, 급성위염 및 만성위염의 급성악화기에서의 위점막병변(미란, 출혈, 발적, 부종) 개선[경구, 서방정]위･십이지장궤양, 역류성식도염, 재발성궤양, 문합부궤양, 졸링거-엘리슨증후군[주사제]위･십이지장궤양, 역류성식도염, 졸링거-엘리슨증후군, 상부소화관출혈(소화성궤양, 급성스트레스궤양, 출혈성위염), 재발성궤양</td>
            </tr>
            <tr id="KDGERI_CIMETIDINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 도페틸라이드 투여 환자(주사제에 한함)</td>
            </tr>
            <tr id="KDGERI_CIMETIDINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구, 일반정] 1회 400mg씩 1일 2회 또는 1회 800mg씩 1일 1회(취침시) 또는1회 300mg씩 1일 4회1일 최대 투여량: 1.6g(1회 400mg씩 1일 4회)신기능부전 환자: 1회 300mg씩 1일 2회, 필요시 1회 300mg씩 1일 3회<br />[경구, 서방정] 1회 700mg씩 1일 1회(취침시) 또는 1회 350mg씩 1일 2회장기투여시 1회 350mg씩 1일 1회<br />[주사제] 1회 200mg씩 4-6시간마다 정맥주사 또는 점적 정맥주사1일 최대 투여량: 2g 점적 정맥주사시 최대주입속도: 150mg/hr 또는 2mg/kg/hr 미만계속적 점적 정맥주사시 평균주입속도: 75mg/hr 미만</td>
            </tr>
            <tr id="KDGERI_CIMETIDINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙고령자는 신기능이 저하되어 있는 경우가 많으므로 감량하여 투여 간격을 연장하는 등 신중히 투여할 것. <br />∙고령자, 만성 폐질환자, 당뇨병 환자 또는 면역력이 약한 환자의 경우 지역사회획득폐렴(CAP)으로 발전할 수 있는 위험성 증가. <br />∙신기능 장애시 혈중농도가 지속되므로 투여량을 감소하거나 간격을 늘림. <br />∙고령자 또는 신부전 등의 중증질환자는 드물게 가역성의 착란 상태(초조, 정신병, 우울, 흥분, 환각, 방향상실)가 쉽게 나타날 수 있으므로 주의할 것. <br />∙혈액 투석은 혈중 시메티딘 농도를 낮춤. 혈액 투석이 끝나고 스케줄에 따라 약물을 다시 투여함. <br />∙심각한 간질환시 중추신경계 독성 증가 우려로 감량을 고려할 수 있음. <br />∙본 약물은 위궤양에서 1차 약제로 고려되지 않으며, H.pylori 감염이 동반되었을 경우 제균요법 병합투여 필요함.</td>
            </tr>
            <tr id="KDGERI_CIMETIDINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>와르파린, 미다졸람, 디아제팜, 클로르디아제폭시드, 프로프라놀롤, 테오필린, 페니토인, 리도카인, 니페디핀, 삼환계 항우울제, 메트로니다졸, 에리트로마이신(CYP 억제로 CYP에 의해 대사되는 약의 혈중농도 증가)</td>
            </tr>
            <tr id="KDGERI_CIMETIDINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>두통, 어지러움, 섬망, 동요, 여성형유방, 설사, 저혈압, 서맥, 요저류, 발진</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_CLIDINIUMCHLORDIAZEPOXIDE" data-drug-number="197">
          <thead>
            <tr>
              <th className="drug-number">197</th>
              <th className="drug-name">클리디늄/클로르디아제폭시드(Clidinium/Chlordiazepoxide)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">정신신경용제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_CLIDINIUMCHLORDIAZEPOXIDE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>정신신체장애(위･십이지장 궤양, 과민성 대장증후군 등)</td>
            </tr>
            <tr id="KDGERI_CLIDINIUMCHLORDIAZEPOXIDE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>급성 협우각형 녹내장, 중증 근무력증, 전립선비대, 양성 담낭경부 폐쇄, 이 약 과민증, 중증 호흡부전</td>
            </tr>
            <tr id="KDGERI_CLIDINIUMCHLORDIAZEPOXIDE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>∙성인: 증세의 경중에 따라 1일 3-4정<br />∙고령자 및 쇠약 환자: 1일 1-2정으로 시작, 최적유효량까지 점차 증량</td>
            </tr>
            <tr id="KDGERI_CLIDINIUMCHLORDIAZEPOXIDE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers’ Criteria 해당 품목(clindinium: 노인환자에게 단기간 사용 이외 사용을 삼감; chlordiazepoxide: 노인환자의 불면증, 동요증, 섬망 치료 목적으로 모든 벤조디아제핀의 사용을 삼감) <br />∙고령자는 운동실조 등의 부작용이 나타나기 쉬우므로 소량부터 신중 투여. <br />∙심･간･신장애 환자, 뇌의 기질적 장애, 중등도 호흡부전, 우울증 환자는 신중히 투여할 것. <br />∙치료 도중 의존성이 나타날 수 있으므로 가능한 한 단기간 동안만 투여. <br />∙갑작스러운 투여중지를 피하고 점차적으로 감량하여 투여. <br />∙장기간 투여시 혈구수 및 간기능 검사 실시 권장. <br />∙졸음, 주의력･집중력･반사운동능력 등의 저하가 나타날 수 있음. <br />∙과도한 진정 부작용으로 인한 낙상, 사고에 주의<br />∙노인환자에게 1차 약제로 추천되지 않으며, 부득이하게 투여시 최저용량부터 시작하여 필요시 점차적으로 증량함. 최저 용량에서도 심각한 부작용이 나타날 수 있으므로 주의 필요.</td>
            </tr>
            <tr id="KDGERI_CLIDINIUMCHLORDIAZEPOXIDE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙중추신경억제제, MAO저해제, 시메티딘, 염산마프로틸린(이 약 효과 증강) <br />∙단트롤렌나트륨(근이완작용 증강) <br />∙디설피람(이 약 혈중 농도 증가) <br />∙벤조디아제핀계 약물과 디곡신 병용투여시 디곡신의 신배설 감소</td>
            </tr>
            <tr id="KDGERI_CLIDINIUMCHLORDIAZEPOXIDE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>졸림, 착란, 운동실조, 항콜린 부작용, 구갈, 변비, 오심</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_BISACODYL" data-drug-number="198">
          <thead>
            <tr>
              <th className="drug-number">198</th>
              <th className="drug-name">비사코딜(Bisacodyl)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">하제, 완장제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_BISACODYL_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제]급만성 변비, 수술, 분만전후 및 X-선 촬영시 장내 분변제거, 임신부변비, 결장조루수술 후 배변[외용제]급만성 변비, 수술, 분만전후 및 X-선 촬영시 장내 분변제거</td>
            </tr>
            <tr id="KDGERI_BISACODYL_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>복통, 구역, 구토 또는 기타 급성 복부질환(충수염, 장출혈, 궤양성 결장염 등), 장마비, 장폐색, 경련성 변비, 중증의 경결변, 급성 복부수술상태, 항문 열창, 급성 장염, 임부, 수유부, 심한 탈수상태, 트리아밀메탄류 과민증</td>
            </tr>
            <tr id="KDGERI_BISACODYL_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 10~15mg씩 1일 1회 (취침전) <br />[외용, 좌제] 1회 10mg씩 1일 1회 (필요시 항문에 삽입)</td>
            </tr>
            <tr id="KDGERI_BISACODYL_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙고령자는 생리기능이 저하되어 있으므로 감량하는 등 주의. <br />∙장용성 경구제인 경우 장용성 코팅을 보호하기 위하여 우유 혹은 유제품과 같이 복용하지 않도록 함(복용 시 적어도 1시간 시간 간격을 두도록 함) <br />∙이 약 투여 후 직장출혈 또는 배변 실패할 경우 투여 중지 후 전문가와 상의. <br />∙장기간 계속 사용시 전해질 불균형 및 반동성 변비증상이 나타날 수 있음.</td>
            </tr>
            <tr id="KDGERI_BISACODYL_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙이뇨제, 부신피질호르몬제(전해질불균형에 따른 강심배당체 감수성 증가) <br />∙제산제（대장에서의 약물 방출을 지연시킴. 복부불편감 유발)</td>
            </tr>
            <tr id="KDGERI_BISACODYL_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>복부불쾌감, 설사, 복통, 구역, 구토, 배뇨감, 두통, 요통, 어지러움</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_ALFUZOSIN" data-drug-number="199">
          <thead>
            <tr>
              <th className="drug-number">199</th>
              <th className="drug-name">알푸조신(Alfuzosin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">기타의 비뇨생식기관 및 항문용약</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_ALFUZOSIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>양성 전립선비대증의 기능적 증상의 치료, 양성 전립선 비대증과 관련된 급성 요폐에서 카테터에 대한 보조 요법</td>
            </tr>
            <tr id="KDGERI_ALFUZOSIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 기립성 저혈압, 간기능부전, 심한 신기능부전(CrCl&lt;30ml/min), 장폐색, 다른 알파차단제 복용</td>
            </tr>
            <tr id="KDGERI_ALFUZOSIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>∙양성 전립선 비대증1회 10mg씩 1일 1회 (저녁식사 직후) <br />∙급성 요폐 카테터 보조요법1회 10mg 씩 1일 1회. 삽입 첫날부터 식사 후 복용카테터 삽입 2-3일간 복용, 카테터 제거 후 1일 복용. 총 3-4일간 복용</td>
            </tr>
            <tr id="KDGERI_ALFUZOSIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙일부 환자, 특히 항고혈압제를 투여 받고 있는 환자에 있어 이 약 투여 후 처음 몇 시간 이내에 기립성 저혈압 발생할 수 있으며, 증상이 완전히 사라질 때까지 누워 있도록 함. <br />∙투여 초기 현기증, 어지럼증, 무력증 등이 나타날 수 있으므로 낙상, 운전 및 기계조작 주의. <br />∙선천성 또는 후천성 QT 연장 환자나 QT 간격을 연장시키는 약물을 복용중인 경우 신중히 투여. <br />∙씹거나 자르거나 분쇄하지 말고 그대로 복용할 것. <br />∙수술 중 홍채이완 증후군이 발생할 수 있으므로 안과 수술 전 알파차단제 복용을 의사에게 미리 알릴 것.</td>
            </tr>
            <tr id="KDGERI_ALFUZOSIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙프라조신, 우라피딜, 미녹시딜 등의 알파차단제(기립성 저혈압 초래) <br />∙항고혈압제, 질산염제제(항고혈압 효과 증가) <br />∙강력한 CYP3A4 억제제(이 약 혈중농도 증가)</td>
            </tr>
            <tr id="KDGERI_ALFUZOSIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>어지러움, 피로, 두통, 통증, 오심, 복통, 소화불량, 변비, 발기부전, 상부 호흡기계 감염, 기관지염, 부비동염, 인두염</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_SILODOSIN" data-drug-number="200">
          <thead>
            <tr>
              <th className="drug-number">200</th>
              <th className="drug-name">실로도신(Silodosin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">기타의 비뇨생식기관 및 항문용약</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_SILODOSIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>전립선비대증에 수반하는 배뇨장애</td>
            </tr>
            <tr id="KDGERI_SILODOSIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 중증의 신장해 환자(CCr&lt;30mL/min), 중증의 간장해 환자(Child-Pugh score≥10), 강력한 CYP3A4 저해제(예: 케토코나졸, 클래리스로마이신, 이트라코나졸, 리토나비어) 복용</td>
            </tr>
            <tr id="KDGERI_SILODOSIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>1회 4mg씩 1일 2회 (아침 저녁 식후) 또는 1회 8mg 1일 1회 식사와 함께 투여</td>
            </tr>
            <tr id="KDGERI_SILODOSIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙기립성 저혈압, 간기능, 신기능 장애 환자에 신중히 투여할 것. <br />∙PDE5 저해제 또는 다른 알파-차단제를 복용하고 있는 환자에 신중히 투여할 것. <br />∙기립성 저혈압이 발생할 수 있으므로 체위 변화에 따른 혈압변화에 주의<br />∙이 약을 투여하기 전에 혈압강하제의 복용여부를 확인하여야 하며, 혈압강하제를 복용한 경우에는 혈압변화에 주의하고 혈압저하가 나타날 경우에는 감량 또는 투여중단 등 적절한 처치 필요. <br />∙투여 초기 현기증, 어지럼증, 무력증 등이 나타날 수 있으므로 낙상, 운전 및 기계조작 주의.</td>
            </tr>
            <tr id="KDGERI_SILODOSIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙강력한 CYP3A4 억제제(이 약 혈중농도 증가) <br />∙혈압강하제(기립성 저혈압 초래) <br />∙알파차단제(기립성 저혈압 초래) <br />∙PDE5 저해제(혈압 강하 작용 증가) <br />∙강력한 P-Glycoprotein 저해제(예.사이클로스포린)(실로도신의 혈장농도 상승)</td>
            </tr>
            <tr id="KDGERI_SILODOSIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>역행성 사정, 기립성 저혈암, 어지러움, 두통, 불면증, 설사, 복통, 전립선특이항원 증가, 무기력증, 콧물, 비충혈, 부비동염</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_SOLIFENACIN" data-drug-number="201">
          <thead>
            <tr>
              <th className="drug-number">201</th>
              <th className="drug-name">솔리페나신(Solifenacin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">기타의 비뇨생식기관 및 항문용약</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_SOLIFENACIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>절박성 뇨실금, 빈뇨, 요절박과 같은 과민성방광 증상의 치료</td>
            </tr>
            <tr id="KDGERI_SOLIFENACIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>요저류, 중독성 거대결장 포함한 중증의 위장관 상태, 중증 근무력증, 협우각 녹내장, 이 약 과민증, 혈액투석, 중증 간장애(Child-Pugh 등급C), 중증 신장애 또는 중등도 간장애환자이면서 강력한 CYP3A4 저해제(예: 케토코나졸) 투약, 갈락토오스 불내성 등의 유전적 문제</td>
            </tr>
            <tr id="KDGERI_SOLIFENACIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>1회 5mg씩 1일 1회 투여1일 최대 투여량: 1일 1회 10mg <br />∙중증 신장애환자(CrCl≤30ml/min): 1일 1회 5mg 초과하지 않음<br />∙중등도 간장애환자((Child-Pugh 등급B): 1일 1회 5mg 초과하지 않음<br />∙강력한 CYP3A4 저해제 투여 환자: 1일 1회 5mg 초과하지 않음</td>
            </tr>
            <tr id="KDGERI_SOLIFENACIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙만성 변비가 있는 경우 항콜린 효과로 변비가 악화될 수 있음<br />∙강한 쓴 맛 및 국소 자극성이 있으므로 부수거나 쪼개지 말고 충분한 물과 함께 그대로 복용할 것. <br />∙QT연장 증후군, 고칼륨혈증 등의 위험요인이 동반된 환자에서 QT연장 및 다형심실성빈맥이 관찰되었음. <br />∙시야흐림, 졸림, 피로가 나타날 수 있으므로 낙상, 운전 및 기계조작 주의<br />∙이 약의 최대효과는 4주 후에 나타남. <br />∙심각한 간장애환자에게 투여는 권장하지 않음. <br />∙옥시부티닌이나 톨테로딘에 비하여 구갈 등의 부작용이 적음</td>
            </tr>
            <tr id="KDGERI_SOLIFENACIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙항콜린성 약물(항콜린 효과 증가) <br />∙위장운동조절제(길항작용) <br />∙CYP3A4 저해제(이 약 대사 감소) <br />∙히드록시클로로퀸, 도네페질, 케토코나졸(QT 간격 연장)</td>
            </tr>
            <tr id="KDGERI_SOLIFENACIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>구강건조, 변비, 부종, 고혈압, 피로, 우울증, 소화불량, 오심, 상복부통증, 요로감염, 요저류, 시야흐림, 안구건조, 기침, 인플루엔자, QT간격 연장, 장폐색, 불면</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_TAMSULOSIN" data-drug-number="202">
          <thead>
            <tr>
              <th className="drug-number">202</th>
              <th className="drug-name">탐술로신(Tamsulosin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">기타의 비뇨생식기관 및 항문용약</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_TAMSULOSIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>양성 전립샘비대증에 따른 배뇨장애</td>
            </tr>
            <tr id="KDGERI_TAMSULOSIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 기립성 저혈압, 중증 간장애, 임부 또는 임신하고 있을 가능성이 있는 여성</td>
            </tr>
            <tr id="KDGERI_TAMSULOSIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 0.2mg씩 1일 1회 식후에 투여</td>
            </tr>
            <tr id="KDGERI_TAMSULOSIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙중증 신장애 환자, 고령환자, 배뇨실신 병력이 있는 환자에게 신중히 투여할 것. <br />∙PDE5 저해제, CYP3A4 억제제, 혈압강하제, 알파-차단제를 투여중인 환자에게 신중히 투여할 것. <br />∙기립성 저혈압이 발생할 수 있으므로 체위 변화에 따른 혈압변화에 주의<br />∙투여 초기 현기증, 어지럼증, 무력증 등이 나타날 수 있으므로 낙상, 운전 및 기계조작 주의.</td>
            </tr>
            <tr id="KDGERI_TAMSULOSIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙혈압강하제(기립성 저혈압 초래) <br />∙PDE5 저해제(혈압 강하 작용 증가) <br />∙시메티딘(청소율과 AUC 변화) <br />∙강력한 CYP3A4 또는 CYP2D6 억제제(이 약 혈중농도 증가)</td>
            </tr>
            <tr id="KDGERI_TAMSULOSIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>기립성 저혈암, 어지러움, 두통, 사정부전, 감염, 코막힘, 졸음, 불면, 현기증, 성욕저하, 설사, 구역, 구토, 무기력증, 등통증, 시야흐림, 인두염, 비염</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_TERAZOSIN" data-drug-number="203">
          <thead>
            <tr>
              <th className="drug-number">203</th>
              <th className="drug-name">테라조신(Terazosin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">기타의 비뇨생식기관 및 항문용약</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_TERAZOSIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>고혈압(경증-중등도), 양성전립선 비대에 의한 배뇨장애</td>
            </tr>
            <tr id="KDGERI_TERAZOSIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 또는 알파차단제 과민증, 12세 이하 소아</td>
            </tr>
            <tr id="KDGERI_TERAZOSIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>초회용량: 1회 1mg씩 1일 1회 (취침전)유지용량: ① 고혈압: 1회 2-10mg씩 1일 1회, 1주 간격으로 2배 증량 가능(1일 최대투여량: 20mg) ② 전립선비대: 1회 5-10mg씩 1일 1회</td>
            </tr>
            <tr id="KDGERI_TERAZOSIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers’ Criteria 해당 품목(노인의 경우 고혈압 치료 목적으로 사용은 가급적 삼감). <br />∙고령자에서 과도한 혈압강하는 바람직하지 않음(뇌경색 등이 나타날 수 있음). <br />∙고령자는 저용량(1회 0.25mg 1일 2회)에서 투여를 시작하는 등 신중히 투여. <br />∙알파차단제 복용 환자에서 백내장 수술 중 ‘수술 중 홍채이완증후군(IFIS)’ 관찰. <br />∙중증의 간, 신기능장애 환자 신중히 투여<br />∙기립성 저혈압, 기절발작, 의식상실, 심근경색, 뇌혈관장애, 일과성 허혈발작, 협심증, 위궤양, 알코올중독, 기타 간질환, Ⅲ,Ⅳ급 고혈압성 망막증, 인슐린 의존성 당뇨병 등의 질환이 있거나 병력이 있는 환자<br />∙초회 투여 또는 투약누락 후 요법 재개시 어지러움, 기립성 조절장애, 심계항진, 두통, 졸음이 나타날 수 있으므로 낙상, 운전 및 기계조작 주의.</td>
            </tr>
            <tr id="KDGERI_TERAZOSIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙혈압강하제(혈압강하작용 증가)</td>
            </tr>
            <tr id="KDGERI_TERAZOSIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>어지러움, 관절쇠약, 말초부종, 기립성 저혈압, 심계항진, 빈맥, 실신, 졸음, 오심, 체중증가, 발기부전, 성욕감퇴, 시각장애, 비충혈, 호흡곤란, 부비동염, 손발저림, 근육통</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_TOLTERODINE" data-drug-number="204">
          <thead>
            <tr>
              <th className="drug-number">204</th>
              <th className="drug-name">톨테로딘(Tolterodine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">기타의 비뇨생식기관 및 항문용약</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_TOLTERODINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>절박뇨, 빈뇨 또는 절박성 요실금과 같은 증상의 과활동성 방광의 치료</td>
            </tr>
            <tr id="KDGERI_TOLTERODINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>요폐, 위정체, 협각녹내장, 이 약 과민증, 중증 근무력증, 중증 궤양성 대장염, 중독성 거대결장</td>
            </tr>
            <tr id="KDGERI_TOLTERODINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구, 서방정/캡슐] 1회 4mg씩 1일 1회, 이상반응 발현시 1회 2mg씩 1일 1회로 감량신기능장애, 간기능장애, 강력한 CYP3A4 저해제 투여: 1회 2mg씩 1일 1회<br />[경구, 일반정] 1회 2mg씩 1일 2회신기능장애, 간기능장애, 강력한 CYP3A4 저해제 투여: 1회 1mg씩 1일 2회</td>
            </tr>
            <tr id="KDGERI_TOLTERODINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙만성 변비가 있는 경우 항콜린 효과로 변비가 악화될 수 있음<br />∙QT 연장 약물 복용, 저칼륨혈증 등 전해질 이상, 서맥, 강력한 CYP3A4 저해제 투여시 주의. <br />∙64세 이상의 안전성 및 유효성은 성인과 유사하므로 나이에 따른 용량조절은 필요하지 않음. <br />∙서방정의 경우 부수거나 쪼개지 말고 충분한 물과 함께 그대로 복용할 것. <br />∙중증도의 신장애(CrCl 10ml/min 이하), 간장애 환자에는 서방형캡슐의 복용은 추천되지 않음. <br />∙중등도의 신장애(CrCl 10-30ml/min), 간장애 환자에는 용량 감소 권장</td>
            </tr>
            <tr id="KDGERI_TOLTERODINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙항우울제 등 항무스카린 효능 약물(항무스카린 작용 상승) <br />∙CYP3A4 저해제(이 약 대사 감소) <br />∙위장운동조절제(길항작용) <br />∙클래리트로마이신, 히드록시클로로퀸, 케토코나졸, 퀴니딘, 프로파페논_QT간격 연장<br />∙와파린(출혈 위험 증가) <br />∙갈란타민, 리바스티그민(콜린분해억제 효과 감소)</td>
            </tr>
            <tr id="KDGERI_TOLTERODINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>구갈, 흉통, 두통, 현기증, 피로, 졸음, 불안, 피부 건조, 변비, 복통, 설사, 소화불량, 체중증가, 요저류, 관절통, 안구 건조증, 시각이상, 기관지염, 부비동염</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_OXYBUTYNIN" data-drug-number="205">
          <thead>
            <tr>
              <th className="drug-number">205</th>
              <th className="drug-name">옥시부티닌(Oxybutynin)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">기타의 비뇨생식기관 및 항문용약, 진경제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_OXYBUTYNIN_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>과민성 방광으로 인한 요실금, 절박뇨, 빈뇨</td>
            </tr>
            <tr id="KDGERI_OXYBUTYNIN_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>요저류, 폐쇄성 요로증, 위장관 운동 저하(위장관 폐색, 중증결장염, 거대결장증, 장이완증), 협우각 녹내장, 이 약 과민증, 갈락토오스 관련 유전적 문제</td>
            </tr>
            <tr id="KDGERI_OXYBUTYNIN_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구, 서방정] 1회 5-10mg씩 1일 1회, 필요시 1주 간격으로 1회 5mg씩 증량1일 최대 투여량: 30mg <br />[경구, 일반정] 1일 6-15㎎을 2-3회 분할투여1일 최대 투여량: 20mg연령, 증상에 따라 적절히 증감</td>
            </tr>
            <tr id="KDGERI_OXYBUTYNIN_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙만성 변비가 있는 경우 항콜린 효과로 변비가 악화될 수 있음. <br />∙허약한 고령자의 경우 소실반감기가 연장되므로 저용량으로 투여하고 과량 투여되지 않도록 주의 깊게 관찰. <br />∙치료 초기 및 증량 후 항콜린성 중추신경계 작용 징후 모니터링 필요. <br />∙항콜린성 중추신경계 부작용을 겪을 경우 용량 감소 또는 투약 중단 고려. <br />∙졸음 또는 시야 흔들림을 일으킬 수 있으므로 낙상, 낙상, 운전 및 기계조작 주의. <br />∙얼굴, 입술, 혀 및/또는 후두의 혈관부종이 발생한 경우 투여를 즉시 중단하고 적절한 치료 및 처치 실시. <br />∙서방정의 경우 씹거나 자르거나 분쇄하지 말고 그대로 복용할 것. <br />∙고온 환경에서 이 약 투여시 발한(땀분비)이 감소되어 발열 및 열사병이 나타날 수 있음. <br />∙전립선비대증 환자, 갑상선기능항진증 환자(심박수 증가), 울혈성 심부전 환자 (교감신경계의 항진 촉진), 부정맥 환자에게 투여 주의</td>
            </tr>
            <tr id="KDGERI_OXYBUTYNIN_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙항콜린성 약물(항콜린 작용 증가) <br />∙강력한 CYP3A4저해제(옥시부티닌 혈장농도 상승) <br />∙위장운동조절제(길항작용)</td>
            </tr>
            <tr id="KDGERI_OXYBUTYNIN_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>어지러움, 졸음, 손발저림, 구강건조, 변비, 설사, 소화불량, 구역, 심계항진, 심부정맥, 부종, 두통, 불면, 가려움증, 시야흐림, 동공산대, 안내압 상승, 안구건조, 기침, 배뇨곤란, 요폐, 잔뇨감, ALT/AST 상승, 피부/호흡기계310</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_CHLORPHENIRAMINE" data-drug-number="206">
          <thead>
            <tr>
              <th className="drug-number">206</th>
              <th className="drug-name">클로르페니라민(Chlorpheniramine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항히스타민제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_CHLORPHENIRAMINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제]고초열, 두드러기, 소양성 피부질환(습진･피부염, 피부소양증, 약진), 알레르기성 비염, 혈관운동성 비염, 코감기에 의한 재채기･콧물･기침, 혈관운동성 부종, 곤충자상[주사제]고초열, 두드러기, 소양성 피부질환(습진･피부염, 피부소양증, 약진, 교자증), 알레르기성 비염, 혈관운동성 비염</td>
            </tr>
            <tr id="KDGERI_CHLORPHENIRAMINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 녹내장, 전립선 비대 등 하부요로폐색, 미숙아 및 신생아, MAO 저해제 투여중인 환자</td>
            </tr>
            <tr id="KDGERI_CHLORPHENIRAMINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 2-6mg씩 1일 2-4회<br />[주사제] 1회 5-10mg씩 1일 1-2회, SC, IM, IV</td>
            </tr>
            <tr id="KDGERI_CHLORPHENIRAMINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers’ Criteria 해당 품목(노인에게 1세대 항히스타민제 사용하지 않음). <br />∙고령자는 생리기능이 저하되어 있으므로 환자 상태를 관찰하면서 신중투여. <br />∙졸음 및 착란을 유발할 수 있으므로 낙상, 운전 및 기계조작에 주의. <br />∙안내압상승, 갑상선기능항진, 협착성 궤양, 고혈압, 간질, 기관지 확장증, 천식, 간질환 환자는 신중히 투여.</td>
            </tr>
            <tr id="KDGERI_CHLORPHENIRAMINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙알코올, 중추신경억제제(진정작용 증가) <br />∙페니토인(페니토인 대사 억제) <br />∙소화기계 운동조절약물(약물 효과 저해) <br />∙글루카곤(병용 사용 피할 것) <br />∙이프라트로피움(항콜린제 효과 증가) <br />∙레보설프라이드(항콜린제 효과 증가) <br />∙멀타자핀, 졸피뎀(중추신경계 억제 작용 증가) <br />∙티아자이드 이뇨제(이뇨제 혈중 농도 증가)</td>
            </tr>
            <tr id="KDGERI_CHLORPHENIRAMINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>발진, 광선과민증, 박리성 피부염, 두드러기, 연축, 근허약, 진정, 졸음, 신경과민, 두통, 복통, 복시, 불면, 기면, 어지러움, 이명, 전정장애, 구갈, 가슴쓰림, 소화불량, 구역, 구토, 변비, 설사, 빈뇨, 배뇨곤란, 요폐, 요저류, 저혈압, 심계항진, 빈맥, 코막힘, 기관지 분비 밀도 증가, 경련, 착란, 재생불량성빈혈, 무과립구증피부/호흡기계</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_CLEMASTINE" data-drug-number="207">
          <thead>
            <tr>
              <th className="drug-number">207</th>
              <th className="drug-name">클레마스틴(Clemastine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항히스타민제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_CLEMASTINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>알레르기성 비염, 고초열, 두드러기, 소양성 피부질환(소양증, 습진･피부염), 맥관신경성 부종, 코감기에 의한 재채기･콧물･기침</td>
            </tr>
            <tr id="KDGERI_CLEMASTINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>수유부, 미숙아 및 1세 이하 영아, 이 약 과민증, 천식발작 등 하기도 질환, MAO저해제 투여, 전립선 비대 등 하부요로 폐색성 질환, 녹내장</td>
            </tr>
            <tr id="KDGERI_CLEMASTINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>1회 1mg씩 1일 2회1일 최대 투여량: 2mg</td>
            </tr>
            <tr id="KDGERI_CLEMASTINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers’ Criteria 해당 품목(노인에게 1세대 항히스타민제 사용하지 않음). <br />∙고령자에게 투여할 경우 어지러움, 진전, 저혈압이 자주 나타날 수 있음. <br />∙협착성 소화성 궤양, 유문십이지장 폐색 환자, 고혈압, 천식, 갑상선기능 항진, 심혈관 질환, 다뇨증, 간질 등의 환자에는 투여 시 주의<br />∙졸음을 유발할 수 있으므로 낙상, 운전 및 기계조작 주의</td>
            </tr>
            <tr id="KDGERI_CLEMASTINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙중추신경억제제, 알코올(진정작용 증강) <br />∙항콜린제(항콜린작용 증강) <br />∙아세틸콜린에스터레이즈 억제제(항콜린제 효과 저해)</td>
            </tr>
            <tr id="KDGERI_CLEMASTINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>두드러기, 발진, 약진, 아나필락시스쇼크, 광선과민증, 발한, 오한, 저혈압, 두통, 심계항진, 진정, 졸음, 어지러움, 피로, 혼란, 불안, 시야몽롱, 식욕부진, 구역, 구토, 구갈, 설사, 소화불량, 용혈성 빈혈, 무과립구증, 빈뇨, 배뇨곤란, 요저류, 조기월경, 코막힘, 이명, 기관지 분비 농도 증가피부/호흡기계312</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_OXATOMIDE" data-drug-number="208">
          <thead>
            <tr>
              <th className="drug-number">208</th>
              <th className="drug-name">옥사토마이드(Oxatomide)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항히스타민제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_OXATOMIDE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>고초열, 만성 두드러기, 피부 소양증, 습진, 알레르기성 천식, 음식에 의한 알레르기, 알레르기성 비염</td>
            </tr>
            <tr id="KDGERI_OXATOMIDE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 임부, 수유부</td>
            </tr>
            <tr id="KDGERI_OXATOMIDE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>1회 30mg씩 1일 2회1일 최대 투여량: 1회 60mg씩 1일 2회</td>
            </tr>
            <tr id="KDGERI_OXATOMIDE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙고령자는 나이에 따른 생리변화(혈액-뇌관문 투과성 증가, 간대사 저하)로 H1수용체 저해제의 작용에 영향을 줄 수 있으므로 신중 투여. <br />∙이 약 효과가 천천히 나타나므로 알레르기성 쇼크, 호흡곤란, 급성 천식발작 등의 급성 증상 치료에는 적당하지 않음. <br />∙치료 초기 졸음 등 각성과 반응성의 장애를 초래할 수 있으므로 낙상, 운전 및 기계 조작 주의. <br />∙이 약은 간에서 대사되므로 간질환이 있는 환자는 신중 투여. 필요시 투여간격은 그대로 두고 상용량의 절반으로 투여 시작.</td>
            </tr>
            <tr id="KDGERI_OXATOMIDE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙알코올, 바르비탈류, 수면제, 마취성진통제, 중추신경 억제성 항불안제(진정작용 증가) <br />∙아트로핀, 삼환계 항우울약(항콜린효과 증가) <br />∙아미노글리코시드 항생물질(난청 등 이상반응 불현성화)</td>
            </tr>
            <tr id="KDGERI_OXATOMIDE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>졸음, 체중증가, 식욕증가, 입의 건조, 빈뇨, 배뇨통, 배뇨곤란, 산동, 소화기계 증상, 부종피부/호흡기계</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_PIPRINHYDRINATE" data-drug-number="209">
          <thead>
            <tr>
              <th className="drug-number">209</th>
              <th className="drug-name">피프린히드리네이트(Piprinhydrinate)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">항히스타민제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_PIPRINHYDRINATE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>[경구제, 주사제]소양성 피부질환(습진･피부염, 피부소양증, 소아스트로플루스, 약진, 중독진, 다형성 삼출성 홍반), 두드러기, 알레르기성 비염, 코감기로 인한 재채기･콧물･기침</td>
            </tr>
            <tr id="KDGERI_PIPRINHYDRINATE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>녹내장, 전립선 비대 등 하부 요로폐색성 질환,신생아 또는 미숙아(주사제에 한함, 벤질알코올 함유)</td>
            </tr>
            <tr id="KDGERI_PIPRINHYDRINATE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>[경구제] 1회 3mg씩 1일 2회<br />[주사제] 1회 3mg씩 1일 1-3회 SC 또는 IM</td>
            </tr>
            <tr id="KDGERI_PIPRINHYDRINATE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙고령자는 생리기능이 저하되어 있으므로 감량하는 등 주의<br />∙졸음, 어지러움을 유발할 수 있으므로 낙상, 운전 및 기계조작 주의<br />∙피하･근육내 투여 후 주사부위 신경마비 또는 경결 등이 나타날 수 있음(주사제에 한함).</td>
            </tr>
            <tr id="KDGERI_PIPRINHYDRINATE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙알코올, 중추신경억제제, MAO 저해제(약효 증강)</td>
            </tr>
            <tr id="KDGERI_PIPRINHYDRINATE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>발진, 어지러움, 다행감, 불면, 권태감, 졸음, 두중감, 두통, 구갈, 구역, 식욕부진, 복통, 과민증피부/호흡기계314</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_HYDROXYZINE" data-drug-number="210">
          <thead>
            <tr>
              <th className="drug-number">210</th>
              <th className="drug-name">히드록시진(Hydroxyzine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">정신신경용제/항히스타민제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_HYDROXYZINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>수술 전･후 신경증에서의 불안, 긴장, 초조, 두드러기 또는 피부질환에 수반하는 가려움(습진, 피부염, 피부가려움증)</td>
            </tr>
            <tr id="KDGERI_HYDROXYZINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>이 약 과민증, 급성폐쇄각 녹내장, 세티리진･피페라진 유도체･아미노필린･에틸렌디아민 과민증, 포르피린증, 임부, 수유부, 갈락토오스 관련 유전적 문제, QT 간격 연장</td>
            </tr>
            <tr id="KDGERI_HYDROXYZINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>정신과 영역(긴장 및 불안) : 1일 75-150㎎, 3-4회로 분할 투여.피부과 영역(소양증) : 1일 30-60mg, 2-3회 분할 투여.초기에는 1회 25mg qd hs, 점차 증량하여 30-60㎎/일을 2-3회로 분할 투여.</td>
            </tr>
            <tr id="KDGERI_HYDROXYZINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙2012 Beers‘ Criteria 해당 품목(노인에게 1세대 항히스타민제 사용하지 않음). <br />∙고령자는 생리기능이 저하되어 있으며, 이 약의 약리 작용이 연장될 수 있기 때문에 감량(예: 권장용량의 1/2용량에서 시작)하는 등 주의. <br />∙전립선비대증, 방광경부 폐쇄증, 천식, COPD 환자에 신중투여. <br />∙노인에서 allergy 치료 시에는 항콜린 작용이 없는 antihistamine 사용할 것을 권고함. <br />∙간장애 환자는 1일 용량의 2/3으로 감량<br />∙신장애 환자는 중등도 신장애일 경우 1일 용량의 1/2, 중증의 경우 1/4로 감량<br />∙피로, 어지러움, 진정, 시각장애 등을 일으킬 수 있으므로 낙상, 운전 및 기계 조작 주의.</td>
            </tr>
            <tr id="KDGERI_HYDROXYZINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙중추신경억제제, 항콜린성 약물, 알콜(약효 증가) <br />∙베타히스틴, 콜린에스테라제 저해제(효과 상쇄) <br />∙잠재적 부정맥 유발 약물(QT연장 위험 증가) <br />∙CYP2D6의 기질인 약물 농도 증가</td>
            </tr>
            <tr id="KDGERI_HYDROXYZINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>졸음, 두통, 진정, 입마름, 피로대사체인 세티리진의 부작용(혈소판감소증, 공격성, 우울, 틱, 배뇨장애, 설사, 체중증가 등)피부/호흡기계</td>
            </tr>
          </tbody>
        </table>


        <table className="drug-table" id="KDGERI_CODEINE" data-drug-number="211">
          <thead>
            <tr>
              <th className="drug-number">211</th>
              <th className="drug-name">코데인(Codeine)</th>
              <th className="drug-category-label">약효군</th>
              <th className="drug-category-value">아편알칼로이드계 제제</th>
            </tr>
          </thead>
          <tbody>
            <tr id="KDGERI_CODEINE_INDICATION">
              <td className="field-label">효능<br/>효과</td>
              <td className="field-content" colSpan={3}>기관지염, 폐렴, 인두염, 후두염, 기관지천식, 기타 호흡기 질환에 동반되는 기침의 진정, 아세트아미노펜이나 이부프로펜과 같은 다른 진통제로 경감되지 않은 급성 중등도 통증의 치료</td>
            </tr>
            <tr id="KDGERI_CODEINE_CONTRAINDICATION">
              <td className="field-label">금기</td>
              <td className="field-content" colSpan={3}>중증 호흡억제, 천식발작 지속상태, 중증 간장애, 만성폐질환에 속발한 심부전, 경련상태, 급성 알코올중독, 이 약 과민증, 출혈성대장염, 폐쇄성 수면무호흡증 치료 위해 편도절제술 또는 아데노이드절제술 받은 18세 미만, 12세 미만 소아, 수유부, CYP2D6 초고속대사자, 갈락토오스 관련 유전적 문제</td>
            </tr>
            <tr id="KDGERI_CODEINE_DOSAGE">
              <td className="field-label">용법<br/>용량</td>
              <td className="field-content" colSpan={3}>1회 20mg씩 1일 3회1일 최대투여량: 240mg(최소 6시간 간격으로 하루에 4회까지 투여) 1회 최대용량 100mg</td>
            </tr>
            <tr id="KDGERI_CODEINE_PRC">
              <td className="field-label">참고<br/>주의사항</td>
              <td className="field-content" colSpan={3}>∙고령자는 생리기능이 저하되어 있고, 특히 호흡억제가 일어나기 쉬우므로 저용량부터 시작하는 등 신중히 투여. <br />∙필요한 최소량으로 신중 투여하고 투여를 중단할 경우 부작용 발현에 유의하면서 서서히 감량. <br />∙노인에서는 특히 중추신경기능 저하, 혼돈, 변비에 더 민감할 수 있음. <br />∙졸음, 어지러움 등이 나타날 수 있으므로 낙상, 운전 및 기계조작 주의.</td>
            </tr>
            <tr id="KDGERI_CODEINE_INTERACTION">
              <td className="field-label">주요<br/>약물상호작용</td>
              <td className="field-content" colSpan={3}>∙중추신경억제제, 베타차단제, 삼환계항우울제(중추신경억제작용, 호흡억제 유발) <br />∙와르파린(항응고효과 증강) <br />∙항콜린제(항콜린효과 증강) <br />∙암모니움클로라이드(오피오이드 계열 배설 증가) <br />∙이뇨제 계열(오피오이드가 이뇨제 계열 제재의 부작용 증가) <br />∙하이드록시진(하이드로코돈 계열과 동시 사용 시 하이드로코돈 계열을 20~30%정도 감량해서 시작) <br />∙SSRI(오피오이드계열이 부작용 증가) <br />∙졸피뎀(효과 증가)</td>
            </tr>
            <tr id="KDGERI_CODEINE_ADVERSE">
              <td className="field-label">주요<br/>이상사례</td>
              <td className="field-content" colSpan={3}>의존성, 호흡곤란, 착란, 건망, 졸음, 어지러움, 시력조절장애, 발한, 구역, 구토, 변비, 부정맥, 혈압변동, 안면홍조, 발진, 가려움, 배뇨장애</td>
            </tr>
          </tbody>
        </table>

        {/* 발행 정보 */}
        <div className="publication-info" style={{ marginTop: '60px', padding: '30px', backgroundColor: '#f8f9fa', borderTop: '3px solid #354380' }}>
          <h3 style={{ textAlign: 'center', marginBottom: '30px', color: '#354380' }}>노인에 대한 의약품 적정사용 정보집</h3>

          <div style={{ lineHeight: '2', fontSize: '15px' }}>
            <p><strong>발행일</strong> / 2015년 12월 개정판</p>
            <p><strong>발행인</strong> / 김 승 희</p>
            <p><strong>편집위원장</strong> / 김관성 구본기</p>
            <p><strong>편집위원</strong> / 이수정 김혜숙 김상현 도원임 임상우 현진우 한송이 전보명 김미경 김미영 신선미 이신행 박효주 장유진 김미희</p>
            <p><strong>발행처</strong> / 식품의약품안전처</p>
            <p style={{ paddingLeft: '60px', fontSize: '14px', color: '#666' }}>
              28159 충청북도 청주시 흥덕구 오송읍 오송생명2로 187<br />
              한국의약품안전관리원<br />
              14051 경기도 안양시 동안구 부림로 169번길 30 5층
            </p>
            <p><strong>디자인인쇄</strong> / (사)한국척수장애인협회 T.031-421-8418</p>
          </div>
        </div>

      </div>
    </Container>
 );
};

export default KIDS_GERI;
